(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('log4js'), require('dayjs')) :
    typeof define === 'function' && define.amd ? define(['log4js', 'dayjs'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.wizCloudRender = factory(global.log4js, global.dayjs));
})(this, (function (log4js, dayjs) { 'use strict';

    function _interopNamespaceDefault(e) {
        var n = Object.create(null);
        if (e) {
            Object.keys(e).forEach(function (k) {
                if (k !== 'default') {
                    var d = Object.getOwnPropertyDescriptor(e, k);
                    Object.defineProperty(n, k, d.get ? d : {
                        enumerable: true,
                        get: function () { return e[k]; }
                    });
                }
            });
        }
        n.default = e;
        return Object.freeze(n);
    }

    var log4js__namespace = /*#__PURE__*/_interopNamespaceDefault(log4js);

    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise, SuppressedError, Symbol, Iterator */

    var extendStatics$1 = function(d, b) {
        extendStatics$1 = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics$1(d, b);
    };

    function __extends$1(d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics$1(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign$2 = function() {
        __assign$2 = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign$2.apply(this, arguments);
    };

    function __awaiter$1(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator$1(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
        return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (g && (g = 0, op[0] && (_ = 0)), _) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __spreadArray$2(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || Array.prototype.slice.call(from));
    }

    typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
        var e = new Error(message);
        return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
    };

    var EDomType;
    (function (EDomType) {
        EDomType[EDomType["video"] = 0] = "video";
        EDomType[EDomType["img"] = 1] = "img";
    })(EDomType || (EDomType = {}));
    var LoadEngineStatus;
    (function (LoadEngineStatus) {
        LoadEngineStatus[LoadEngineStatus["NativeLoad"] = 0] = "NativeLoad";
        LoadEngineStatus[LoadEngineStatus["Connected"] = 1] = "Connected";
        LoadEngineStatus[LoadEngineStatus["Disconnected"] = 2] = "Disconnected";
        LoadEngineStatus[LoadEngineStatus["UserTimeOut"] = 3] = "UserTimeOut";
    })(LoadEngineStatus || (LoadEngineStatus = {}));
    var ILoadModelStatus;
    (function (ILoadModelStatus) {
        ILoadModelStatus[ILoadModelStatus["Init"] = 0] = "Init";
        ILoadModelStatus[ILoadModelStatus["Loading"] = 1] = "Loading";
        ILoadModelStatus[ILoadModelStatus["Error"] = 2] = "Error";
        ILoadModelStatus[ILoadModelStatus["DownLoading"] = 3] = "DownLoading";
        ILoadModelStatus[ILoadModelStatus["LoadSuccess"] = 4] = "LoadSuccess";
        ILoadModelStatus[ILoadModelStatus["DownLoadSuccess"] = 5] = "DownLoadSuccess";
        ILoadModelStatus[ILoadModelStatus["UnLoadModel"] = 6] = "UnLoadModel";
        ILoadModelStatus[ILoadModelStatus["CreateTask"] = 7] = "CreateTask";
    })(ILoadModelStatus || (ILoadModelStatus = {}));

    var cacheType;
    (function (cacheType) {
        cacheType[cacheType["Engine"] = 0] = "Engine";
        cacheType[cacheType["Model"] = 1] = "Model";
        cacheType[cacheType["Node"] = 2] = "Node";
        cacheType[cacheType["LoadNode"] = 3] = "LoadNode";
        cacheType[cacheType["GIS"] = 4] = "GIS";
        cacheType[cacheType["Item"] = 5] = "Item";
        cacheType[cacheType["Clip"] = 6] = "Clip";
        cacheType[cacheType["ElectoronicRail"] = 7] = "ElectoronicRail";
        cacheType[cacheType["Axis"] = 8] = "Axis";
        cacheType[cacheType["Route"] = 9] = "Route";
        cacheType[cacheType["ModelGlitter"] = 10] = "ModelGlitter";
        cacheType[cacheType["Particle"] = 11] = "Particle";
        cacheType[cacheType["Marker"] = 12] = "Marker";
        cacheType[cacheType["PosViewer"] = 13] = "PosViewer";
        cacheType[cacheType["SkeletonNode"] = 14] = "SkeletonNode";
        cacheType[cacheType["Animation"] = 15] = "Animation";
        cacheType[cacheType["HistoryTrajectory"] = 16] = "HistoryTrajectory";
        cacheType[cacheType["Inspection"] = 17] = "Inspection";
        cacheType[cacheType["Image"] = 18] = "Image";
        cacheType[cacheType["DroneNode"] = 19] = "DroneNode";
    })(cacheType || (cacheType = {}));

    /**
     * @description: 生成唯一的uuid
     * @return {*}
     */
    function generateUUID() {
        var d = new Date().getTime();
        if (typeof window !== 'undefined' && window.performance && typeof window.performance.now === 'function') {
            d += performance.now();
        }
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
        });
        return uuid;
    }
    /**
     * @description: 检查player是否有效
     * @param {IPlayer} player
     * @return {*}
     */
    function checkPlayerLoad(player) {
        if (!player) {
            return false;
        }
        if (!player.Native) {
            return false;
        }
        return true;
    }
    function hex2rgba(hex) {
        var result = {
            r: 0,
            g: 0,
            b: 0,
            a: 255,
        };
        result.r = Number(parseInt(hex.substring(1, 3), 16)) || 0;
        result.g = Number(parseInt(hex.substring(3, 5), 16)) || 0;
        result.b = Number(parseInt(hex.substring(5, 7), 16)) || 0;
        result.a = Number(parseInt(hex.substring(7), 16)) || 255;
        return result;
    }
    function hex2Number(hex) {
        return Number(hex.replace("#", '0x'));
    }
    function computedByteLen(str) {
        var chineseReg = /[^\x00=\xff]/g;
        return str.replace(chineseReg, '**').length;
    }
    function computedTextWidth(text, font) {
        if (font === void 0) { font = '14px'; }
        var __span = document.createElement('span');
        __span.style.fontFamily = "";
        __span.innerText = text;
        __span.style.fontSize = font;
        __span.style.visibility = 'hidden';
        __span.style.position = "absolute";
        document.body.appendChild(__span);
        var width = __span.offsetWidth;
        document.body.removeChild(__span);
        return width;
    }
    function computedText(text, font) {
        if (font === void 0) { font = 14; }
        var __span = document.createElement('span');
        __span.innerText = text;
        __span.style.display = 'inline-block';
        // __span.style.fontFamily = ""
        __span.style.fontSize = 12 + "px";
        __span.style.visibility = 'hidden';
        __span.style.position = "absolute";
        document.body.appendChild(__span);
        var width = __span.offsetWidth / 12 * font;
        var height = __span.offsetHeight / 12 * font;
        document.body.removeChild(__span);
        return [width, height];
    }
    function getPlayerData(cacheManagement) {
        var engineCache = cacheManagement.findCacheByType(cacheType.Engine);
        if (engineCache.length > 0 && engineCache[0].instance) {
            return engineCache[0].instance.getDataInfo();
        }
    }

    var ItableType;
    (function (ItableType) {
        ItableType["CloudInterface"] = "CloudInterface";
        ItableType["CloudError"] = "CloudError";
    })(ItableType || (ItableType = {}));

    /*
     * Dexie.js - a minimalistic wrapper for IndexedDB
     * ===============================================
     *
     * By David Fahlander, david.fahlander@gmail.com
     *
     * Version 3.2.7, Wed Mar 20 2024
     *
     * https://dexie.org
     *
     * Apache License Version 2.0, January 2004, http://www.apache.org/licenses/
     */
     
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.
    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.
    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    var __assign$1 = function() {
        __assign$1 = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign$1.apply(this, arguments);
    };
    function __spreadArray$1(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || Array.prototype.slice.call(from));
    }

    var _global = typeof globalThis !== 'undefined' ? globalThis :
        typeof self !== 'undefined' ? self :
            typeof window !== 'undefined' ? window :
                global;

    var keys = Object.keys;
    var isArray = Array.isArray;
    if (typeof Promise !== 'undefined' && !_global.Promise) {
        _global.Promise = Promise;
    }
    function extend(obj, extension) {
        if (typeof extension !== 'object')
            return obj;
        keys(extension).forEach(function (key) {
            obj[key] = extension[key];
        });
        return obj;
    }
    var getProto = Object.getPrototypeOf;
    var _hasOwn = {}.hasOwnProperty;
    function hasOwn(obj, prop) {
        return _hasOwn.call(obj, prop);
    }
    function props(proto, extension) {
        if (typeof extension === 'function')
            extension = extension(getProto(proto));
        (typeof Reflect === "undefined" ? keys : Reflect.ownKeys)(extension).forEach(function (key) {
            setProp(proto, key, extension[key]);
        });
    }
    var defineProperty = Object.defineProperty;
    function setProp(obj, prop, functionOrGetSet, options) {
        defineProperty(obj, prop, extend(functionOrGetSet && hasOwn(functionOrGetSet, "get") && typeof functionOrGetSet.get === 'function' ?
            { get: functionOrGetSet.get, set: functionOrGetSet.set, configurable: true } :
            { value: functionOrGetSet, configurable: true, writable: true }, options));
    }
    function derive(Child) {
        return {
            from: function (Parent) {
                Child.prototype = Object.create(Parent.prototype);
                setProp(Child.prototype, "constructor", Child);
                return {
                    extend: props.bind(null, Child.prototype)
                };
            }
        };
    }
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    function getPropertyDescriptor(obj, prop) {
        var pd = getOwnPropertyDescriptor(obj, prop);
        var proto;
        return pd || (proto = getProto(obj)) && getPropertyDescriptor(proto, prop);
    }
    var _slice = [].slice;
    function slice(args, start, end) {
        return _slice.call(args, start, end);
    }
    function override(origFunc, overridedFactory) {
        return overridedFactory(origFunc);
    }
    function assert(b) {
        if (!b)
            throw new Error("Assertion Failed");
    }
    function asap$1(fn) {
        if (_global.setImmediate)
            setImmediate(fn);
        else
            setTimeout(fn, 0);
    }
    function arrayToObject(array, extractor) {
        return array.reduce(function (result, item, i) {
            var nameAndValue = extractor(item, i);
            if (nameAndValue)
                result[nameAndValue[0]] = nameAndValue[1];
            return result;
        }, {});
    }
    function tryCatch(fn, onerror, args) {
        try {
            fn.apply(null, args);
        }
        catch (ex) {
            onerror && onerror(ex);
        }
    }
    function getByKeyPath(obj, keyPath) {
        if (typeof keyPath === 'string' && hasOwn(obj, keyPath))
            return obj[keyPath];
        if (!keyPath)
            return obj;
        if (typeof keyPath !== 'string') {
            var rv = [];
            for (var i = 0, l = keyPath.length; i < l; ++i) {
                var val = getByKeyPath(obj, keyPath[i]);
                rv.push(val);
            }
            return rv;
        }
        var period = keyPath.indexOf('.');
        if (period !== -1) {
            var innerObj = obj[keyPath.substr(0, period)];
            return innerObj == null ? undefined : getByKeyPath(innerObj, keyPath.substr(period + 1));
        }
        return undefined;
    }
    function setByKeyPath(obj, keyPath, value) {
        if (!obj || keyPath === undefined)
            return;
        if ('isFrozen' in Object && Object.isFrozen(obj))
            return;
        if (typeof keyPath !== 'string' && 'length' in keyPath) {
            assert(typeof value !== 'string' && 'length' in value);
            for (var i = 0, l = keyPath.length; i < l; ++i) {
                setByKeyPath(obj, keyPath[i], value[i]);
            }
        }
        else {
            var period = keyPath.indexOf('.');
            if (period !== -1) {
                var currentKeyPath = keyPath.substr(0, period);
                var remainingKeyPath = keyPath.substr(period + 1);
                if (remainingKeyPath === "")
                    if (value === undefined) {
                        if (isArray(obj) && !isNaN(parseInt(currentKeyPath)))
                            obj.splice(currentKeyPath, 1);
                        else
                            delete obj[currentKeyPath];
                    }
                    else
                        obj[currentKeyPath] = value;
                else {
                    var innerObj = obj[currentKeyPath];
                    if (!innerObj || !hasOwn(obj, currentKeyPath))
                        innerObj = (obj[currentKeyPath] = {});
                    setByKeyPath(innerObj, remainingKeyPath, value);
                }
            }
            else {
                if (value === undefined) {
                    if (isArray(obj) && !isNaN(parseInt(keyPath)))
                        obj.splice(keyPath, 1);
                    else
                        delete obj[keyPath];
                }
                else
                    obj[keyPath] = value;
            }
        }
    }
    function delByKeyPath(obj, keyPath) {
        if (typeof keyPath === 'string')
            setByKeyPath(obj, keyPath, undefined);
        else if ('length' in keyPath)
            [].map.call(keyPath, function (kp) {
                setByKeyPath(obj, kp, undefined);
            });
    }
    function shallowClone(obj) {
        var rv = {};
        for (var m in obj) {
            if (hasOwn(obj, m))
                rv[m] = obj[m];
        }
        return rv;
    }
    var concat = [].concat;
    function flatten(a) {
        return concat.apply([], a);
    }
    var intrinsicTypeNames = "BigUint64Array,BigInt64Array,Array,Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,FileSystemDirectoryHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey"
        .split(',').concat(flatten([8, 16, 32, 64].map(function (num) { return ["Int", "Uint", "Float"].map(function (t) { return t + num + "Array"; }); }))).filter(function (t) { return _global[t]; });
    var intrinsicTypes = intrinsicTypeNames.map(function (t) { return _global[t]; });
    arrayToObject(intrinsicTypeNames, function (x) { return [x, true]; });
    var circularRefs = null;
    function deepClone$1(any) {
        circularRefs = typeof WeakMap !== 'undefined' && new WeakMap();
        var rv = innerDeepClone(any);
        circularRefs = null;
        return rv;
    }
    function innerDeepClone(any) {
        if (!any || typeof any !== 'object')
            return any;
        var rv = circularRefs && circularRefs.get(any);
        if (rv)
            return rv;
        if (isArray(any)) {
            rv = [];
            circularRefs && circularRefs.set(any, rv);
            for (var i = 0, l = any.length; i < l; ++i) {
                rv.push(innerDeepClone(any[i]));
            }
        }
        else if (intrinsicTypes.indexOf(any.constructor) >= 0) {
            rv = any;
        }
        else {
            var proto = getProto(any);
            rv = proto === Object.prototype ? {} : Object.create(proto);
            circularRefs && circularRefs.set(any, rv);
            for (var prop in any) {
                if (hasOwn(any, prop)) {
                    rv[prop] = innerDeepClone(any[prop]);
                }
            }
        }
        return rv;
    }
    var toString = {}.toString;
    function toStringTag(o) {
        return toString.call(o).slice(8, -1);
    }
    var iteratorSymbol = typeof Symbol !== 'undefined' ?
        Symbol.iterator :
        '@@iterator';
    var getIteratorOf = typeof iteratorSymbol === "symbol" ? function (x) {
        var i;
        return x != null && (i = x[iteratorSymbol]) && i.apply(x);
    } : function () { return null; };
    var NO_CHAR_ARRAY = {};
    function getArrayOf(arrayLike) {
        var i, a, x, it;
        if (arguments.length === 1) {
            if (isArray(arrayLike))
                return arrayLike.slice();
            if (this === NO_CHAR_ARRAY && typeof arrayLike === 'string')
                return [arrayLike];
            if ((it = getIteratorOf(arrayLike))) {
                a = [];
                while ((x = it.next()), !x.done)
                    a.push(x.value);
                return a;
            }
            if (arrayLike == null)
                return [arrayLike];
            i = arrayLike.length;
            if (typeof i === 'number') {
                a = new Array(i);
                while (i--)
                    a[i] = arrayLike[i];
                return a;
            }
            return [arrayLike];
        }
        i = arguments.length;
        a = new Array(i);
        while (i--)
            a[i] = arguments[i];
        return a;
    }
    var isAsyncFunction = typeof Symbol !== 'undefined'
        ? function (fn) { return fn[Symbol.toStringTag] === 'AsyncFunction'; }
        : function () { return false; };

    var debug = typeof location !== 'undefined' &&
        /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
    function setDebug(value, filter) {
        debug = value;
        libraryFilter = filter;
    }
    var libraryFilter = function () { return true; };
    var NEEDS_THROW_FOR_STACK = !new Error("").stack;
    function getErrorWithStack() {
        if (NEEDS_THROW_FOR_STACK)
            try {
                getErrorWithStack.arguments;
                throw new Error();
            }
            catch (e) {
                return e;
            }
        return new Error();
    }
    function prettyStack(exception, numIgnoredFrames) {
        var stack = exception.stack;
        if (!stack)
            return "";
        numIgnoredFrames = (numIgnoredFrames || 0);
        if (stack.indexOf(exception.name) === 0)
            numIgnoredFrames += (exception.name + exception.message).split('\n').length;
        return stack.split('\n')
            .slice(numIgnoredFrames)
            .filter(libraryFilter)
            .map(function (frame) { return "\n" + frame; })
            .join('');
    }

    var dexieErrorNames = [
        'Modify',
        'Bulk',
        'OpenFailed',
        'VersionChange',
        'Schema',
        'Upgrade',
        'InvalidTable',
        'MissingAPI',
        'NoSuchDatabase',
        'InvalidArgument',
        'SubTransaction',
        'Unsupported',
        'Internal',
        'DatabaseClosed',
        'PrematureCommit',
        'ForeignAwait'
    ];
    var idbDomErrorNames = [
        'Unknown',
        'Constraint',
        'Data',
        'TransactionInactive',
        'ReadOnly',
        'Version',
        'NotFound',
        'InvalidState',
        'InvalidAccess',
        'Abort',
        'Timeout',
        'QuotaExceeded',
        'Syntax',
        'DataClone'
    ];
    var errorList = dexieErrorNames.concat(idbDomErrorNames);
    var defaultTexts = {
        VersionChanged: "Database version changed by other database connection",
        DatabaseClosed: "Database has been closed",
        Abort: "Transaction aborted",
        TransactionInactive: "Transaction has already completed or failed",
        MissingAPI: "IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb"
    };
    function DexieError(name, msg) {
        this._e = getErrorWithStack();
        this.name = name;
        this.message = msg;
    }
    derive(DexieError).from(Error).extend({
        stack: {
            get: function () {
                return this._stack ||
                    (this._stack = this.name + ": " + this.message + prettyStack(this._e, 2));
            }
        },
        toString: function () { return this.name + ": " + this.message; }
    });
    function getMultiErrorMessage(msg, failures) {
        return msg + ". Errors: " + Object.keys(failures)
            .map(function (key) { return failures[key].toString(); })
            .filter(function (v, i, s) { return s.indexOf(v) === i; })
            .join('\n');
    }
    function ModifyError(msg, failures, successCount, failedKeys) {
        this._e = getErrorWithStack();
        this.failures = failures;
        this.failedKeys = failedKeys;
        this.successCount = successCount;
        this.message = getMultiErrorMessage(msg, failures);
    }
    derive(ModifyError).from(DexieError);
    function BulkError(msg, failures) {
        this._e = getErrorWithStack();
        this.name = "BulkError";
        this.failures = Object.keys(failures).map(function (pos) { return failures[pos]; });
        this.failuresByPos = failures;
        this.message = getMultiErrorMessage(msg, failures);
    }
    derive(BulkError).from(DexieError);
    var errnames = errorList.reduce(function (obj, name) { return (obj[name] = name + "Error", obj); }, {});
    var BaseException = DexieError;
    var exceptions = errorList.reduce(function (obj, name) {
        var fullName = name + "Error";
        function DexieError(msgOrInner, inner) {
            this._e = getErrorWithStack();
            this.name = fullName;
            if (!msgOrInner) {
                this.message = defaultTexts[name] || fullName;
                this.inner = null;
            }
            else if (typeof msgOrInner === 'string') {
                this.message = "" + msgOrInner + (!inner ? '' : '\n ' + inner);
                this.inner = inner || null;
            }
            else if (typeof msgOrInner === 'object') {
                this.message = msgOrInner.name + " " + msgOrInner.message;
                this.inner = msgOrInner;
            }
        }
        derive(DexieError).from(BaseException);
        obj[name] = DexieError;
        return obj;
    }, {});
    exceptions.Syntax = SyntaxError;
    exceptions.Type = TypeError;
    exceptions.Range = RangeError;
    var exceptionMap = idbDomErrorNames.reduce(function (obj, name) {
        obj[name + "Error"] = exceptions[name];
        return obj;
    }, {});
    function mapError(domError, message) {
        if (!domError || domError instanceof DexieError || domError instanceof TypeError || domError instanceof SyntaxError || !domError.name || !exceptionMap[domError.name])
            return domError;
        var rv = new exceptionMap[domError.name](message || domError.message, domError);
        if ("stack" in domError) {
            setProp(rv, "stack", { get: function () {
                    return this.inner.stack;
                } });
        }
        return rv;
    }
    var fullNameExceptions = errorList.reduce(function (obj, name) {
        if (["Syntax", "Type", "Range"].indexOf(name) === -1)
            obj[name + "Error"] = exceptions[name];
        return obj;
    }, {});
    fullNameExceptions.ModifyError = ModifyError;
    fullNameExceptions.DexieError = DexieError;
    fullNameExceptions.BulkError = BulkError;

    function nop() { }
    function mirror(val) { return val; }
    function pureFunctionChain(f1, f2) {
        if (f1 == null || f1 === mirror)
            return f2;
        return function (val) {
            return f2(f1(val));
        };
    }
    function callBoth(on1, on2) {
        return function () {
            on1.apply(this, arguments);
            on2.apply(this, arguments);
        };
    }
    function hookCreatingChain(f1, f2) {
        if (f1 === nop)
            return f2;
        return function () {
            var res = f1.apply(this, arguments);
            if (res !== undefined)
                arguments[0] = res;
            var onsuccess = this.onsuccess,
            onerror = this.onerror;
            this.onsuccess = null;
            this.onerror = null;
            var res2 = f2.apply(this, arguments);
            if (onsuccess)
                this.onsuccess = this.onsuccess ? callBoth(onsuccess, this.onsuccess) : onsuccess;
            if (onerror)
                this.onerror = this.onerror ? callBoth(onerror, this.onerror) : onerror;
            return res2 !== undefined ? res2 : res;
        };
    }
    function hookDeletingChain(f1, f2) {
        if (f1 === nop)
            return f2;
        return function () {
            f1.apply(this, arguments);
            var onsuccess = this.onsuccess,
            onerror = this.onerror;
            this.onsuccess = this.onerror = null;
            f2.apply(this, arguments);
            if (onsuccess)
                this.onsuccess = this.onsuccess ? callBoth(onsuccess, this.onsuccess) : onsuccess;
            if (onerror)
                this.onerror = this.onerror ? callBoth(onerror, this.onerror) : onerror;
        };
    }
    function hookUpdatingChain(f1, f2) {
        if (f1 === nop)
            return f2;
        return function (modifications) {
            var res = f1.apply(this, arguments);
            extend(modifications, res);
            var onsuccess = this.onsuccess,
            onerror = this.onerror;
            this.onsuccess = null;
            this.onerror = null;
            var res2 = f2.apply(this, arguments);
            if (onsuccess)
                this.onsuccess = this.onsuccess ? callBoth(onsuccess, this.onsuccess) : onsuccess;
            if (onerror)
                this.onerror = this.onerror ? callBoth(onerror, this.onerror) : onerror;
            return res === undefined ?
                (res2 === undefined ? undefined : res2) :
                (extend(res, res2));
        };
    }
    function reverseStoppableEventChain(f1, f2) {
        if (f1 === nop)
            return f2;
        return function () {
            if (f2.apply(this, arguments) === false)
                return false;
            return f1.apply(this, arguments);
        };
    }
    function promisableChain(f1, f2) {
        if (f1 === nop)
            return f2;
        return function () {
            var res = f1.apply(this, arguments);
            if (res && typeof res.then === 'function') {
                var thiz = this, i = arguments.length, args = new Array(i);
                while (i--)
                    args[i] = arguments[i];
                return res.then(function () {
                    return f2.apply(thiz, args);
                });
            }
            return f2.apply(this, arguments);
        };
    }

    var INTERNAL = {};
    var LONG_STACKS_CLIP_LIMIT = 100,
    MAX_LONG_STACKS = 20, ZONE_ECHO_LIMIT = 100, _a$1 = typeof Promise === 'undefined' ?
        [] :
        (function () {
            var globalP = Promise.resolve();
            if (typeof crypto === 'undefined' || !crypto.subtle)
                return [globalP, getProto(globalP), globalP];
            var nativeP = crypto.subtle.digest("SHA-512", new Uint8Array([0]));
            return [
                nativeP,
                getProto(nativeP),
                globalP
            ];
        })(), resolvedNativePromise = _a$1[0], nativePromiseProto = _a$1[1], resolvedGlobalPromise = _a$1[2], nativePromiseThen = nativePromiseProto && nativePromiseProto.then;
    var NativePromise = resolvedNativePromise && resolvedNativePromise.constructor;
    var patchGlobalPromise = !!resolvedGlobalPromise;
    var stack_being_generated = false;
    var schedulePhysicalTick = resolvedGlobalPromise ?
        function () { resolvedGlobalPromise.then(physicalTick); }
        :
            _global.setImmediate ?
                setImmediate.bind(null, physicalTick) :
                _global.MutationObserver ?
                    function () {
                        var hiddenDiv = document.createElement("div");
                        (new MutationObserver(function () {
                            physicalTick();
                            hiddenDiv = null;
                        })).observe(hiddenDiv, { attributes: true });
                        hiddenDiv.setAttribute('i', '1');
                    } :
                    function () { setTimeout(physicalTick, 0); };
    var asap = function (callback, args) {
        microtickQueue.push([callback, args]);
        if (needsNewPhysicalTick) {
            schedulePhysicalTick();
            needsNewPhysicalTick = false;
        }
    };
    var isOutsideMicroTick = true,
    needsNewPhysicalTick = true,
    unhandledErrors = [],
    rejectingErrors = [],
    currentFulfiller = null, rejectionMapper = mirror;
    var globalPSD = {
        id: 'global',
        global: true,
        ref: 0,
        unhandleds: [],
        onunhandled: globalError,
        pgp: false,
        env: {},
        finalize: function () {
            this.unhandleds.forEach(function (uh) {
                try {
                    globalError(uh[0], uh[1]);
                }
                catch (e) { }
            });
        }
    };
    var PSD = globalPSD;
    var microtickQueue = [];
    var numScheduledCalls = 0;
    var tickFinalizers = [];
    function DexiePromise(fn) {
        if (typeof this !== 'object')
            throw new TypeError('Promises must be constructed via new');
        this._listeners = [];
        this.onuncatched = nop;
        this._lib = false;
        var psd = (this._PSD = PSD);
        if (debug) {
            this._stackHolder = getErrorWithStack();
            this._prev = null;
            this._numPrev = 0;
        }
        if (typeof fn !== 'function') {
            if (fn !== INTERNAL)
                throw new TypeError('Not a function');
            this._state = arguments[1];
            this._value = arguments[2];
            if (this._state === false)
                handleRejection(this, this._value);
            return;
        }
        this._state = null;
        this._value = null;
        ++psd.ref;
        executePromiseTask(this, fn);
    }
    var thenProp = {
        get: function () {
            var psd = PSD, microTaskId = totalEchoes;
            function then(onFulfilled, onRejected) {
                var _this = this;
                var possibleAwait = !psd.global && (psd !== PSD || microTaskId !== totalEchoes);
                var cleanup = possibleAwait && !decrementExpectedAwaits();
                var rv = new DexiePromise(function (resolve, reject) {
                    propagateToListener(_this, new Listener(nativeAwaitCompatibleWrap(onFulfilled, psd, possibleAwait, cleanup), nativeAwaitCompatibleWrap(onRejected, psd, possibleAwait, cleanup), resolve, reject, psd));
                });
                debug && linkToPreviousPromise(rv, this);
                return rv;
            }
            then.prototype = INTERNAL;
            return then;
        },
        set: function (value) {
            setProp(this, 'then', value && value.prototype === INTERNAL ?
                thenProp :
                {
                    get: function () {
                        return value;
                    },
                    set: thenProp.set
                });
        }
    };
    props(DexiePromise.prototype, {
        then: thenProp,
        _then: function (onFulfilled, onRejected) {
            propagateToListener(this, new Listener(null, null, onFulfilled, onRejected, PSD));
        },
        catch: function (onRejected) {
            if (arguments.length === 1)
                return this.then(null, onRejected);
            var type = arguments[0], handler = arguments[1];
            return typeof type === 'function' ? this.then(null, function (err) {
                return err instanceof type ? handler(err) : PromiseReject(err);
            })
                : this.then(null, function (err) {
                    return err && err.name === type ? handler(err) : PromiseReject(err);
                });
        },
        finally: function (onFinally) {
            return this.then(function (value) {
                onFinally();
                return value;
            }, function (err) {
                onFinally();
                return PromiseReject(err);
            });
        },
        stack: {
            get: function () {
                if (this._stack)
                    return this._stack;
                try {
                    stack_being_generated = true;
                    var stacks = getStack(this, [], MAX_LONG_STACKS);
                    var stack = stacks.join("\nFrom previous: ");
                    if (this._state !== null)
                        this._stack = stack;
                    return stack;
                }
                finally {
                    stack_being_generated = false;
                }
            }
        },
        timeout: function (ms, msg) {
            var _this = this;
            return ms < Infinity ?
                new DexiePromise(function (resolve, reject) {
                    var handle = setTimeout(function () { return reject(new exceptions.Timeout(msg)); }, ms);
                    _this.then(resolve, reject).finally(clearTimeout.bind(null, handle));
                }) : this;
        }
    });
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag)
        setProp(DexiePromise.prototype, Symbol.toStringTag, 'Dexie.Promise');
    globalPSD.env = snapShot();
    function Listener(onFulfilled, onRejected, resolve, reject, zone) {
        this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
        this.onRejected = typeof onRejected === 'function' ? onRejected : null;
        this.resolve = resolve;
        this.reject = reject;
        this.psd = zone;
    }
    props(DexiePromise, {
        all: function () {
            var values = getArrayOf.apply(null, arguments)
                .map(onPossibleParallellAsync);
            return new DexiePromise(function (resolve, reject) {
                if (values.length === 0)
                    resolve([]);
                var remaining = values.length;
                values.forEach(function (a, i) { return DexiePromise.resolve(a).then(function (x) {
                    values[i] = x;
                    if (!--remaining)
                        resolve(values);
                }, reject); });
            });
        },
        resolve: function (value) {
            if (value instanceof DexiePromise)
                return value;
            if (value && typeof value.then === 'function')
                return new DexiePromise(function (resolve, reject) {
                    value.then(resolve, reject);
                });
            var rv = new DexiePromise(INTERNAL, true, value);
            linkToPreviousPromise(rv, currentFulfiller);
            return rv;
        },
        reject: PromiseReject,
        race: function () {
            var values = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
            return new DexiePromise(function (resolve, reject) {
                values.map(function (value) { return DexiePromise.resolve(value).then(resolve, reject); });
            });
        },
        PSD: {
            get: function () { return PSD; },
            set: function (value) { return PSD = value; }
        },
        totalEchoes: { get: function () { return totalEchoes; } },
        newPSD: newScope,
        usePSD: usePSD,
        scheduler: {
            get: function () { return asap; },
            set: function (value) { asap = value; }
        },
        rejectionMapper: {
            get: function () { return rejectionMapper; },
            set: function (value) { rejectionMapper = value; }
        },
        follow: function (fn, zoneProps) {
            return new DexiePromise(function (resolve, reject) {
                return newScope(function (resolve, reject) {
                    var psd = PSD;
                    psd.unhandleds = [];
                    psd.onunhandled = reject;
                    psd.finalize = callBoth(function () {
                        var _this = this;
                        run_at_end_of_this_or_next_physical_tick(function () {
                            _this.unhandleds.length === 0 ? resolve() : reject(_this.unhandleds[0]);
                        });
                    }, psd.finalize);
                    fn();
                }, zoneProps, resolve, reject);
            });
        }
    });
    if (NativePromise) {
        if (NativePromise.allSettled)
            setProp(DexiePromise, "allSettled", function () {
                var possiblePromises = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
                return new DexiePromise(function (resolve) {
                    if (possiblePromises.length === 0)
                        resolve([]);
                    var remaining = possiblePromises.length;
                    var results = new Array(remaining);
                    possiblePromises.forEach(function (p, i) { return DexiePromise.resolve(p).then(function (value) { return results[i] = { status: "fulfilled", value: value }; }, function (reason) { return results[i] = { status: "rejected", reason: reason }; })
                        .then(function () { return --remaining || resolve(results); }); });
                });
            });
        if (NativePromise.any && typeof AggregateError !== 'undefined')
            setProp(DexiePromise, "any", function () {
                var possiblePromises = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
                return new DexiePromise(function (resolve, reject) {
                    if (possiblePromises.length === 0)
                        reject(new AggregateError([]));
                    var remaining = possiblePromises.length;
                    var failures = new Array(remaining);
                    possiblePromises.forEach(function (p, i) { return DexiePromise.resolve(p).then(function (value) { return resolve(value); }, function (failure) {
                        failures[i] = failure;
                        if (!--remaining)
                            reject(new AggregateError(failures));
                    }); });
                });
            });
    }
    function executePromiseTask(promise, fn) {
        try {
            fn(function (value) {
                if (promise._state !== null)
                    return;
                if (value === promise)
                    throw new TypeError('A promise cannot be resolved with itself.');
                var shouldExecuteTick = promise._lib && beginMicroTickScope();
                if (value && typeof value.then === 'function') {
                    executePromiseTask(promise, function (resolve, reject) {
                        value instanceof DexiePromise ?
                            value._then(resolve, reject) :
                            value.then(resolve, reject);
                    });
                }
                else {
                    promise._state = true;
                    promise._value = value;
                    propagateAllListeners(promise);
                }
                if (shouldExecuteTick)
                    endMicroTickScope();
            }, handleRejection.bind(null, promise));
        }
        catch (ex) {
            handleRejection(promise, ex);
        }
    }
    function handleRejection(promise, reason) {
        rejectingErrors.push(reason);
        if (promise._state !== null)
            return;
        var shouldExecuteTick = promise._lib && beginMicroTickScope();
        reason = rejectionMapper(reason);
        promise._state = false;
        promise._value = reason;
        debug && reason !== null && typeof reason === 'object' && !reason._promise && tryCatch(function () {
            var origProp = getPropertyDescriptor(reason, "stack");
            reason._promise = promise;
            setProp(reason, "stack", {
                get: function () {
                    return stack_being_generated ?
                        origProp && (origProp.get ?
                            origProp.get.apply(reason) :
                            origProp.value) :
                        promise.stack;
                }
            });
        });
        addPossiblyUnhandledError(promise);
        propagateAllListeners(promise);
        if (shouldExecuteTick)
            endMicroTickScope();
    }
    function propagateAllListeners(promise) {
        var listeners = promise._listeners;
        promise._listeners = [];
        for (var i = 0, len = listeners.length; i < len; ++i) {
            propagateToListener(promise, listeners[i]);
        }
        var psd = promise._PSD;
        --psd.ref || psd.finalize();
        if (numScheduledCalls === 0) {
            ++numScheduledCalls;
            asap(function () {
                if (--numScheduledCalls === 0)
                    finalizePhysicalTick();
            }, []);
        }
    }
    function propagateToListener(promise, listener) {
        if (promise._state === null) {
            promise._listeners.push(listener);
            return;
        }
        var cb = promise._state ? listener.onFulfilled : listener.onRejected;
        if (cb === null) {
            return (promise._state ? listener.resolve : listener.reject)(promise._value);
        }
        ++listener.psd.ref;
        ++numScheduledCalls;
        asap(callListener, [cb, promise, listener]);
    }
    function callListener(cb, promise, listener) {
        try {
            currentFulfiller = promise;
            var ret, value = promise._value;
            if (promise._state) {
                ret = cb(value);
            }
            else {
                if (rejectingErrors.length)
                    rejectingErrors = [];
                ret = cb(value);
                if (rejectingErrors.indexOf(value) === -1)
                    markErrorAsHandled(promise);
            }
            listener.resolve(ret);
        }
        catch (e) {
            listener.reject(e);
        }
        finally {
            currentFulfiller = null;
            if (--numScheduledCalls === 0)
                finalizePhysicalTick();
            --listener.psd.ref || listener.psd.finalize();
        }
    }
    function getStack(promise, stacks, limit) {
        if (stacks.length === limit)
            return stacks;
        var stack = "";
        if (promise._state === false) {
            var failure = promise._value, errorName, message;
            if (failure != null) {
                errorName = failure.name || "Error";
                message = failure.message || failure;
                stack = prettyStack(failure, 0);
            }
            else {
                errorName = failure;
                message = "";
            }
            stacks.push(errorName + (message ? ": " + message : "") + stack);
        }
        if (debug) {
            stack = prettyStack(promise._stackHolder, 2);
            if (stack && stacks.indexOf(stack) === -1)
                stacks.push(stack);
            if (promise._prev)
                getStack(promise._prev, stacks, limit);
        }
        return stacks;
    }
    function linkToPreviousPromise(promise, prev) {
        var numPrev = prev ? prev._numPrev + 1 : 0;
        if (numPrev < LONG_STACKS_CLIP_LIMIT) {
            promise._prev = prev;
            promise._numPrev = numPrev;
        }
    }
    function physicalTick() {
        beginMicroTickScope() && endMicroTickScope();
    }
    function beginMicroTickScope() {
        var wasRootExec = isOutsideMicroTick;
        isOutsideMicroTick = false;
        needsNewPhysicalTick = false;
        return wasRootExec;
    }
    function endMicroTickScope() {
        var callbacks, i, l;
        do {
            while (microtickQueue.length > 0) {
                callbacks = microtickQueue;
                microtickQueue = [];
                l = callbacks.length;
                for (i = 0; i < l; ++i) {
                    var item = callbacks[i];
                    item[0].apply(null, item[1]);
                }
            }
        } while (microtickQueue.length > 0);
        isOutsideMicroTick = true;
        needsNewPhysicalTick = true;
    }
    function finalizePhysicalTick() {
        var unhandledErrs = unhandledErrors;
        unhandledErrors = [];
        unhandledErrs.forEach(function (p) {
            p._PSD.onunhandled.call(null, p._value, p);
        });
        var finalizers = tickFinalizers.slice(0);
        var i = finalizers.length;
        while (i)
            finalizers[--i]();
    }
    function run_at_end_of_this_or_next_physical_tick(fn) {
        function finalizer() {
            fn();
            tickFinalizers.splice(tickFinalizers.indexOf(finalizer), 1);
        }
        tickFinalizers.push(finalizer);
        ++numScheduledCalls;
        asap(function () {
            if (--numScheduledCalls === 0)
                finalizePhysicalTick();
        }, []);
    }
    function addPossiblyUnhandledError(promise) {
        if (!unhandledErrors.some(function (p) { return p._value === promise._value; }))
            unhandledErrors.push(promise);
    }
    function markErrorAsHandled(promise) {
        var i = unhandledErrors.length;
        while (i)
            if (unhandledErrors[--i]._value === promise._value) {
                unhandledErrors.splice(i, 1);
                return;
            }
    }
    function PromiseReject(reason) {
        return new DexiePromise(INTERNAL, false, reason);
    }
    function wrap(fn, errorCatcher) {
        var psd = PSD;
        return function () {
            var wasRootExec = beginMicroTickScope(), outerScope = PSD;
            try {
                switchToZone(psd, true);
                return fn.apply(this, arguments);
            }
            catch (e) {
                errorCatcher && errorCatcher(e);
            }
            finally {
                switchToZone(outerScope, false);
                if (wasRootExec)
                    endMicroTickScope();
            }
        };
    }
    var task = { awaits: 0, echoes: 0, id: 0 };
    var taskCounter = 0;
    var zoneStack = [];
    var zoneEchoes = 0;
    var totalEchoes = 0;
    var zone_id_counter = 0;
    function newScope(fn, props, a1, a2) {
        var parent = PSD, psd = Object.create(parent);
        psd.parent = parent;
        psd.ref = 0;
        psd.global = false;
        psd.id = ++zone_id_counter;
        var globalEnv = globalPSD.env;
        psd.env = patchGlobalPromise ? {
            Promise: DexiePromise,
            PromiseProp: { value: DexiePromise, configurable: true, writable: true },
            all: DexiePromise.all,
            race: DexiePromise.race,
            allSettled: DexiePromise.allSettled,
            any: DexiePromise.any,
            resolve: DexiePromise.resolve,
            reject: DexiePromise.reject,
            nthen: getPatchedPromiseThen(globalEnv.nthen, psd),
            gthen: getPatchedPromiseThen(globalEnv.gthen, psd)
        } : {};
        if (props)
            extend(psd, props);
        ++parent.ref;
        psd.finalize = function () {
            --this.parent.ref || this.parent.finalize();
        };
        var rv = usePSD(psd, fn, a1, a2);
        if (psd.ref === 0)
            psd.finalize();
        return rv;
    }
    function incrementExpectedAwaits() {
        if (!task.id)
            task.id = ++taskCounter;
        ++task.awaits;
        task.echoes += ZONE_ECHO_LIMIT;
        return task.id;
    }
    function decrementExpectedAwaits() {
        if (!task.awaits)
            return false;
        if (--task.awaits === 0)
            task.id = 0;
        task.echoes = task.awaits * ZONE_ECHO_LIMIT;
        return true;
    }
    if (('' + nativePromiseThen).indexOf('[native code]') === -1) {
        incrementExpectedAwaits = decrementExpectedAwaits = nop;
    }
    function onPossibleParallellAsync(possiblePromise) {
        if (task.echoes && possiblePromise && possiblePromise.constructor === NativePromise) {
            incrementExpectedAwaits();
            return possiblePromise.then(function (x) {
                decrementExpectedAwaits();
                return x;
            }, function (e) {
                decrementExpectedAwaits();
                return rejection(e);
            });
        }
        return possiblePromise;
    }
    function zoneEnterEcho(targetZone) {
        ++totalEchoes;
        if (!task.echoes || --task.echoes === 0) {
            task.echoes = task.id = 0;
        }
        zoneStack.push(PSD);
        switchToZone(targetZone, true);
    }
    function zoneLeaveEcho() {
        var zone = zoneStack[zoneStack.length - 1];
        zoneStack.pop();
        switchToZone(zone, false);
    }
    function switchToZone(targetZone, bEnteringZone) {
        var currentZone = PSD;
        if (bEnteringZone ? task.echoes && (!zoneEchoes++ || targetZone !== PSD) : zoneEchoes && (!--zoneEchoes || targetZone !== PSD)) {
            enqueueNativeMicroTask(bEnteringZone ? zoneEnterEcho.bind(null, targetZone) : zoneLeaveEcho);
        }
        if (targetZone === PSD)
            return;
        PSD = targetZone;
        if (currentZone === globalPSD)
            globalPSD.env = snapShot();
        if (patchGlobalPromise) {
            var GlobalPromise_1 = globalPSD.env.Promise;
            var targetEnv = targetZone.env;
            nativePromiseProto.then = targetEnv.nthen;
            GlobalPromise_1.prototype.then = targetEnv.gthen;
            if (currentZone.global || targetZone.global) {
                Object.defineProperty(_global, 'Promise', targetEnv.PromiseProp);
                GlobalPromise_1.all = targetEnv.all;
                GlobalPromise_1.race = targetEnv.race;
                GlobalPromise_1.resolve = targetEnv.resolve;
                GlobalPromise_1.reject = targetEnv.reject;
                if (targetEnv.allSettled)
                    GlobalPromise_1.allSettled = targetEnv.allSettled;
                if (targetEnv.any)
                    GlobalPromise_1.any = targetEnv.any;
            }
        }
    }
    function snapShot() {
        var GlobalPromise = _global.Promise;
        return patchGlobalPromise ? {
            Promise: GlobalPromise,
            PromiseProp: Object.getOwnPropertyDescriptor(_global, "Promise"),
            all: GlobalPromise.all,
            race: GlobalPromise.race,
            allSettled: GlobalPromise.allSettled,
            any: GlobalPromise.any,
            resolve: GlobalPromise.resolve,
            reject: GlobalPromise.reject,
            nthen: nativePromiseProto.then,
            gthen: GlobalPromise.prototype.then
        } : {};
    }
    function usePSD(psd, fn, a1, a2, a3) {
        var outerScope = PSD;
        try {
            switchToZone(psd, true);
            return fn(a1, a2, a3);
        }
        finally {
            switchToZone(outerScope, false);
        }
    }
    function enqueueNativeMicroTask(job) {
        nativePromiseThen.call(resolvedNativePromise, job);
    }
    function nativeAwaitCompatibleWrap(fn, zone, possibleAwait, cleanup) {
        return typeof fn !== 'function' ? fn : function () {
            var outerZone = PSD;
            if (possibleAwait)
                incrementExpectedAwaits();
            switchToZone(zone, true);
            try {
                return fn.apply(this, arguments);
            }
            finally {
                switchToZone(outerZone, false);
                if (cleanup)
                    enqueueNativeMicroTask(decrementExpectedAwaits);
            }
        };
    }
    function getPatchedPromiseThen(origThen, zone) {
        return function (onResolved, onRejected) {
            return origThen.call(this, nativeAwaitCompatibleWrap(onResolved, zone), nativeAwaitCompatibleWrap(onRejected, zone));
        };
    }
    var UNHANDLEDREJECTION = "unhandledrejection";
    function globalError(err, promise) {
        var rv;
        try {
            rv = promise.onuncatched(err);
        }
        catch (e) { }
        if (rv !== false)
            try {
                var event, eventData = { promise: promise, reason: err };
                if (_global.document && document.createEvent) {
                    event = document.createEvent('Event');
                    event.initEvent(UNHANDLEDREJECTION, true, true);
                    extend(event, eventData);
                }
                else if (_global.CustomEvent) {
                    event = new CustomEvent(UNHANDLEDREJECTION, { detail: eventData });
                    extend(event, eventData);
                }
                if (event && _global.dispatchEvent) {
                    dispatchEvent(event);
                    if (!_global.PromiseRejectionEvent && _global.onunhandledrejection)
                        try {
                            _global.onunhandledrejection(event);
                        }
                        catch (_) { }
                }
                if (debug && event && !event.defaultPrevented) {
                    console.warn("Unhandled rejection: " + (err.stack || err));
                }
            }
            catch (e) { }
    }
    var rejection = DexiePromise.reject;

    function tempTransaction(db, mode, storeNames, fn) {
        if (!db.idbdb || (!db._state.openComplete && (!PSD.letThrough && !db._vip))) {
            if (db._state.openComplete) {
                return rejection(new exceptions.DatabaseClosed(db._state.dbOpenError));
            }
            if (!db._state.isBeingOpened) {
                if (!db._options.autoOpen)
                    return rejection(new exceptions.DatabaseClosed());
                db.open().catch(nop);
            }
            return db._state.dbReadyPromise.then(function () { return tempTransaction(db, mode, storeNames, fn); });
        }
        else {
            var trans = db._createTransaction(mode, storeNames, db._dbSchema);
            try {
                trans.create();
                db._state.PR1398_maxLoop = 3;
            }
            catch (ex) {
                if (ex.name === errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                    console.warn('Dexie: Need to reopen db');
                    db._close();
                    return db.open().then(function () { return tempTransaction(db, mode, storeNames, fn); });
                }
                return rejection(ex);
            }
            return trans._promise(mode, function (resolve, reject) {
                return newScope(function () {
                    PSD.trans = trans;
                    return fn(resolve, reject, trans);
                });
            }).then(function (result) {
                return trans._completion.then(function () { return result; });
            });
        }
    }

    var DEXIE_VERSION = '3.2.7';
    var maxString = String.fromCharCode(65535);
    var minKey = -Infinity;
    var INVALID_KEY_ARGUMENT = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.";
    var STRING_EXPECTED = "String expected.";
    var connections = [];
    var isIEOrEdge = typeof navigator !== 'undefined' && /(MSIE|Trident|Edge)/.test(navigator.userAgent);
    var hasIEDeleteObjectStoreBug = isIEOrEdge;
    var hangsOnDeleteLargeKeyRange = isIEOrEdge;
    var dexieStackFrameFilter = function (frame) { return !/(dexie\.js|dexie\.min\.js)/.test(frame); };
    var DBNAMES_DB = '__dbnames';
    var READONLY = 'readonly';
    var READWRITE = 'readwrite';

    function combine(filter1, filter2) {
        return filter1 ?
            filter2 ?
                function () { return filter1.apply(this, arguments) && filter2.apply(this, arguments); } :
                filter1 :
            filter2;
    }

    var AnyRange = {
        type: 3 ,
        lower: -Infinity,
        lowerOpen: false,
        upper: [[]],
        upperOpen: false
    };

    function workaroundForUndefinedPrimKey(keyPath) {
        return typeof keyPath === "string" && !/\./.test(keyPath)
            ? function (obj) {
                if (obj[keyPath] === undefined && (keyPath in obj)) {
                    obj = deepClone$1(obj);
                    delete obj[keyPath];
                }
                return obj;
            }
            : function (obj) { return obj; };
    }

    var Table =  (function () {
        function Table() {
        }
        Table.prototype._trans = function (mode, fn, writeLocked) {
            var trans = this._tx || PSD.trans;
            var tableName = this.name;
            function checkTableInTransaction(resolve, reject, trans) {
                if (!trans.schema[tableName])
                    throw new exceptions.NotFound("Table " + tableName + " not part of transaction");
                return fn(trans.idbtrans, trans);
            }
            var wasRootExec = beginMicroTickScope();
            try {
                return trans && trans.db === this.db ?
                    trans === PSD.trans ?
                        trans._promise(mode, checkTableInTransaction, writeLocked) :
                        newScope(function () { return trans._promise(mode, checkTableInTransaction, writeLocked); }, { trans: trans, transless: PSD.transless || PSD }) :
                    tempTransaction(this.db, mode, [this.name], checkTableInTransaction);
            }
            finally {
                if (wasRootExec)
                    endMicroTickScope();
            }
        };
        Table.prototype.get = function (keyOrCrit, cb) {
            var _this = this;
            if (keyOrCrit && keyOrCrit.constructor === Object)
                return this.where(keyOrCrit).first(cb);
            return this._trans('readonly', function (trans) {
                return _this.core.get({ trans: trans, key: keyOrCrit })
                    .then(function (res) { return _this.hook.reading.fire(res); });
            }).then(cb);
        };
        Table.prototype.where = function (indexOrCrit) {
            if (typeof indexOrCrit === 'string')
                return new this.db.WhereClause(this, indexOrCrit);
            if (isArray(indexOrCrit))
                return new this.db.WhereClause(this, "[" + indexOrCrit.join('+') + "]");
            var keyPaths = keys(indexOrCrit);
            if (keyPaths.length === 1)
                return this
                    .where(keyPaths[0])
                    .equals(indexOrCrit[keyPaths[0]]);
            var compoundIndex = this.schema.indexes.concat(this.schema.primKey).filter(function (ix) {
                if (ix.compound &&
                    keyPaths.every(function (keyPath) { return ix.keyPath.indexOf(keyPath) >= 0; })) {
                    for (var i = 0; i < keyPaths.length; ++i) {
                        if (keyPaths.indexOf(ix.keyPath[i]) === -1)
                            return false;
                    }
                    return true;
                }
                return false;
            }).sort(function (a, b) { return a.keyPath.length - b.keyPath.length; })[0];
            if (compoundIndex && this.db._maxKey !== maxString) {
                var keyPathsInValidOrder = compoundIndex.keyPath.slice(0, keyPaths.length);
                return this
                    .where(keyPathsInValidOrder)
                    .equals(keyPathsInValidOrder.map(function (kp) { return indexOrCrit[kp]; }));
            }
            if (!compoundIndex && debug)
                console.warn("The query " + JSON.stringify(indexOrCrit) + " on " + this.name + " would benefit of a " +
                    ("compound index [" + keyPaths.join('+') + "]"));
            var idxByName = this.schema.idxByName;
            var idb = this.db._deps.indexedDB;
            function equals(a, b) {
                try {
                    return idb.cmp(a, b) === 0;
                }
                catch (e) {
                    return false;
                }
            }
            var _a = keyPaths.reduce(function (_a, keyPath) {
                var prevIndex = _a[0], prevFilterFn = _a[1];
                var index = idxByName[keyPath];
                var value = indexOrCrit[keyPath];
                return [
                    prevIndex || index,
                    prevIndex || !index ?
                        combine(prevFilterFn, index && index.multi ?
                            function (x) {
                                var prop = getByKeyPath(x, keyPath);
                                return isArray(prop) && prop.some(function (item) { return equals(value, item); });
                            } : function (x) { return equals(value, getByKeyPath(x, keyPath)); })
                        : prevFilterFn
                ];
            }, [null, null]), idx = _a[0], filterFunction = _a[1];
            return idx ?
                this.where(idx.name).equals(indexOrCrit[idx.keyPath])
                    .filter(filterFunction) :
                compoundIndex ?
                    this.filter(filterFunction) :
                    this.where(keyPaths).equals('');
        };
        Table.prototype.filter = function (filterFunction) {
            return this.toCollection().and(filterFunction);
        };
        Table.prototype.count = function (thenShortcut) {
            return this.toCollection().count(thenShortcut);
        };
        Table.prototype.offset = function (offset) {
            return this.toCollection().offset(offset);
        };
        Table.prototype.limit = function (numRows) {
            return this.toCollection().limit(numRows);
        };
        Table.prototype.each = function (callback) {
            return this.toCollection().each(callback);
        };
        Table.prototype.toArray = function (thenShortcut) {
            return this.toCollection().toArray(thenShortcut);
        };
        Table.prototype.toCollection = function () {
            return new this.db.Collection(new this.db.WhereClause(this));
        };
        Table.prototype.orderBy = function (index) {
            return new this.db.Collection(new this.db.WhereClause(this, isArray(index) ?
                "[" + index.join('+') + "]" :
                index));
        };
        Table.prototype.reverse = function () {
            return this.toCollection().reverse();
        };
        Table.prototype.mapToClass = function (constructor) {
            this.schema.mappedClass = constructor;
            var readHook = function (obj) {
                if (!obj)
                    return obj;
                var res = Object.create(constructor.prototype);
                for (var m in obj)
                    if (hasOwn(obj, m))
                        try {
                            res[m] = obj[m];
                        }
                        catch (_) { }
                return res;
            };
            if (this.schema.readHook) {
                this.hook.reading.unsubscribe(this.schema.readHook);
            }
            this.schema.readHook = readHook;
            this.hook("reading", readHook);
            return constructor;
        };
        Table.prototype.defineClass = function () {
            function Class(content) {
                extend(this, content);
            }
            return this.mapToClass(Class);
        };
        Table.prototype.add = function (obj, key) {
            var _this = this;
            var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            var objToAdd = obj;
            if (keyPath && auto) {
                objToAdd = workaroundForUndefinedPrimKey(keyPath)(obj);
            }
            return this._trans('readwrite', function (trans) {
                return _this.core.mutate({ trans: trans, type: 'add', keys: key != null ? [key] : null, values: [objToAdd] });
            }).then(function (res) { return res.numFailures ? DexiePromise.reject(res.failures[0]) : res.lastResult; })
                .then(function (lastResult) {
                if (keyPath) {
                    try {
                        setByKeyPath(obj, keyPath, lastResult);
                    }
                    catch (_) { }
                }
                return lastResult;
            });
        };
        Table.prototype.update = function (keyOrObject, modifications) {
            if (typeof keyOrObject === 'object' && !isArray(keyOrObject)) {
                var key = getByKeyPath(keyOrObject, this.schema.primKey.keyPath);
                if (key === undefined)
                    return rejection(new exceptions.InvalidArgument("Given object does not contain its primary key"));
                try {
                    if (typeof modifications !== "function") {
                        keys(modifications).forEach(function (keyPath) {
                            setByKeyPath(keyOrObject, keyPath, modifications[keyPath]);
                        });
                    }
                    else {
                        modifications(keyOrObject, { value: keyOrObject, primKey: key });
                    }
                }
                catch (_a) {
                }
                return this.where(":id").equals(key).modify(modifications);
            }
            else {
                return this.where(":id").equals(keyOrObject).modify(modifications);
            }
        };
        Table.prototype.put = function (obj, key) {
            var _this = this;
            var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            var objToAdd = obj;
            if (keyPath && auto) {
                objToAdd = workaroundForUndefinedPrimKey(keyPath)(obj);
            }
            return this._trans('readwrite', function (trans) { return _this.core.mutate({ trans: trans, type: 'put', values: [objToAdd], keys: key != null ? [key] : null }); })
                .then(function (res) { return res.numFailures ? DexiePromise.reject(res.failures[0]) : res.lastResult; })
                .then(function (lastResult) {
                if (keyPath) {
                    try {
                        setByKeyPath(obj, keyPath, lastResult);
                    }
                    catch (_) { }
                }
                return lastResult;
            });
        };
        Table.prototype.delete = function (key) {
            var _this = this;
            return this._trans('readwrite', function (trans) { return _this.core.mutate({ trans: trans, type: 'delete', keys: [key] }); })
                .then(function (res) { return res.numFailures ? DexiePromise.reject(res.failures[0]) : undefined; });
        };
        Table.prototype.clear = function () {
            var _this = this;
            return this._trans('readwrite', function (trans) { return _this.core.mutate({ trans: trans, type: 'deleteRange', range: AnyRange }); })
                .then(function (res) { return res.numFailures ? DexiePromise.reject(res.failures[0]) : undefined; });
        };
        Table.prototype.bulkGet = function (keys) {
            var _this = this;
            return this._trans('readonly', function (trans) {
                return _this.core.getMany({
                    keys: keys,
                    trans: trans
                }).then(function (result) { return result.map(function (res) { return _this.hook.reading.fire(res); }); });
            });
        };
        Table.prototype.bulkAdd = function (objects, keysOrOptions, options) {
            var _this = this;
            var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
            options = options || (keys ? undefined : keysOrOptions);
            var wantResults = options ? options.allKeys : undefined;
            return this._trans('readwrite', function (trans) {
                var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
                if (keyPath && keys)
                    throw new exceptions.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
                if (keys && keys.length !== objects.length)
                    throw new exceptions.InvalidArgument("Arguments objects and keys must have the same length");
                var numObjects = objects.length;
                var objectsToAdd = keyPath && auto ?
                    objects.map(workaroundForUndefinedPrimKey(keyPath)) :
                    objects;
                return _this.core.mutate({ trans: trans, type: 'add', keys: keys, values: objectsToAdd, wantResults: wantResults })
                    .then(function (_a) {
                    var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                    var result = wantResults ? results : lastResult;
                    if (numFailures === 0)
                        return result;
                    throw new BulkError(_this.name + ".bulkAdd(): " + numFailures + " of " + numObjects + " operations failed", failures);
                });
            });
        };
        Table.prototype.bulkPut = function (objects, keysOrOptions, options) {
            var _this = this;
            var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
            options = options || (keys ? undefined : keysOrOptions);
            var wantResults = options ? options.allKeys : undefined;
            return this._trans('readwrite', function (trans) {
                var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
                if (keyPath && keys)
                    throw new exceptions.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
                if (keys && keys.length !== objects.length)
                    throw new exceptions.InvalidArgument("Arguments objects and keys must have the same length");
                var numObjects = objects.length;
                var objectsToPut = keyPath && auto ?
                    objects.map(workaroundForUndefinedPrimKey(keyPath)) :
                    objects;
                return _this.core.mutate({ trans: trans, type: 'put', keys: keys, values: objectsToPut, wantResults: wantResults })
                    .then(function (_a) {
                    var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                    var result = wantResults ? results : lastResult;
                    if (numFailures === 0)
                        return result;
                    throw new BulkError(_this.name + ".bulkPut(): " + numFailures + " of " + numObjects + " operations failed", failures);
                });
            });
        };
        Table.prototype.bulkDelete = function (keys) {
            var _this = this;
            var numKeys = keys.length;
            return this._trans('readwrite', function (trans) {
                return _this.core.mutate({ trans: trans, type: 'delete', keys: keys });
            }).then(function (_a) {
                var numFailures = _a.numFailures, lastResult = _a.lastResult, failures = _a.failures;
                if (numFailures === 0)
                    return lastResult;
                throw new BulkError(_this.name + ".bulkDelete(): " + numFailures + " of " + numKeys + " operations failed", failures);
            });
        };
        return Table;
    }());

    function Events(ctx) {
        var evs = {};
        var rv = function (eventName, subscriber) {
            if (subscriber) {
                var i = arguments.length, args = new Array(i - 1);
                while (--i)
                    args[i - 1] = arguments[i];
                evs[eventName].subscribe.apply(null, args);
                return ctx;
            }
            else if (typeof (eventName) === 'string') {
                return evs[eventName];
            }
        };
        rv.addEventType = add;
        for (var i = 1, l = arguments.length; i < l; ++i) {
            add(arguments[i]);
        }
        return rv;
        function add(eventName, chainFunction, defaultFunction) {
            if (typeof eventName === 'object')
                return addConfiguredEvents(eventName);
            if (!chainFunction)
                chainFunction = reverseStoppableEventChain;
            if (!defaultFunction)
                defaultFunction = nop;
            var context = {
                subscribers: [],
                fire: defaultFunction,
                subscribe: function (cb) {
                    if (context.subscribers.indexOf(cb) === -1) {
                        context.subscribers.push(cb);
                        context.fire = chainFunction(context.fire, cb);
                    }
                },
                unsubscribe: function (cb) {
                    context.subscribers = context.subscribers.filter(function (fn) { return fn !== cb; });
                    context.fire = context.subscribers.reduce(chainFunction, defaultFunction);
                }
            };
            evs[eventName] = rv[eventName] = context;
            return context;
        }
        function addConfiguredEvents(cfg) {
            keys(cfg).forEach(function (eventName) {
                var args = cfg[eventName];
                if (isArray(args)) {
                    add(eventName, cfg[eventName][0], cfg[eventName][1]);
                }
                else if (args === 'asap') {
                    var context = add(eventName, mirror, function fire() {
                        var i = arguments.length, args = new Array(i);
                        while (i--)
                            args[i] = arguments[i];
                        context.subscribers.forEach(function (fn) {
                            asap$1(function fireEvent() {
                                fn.apply(null, args);
                            });
                        });
                    });
                }
                else
                    throw new exceptions.InvalidArgument("Invalid event config");
            });
        }
    }

    function makeClassConstructor(prototype, constructor) {
        derive(constructor).from({ prototype: prototype });
        return constructor;
    }

    function createTableConstructor(db) {
        return makeClassConstructor(Table.prototype, function Table(name, tableSchema, trans) {
            this.db = db;
            this._tx = trans;
            this.name = name;
            this.schema = tableSchema;
            this.hook = db._allTables[name] ? db._allTables[name].hook : Events(null, {
                "creating": [hookCreatingChain, nop],
                "reading": [pureFunctionChain, mirror],
                "updating": [hookUpdatingChain, nop],
                "deleting": [hookDeletingChain, nop]
            });
        });
    }

    function isPlainKeyRange(ctx, ignoreLimitFilter) {
        return !(ctx.filter || ctx.algorithm || ctx.or) &&
            (ignoreLimitFilter ? ctx.justLimit : !ctx.replayFilter);
    }
    function addFilter(ctx, fn) {
        ctx.filter = combine(ctx.filter, fn);
    }
    function addReplayFilter(ctx, factory, isLimitFilter) {
        var curr = ctx.replayFilter;
        ctx.replayFilter = curr ? function () { return combine(curr(), factory()); } : factory;
        ctx.justLimit = isLimitFilter && !curr;
    }
    function addMatchFilter(ctx, fn) {
        ctx.isMatch = combine(ctx.isMatch, fn);
    }
    function getIndexOrStore(ctx, coreSchema) {
        if (ctx.isPrimKey)
            return coreSchema.primaryKey;
        var index = coreSchema.getIndexByKeyPath(ctx.index);
        if (!index)
            throw new exceptions.Schema("KeyPath " + ctx.index + " on object store " + coreSchema.name + " is not indexed");
        return index;
    }
    function openCursor(ctx, coreTable, trans) {
        var index = getIndexOrStore(ctx, coreTable.schema);
        return coreTable.openCursor({
            trans: trans,
            values: !ctx.keysOnly,
            reverse: ctx.dir === 'prev',
            unique: !!ctx.unique,
            query: {
                index: index,
                range: ctx.range
            }
        });
    }
    function iter(ctx, fn, coreTrans, coreTable) {
        var filter = ctx.replayFilter ? combine(ctx.filter, ctx.replayFilter()) : ctx.filter;
        if (!ctx.or) {
            return iterate(openCursor(ctx, coreTable, coreTrans), combine(ctx.algorithm, filter), fn, !ctx.keysOnly && ctx.valueMapper);
        }
        else {
            var set_1 = {};
            var union = function (item, cursor, advance) {
                if (!filter || filter(cursor, advance, function (result) { return cursor.stop(result); }, function (err) { return cursor.fail(err); })) {
                    var primaryKey = cursor.primaryKey;
                    var key = '' + primaryKey;
                    if (key === '[object ArrayBuffer]')
                        key = '' + new Uint8Array(primaryKey);
                    if (!hasOwn(set_1, key)) {
                        set_1[key] = true;
                        fn(item, cursor, advance);
                    }
                }
            };
            return Promise.all([
                ctx.or._iterate(union, coreTrans),
                iterate(openCursor(ctx, coreTable, coreTrans), ctx.algorithm, union, !ctx.keysOnly && ctx.valueMapper)
            ]);
        }
    }
    function iterate(cursorPromise, filter, fn, valueMapper) {
        var mappedFn = valueMapper ? function (x, c, a) { return fn(valueMapper(x), c, a); } : fn;
        var wrappedFn = wrap(mappedFn);
        return cursorPromise.then(function (cursor) {
            if (cursor) {
                return cursor.start(function () {
                    var c = function () { return cursor.continue(); };
                    if (!filter || filter(cursor, function (advancer) { return c = advancer; }, function (val) { cursor.stop(val); c = nop; }, function (e) { cursor.fail(e); c = nop; }))
                        wrappedFn(cursor.value, cursor, function (advancer) { return c = advancer; });
                    c();
                });
            }
        });
    }

    function cmp(a, b) {
        try {
            var ta = type(a);
            var tb = type(b);
            if (ta !== tb) {
                if (ta === 'Array')
                    return 1;
                if (tb === 'Array')
                    return -1;
                if (ta === 'binary')
                    return 1;
                if (tb === 'binary')
                    return -1;
                if (ta === 'string')
                    return 1;
                if (tb === 'string')
                    return -1;
                if (ta === 'Date')
                    return 1;
                if (tb !== 'Date')
                    return NaN;
                return -1;
            }
            switch (ta) {
                case 'number':
                case 'Date':
                case 'string':
                    return a > b ? 1 : a < b ? -1 : 0;
                case 'binary': {
                    return compareUint8Arrays(getUint8Array(a), getUint8Array(b));
                }
                case 'Array':
                    return compareArrays(a, b);
            }
        }
        catch (_a) { }
        return NaN;
    }
    function compareArrays(a, b) {
        var al = a.length;
        var bl = b.length;
        var l = al < bl ? al : bl;
        for (var i = 0; i < l; ++i) {
            var res = cmp(a[i], b[i]);
            if (res !== 0)
                return res;
        }
        return al === bl ? 0 : al < bl ? -1 : 1;
    }
    function compareUint8Arrays(a, b) {
        var al = a.length;
        var bl = b.length;
        var l = al < bl ? al : bl;
        for (var i = 0; i < l; ++i) {
            if (a[i] !== b[i])
                return a[i] < b[i] ? -1 : 1;
        }
        return al === bl ? 0 : al < bl ? -1 : 1;
    }
    function type(x) {
        var t = typeof x;
        if (t !== 'object')
            return t;
        if (ArrayBuffer.isView(x))
            return 'binary';
        var tsTag = toStringTag(x);
        return tsTag === 'ArrayBuffer' ? 'binary' : tsTag;
    }
    function getUint8Array(a) {
        if (a instanceof Uint8Array)
            return a;
        if (ArrayBuffer.isView(a))
            return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
        return new Uint8Array(a);
    }

    var Collection =  (function () {
        function Collection() {
        }
        Collection.prototype._read = function (fn, cb) {
            var ctx = this._ctx;
            return ctx.error ?
                ctx.table._trans(null, rejection.bind(null, ctx.error)) :
                ctx.table._trans('readonly', fn).then(cb);
        };
        Collection.prototype._write = function (fn) {
            var ctx = this._ctx;
            return ctx.error ?
                ctx.table._trans(null, rejection.bind(null, ctx.error)) :
                ctx.table._trans('readwrite', fn, "locked");
        };
        Collection.prototype._addAlgorithm = function (fn) {
            var ctx = this._ctx;
            ctx.algorithm = combine(ctx.algorithm, fn);
        };
        Collection.prototype._iterate = function (fn, coreTrans) {
            return iter(this._ctx, fn, coreTrans, this._ctx.table.core);
        };
        Collection.prototype.clone = function (props) {
            var rv = Object.create(this.constructor.prototype), ctx = Object.create(this._ctx);
            if (props)
                extend(ctx, props);
            rv._ctx = ctx;
            return rv;
        };
        Collection.prototype.raw = function () {
            this._ctx.valueMapper = null;
            return this;
        };
        Collection.prototype.each = function (fn) {
            var ctx = this._ctx;
            return this._read(function (trans) { return iter(ctx, fn, trans, ctx.table.core); });
        };
        Collection.prototype.count = function (cb) {
            var _this = this;
            return this._read(function (trans) {
                var ctx = _this._ctx;
                var coreTable = ctx.table.core;
                if (isPlainKeyRange(ctx, true)) {
                    return coreTable.count({
                        trans: trans,
                        query: {
                            index: getIndexOrStore(ctx, coreTable.schema),
                            range: ctx.range
                        }
                    }).then(function (count) { return Math.min(count, ctx.limit); });
                }
                else {
                    var count = 0;
                    return iter(ctx, function () { ++count; return false; }, trans, coreTable)
                        .then(function () { return count; });
                }
            }).then(cb);
        };
        Collection.prototype.sortBy = function (keyPath, cb) {
            var parts = keyPath.split('.').reverse(), lastPart = parts[0], lastIndex = parts.length - 1;
            function getval(obj, i) {
                if (i)
                    return getval(obj[parts[i]], i - 1);
                return obj[lastPart];
            }
            var order = this._ctx.dir === "next" ? 1 : -1;
            function sorter(a, b) {
                var aVal = getval(a, lastIndex), bVal = getval(b, lastIndex);
                return aVal < bVal ? -order : aVal > bVal ? order : 0;
            }
            return this.toArray(function (a) {
                return a.sort(sorter);
            }).then(cb);
        };
        Collection.prototype.toArray = function (cb) {
            var _this = this;
            return this._read(function (trans) {
                var ctx = _this._ctx;
                if (ctx.dir === 'next' && isPlainKeyRange(ctx, true) && ctx.limit > 0) {
                    var valueMapper_1 = ctx.valueMapper;
                    var index = getIndexOrStore(ctx, ctx.table.core.schema);
                    return ctx.table.core.query({
                        trans: trans,
                        limit: ctx.limit,
                        values: true,
                        query: {
                            index: index,
                            range: ctx.range
                        }
                    }).then(function (_a) {
                        var result = _a.result;
                        return valueMapper_1 ? result.map(valueMapper_1) : result;
                    });
                }
                else {
                    var a_1 = [];
                    return iter(ctx, function (item) { return a_1.push(item); }, trans, ctx.table.core).then(function () { return a_1; });
                }
            }, cb);
        };
        Collection.prototype.offset = function (offset) {
            var ctx = this._ctx;
            if (offset <= 0)
                return this;
            ctx.offset += offset;
            if (isPlainKeyRange(ctx)) {
                addReplayFilter(ctx, function () {
                    var offsetLeft = offset;
                    return function (cursor, advance) {
                        if (offsetLeft === 0)
                            return true;
                        if (offsetLeft === 1) {
                            --offsetLeft;
                            return false;
                        }
                        advance(function () {
                            cursor.advance(offsetLeft);
                            offsetLeft = 0;
                        });
                        return false;
                    };
                });
            }
            else {
                addReplayFilter(ctx, function () {
                    var offsetLeft = offset;
                    return function () { return (--offsetLeft < 0); };
                });
            }
            return this;
        };
        Collection.prototype.limit = function (numRows) {
            this._ctx.limit = Math.min(this._ctx.limit, numRows);
            addReplayFilter(this._ctx, function () {
                var rowsLeft = numRows;
                return function (cursor, advance, resolve) {
                    if (--rowsLeft <= 0)
                        advance(resolve);
                    return rowsLeft >= 0;
                };
            }, true);
            return this;
        };
        Collection.prototype.until = function (filterFunction, bIncludeStopEntry) {
            addFilter(this._ctx, function (cursor, advance, resolve) {
                if (filterFunction(cursor.value)) {
                    advance(resolve);
                    return bIncludeStopEntry;
                }
                else {
                    return true;
                }
            });
            return this;
        };
        Collection.prototype.first = function (cb) {
            return this.limit(1).toArray(function (a) { return a[0]; }).then(cb);
        };
        Collection.prototype.last = function (cb) {
            return this.reverse().first(cb);
        };
        Collection.prototype.filter = function (filterFunction) {
            addFilter(this._ctx, function (cursor) {
                return filterFunction(cursor.value);
            });
            addMatchFilter(this._ctx, filterFunction);
            return this;
        };
        Collection.prototype.and = function (filter) {
            return this.filter(filter);
        };
        Collection.prototype.or = function (indexName) {
            return new this.db.WhereClause(this._ctx.table, indexName, this);
        };
        Collection.prototype.reverse = function () {
            this._ctx.dir = (this._ctx.dir === "prev" ? "next" : "prev");
            if (this._ondirectionchange)
                this._ondirectionchange(this._ctx.dir);
            return this;
        };
        Collection.prototype.desc = function () {
            return this.reverse();
        };
        Collection.prototype.eachKey = function (cb) {
            var ctx = this._ctx;
            ctx.keysOnly = !ctx.isMatch;
            return this.each(function (val, cursor) { cb(cursor.key, cursor); });
        };
        Collection.prototype.eachUniqueKey = function (cb) {
            this._ctx.unique = "unique";
            return this.eachKey(cb);
        };
        Collection.prototype.eachPrimaryKey = function (cb) {
            var ctx = this._ctx;
            ctx.keysOnly = !ctx.isMatch;
            return this.each(function (val, cursor) { cb(cursor.primaryKey, cursor); });
        };
        Collection.prototype.keys = function (cb) {
            var ctx = this._ctx;
            ctx.keysOnly = !ctx.isMatch;
            var a = [];
            return this.each(function (item, cursor) {
                a.push(cursor.key);
            }).then(function () {
                return a;
            }).then(cb);
        };
        Collection.prototype.primaryKeys = function (cb) {
            var ctx = this._ctx;
            if (ctx.dir === 'next' && isPlainKeyRange(ctx, true) && ctx.limit > 0) {
                return this._read(function (trans) {
                    var index = getIndexOrStore(ctx, ctx.table.core.schema);
                    return ctx.table.core.query({
                        trans: trans,
                        values: false,
                        limit: ctx.limit,
                        query: {
                            index: index,
                            range: ctx.range
                        }
                    });
                }).then(function (_a) {
                    var result = _a.result;
                    return result;
                }).then(cb);
            }
            ctx.keysOnly = !ctx.isMatch;
            var a = [];
            return this.each(function (item, cursor) {
                a.push(cursor.primaryKey);
            }).then(function () {
                return a;
            }).then(cb);
        };
        Collection.prototype.uniqueKeys = function (cb) {
            this._ctx.unique = "unique";
            return this.keys(cb);
        };
        Collection.prototype.firstKey = function (cb) {
            return this.limit(1).keys(function (a) { return a[0]; }).then(cb);
        };
        Collection.prototype.lastKey = function (cb) {
            return this.reverse().firstKey(cb);
        };
        Collection.prototype.distinct = function () {
            var ctx = this._ctx, idx = ctx.index && ctx.table.schema.idxByName[ctx.index];
            if (!idx || !idx.multi)
                return this;
            var set = {};
            addFilter(this._ctx, function (cursor) {
                var strKey = cursor.primaryKey.toString();
                var found = hasOwn(set, strKey);
                set[strKey] = true;
                return !found;
            });
            return this;
        };
        Collection.prototype.modify = function (changes) {
            var _this = this;
            var ctx = this._ctx;
            return this._write(function (trans) {
                var modifyer;
                if (typeof changes === 'function') {
                    modifyer = changes;
                }
                else {
                    var keyPaths = keys(changes);
                    var numKeys = keyPaths.length;
                    modifyer = function (item) {
                        var anythingModified = false;
                        for (var i = 0; i < numKeys; ++i) {
                            var keyPath = keyPaths[i], val = changes[keyPath];
                            if (getByKeyPath(item, keyPath) !== val) {
                                setByKeyPath(item, keyPath, val);
                                anythingModified = true;
                            }
                        }
                        return anythingModified;
                    };
                }
                var coreTable = ctx.table.core;
                var _a = coreTable.schema.primaryKey, outbound = _a.outbound, extractKey = _a.extractKey;
                var limit = _this.db._options.modifyChunkSize || 200;
                var totalFailures = [];
                var successCount = 0;
                var failedKeys = [];
                var applyMutateResult = function (expectedCount, res) {
                    var failures = res.failures, numFailures = res.numFailures;
                    successCount += expectedCount - numFailures;
                    for (var _i = 0, _a = keys(failures); _i < _a.length; _i++) {
                        var pos = _a[_i];
                        totalFailures.push(failures[pos]);
                    }
                };
                return _this.clone().primaryKeys().then(function (keys) {
                    var nextChunk = function (offset) {
                        var count = Math.min(limit, keys.length - offset);
                        return coreTable.getMany({
                            trans: trans,
                            keys: keys.slice(offset, offset + count),
                            cache: "immutable"
                        }).then(function (values) {
                            var addValues = [];
                            var putValues = [];
                            var putKeys = outbound ? [] : null;
                            var deleteKeys = [];
                            for (var i = 0; i < count; ++i) {
                                var origValue = values[i];
                                var ctx_1 = {
                                    value: deepClone$1(origValue),
                                    primKey: keys[offset + i]
                                };
                                if (modifyer.call(ctx_1, ctx_1.value, ctx_1) !== false) {
                                    if (ctx_1.value == null) {
                                        deleteKeys.push(keys[offset + i]);
                                    }
                                    else if (!outbound && cmp(extractKey(origValue), extractKey(ctx_1.value)) !== 0) {
                                        deleteKeys.push(keys[offset + i]);
                                        addValues.push(ctx_1.value);
                                    }
                                    else {
                                        putValues.push(ctx_1.value);
                                        if (outbound)
                                            putKeys.push(keys[offset + i]);
                                    }
                                }
                            }
                            var criteria = isPlainKeyRange(ctx) &&
                                ctx.limit === Infinity &&
                                (typeof changes !== 'function' || changes === deleteCallback) && {
                                index: ctx.index,
                                range: ctx.range
                            };
                            return Promise.resolve(addValues.length > 0 &&
                                coreTable.mutate({ trans: trans, type: 'add', values: addValues })
                                    .then(function (res) {
                                    for (var pos in res.failures) {
                                        deleteKeys.splice(parseInt(pos), 1);
                                    }
                                    applyMutateResult(addValues.length, res);
                                })).then(function () { return (putValues.length > 0 || (criteria && typeof changes === 'object')) &&
                                coreTable.mutate({
                                    trans: trans,
                                    type: 'put',
                                    keys: putKeys,
                                    values: putValues,
                                    criteria: criteria,
                                    changeSpec: typeof changes !== 'function'
                                        && changes
                                }).then(function (res) { return applyMutateResult(putValues.length, res); }); }).then(function () { return (deleteKeys.length > 0 || (criteria && changes === deleteCallback)) &&
                                coreTable.mutate({
                                    trans: trans,
                                    type: 'delete',
                                    keys: deleteKeys,
                                    criteria: criteria
                                }).then(function (res) { return applyMutateResult(deleteKeys.length, res); }); }).then(function () {
                                return keys.length > offset + count && nextChunk(offset + limit);
                            });
                        });
                    };
                    return nextChunk(0).then(function () {
                        if (totalFailures.length > 0)
                            throw new ModifyError("Error modifying one or more objects", totalFailures, successCount, failedKeys);
                        return keys.length;
                    });
                });
            });
        };
        Collection.prototype.delete = function () {
            var ctx = this._ctx, range = ctx.range;
            if (isPlainKeyRange(ctx) &&
                ((ctx.isPrimKey && !hangsOnDeleteLargeKeyRange) || range.type === 3 ))
             {
                return this._write(function (trans) {
                    var primaryKey = ctx.table.core.schema.primaryKey;
                    var coreRange = range;
                    return ctx.table.core.count({ trans: trans, query: { index: primaryKey, range: coreRange } }).then(function (count) {
                        return ctx.table.core.mutate({ trans: trans, type: 'deleteRange', range: coreRange })
                            .then(function (_a) {
                            var failures = _a.failures; _a.lastResult; _a.results; var numFailures = _a.numFailures;
                            if (numFailures)
                                throw new ModifyError("Could not delete some values", Object.keys(failures).map(function (pos) { return failures[pos]; }), count - numFailures);
                            return count - numFailures;
                        });
                    });
                });
            }
            return this.modify(deleteCallback);
        };
        return Collection;
    }());
    var deleteCallback = function (value, ctx) { return ctx.value = null; };

    function createCollectionConstructor(db) {
        return makeClassConstructor(Collection.prototype, function Collection(whereClause, keyRangeGenerator) {
            this.db = db;
            var keyRange = AnyRange, error = null;
            if (keyRangeGenerator)
                try {
                    keyRange = keyRangeGenerator();
                }
                catch (ex) {
                    error = ex;
                }
            var whereCtx = whereClause._ctx;
            var table = whereCtx.table;
            var readingHook = table.hook.reading.fire;
            this._ctx = {
                table: table,
                index: whereCtx.index,
                isPrimKey: (!whereCtx.index || (table.schema.primKey.keyPath && whereCtx.index === table.schema.primKey.name)),
                range: keyRange,
                keysOnly: false,
                dir: "next",
                unique: "",
                algorithm: null,
                filter: null,
                replayFilter: null,
                justLimit: true,
                isMatch: null,
                offset: 0,
                limit: Infinity,
                error: error,
                or: whereCtx.or,
                valueMapper: readingHook !== mirror ? readingHook : null
            };
        });
    }

    function simpleCompare(a, b) {
        return a < b ? -1 : a === b ? 0 : 1;
    }
    function simpleCompareReverse(a, b) {
        return a > b ? -1 : a === b ? 0 : 1;
    }

    function fail(collectionOrWhereClause, err, T) {
        var collection = collectionOrWhereClause instanceof WhereClause ?
            new collectionOrWhereClause.Collection(collectionOrWhereClause) :
            collectionOrWhereClause;
        collection._ctx.error = T ? new T(err) : new TypeError(err);
        return collection;
    }
    function emptyCollection(whereClause) {
        return new whereClause.Collection(whereClause, function () { return rangeEqual(""); }).limit(0);
    }
    function upperFactory(dir) {
        return dir === "next" ?
            function (s) { return s.toUpperCase(); } :
            function (s) { return s.toLowerCase(); };
    }
    function lowerFactory(dir) {
        return dir === "next" ?
            function (s) { return s.toLowerCase(); } :
            function (s) { return s.toUpperCase(); };
    }
    function nextCasing(key, lowerKey, upperNeedle, lowerNeedle, cmp, dir) {
        var length = Math.min(key.length, lowerNeedle.length);
        var llp = -1;
        for (var i = 0; i < length; ++i) {
            var lwrKeyChar = lowerKey[i];
            if (lwrKeyChar !== lowerNeedle[i]) {
                if (cmp(key[i], upperNeedle[i]) < 0)
                    return key.substr(0, i) + upperNeedle[i] + upperNeedle.substr(i + 1);
                if (cmp(key[i], lowerNeedle[i]) < 0)
                    return key.substr(0, i) + lowerNeedle[i] + upperNeedle.substr(i + 1);
                if (llp >= 0)
                    return key.substr(0, llp) + lowerKey[llp] + upperNeedle.substr(llp + 1);
                return null;
            }
            if (cmp(key[i], lwrKeyChar) < 0)
                llp = i;
        }
        if (length < lowerNeedle.length && dir === "next")
            return key + upperNeedle.substr(key.length);
        if (length < key.length && dir === "prev")
            return key.substr(0, upperNeedle.length);
        return (llp < 0 ? null : key.substr(0, llp) + lowerNeedle[llp] + upperNeedle.substr(llp + 1));
    }
    function addIgnoreCaseAlgorithm(whereClause, match, needles, suffix) {
        var upper, lower, compare, upperNeedles, lowerNeedles, direction, nextKeySuffix, needlesLen = needles.length;
        if (!needles.every(function (s) { return typeof s === 'string'; })) {
            return fail(whereClause, STRING_EXPECTED);
        }
        function initDirection(dir) {
            upper = upperFactory(dir);
            lower = lowerFactory(dir);
            compare = (dir === "next" ? simpleCompare : simpleCompareReverse);
            var needleBounds = needles.map(function (needle) {
                return { lower: lower(needle), upper: upper(needle) };
            }).sort(function (a, b) {
                return compare(a.lower, b.lower);
            });
            upperNeedles = needleBounds.map(function (nb) { return nb.upper; });
            lowerNeedles = needleBounds.map(function (nb) { return nb.lower; });
            direction = dir;
            nextKeySuffix = (dir === "next" ? "" : suffix);
        }
        initDirection("next");
        var c = new whereClause.Collection(whereClause, function () { return createRange$1(upperNeedles[0], lowerNeedles[needlesLen - 1] + suffix); });
        c._ondirectionchange = function (direction) {
            initDirection(direction);
        };
        var firstPossibleNeedle = 0;
        c._addAlgorithm(function (cursor, advance, resolve) {
            var key = cursor.key;
            if (typeof key !== 'string')
                return false;
            var lowerKey = lower(key);
            if (match(lowerKey, lowerNeedles, firstPossibleNeedle)) {
                return true;
            }
            else {
                var lowestPossibleCasing = null;
                for (var i = firstPossibleNeedle; i < needlesLen; ++i) {
                    var casing = nextCasing(key, lowerKey, upperNeedles[i], lowerNeedles[i], compare, direction);
                    if (casing === null && lowestPossibleCasing === null)
                        firstPossibleNeedle = i + 1;
                    else if (lowestPossibleCasing === null || compare(lowestPossibleCasing, casing) > 0) {
                        lowestPossibleCasing = casing;
                    }
                }
                if (lowestPossibleCasing !== null) {
                    advance(function () { cursor.continue(lowestPossibleCasing + nextKeySuffix); });
                }
                else {
                    advance(resolve);
                }
                return false;
            }
        });
        return c;
    }
    function createRange$1(lower, upper, lowerOpen, upperOpen) {
        return {
            type: 2 ,
            lower: lower,
            upper: upper,
            lowerOpen: lowerOpen,
            upperOpen: upperOpen
        };
    }
    function rangeEqual(value) {
        return {
            type: 1 ,
            lower: value,
            upper: value
        };
    }

    var WhereClause =  (function () {
        function WhereClause() {
        }
        Object.defineProperty(WhereClause.prototype, "Collection", {
            get: function () {
                return this._ctx.table.db.Collection;
            },
            enumerable: false,
            configurable: true
        });
        WhereClause.prototype.between = function (lower, upper, includeLower, includeUpper) {
            includeLower = includeLower !== false;
            includeUpper = includeUpper === true;
            try {
                if ((this._cmp(lower, upper) > 0) ||
                    (this._cmp(lower, upper) === 0 && (includeLower || includeUpper) && !(includeLower && includeUpper)))
                    return emptyCollection(this);
                return new this.Collection(this, function () { return createRange$1(lower, upper, !includeLower, !includeUpper); });
            }
            catch (e) {
                return fail(this, INVALID_KEY_ARGUMENT);
            }
        };
        WhereClause.prototype.equals = function (value) {
            if (value == null)
                return fail(this, INVALID_KEY_ARGUMENT);
            return new this.Collection(this, function () { return rangeEqual(value); });
        };
        WhereClause.prototype.above = function (value) {
            if (value == null)
                return fail(this, INVALID_KEY_ARGUMENT);
            return new this.Collection(this, function () { return createRange$1(value, undefined, true); });
        };
        WhereClause.prototype.aboveOrEqual = function (value) {
            if (value == null)
                return fail(this, INVALID_KEY_ARGUMENT);
            return new this.Collection(this, function () { return createRange$1(value, undefined, false); });
        };
        WhereClause.prototype.below = function (value) {
            if (value == null)
                return fail(this, INVALID_KEY_ARGUMENT);
            return new this.Collection(this, function () { return createRange$1(undefined, value, false, true); });
        };
        WhereClause.prototype.belowOrEqual = function (value) {
            if (value == null)
                return fail(this, INVALID_KEY_ARGUMENT);
            return new this.Collection(this, function () { return createRange$1(undefined, value); });
        };
        WhereClause.prototype.startsWith = function (str) {
            if (typeof str !== 'string')
                return fail(this, STRING_EXPECTED);
            return this.between(str, str + maxString, true, true);
        };
        WhereClause.prototype.startsWithIgnoreCase = function (str) {
            if (str === "")
                return this.startsWith(str);
            return addIgnoreCaseAlgorithm(this, function (x, a) { return x.indexOf(a[0]) === 0; }, [str], maxString);
        };
        WhereClause.prototype.equalsIgnoreCase = function (str) {
            return addIgnoreCaseAlgorithm(this, function (x, a) { return x === a[0]; }, [str], "");
        };
        WhereClause.prototype.anyOfIgnoreCase = function () {
            var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
            if (set.length === 0)
                return emptyCollection(this);
            return addIgnoreCaseAlgorithm(this, function (x, a) { return a.indexOf(x) !== -1; }, set, "");
        };
        WhereClause.prototype.startsWithAnyOfIgnoreCase = function () {
            var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
            if (set.length === 0)
                return emptyCollection(this);
            return addIgnoreCaseAlgorithm(this, function (x, a) { return a.some(function (n) { return x.indexOf(n) === 0; }); }, set, maxString);
        };
        WhereClause.prototype.anyOf = function () {
            var _this = this;
            var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
            var compare = this._cmp;
            try {
                set.sort(compare);
            }
            catch (e) {
                return fail(this, INVALID_KEY_ARGUMENT);
            }
            if (set.length === 0)
                return emptyCollection(this);
            var c = new this.Collection(this, function () { return createRange$1(set[0], set[set.length - 1]); });
            c._ondirectionchange = function (direction) {
                compare = (direction === "next" ?
                    _this._ascending :
                    _this._descending);
                set.sort(compare);
            };
            var i = 0;
            c._addAlgorithm(function (cursor, advance, resolve) {
                var key = cursor.key;
                while (compare(key, set[i]) > 0) {
                    ++i;
                    if (i === set.length) {
                        advance(resolve);
                        return false;
                    }
                }
                if (compare(key, set[i]) === 0) {
                    return true;
                }
                else {
                    advance(function () { cursor.continue(set[i]); });
                    return false;
                }
            });
            return c;
        };
        WhereClause.prototype.notEqual = function (value) {
            return this.inAnyRange([[minKey, value], [value, this.db._maxKey]], { includeLowers: false, includeUppers: false });
        };
        WhereClause.prototype.noneOf = function () {
            var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
            if (set.length === 0)
                return new this.Collection(this);
            try {
                set.sort(this._ascending);
            }
            catch (e) {
                return fail(this, INVALID_KEY_ARGUMENT);
            }
            var ranges = set.reduce(function (res, val) { return res ?
                res.concat([[res[res.length - 1][1], val]]) :
                [[minKey, val]]; }, null);
            ranges.push([set[set.length - 1], this.db._maxKey]);
            return this.inAnyRange(ranges, { includeLowers: false, includeUppers: false });
        };
        WhereClause.prototype.inAnyRange = function (ranges, options) {
            var _this = this;
            var cmp = this._cmp, ascending = this._ascending, descending = this._descending, min = this._min, max = this._max;
            if (ranges.length === 0)
                return emptyCollection(this);
            if (!ranges.every(function (range) {
                return range[0] !== undefined &&
                    range[1] !== undefined &&
                    ascending(range[0], range[1]) <= 0;
            })) {
                return fail(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", exceptions.InvalidArgument);
            }
            var includeLowers = !options || options.includeLowers !== false;
            var includeUppers = options && options.includeUppers === true;
            function addRange(ranges, newRange) {
                var i = 0, l = ranges.length;
                for (; i < l; ++i) {
                    var range = ranges[i];
                    if (cmp(newRange[0], range[1]) < 0 && cmp(newRange[1], range[0]) > 0) {
                        range[0] = min(range[0], newRange[0]);
                        range[1] = max(range[1], newRange[1]);
                        break;
                    }
                }
                if (i === l)
                    ranges.push(newRange);
                return ranges;
            }
            var sortDirection = ascending;
            function rangeSorter(a, b) { return sortDirection(a[0], b[0]); }
            var set;
            try {
                set = ranges.reduce(addRange, []);
                set.sort(rangeSorter);
            }
            catch (ex) {
                return fail(this, INVALID_KEY_ARGUMENT);
            }
            var rangePos = 0;
            var keyIsBeyondCurrentEntry = includeUppers ?
                function (key) { return ascending(key, set[rangePos][1]) > 0; } :
                function (key) { return ascending(key, set[rangePos][1]) >= 0; };
            var keyIsBeforeCurrentEntry = includeLowers ?
                function (key) { return descending(key, set[rangePos][0]) > 0; } :
                function (key) { return descending(key, set[rangePos][0]) >= 0; };
            function keyWithinCurrentRange(key) {
                return !keyIsBeyondCurrentEntry(key) && !keyIsBeforeCurrentEntry(key);
            }
            var checkKey = keyIsBeyondCurrentEntry;
            var c = new this.Collection(this, function () { return createRange$1(set[0][0], set[set.length - 1][1], !includeLowers, !includeUppers); });
            c._ondirectionchange = function (direction) {
                if (direction === "next") {
                    checkKey = keyIsBeyondCurrentEntry;
                    sortDirection = ascending;
                }
                else {
                    checkKey = keyIsBeforeCurrentEntry;
                    sortDirection = descending;
                }
                set.sort(rangeSorter);
            };
            c._addAlgorithm(function (cursor, advance, resolve) {
                var key = cursor.key;
                while (checkKey(key)) {
                    ++rangePos;
                    if (rangePos === set.length) {
                        advance(resolve);
                        return false;
                    }
                }
                if (keyWithinCurrentRange(key)) {
                    return true;
                }
                else if (_this._cmp(key, set[rangePos][1]) === 0 || _this._cmp(key, set[rangePos][0]) === 0) {
                    return false;
                }
                else {
                    advance(function () {
                        if (sortDirection === ascending)
                            cursor.continue(set[rangePos][0]);
                        else
                            cursor.continue(set[rangePos][1]);
                    });
                    return false;
                }
            });
            return c;
        };
        WhereClause.prototype.startsWithAnyOf = function () {
            var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
            if (!set.every(function (s) { return typeof s === 'string'; })) {
                return fail(this, "startsWithAnyOf() only works with strings");
            }
            if (set.length === 0)
                return emptyCollection(this);
            return this.inAnyRange(set.map(function (str) { return [str, str + maxString]; }));
        };
        return WhereClause;
    }());

    function createWhereClauseConstructor(db) {
        return makeClassConstructor(WhereClause.prototype, function WhereClause(table, index, orCollection) {
            this.db = db;
            this._ctx = {
                table: table,
                index: index === ":id" ? null : index,
                or: orCollection
            };
            var indexedDB = db._deps.indexedDB;
            if (!indexedDB)
                throw new exceptions.MissingAPI();
            this._cmp = this._ascending = indexedDB.cmp.bind(indexedDB);
            this._descending = function (a, b) { return indexedDB.cmp(b, a); };
            this._max = function (a, b) { return indexedDB.cmp(a, b) > 0 ? a : b; };
            this._min = function (a, b) { return indexedDB.cmp(a, b) < 0 ? a : b; };
            this._IDBKeyRange = db._deps.IDBKeyRange;
        });
    }

    function eventRejectHandler(reject) {
        return wrap(function (event) {
            preventDefault(event);
            reject(event.target.error);
            return false;
        });
    }
    function preventDefault(event) {
        if (event.stopPropagation)
            event.stopPropagation();
        if (event.preventDefault)
            event.preventDefault();
    }

    var DEXIE_STORAGE_MUTATED_EVENT_NAME = 'storagemutated';
    var STORAGE_MUTATED_DOM_EVENT_NAME = 'x-storagemutated-1';
    var globalEvents = Events(null, DEXIE_STORAGE_MUTATED_EVENT_NAME);

    var Transaction =  (function () {
        function Transaction() {
        }
        Transaction.prototype._lock = function () {
            assert(!PSD.global);
            ++this._reculock;
            if (this._reculock === 1 && !PSD.global)
                PSD.lockOwnerFor = this;
            return this;
        };
        Transaction.prototype._unlock = function () {
            assert(!PSD.global);
            if (--this._reculock === 0) {
                if (!PSD.global)
                    PSD.lockOwnerFor = null;
                while (this._blockedFuncs.length > 0 && !this._locked()) {
                    var fnAndPSD = this._blockedFuncs.shift();
                    try {
                        usePSD(fnAndPSD[1], fnAndPSD[0]);
                    }
                    catch (e) { }
                }
            }
            return this;
        };
        Transaction.prototype._locked = function () {
            return this._reculock && PSD.lockOwnerFor !== this;
        };
        Transaction.prototype.create = function (idbtrans) {
            var _this = this;
            if (!this.mode)
                return this;
            var idbdb = this.db.idbdb;
            var dbOpenError = this.db._state.dbOpenError;
            assert(!this.idbtrans);
            if (!idbtrans && !idbdb) {
                switch (dbOpenError && dbOpenError.name) {
                    case "DatabaseClosedError":
                        throw new exceptions.DatabaseClosed(dbOpenError);
                    case "MissingAPIError":
                        throw new exceptions.MissingAPI(dbOpenError.message, dbOpenError);
                    default:
                        throw new exceptions.OpenFailed(dbOpenError);
                }
            }
            if (!this.active)
                throw new exceptions.TransactionInactive();
            assert(this._completion._state === null);
            idbtrans = this.idbtrans = idbtrans ||
                (this.db.core
                    ? this.db.core.transaction(this.storeNames, this.mode, { durability: this.chromeTransactionDurability })
                    : idbdb.transaction(this.storeNames, this.mode, { durability: this.chromeTransactionDurability }));
            idbtrans.onerror = wrap(function (ev) {
                preventDefault(ev);
                _this._reject(idbtrans.error);
            });
            idbtrans.onabort = wrap(function (ev) {
                preventDefault(ev);
                _this.active && _this._reject(new exceptions.Abort(idbtrans.error));
                _this.active = false;
                _this.on("abort").fire(ev);
            });
            idbtrans.oncomplete = wrap(function () {
                _this.active = false;
                _this._resolve();
                if ('mutatedParts' in idbtrans) {
                    globalEvents.storagemutated.fire(idbtrans["mutatedParts"]);
                }
            });
            return this;
        };
        Transaction.prototype._promise = function (mode, fn, bWriteLock) {
            var _this = this;
            if (mode === 'readwrite' && this.mode !== 'readwrite')
                return rejection(new exceptions.ReadOnly("Transaction is readonly"));
            if (!this.active)
                return rejection(new exceptions.TransactionInactive());
            if (this._locked()) {
                return new DexiePromise(function (resolve, reject) {
                    _this._blockedFuncs.push([function () {
                            _this._promise(mode, fn, bWriteLock).then(resolve, reject);
                        }, PSD]);
                });
            }
            else if (bWriteLock) {
                return newScope(function () {
                    var p = new DexiePromise(function (resolve, reject) {
                        _this._lock();
                        var rv = fn(resolve, reject, _this);
                        if (rv && rv.then)
                            rv.then(resolve, reject);
                    });
                    p.finally(function () { return _this._unlock(); });
                    p._lib = true;
                    return p;
                });
            }
            else {
                var p = new DexiePromise(function (resolve, reject) {
                    var rv = fn(resolve, reject, _this);
                    if (rv && rv.then)
                        rv.then(resolve, reject);
                });
                p._lib = true;
                return p;
            }
        };
        Transaction.prototype._root = function () {
            return this.parent ? this.parent._root() : this;
        };
        Transaction.prototype.waitFor = function (promiseLike) {
            var root = this._root();
            var promise = DexiePromise.resolve(promiseLike);
            if (root._waitingFor) {
                root._waitingFor = root._waitingFor.then(function () { return promise; });
            }
            else {
                root._waitingFor = promise;
                root._waitingQueue = [];
                var store = root.idbtrans.objectStore(root.storeNames[0]);
                (function spin() {
                    ++root._spinCount;
                    while (root._waitingQueue.length)
                        (root._waitingQueue.shift())();
                    if (root._waitingFor)
                        store.get(-Infinity).onsuccess = spin;
                }());
            }
            var currentWaitPromise = root._waitingFor;
            return new DexiePromise(function (resolve, reject) {
                promise.then(function (res) { return root._waitingQueue.push(wrap(resolve.bind(null, res))); }, function (err) { return root._waitingQueue.push(wrap(reject.bind(null, err))); }).finally(function () {
                    if (root._waitingFor === currentWaitPromise) {
                        root._waitingFor = null;
                    }
                });
            });
        };
        Transaction.prototype.abort = function () {
            if (this.active) {
                this.active = false;
                if (this.idbtrans)
                    this.idbtrans.abort();
                this._reject(new exceptions.Abort());
            }
        };
        Transaction.prototype.table = function (tableName) {
            var memoizedTables = (this._memoizedTables || (this._memoizedTables = {}));
            if (hasOwn(memoizedTables, tableName))
                return memoizedTables[tableName];
            var tableSchema = this.schema[tableName];
            if (!tableSchema) {
                throw new exceptions.NotFound("Table " + tableName + " not part of transaction");
            }
            var transactionBoundTable = new this.db.Table(tableName, tableSchema, this);
            transactionBoundTable.core = this.db.core.table(tableName);
            memoizedTables[tableName] = transactionBoundTable;
            return transactionBoundTable;
        };
        return Transaction;
    }());

    function createTransactionConstructor(db) {
        return makeClassConstructor(Transaction.prototype, function Transaction(mode, storeNames, dbschema, chromeTransactionDurability, parent) {
            var _this = this;
            this.db = db;
            this.mode = mode;
            this.storeNames = storeNames;
            this.schema = dbschema;
            this.chromeTransactionDurability = chromeTransactionDurability;
            this.idbtrans = null;
            this.on = Events(this, "complete", "error", "abort");
            this.parent = parent || null;
            this.active = true;
            this._reculock = 0;
            this._blockedFuncs = [];
            this._resolve = null;
            this._reject = null;
            this._waitingFor = null;
            this._waitingQueue = null;
            this._spinCount = 0;
            this._completion = new DexiePromise(function (resolve, reject) {
                _this._resolve = resolve;
                _this._reject = reject;
            });
            this._completion.then(function () {
                _this.active = false;
                _this.on.complete.fire();
            }, function (e) {
                var wasActive = _this.active;
                _this.active = false;
                _this.on.error.fire(e);
                _this.parent ?
                    _this.parent._reject(e) :
                    wasActive && _this.idbtrans && _this.idbtrans.abort();
                return rejection(e);
            });
        });
    }

    function createIndexSpec(name, keyPath, unique, multi, auto, compound, isPrimKey) {
        return {
            name: name,
            keyPath: keyPath,
            unique: unique,
            multi: multi,
            auto: auto,
            compound: compound,
            src: (unique && !isPrimKey ? '&' : '') + (multi ? '*' : '') + (auto ? "++" : "") + nameFromKeyPath(keyPath)
        };
    }
    function nameFromKeyPath(keyPath) {
        return typeof keyPath === 'string' ?
            keyPath :
            keyPath ? ('[' + [].join.call(keyPath, '+') + ']') : "";
    }

    function createTableSchema(name, primKey, indexes) {
        return {
            name: name,
            primKey: primKey,
            indexes: indexes,
            mappedClass: null,
            idxByName: arrayToObject(indexes, function (index) { return [index.name, index]; })
        };
    }

    function safariMultiStoreFix(storeNames) {
        return storeNames.length === 1 ? storeNames[0] : storeNames;
    }
    var getMaxKey = function (IdbKeyRange) {
        try {
            IdbKeyRange.only([[]]);
            getMaxKey = function () { return [[]]; };
            return [[]];
        }
        catch (e) {
            getMaxKey = function () { return maxString; };
            return maxString;
        }
    };

    function getKeyExtractor(keyPath) {
        if (keyPath == null) {
            return function () { return undefined; };
        }
        else if (typeof keyPath === 'string') {
            return getSinglePathKeyExtractor(keyPath);
        }
        else {
            return function (obj) { return getByKeyPath(obj, keyPath); };
        }
    }
    function getSinglePathKeyExtractor(keyPath) {
        var split = keyPath.split('.');
        if (split.length === 1) {
            return function (obj) { return obj[keyPath]; };
        }
        else {
            return function (obj) { return getByKeyPath(obj, keyPath); };
        }
    }

    function arrayify(arrayLike) {
        return [].slice.call(arrayLike);
    }
    var _id_counter = 0;
    function getKeyPathAlias(keyPath) {
        return keyPath == null ?
            ":id" :
            typeof keyPath === 'string' ?
                keyPath :
                "[" + keyPath.join('+') + "]";
    }
    function createDBCore(db, IdbKeyRange, tmpTrans) {
        function extractSchema(db, trans) {
            var tables = arrayify(db.objectStoreNames);
            return {
                schema: {
                    name: db.name,
                    tables: tables.map(function (table) { return trans.objectStore(table); }).map(function (store) {
                        var keyPath = store.keyPath, autoIncrement = store.autoIncrement;
                        var compound = isArray(keyPath);
                        var outbound = keyPath == null;
                        var indexByKeyPath = {};
                        var result = {
                            name: store.name,
                            primaryKey: {
                                name: null,
                                isPrimaryKey: true,
                                outbound: outbound,
                                compound: compound,
                                keyPath: keyPath,
                                autoIncrement: autoIncrement,
                                unique: true,
                                extractKey: getKeyExtractor(keyPath)
                            },
                            indexes: arrayify(store.indexNames).map(function (indexName) { return store.index(indexName); })
                                .map(function (index) {
                                var name = index.name, unique = index.unique, multiEntry = index.multiEntry, keyPath = index.keyPath;
                                var compound = isArray(keyPath);
                                var result = {
                                    name: name,
                                    compound: compound,
                                    keyPath: keyPath,
                                    unique: unique,
                                    multiEntry: multiEntry,
                                    extractKey: getKeyExtractor(keyPath)
                                };
                                indexByKeyPath[getKeyPathAlias(keyPath)] = result;
                                return result;
                            }),
                            getIndexByKeyPath: function (keyPath) { return indexByKeyPath[getKeyPathAlias(keyPath)]; }
                        };
                        indexByKeyPath[":id"] = result.primaryKey;
                        if (keyPath != null) {
                            indexByKeyPath[getKeyPathAlias(keyPath)] = result.primaryKey;
                        }
                        return result;
                    })
                },
                hasGetAll: tables.length > 0 && ('getAll' in trans.objectStore(tables[0])) &&
                    !(typeof navigator !== 'undefined' && /Safari/.test(navigator.userAgent) &&
                        !/(Chrome\/|Edge\/)/.test(navigator.userAgent) &&
                        [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604)
            };
        }
        function makeIDBKeyRange(range) {
            if (range.type === 3 )
                return null;
            if (range.type === 4 )
                throw new Error("Cannot convert never type to IDBKeyRange");
            var lower = range.lower, upper = range.upper, lowerOpen = range.lowerOpen, upperOpen = range.upperOpen;
            var idbRange = lower === undefined ?
                upper === undefined ?
                    null :
                    IdbKeyRange.upperBound(upper, !!upperOpen) :
                upper === undefined ?
                    IdbKeyRange.lowerBound(lower, !!lowerOpen) :
                    IdbKeyRange.bound(lower, upper, !!lowerOpen, !!upperOpen);
            return idbRange;
        }
        function createDbCoreTable(tableSchema) {
            var tableName = tableSchema.name;
            function mutate(_a) {
                var trans = _a.trans, type = _a.type, keys = _a.keys, values = _a.values, range = _a.range;
                return new Promise(function (resolve, reject) {
                    resolve = wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var outbound = store.keyPath == null;
                    var isAddOrPut = type === "put" || type === "add";
                    if (!isAddOrPut && type !== 'delete' && type !== 'deleteRange')
                        throw new Error("Invalid operation type: " + type);
                    var length = (keys || values || { length: 1 }).length;
                    if (keys && values && keys.length !== values.length) {
                        throw new Error("Given keys array must have same length as given values array.");
                    }
                    if (length === 0)
                        return resolve({ numFailures: 0, failures: {}, results: [], lastResult: undefined });
                    var req;
                    var reqs = [];
                    var failures = [];
                    var numFailures = 0;
                    var errorHandler = function (event) {
                        ++numFailures;
                        preventDefault(event);
                    };
                    if (type === 'deleteRange') {
                        if (range.type === 4 )
                            return resolve({ numFailures: numFailures, failures: failures, results: [], lastResult: undefined });
                        if (range.type === 3 )
                            reqs.push(req = store.clear());
                        else
                            reqs.push(req = store.delete(makeIDBKeyRange(range)));
                    }
                    else {
                        var _a = isAddOrPut ?
                            outbound ?
                                [values, keys] :
                                [values, null] :
                            [keys, null], args1 = _a[0], args2 = _a[1];
                        if (isAddOrPut) {
                            for (var i = 0; i < length; ++i) {
                                reqs.push(req = (args2 && args2[i] !== undefined ?
                                    store[type](args1[i], args2[i]) :
                                    store[type](args1[i])));
                                req.onerror = errorHandler;
                            }
                        }
                        else {
                            for (var i = 0; i < length; ++i) {
                                reqs.push(req = store[type](args1[i]));
                                req.onerror = errorHandler;
                            }
                        }
                    }
                    var done = function (event) {
                        var lastResult = event.target.result;
                        reqs.forEach(function (req, i) { return req.error != null && (failures[i] = req.error); });
                        resolve({
                            numFailures: numFailures,
                            failures: failures,
                            results: type === "delete" ? keys : reqs.map(function (req) { return req.result; }),
                            lastResult: lastResult
                        });
                    };
                    req.onerror = function (event) {
                        errorHandler(event);
                        done(event);
                    };
                    req.onsuccess = done;
                });
            }
            function openCursor(_a) {
                var trans = _a.trans, values = _a.values, query = _a.query, reverse = _a.reverse, unique = _a.unique;
                return new Promise(function (resolve, reject) {
                    resolve = wrap(resolve);
                    var index = query.index, range = query.range;
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ?
                        store :
                        store.index(index.name);
                    var direction = reverse ?
                        unique ?
                            "prevunique" :
                            "prev" :
                        unique ?
                            "nextunique" :
                            "next";
                    var req = values || !('openKeyCursor' in source) ?
                        source.openCursor(makeIDBKeyRange(range), direction) :
                        source.openKeyCursor(makeIDBKeyRange(range), direction);
                    req.onerror = eventRejectHandler(reject);
                    req.onsuccess = wrap(function (ev) {
                        var cursor = req.result;
                        if (!cursor) {
                            resolve(null);
                            return;
                        }
                        cursor.___id = ++_id_counter;
                        cursor.done = false;
                        var _cursorContinue = cursor.continue.bind(cursor);
                        var _cursorContinuePrimaryKey = cursor.continuePrimaryKey;
                        if (_cursorContinuePrimaryKey)
                            _cursorContinuePrimaryKey = _cursorContinuePrimaryKey.bind(cursor);
                        var _cursorAdvance = cursor.advance.bind(cursor);
                        var doThrowCursorIsNotStarted = function () { throw new Error("Cursor not started"); };
                        var doThrowCursorIsStopped = function () { throw new Error("Cursor not stopped"); };
                        cursor.trans = trans;
                        cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsNotStarted;
                        cursor.fail = wrap(reject);
                        cursor.next = function () {
                            var _this = this;
                            var gotOne = 1;
                            return this.start(function () { return gotOne-- ? _this.continue() : _this.stop(); }).then(function () { return _this; });
                        };
                        cursor.start = function (callback) {
                            var iterationPromise = new Promise(function (resolveIteration, rejectIteration) {
                                resolveIteration = wrap(resolveIteration);
                                req.onerror = eventRejectHandler(rejectIteration);
                                cursor.fail = rejectIteration;
                                cursor.stop = function (value) {
                                    cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsStopped;
                                    resolveIteration(value);
                                };
                            });
                            var guardedCallback = function () {
                                if (req.result) {
                                    try {
                                        callback();
                                    }
                                    catch (err) {
                                        cursor.fail(err);
                                    }
                                }
                                else {
                                    cursor.done = true;
                                    cursor.start = function () { throw new Error("Cursor behind last entry"); };
                                    cursor.stop();
                                }
                            };
                            req.onsuccess = wrap(function (ev) {
                                req.onsuccess = guardedCallback;
                                guardedCallback();
                            });
                            cursor.continue = _cursorContinue;
                            cursor.continuePrimaryKey = _cursorContinuePrimaryKey;
                            cursor.advance = _cursorAdvance;
                            guardedCallback();
                            return iterationPromise;
                        };
                        resolve(cursor);
                    }, reject);
                });
            }
            function query(hasGetAll) {
                return function (request) {
                    return new Promise(function (resolve, reject) {
                        resolve = wrap(resolve);
                        var trans = request.trans, values = request.values, limit = request.limit, query = request.query;
                        var nonInfinitLimit = limit === Infinity ? undefined : limit;
                        var index = query.index, range = query.range;
                        var store = trans.objectStore(tableName);
                        var source = index.isPrimaryKey ? store : store.index(index.name);
                        var idbKeyRange = makeIDBKeyRange(range);
                        if (limit === 0)
                            return resolve({ result: [] });
                        if (hasGetAll) {
                            var req = values ?
                                source.getAll(idbKeyRange, nonInfinitLimit) :
                                source.getAllKeys(idbKeyRange, nonInfinitLimit);
                            req.onsuccess = function (event) { return resolve({ result: event.target.result }); };
                            req.onerror = eventRejectHandler(reject);
                        }
                        else {
                            var count_1 = 0;
                            var req_1 = values || !('openKeyCursor' in source) ?
                                source.openCursor(idbKeyRange) :
                                source.openKeyCursor(idbKeyRange);
                            var result_1 = [];
                            req_1.onsuccess = function (event) {
                                var cursor = req_1.result;
                                if (!cursor)
                                    return resolve({ result: result_1 });
                                result_1.push(values ? cursor.value : cursor.primaryKey);
                                if (++count_1 === limit)
                                    return resolve({ result: result_1 });
                                cursor.continue();
                            };
                            req_1.onerror = eventRejectHandler(reject);
                        }
                    });
                };
            }
            return {
                name: tableName,
                schema: tableSchema,
                mutate: mutate,
                getMany: function (_a) {
                    var trans = _a.trans, keys = _a.keys;
                    return new Promise(function (resolve, reject) {
                        resolve = wrap(resolve);
                        var store = trans.objectStore(tableName);
                        var length = keys.length;
                        var result = new Array(length);
                        var keyCount = 0;
                        var callbackCount = 0;
                        var req;
                        var successHandler = function (event) {
                            var req = event.target;
                            if ((result[req._pos] = req.result) != null)
                                ;
                            if (++callbackCount === keyCount)
                                resolve(result);
                        };
                        var errorHandler = eventRejectHandler(reject);
                        for (var i = 0; i < length; ++i) {
                            var key = keys[i];
                            if (key != null) {
                                req = store.get(keys[i]);
                                req._pos = i;
                                req.onsuccess = successHandler;
                                req.onerror = errorHandler;
                                ++keyCount;
                            }
                        }
                        if (keyCount === 0)
                            resolve(result);
                    });
                },
                get: function (_a) {
                    var trans = _a.trans, key = _a.key;
                    return new Promise(function (resolve, reject) {
                        resolve = wrap(resolve);
                        var store = trans.objectStore(tableName);
                        var req = store.get(key);
                        req.onsuccess = function (event) { return resolve(event.target.result); };
                        req.onerror = eventRejectHandler(reject);
                    });
                },
                query: query(hasGetAll),
                openCursor: openCursor,
                count: function (_a) {
                    var query = _a.query, trans = _a.trans;
                    var index = query.index, range = query.range;
                    return new Promise(function (resolve, reject) {
                        var store = trans.objectStore(tableName);
                        var source = index.isPrimaryKey ? store : store.index(index.name);
                        var idbKeyRange = makeIDBKeyRange(range);
                        var req = idbKeyRange ? source.count(idbKeyRange) : source.count();
                        req.onsuccess = wrap(function (ev) { return resolve(ev.target.result); });
                        req.onerror = eventRejectHandler(reject);
                    });
                }
            };
        }
        var _a = extractSchema(db, tmpTrans), schema = _a.schema, hasGetAll = _a.hasGetAll;
        var tables = schema.tables.map(function (tableSchema) { return createDbCoreTable(tableSchema); });
        var tableMap = {};
        tables.forEach(function (table) { return tableMap[table.name] = table; });
        return {
            stack: "dbcore",
            transaction: db.transaction.bind(db),
            table: function (name) {
                var result = tableMap[name];
                if (!result)
                    throw new Error("Table '" + name + "' not found");
                return tableMap[name];
            },
            MIN_KEY: -Infinity,
            MAX_KEY: getMaxKey(IdbKeyRange),
            schema: schema
        };
    }

    function createMiddlewareStack(stackImpl, middlewares) {
        return middlewares.reduce(function (down, _a) {
            var create = _a.create;
            return (__assign$1(__assign$1({}, down), create(down)));
        }, stackImpl);
    }
    function createMiddlewareStacks(middlewares, idbdb, _a, tmpTrans) {
        var IDBKeyRange = _a.IDBKeyRange; _a.indexedDB;
        var dbcore = createMiddlewareStack(createDBCore(idbdb, IDBKeyRange, tmpTrans), middlewares.dbcore);
        return {
            dbcore: dbcore
        };
    }
    function generateMiddlewareStacks(_a, tmpTrans) {
        var db = _a._novip;
        var idbdb = tmpTrans.db;
        var stacks = createMiddlewareStacks(db._middlewares, idbdb, db._deps, tmpTrans);
        db.core = stacks.dbcore;
        db.tables.forEach(function (table) {
            var tableName = table.name;
            if (db.core.schema.tables.some(function (tbl) { return tbl.name === tableName; })) {
                table.core = db.core.table(tableName);
                if (db[tableName] instanceof db.Table) {
                    db[tableName].core = table.core;
                }
            }
        });
    }

    function setApiOnPlace(_a, objs, tableNames, dbschema) {
        var db = _a._novip;
        tableNames.forEach(function (tableName) {
            var schema = dbschema[tableName];
            objs.forEach(function (obj) {
                var propDesc = getPropertyDescriptor(obj, tableName);
                if (!propDesc || ("value" in propDesc && propDesc.value === undefined)) {
                    if (obj === db.Transaction.prototype || obj instanceof db.Transaction) {
                        setProp(obj, tableName, {
                            get: function () { return this.table(tableName); },
                            set: function (value) {
                                defineProperty(this, tableName, { value: value, writable: true, configurable: true, enumerable: true });
                            }
                        });
                    }
                    else {
                        obj[tableName] = new db.Table(tableName, schema);
                    }
                }
            });
        });
    }
    function removeTablesApi(_a, objs) {
        var db = _a._novip;
        objs.forEach(function (obj) {
            for (var key in obj) {
                if (obj[key] instanceof db.Table)
                    delete obj[key];
            }
        });
    }
    function lowerVersionFirst(a, b) {
        return a._cfg.version - b._cfg.version;
    }
    function runUpgraders(db, oldVersion, idbUpgradeTrans, reject) {
        var globalSchema = db._dbSchema;
        var trans = db._createTransaction('readwrite', db._storeNames, globalSchema);
        trans.create(idbUpgradeTrans);
        trans._completion.catch(reject);
        var rejectTransaction = trans._reject.bind(trans);
        var transless = PSD.transless || PSD;
        newScope(function () {
            PSD.trans = trans;
            PSD.transless = transless;
            if (oldVersion === 0) {
                keys(globalSchema).forEach(function (tableName) {
                    createTable(idbUpgradeTrans, tableName, globalSchema[tableName].primKey, globalSchema[tableName].indexes);
                });
                generateMiddlewareStacks(db, idbUpgradeTrans);
                DexiePromise.follow(function () { return db.on.populate.fire(trans); }).catch(rejectTransaction);
            }
            else
                updateTablesAndIndexes(db, oldVersion, trans, idbUpgradeTrans).catch(rejectTransaction);
        });
    }
    function updateTablesAndIndexes(_a, oldVersion, trans, idbUpgradeTrans) {
        var db = _a._novip;
        var queue = [];
        var versions = db._versions;
        var globalSchema = db._dbSchema = buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
        var anyContentUpgraderHasRun = false;
        var versToRun = versions.filter(function (v) { return v._cfg.version >= oldVersion; });
        versToRun.forEach(function (version) {
            queue.push(function () {
                var oldSchema = globalSchema;
                var newSchema = version._cfg.dbschema;
                adjustToExistingIndexNames(db, oldSchema, idbUpgradeTrans);
                adjustToExistingIndexNames(db, newSchema, idbUpgradeTrans);
                globalSchema = db._dbSchema = newSchema;
                var diff = getSchemaDiff(oldSchema, newSchema);
                diff.add.forEach(function (tuple) {
                    createTable(idbUpgradeTrans, tuple[0], tuple[1].primKey, tuple[1].indexes);
                });
                diff.change.forEach(function (change) {
                    if (change.recreate) {
                        throw new exceptions.Upgrade("Not yet support for changing primary key");
                    }
                    else {
                        var store_1 = idbUpgradeTrans.objectStore(change.name);
                        change.add.forEach(function (idx) { return addIndex(store_1, idx); });
                        change.change.forEach(function (idx) {
                            store_1.deleteIndex(idx.name);
                            addIndex(store_1, idx);
                        });
                        change.del.forEach(function (idxName) { return store_1.deleteIndex(idxName); });
                    }
                });
                var contentUpgrade = version._cfg.contentUpgrade;
                if (contentUpgrade && version._cfg.version > oldVersion) {
                    generateMiddlewareStacks(db, idbUpgradeTrans);
                    trans._memoizedTables = {};
                    anyContentUpgraderHasRun = true;
                    var upgradeSchema_1 = shallowClone(newSchema);
                    diff.del.forEach(function (table) {
                        upgradeSchema_1[table] = oldSchema[table];
                    });
                    removeTablesApi(db, [db.Transaction.prototype]);
                    setApiOnPlace(db, [db.Transaction.prototype], keys(upgradeSchema_1), upgradeSchema_1);
                    trans.schema = upgradeSchema_1;
                    var contentUpgradeIsAsync_1 = isAsyncFunction(contentUpgrade);
                    if (contentUpgradeIsAsync_1) {
                        incrementExpectedAwaits();
                    }
                    var returnValue_1;
                    var promiseFollowed = DexiePromise.follow(function () {
                        returnValue_1 = contentUpgrade(trans);
                        if (returnValue_1) {
                            if (contentUpgradeIsAsync_1) {
                                var decrementor = decrementExpectedAwaits.bind(null, null);
                                returnValue_1.then(decrementor, decrementor);
                            }
                        }
                    });
                    return (returnValue_1 && typeof returnValue_1.then === 'function' ?
                        DexiePromise.resolve(returnValue_1) : promiseFollowed.then(function () { return returnValue_1; }));
                }
            });
            queue.push(function (idbtrans) {
                if (!anyContentUpgraderHasRun || !hasIEDeleteObjectStoreBug) {
                    var newSchema = version._cfg.dbschema;
                    deleteRemovedTables(newSchema, idbtrans);
                }
                removeTablesApi(db, [db.Transaction.prototype]);
                setApiOnPlace(db, [db.Transaction.prototype], db._storeNames, db._dbSchema);
                trans.schema = db._dbSchema;
            });
        });
        function runQueue() {
            return queue.length ? DexiePromise.resolve(queue.shift()(trans.idbtrans)).then(runQueue) :
                DexiePromise.resolve();
        }
        return runQueue().then(function () {
            createMissingTables(globalSchema, idbUpgradeTrans);
        });
    }
    function getSchemaDiff(oldSchema, newSchema) {
        var diff = {
            del: [],
            add: [],
            change: []
        };
        var table;
        for (table in oldSchema) {
            if (!newSchema[table])
                diff.del.push(table);
        }
        for (table in newSchema) {
            var oldDef = oldSchema[table], newDef = newSchema[table];
            if (!oldDef) {
                diff.add.push([table, newDef]);
            }
            else {
                var change = {
                    name: table,
                    def: newDef,
                    recreate: false,
                    del: [],
                    add: [],
                    change: []
                };
                if ((
                '' + (oldDef.primKey.keyPath || '')) !== ('' + (newDef.primKey.keyPath || '')) ||
                    (oldDef.primKey.auto !== newDef.primKey.auto && !isIEOrEdge))
                 {
                    change.recreate = true;
                    diff.change.push(change);
                }
                else {
                    var oldIndexes = oldDef.idxByName;
                    var newIndexes = newDef.idxByName;
                    var idxName = void 0;
                    for (idxName in oldIndexes) {
                        if (!newIndexes[idxName])
                            change.del.push(idxName);
                    }
                    for (idxName in newIndexes) {
                        var oldIdx = oldIndexes[idxName], newIdx = newIndexes[idxName];
                        if (!oldIdx)
                            change.add.push(newIdx);
                        else if (oldIdx.src !== newIdx.src)
                            change.change.push(newIdx);
                    }
                    if (change.del.length > 0 || change.add.length > 0 || change.change.length > 0) {
                        diff.change.push(change);
                    }
                }
            }
        }
        return diff;
    }
    function createTable(idbtrans, tableName, primKey, indexes) {
        var store = idbtrans.db.createObjectStore(tableName, primKey.keyPath ?
            { keyPath: primKey.keyPath, autoIncrement: primKey.auto } :
            { autoIncrement: primKey.auto });
        indexes.forEach(function (idx) { return addIndex(store, idx); });
        return store;
    }
    function createMissingTables(newSchema, idbtrans) {
        keys(newSchema).forEach(function (tableName) {
            if (!idbtrans.db.objectStoreNames.contains(tableName)) {
                createTable(idbtrans, tableName, newSchema[tableName].primKey, newSchema[tableName].indexes);
            }
        });
    }
    function deleteRemovedTables(newSchema, idbtrans) {
        [].slice.call(idbtrans.db.objectStoreNames).forEach(function (storeName) {
            return newSchema[storeName] == null && idbtrans.db.deleteObjectStore(storeName);
        });
    }
    function addIndex(store, idx) {
        store.createIndex(idx.name, idx.keyPath, { unique: idx.unique, multiEntry: idx.multi });
    }
    function buildGlobalSchema(db, idbdb, tmpTrans) {
        var globalSchema = {};
        var dbStoreNames = slice(idbdb.objectStoreNames, 0);
        dbStoreNames.forEach(function (storeName) {
            var store = tmpTrans.objectStore(storeName);
            var keyPath = store.keyPath;
            var primKey = createIndexSpec(nameFromKeyPath(keyPath), keyPath || "", false, false, !!store.autoIncrement, keyPath && typeof keyPath !== "string", true);
            var indexes = [];
            for (var j = 0; j < store.indexNames.length; ++j) {
                var idbindex = store.index(store.indexNames[j]);
                keyPath = idbindex.keyPath;
                var index = createIndexSpec(idbindex.name, keyPath, !!idbindex.unique, !!idbindex.multiEntry, false, keyPath && typeof keyPath !== "string", false);
                indexes.push(index);
            }
            globalSchema[storeName] = createTableSchema(storeName, primKey, indexes);
        });
        return globalSchema;
    }
    function readGlobalSchema(_a, idbdb, tmpTrans) {
        var db = _a._novip;
        db.verno = idbdb.version / 10;
        var globalSchema = db._dbSchema = buildGlobalSchema(db, idbdb, tmpTrans);
        db._storeNames = slice(idbdb.objectStoreNames, 0);
        setApiOnPlace(db, [db._allTables], keys(globalSchema), globalSchema);
    }
    function verifyInstalledSchema(db, tmpTrans) {
        var installedSchema = buildGlobalSchema(db, db.idbdb, tmpTrans);
        var diff = getSchemaDiff(installedSchema, db._dbSchema);
        return !(diff.add.length || diff.change.some(function (ch) { return ch.add.length || ch.change.length; }));
    }
    function adjustToExistingIndexNames(_a, schema, idbtrans) {
        var db = _a._novip;
        var storeNames = idbtrans.db.objectStoreNames;
        for (var i = 0; i < storeNames.length; ++i) {
            var storeName = storeNames[i];
            var store = idbtrans.objectStore(storeName);
            db._hasGetAll = 'getAll' in store;
            for (var j = 0; j < store.indexNames.length; ++j) {
                var indexName = store.indexNames[j];
                var keyPath = store.index(indexName).keyPath;
                var dexieName = typeof keyPath === 'string' ? keyPath : "[" + slice(keyPath).join('+') + "]";
                if (schema[storeName]) {
                    var indexSpec = schema[storeName].idxByName[dexieName];
                    if (indexSpec) {
                        indexSpec.name = indexName;
                        delete schema[storeName].idxByName[dexieName];
                        schema[storeName].idxByName[indexName] = indexSpec;
                    }
                }
            }
        }
        if (typeof navigator !== 'undefined' && /Safari/.test(navigator.userAgent) &&
            !/(Chrome\/|Edge\/)/.test(navigator.userAgent) &&
            _global.WorkerGlobalScope && _global instanceof _global.WorkerGlobalScope &&
            [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604) {
            db._hasGetAll = false;
        }
    }
    function parseIndexSyntax(primKeyAndIndexes) {
        return primKeyAndIndexes.split(',').map(function (index, indexNum) {
            index = index.trim();
            var name = index.replace(/([&*]|\+\+)/g, "");
            var keyPath = /^\[/.test(name) ? name.match(/^\[(.*)\]$/)[1].split('+') : name;
            return createIndexSpec(name, keyPath || null, /\&/.test(index), /\*/.test(index), /\+\+/.test(index), isArray(keyPath), indexNum === 0);
        });
    }

    var Version =  (function () {
        function Version() {
        }
        Version.prototype._parseStoresSpec = function (stores, outSchema) {
            keys(stores).forEach(function (tableName) {
                if (stores[tableName] !== null) {
                    var indexes = parseIndexSyntax(stores[tableName]);
                    var primKey = indexes.shift();
                    if (primKey.multi)
                        throw new exceptions.Schema("Primary key cannot be multi-valued");
                    indexes.forEach(function (idx) {
                        if (idx.auto)
                            throw new exceptions.Schema("Only primary key can be marked as autoIncrement (++)");
                        if (!idx.keyPath)
                            throw new exceptions.Schema("Index must have a name and cannot be an empty string");
                    });
                    outSchema[tableName] = createTableSchema(tableName, primKey, indexes);
                }
            });
        };
        Version.prototype.stores = function (stores) {
            var db = this.db;
            this._cfg.storesSource = this._cfg.storesSource ?
                extend(this._cfg.storesSource, stores) :
                stores;
            var versions = db._versions;
            var storesSpec = {};
            var dbschema = {};
            versions.forEach(function (version) {
                extend(storesSpec, version._cfg.storesSource);
                dbschema = (version._cfg.dbschema = {});
                version._parseStoresSpec(storesSpec, dbschema);
            });
            db._dbSchema = dbschema;
            removeTablesApi(db, [db._allTables, db, db.Transaction.prototype]);
            setApiOnPlace(db, [db._allTables, db, db.Transaction.prototype, this._cfg.tables], keys(dbschema), dbschema);
            db._storeNames = keys(dbschema);
            return this;
        };
        Version.prototype.upgrade = function (upgradeFunction) {
            this._cfg.contentUpgrade = promisableChain(this._cfg.contentUpgrade || nop, upgradeFunction);
            return this;
        };
        return Version;
    }());

    function createVersionConstructor(db) {
        return makeClassConstructor(Version.prototype, function Version(versionNumber) {
            this.db = db;
            this._cfg = {
                version: versionNumber,
                storesSource: null,
                dbschema: {},
                tables: {},
                contentUpgrade: null
            };
        });
    }

    function getDbNamesTable(indexedDB, IDBKeyRange) {
        var dbNamesDB = indexedDB["_dbNamesDB"];
        if (!dbNamesDB) {
            dbNamesDB = indexedDB["_dbNamesDB"] = new Dexie$1(DBNAMES_DB, {
                addons: [],
                indexedDB: indexedDB,
                IDBKeyRange: IDBKeyRange,
            });
            dbNamesDB.version(1).stores({ dbnames: "name" });
        }
        return dbNamesDB.table("dbnames");
    }
    function hasDatabasesNative(indexedDB) {
        return indexedDB && typeof indexedDB.databases === "function";
    }
    function getDatabaseNames(_a) {
        var indexedDB = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
        return hasDatabasesNative(indexedDB)
            ? Promise.resolve(indexedDB.databases()).then(function (infos) {
                return infos
                    .map(function (info) { return info.name; })
                    .filter(function (name) { return name !== DBNAMES_DB; });
            })
            : getDbNamesTable(indexedDB, IDBKeyRange).toCollection().primaryKeys();
    }
    function _onDatabaseCreated(_a, name) {
        var indexedDB = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
        !hasDatabasesNative(indexedDB) &&
            name !== DBNAMES_DB &&
            getDbNamesTable(indexedDB, IDBKeyRange).put({ name: name }).catch(nop);
    }
    function _onDatabaseDeleted(_a, name) {
        var indexedDB = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
        !hasDatabasesNative(indexedDB) &&
            name !== DBNAMES_DB &&
            getDbNamesTable(indexedDB, IDBKeyRange).delete(name).catch(nop);
    }

    function vip(fn) {
        return newScope(function () {
            PSD.letThrough = true;
            return fn();
        });
    }

    function idbReady() {
        var isSafari = !navigator.userAgentData &&
            /Safari\//.test(navigator.userAgent) &&
            !/Chrom(e|ium)\//.test(navigator.userAgent);
        if (!isSafari || !indexedDB.databases)
            return Promise.resolve();
        var intervalId;
        return new Promise(function (resolve) {
            var tryIdb = function () { return indexedDB.databases().finally(resolve); };
            intervalId = setInterval(tryIdb, 100);
            tryIdb();
        }).finally(function () { return clearInterval(intervalId); });
    }

    function dexieOpen(db) {
        var state = db._state;
        var indexedDB = db._deps.indexedDB;
        if (state.isBeingOpened || db.idbdb)
            return state.dbReadyPromise.then(function () { return state.dbOpenError ?
                rejection(state.dbOpenError) :
                db; });
        debug && (state.openCanceller._stackHolder = getErrorWithStack());
        state.isBeingOpened = true;
        state.dbOpenError = null;
        state.openComplete = false;
        var openCanceller = state.openCanceller;
        function throwIfCancelled() {
            if (state.openCanceller !== openCanceller)
                throw new exceptions.DatabaseClosed('db.open() was cancelled');
        }
        var resolveDbReady = state.dbReadyResolve,
        upgradeTransaction = null, wasCreated = false;
        var tryOpenDB = function () { return new DexiePromise(function (resolve, reject) {
            throwIfCancelled();
            if (!indexedDB)
                throw new exceptions.MissingAPI();
            var dbName = db.name;
            var req = state.autoSchema ?
                indexedDB.open(dbName) :
                indexedDB.open(dbName, Math.round(db.verno * 10));
            if (!req)
                throw new exceptions.MissingAPI();
            req.onerror = eventRejectHandler(reject);
            req.onblocked = wrap(db._fireOnBlocked);
            req.onupgradeneeded = wrap(function (e) {
                upgradeTransaction = req.transaction;
                if (state.autoSchema && !db._options.allowEmptyDB) {
                    req.onerror = preventDefault;
                    upgradeTransaction.abort();
                    req.result.close();
                    var delreq = indexedDB.deleteDatabase(dbName);
                    delreq.onsuccess = delreq.onerror = wrap(function () {
                        reject(new exceptions.NoSuchDatabase("Database " + dbName + " doesnt exist"));
                    });
                }
                else {
                    upgradeTransaction.onerror = eventRejectHandler(reject);
                    var oldVer = e.oldVersion > Math.pow(2, 62) ? 0 : e.oldVersion;
                    wasCreated = oldVer < 1;
                    db._novip.idbdb = req.result;
                    runUpgraders(db, oldVer / 10, upgradeTransaction, reject);
                }
            }, reject);
            req.onsuccess = wrap(function () {
                upgradeTransaction = null;
                var idbdb = db._novip.idbdb = req.result;
                var objectStoreNames = slice(idbdb.objectStoreNames);
                if (objectStoreNames.length > 0)
                    try {
                        var tmpTrans = idbdb.transaction(safariMultiStoreFix(objectStoreNames), 'readonly');
                        if (state.autoSchema)
                            readGlobalSchema(db, idbdb, tmpTrans);
                        else {
                            adjustToExistingIndexNames(db, db._dbSchema, tmpTrans);
                            if (!verifyInstalledSchema(db, tmpTrans)) {
                                console.warn("Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Some queries may fail.");
                            }
                        }
                        generateMiddlewareStacks(db, tmpTrans);
                    }
                    catch (e) {
                    }
                connections.push(db);
                idbdb.onversionchange = wrap(function (ev) {
                    state.vcFired = true;
                    db.on("versionchange").fire(ev);
                });
                idbdb.onclose = wrap(function (ev) {
                    db.on("close").fire(ev);
                });
                if (wasCreated)
                    _onDatabaseCreated(db._deps, dbName);
                resolve();
            }, reject);
        }).catch(function (err) {
            if (err && err.name === 'UnknownError' && state.PR1398_maxLoop > 0) {
                state.PR1398_maxLoop--;
                console.warn('Dexie: Workaround for Chrome UnknownError on open()');
                return tryOpenDB();
            }
            else {
                return DexiePromise.reject(err);
            }
        }); };
        return DexiePromise.race([
            openCanceller,
            (typeof navigator === 'undefined' ? DexiePromise.resolve() : idbReady()).then(tryOpenDB)
        ]).then(function () {
            throwIfCancelled();
            state.onReadyBeingFired = [];
            return DexiePromise.resolve(vip(function () { return db.on.ready.fire(db.vip); })).then(function fireRemainders() {
                if (state.onReadyBeingFired.length > 0) {
                    var remainders_1 = state.onReadyBeingFired.reduce(promisableChain, nop);
                    state.onReadyBeingFired = [];
                    return DexiePromise.resolve(vip(function () { return remainders_1(db.vip); })).then(fireRemainders);
                }
            });
        }).finally(function () {
            state.onReadyBeingFired = null;
            state.isBeingOpened = false;
        }).then(function () {
            return db;
        }).catch(function (err) {
            state.dbOpenError = err;
            try {
                upgradeTransaction && upgradeTransaction.abort();
            }
            catch (_a) { }
            if (openCanceller === state.openCanceller) {
                db._close();
            }
            return rejection(err);
        }).finally(function () {
            state.openComplete = true;
            resolveDbReady();
        });
    }

    function awaitIterator(iterator) {
        var callNext = function (result) { return iterator.next(result); }, doThrow = function (error) { return iterator.throw(error); }, onSuccess = step(callNext), onError = step(doThrow);
        function step(getNext) {
            return function (val) {
                var next = getNext(val), value = next.value;
                return next.done ? value :
                    (!value || typeof value.then !== 'function' ?
                        isArray(value) ? Promise.all(value).then(onSuccess, onError) : onSuccess(value) :
                        value.then(onSuccess, onError));
            };
        }
        return step(callNext)();
    }

    function extractTransactionArgs(mode, _tableArgs_, scopeFunc) {
        var i = arguments.length;
        if (i < 2)
            throw new exceptions.InvalidArgument("Too few arguments");
        var args = new Array(i - 1);
        while (--i)
            args[i - 1] = arguments[i];
        scopeFunc = args.pop();
        var tables = flatten(args);
        return [mode, tables, scopeFunc];
    }
    function enterTransactionScope(db, mode, storeNames, parentTransaction, scopeFunc) {
        return DexiePromise.resolve().then(function () {
            var transless = PSD.transless || PSD;
            var trans = db._createTransaction(mode, storeNames, db._dbSchema, parentTransaction);
            var zoneProps = {
                trans: trans,
                transless: transless
            };
            if (parentTransaction) {
                trans.idbtrans = parentTransaction.idbtrans;
            }
            else {
                try {
                    trans.create();
                    db._state.PR1398_maxLoop = 3;
                }
                catch (ex) {
                    if (ex.name === errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                        console.warn('Dexie: Need to reopen db');
                        db._close();
                        return db.open().then(function () { return enterTransactionScope(db, mode, storeNames, null, scopeFunc); });
                    }
                    return rejection(ex);
                }
            }
            var scopeFuncIsAsync = isAsyncFunction(scopeFunc);
            if (scopeFuncIsAsync) {
                incrementExpectedAwaits();
            }
            var returnValue;
            var promiseFollowed = DexiePromise.follow(function () {
                returnValue = scopeFunc.call(trans, trans);
                if (returnValue) {
                    if (scopeFuncIsAsync) {
                        var decrementor = decrementExpectedAwaits.bind(null, null);
                        returnValue.then(decrementor, decrementor);
                    }
                    else if (typeof returnValue.next === 'function' && typeof returnValue.throw === 'function') {
                        returnValue = awaitIterator(returnValue);
                    }
                }
            }, zoneProps);
            return (returnValue && typeof returnValue.then === 'function' ?
                DexiePromise.resolve(returnValue).then(function (x) { return trans.active ?
                    x
                    : rejection(new exceptions.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn")); })
                : promiseFollowed.then(function () { return returnValue; })).then(function (x) {
                if (parentTransaction)
                    trans._resolve();
                return trans._completion.then(function () { return x; });
            }).catch(function (e) {
                trans._reject(e);
                return rejection(e);
            });
        });
    }

    function pad(a, value, count) {
        var result = isArray(a) ? a.slice() : [a];
        for (var i = 0; i < count; ++i)
            result.push(value);
        return result;
    }
    function createVirtualIndexMiddleware(down) {
        return __assign$1(__assign$1({}, down), { table: function (tableName) {
                var table = down.table(tableName);
                var schema = table.schema;
                var indexLookup = {};
                var allVirtualIndexes = [];
                function addVirtualIndexes(keyPath, keyTail, lowLevelIndex) {
                    var keyPathAlias = getKeyPathAlias(keyPath);
                    var indexList = (indexLookup[keyPathAlias] = indexLookup[keyPathAlias] || []);
                    var keyLength = keyPath == null ? 0 : typeof keyPath === 'string' ? 1 : keyPath.length;
                    var isVirtual = keyTail > 0;
                    var virtualIndex = __assign$1(__assign$1({}, lowLevelIndex), { isVirtual: isVirtual, keyTail: keyTail, keyLength: keyLength, extractKey: getKeyExtractor(keyPath), unique: !isVirtual && lowLevelIndex.unique });
                    indexList.push(virtualIndex);
                    if (!virtualIndex.isPrimaryKey) {
                        allVirtualIndexes.push(virtualIndex);
                    }
                    if (keyLength > 1) {
                        var virtualKeyPath = keyLength === 2 ?
                            keyPath[0] :
                            keyPath.slice(0, keyLength - 1);
                        addVirtualIndexes(virtualKeyPath, keyTail + 1, lowLevelIndex);
                    }
                    indexList.sort(function (a, b) { return a.keyTail - b.keyTail; });
                    return virtualIndex;
                }
                var primaryKey = addVirtualIndexes(schema.primaryKey.keyPath, 0, schema.primaryKey);
                indexLookup[":id"] = [primaryKey];
                for (var _i = 0, _a = schema.indexes; _i < _a.length; _i++) {
                    var index = _a[_i];
                    addVirtualIndexes(index.keyPath, 0, index);
                }
                function findBestIndex(keyPath) {
                    var result = indexLookup[getKeyPathAlias(keyPath)];
                    return result && result[0];
                }
                function translateRange(range, keyTail) {
                    return {
                        type: range.type === 1  ?
                            2  :
                            range.type,
                        lower: pad(range.lower, range.lowerOpen ? down.MAX_KEY : down.MIN_KEY, keyTail),
                        lowerOpen: true,
                        upper: pad(range.upper, range.upperOpen ? down.MIN_KEY : down.MAX_KEY, keyTail),
                        upperOpen: true
                    };
                }
                function translateRequest(req) {
                    var index = req.query.index;
                    return index.isVirtual ? __assign$1(__assign$1({}, req), { query: {
                            index: index,
                            range: translateRange(req.query.range, index.keyTail)
                        } }) : req;
                }
                var result = __assign$1(__assign$1({}, table), { schema: __assign$1(__assign$1({}, schema), { primaryKey: primaryKey, indexes: allVirtualIndexes, getIndexByKeyPath: findBestIndex }), count: function (req) {
                        return table.count(translateRequest(req));
                    }, query: function (req) {
                        return table.query(translateRequest(req));
                    }, openCursor: function (req) {
                        var _a = req.query.index, keyTail = _a.keyTail, isVirtual = _a.isVirtual, keyLength = _a.keyLength;
                        if (!isVirtual)
                            return table.openCursor(req);
                        function createVirtualCursor(cursor) {
                            function _continue(key) {
                                key != null ?
                                    cursor.continue(pad(key, req.reverse ? down.MAX_KEY : down.MIN_KEY, keyTail)) :
                                    req.unique ?
                                        cursor.continue(cursor.key.slice(0, keyLength)
                                            .concat(req.reverse
                                            ? down.MIN_KEY
                                            : down.MAX_KEY, keyTail)) :
                                        cursor.continue();
                            }
                            var virtualCursor = Object.create(cursor, {
                                continue: { value: _continue },
                                continuePrimaryKey: {
                                    value: function (key, primaryKey) {
                                        cursor.continuePrimaryKey(pad(key, down.MAX_KEY, keyTail), primaryKey);
                                    }
                                },
                                primaryKey: {
                                    get: function () {
                                        return cursor.primaryKey;
                                    }
                                },
                                key: {
                                    get: function () {
                                        var key = cursor.key;
                                        return keyLength === 1 ?
                                            key[0] :
                                            key.slice(0, keyLength);
                                    }
                                },
                                value: {
                                    get: function () {
                                        return cursor.value;
                                    }
                                }
                            });
                            return virtualCursor;
                        }
                        return table.openCursor(translateRequest(req))
                            .then(function (cursor) { return cursor && createVirtualCursor(cursor); });
                    } });
                return result;
            } });
    }
    var virtualIndexMiddleware = {
        stack: "dbcore",
        name: "VirtualIndexMiddleware",
        level: 1,
        create: createVirtualIndexMiddleware
    };

    function getObjectDiff(a, b, rv, prfx) {
        rv = rv || {};
        prfx = prfx || '';
        keys(a).forEach(function (prop) {
            if (!hasOwn(b, prop)) {
                rv[prfx + prop] = undefined;
            }
            else {
                var ap = a[prop], bp = b[prop];
                if (typeof ap === 'object' && typeof bp === 'object' && ap && bp) {
                    var apTypeName = toStringTag(ap);
                    var bpTypeName = toStringTag(bp);
                    if (apTypeName !== bpTypeName) {
                        rv[prfx + prop] = b[prop];
                    }
                    else if (apTypeName === 'Object') {
                        getObjectDiff(ap, bp, rv, prfx + prop + '.');
                    }
                    else if (ap !== bp) {
                        rv[prfx + prop] = b[prop];
                    }
                }
                else if (ap !== bp)
                    rv[prfx + prop] = b[prop];
            }
        });
        keys(b).forEach(function (prop) {
            if (!hasOwn(a, prop)) {
                rv[prfx + prop] = b[prop];
            }
        });
        return rv;
    }

    function getEffectiveKeys(primaryKey, req) {
        if (req.type === 'delete')
            return req.keys;
        return req.keys || req.values.map(primaryKey.extractKey);
    }

    var hooksMiddleware = {
        stack: "dbcore",
        name: "HooksMiddleware",
        level: 2,
        create: function (downCore) { return (__assign$1(__assign$1({}, downCore), { table: function (tableName) {
                var downTable = downCore.table(tableName);
                var primaryKey = downTable.schema.primaryKey;
                var tableMiddleware = __assign$1(__assign$1({}, downTable), { mutate: function (req) {
                        var dxTrans = PSD.trans;
                        var _a = dxTrans.table(tableName).hook, deleting = _a.deleting, creating = _a.creating, updating = _a.updating;
                        switch (req.type) {
                            case 'add':
                                if (creating.fire === nop)
                                    break;
                                return dxTrans._promise('readwrite', function () { return addPutOrDelete(req); }, true);
                            case 'put':
                                if (creating.fire === nop && updating.fire === nop)
                                    break;
                                return dxTrans._promise('readwrite', function () { return addPutOrDelete(req); }, true);
                            case 'delete':
                                if (deleting.fire === nop)
                                    break;
                                return dxTrans._promise('readwrite', function () { return addPutOrDelete(req); }, true);
                            case 'deleteRange':
                                if (deleting.fire === nop)
                                    break;
                                return dxTrans._promise('readwrite', function () { return deleteRange(req); }, true);
                        }
                        return downTable.mutate(req);
                        function addPutOrDelete(req) {
                            var dxTrans = PSD.trans;
                            var keys = req.keys || getEffectiveKeys(primaryKey, req);
                            if (!keys)
                                throw new Error("Keys missing");
                            req = req.type === 'add' || req.type === 'put' ? __assign$1(__assign$1({}, req), { keys: keys }) : __assign$1({}, req);
                            if (req.type !== 'delete')
                                req.values = __spreadArray$1([], req.values, true);
                            if (req.keys)
                                req.keys = __spreadArray$1([], req.keys, true);
                            return getExistingValues(downTable, req, keys).then(function (existingValues) {
                                var contexts = keys.map(function (key, i) {
                                    var existingValue = existingValues[i];
                                    var ctx = { onerror: null, onsuccess: null };
                                    if (req.type === 'delete') {
                                        deleting.fire.call(ctx, key, existingValue, dxTrans);
                                    }
                                    else if (req.type === 'add' || existingValue === undefined) {
                                        var generatedPrimaryKey = creating.fire.call(ctx, key, req.values[i], dxTrans);
                                        if (key == null && generatedPrimaryKey != null) {
                                            key = generatedPrimaryKey;
                                            req.keys[i] = key;
                                            if (!primaryKey.outbound) {
                                                setByKeyPath(req.values[i], primaryKey.keyPath, key);
                                            }
                                        }
                                    }
                                    else {
                                        var objectDiff = getObjectDiff(existingValue, req.values[i]);
                                        var additionalChanges_1 = updating.fire.call(ctx, objectDiff, key, existingValue, dxTrans);
                                        if (additionalChanges_1) {
                                            var requestedValue_1 = req.values[i];
                                            Object.keys(additionalChanges_1).forEach(function (keyPath) {
                                                if (hasOwn(requestedValue_1, keyPath)) {
                                                    requestedValue_1[keyPath] = additionalChanges_1[keyPath];
                                                }
                                                else {
                                                    setByKeyPath(requestedValue_1, keyPath, additionalChanges_1[keyPath]);
                                                }
                                            });
                                        }
                                    }
                                    return ctx;
                                });
                                return downTable.mutate(req).then(function (_a) {
                                    var failures = _a.failures, results = _a.results, numFailures = _a.numFailures, lastResult = _a.lastResult;
                                    for (var i = 0; i < keys.length; ++i) {
                                        var primKey = results ? results[i] : keys[i];
                                        var ctx = contexts[i];
                                        if (primKey == null) {
                                            ctx.onerror && ctx.onerror(failures[i]);
                                        }
                                        else {
                                            ctx.onsuccess && ctx.onsuccess(req.type === 'put' && existingValues[i] ?
                                                req.values[i] :
                                                primKey
                                            );
                                        }
                                    }
                                    return { failures: failures, results: results, numFailures: numFailures, lastResult: lastResult };
                                }).catch(function (error) {
                                    contexts.forEach(function (ctx) { return ctx.onerror && ctx.onerror(error); });
                                    return Promise.reject(error);
                                });
                            });
                        }
                        function deleteRange(req) {
                            return deleteNextChunk(req.trans, req.range, 10000);
                        }
                        function deleteNextChunk(trans, range, limit) {
                            return downTable.query({ trans: trans, values: false, query: { index: primaryKey, range: range }, limit: limit })
                                .then(function (_a) {
                                var result = _a.result;
                                return addPutOrDelete({ type: 'delete', keys: result, trans: trans }).then(function (res) {
                                    if (res.numFailures > 0)
                                        return Promise.reject(res.failures[0]);
                                    if (result.length < limit) {
                                        return { failures: [], numFailures: 0, lastResult: undefined };
                                    }
                                    else {
                                        return deleteNextChunk(trans, __assign$1(__assign$1({}, range), { lower: result[result.length - 1], lowerOpen: true }), limit);
                                    }
                                });
                            });
                        }
                    } });
                return tableMiddleware;
            } })); }
    };
    function getExistingValues(table, req, effectiveKeys) {
        return req.type === "add"
            ? Promise.resolve([])
            : table.getMany({ trans: req.trans, keys: effectiveKeys, cache: "immutable" });
    }

    function getFromTransactionCache(keys, cache, clone) {
        try {
            if (!cache)
                return null;
            if (cache.keys.length < keys.length)
                return null;
            var result = [];
            for (var i = 0, j = 0; i < cache.keys.length && j < keys.length; ++i) {
                if (cmp(cache.keys[i], keys[j]) !== 0)
                    continue;
                result.push(clone ? deepClone$1(cache.values[i]) : cache.values[i]);
                ++j;
            }
            return result.length === keys.length ? result : null;
        }
        catch (_a) {
            return null;
        }
    }
    var cacheExistingValuesMiddleware = {
        stack: "dbcore",
        level: -1,
        create: function (core) {
            return {
                table: function (tableName) {
                    var table = core.table(tableName);
                    return __assign$1(__assign$1({}, table), { getMany: function (req) {
                            if (!req.cache) {
                                return table.getMany(req);
                            }
                            var cachedResult = getFromTransactionCache(req.keys, req.trans["_cache"], req.cache === "clone");
                            if (cachedResult) {
                                return DexiePromise.resolve(cachedResult);
                            }
                            return table.getMany(req).then(function (res) {
                                req.trans["_cache"] = {
                                    keys: req.keys,
                                    values: req.cache === "clone" ? deepClone$1(res) : res,
                                };
                                return res;
                            });
                        }, mutate: function (req) {
                            if (req.type !== "add")
                                req.trans["_cache"] = null;
                            return table.mutate(req);
                        } });
                },
            };
        },
    };

    var _a$2;
    function isEmptyRange(node) {
        return !("from" in node);
    }
    var RangeSet = function (fromOrTree, to) {
        if (this) {
            extend(this, arguments.length ? { d: 1, from: fromOrTree, to: arguments.length > 1 ? to : fromOrTree } : { d: 0 });
        }
        else {
            var rv = new RangeSet();
            if (fromOrTree && ("d" in fromOrTree)) {
                extend(rv, fromOrTree);
            }
            return rv;
        }
    };
    props(RangeSet.prototype, (_a$2 = {
            add: function (rangeSet) {
                mergeRanges(this, rangeSet);
                return this;
            },
            addKey: function (key) {
                addRange(this, key, key);
                return this;
            },
            addKeys: function (keys) {
                var _this = this;
                keys.forEach(function (key) { return addRange(_this, key, key); });
                return this;
            }
        },
        _a$2[iteratorSymbol] = function () {
            return getRangeSetIterator(this);
        },
        _a$2));
    function addRange(target, from, to) {
        var diff = cmp(from, to);
        if (isNaN(diff))
            return;
        if (diff > 0)
            throw RangeError();
        if (isEmptyRange(target))
            return extend(target, { from: from, to: to, d: 1 });
        var left = target.l;
        var right = target.r;
        if (cmp(to, target.from) < 0) {
            left
                ? addRange(left, from, to)
                : (target.l = { from: from, to: to, d: 1, l: null, r: null });
            return rebalance(target);
        }
        if (cmp(from, target.to) > 0) {
            right
                ? addRange(right, from, to)
                : (target.r = { from: from, to: to, d: 1, l: null, r: null });
            return rebalance(target);
        }
        if (cmp(from, target.from) < 0) {
            target.from = from;
            target.l = null;
            target.d = right ? right.d + 1 : 1;
        }
        if (cmp(to, target.to) > 0) {
            target.to = to;
            target.r = null;
            target.d = target.l ? target.l.d + 1 : 1;
        }
        var rightWasCutOff = !target.r;
        if (left && !target.l) {
            mergeRanges(target, left);
        }
        if (right && rightWasCutOff) {
            mergeRanges(target, right);
        }
    }
    function mergeRanges(target, newSet) {
        function _addRangeSet(target, _a) {
            var from = _a.from, to = _a.to, l = _a.l, r = _a.r;
            addRange(target, from, to);
            if (l)
                _addRangeSet(target, l);
            if (r)
                _addRangeSet(target, r);
        }
        if (!isEmptyRange(newSet))
            _addRangeSet(target, newSet);
    }
    function rangesOverlap(rangeSet1, rangeSet2) {
        var i1 = getRangeSetIterator(rangeSet2);
        var nextResult1 = i1.next();
        if (nextResult1.done)
            return false;
        var a = nextResult1.value;
        var i2 = getRangeSetIterator(rangeSet1);
        var nextResult2 = i2.next(a.from);
        var b = nextResult2.value;
        while (!nextResult1.done && !nextResult2.done) {
            if (cmp(b.from, a.to) <= 0 && cmp(b.to, a.from) >= 0)
                return true;
            cmp(a.from, b.from) < 0
                ? (a = (nextResult1 = i1.next(b.from)).value)
                : (b = (nextResult2 = i2.next(a.from)).value);
        }
        return false;
    }
    function getRangeSetIterator(node) {
        var state = isEmptyRange(node) ? null : { s: 0, n: node };
        return {
            next: function (key) {
                var keyProvided = arguments.length > 0;
                while (state) {
                    switch (state.s) {
                        case 0:
                            state.s = 1;
                            if (keyProvided) {
                                while (state.n.l && cmp(key, state.n.from) < 0)
                                    state = { up: state, n: state.n.l, s: 1 };
                            }
                            else {
                                while (state.n.l)
                                    state = { up: state, n: state.n.l, s: 1 };
                            }
                        case 1:
                            state.s = 2;
                            if (!keyProvided || cmp(key, state.n.to) <= 0)
                                return { value: state.n, done: false };
                        case 2:
                            if (state.n.r) {
                                state.s = 3;
                                state = { up: state, n: state.n.r, s: 0 };
                                continue;
                            }
                        case 3:
                            state = state.up;
                    }
                }
                return { done: true };
            },
        };
    }
    function rebalance(target) {
        var _a, _b;
        var diff = (((_a = target.r) === null || _a === void 0 ? void 0 : _a.d) || 0) - (((_b = target.l) === null || _b === void 0 ? void 0 : _b.d) || 0);
        var r = diff > 1 ? "r" : diff < -1 ? "l" : "";
        if (r) {
            var l = r === "r" ? "l" : "r";
            var rootClone = __assign$1({}, target);
            var oldRootRight = target[r];
            target.from = oldRootRight.from;
            target.to = oldRootRight.to;
            target[r] = oldRootRight[r];
            rootClone[r] = oldRootRight[l];
            target[l] = rootClone;
            rootClone.d = computeDepth(rootClone);
        }
        target.d = computeDepth(target);
    }
    function computeDepth(_a) {
        var r = _a.r, l = _a.l;
        return (r ? (l ? Math.max(r.d, l.d) : r.d) : l ? l.d : 0) + 1;
    }

    var observabilityMiddleware = {
        stack: "dbcore",
        level: 0,
        create: function (core) {
            var dbName = core.schema.name;
            var FULL_RANGE = new RangeSet(core.MIN_KEY, core.MAX_KEY);
            return __assign$1(__assign$1({}, core), { table: function (tableName) {
                    var table = core.table(tableName);
                    var schema = table.schema;
                    var primaryKey = schema.primaryKey;
                    var extractKey = primaryKey.extractKey, outbound = primaryKey.outbound;
                    var tableClone = __assign$1(__assign$1({}, table), { mutate: function (req) {
                            var trans = req.trans;
                            var mutatedParts = trans.mutatedParts || (trans.mutatedParts = {});
                            var getRangeSet = function (indexName) {
                                var part = "idb://" + dbName + "/" + tableName + "/" + indexName;
                                return (mutatedParts[part] ||
                                    (mutatedParts[part] = new RangeSet()));
                            };
                            var pkRangeSet = getRangeSet("");
                            var delsRangeSet = getRangeSet(":dels");
                            var type = req.type;
                            var _a = req.type === "deleteRange"
                                ? [req.range]
                                : req.type === "delete"
                                    ? [req.keys]
                                    : req.values.length < 50
                                        ? [[], req.values]
                                        : [], keys = _a[0], newObjs = _a[1];
                            var oldCache = req.trans["_cache"];
                            return table.mutate(req).then(function (res) {
                                if (isArray(keys)) {
                                    if (type !== "delete")
                                        keys = res.results;
                                    pkRangeSet.addKeys(keys);
                                    var oldObjs = getFromTransactionCache(keys, oldCache);
                                    if (!oldObjs && type !== "add") {
                                        delsRangeSet.addKeys(keys);
                                    }
                                    if (oldObjs || newObjs) {
                                        trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs);
                                    }
                                }
                                else if (keys) {
                                    var range = { from: keys.lower, to: keys.upper };
                                    delsRangeSet.add(range);
                                    pkRangeSet.add(range);
                                }
                                else {
                                    pkRangeSet.add(FULL_RANGE);
                                    delsRangeSet.add(FULL_RANGE);
                                    schema.indexes.forEach(function (idx) { return getRangeSet(idx.name).add(FULL_RANGE); });
                                }
                                return res;
                            });
                        } });
                    var getRange = function (_a) {
                        var _b, _c;
                        var _d = _a.query, index = _d.index, range = _d.range;
                        return [
                            index,
                            new RangeSet((_b = range.lower) !== null && _b !== void 0 ? _b : core.MIN_KEY, (_c = range.upper) !== null && _c !== void 0 ? _c : core.MAX_KEY),
                        ];
                    };
                    var readSubscribers = {
                        get: function (req) { return [primaryKey, new RangeSet(req.key)]; },
                        getMany: function (req) { return [primaryKey, new RangeSet().addKeys(req.keys)]; },
                        count: getRange,
                        query: getRange,
                        openCursor: getRange,
                    };
                    keys(readSubscribers).forEach(function (method) {
                        tableClone[method] = function (req) {
                            var subscr = PSD.subscr;
                            if (subscr) {
                                var getRangeSet = function (indexName) {
                                    var part = "idb://" + dbName + "/" + tableName + "/" + indexName;
                                    return (subscr[part] ||
                                        (subscr[part] = new RangeSet()));
                                };
                                var pkRangeSet_1 = getRangeSet("");
                                var delsRangeSet_1 = getRangeSet(":dels");
                                var _a = readSubscribers[method](req), queriedIndex = _a[0], queriedRanges = _a[1];
                                getRangeSet(queriedIndex.name || "").add(queriedRanges);
                                if (!queriedIndex.isPrimaryKey) {
                                    if (method === "count") {
                                        delsRangeSet_1.add(FULL_RANGE);
                                    }
                                    else {
                                        var keysPromise_1 = method === "query" &&
                                            outbound &&
                                            req.values &&
                                            table.query(__assign$1(__assign$1({}, req), { values: false }));
                                        return table[method].apply(this, arguments).then(function (res) {
                                            if (method === "query") {
                                                if (outbound && req.values) {
                                                    return keysPromise_1.then(function (_a) {
                                                        var resultingKeys = _a.result;
                                                        pkRangeSet_1.addKeys(resultingKeys);
                                                        return res;
                                                    });
                                                }
                                                var pKeys = req.values
                                                    ? res.result.map(extractKey)
                                                    : res.result;
                                                if (req.values) {
                                                    pkRangeSet_1.addKeys(pKeys);
                                                }
                                                else {
                                                    delsRangeSet_1.addKeys(pKeys);
                                                }
                                            }
                                            else if (method === "openCursor") {
                                                var cursor_1 = res;
                                                var wantValues_1 = req.values;
                                                return (cursor_1 &&
                                                    Object.create(cursor_1, {
                                                        key: {
                                                            get: function () {
                                                                delsRangeSet_1.addKey(cursor_1.primaryKey);
                                                                return cursor_1.key;
                                                            },
                                                        },
                                                        primaryKey: {
                                                            get: function () {
                                                                var pkey = cursor_1.primaryKey;
                                                                delsRangeSet_1.addKey(pkey);
                                                                return pkey;
                                                            },
                                                        },
                                                        value: {
                                                            get: function () {
                                                                wantValues_1 && pkRangeSet_1.addKey(cursor_1.primaryKey);
                                                                return cursor_1.value;
                                                            },
                                                        },
                                                    }));
                                            }
                                            return res;
                                        });
                                    }
                                }
                            }
                            return table[method].apply(this, arguments);
                        };
                    });
                    return tableClone;
                } });
        },
    };
    function trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs) {
        function addAffectedIndex(ix) {
            var rangeSet = getRangeSet(ix.name || "");
            function extractKey(obj) {
                return obj != null ? ix.extractKey(obj) : null;
            }
            var addKeyOrKeys = function (key) { return ix.multiEntry && isArray(key)
                ? key.forEach(function (key) { return rangeSet.addKey(key); })
                : rangeSet.addKey(key); };
            (oldObjs || newObjs).forEach(function (_, i) {
                var oldKey = oldObjs && extractKey(oldObjs[i]);
                var newKey = newObjs && extractKey(newObjs[i]);
                if (cmp(oldKey, newKey) !== 0) {
                    if (oldKey != null)
                        addKeyOrKeys(oldKey);
                    if (newKey != null)
                        addKeyOrKeys(newKey);
                }
            });
        }
        schema.indexes.forEach(addAffectedIndex);
    }

    var Dexie$1 =  (function () {
        function Dexie(name, options) {
            var _this = this;
            this._middlewares = {};
            this.verno = 0;
            var deps = Dexie.dependencies;
            this._options = options = __assign$1({
                addons: Dexie.addons, autoOpen: true,
                indexedDB: deps.indexedDB, IDBKeyRange: deps.IDBKeyRange }, options);
            this._deps = {
                indexedDB: options.indexedDB,
                IDBKeyRange: options.IDBKeyRange
            };
            var addons = options.addons;
            this._dbSchema = {};
            this._versions = [];
            this._storeNames = [];
            this._allTables = {};
            this.idbdb = null;
            this._novip = this;
            var state = {
                dbOpenError: null,
                isBeingOpened: false,
                onReadyBeingFired: null,
                openComplete: false,
                dbReadyResolve: nop,
                dbReadyPromise: null,
                cancelOpen: nop,
                openCanceller: null,
                autoSchema: true,
                PR1398_maxLoop: 3
            };
            state.dbReadyPromise = new DexiePromise(function (resolve) {
                state.dbReadyResolve = resolve;
            });
            state.openCanceller = new DexiePromise(function (_, reject) {
                state.cancelOpen = reject;
            });
            this._state = state;
            this.name = name;
            this.on = Events(this, "populate", "blocked", "versionchange", "close", { ready: [promisableChain, nop] });
            this.on.ready.subscribe = override(this.on.ready.subscribe, function (subscribe) {
                return function (subscriber, bSticky) {
                    Dexie.vip(function () {
                        var state = _this._state;
                        if (state.openComplete) {
                            if (!state.dbOpenError)
                                DexiePromise.resolve().then(subscriber);
                            if (bSticky)
                                subscribe(subscriber);
                        }
                        else if (state.onReadyBeingFired) {
                            state.onReadyBeingFired.push(subscriber);
                            if (bSticky)
                                subscribe(subscriber);
                        }
                        else {
                            subscribe(subscriber);
                            var db_1 = _this;
                            if (!bSticky)
                                subscribe(function unsubscribe() {
                                    db_1.on.ready.unsubscribe(subscriber);
                                    db_1.on.ready.unsubscribe(unsubscribe);
                                });
                        }
                    });
                };
            });
            this.Collection = createCollectionConstructor(this);
            this.Table = createTableConstructor(this);
            this.Transaction = createTransactionConstructor(this);
            this.Version = createVersionConstructor(this);
            this.WhereClause = createWhereClauseConstructor(this);
            this.on("versionchange", function (ev) {
                if (ev.newVersion > 0)
                    console.warn("Another connection wants to upgrade database '" + _this.name + "'. Closing db now to resume the upgrade.");
                else
                    console.warn("Another connection wants to delete database '" + _this.name + "'. Closing db now to resume the delete request.");
                _this.close();
            });
            this.on("blocked", function (ev) {
                if (!ev.newVersion || ev.newVersion < ev.oldVersion)
                    console.warn("Dexie.delete('" + _this.name + "') was blocked");
                else
                    console.warn("Upgrade '" + _this.name + "' blocked by other connection holding version " + ev.oldVersion / 10);
            });
            this._maxKey = getMaxKey(options.IDBKeyRange);
            this._createTransaction = function (mode, storeNames, dbschema, parentTransaction) { return new _this.Transaction(mode, storeNames, dbschema, _this._options.chromeTransactionDurability, parentTransaction); };
            this._fireOnBlocked = function (ev) {
                _this.on("blocked").fire(ev);
                connections
                    .filter(function (c) { return c.name === _this.name && c !== _this && !c._state.vcFired; })
                    .map(function (c) { return c.on("versionchange").fire(ev); });
            };
            this.use(virtualIndexMiddleware);
            this.use(hooksMiddleware);
            this.use(observabilityMiddleware);
            this.use(cacheExistingValuesMiddleware);
            this.vip = Object.create(this, { _vip: { value: true } });
            addons.forEach(function (addon) { return addon(_this); });
        }
        Dexie.prototype.version = function (versionNumber) {
            if (isNaN(versionNumber) || versionNumber < 0.1)
                throw new exceptions.Type("Given version is not a positive number");
            versionNumber = Math.round(versionNumber * 10) / 10;
            if (this.idbdb || this._state.isBeingOpened)
                throw new exceptions.Schema("Cannot add version when database is open");
            this.verno = Math.max(this.verno, versionNumber);
            var versions = this._versions;
            var versionInstance = versions.filter(function (v) { return v._cfg.version === versionNumber; })[0];
            if (versionInstance)
                return versionInstance;
            versionInstance = new this.Version(versionNumber);
            versions.push(versionInstance);
            versions.sort(lowerVersionFirst);
            versionInstance.stores({});
            this._state.autoSchema = false;
            return versionInstance;
        };
        Dexie.prototype._whenReady = function (fn) {
            var _this = this;
            return (this.idbdb && (this._state.openComplete || PSD.letThrough || this._vip)) ? fn() : new DexiePromise(function (resolve, reject) {
                if (_this._state.openComplete) {
                    return reject(new exceptions.DatabaseClosed(_this._state.dbOpenError));
                }
                if (!_this._state.isBeingOpened) {
                    if (!_this._options.autoOpen) {
                        reject(new exceptions.DatabaseClosed());
                        return;
                    }
                    _this.open().catch(nop);
                }
                _this._state.dbReadyPromise.then(resolve, reject);
            }).then(fn);
        };
        Dexie.prototype.use = function (_a) {
            var stack = _a.stack, create = _a.create, level = _a.level, name = _a.name;
            if (name)
                this.unuse({ stack: stack, name: name });
            var middlewares = this._middlewares[stack] || (this._middlewares[stack] = []);
            middlewares.push({ stack: stack, create: create, level: level == null ? 10 : level, name: name });
            middlewares.sort(function (a, b) { return a.level - b.level; });
            return this;
        };
        Dexie.prototype.unuse = function (_a) {
            var stack = _a.stack, name = _a.name, create = _a.create;
            if (stack && this._middlewares[stack]) {
                this._middlewares[stack] = this._middlewares[stack].filter(function (mw) {
                    return create ? mw.create !== create :
                        name ? mw.name !== name :
                            false;
                });
            }
            return this;
        };
        Dexie.prototype.open = function () {
            return dexieOpen(this);
        };
        Dexie.prototype._close = function () {
            var state = this._state;
            var idx = connections.indexOf(this);
            if (idx >= 0)
                connections.splice(idx, 1);
            if (this.idbdb) {
                try {
                    this.idbdb.close();
                }
                catch (e) { }
                this._novip.idbdb = null;
            }
            state.dbReadyPromise = new DexiePromise(function (resolve) {
                state.dbReadyResolve = resolve;
            });
            state.openCanceller = new DexiePromise(function (_, reject) {
                state.cancelOpen = reject;
            });
        };
        Dexie.prototype.close = function () {
            this._close();
            var state = this._state;
            this._options.autoOpen = false;
            state.dbOpenError = new exceptions.DatabaseClosed();
            if (state.isBeingOpened)
                state.cancelOpen(state.dbOpenError);
        };
        Dexie.prototype.delete = function () {
            var _this = this;
            var hasArguments = arguments.length > 0;
            var state = this._state;
            return new DexiePromise(function (resolve, reject) {
                var doDelete = function () {
                    _this.close();
                    var req = _this._deps.indexedDB.deleteDatabase(_this.name);
                    req.onsuccess = wrap(function () {
                        _onDatabaseDeleted(_this._deps, _this.name);
                        resolve();
                    });
                    req.onerror = eventRejectHandler(reject);
                    req.onblocked = _this._fireOnBlocked;
                };
                if (hasArguments)
                    throw new exceptions.InvalidArgument("Arguments not allowed in db.delete()");
                if (state.isBeingOpened) {
                    state.dbReadyPromise.then(doDelete);
                }
                else {
                    doDelete();
                }
            });
        };
        Dexie.prototype.backendDB = function () {
            return this.idbdb;
        };
        Dexie.prototype.isOpen = function () {
            return this.idbdb !== null;
        };
        Dexie.prototype.hasBeenClosed = function () {
            var dbOpenError = this._state.dbOpenError;
            return dbOpenError && (dbOpenError.name === 'DatabaseClosed');
        };
        Dexie.prototype.hasFailed = function () {
            return this._state.dbOpenError !== null;
        };
        Dexie.prototype.dynamicallyOpened = function () {
            return this._state.autoSchema;
        };
        Object.defineProperty(Dexie.prototype, "tables", {
            get: function () {
                var _this = this;
                return keys(this._allTables).map(function (name) { return _this._allTables[name]; });
            },
            enumerable: false,
            configurable: true
        });
        Dexie.prototype.transaction = function () {
            var args = extractTransactionArgs.apply(this, arguments);
            return this._transaction.apply(this, args);
        };
        Dexie.prototype._transaction = function (mode, tables, scopeFunc) {
            var _this = this;
            var parentTransaction = PSD.trans;
            if (!parentTransaction || parentTransaction.db !== this || mode.indexOf('!') !== -1)
                parentTransaction = null;
            var onlyIfCompatible = mode.indexOf('?') !== -1;
            mode = mode.replace('!', '').replace('?', '');
            var idbMode, storeNames;
            try {
                storeNames = tables.map(function (table) {
                    var storeName = table instanceof _this.Table ? table.name : table;
                    if (typeof storeName !== 'string')
                        throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
                    return storeName;
                });
                if (mode == "r" || mode === READONLY)
                    idbMode = READONLY;
                else if (mode == "rw" || mode == READWRITE)
                    idbMode = READWRITE;
                else
                    throw new exceptions.InvalidArgument("Invalid transaction mode: " + mode);
                if (parentTransaction) {
                    if (parentTransaction.mode === READONLY && idbMode === READWRITE) {
                        if (onlyIfCompatible) {
                            parentTransaction = null;
                        }
                        else
                            throw new exceptions.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
                    }
                    if (parentTransaction) {
                        storeNames.forEach(function (storeName) {
                            if (parentTransaction && parentTransaction.storeNames.indexOf(storeName) === -1) {
                                if (onlyIfCompatible) {
                                    parentTransaction = null;
                                }
                                else
                                    throw new exceptions.SubTransaction("Table " + storeName +
                                        " not included in parent transaction.");
                            }
                        });
                    }
                    if (onlyIfCompatible && parentTransaction && !parentTransaction.active) {
                        parentTransaction = null;
                    }
                }
            }
            catch (e) {
                return parentTransaction ?
                    parentTransaction._promise(null, function (_, reject) { reject(e); }) :
                    rejection(e);
            }
            var enterTransaction = enterTransactionScope.bind(null, this, idbMode, storeNames, parentTransaction, scopeFunc);
            return (parentTransaction ?
                parentTransaction._promise(idbMode, enterTransaction, "lock") :
                PSD.trans ?
                    usePSD(PSD.transless, function () { return _this._whenReady(enterTransaction); }) :
                    this._whenReady(enterTransaction));
        };
        Dexie.prototype.table = function (tableName) {
            if (!hasOwn(this._allTables, tableName)) {
                throw new exceptions.InvalidTable("Table " + tableName + " does not exist");
            }
            return this._allTables[tableName];
        };
        return Dexie;
    }());

    var symbolObservable = typeof Symbol !== "undefined" && "observable" in Symbol
        ? Symbol.observable
        : "@@observable";
    var Observable =  (function () {
        function Observable(subscribe) {
            this._subscribe = subscribe;
        }
        Observable.prototype.subscribe = function (x, error, complete) {
            return this._subscribe(!x || typeof x === "function" ? { next: x, error: error, complete: complete } : x);
        };
        Observable.prototype[symbolObservable] = function () {
            return this;
        };
        return Observable;
    }());

    function extendObservabilitySet(target, newSet) {
        keys(newSet).forEach(function (part) {
            var rangeSet = target[part] || (target[part] = new RangeSet());
            mergeRanges(rangeSet, newSet[part]);
        });
        return target;
    }

    function liveQuery(querier) {
        var hasValue = false;
        var currentValue = undefined;
        var observable = new Observable(function (observer) {
            var scopeFuncIsAsync = isAsyncFunction(querier);
            function execute(subscr) {
                if (scopeFuncIsAsync) {
                    incrementExpectedAwaits();
                }
                var exec = function () { return newScope(querier, { subscr: subscr, trans: null }); };
                var rv = PSD.trans
                    ?
                        usePSD(PSD.transless, exec)
                    : exec();
                if (scopeFuncIsAsync) {
                    rv.then(decrementExpectedAwaits, decrementExpectedAwaits);
                }
                return rv;
            }
            var closed = false;
            var accumMuts = {};
            var currentObs = {};
            var subscription = {
                get closed() {
                    return closed;
                },
                unsubscribe: function () {
                    closed = true;
                    globalEvents.storagemutated.unsubscribe(mutationListener);
                },
            };
            observer.start && observer.start(subscription);
            var querying = false, startedListening = false;
            function shouldNotify() {
                return keys(currentObs).some(function (key) {
                    return accumMuts[key] && rangesOverlap(accumMuts[key], currentObs[key]);
                });
            }
            var mutationListener = function (parts) {
                extendObservabilitySet(accumMuts, parts);
                if (shouldNotify()) {
                    doQuery();
                }
            };
            var doQuery = function () {
                if (querying || closed)
                    return;
                accumMuts = {};
                var subscr = {};
                var ret = execute(subscr);
                if (!startedListening) {
                    globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME, mutationListener);
                    startedListening = true;
                }
                querying = true;
                Promise.resolve(ret).then(function (result) {
                    hasValue = true;
                    currentValue = result;
                    querying = false;
                    if (closed)
                        return;
                    if (shouldNotify()) {
                        doQuery();
                    }
                    else {
                        accumMuts = {};
                        currentObs = subscr;
                        observer.next && observer.next(result);
                    }
                }, function (err) {
                    querying = false;
                    hasValue = false;
                    observer.error && observer.error(err);
                    subscription.unsubscribe();
                });
            };
            doQuery();
            return subscription;
        });
        observable.hasValue = function () { return hasValue; };
        observable.getValue = function () { return currentValue; };
        return observable;
    }

    var domDeps;
    try {
        domDeps = {
            indexedDB: _global.indexedDB || _global.mozIndexedDB || _global.webkitIndexedDB || _global.msIndexedDB,
            IDBKeyRange: _global.IDBKeyRange || _global.webkitIDBKeyRange
        };
    }
    catch (e) {
        domDeps = { indexedDB: null, IDBKeyRange: null };
    }

    var Dexie = Dexie$1;
    props(Dexie, __assign$1(__assign$1({}, fullNameExceptions), {
        delete: function (databaseName) {
            var db = new Dexie(databaseName, { addons: [] });
            return db.delete();
        },
        exists: function (name) {
            return new Dexie(name, { addons: [] }).open().then(function (db) {
                db.close();
                return true;
            }).catch('NoSuchDatabaseError', function () { return false; });
        },
        getDatabaseNames: function (cb) {
            try {
                return getDatabaseNames(Dexie.dependencies).then(cb);
            }
            catch (_a) {
                return rejection(new exceptions.MissingAPI());
            }
        },
        defineClass: function () {
            function Class(content) {
                extend(this, content);
            }
            return Class;
        }, ignoreTransaction: function (scopeFunc) {
            return PSD.trans ?
                usePSD(PSD.transless, scopeFunc) :
                scopeFunc();
        }, vip: vip, async: function (generatorFn) {
            return function () {
                try {
                    var rv = awaitIterator(generatorFn.apply(this, arguments));
                    if (!rv || typeof rv.then !== 'function')
                        return DexiePromise.resolve(rv);
                    return rv;
                }
                catch (e) {
                    return rejection(e);
                }
            };
        }, spawn: function (generatorFn, args, thiz) {
            try {
                var rv = awaitIterator(generatorFn.apply(thiz, args || []));
                if (!rv || typeof rv.then !== 'function')
                    return DexiePromise.resolve(rv);
                return rv;
            }
            catch (e) {
                return rejection(e);
            }
        },
        currentTransaction: {
            get: function () { return PSD.trans || null; }
        }, waitFor: function (promiseOrFunction, optionalTimeout) {
            var promise = DexiePromise.resolve(typeof promiseOrFunction === 'function' ?
                Dexie.ignoreTransaction(promiseOrFunction) :
                promiseOrFunction)
                .timeout(optionalTimeout || 60000);
            return PSD.trans ?
                PSD.trans.waitFor(promise) :
                promise;
        },
        Promise: DexiePromise,
        debug: {
            get: function () { return debug; },
            set: function (value) {
                setDebug(value, value === 'dexie' ? function () { return true; } : dexieStackFrameFilter);
            }
        },
        derive: derive, extend: extend, props: props, override: override,
        Events: Events, on: globalEvents, liveQuery: liveQuery, extendObservabilitySet: extendObservabilitySet,
        getByKeyPath: getByKeyPath, setByKeyPath: setByKeyPath, delByKeyPath: delByKeyPath, shallowClone: shallowClone, deepClone: deepClone$1, getObjectDiff: getObjectDiff, cmp: cmp, asap: asap$1,
        minKey: minKey,
        addons: [],
        connections: connections,
        errnames: errnames,
        dependencies: domDeps,
        semVer: DEXIE_VERSION, version: DEXIE_VERSION.split('.')
            .map(function (n) { return parseInt(n); })
            .reduce(function (p, c, i) { return p + (c / Math.pow(10, i * 2)); }) }));
    Dexie.maxKey = getMaxKey(Dexie.dependencies.IDBKeyRange);

    if (typeof dispatchEvent !== 'undefined' && typeof addEventListener !== 'undefined') {
        globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME, function (updatedParts) {
            if (!propagatingLocally) {
                var event_1;
                if (isIEOrEdge) {
                    event_1 = document.createEvent('CustomEvent');
                    event_1.initCustomEvent(STORAGE_MUTATED_DOM_EVENT_NAME, true, true, updatedParts);
                }
                else {
                    event_1 = new CustomEvent(STORAGE_MUTATED_DOM_EVENT_NAME, {
                        detail: updatedParts
                    });
                }
                propagatingLocally = true;
                dispatchEvent(event_1);
                propagatingLocally = false;
            }
        });
        addEventListener(STORAGE_MUTATED_DOM_EVENT_NAME, function (_a) {
            var detail = _a.detail;
            if (!propagatingLocally) {
                propagateLocally(detail);
            }
        });
    }
    function propagateLocally(updateParts) {
        var wasMe = propagatingLocally;
        try {
            propagatingLocally = true;
            globalEvents.storagemutated.fire(updateParts);
        }
        finally {
            propagatingLocally = wasMe;
        }
    }
    var propagatingLocally = false;

    if (typeof BroadcastChannel !== 'undefined') {
        var bc_1 = new BroadcastChannel(STORAGE_MUTATED_DOM_EVENT_NAME);
        if (typeof bc_1.unref === 'function') {
            bc_1.unref();
        }
        globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME, function (changedParts) {
            if (!propagatingLocally) {
                bc_1.postMessage(changedParts);
            }
        });
        bc_1.onmessage = function (ev) {
            if (ev.data)
                propagateLocally(ev.data);
        };
    }
    else if (typeof self !== 'undefined' && typeof navigator !== 'undefined') {
        globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME, function (changedParts) {
            try {
                if (!propagatingLocally) {
                    if (typeof localStorage !== 'undefined') {
                        localStorage.setItem(STORAGE_MUTATED_DOM_EVENT_NAME, JSON.stringify({
                            trig: Math.random(),
                            changedParts: changedParts,
                        }));
                    }
                    if (typeof self['clients'] === 'object') {
                        __spreadArray$1([], self['clients'].matchAll({ includeUncontrolled: true }), true).forEach(function (client) {
                            return client.postMessage({
                                type: STORAGE_MUTATED_DOM_EVENT_NAME,
                                changedParts: changedParts,
                            });
                        });
                    }
                }
            }
            catch (_a) { }
        });
        if (typeof addEventListener !== 'undefined') {
            addEventListener('storage', function (ev) {
                if (ev.key === STORAGE_MUTATED_DOM_EVENT_NAME) {
                    var data = JSON.parse(ev.newValue);
                    if (data)
                        propagateLocally(data.changedParts);
                }
            });
        }
        var swContainer = self.document && navigator.serviceWorker;
        if (swContainer) {
            swContainer.addEventListener('message', propagateMessageLocally);
        }
    }
    function propagateMessageLocally(_a) {
        var data = _a.data;
        if (data && data.type === STORAGE_MUTATED_DOM_EVENT_NAME) {
            propagateLocally(data.changedParts);
        }
    }

    DexiePromise.rejectionMapper = mapError;
    setDebug(debug, dexieStackFrameFilter);

    var MySubDexie = /** @class */ (function (_super) {
        __extends$1(MySubDexie, _super);
        function MySubDexie() {
            var _this = _super.call(this, 'CLOUND_DB') || this;
            _this.version(2).stores({
                CloudInterface: "&key,[engineId+cmdId],engineId,NativeRequest,NativeResponse,signalConnect,signalDisconnect,cmdId,requestTime",
            });
            _this.version(2).stores({
                CloudError: "&key,engineId,data,requestTime",
            });
            return _this;
        }
        return MySubDexie;
    }(Dexie$1));
    var DB = new MySubDexie();

    var Log = /** @class */ (function () {
        function Log() {
            this.addTransaction = [];
            this.updateTransaction = [];
            this.dealStatus = true;
            this.dealUpdateStatus = true;
            Log.instance = this;
        }
        Log.getInstance = function () {
            if (this.instance === null) {
                this.instance = new Log();
            }
            return Log.instance;
        };
        /**
         * @description 添加表数据
         * @param type 类型
         * @param data
         */
        Log.prototype.addData = function (type, data) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var type_1, data_1, count, list;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            this.addTransaction.push({
                                type: type,
                                data: data,
                            });
                            if (!this.dealStatus)
                                return [2 /*return*/];
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 9, , 10]);
                            _b.label = 2;
                        case 2:
                            if (!(this.addTransaction.length > 0)) return [3 /*break*/, 8];
                            this.dealStatus = false;
                            type_1 = this.addTransaction[0].type;
                            data_1 = this.addTransaction[0].data;
                            if (!DB) {
                                return [2 /*return*/, { status: false, message: "CLOUND_DB已删除" }];
                            }
                            return [4 /*yield*/, DB.table(type_1).add(data_1)];
                        case 3:
                            _b.sent();
                            return [4 /*yield*/, DB.table(type_1).count()];
                        case 4:
                            count = _b.sent();
                            if (!(count > 1000)) return [3 /*break*/, 7];
                            return [4 /*yield*/, this.sortDataBy(type_1, "requestTime")];
                        case 5:
                            list = _b.sent();
                            if (!(list && list.length > 0)) return [3 /*break*/, 7];
                            return [4 /*yield*/, DB.table(type_1).delete((_a = list[0]) === null || _a === void 0 ? void 0 : _a.key)];
                        case 6:
                            _b.sent();
                            _b.label = 7;
                        case 7:
                            this.addTransaction.shift();
                            return [3 /*break*/, 2];
                        case 8: return [3 /*break*/, 10];
                        case 9:
                            _b.sent();
                            this.addTransaction.shift();
                            this.dealStatus = true;
                            return [3 /*break*/, 10];
                        case 10:
                            this.dealStatus = true;
                            return [2 /*return*/];
                    }
                });
            });
        };
        Log.prototype.sortDataBy = function (type, orderBy) {
            return __awaiter$1(this, void 0, void 0, function () {
                var data;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!DB) {
                                return [2 /*return*/, []];
                            }
                            return [4 /*yield*/, DB.table(type)
                                    .toCollection()
                                    .sortBy(orderBy)];
                        case 1:
                            data = _a.sent();
                            return [2 /*return*/, data];
                    }
                });
            });
        };
        /**
         * @description 全等查询
         * @param type
         * @param filed
         * @param value
         * @returns
         */
        Log.prototype.queryEQBy = function (type, filed, value) {
            return __awaiter$1(this, void 0, void 0, function () {
                var whereQuery, res;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!DB) {
                                return [2 /*return*/, { status: false, message: "CLOUND_DB已删除" }];
                            }
                            whereQuery = {};
                            filed.forEach(function (el, index) {
                                whereQuery[el] = value[index];
                            });
                            return [4 /*yield*/, DB.table(type)
                                    .where(whereQuery)
                                    .sortBy("requestTime")];
                        case 1:
                            res = _a.sent();
                            return [2 /*return*/, { status: true, data: res }];
                    }
                });
            });
        };
        /**
         * @description  更新数据
         * @param type 日志类型（表名）
         * @param data
         */
        Log.prototype.update = function (type, data) {
            return __awaiter$1(this, void 0, void 0, function () {
                var type_2, data_2;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!DB) {
                                return [2 /*return*/, { status: false, message: "CLOUND_DB已删除" }];
                            }
                            this.updateTransaction.push({
                                type: type,
                                data: data,
                            });
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 5, , 6]);
                            if (!this.dealUpdateStatus)
                                return [2 /*return*/];
                            _a.label = 2;
                        case 2:
                            if (!(this.updateTransaction.length > 0)) return [3 /*break*/, 4];
                            this.dealUpdateStatus = false;
                            type_2 = this.updateTransaction[0].type;
                            data_2 = this.updateTransaction[0].data;
                            if (!DB) {
                                return [2 /*return*/, { status: false, message: "CLOUND_DB已删除" }];
                            }
                            return [4 /*yield*/, DB.table(type_2).update(data_2.key, data_2)];
                        case 3:
                            _a.sent();
                            this.updateTransaction.shift();
                            return [3 /*break*/, 2];
                        case 4:
                            this.dealUpdateStatus = true;
                            return [3 /*break*/, 6];
                        case 5:
                            _a.sent();
                            this.dealUpdateStatus = true;
                            return [3 /*break*/, 6];
                        case 6: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * @description 获取表中所有日志
         * @param type
         * @returns
         */
        Log.prototype.getLogToArray = function (type) {
            return __awaiter$1(this, void 0, void 0, function () {
                var res;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!DB) {
                                return [2 /*return*/, { status: false, message: "CLOUND_DB已删除" }];
                            }
                            return [4 /*yield*/, DB.table(type).toCollection().sortBy("requestTime")];
                        case 1:
                            res = _a.sent();
                            return [2 /*return*/, { status: true, data: res }];
                    }
                });
            });
        };
        /**
         * @description 获取表中所有数据集合
         * @param {ItableType} type
         * @returns
         */
        Log.prototype.getTableCollection = function (type, engineId) {
            return __awaiter$1(this, void 0, void 0, function () {
                var res;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!DB) {
                                return [2 /*return*/, { status: false, message: "CLOUND_DB已删除" }];
                            }
                            return [4 /*yield*/, DB.table(type).where({
                                    engineId: engineId,
                                })
                                    .sortBy("requestTime")];
                        case 1:
                            res = _a.sent();
                            if (type == ItableType["CloudError"]) {
                                res.forEach(function (element) {
                                    var _a;
                                    (_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
                                        item.NativeRequest
                                            ? (item.NativeRequest = JSON.parse(item.NativeRequest))
                                            : null;
                                        item.NativeResponse
                                            ? (item.NativeResponse = JSON.parse(item.NativeResponse))
                                            : null;
                                        item.signalEmitted
                                            ? (item.signalEmitted = JSON.parse(item.signalEmitted))
                                            : null;
                                    });
                                });
                            }
                            else {
                                res.forEach(function (element) {
                                    element.NativeRequest
                                        ? (element.NativeRequest = JSON.parse(element.NativeRequest))
                                        : null;
                                    element.NativeResponse
                                        ? (element.NativeResponse = JSON.parse(element.NativeResponse))
                                        : null;
                                    element.signalEmitted
                                        ? (element.signalEmitted = JSON.parse(element.signalEmitted))
                                        : null;
                                });
                            }
                            return [2 /*return*/, { status: true, data: res }];
                    }
                });
            });
        };
        /**
         * 获取所有的报错日志
         */
        Log.prototype.getErrorList = function () {
            return __awaiter$1(this, void 0, void 0, function () {
                var res;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!DB) {
                                return [2 /*return*/, { status: false, message: "未查到" }];
                            }
                            return [4 /*yield*/, DB.table("CloudError").toCollection().sortBy("requestTime")];
                        case 1:
                            res = _a.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    data: res
                                }];
                    }
                });
            });
        };
        /**
         * 获取最近一条报错日志
         */
        Log.prototype.getLastError = function () {
            return __awaiter$1(this, void 0, void 0, function () {
                var res;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!DB) {
                                return [2 /*return*/, { status: false, message: "未查到" }];
                            }
                            return [4 /*yield*/, DB.table("CloudError").toCollection().sortBy("requestTime")];
                        case 1:
                            res = _a.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    data: res[res.length - 1]
                                }];
                    }
                });
            });
        };
        /**
         * 获取所有的调用日志
         */
        Log.prototype.getCloudRenderLog = function () {
            return __awaiter$1(this, void 0, void 0, function () {
                var res;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!DB) {
                                return [2 /*return*/, { status: false, message: "未查到" }];
                            }
                            return [4 /*yield*/, DB.table("CloudInterface").toCollection().sortBy("requestTime")];
                        case 1:
                            res = _a.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    data: this.dealLogData(res)
                                }];
                    }
                });
            });
        };
        Log.prototype.dealLogData = function (res) {
            var logsMap = {};
            for (var i = 0; i < res.length; i++) {
                var element = res[i];
                if (logsMap[element.engineId] && element) {
                    logsMap[element.engineId].push(element);
                }
                else {
                    logsMap[element.engineId] = [element];
                }
            }
            return logsMap;
        };
        Log.instance = null;
        return Log;
    }());

    var key;
    var timer;
    var IndexedDB = {
        configure: function (config, layouts, findAppender, levels) {
            return function (loggingEvent) { return __awaiter$1(void 0, void 0, void 0, function () {
                var DBInstance, dbType, dbData, res, data;
                var _a;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            DBInstance = (_a = Log.getInstance()) !== null && _a !== void 0 ? _a : new Log();
                            if (!(loggingEvent.categoryName === 'interface')) return [3 /*break*/, 9];
                            dbType = loggingEvent.data[1];
                            dbData = loggingEvent.data[2];
                            if (key === dbData) {
                                return [2 /*return*/];
                            }
                            key = dbData;
                            if (!(dbType === 'add')) return [3 /*break*/, 2];
                            return [4 /*yield*/, DBInstance.addData(ItableType.CloudInterface, dbData)];
                        case 1:
                            _b.sent();
                            _b.label = 2;
                        case 2:
                            if (!(dbType === 'update')) return [3 /*break*/, 9];
                            _b.label = 3;
                        case 3:
                            if (!!dbData.NativeRequest) return [3 /*break*/, 9];
                            return [4 /*yield*/, DBInstance.queryEQBy(ItableType.CloudInterface, ["cmdId", "engineId"], [dbData.cmdId, dbData.engineId])];
                        case 4:
                            res = _b.sent();
                            if (!(res.status && res.data &&
                                res.data.length > 0 &&
                                !res.data[res.data.length - 1].NativeResponse)) return [3 /*break*/, 6];
                            data = res.data[res.data.length - 1];
                            data.timeDiff =
                                dbData.time - res.data[res.data.length - 1].requestTime;
                            delete dbData.time;
                            Object.assign(dbData, data);
                            return [4 /*yield*/, DBInstance.update(ItableType.CloudInterface, dbData)];
                        case 5:
                            _b.sent();
                            return [3 /*break*/, 8];
                        case 6: return [4 /*yield*/, DBInstance.addData(ItableType.CloudInterface, dbData)];
                        case 7:
                            _b.sent();
                            _b.label = 8;
                        case 8:
                            dbData.NativeRequest = true;
                            return [3 /*break*/, 3];
                        case 9:
                            if (loggingEvent.categoryName === 'interfaceError') {
                                if (timer) {
                                    clearTimeout(timer);
                                }
                                timer = setTimeout(function () { return __awaiter$1(void 0, void 0, void 0, function () {
                                    var engineId, res, errorLog, param;
                                    return __generator$1(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                engineId = loggingEvent.data[1];
                                                return [4 /*yield*/, (DBInstance === null || DBInstance === void 0 ? void 0 : DBInstance.getLogToArray(ItableType.CloudInterface))];
                                            case 1:
                                                res = _a.sent();
                                                if (!((res === null || res === void 0 ? void 0 : res.status) && res.data)) return [3 /*break*/, 3];
                                                errorLog = res.data.splice(-100, 100);
                                                param = { key: "[".concat(dayjs().format('YYYY-MM-DD HH:mm:ss:SSS'), "]"), time: new Date().getTime(), engineId: engineId, data: errorLog };
                                                return [4 /*yield*/, (DBInstance === null || DBInstance === void 0 ? void 0 : DBInstance.addData(ItableType.CloudError, param))];
                                            case 2:
                                                _a.sent();
                                                _a.label = 3;
                                            case 3:
                                                clearTimeout(timer);
                                                return [2 /*return*/];
                                        }
                                    });
                                }); }, 0);
                            }
                            return [2 /*return*/];
                    }
                });
            }); };
        }
    };

    var EItemType;
    (function (EItemType) {
        EItemType[EItemType["PR"] = 0] = "PR";
        EItemType[EItemType["Node"] = 1] = "Node";
        EItemType[EItemType["GisObj"] = 2] = "GisObj";
        EItemType[EItemType["Root"] = 3] = "Root";
    })(EItemType || (EItemType = {}));
    var EMode;
    (function (EMode) {
        EMode[EMode["production"] = 0] = "production";
        EMode[EMode["development"] = 1] = "development";
    })(EMode || (EMode = {}));
    var INodeEditorType;
    (function (INodeEditorType) {
        INodeEditorType[INodeEditorType["None"] = 0] = "None";
        INodeEditorType[INodeEditorType["Translate"] = 1] = "Translate";
        INodeEditorType[INodeEditorType["Rotate"] = 2] = "Rotate";
        INodeEditorType[INodeEditorType["Scale"] = 3] = "Scale";
    })(INodeEditorType || (INodeEditorType = {}));
    var operatMode$1;
    (function (operatMode) {
        operatMode[operatMode["OF_None"] = 0] = "OF_None";
        operatMode[operatMode["system.Pickup"] = 1] = "system.Pickup";
        operatMode[operatMode["OF_FreePickUp"] = 2] = "OF_FreePickUp";
        operatMode[operatMode["system.ToolHideModel"] = 3] = "system.ToolHideModel";
        operatMode[operatMode["system.PickupCenter"] = 4] = "system.PickupCenter";
    })(operatMode$1 || (operatMode$1 = {}));
    var IDirection;
    (function (IDirection) {
        /** 向上 */
        IDirection[IDirection["up"] = 0] = "up";
        /** 向下 */
        IDirection[IDirection["down"] = 1] = "down";
    })(IDirection || (IDirection = {}));
    var ISearchType;
    (function (ISearchType) {
        /** 包含 */
        ISearchType[ISearchType["include"] = 0] = "include";
        /** 从头匹配 */
        ISearchType[ISearchType["start"] = 1] = "start";
        /** 从尾匹配 */
        ISearchType[ISearchType["end"] = 2] = "end";
        /** 相等 */
        ISearchType[ISearchType["equal"] = 3] = "equal";
    })(ISearchType || (ISearchType = {}));

    var _a;
    var DBInstance = (_a = Log.getInstance()) !== null && _a !== void 0 ? _a : new Log();
    //日志级别
    var LoggerLevel;
    (function (LoggerLevel) {
        LoggerLevel["ALL"] = "ALL";
        LoggerLevel["MARK"] = "MARK";
        LoggerLevel["TRACE"] = "TRACE";
        LoggerLevel["DEBUG"] = "DEBUG";
        LoggerLevel["INFO"] = "INFO";
        LoggerLevel["WARN"] = "WARN";
        LoggerLevel["ERROR"] = "ERROR";
        LoggerLevel["FATAL"] = "FATAL";
        LoggerLevel["OFF"] = "OFF";
    })(LoggerLevel || (LoggerLevel = {}));
    var log4jsConfig = {
        appenders: {
            console: { type: "console" },
        },
        categories: {}
    };
    if (typeof window !== 'undefined' && window.document) {
        // 在浏览器中
        log4jsConfig.appenders['IndexedDB'] = {
            type: IndexedDB,
        };
        log4jsConfig.categories = {
            default: {
                appenders: ['console'],
                level: 'DEBUG',
            },
            interface: { appenders: ["IndexedDB"], level: 'info' },
            interfaceError: { appenders: ["IndexedDB"], level: 'info' },
        };
    }
    else {
        // 在Node.js中
        // 使用文件Appender或其他Node.js特定的存储
        // 例如:
        log4jsConfig.appenders['interface'] = {
            type: 'dateFile',
            filename: "/interface/interface.log",
            alwaysIncludePattern: true,
            pattern: 'yyyyMMdd',
            daysToKeep: 60,
            numBackups: 3,
            category: 'interface',
            keepFileExt: true, //是否保留文件后缀
        };
        log4jsConfig.appenders['interfaceError'] = {
            type: 'dateFile',
            filename: "/interface/interfaceError.log",
            alwaysIncludePattern: true,
            layout: {
                type: 'pattern',
                pattern: '{"date":"%d","level":"%p","category":"%c","host":"%h","pid":"%z","data":\'%m\'}',
            },
            //日志文件按日期切割
            pattern: 'yyyyMMdd',
            daysToKeep: 60,
            numBackups: 3,
            keepFileExt: true,
        };
        log4jsConfig.categories = {
            default: {
                appenders: ['console'],
                level: 'DEBUG',
            },
            info: { appenders: ['console'], level: 'info' },
            interface: { appenders: ['interface', 'console'], level: 'DEBUG' },
            interfaceError: { appenders: ['interface', 'interfaceError', 'console'], level: 'DEBUG' },
        };
    }
    log4js__namespace.configure(log4jsConfig);
    //实例化
    var logger = log4js__namespace.getLogger();
    logger.level = LoggerLevel.OFF;
    var Logger$1 = /** @class */ (function () {
        function Logger() {
        }
        Logger.setMode = function (mode) {
            if (mode === EMode.development) {
                log4jsConfig.categories['default'].level = 'DEBUG';
                logger.level = LoggerLevel.TRACE;
                log4jsConfig.categories['interface'].appenders.push("console");
            }
            else {
                log4jsConfig.categories['default'].level = 'OFF';
                logger.level = LoggerLevel.OFF;
            }
            log4js__namespace.configure(log4jsConfig);
        };
        Logger.trace = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            logger.trace(args);
        };
        Logger.debug = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            logger.debug(args);
        };
        Logger.log = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            logger.info(args);
        };
        Logger.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            logger.info(args);
        };
        Logger.warn = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            logger.warn(args);
        };
        Logger.warning = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            logger.warn(args);
        };
        Logger.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            logger.error(args);
        };
        Logger.fatal = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            logger.fatal(args);
        };
        Logger.interface = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var loggerCustom = log4js__namespace.getLogger('interface');
            loggerCustom.info(args);
        };
        Logger.interfaceError = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var loggerCustom = log4js__namespace.getLogger('interfaceError');
            loggerCustom.info(args);
        };
        Logger.access = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var loggerCustom = log4js__namespace.getLogger('http');
            loggerCustom.info(args);
        };
        Logger.getLastError = function () {
            if (typeof window !== 'undefined' && window.document) {
                return Logger.getLastErrorByBrowser();
            }
            else {
                return Logger.getLastErrorByNode();
            }
        };
        Logger.getCloudRenderLog = function () {
            if (typeof window !== 'undefined' && window.document) {
                return Logger.getCloudRenderLogByBrowser();
            }
            else {
                return Logger.getCloudRenderLogByNode();
            }
        };
        Logger.getErrorList = function () {
            if (typeof window !== 'undefined' && window.document) {
                return Logger.getErrorListByBrowser();
            }
            else {
                return Logger.getErrorListByNode();
            }
        };
        Logger.getLastErrorByBrowser = function () {
            return DBInstance.getLastError();
        };
        Logger.getLastErrorByNode = function () {
        };
        Logger.getCloudRenderLogByBrowser = function () {
            return DBInstance.getCloudRenderLog();
        };
        Logger.getCloudRenderLogByNode = function () {
        };
        Logger.getErrorListByBrowser = function () {
            return DBInstance.getErrorList();
        };
        Logger.getErrorListByNode = function () {
        };
        return Logger;
    }());

    /****************************************************************************
    **
    ** Copyright (C) 2016 The Qt Company Ltd.
    ** Copyright (C) 2016 Klarälvdalens Datakonsult AB, a KDAB Group company, info@kdab.com, author Milian Wolff <milian.wolff@kdab.com>
    ** Contact: https://www.qt.io/licensing/
    **
    ** This file is part of the QtWebChannel module of the Qt Toolkit.
    **
    ** $QT_BEGIN_LICENSE:LGPL$
    ** Commercial License Usage
    ** Licensees holding valid commercial Qt licenses may use this file in
    ** accordance with the commercial license agreement provided with the
    ** Software or, alternatively, in accordance with the terms contained in
    ** a written agreement between you and The Qt Company. For licensing terms
    ** and conditions see https://www.qt.io/terms-conditions. For further
    ** information use the contact form at https://www.qt.io/contact-us.
    **
    ** GNU Lesser General Public License Usage
    ** Alternatively, this file may be used under the terms of the GNU Lesser
    ** General Public License version 3 as published by the Free Software
    ** Foundation and appearing in the file LICENSE.LGPL3 included in the
    ** packaging of this file. Please review the following information to
    ** ensure the GNU Lesser General Public License version 3 requirements
    ** will be met: https://www.gnu.org/licenses/lgpl-3.0.html.
    **
    ** GNU General Public License Usage
    ** Alternatively, this file may be used under the terms of the GNU
    ** General Public License version 2.0 or (at your option) the GNU General
    ** Public license version 3 or any later version approved by the KDE Free
    ** Qt Foundation. The licenses are as published by the Free Software
    ** Foundation and appearing in the file LICENSE.GPL2 and LICENSE.GPL3
    ** included in the packaging of this file. Please review the following
    ** information to ensure the GNU General Public License requirements will
    ** be met: https://www.gnu.org/licenses/gpl-2.0.html and
    ** https://www.gnu.org/licenses/gpl-3.0.html.
    **
    ** $QT_END_LICENSE$
    **
    ****************************************************************************/

    var QWebChannelMessageTypes = {
        signal: 1,
        propertyUpdate: 2,
        init: 3,
        idle: 4,
        debug: 5,
        invokeMethod: 6,
        connectToSignal: 7,
        disconnectFromSignal: 8,
        setProperty: 9,
        response: 10,
    };

    var QWebChannel = function(transport, initCallback, logger)
    {
        if (typeof transport !== "object" || typeof transport.send !== "function") {
            Logger$1.error("The QWebChannel expects a transport object with a send function and onmessage callback property." +
            " Given is: transport: " + typeof(transport) + ", transport.send: " + typeof(transport.send));
            return;
        }

        var channel = this;
        this.transport = transport;
        this.logger = logger;

        this.send = function(data)
        {
            // if(channel.transport.save) channel.transport.save(data);
            if (typeof(data) !== "string") {
                data = JSON.stringify(data);
            }
            channel.transport.send(data);
            
        };

        this.transport.onmessage = function(message)
        {
            var data = message.data;
            if (typeof data === "string") {
                data = JSON.parse(data);
            }
            switch (data.type) {
                case QWebChannelMessageTypes.signal:
                    channel.handleSignal(data);
                    break;
                case QWebChannelMessageTypes.response:
                    channel.handleResponse(data);
                    break;
                case QWebChannelMessageTypes.propertyUpdate:
                    channel.handlePropertyUpdate(data);
                    break;
                default:
                    Logger$1.error("invalid message received:", message.data);
                    break;
            }
        };

        this.execCallbacks = {};
        this.execId = 0;
        this.exec = function(data, callback)
        {
            if (!callback) {
                // if no callback is given, send directly
                channel.send(data);
                return;
            }
            if (channel.execId === Number.MAX_VALUE) {
                // wrap
                channel.execId = Number.MIN_VALUE;
            }
            if (data.hasOwnProperty("id")) {
                Logger$1.error("Cannot exec message with property id: " + JSON.stringify(data));
                return;
            }
            data.id = channel.execId++;
            channel.execCallbacks[data.id] = callback;

            if (this.logger && this.inited)
            {
                if (data.type == QWebChannelMessageTypes.invokeMethod)
                {
                    var uri = this.objects[data.object].objectName + "." + data.method;
                    this.logger.onRequest(data.id, uri, data.args);
                }
                //TODO: else ?
            }
            
            channel.send(data);
        };

        this.objects = {};

        this.handleSignal = function(message)
        {
            var object = channel.objects[message.object];
            if (object) {
                object.signalEmitted(message.signal, message.args);
            } else {
                Logger$1.warn("Unhandled signal: " + message.object + "::" + message.signal);
            }
        };

        this.handleResponse = function(message)
        {
            if (!message.hasOwnProperty("id")) {
                Logger$1.error("Invalid response message received: ", JSON.stringify(message));
                return;
            }
            if (this.logger && this.inited) {
                this.logger.onResponse(message.id, message.data);
            }
            if ("function" == typeof(channel.execCallbacks[message.id]))
            {
                channel.execCallbacks[message.id](message.data);
                delete channel.execCallbacks[message.id];
            }
        };

        this.handlePropertyUpdate = function(message)
        {
            message.data.forEach(data => {
                var object = channel.objects[data.object];
                if (object) {
                    object.propertyUpdate(data.signals, data.properties);
                } else {
                    Logger$1.warn("Unhandled property update: " + data.object + "::" + data.signal);
                }
            });
            channel.exec({type: QWebChannelMessageTypes.idle});
        };

        this.debug = function(message)
        {
            channel.send({type: QWebChannelMessageTypes.debug, data: message});
        };

        channel.exec({type: QWebChannelMessageTypes.init}, function(data) {
            for (const objectName of Object.keys(data)) {
                new QObject(objectName, data[objectName], channel);
            }

            // now unwrap properties, which might reference other registered objects
            for (const objectName of Object.keys(channel.objects)) {
                channel.objects[objectName].unwrapProperties();
            }

            if (initCallback) {
                channel.inited = true;
                initCallback(channel);
            }
            channel.exec({type: QWebChannelMessageTypes.idle});
        });
    };

    function QObject(name, data, webChannel)
    {
        this.__id__ = name;
        webChannel.objects[name] = this;

        // List of callbacks that get invoked upon signal emission
        this.__objectSignals__ = {};

        // Cache of all properties, updated when a notify signal is emitted
        this.__propertyCache__ = {};

        var object = this;

        // ----------------------------------------------------------------------

        this.unwrapQObject = function(response)
        {
            if (response instanceof Array) {
                // support list of objects
                return response.map(qobj => object.unwrapQObject(qobj))
            }
            if (!(response instanceof Object))
                return response;

            if (!response["__QObject*__"] || response.id === undefined) {
                var jObj = {};
                for (const propName of Object.keys(response)) {
                    jObj[propName] = object.unwrapQObject(response[propName]);
                }
                return jObj;
            }

            var objectId = response.id;
            if (webChannel.objects[objectId])
                return webChannel.objects[objectId];

            if (!response.data) {
                Logger$1.error("Cannot unwrap unknown QObject " + objectId + " without data.");
                return;
            }

            var qObject = new QObject( objectId, response.data, webChannel );
            qObject.destroyed.connect(function() {
                if (webChannel.objects[objectId] === qObject) {
                    delete webChannel.objects[objectId];
                    // reset the now deleted QObject to an empty {} object
                    // just assigning {} though would not have the desired effect, but the
                    // below also ensures all external references will see the empty map
                    // NOTE: this detour is necessary to workaround QTBUG-40021
                    Object.keys(qObject).forEach(name => delete qObject[name]);
                }
            });
            // here we are already initialized, and thus must directly unwrap the properties
            qObject.unwrapProperties();
            return qObject;
        };

        this.unwrapProperties = function()
        {
            for (const propertyIdx of Object.keys(object.__propertyCache__)) {
                object.__propertyCache__[propertyIdx] = object.unwrapQObject(object.__propertyCache__[propertyIdx]);
            }
        };

        function addSignal(signalData, isPropertyNotifySignal)
        {
            var signalName = signalData[0];
            var signalIndex = signalData[1];
            object[signalName] = {
                connect: function(callback) {
                    if (typeof(callback) !== "function") {
                        Logger$1.error("Bad callback given to connect to signal " + signalName);
                        return;
                    }

                    object.__signaleNames__ = object.__signaleNames__ || {};
                    object.__signaleNames__[signalIndex] = signalName;
                    object.__objectSignals__[signalIndex] = object.__objectSignals__[signalIndex] || [];
                    object.__objectSignals__[signalIndex].push(callback);

                    if (webChannel.logger && webChannel.inited) {
                        var fullName = webChannel.objects[object.__id__].objectName + "." + signalName;
                        webChannel.logger.onConnectSignal(object.__objectSignals__[signalIndex].length - 1, fullName, callback);
                    }

                    // only required for "pure" signals, handled separately for properties in propertyUpdate
                    if (isPropertyNotifySignal)
                        return;

                    // also note that we always get notified about the destroyed signal
                    if (signalName === "destroyed" || signalName === "destroyed()" || signalName === "destroyed(QObject*)")
                        return;

                    // and otherwise we only need to be connected only once
                    if (object.__objectSignals__[signalIndex].length == 1) {
                        webChannel.exec({
                            type: QWebChannelMessageTypes.connectToSignal,
                            object: object.__id__,
                            signal: signalIndex
                        });
                    }
                },
                disconnect: function(callback) {
                    if (typeof(callback) !== "function") {
                        Logger$1.error("Bad callback given to disconnect from signal " + signalName);
                        return;
                    }
                    object.__objectSignals__[signalIndex] = object.__objectSignals__[signalIndex] || [];
                    var idx = object.__objectSignals__[signalIndex].indexOf(callback);
                    if (idx === -1) {
                        Logger$1.error("Cannot find connection of signal " + signalName + " to " + callback.name);
                        return;
                    }
                    
                    if (webChannel.logger && webChannel.inited) {
                        var fullName = webChannel.objects[object.__id__].objectName + "." + signalName;
                        webChannel.logger.onDisconnectSignal(idx, fullName, callback);
                    }
                    
                    object.__objectSignals__[signalIndex].splice(idx, 1);
                    if (!isPropertyNotifySignal && object.__objectSignals__[signalIndex].length === 0) {
                        // only required for "pure" signals, handled separately for properties in propertyUpdate
                        webChannel.exec({
                            type: QWebChannelMessageTypes.disconnectFromSignal,
                            object: object.__id__,
                            signal: signalIndex
                        });
                    }
                }
            };
        }

        /**
         * Invokes all callbacks for the given signalname. Also works for property notify callbacks.
         */
        function invokeSignalCallbacks(signalName, signalArgs)
        {
            var connections = object.__objectSignals__[signalName];
            if (connections) {
                connections.forEach(function(callback) {
                    callback.apply(callback, signalArgs);
                });
            }
        }

        this.propertyUpdate = function(signals, propertyMap)
        {
            // update property cache
            for (const propertyIndex of Object.keys(propertyMap)) {
                var propertyValue = propertyMap[propertyIndex];
                object.__propertyCache__[propertyIndex] = this.unwrapQObject(propertyValue);
            }

            for (const signalName of Object.keys(signals)) {
                // Invoke all callbacks, as signalEmitted() does not. This ensures the
                // property cache is updated before the callbacks are invoked.
                invokeSignalCallbacks(signalName, signals[signalName]);
            }
        };

        this.signalEmitted = function(signalName, signalArgs)
        {
            if (webChannel.logger && webChannel.inited) {
                var fullName = webChannel.objects[object.__id__].objectName + "." + object.__signaleNames__[signalName];
                webChannel.logger.onSignal(fullName, signalArgs);
            }
            invokeSignalCallbacks(signalName, this.unwrapQObject(signalArgs));
        };

        function addMethod(methodData)
        {
            var methodName = methodData[0];
            var methodIdx = methodData[1];

            // Fully specified methods are invoked by id, others by name for host-side overload resolution
            var invokedMethod = methodName[methodName.length - 1] === ')' ? methodIdx : methodName;

            object[methodName] = function() {
                var args = [];
                var callback;
                var errCallback;
                for (var i = 0; i < arguments.length; ++i) {
                    var argument = arguments[i];
                    if (typeof argument === "function")
                        callback = argument;
                    else if (argument instanceof QObject && webChannel.objects[argument.__id__] !== undefined)
                        args.push({
                            "id": argument.__id__
                        });
                    else
                        args.push(argument);
                }

                var result;
                // during test, webChannel.exec synchronously calls the callback
                // therefore, the promise must be constucted before calling
                // webChannel.exec to ensure the callback is set up
                if (!callback && (typeof(Promise) === 'function')) {
                  result = new Promise(function(resolve, reject) {
                    callback = resolve;
                    errCallback = reject;
                  });
                }

                webChannel.exec({
                    "type": QWebChannelMessageTypes.invokeMethod,
                    "object": object.__id__,
                    "method": invokedMethod,
                    "args": args
                }, function(response) {
                    if (response !== undefined) {
                        var result = object.unwrapQObject(response);
                        if (callback) {
                            (callback)(result);
                        }
                    } else if (errCallback) {
                      (errCallback)();
                    }
                });
                return result;
            };
        }

        function bindGetterSetter(propertyInfo)
        {
            var propertyIndex = propertyInfo[0];
            var propertyName = propertyInfo[1];
            var notifySignalData = propertyInfo[2];
            // initialize property cache with current value
            // NOTE: if this is an object, it is not directly unwrapped as it might
            // reference other QObject that we do not know yet
            object.__propertyCache__[propertyIndex] = propertyInfo[3];

            if (notifySignalData) {
                if (notifySignalData[0] === 1) {
                    // signal name is optimized away, reconstruct the actual name
                    notifySignalData[0] = propertyName + "Changed";
                }
                addSignal(notifySignalData, true);
            }

            Object.defineProperty(object, propertyName, {
                configurable: true,
                get: function () {
                    var propertyValue = object.__propertyCache__[propertyIndex];
                    if (propertyValue === undefined) {
                        // This shouldn't happen
                        Logger$1.warn("Undefined value in property cache for property \"" + propertyName + "\" in object " + object.__id__);
                    }

                    return propertyValue;
                },
                set: function(value) {
                    if (value === undefined) {
                        Logger$1.warn("Property setter for " + propertyName + " called with undefined value!");
                        return;
                    }
                    object.__propertyCache__[propertyIndex] = value;
                    var valueToSend = value;
                    if (valueToSend instanceof QObject && webChannel.objects[valueToSend.__id__] !== undefined)
                        valueToSend = { "id": valueToSend.__id__ };
                    webChannel.exec({
                        "type": QWebChannelMessageTypes.setProperty,
                        "object": object.__id__,
                        "property": propertyIndex,
                        "value": valueToSend
                    });
                }
            });

        }

        // ----------------------------------------------------------------------

        data.methods.forEach(addMethod);

        data.properties.forEach(bindGetterSetter);

        data.signals.forEach(function(signal) { addSignal(signal, false); });

        Object.assign(object, data.enums);
    }

    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

    function unwrapExports (x) {
    	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }

    function createCommonjsModule(fn, module) {
    	return module = { exports: {} }, fn(module, module.exports), module.exports;
    }

    var pako_min = createCommonjsModule(function (module, exports) {
    /*! pako 2.0.4 https://github.com/nodeca/pako @license (MIT AND Zlib) */
    !function(t,e){e(exports);}(commonjsGlobal,(function(t){function e(t){let e=t.length;for(;--e>=0;)t[e]=0;}const a=256,i=286,n=30,s=15,r=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),l=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),o=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),h=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),d=new Array(576);e(d);const _=new Array(60);e(_);const f=new Array(512);e(f);const c=new Array(256);e(c);const u=new Array(29);e(u);const w=new Array(n);function b(t,e,a,i,n){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=i,this.max_length=n,this.has_stree=t&&t.length;}let g,p,m;function k(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e;}e(w);const v=t=>t<256?f[t]:f[256+(t>>>7)],y=(t,e)=>{t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255;},x=(t,e,a)=>{t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,y(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a);},z=(t,e,a)=>{x(t,a[2*e],a[2*e+1]);},A=(t,e)=>{let a=0;do{a|=1&t,t>>>=1,a<<=1;}while(--e>0);return a>>>1},E=(t,e,a)=>{const i=new Array(16);let n,r,l=0;for(n=1;n<=s;n++)i[n]=l=l+a[n-1]<<1;for(r=0;r<=e;r++){let e=t[2*r+1];0!==e&&(t[2*r]=A(i[e]++,e));}},R=t=>{let e;for(e=0;e<i;e++)t.dyn_ltree[2*e]=0;for(e=0;e<n;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0;},Z=t=>{t.bi_valid>8?y(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0;},U=(t,e,a,i)=>{const n=2*e,s=2*a;return t[n]<t[s]||t[n]===t[s]&&i[e]<=i[a]},S=(t,e,a)=>{const i=t.heap[a];let n=a<<1;for(;n<=t.heap_len&&(n<t.heap_len&&U(e,t.heap[n+1],t.heap[n],t.depth)&&n++,!U(e,i,t.heap[n],t.depth));)t.heap[a]=t.heap[n],a=n,n<<=1;t.heap[a]=i;},D=(t,e,i)=>{let n,s,o,h,d=0;if(0!==t.last_lit)do{n=t.pending_buf[t.d_buf+2*d]<<8|t.pending_buf[t.d_buf+2*d+1],s=t.pending_buf[t.l_buf+d],d++,0===n?z(t,s,e):(o=c[s],z(t,o+a+1,e),h=r[o],0!==h&&(s-=u[o],x(t,s,h)),n--,o=v(n),z(t,o,i),h=l[o],0!==h&&(n-=w[o],x(t,n,h)));}while(d<t.last_lit);z(t,256,e);},T=(t,e)=>{const a=e.dyn_tree,i=e.stat_desc.static_tree,n=e.stat_desc.has_stree,r=e.stat_desc.elems;let l,o,h,d=-1;for(t.heap_len=0,t.heap_max=573,l=0;l<r;l++)0!==a[2*l]?(t.heap[++t.heap_len]=d=l,t.depth[l]=0):a[2*l+1]=0;for(;t.heap_len<2;)h=t.heap[++t.heap_len]=d<2?++d:0,a[2*h]=1,t.depth[h]=0,t.opt_len--,n&&(t.static_len-=i[2*h+1]);for(e.max_code=d,l=t.heap_len>>1;l>=1;l--)S(t,a,l);h=r;do{l=t.heap[1],t.heap[1]=t.heap[t.heap_len--],S(t,a,1),o=t.heap[1],t.heap[--t.heap_max]=l,t.heap[--t.heap_max]=o,a[2*h]=a[2*l]+a[2*o],t.depth[h]=(t.depth[l]>=t.depth[o]?t.depth[l]:t.depth[o])+1,a[2*l+1]=a[2*o+1]=h,t.heap[1]=h++,S(t,a,1);}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],((t,e)=>{const a=e.dyn_tree,i=e.max_code,n=e.stat_desc.static_tree,r=e.stat_desc.has_stree,l=e.stat_desc.extra_bits,o=e.stat_desc.extra_base,h=e.stat_desc.max_length;let d,_,f,c,u,w,b=0;for(c=0;c<=s;c++)t.bl_count[c]=0;for(a[2*t.heap[t.heap_max]+1]=0,d=t.heap_max+1;d<573;d++)_=t.heap[d],c=a[2*a[2*_+1]+1]+1,c>h&&(c=h,b++),a[2*_+1]=c,_>i||(t.bl_count[c]++,u=0,_>=o&&(u=l[_-o]),w=a[2*_],t.opt_len+=w*(c+u),r&&(t.static_len+=w*(n[2*_+1]+u)));if(0!==b){do{for(c=h-1;0===t.bl_count[c];)c--;t.bl_count[c]--,t.bl_count[c+1]+=2,t.bl_count[h]--,b-=2;}while(b>0);for(c=h;0!==c;c--)for(_=t.bl_count[c];0!==_;)f=t.heap[--d],f>i||(a[2*f+1]!==c&&(t.opt_len+=(c-a[2*f+1])*a[2*f],a[2*f+1]=c),_--);}})(t,e),E(a,d,t.bl_count);},O=(t,e,a)=>{let i,n,s=-1,r=e[1],l=0,o=7,h=4;for(0===r&&(o=138,h=3),e[2*(a+1)+1]=65535,i=0;i<=a;i++)n=r,r=e[2*(i+1)+1],++l<o&&n===r||(l<h?t.bl_tree[2*n]+=l:0!==n?(n!==s&&t.bl_tree[2*n]++,t.bl_tree[32]++):l<=10?t.bl_tree[34]++:t.bl_tree[36]++,l=0,s=n,0===r?(o=138,h=3):n===r?(o=6,h=3):(o=7,h=4));},I=(t,e,a)=>{let i,n,s=-1,r=e[1],l=0,o=7,h=4;for(0===r&&(o=138,h=3),i=0;i<=a;i++)if(n=r,r=e[2*(i+1)+1],!(++l<o&&n===r)){if(l<h)do{z(t,n,t.bl_tree);}while(0!=--l);else 0!==n?(n!==s&&(z(t,n,t.bl_tree),l--),z(t,16,t.bl_tree),x(t,l-3,2)):l<=10?(z(t,17,t.bl_tree),x(t,l-3,3)):(z(t,18,t.bl_tree),x(t,l-11,7));l=0,s=n,0===r?(o=138,h=3):n===r?(o=6,h=3):(o=7,h=4);}};let F=!1;const L=(t,e,a,i)=>{x(t,0+(i?1:0),3),((t,e,a,i)=>{Z(t),i&&(y(t,a),y(t,~a)),t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a;})(t,e,a,!0);};var N={_tr_init:t=>{F||((()=>{let t,e,a,h,k;const v=new Array(16);for(a=0,h=0;h<28;h++)for(u[h]=a,t=0;t<1<<r[h];t++)c[a++]=h;for(c[a-1]=h,k=0,h=0;h<16;h++)for(w[h]=k,t=0;t<1<<l[h];t++)f[k++]=h;for(k>>=7;h<n;h++)for(w[h]=k<<7,t=0;t<1<<l[h]-7;t++)f[256+k++]=h;for(e=0;e<=s;e++)v[e]=0;for(t=0;t<=143;)d[2*t+1]=8,t++,v[8]++;for(;t<=255;)d[2*t+1]=9,t++,v[9]++;for(;t<=279;)d[2*t+1]=7,t++,v[7]++;for(;t<=287;)d[2*t+1]=8,t++,v[8]++;for(E(d,287,v),t=0;t<n;t++)_[2*t+1]=5,_[2*t]=A(t,5);g=new b(d,r,257,i,s),p=new b(_,l,0,n,s),m=new b(new Array(0),o,0,19,7);})(),F=!0),t.l_desc=new k(t.dyn_ltree,g),t.d_desc=new k(t.dyn_dtree,p),t.bl_desc=new k(t.bl_tree,m),t.bi_buf=0,t.bi_valid=0,R(t);},_tr_stored_block:L,_tr_flush_block:(t,e,i,n)=>{let s,r,l=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=(t=>{let e,i=4093624447;for(e=0;e<=31;e++,i>>>=1)if(1&i&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<a;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0})(t)),T(t,t.l_desc),T(t,t.d_desc),l=(t=>{let e;for(O(t,t.dyn_ltree,t.l_desc.max_code),O(t,t.dyn_dtree,t.d_desc.max_code),T(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*h[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e})(t),s=t.opt_len+3+7>>>3,r=t.static_len+3+7>>>3,r<=s&&(s=r)):s=r=i+5,i+4<=s&&-1!==e?L(t,e,i,n):4===t.strategy||r===s?(x(t,2+(n?1:0),3),D(t,d,_)):(x(t,4+(n?1:0),3),((t,e,a,i)=>{let n;for(x(t,e-257,5),x(t,a-1,5),x(t,i-4,4),n=0;n<i;n++)x(t,t.bl_tree[2*h[n]+1],3);I(t,t.dyn_ltree,e-1),I(t,t.dyn_dtree,a-1);})(t,t.l_desc.max_code+1,t.d_desc.max_code+1,l+1),D(t,t.dyn_ltree,t.dyn_dtree)),R(t),n&&Z(t);},_tr_tally:(t,e,i)=>(t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&i,t.last_lit++,0===e?t.dyn_ltree[2*i]++:(t.matches++,e--,t.dyn_ltree[2*(c[i]+a+1)]++,t.dyn_dtree[2*v(e)]++),t.last_lit===t.lit_bufsize-1),_tr_align:t=>{x(t,2,3),z(t,256,d),(t=>{16===t.bi_valid?(y(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8);})(t);}};var B=(t,e,a,i)=>{let n=65535&t|0,s=t>>>16&65535|0,r=0;for(;0!==a;){r=a>2e3?2e3:a,a-=r;do{n=n+e[i++]|0,s=s+n|0;}while(--r);n%=65521,s%=65521;}return n|s<<16|0};const C=new Uint32Array((()=>{let t,e=[];for(var a=0;a<256;a++){t=a;for(var i=0;i<8;i++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t;}return e})());var M=(t,e,a,i)=>{const n=C,s=i+a;t^=-1;for(let a=i;a<s;a++)t=t>>>8^n[255&(t^e[a])];return -1^t},H={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"},j={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_MEM_ERROR:-4,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8};const{_tr_init:K,_tr_stored_block:P,_tr_flush_block:Y,_tr_tally:G,_tr_align:X}=N,{Z_NO_FLUSH:W,Z_PARTIAL_FLUSH:q,Z_FULL_FLUSH:J,Z_FINISH:Q,Z_BLOCK:V,Z_OK:$,Z_STREAM_END:tt,Z_STREAM_ERROR:et,Z_DATA_ERROR:at,Z_BUF_ERROR:it,Z_DEFAULT_COMPRESSION:nt,Z_FILTERED:st,Z_HUFFMAN_ONLY:rt,Z_RLE:lt,Z_FIXED:ot,Z_DEFAULT_STRATEGY:ht,Z_UNKNOWN:dt,Z_DEFLATED:_t}=j,ft=258,ct=262,ut=103,wt=113,bt=666,gt=(t,e)=>(t.msg=H[e],e),pt=t=>(t<<1)-(t>4?9:0),mt=t=>{let e=t.length;for(;--e>=0;)t[e]=0;};let kt=(t,e,a)=>(e<<t.hash_shift^a)&t.hash_mask;const vt=t=>{const e=t.state;let a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0));},yt=(t,e)=>{Y(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,vt(t.strm);},xt=(t,e)=>{t.pending_buf[t.pending++]=e;},zt=(t,e)=>{t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e;},At=(t,e,a,i)=>{let n=t.avail_in;return n>i&&(n=i),0===n?0:(t.avail_in-=n,e.set(t.input.subarray(t.next_in,t.next_in+n),a),1===t.state.wrap?t.adler=B(t.adler,e,n,a):2===t.state.wrap&&(t.adler=M(t.adler,e,n,a)),t.next_in+=n,t.total_in+=n,n)},Et=(t,e)=>{let a,i,n=t.max_chain_length,s=t.strstart,r=t.prev_length,l=t.nice_match;const o=t.strstart>t.w_size-ct?t.strstart-(t.w_size-ct):0,h=t.window,d=t.w_mask,_=t.prev,f=t.strstart+ft;let c=h[s+r-1],u=h[s+r];t.prev_length>=t.good_match&&(n>>=2),l>t.lookahead&&(l=t.lookahead);do{if(a=e,h[a+r]===u&&h[a+r-1]===c&&h[a]===h[s]&&h[++a]===h[s+1]){s+=2,a++;do{}while(h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&s<f);if(i=ft-(f-s),s=f-ft,i>r){if(t.match_start=e,r=i,i>=l)break;c=h[s+r-1],u=h[s+r];}}}while((e=_[e&d])>o&&0!=--n);return r<=t.lookahead?r:t.lookahead},Rt=t=>{const e=t.w_size;let a,i,n,s,r;do{if(s=t.window_size-t.lookahead-t.strstart,t.strstart>=e+(e-ct)){t.window.set(t.window.subarray(e,e+e),0),t.match_start-=e,t.strstart-=e,t.block_start-=e,i=t.hash_size,a=i;do{n=t.head[--a],t.head[a]=n>=e?n-e:0;}while(--i);i=e,a=i;do{n=t.prev[--a],t.prev[a]=n>=e?n-e:0;}while(--i);s+=e;}if(0===t.strm.avail_in)break;if(i=At(t.strm,t.window,t.strstart+t.lookahead,s),t.lookahead+=i,t.lookahead+t.insert>=3)for(r=t.strstart-t.insert,t.ins_h=t.window[r],t.ins_h=kt(t,t.ins_h,t.window[r+1]);t.insert&&(t.ins_h=kt(t,t.ins_h,t.window[r+3-1]),t.prev[r&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=r,r++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<ct&&0!==t.strm.avail_in)},Zt=(t,e)=>{let a,i;for(;;){if(t.lookahead<ct){if(Rt(t),t.lookahead<ct&&e===W)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=kt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a)),t.match_length>=3)if(i=G(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=kt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart;}while(0!=--t.match_length);t.strstart++;}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=kt(t,t.ins_h,t.window[t.strstart+1]);else i=G(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(i&&(yt(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,e===Q?(yt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(yt(t,!1),0===t.strm.avail_out)?1:2},Ut=(t,e)=>{let a,i,n;for(;;){if(t.lookahead<ct){if(Rt(t),t.lookahead<ct&&e===W)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=kt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a),t.match_length<=5&&(t.strategy===st||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){n=t.strstart+t.lookahead-3,i=G(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=n&&(t.ins_h=kt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart);}while(0!=--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,i&&(yt(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if(i=G(t,0,t.window[t.strstart-1]),i&&yt(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--;}return t.match_available&&(i=G(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,e===Q?(yt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(yt(t,!1),0===t.strm.avail_out)?1:2};function St(t,e,a,i,n){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=i,this.func=n;}const Dt=[new St(0,0,0,0,((t,e)=>{let a=65535;for(a>t.pending_buf_size-5&&(a=t.pending_buf_size-5);;){if(t.lookahead<=1){if(Rt(t),0===t.lookahead&&e===W)return 1;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;const i=t.block_start+a;if((0===t.strstart||t.strstart>=i)&&(t.lookahead=t.strstart-i,t.strstart=i,yt(t,!1),0===t.strm.avail_out))return 1;if(t.strstart-t.block_start>=t.w_size-ct&&(yt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===Q?(yt(t,!0),0===t.strm.avail_out?3:4):(t.strstart>t.block_start&&(yt(t,!1),t.strm.avail_out),1)})),new St(4,4,8,4,Zt),new St(4,5,16,8,Zt),new St(4,6,32,32,Zt),new St(4,4,16,16,Ut),new St(8,16,32,32,Ut),new St(8,16,128,128,Ut),new St(8,32,128,256,Ut),new St(32,128,258,1024,Ut),new St(32,258,258,4096,Ut)];function Tt(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=_t,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),mt(this.dyn_ltree),mt(this.dyn_dtree),mt(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),mt(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),mt(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0;}const Ot=t=>{if(!t||!t.state)return gt(t,et);t.total_in=t.total_out=0,t.data_type=dt;const e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?42:wt,t.adler=2===e.wrap?0:1,e.last_flush=W,K(e),$},It=t=>{const e=Ot(t);var a;return e===$&&((a=t.state).window_size=2*a.w_size,mt(a.head),a.max_lazy_match=Dt[a.level].max_lazy,a.good_match=Dt[a.level].good_length,a.nice_match=Dt[a.level].nice_length,a.max_chain_length=Dt[a.level].max_chain,a.strstart=0,a.block_start=0,a.lookahead=0,a.insert=0,a.match_length=a.prev_length=2,a.match_available=0,a.ins_h=0),e},Ft=(t,e,a,i,n,s)=>{if(!t)return et;let r=1;if(e===nt&&(e=6),i<0?(r=0,i=-i):i>15&&(r=2,i-=16),n<1||n>9||a!==_t||i<8||i>15||e<0||e>9||s<0||s>ot)return gt(t,et);8===i&&(i=9);const l=new Tt;return t.state=l,l.strm=t,l.wrap=r,l.gzhead=null,l.w_bits=i,l.w_size=1<<l.w_bits,l.w_mask=l.w_size-1,l.hash_bits=n+7,l.hash_size=1<<l.hash_bits,l.hash_mask=l.hash_size-1,l.hash_shift=~~((l.hash_bits+3-1)/3),l.window=new Uint8Array(2*l.w_size),l.head=new Uint16Array(l.hash_size),l.prev=new Uint16Array(l.w_size),l.lit_bufsize=1<<n+6,l.pending_buf_size=4*l.lit_bufsize,l.pending_buf=new Uint8Array(l.pending_buf_size),l.d_buf=1*l.lit_bufsize,l.l_buf=3*l.lit_bufsize,l.level=e,l.strategy=s,l.method=a,It(t)};var Lt={deflateInit:(t,e)=>Ft(t,e,_t,15,8,ht),deflateInit2:Ft,deflateReset:It,deflateResetKeep:Ot,deflateSetHeader:(t,e)=>t&&t.state?2!==t.state.wrap?et:(t.state.gzhead=e,$):et,deflate:(t,e)=>{let a,i;if(!t||!t.state||e>V||e<0)return t?gt(t,et):et;const n=t.state;if(!t.output||!t.input&&0!==t.avail_in||n.status===bt&&e!==Q)return gt(t,0===t.avail_out?it:et);n.strm=t;const s=n.last_flush;if(n.last_flush=e,42===n.status)if(2===n.wrap)t.adler=0,xt(n,31),xt(n,139),xt(n,8),n.gzhead?(xt(n,(n.gzhead.text?1:0)+(n.gzhead.hcrc?2:0)+(n.gzhead.extra?4:0)+(n.gzhead.name?8:0)+(n.gzhead.comment?16:0)),xt(n,255&n.gzhead.time),xt(n,n.gzhead.time>>8&255),xt(n,n.gzhead.time>>16&255),xt(n,n.gzhead.time>>24&255),xt(n,9===n.level?2:n.strategy>=rt||n.level<2?4:0),xt(n,255&n.gzhead.os),n.gzhead.extra&&n.gzhead.extra.length&&(xt(n,255&n.gzhead.extra.length),xt(n,n.gzhead.extra.length>>8&255)),n.gzhead.hcrc&&(t.adler=M(t.adler,n.pending_buf,n.pending,0)),n.gzindex=0,n.status=69):(xt(n,0),xt(n,0),xt(n,0),xt(n,0),xt(n,0),xt(n,9===n.level?2:n.strategy>=rt||n.level<2?4:0),xt(n,3),n.status=wt);else {let e=_t+(n.w_bits-8<<4)<<8,a=-1;a=n.strategy>=rt||n.level<2?0:n.level<6?1:6===n.level?2:3,e|=a<<6,0!==n.strstart&&(e|=32),e+=31-e%31,n.status=wt,zt(n,e),0!==n.strstart&&(zt(n,t.adler>>>16),zt(n,65535&t.adler)),t.adler=1;}if(69===n.status)if(n.gzhead.extra){for(a=n.pending;n.gzindex<(65535&n.gzhead.extra.length)&&(n.pending!==n.pending_buf_size||(n.gzhead.hcrc&&n.pending>a&&(t.adler=M(t.adler,n.pending_buf,n.pending-a,a)),vt(t),a=n.pending,n.pending!==n.pending_buf_size));)xt(n,255&n.gzhead.extra[n.gzindex]),n.gzindex++;n.gzhead.hcrc&&n.pending>a&&(t.adler=M(t.adler,n.pending_buf,n.pending-a,a)),n.gzindex===n.gzhead.extra.length&&(n.gzindex=0,n.status=73);}else n.status=73;if(73===n.status)if(n.gzhead.name){a=n.pending;do{if(n.pending===n.pending_buf_size&&(n.gzhead.hcrc&&n.pending>a&&(t.adler=M(t.adler,n.pending_buf,n.pending-a,a)),vt(t),a=n.pending,n.pending===n.pending_buf_size)){i=1;break}i=n.gzindex<n.gzhead.name.length?255&n.gzhead.name.charCodeAt(n.gzindex++):0,xt(n,i);}while(0!==i);n.gzhead.hcrc&&n.pending>a&&(t.adler=M(t.adler,n.pending_buf,n.pending-a,a)),0===i&&(n.gzindex=0,n.status=91);}else n.status=91;if(91===n.status)if(n.gzhead.comment){a=n.pending;do{if(n.pending===n.pending_buf_size&&(n.gzhead.hcrc&&n.pending>a&&(t.adler=M(t.adler,n.pending_buf,n.pending-a,a)),vt(t),a=n.pending,n.pending===n.pending_buf_size)){i=1;break}i=n.gzindex<n.gzhead.comment.length?255&n.gzhead.comment.charCodeAt(n.gzindex++):0,xt(n,i);}while(0!==i);n.gzhead.hcrc&&n.pending>a&&(t.adler=M(t.adler,n.pending_buf,n.pending-a,a)),0===i&&(n.status=ut);}else n.status=ut;if(n.status===ut&&(n.gzhead.hcrc?(n.pending+2>n.pending_buf_size&&vt(t),n.pending+2<=n.pending_buf_size&&(xt(n,255&t.adler),xt(n,t.adler>>8&255),t.adler=0,n.status=wt)):n.status=wt),0!==n.pending){if(vt(t),0===t.avail_out)return n.last_flush=-1,$}else if(0===t.avail_in&&pt(e)<=pt(s)&&e!==Q)return gt(t,it);if(n.status===bt&&0!==t.avail_in)return gt(t,it);if(0!==t.avail_in||0!==n.lookahead||e!==W&&n.status!==bt){let a=n.strategy===rt?((t,e)=>{let a;for(;;){if(0===t.lookahead&&(Rt(t),0===t.lookahead)){if(e===W)return 1;break}if(t.match_length=0,a=G(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(yt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===Q?(yt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(yt(t,!1),0===t.strm.avail_out)?1:2})(n,e):n.strategy===lt?((t,e)=>{let a,i,n,s;const r=t.window;for(;;){if(t.lookahead<=ft){if(Rt(t),t.lookahead<=ft&&e===W)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=t.strstart-1,i=r[n],i===r[++n]&&i===r[++n]&&i===r[++n])){s=t.strstart+ft;do{}while(i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&n<s);t.match_length=ft-(s-n),t.match_length>t.lookahead&&(t.match_length=t.lookahead);}if(t.match_length>=3?(a=G(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=G(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(yt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===Q?(yt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(yt(t,!1),0===t.strm.avail_out)?1:2})(n,e):Dt[n.level].func(n,e);if(3!==a&&4!==a||(n.status=bt),1===a||3===a)return 0===t.avail_out&&(n.last_flush=-1),$;if(2===a&&(e===q?X(n):e!==V&&(P(n,0,0,!1),e===J&&(mt(n.head),0===n.lookahead&&(n.strstart=0,n.block_start=0,n.insert=0))),vt(t),0===t.avail_out))return n.last_flush=-1,$}return e!==Q?$:n.wrap<=0?tt:(2===n.wrap?(xt(n,255&t.adler),xt(n,t.adler>>8&255),xt(n,t.adler>>16&255),xt(n,t.adler>>24&255),xt(n,255&t.total_in),xt(n,t.total_in>>8&255),xt(n,t.total_in>>16&255),xt(n,t.total_in>>24&255)):(zt(n,t.adler>>>16),zt(n,65535&t.adler)),vt(t),n.wrap>0&&(n.wrap=-n.wrap),0!==n.pending?$:tt)},deflateEnd:t=>{if(!t||!t.state)return et;const e=t.state.status;return 42!==e&&69!==e&&73!==e&&91!==e&&e!==ut&&e!==wt&&e!==bt?gt(t,et):(t.state=null,e===wt?gt(t,at):$)},deflateSetDictionary:(t,e)=>{let a=e.length;if(!t||!t.state)return et;const i=t.state,n=i.wrap;if(2===n||1===n&&42!==i.status||i.lookahead)return et;if(1===n&&(t.adler=B(t.adler,e,a,0)),i.wrap=0,a>=i.w_size){0===n&&(mt(i.head),i.strstart=0,i.block_start=0,i.insert=0);let t=new Uint8Array(i.w_size);t.set(e.subarray(a-i.w_size,a),0),e=t,a=i.w_size;}const s=t.avail_in,r=t.next_in,l=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,Rt(i);i.lookahead>=3;){let t=i.strstart,e=i.lookahead-2;do{i.ins_h=kt(i,i.ins_h,i.window[t+3-1]),i.prev[t&i.w_mask]=i.head[i.ins_h],i.head[i.ins_h]=t,t++;}while(--e);i.strstart=t,i.lookahead=2,Rt(i);}return i.strstart+=i.lookahead,i.block_start=i.strstart,i.insert=i.lookahead,i.lookahead=0,i.match_length=i.prev_length=2,i.match_available=0,t.next_in=r,t.input=l,t.avail_in=s,i.wrap=n,$},deflateInfo:"pako deflate (from Nodeca project)"};const Nt=(t,e)=>Object.prototype.hasOwnProperty.call(t,e);var Bt=function(t){const e=Array.prototype.slice.call(arguments,1);for(;e.length;){const a=e.shift();if(a){if("object"!=typeof a)throw new TypeError(a+"must be non-object");for(const e in a)Nt(a,e)&&(t[e]=a[e]);}}return t},Ct=t=>{let e=0;for(let a=0,i=t.length;a<i;a++)e+=t[a].length;const a=new Uint8Array(e);for(let e=0,i=0,n=t.length;e<n;e++){let n=t[e];a.set(n,i),i+=n.length;}return a};let Mt=!0;try{String.fromCharCode.apply(null,new Uint8Array(1));}catch(t){Mt=!1;}const Ht=new Uint8Array(256);for(let t=0;t<256;t++)Ht[t]=t>=252?6:t>=248?5:t>=240?4:t>=224?3:t>=192?2:1;Ht[254]=Ht[254]=1;var jt=t=>{if("function"==typeof TextEncoder&&TextEncoder.prototype.encode)return (new TextEncoder).encode(t);let e,a,i,n,s,r=t.length,l=0;for(n=0;n<r;n++)a=t.charCodeAt(n),55296==(64512&a)&&n+1<r&&(i=t.charCodeAt(n+1),56320==(64512&i)&&(a=65536+(a-55296<<10)+(i-56320),n++)),l+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(l),s=0,n=0;s<l;n++)a=t.charCodeAt(n),55296==(64512&a)&&n+1<r&&(i=t.charCodeAt(n+1),56320==(64512&i)&&(a=65536+(a-55296<<10)+(i-56320),n++)),a<128?e[s++]=a:a<2048?(e[s++]=192|a>>>6,e[s++]=128|63&a):a<65536?(e[s++]=224|a>>>12,e[s++]=128|a>>>6&63,e[s++]=128|63&a):(e[s++]=240|a>>>18,e[s++]=128|a>>>12&63,e[s++]=128|a>>>6&63,e[s++]=128|63&a);return e},Kt=(t,e)=>{const a=e||t.length;if("function"==typeof TextDecoder&&TextDecoder.prototype.decode)return (new TextDecoder).decode(t.subarray(0,e));let i,n;const s=new Array(2*a);for(n=0,i=0;i<a;){let e=t[i++];if(e<128){s[n++]=e;continue}let r=Ht[e];if(r>4)s[n++]=65533,i+=r-1;else {for(e&=2===r?31:3===r?15:7;r>1&&i<a;)e=e<<6|63&t[i++],r--;r>1?s[n++]=65533:e<65536?s[n++]=e:(e-=65536,s[n++]=55296|e>>10&1023,s[n++]=56320|1023&e);}}return ((t,e)=>{if(e<65534&&t.subarray&&Mt)return String.fromCharCode.apply(null,t.length===e?t:t.subarray(0,e));let a="";for(let i=0;i<e;i++)a+=String.fromCharCode(t[i]);return a})(s,n)},Pt=(t,e)=>{(e=e||t.length)>t.length&&(e=t.length);let a=e-1;for(;a>=0&&128==(192&t[a]);)a--;return a<0||0===a?e:a+Ht[t[a]]>e?a:e};var Yt=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0;};const Gt=Object.prototype.toString,{Z_NO_FLUSH:Xt,Z_SYNC_FLUSH:Wt,Z_FULL_FLUSH:qt,Z_FINISH:Jt,Z_OK:Qt,Z_STREAM_END:Vt,Z_DEFAULT_COMPRESSION:$t,Z_DEFAULT_STRATEGY:te,Z_DEFLATED:ee}=j;function ae(t){this.options=Bt({level:$t,method:ee,chunkSize:16384,windowBits:15,memLevel:8,strategy:te},t||{});let e=this.options;e.raw&&e.windowBits>0?e.windowBits=-e.windowBits:e.gzip&&e.windowBits>0&&e.windowBits<16&&(e.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new Yt,this.strm.avail_out=0;let a=Lt.deflateInit2(this.strm,e.level,e.method,e.windowBits,e.memLevel,e.strategy);if(a!==Qt)throw new Error(H[a]);if(e.header&&Lt.deflateSetHeader(this.strm,e.header),e.dictionary){let t;if(t="string"==typeof e.dictionary?jt(e.dictionary):"[object ArrayBuffer]"===Gt.call(e.dictionary)?new Uint8Array(e.dictionary):e.dictionary,a=Lt.deflateSetDictionary(this.strm,t),a!==Qt)throw new Error(H[a]);this._dict_set=!0;}}function ie(t,e){const a=new ae(e);if(a.push(t,!0),a.err)throw a.msg||H[a.err];return a.result}ae.prototype.push=function(t,e){const a=this.strm,i=this.options.chunkSize;let n,s;if(this.ended)return !1;for(s=e===~~e?e:!0===e?Jt:Xt,"string"==typeof t?a.input=jt(t):"[object ArrayBuffer]"===Gt.call(t)?a.input=new Uint8Array(t):a.input=t,a.next_in=0,a.avail_in=a.input.length;;)if(0===a.avail_out&&(a.output=new Uint8Array(i),a.next_out=0,a.avail_out=i),(s===Wt||s===qt)&&a.avail_out<=6)this.onData(a.output.subarray(0,a.next_out)),a.avail_out=0;else {if(n=Lt.deflate(a,s),n===Vt)return a.next_out>0&&this.onData(a.output.subarray(0,a.next_out)),n=Lt.deflateEnd(this.strm),this.onEnd(n),this.ended=!0,n===Qt;if(0!==a.avail_out){if(s>0&&a.next_out>0)this.onData(a.output.subarray(0,a.next_out)),a.avail_out=0;else if(0===a.avail_in)break}else this.onData(a.output);}return !0},ae.prototype.onData=function(t){this.chunks.push(t);},ae.prototype.onEnd=function(t){t===Qt&&(this.result=Ct(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg;};var ne={Deflate:ae,deflate:ie,deflateRaw:function(t,e){return (e=e||{}).raw=!0,ie(t,e)},gzip:function(t,e){return (e=e||{}).gzip=!0,ie(t,e)},constants:j};var se=function(t,e){let a,i,n,s,r,l,o,h,d,_,f,c,u,w,b,g,p,m,k,v,y,x,z,A;const E=t.state;a=t.next_in,z=t.input,i=a+(t.avail_in-5),n=t.next_out,A=t.output,s=n-(e-t.avail_out),r=n+(t.avail_out-257),l=E.dmax,o=E.wsize,h=E.whave,d=E.wnext,_=E.window,f=E.hold,c=E.bits,u=E.lencode,w=E.distcode,b=(1<<E.lenbits)-1,g=(1<<E.distbits)-1;t:do{c<15&&(f+=z[a++]<<c,c+=8,f+=z[a++]<<c,c+=8),p=u[f&b];e:for(;;){if(m=p>>>24,f>>>=m,c-=m,m=p>>>16&255,0===m)A[n++]=65535&p;else {if(!(16&m)){if(0==(64&m)){p=u[(65535&p)+(f&(1<<m)-1)];continue e}if(32&m){E.mode=12;break t}t.msg="invalid literal/length code",E.mode=30;break t}k=65535&p,m&=15,m&&(c<m&&(f+=z[a++]<<c,c+=8),k+=f&(1<<m)-1,f>>>=m,c-=m),c<15&&(f+=z[a++]<<c,c+=8,f+=z[a++]<<c,c+=8),p=w[f&g];a:for(;;){if(m=p>>>24,f>>>=m,c-=m,m=p>>>16&255,!(16&m)){if(0==(64&m)){p=w[(65535&p)+(f&(1<<m)-1)];continue a}t.msg="invalid distance code",E.mode=30;break t}if(v=65535&p,m&=15,c<m&&(f+=z[a++]<<c,c+=8,c<m&&(f+=z[a++]<<c,c+=8)),v+=f&(1<<m)-1,v>l){t.msg="invalid distance too far back",E.mode=30;break t}if(f>>>=m,c-=m,m=n-s,v>m){if(m=v-m,m>h&&E.sane){t.msg="invalid distance too far back",E.mode=30;break t}if(y=0,x=_,0===d){if(y+=o-m,m<k){k-=m;do{A[n++]=_[y++];}while(--m);y=n-v,x=A;}}else if(d<m){if(y+=o+d-m,m-=d,m<k){k-=m;do{A[n++]=_[y++];}while(--m);if(y=0,d<k){m=d,k-=m;do{A[n++]=_[y++];}while(--m);y=n-v,x=A;}}}else if(y+=d-m,m<k){k-=m;do{A[n++]=_[y++];}while(--m);y=n-v,x=A;}for(;k>2;)A[n++]=x[y++],A[n++]=x[y++],A[n++]=x[y++],k-=3;k&&(A[n++]=x[y++],k>1&&(A[n++]=x[y++]));}else {y=n-v;do{A[n++]=A[y++],A[n++]=A[y++],A[n++]=A[y++],k-=3;}while(k>2);k&&(A[n++]=A[y++],k>1&&(A[n++]=A[y++]));}break}}break}}while(a<i&&n<r);k=c>>3,a-=k,c-=k<<3,f&=(1<<c)-1,t.next_in=a,t.next_out=n,t.avail_in=a<i?i-a+5:5-(a-i),t.avail_out=n<r?r-n+257:257-(n-r),E.hold=f,E.bits=c;};const re=15,le=new Uint16Array([3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0]),oe=new Uint8Array([16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78]),he=new Uint16Array([1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0]),de=new Uint8Array([16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64]);var _e=(t,e,a,i,n,s,r,l)=>{const o=l.bits;let h,d,_,f,c,u,w=0,b=0,g=0,p=0,m=0,k=0,v=0,y=0,x=0,z=0,A=null,E=0;const R=new Uint16Array(16),Z=new Uint16Array(16);let U,S,D,T=null,O=0;for(w=0;w<=re;w++)R[w]=0;for(b=0;b<i;b++)R[e[a+b]]++;for(m=o,p=re;p>=1&&0===R[p];p--);if(m>p&&(m=p),0===p)return n[s++]=20971520,n[s++]=20971520,l.bits=1,0;for(g=1;g<p&&0===R[g];g++);for(m<g&&(m=g),y=1,w=1;w<=re;w++)if(y<<=1,y-=R[w],y<0)return -1;if(y>0&&(0===t||1!==p))return -1;for(Z[1]=0,w=1;w<re;w++)Z[w+1]=Z[w]+R[w];for(b=0;b<i;b++)0!==e[a+b]&&(r[Z[e[a+b]]++]=b);if(0===t?(A=T=r,u=19):1===t?(A=le,E-=257,T=oe,O-=257,u=256):(A=he,T=de,u=-1),z=0,b=0,w=g,c=s,k=m,v=0,_=-1,x=1<<m,f=x-1,1===t&&x>852||2===t&&x>592)return 1;for(;;){U=w-v,r[b]<u?(S=0,D=r[b]):r[b]>u?(S=T[O+r[b]],D=A[E+r[b]]):(S=96,D=0),h=1<<w-v,d=1<<k,g=d;do{d-=h,n[c+(z>>v)+d]=U<<24|S<<16|D|0;}while(0!==d);for(h=1<<w-1;z&h;)h>>=1;if(0!==h?(z&=h-1,z+=h):z=0,b++,0==--R[w]){if(w===p)break;w=e[a+r[b]];}if(w>m&&(z&f)!==_){for(0===v&&(v=m),c+=g,k=w-v,y=1<<k;k+v<p&&(y-=R[k+v],!(y<=0));)k++,y<<=1;if(x+=1<<k,1===t&&x>852||2===t&&x>592)return 1;_=z&f,n[_]=m<<24|k<<16|c-s|0;}}return 0!==z&&(n[c+z]=w-v<<24|64<<16|0),l.bits=m,0};const{Z_FINISH:fe,Z_BLOCK:ce,Z_TREES:ue,Z_OK:we,Z_STREAM_END:be,Z_NEED_DICT:ge,Z_STREAM_ERROR:pe,Z_DATA_ERROR:me,Z_MEM_ERROR:ke,Z_BUF_ERROR:ve,Z_DEFLATED:ye}=j,xe=12,ze=30,Ae=t=>(t>>>24&255)+(t>>>8&65280)+((65280&t)<<8)+((255&t)<<24);function Ee(){this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new Uint16Array(320),this.work=new Uint16Array(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0;}const Re=t=>{if(!t||!t.state)return pe;const e=t.state;return t.total_in=t.total_out=e.total=0,t.msg="",e.wrap&&(t.adler=1&e.wrap),e.mode=1,e.last=0,e.havedict=0,e.dmax=32768,e.head=null,e.hold=0,e.bits=0,e.lencode=e.lendyn=new Int32Array(852),e.distcode=e.distdyn=new Int32Array(592),e.sane=1,e.back=-1,we},Ze=t=>{if(!t||!t.state)return pe;const e=t.state;return e.wsize=0,e.whave=0,e.wnext=0,Re(t)},Ue=(t,e)=>{let a;if(!t||!t.state)return pe;const i=t.state;return e<0?(a=0,e=-e):(a=1+(e>>4),e<48&&(e&=15)),e&&(e<8||e>15)?pe:(null!==i.window&&i.wbits!==e&&(i.window=null),i.wrap=a,i.wbits=e,Ze(t))},Se=(t,e)=>{if(!t)return pe;const a=new Ee;t.state=a,a.window=null;const i=Ue(t,e);return i!==we&&(t.state=null),i};let De,Te,Oe=!0;const Ie=t=>{if(Oe){De=new Int32Array(512),Te=new Int32Array(32);let e=0;for(;e<144;)t.lens[e++]=8;for(;e<256;)t.lens[e++]=9;for(;e<280;)t.lens[e++]=7;for(;e<288;)t.lens[e++]=8;for(_e(1,t.lens,0,288,De,0,t.work,{bits:9}),e=0;e<32;)t.lens[e++]=5;_e(2,t.lens,0,32,Te,0,t.work,{bits:5}),Oe=!1;}t.lencode=De,t.lenbits=9,t.distcode=Te,t.distbits=5;},Fe=(t,e,a,i)=>{let n;const s=t.state;return null===s.window&&(s.wsize=1<<s.wbits,s.wnext=0,s.whave=0,s.window=new Uint8Array(s.wsize)),i>=s.wsize?(s.window.set(e.subarray(a-s.wsize,a),0),s.wnext=0,s.whave=s.wsize):(n=s.wsize-s.wnext,n>i&&(n=i),s.window.set(e.subarray(a-i,a-i+n),s.wnext),(i-=n)?(s.window.set(e.subarray(a-i,a),0),s.wnext=i,s.whave=s.wsize):(s.wnext+=n,s.wnext===s.wsize&&(s.wnext=0),s.whave<s.wsize&&(s.whave+=n))),0};var Le={inflateReset:Ze,inflateReset2:Ue,inflateResetKeep:Re,inflateInit:t=>Se(t,15),inflateInit2:Se,inflate:(t,e)=>{let a,i,n,s,r,l,o,h,d,_,f,c,u,w,b,g,p,m,k,v,y,x,z=0;const A=new Uint8Array(4);let E,R;const Z=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]);if(!t||!t.state||!t.output||!t.input&&0!==t.avail_in)return pe;a=t.state,a.mode===xe&&(a.mode=13),r=t.next_out,n=t.output,o=t.avail_out,s=t.next_in,i=t.input,l=t.avail_in,h=a.hold,d=a.bits,_=l,f=o,x=we;t:for(;;)switch(a.mode){case 1:if(0===a.wrap){a.mode=13;break}for(;d<16;){if(0===l)break t;l--,h+=i[s++]<<d,d+=8;}if(2&a.wrap&&35615===h){a.check=0,A[0]=255&h,A[1]=h>>>8&255,a.check=M(a.check,A,2,0),h=0,d=0,a.mode=2;break}if(a.flags=0,a.head&&(a.head.done=!1),!(1&a.wrap)||(((255&h)<<8)+(h>>8))%31){t.msg="incorrect header check",a.mode=ze;break}if((15&h)!==ye){t.msg="unknown compression method",a.mode=ze;break}if(h>>>=4,d-=4,y=8+(15&h),0===a.wbits)a.wbits=y;else if(y>a.wbits){t.msg="invalid window size",a.mode=ze;break}a.dmax=1<<a.wbits,t.adler=a.check=1,a.mode=512&h?10:xe,h=0,d=0;break;case 2:for(;d<16;){if(0===l)break t;l--,h+=i[s++]<<d,d+=8;}if(a.flags=h,(255&a.flags)!==ye){t.msg="unknown compression method",a.mode=ze;break}if(57344&a.flags){t.msg="unknown header flags set",a.mode=ze;break}a.head&&(a.head.text=h>>8&1),512&a.flags&&(A[0]=255&h,A[1]=h>>>8&255,a.check=M(a.check,A,2,0)),h=0,d=0,a.mode=3;case 3:for(;d<32;){if(0===l)break t;l--,h+=i[s++]<<d,d+=8;}a.head&&(a.head.time=h),512&a.flags&&(A[0]=255&h,A[1]=h>>>8&255,A[2]=h>>>16&255,A[3]=h>>>24&255,a.check=M(a.check,A,4,0)),h=0,d=0,a.mode=4;case 4:for(;d<16;){if(0===l)break t;l--,h+=i[s++]<<d,d+=8;}a.head&&(a.head.xflags=255&h,a.head.os=h>>8),512&a.flags&&(A[0]=255&h,A[1]=h>>>8&255,a.check=M(a.check,A,2,0)),h=0,d=0,a.mode=5;case 5:if(1024&a.flags){for(;d<16;){if(0===l)break t;l--,h+=i[s++]<<d,d+=8;}a.length=h,a.head&&(a.head.extra_len=h),512&a.flags&&(A[0]=255&h,A[1]=h>>>8&255,a.check=M(a.check,A,2,0)),h=0,d=0;}else a.head&&(a.head.extra=null);a.mode=6;case 6:if(1024&a.flags&&(c=a.length,c>l&&(c=l),c&&(a.head&&(y=a.head.extra_len-a.length,a.head.extra||(a.head.extra=new Uint8Array(a.head.extra_len)),a.head.extra.set(i.subarray(s,s+c),y)),512&a.flags&&(a.check=M(a.check,i,c,s)),l-=c,s+=c,a.length-=c),a.length))break t;a.length=0,a.mode=7;case 7:if(2048&a.flags){if(0===l)break t;c=0;do{y=i[s+c++],a.head&&y&&a.length<65536&&(a.head.name+=String.fromCharCode(y));}while(y&&c<l);if(512&a.flags&&(a.check=M(a.check,i,c,s)),l-=c,s+=c,y)break t}else a.head&&(a.head.name=null);a.length=0,a.mode=8;case 8:if(4096&a.flags){if(0===l)break t;c=0;do{y=i[s+c++],a.head&&y&&a.length<65536&&(a.head.comment+=String.fromCharCode(y));}while(y&&c<l);if(512&a.flags&&(a.check=M(a.check,i,c,s)),l-=c,s+=c,y)break t}else a.head&&(a.head.comment=null);a.mode=9;case 9:if(512&a.flags){for(;d<16;){if(0===l)break t;l--,h+=i[s++]<<d,d+=8;}if(h!==(65535&a.check)){t.msg="header crc mismatch",a.mode=ze;break}h=0,d=0;}a.head&&(a.head.hcrc=a.flags>>9&1,a.head.done=!0),t.adler=a.check=0,a.mode=xe;break;case 10:for(;d<32;){if(0===l)break t;l--,h+=i[s++]<<d,d+=8;}t.adler=a.check=Ae(h),h=0,d=0,a.mode=11;case 11:if(0===a.havedict)return t.next_out=r,t.avail_out=o,t.next_in=s,t.avail_in=l,a.hold=h,a.bits=d,ge;t.adler=a.check=1,a.mode=xe;case xe:if(e===ce||e===ue)break t;case 13:if(a.last){h>>>=7&d,d-=7&d,a.mode=27;break}for(;d<3;){if(0===l)break t;l--,h+=i[s++]<<d,d+=8;}switch(a.last=1&h,h>>>=1,d-=1,3&h){case 0:a.mode=14;break;case 1:if(Ie(a),a.mode=20,e===ue){h>>>=2,d-=2;break t}break;case 2:a.mode=17;break;case 3:t.msg="invalid block type",a.mode=ze;}h>>>=2,d-=2;break;case 14:for(h>>>=7&d,d-=7&d;d<32;){if(0===l)break t;l--,h+=i[s++]<<d,d+=8;}if((65535&h)!=(h>>>16^65535)){t.msg="invalid stored block lengths",a.mode=ze;break}if(a.length=65535&h,h=0,d=0,a.mode=15,e===ue)break t;case 15:a.mode=16;case 16:if(c=a.length,c){if(c>l&&(c=l),c>o&&(c=o),0===c)break t;n.set(i.subarray(s,s+c),r),l-=c,s+=c,o-=c,r+=c,a.length-=c;break}a.mode=xe;break;case 17:for(;d<14;){if(0===l)break t;l--,h+=i[s++]<<d,d+=8;}if(a.nlen=257+(31&h),h>>>=5,d-=5,a.ndist=1+(31&h),h>>>=5,d-=5,a.ncode=4+(15&h),h>>>=4,d-=4,a.nlen>286||a.ndist>30){t.msg="too many length or distance symbols",a.mode=ze;break}a.have=0,a.mode=18;case 18:for(;a.have<a.ncode;){for(;d<3;){if(0===l)break t;l--,h+=i[s++]<<d,d+=8;}a.lens[Z[a.have++]]=7&h,h>>>=3,d-=3;}for(;a.have<19;)a.lens[Z[a.have++]]=0;if(a.lencode=a.lendyn,a.lenbits=7,E={bits:a.lenbits},x=_e(0,a.lens,0,19,a.lencode,0,a.work,E),a.lenbits=E.bits,x){t.msg="invalid code lengths set",a.mode=ze;break}a.have=0,a.mode=19;case 19:for(;a.have<a.nlen+a.ndist;){for(;z=a.lencode[h&(1<<a.lenbits)-1],b=z>>>24,g=z>>>16&255,p=65535&z,!(b<=d);){if(0===l)break t;l--,h+=i[s++]<<d,d+=8;}if(p<16)h>>>=b,d-=b,a.lens[a.have++]=p;else {if(16===p){for(R=b+2;d<R;){if(0===l)break t;l--,h+=i[s++]<<d,d+=8;}if(h>>>=b,d-=b,0===a.have){t.msg="invalid bit length repeat",a.mode=ze;break}y=a.lens[a.have-1],c=3+(3&h),h>>>=2,d-=2;}else if(17===p){for(R=b+3;d<R;){if(0===l)break t;l--,h+=i[s++]<<d,d+=8;}h>>>=b,d-=b,y=0,c=3+(7&h),h>>>=3,d-=3;}else {for(R=b+7;d<R;){if(0===l)break t;l--,h+=i[s++]<<d,d+=8;}h>>>=b,d-=b,y=0,c=11+(127&h),h>>>=7,d-=7;}if(a.have+c>a.nlen+a.ndist){t.msg="invalid bit length repeat",a.mode=ze;break}for(;c--;)a.lens[a.have++]=y;}}if(a.mode===ze)break;if(0===a.lens[256]){t.msg="invalid code -- missing end-of-block",a.mode=ze;break}if(a.lenbits=9,E={bits:a.lenbits},x=_e(1,a.lens,0,a.nlen,a.lencode,0,a.work,E),a.lenbits=E.bits,x){t.msg="invalid literal/lengths set",a.mode=ze;break}if(a.distbits=6,a.distcode=a.distdyn,E={bits:a.distbits},x=_e(2,a.lens,a.nlen,a.ndist,a.distcode,0,a.work,E),a.distbits=E.bits,x){t.msg="invalid distances set",a.mode=ze;break}if(a.mode=20,e===ue)break t;case 20:a.mode=21;case 21:if(l>=6&&o>=258){t.next_out=r,t.avail_out=o,t.next_in=s,t.avail_in=l,a.hold=h,a.bits=d,se(t,f),r=t.next_out,n=t.output,o=t.avail_out,s=t.next_in,i=t.input,l=t.avail_in,h=a.hold,d=a.bits,a.mode===xe&&(a.back=-1);break}for(a.back=0;z=a.lencode[h&(1<<a.lenbits)-1],b=z>>>24,g=z>>>16&255,p=65535&z,!(b<=d);){if(0===l)break t;l--,h+=i[s++]<<d,d+=8;}if(g&&0==(240&g)){for(m=b,k=g,v=p;z=a.lencode[v+((h&(1<<m+k)-1)>>m)],b=z>>>24,g=z>>>16&255,p=65535&z,!(m+b<=d);){if(0===l)break t;l--,h+=i[s++]<<d,d+=8;}h>>>=m,d-=m,a.back+=m;}if(h>>>=b,d-=b,a.back+=b,a.length=p,0===g){a.mode=26;break}if(32&g){a.back=-1,a.mode=xe;break}if(64&g){t.msg="invalid literal/length code",a.mode=ze;break}a.extra=15&g,a.mode=22;case 22:if(a.extra){for(R=a.extra;d<R;){if(0===l)break t;l--,h+=i[s++]<<d,d+=8;}a.length+=h&(1<<a.extra)-1,h>>>=a.extra,d-=a.extra,a.back+=a.extra;}a.was=a.length,a.mode=23;case 23:for(;z=a.distcode[h&(1<<a.distbits)-1],b=z>>>24,g=z>>>16&255,p=65535&z,!(b<=d);){if(0===l)break t;l--,h+=i[s++]<<d,d+=8;}if(0==(240&g)){for(m=b,k=g,v=p;z=a.distcode[v+((h&(1<<m+k)-1)>>m)],b=z>>>24,g=z>>>16&255,p=65535&z,!(m+b<=d);){if(0===l)break t;l--,h+=i[s++]<<d,d+=8;}h>>>=m,d-=m,a.back+=m;}if(h>>>=b,d-=b,a.back+=b,64&g){t.msg="invalid distance code",a.mode=ze;break}a.offset=p,a.extra=15&g,a.mode=24;case 24:if(a.extra){for(R=a.extra;d<R;){if(0===l)break t;l--,h+=i[s++]<<d,d+=8;}a.offset+=h&(1<<a.extra)-1,h>>>=a.extra,d-=a.extra,a.back+=a.extra;}if(a.offset>a.dmax){t.msg="invalid distance too far back",a.mode=ze;break}a.mode=25;case 25:if(0===o)break t;if(c=f-o,a.offset>c){if(c=a.offset-c,c>a.whave&&a.sane){t.msg="invalid distance too far back",a.mode=ze;break}c>a.wnext?(c-=a.wnext,u=a.wsize-c):u=a.wnext-c,c>a.length&&(c=a.length),w=a.window;}else w=n,u=r-a.offset,c=a.length;c>o&&(c=o),o-=c,a.length-=c;do{n[r++]=w[u++];}while(--c);0===a.length&&(a.mode=21);break;case 26:if(0===o)break t;n[r++]=a.length,o--,a.mode=21;break;case 27:if(a.wrap){for(;d<32;){if(0===l)break t;l--,h|=i[s++]<<d,d+=8;}if(f-=o,t.total_out+=f,a.total+=f,f&&(t.adler=a.check=a.flags?M(a.check,n,f,r-f):B(a.check,n,f,r-f)),f=o,(a.flags?h:Ae(h))!==a.check){t.msg="incorrect data check",a.mode=ze;break}h=0,d=0;}a.mode=28;case 28:if(a.wrap&&a.flags){for(;d<32;){if(0===l)break t;l--,h+=i[s++]<<d,d+=8;}if(h!==(4294967295&a.total)){t.msg="incorrect length check",a.mode=ze;break}h=0,d=0;}a.mode=29;case 29:x=be;break t;case ze:x=me;break t;case 31:return ke;case 32:default:return pe}return t.next_out=r,t.avail_out=o,t.next_in=s,t.avail_in=l,a.hold=h,a.bits=d,(a.wsize||f!==t.avail_out&&a.mode<ze&&(a.mode<27||e!==fe))&&Fe(t,t.output,t.next_out,f-t.avail_out),_-=t.avail_in,f-=t.avail_out,t.total_in+=_,t.total_out+=f,a.total+=f,a.wrap&&f&&(t.adler=a.check=a.flags?M(a.check,n,f,t.next_out-f):B(a.check,n,f,t.next_out-f)),t.data_type=a.bits+(a.last?64:0)+(a.mode===xe?128:0)+(20===a.mode||15===a.mode?256:0),(0===_&&0===f||e===fe)&&x===we&&(x=ve),x},inflateEnd:t=>{if(!t||!t.state)return pe;let e=t.state;return e.window&&(e.window=null),t.state=null,we},inflateGetHeader:(t,e)=>{if(!t||!t.state)return pe;const a=t.state;return 0==(2&a.wrap)?pe:(a.head=e,e.done=!1,we)},inflateSetDictionary:(t,e)=>{const a=e.length;let i,n,s;return t&&t.state?(i=t.state,0!==i.wrap&&11!==i.mode?pe:11===i.mode&&(n=1,n=B(n,e,a,0),n!==i.check)?me:(s=Fe(t,e,a,a),s?(i.mode=31,ke):(i.havedict=1,we))):pe},inflateInfo:"pako inflate (from Nodeca project)"};var Ne=function(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1;};const Be=Object.prototype.toString,{Z_NO_FLUSH:Ce,Z_FINISH:Me,Z_OK:He,Z_STREAM_END:je,Z_NEED_DICT:Ke,Z_STREAM_ERROR:Pe,Z_DATA_ERROR:Ye,Z_MEM_ERROR:Ge}=j;function Xe(t){this.options=Bt({chunkSize:65536,windowBits:15,to:""},t||{});const e=this.options;e.raw&&e.windowBits>=0&&e.windowBits<16&&(e.windowBits=-e.windowBits,0===e.windowBits&&(e.windowBits=-15)),!(e.windowBits>=0&&e.windowBits<16)||t&&t.windowBits||(e.windowBits+=32),e.windowBits>15&&e.windowBits<48&&0==(15&e.windowBits)&&(e.windowBits|=15),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new Yt,this.strm.avail_out=0;let a=Le.inflateInit2(this.strm,e.windowBits);if(a!==He)throw new Error(H[a]);if(this.header=new Ne,Le.inflateGetHeader(this.strm,this.header),e.dictionary&&("string"==typeof e.dictionary?e.dictionary=jt(e.dictionary):"[object ArrayBuffer]"===Be.call(e.dictionary)&&(e.dictionary=new Uint8Array(e.dictionary)),e.raw&&(a=Le.inflateSetDictionary(this.strm,e.dictionary),a!==He)))throw new Error(H[a])}function We(t,e){const a=new Xe(e);if(a.push(t),a.err)throw a.msg||H[a.err];return a.result}Xe.prototype.push=function(t,e){const a=this.strm,i=this.options.chunkSize,n=this.options.dictionary;let s,r,l;if(this.ended)return !1;for(r=e===~~e?e:!0===e?Me:Ce,"[object ArrayBuffer]"===Be.call(t)?a.input=new Uint8Array(t):a.input=t,a.next_in=0,a.avail_in=a.input.length;;){for(0===a.avail_out&&(a.output=new Uint8Array(i),a.next_out=0,a.avail_out=i),s=Le.inflate(a,r),s===Ke&&n&&(s=Le.inflateSetDictionary(a,n),s===He?s=Le.inflate(a,r):s===Ye&&(s=Ke));a.avail_in>0&&s===je&&a.state.wrap>0&&0!==t[a.next_in];)Le.inflateReset(a),s=Le.inflate(a,r);switch(s){case Pe:case Ye:case Ke:case Ge:return this.onEnd(s),this.ended=!0,!1}if(l=a.avail_out,a.next_out&&(0===a.avail_out||s===je))if("string"===this.options.to){let t=Pt(a.output,a.next_out),e=a.next_out-t,n=Kt(a.output,t);a.next_out=e,a.avail_out=i-e,e&&a.output.set(a.output.subarray(t,t+e),0),this.onData(n);}else this.onData(a.output.length===a.next_out?a.output:a.output.subarray(0,a.next_out));if(s!==He||0!==l){if(s===je)return s=Le.inflateEnd(this.strm),this.onEnd(s),this.ended=!0,!0;if(0===a.avail_in)break}}return !0},Xe.prototype.onData=function(t){this.chunks.push(t);},Xe.prototype.onEnd=function(t){t===He&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=Ct(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg;};var qe={Inflate:Xe,inflate:We,inflateRaw:function(t,e){return (e=e||{}).raw=!0,We(t,e)},ungzip:We,constants:j};const{Deflate:Je,deflate:Qe,deflateRaw:Ve,gzip:$e}=ne,{Inflate:ta,inflate:ea,inflateRaw:aa,ungzip:ia}=qe;var na=Je,sa=Qe,ra=Ve,la=$e,oa=ta,ha=ea,da=aa,_a=ia,fa=j,ca={Deflate:na,deflate:sa,deflateRaw:ra,gzip:la,Inflate:oa,inflate:ha,inflateRaw:da,ungzip:_a,constants:fa};t.Deflate=na,t.Inflate=oa,t.constants=fa,t.default=ca,t.deflate=sa,t.deflateRaw=ra,t.gzip=la,t.inflate=ha,t.inflateRaw=da,t.ungzip=_a,Object.defineProperty(t,"__esModule",{value:!0});}));
    });

    var pako = unwrapExports(pako_min);

    const RemotePlayerMsgType = {
        MIN_USER_INPUT_MSG_ID: 0,
        MouseMove: 0,
        MouseDown: 1,
        MouseUp: 2,
        MouseWheel: 3,
        MouseDBClick: 4,
        WindowSize: 5,
        TouchDown: 6,
        TouchUp: 7,
        TouchMove: 8,
        Exit: 9,
        KeyDown: 10,
        KeyUp: 11,
        MAX_USER_INPUT_MSG_ID: 11,

        RELAY_JPG_REQ: 12,
    };

    // Check if Native app
    // if (parent && parent.qt) qt = parent.qt;
    window.isNativeApp = (typeof (qt) == "object" && qt.webChannelTransport);
    if (window.isNativeApp) {
        if ("undefined" != typeof QWebChannel) {
            window.NativeAppLoad = new Promise((resolve) => {
                window.gWebChannel = new QWebChannel(qt.webChannelTransport, function (channel) {
                    window.NativeApp = {};
                    Object.assign(window.NativeApp, channel.objects);
                    console.info("NativeApp Loaded");
                    resolve();
                });
            });
        }
        else {
            console.warn("qwebchannel.js must load before Player.js");
            window.isNativeApp = false;
        }
    }

    function RemotePlayer(config) {
        this.fileVersion = "For WIZPlayer 5.1.0+";

        let $self = this;

        // 配置检查
        config = config || {};

        if (!config.logger && config.debug) {
            const TimeToString = (t) => { return '[' + t.toLocaleTimeString() + ':' + t.getMilliseconds() + ']'; };
            config.logger = {
                onRequest: function (cmdId, request, args) {
                    let t = new Date();
                    console.debug(TimeToString(t) + ` NativeRequest:{"method": "${request}", "id":${cmdId}}`, args);
                },
                onResponse: function (cmdId, ret) {
                    let t = new Date();
                    console.debug(TimeToString(t) + ` NativeResponse: {"id":${cmdId}}`, ret);
                },
                onConnectSignal: function (idx, signalName, callback) {
                    console.debug(TimeToString(new Date()) + ` signalConnect: {"method": "${signalName}", "id":${idx}}`, callback);
                },
                onDisconnectSignal: function (idx, signalName, callback) {
                    console.debug(TimeToString(new Date()) + ` signalDisconnect: {"method": "${signalName}", "id":${idx}}`, callback);
                },
                onSignal: function (signalName, args) {
                    console.debug(TimeToString(new Date()) + ` signalEmitted: {"method": "${signalName}"}`, args);
                }
            };
        }

        // 服务器地址
        config.signalServer = config.signalServer || "ws://localhost:8080";
        // 引擎ID
        config.engineId = config.engineId;
        // player要绑定的视频标签
        config.video = config.video || document.getElementsByTagName("video")[0];
        config.isImage = config.video.tagName == "IMG";
        // config.video.style.transform = "rotateX(180deg)";
        // 是否启用自定义用户输入事件，启用则不监听视频标签上的鼠标、触屏事件，需要用户自行调用输入函数
        config.customInputEvent = config.customInputEvent ? true : false;
        // 自动调整引擎画面大小与绑定视频标签同步
        config.autoResize = config.autoResize ? true : false;
        // 限制用户每秒鼠标移动和触屏的事件个数，事件过多时操作不流畅，限制事件个数来提高操作流畅性
        config.limtMoveCPS = config.limtMoveCPS == undefined ? 10 : config.limtMoveCPS;
        // 用户操作超时时间，当用户鼠标或触屏在该时间内没有产生操作，将首次提示用户，在exitTimeout后将断开连接来节约云渲染资源
        config.userTimeout = isNaN(config.userTimeout) ? 1000 * 60 * 5 : config.userTimeout;
        // 用户操作超时后的延迟断开时间，首次提示后的将过该时间后断开连接，在真正断开前可取消resetTimer();
        config.exitTimeout = isNaN(config.exitTimeout) ? 1000 * 10 : config.exitTimeout;
        // 当前断开后引擎需要保持的时间
        config.maxTimeout = isNaN(config.maxTimeout) ? 0 : config.maxTimeout;
        // 分辨率比率
        $self.pixelRatio = config.pixelRatio || 1;

        $self.config = config;
        config.video.oncontextmenu = (e) => { e.preventDefault(); };

        $self.finishEventObjMap = {};
        $self.eventMap = {};
        $self.event = new Proxy({}, {
            set: (target, property, fn) => {
                this.eventMap[property] || (this.eventMap[property] = []);
                this.eventMap[property].push(fn);
                return true;
            }
        });

        $self.isNativeApp = false;
        if (window.NativeAppLoad) {
            $self.isNativeApp = true;
            $self.reconnect = () => { };
            window.NativeAppLoad.then(() => {
                $self.checkVideoPos = function () {
                    var posInParent = [0, 0];
                    for (var win = window; win.self.frameElement; win = win.parent) {
                        let rectInParent = win.self.frameElement.getBoundingClientRect();
                        posInParent[0] += rectInParent.left;
                        posInParent[1] += rectInParent.top;
                    }
                    var p = $self.config.video.getBoundingClientRect();
                    var pos = [posInParent[0] + p.left, posInParent[1] + p.top];
                    window.NativeApp.EngineMgr.update($self.config.engineId, { pos: pos, visible: !$self.config.video.hidden });
                };
                window.NativeApp.EngineMgr.EventEngineStarted.connect((engineId, objId) => {
                    new QWebChannel(qt.webChannelTransport, function (channel) {
                        var obs = new ResizeObserver($self.checkVideoPos);
                        obs.observe($self.config.video);
                        for (var win = window; win.self.frameElement; win = win.parent) obs.observe(win.self.frameElement);
                        $self.Native = channel.objects[objId];
                        $self.objects = channel.objects;
                        window.NativeApp = {};
                        Object.assign(window.NativeApp, channel.objects);
                        window.webchannelDebug = $self.config.debug;
                        if ($self.Native.ControlChannel) {
                            $self._controlChannel = {
                                send: (buffer) => {
                                    var str = window.btoa(String.fromCharCode(...new Uint8Array(buffer)));
                                    $self.Native.ControlChannel.send(str);
                                }
                            };
                        }
                        else {
                            console.warn("Native not has ControlChannel");
                        }
                        console.info("Engine Native Loaded");
                        $self.finishEventObjMap["NativeLoad"] = $self.Native;
                        $self.emit("NativeLoad", $self.Native);
                    }, $self.config.logger);
                });
                window.NativeApp.EngineMgr.create($self.config.engineId, { visible: false });
                window.addEventListener("unload", () => {
                    window.NativeApp.EngineMgr.destory($self.config.engineId);
                });
            });
        }
        else {

            $self._ws = null;
            $self._pc = null;

            $self.resetTimer = function () {
                if ($self._pc && !$self.exited) {
                    clearTimeout($self._userTimer);
                    $self._userTimer = setTimeout(() => {
                        $self._userTimer = setTimeout(() => {
                            if (!$self.exited) {
                                $self.exit();
                                // console.log(`长时间没有操作，已断开连接`);
                                if (!$self.emit("TimeOutExit", $self)) {
                                    alert(`长时间没有操作，已断开连接`);
                                }
                            }
                        }, $self.config.exitTimeout);
                        $self.emit("UserTimeOut", $self);
                    }, $self.config.userTimeout);
                }
            };
            // 处理zip模式数据的函数
            function handleZipModeData(blob, player) {
                const startTime = performance.now();
                const reader = new FileReader();
                reader.onload = function (event) {
                    performance.now() - startTime;
                    // console.log(`[Zip模式] 文件读取完成，用时: ${fileReadTime.toFixed(2)}ms`);
                    const buffer = event.target.result;
                    const dataView = new DataView(buffer);
                    let offset = 0;

                    // 解析数据头
                    const width = dataView.getUint32(offset, true);
                    offset += 4;
                    const height = dataView.getUint32(offset, true);
                    offset += 4;
                    const imageFormat = dataView.getUint32(offset, true); // 0: RGB, 1: YUV420
                    offset += 4;
                    const blockCount = dataView.getUint32(offset, true);
                    offset += 4;

                    // console.log(`[Zip模式] 解析数据头: 宽度=${width}, 高度=${height}, 格式=${imageFormat}, 块数=${blockCount}`);

                    // 解析数据块
                    const decompressedData = [];
                    let totalOriginalSize = 0;
                    const totalDecompressStartTime = performance.now();

                    for (let i = 0; i < blockCount; i++) {
                        const originalSize = dataView.getUint32(offset, true);
                        offset += 4;
                        const compressedSize = dataView.getUint32(offset, true);
                        offset += 4;
                        const isCompressed = dataView.getUint32(offset, true);
                        offset += 4;

                        // 提取压缩数据
                        const compressedData = new Uint8Array(buffer, offset, compressedSize);
                        offset += compressedSize;

                        if (isCompressed === 1) {
                            try {
                                // 使用pako.inflate解压数据
                                const blockDecompressStartTime = performance.now();
                                const result = pako.inflate(compressedData);
                                const blockDecompressTime = performance.now() - blockDecompressStartTime;
                                decompressedData.push(result);
                                totalOriginalSize += originalSize;
                                // console.log(`[Zip模式] 解压块 ${i + 1}/${blockCount} 成功，用时: ${blockDecompressTime.toFixed(2)}ms`);
                            } catch (error) {
                                console.error(`[Zip模式] 解压块 ${i + 1}/${blockCount} 失败:`, error);
                                // 解压失败时使用原始压缩数据
                                decompressedData.push(compressedData);
                                totalOriginalSize += compressedSize;
                            }
                        } else {
                            // 不需要解压，直接使用
                            decompressedData.push(compressedData);
                            totalOriginalSize += compressedSize;
                        }
                    }

                    // 记录总解压用时
                    performance.now() - totalDecompressStartTime;
                    // console.log(`[Zip模式] 所有块解压完成，总用时: ${totalDecompressTime.toFixed(2)}ms`);

                    // 合并所有解压后的数据
                    const finalData = new Uint8Array(totalOriginalSize);
                    let finalOffset = 0;
                    for (let i = 0; i < decompressedData.length; i++) {
                        finalData.set(decompressedData[i], finalOffset);
                        finalOffset += decompressedData[i].length;
                    }

                    // 记录开始处理图像数据的时间
                    const imageProcessStartTime = performance.now();

                    // 根据图像格式处理数据
                    processImageData(finalData, width, height, imageFormat, player, imageProcessStartTime, startTime);
                };
                reader.readAsArrayBuffer(blob);
            }
            // 处理图像数据并显示
            function processImageData(data, width, height, format, player, imageProcessStartTime, startTime) {
                try {
                    // 检查数据完整性
                    if (!data || data.length === 0) {
                        console.error('[图像处理] 无效的图像数据');
                        return;
                    }
                    // console.log(`[图像处理] 图像数据长度: ${data.length}`);
                    // console.log(`[图像处理] 图像宽度: ${width}`);
                    // console.log(`[图像处理] 图像高度: ${height}`);
                    // console.log(`[图像处理] 图像格式: ${format}`);

                    if (format === 0) { // RGB格式
                        // 将RGB数据转换为ImageData
                        const canvasCreateStartTime = performance.now();
                        const canvas = document.createElement('canvas');
                        canvas.width = width;
                        canvas.height = height;
                        const ctx = canvas.getContext('2d');
                        const imageData = ctx.createImageData(width, height);
                        const pixels = imageData.data;
                        const canvasCreateTime = performance.now() - canvasCreateStartTime;
                        // console.log(`[图像处理] Canvas创建完成，用时: ${canvasCreateTime.toFixed(2)}ms`);

                        // 复制BGR数据到ImageData (注意：BGR转RGBA)
                        const conversionStartTime = performance.now();
                        for (let i = 0, j = 0; i < data.length; i += 3, j += 4) {
                            pixels[j] = data[i + 2];   // R (从BGR的第三个字节获取)
                            pixels[j + 1] = data[i + 1]; // G (保持不变)
                            pixels[j + 2] = data[i];   // B (从BGR的第一个字节获取)
                            pixels[j + 3] = 255;       // A
                        }
                        const conversionTime = performance.now() - conversionStartTime;
                        // console.log(`[图像处理] BGR转RGBA完成，用时: ${conversionTime.toFixed(2)}ms`);

                        const putImageDataStartTime = performance.now();
                        ctx.putImageData(imageData, 0, 0);
                        const putImageDataTime = performance.now() - putImageDataStartTime;
                        // console.log(`[图像处理] putImageData完成，用时: ${putImageDataTime.toFixed(2)}ms`);

                        // 记录图像处理完成的时间
                        const imageProcessTime = performance.now() - imageProcessStartTime;
                        // console.log(`[图像处理] 图像处理完成，用时: ${imageProcessTime.toFixed(2)}ms`);

                        // 将canvas转换为Blob并显示
                        const toBlobStartTime = performance.now();
                        // console.log(`[图像处理] 开始canvas.toBlob转换`);
                        canvas.toBlob(function (blob) {
                            const toBlobTime = performance.now() - toBlobStartTime;
                            // console.log(`[图像处理] canvas.toBlob完成，用时: ${toBlobTime.toFixed(2)}ms`);
                            const oldSrc = player.config.video.src;
                            player.config.video.src = URL.createObjectURL(blob);
                            if (oldSrc) URL.revokeObjectURL(oldSrc);
                            // 记录从开始到显示完成的总时间
                            const totalTime = performance.now() - startTime;
                            // console.log(`[Zip模式] 完整处理流程完成 - 总用时: ${totalTime.toFixed(2)}ms | Canvas创建: ${canvasCreateTime.toFixed(2)}ms | BGR转RGBA: ${conversionTime.toFixed(2)}ms | putImageData: ${putImageDataTime.toFixed(2)}ms | canvas.toBlob: ${toBlobTime.toFixed(2)}ms | 图像处理总耗时: ${imageProcessTime.toFixed(2)}ms`);
                        }, 'image/webp', 0.82);
                    } else if (format === 1) { // YUV420格式
                        // YUV420转RGB并显示
                        const rgbData = yuv420ToRgb(data, width, height);
                        const canvas = document.createElement('canvas');
                        canvas.width = width;
                        canvas.height = height;
                        const ctx = canvas.getContext('2d');
                        const imageData = ctx.createImageData(width, height);
                        imageData.data.set(rgbData);
                        ctx.putImageData(imageData, 0, 0);

                        canvas.toBlob(function (blob) {
                            const oldSrc = player.config.video.src;
                            player.config.video.src = URL.createObjectURL(blob);
                            if (oldSrc) URL.revokeObjectURL(oldSrc);
                            // 记录从开始到显示完成的总时间
                            const totalTime = performance.now() - startTime;
                            // console.log(`[Zip模式] 完整处理流程完成，总用时: ${totalTime.toFixed(2)}ms`);
                        }, 'image/webp', 0.82);
                        // console.log('[图像处理] YUV420格式图像显示成功');
                    }
                } catch (error) {
                    console.error(`[图像处理] 处理失败:`, error);
                }
            }

            // YUV420转RGB函数
            function yuv420ToRgb(yuvData, width, height) {
                const rgbData = new Uint8ClampedArray(width * height * 4);
                const ySize = width * height;
                const uvSize = ySize / 4;

                for (let y = 0; y < height; y++) {
                    for (let x = 0; x < width; x++) {
                        const yIndex = y * width + x;
                        const uIndex = ySize + Math.floor(y / 2) * Math.floor(width / 2) + Math.floor(x / 2);
                        const vIndex = ySize + uvSize + Math.floor(y / 2) * Math.floor(width / 2) + Math.floor(x / 2);

                        const Y = yuvData[yIndex];
                        const U = yuvData[uIndex] - 128;
                        const V = yuvData[vIndex] - 128;

                        // YUV到RGB的转换
                        const R = Math.clamp(Y + 1.402 * V, 0, 255);
                        const G = Math.clamp(Y - 0.344136 * U - 0.714136 * V, 0, 255);
                        const B = Math.clamp(Y + 1.772 * U, 0, 255);

                        const rgbIndex = yIndex * 4;
                        rgbData[rgbIndex] = R;
                        rgbData[rgbIndex + 1] = G;
                        rgbData[rgbIndex + 2] = B;
                        rgbData[rgbIndex + 3] = 255; // Alpha
                    }
                }

                return rgbData;
            }
            function configPeerConnection() {
                $self._controlChannel = null;

                var connectionCreator = RTCPeerConnection ? RTCPeerConnection : webkitRTCPeerConnection;
                $self._pc = new connectionCreator({ iceServers: $self.iceServers });

                $self._pc.onicecandidate = function (evt) {
                    if (evt.candidate !== null) {
                        $self._ws.send(JSON.stringify({
                            type: "IceCandidate",
                            data: evt.candidate
                        }));
                    }
                };

                $self._pc.ondatachannel = (evt) => {
                    // console.log("Get DataChannel", evt);
                    if (evt.channel && evt.channel.label == "Control") {
                        let checksend = () => {
                            while ($self._controlChannel.sendQueue.length > 0 && evt.channel.bufferedAmount <= evt.channel.bufferedAmountLowThreshold) {
                                evt.channel.send($self._controlChannel.sendQueue.shift());
                            }
                        };
                        $self._controlChannel = {
                            sendQueue: [],
                            send: (msg) => {
                                if (msg.length > evt.channel.bufferedAmountLowThreshold) {
                                    let pktCount = Math.ceil(msg.length / evt.channel.bufferedAmountLowThreshold);
                                    $self._controlChannel.sendQueue.push(`NEXT_COUNT:${pktCount}`);
                                    let s = 0;
                                    while (s < msg.length) {
                                        let e = s + Math.min(evt.channel.bufferedAmountLowThreshold, msg.length - evt.channel.bufferedAmountLowThreshold);
                                        $self._controlChannel.sendQueue.push(msg.slice(s, e));
                                        s = e;
                                    }
                                }
                                else {
                                    $self._controlChannel.sendQueue.push(msg);
                                }
                                checksend();
                            },
                            save: (data) => {
                                const connectMsg = JSON.stringify(data);
                                $self._ws.send(connectMsg);
                            }
                        };
                        evt.channel.bufferedAmountLowThreshold = 65536;
                        evt.channel.onbufferedamountlow = checksend;
                        evt.channel.onopen = () => {
                            new QWebChannel($self._controlChannel, function (channel) {
                                $self.Native = channel.objects.Native;
                                $self.objects = channel.objects;
                                console.info("Engine Native Loaded");
                                window.webchannelDebug = $self.config.debug;
                                $self.finishEventObjMap["NativeLoad"] = $self.Native;
                                $self.emit("NativeLoad", $self.Native);
                            }, $self.config.logger);
                        };

                        evt.channel.onclose = () => {
                            // console.log("Datachannel close");
                            $self._controlChannel = null;
                            $self.Native = null;
                            $self.nativeObjects = [];
                            $self.finishEventObjMap["NativeLoad"] = null;
                            $self.emit("Disconnected", "webrtc channel closed");
                        };

                        $self.config.video.buffers = [];
                        $self.config.video.strBuffer = "";
                        $self.config.video.strCount = 0;
                        let relay_jpg_req = new ArrayBuffer(4); // for request next frame;
                        let dataView = new DataView(relay_jpg_req);
                        dataView.setInt32(0, RemotePlayerMsgType.RELAY_JPG_REQ, true);
                        let lastImage = new Image();
                        evt.channel.onmessage = (event) => {
                            const max_data_channel_buffersize = 256 * 1024;
                            if (typeof (event.data) == "string") {
                                if ("function" == typeof ($self._controlChannel.onmessage)) { // setup by QWebChannel
                                    $self.config.video.strCount--;
                                    if ($self.config.video.strCount == -1) {
                                        if (event.data.startsWith("NEXT_COUNT:")) {
                                            $self.config.video.strCount = parseInt(event.data.substr(11));
                                        }
                                        else {
                                            $self.config.video.strCount = 0;
                                            $self._controlChannel.onmessage({ data: JSON.parse(event.data) });
                                        }
                                    }
                                    else {
                                        $self.config.video.strBuffer += event.data;
                                        if ($self.config.video.strCount == 0) {
                                            var allStr = $self.config.video.strBuffer;
                                            $self.config.video.strBuffer = "";
                                            $self._controlChannel.onmessage({ data: JSON.parse(allStr) });
                                        }
                                    }
                                }
                            }
                            else {
                                // 处理二进制数据
                                if ($self.config.isImage && $self.config.jpgQuality >= 200) {
                                    // zip模式数据处理
                                    // console.log("接收到zip模式数据块", event.data.byteLength);
                                    if (event.data.byteLength > 4) {
                                        $self.config.video.buffers.push(event.data);
                                    }
                                    if (event.data.byteLength < max_data_channel_buffersize) {
                                        if ($self.config.video.buffers.length > 0) {
                                            // 将收集的二进制数据合并为一个Blob并处理
                                            const combinedBlob = new Blob($self.config.video.buffers);
                                            $self.config.video.buffers = [];
                                            handleZipModeData(combinedBlob, $self);
                                        }
                                        if ($self._controlChannel && $self.config.video.tagName != 'VIDEO') {
                                            $self._controlChannel.send(relay_jpg_req);
                                        }
                                    }
                                } else {
                                    // 原有处理逻辑
                                    // console.log("接收到普通数据块", event.data.byteLength);
                                    if (event.data.byteLength > 4) {
                                        $self.config.video.buffers.push(event.data);
                                    }
                                    if (event.data.byteLength < max_data_channel_buffersize) {
                                        if ($self.config.video.buffers.length > 0) {
                                            var src = URL.createObjectURL(new Blob($self.config.video.buffers));
                                            $self.config.video.buffers = [];
                                            lastImage.src = src;
                                            lastImage.decode().then(() => {
                                                var oldSrc;
                                                if ($self.config.video.tagName == 'VIDEO') {
                                                    let stream = player.config.video.srcObject;
                                                    oldSrc = player.config.video.poster;
                                                    player.config.video.poster = src;
                                                    player.config.video.src = '';
                                                    player.config.video.srcObject = stream;
                                                }
                                                else // img
                                                {
                                                    if ($self._controlChannel) $self._controlChannel.send(relay_jpg_req);
                                                    oldSrc = $self.config.video.src;
                                                    $self.config.video.src = src;
                                                }
                                                if (oldSrc) URL.revokeObjectURL(oldSrc);
                                            })
                                                .catch((err) => {
                                                    if ($self._controlChannel && $self.config.video.tagName != 'VIDEO') $self._controlChannel.send(relay_jpg_req);
                                                    console.error(`decode image failed: ${err}`);
                                                    URL.revokeObjectURL(src);
                                                });
                                        }
                                        else {
                                            if ($self._controlChannel && $self.config.video.tagName != 'VIDEO') $self._controlChannel.send(relay_jpg_req);
                                        }
                                    }
                                }
                            }
                        };
                    }
                };

                $self._pc.ontrack = (evt) => {
                    // console.log("Get Remote Track", evt);
                    $self._pc._track = evt.track;
                    config.video.srcObject = evt.streams[0];
                    config.video.play();
                    $self.finishEventObjMap["VideoReady"] = $self.config.video;
                    $self.emit("VideoReady", $self.config.video);
                    $self.resetTimer();
                };

                $self._pc.onconnectionstatechange = (evt) => {
                    switch ($self._pc.connectionState) {
                        case "connecting": break;
                        case "connected": {
                            // console.log("peerconnection connected");
                            $self.emit("Connected");
                        } break;
                        case "disconnected": {
                            // console.log("peerconnection disconnected");
                            $self._pc.close();
                            $self.finishEventObjMap["NativeLoad"] = null;
                            $self.emit("Disconnected");
                        } break;
                        case "failed": {
                            // console.log("peerconnection connect failed");
                            $self._pc.close();
                            $self.emit("ConnectedFailed", evt);
                        } break;
                    }
                };
            }

            $self.reconnect = function () {
                if ($self.exited) return false;
                try {
                    $self._ws = new WebSocket(`${config.signalServer}?engineId=${config.engineId}&maxTimeout=${config.maxTimeout}&type=${config.isImage ? "img" : "video"}&rtcIni=${config.rtcIni}&jpgQuality=${config.jpgQuality}`);
                    $self._ws.onopen = function () { 
                        // console.log("signal websocket connected"); 
                    };
                    $self._ws.onerror = function (e) {
                        // console.log("signal websocket error", e);
                        $self.emit('Disconnected', "signal websocket error");
                    };
                    $self._ws.onmessage = function (msgData) {
                        msgData = msgData.data;
                        console.debug(msgData);
                        var msg = JSON.parse(msgData);

                        // 提示信息
                        if (msg.type == "Message") {
                            console.warn(msg.data);
                            if (!$self.emit("Message", msg.data)) {
                                alert(msg.data);
                            }
                        }
                        // 收到引擎会话的地址
                        else if (msg.type == "EngineWs") {
                            console.warn(msg.data);
                            $self.sessionWs = msg.data;
                            // console.log(`Get Engine session connection info: ${$self.sessionWs}`);
                            $self._engineWs = new WebSocket($self.sessionWs);
                            let transport = {
                                send: (msg) => {
                                    if ($self.config.debug && typeof msg == "string") // console.log(msg);
                                    $self._engineWs.send(msg);
                                }
                            };
                            $self._engineWs.onopen = () => {
                                // console.log(`Engine session connected`);
                                $self.emit("Connected");
                                new QWebChannel(transport, function (channel) {
                                    $self.Native = channel.objects.Native;
                                    $self.objects = channel.objects;
                                    console.info("Engine Native Loaded");
                                    window.webchannelDebug = $self.config.debug;
                                    $self.finishEventObjMap["NativeLoad"] = $self.Native;
                                    $self._controlChannel = {
                                        send: (buffer) => {
                                            var str = window.btoa(String.fromCharCode(...new Uint8Array(buffer)));
                                            $self.Native.ControlChannel.send(str);
                                        }
                                    };
                                    $self.emit("NativeLoad", $self.Native);
                                }, $self.config.logger);
                            };

                            $self._engineWs.onclose = () => {
                                $self._controlChannel = null;
                                $self.Native = null;
                                $self.nativeObjects = [];
                                $self.finishEventObjMap["NativeLoad"] = null;
                                $self.emit("Disconnected", "Engine session closed");
                            };

                            $self._engineWs.onmessage = (event) => {
                                if (typeof (event.data) == "string") {
                                    if ("function" == typeof transport.onmessage) { // setup by QWebChannel
                                        transport.onmessage({ data: JSON.parse(event.data) });
                                    }
                                }
                                else if (event.data instanceof Blob) {
                                    // 处理zip模式数据
                                    if ($self.config.isImage && $self.config.jpgQuality) {
                                        handleZipModeData(event.data, $self);
                                    } else {
                                        // 原有处理逻辑
                                        var oldSrc = $self.config.video.src;
                                        $self.config.video.src = URL.createObjectURL(event.data);
                                        if (oldSrc) URL.revokeObjectURL(oldSrc);
                                    }
                                }
                            };
                            // 处理zip模式数据的函数
                            function handleZipModeData(blob, player) {
                                const startTime = performance.now();
                                const reader = new FileReader();
                                reader.onload = function (event) {
                                    const fileReadTime = performance.now() - startTime;
                                    // console.log(`[Zip模式] 文件读取完成，用时: ${fileReadTime.toFixed(2)}ms`);
                                    const buffer = event.target.result;
                                    const dataView = new DataView(buffer);
                                    let offset = 0;

                                    // 解析数据头
                                    const width = dataView.getUint32(offset, true);
                                    offset += 4;
                                    const height = dataView.getUint32(offset, true);
                                    offset += 4;
                                    const imageFormat = dataView.getUint32(offset, true); // 0: RGB, 1: YUV420
                                    offset += 4;
                                    const blockCount = dataView.getUint32(offset, true);
                                    offset += 4;

                                    // console.log(`[Zip模式] 解析数据头: 宽度=${width}, 高度=${height}, 格式=${imageFormat}, 块数=${blockCount}`);

                                    // 解析数据块
                                    const decompressedData = [];
                                    let totalOriginalSize = 0;
                                    const totalDecompressStartTime = performance.now();

                                    for (let i = 0; i < blockCount; i++) {
                                        const originalSize = dataView.getUint32(offset, true);
                                        offset += 4;
                                        const compressedSize = dataView.getUint32(offset, true);
                                        offset += 4;
                                        const isCompressed = dataView.getUint32(offset, true);
                                        offset += 4;

                                        // 提取压缩数据
                                        const compressedData = new Uint8Array(buffer, offset, compressedSize);
                                        offset += compressedSize;

                                        if (isCompressed === 1) {
                                            try {
                                                // 使用pako.inflate解压数据
                                                const blockDecompressStartTime = performance.now();
                                                const result = pako.inflate(compressedData);
                                                const blockDecompressTime = performance.now() - blockDecompressStartTime;
                                                decompressedData.push(result);
                                                totalOriginalSize += originalSize;
                                                // console.log(`[Zip模式] 解压块 ${i + 1}/${blockCount} 成功，用时: ${blockDecompressTime.toFixed(2)}ms`);
                                            } catch (error) {
                                                console.error(`[Zip模式] 解压块 ${i + 1}/${blockCount} 失败:`, error);
                                                // 解压失败时使用原始压缩数据
                                                decompressedData.push(compressedData);
                                                totalOriginalSize += compressedSize;
                                            }
                                        } else {
                                            // 不需要解压，直接使用
                                            decompressedData.push(compressedData);
                                            totalOriginalSize += compressedSize;
                                        }
                                    }

                                    // 记录总解压用时
                                    const totalDecompressTime = performance.now() - totalDecompressStartTime;
                                    // console.log(`[Zip模式] 所有块解压完成，总用时: ${totalDecompressTime.toFixed(2)}ms`);

                                    // 合并所有解压后的数据
                                    const finalData = new Uint8Array(totalOriginalSize);
                                    let finalOffset = 0;
                                    for (let i = 0; i < decompressedData.length; i++) {
                                        finalData.set(decompressedData[i], finalOffset);
                                        finalOffset += decompressedData[i].length;
                                    }

                                    // 记录开始处理图像数据的时间
                                    const imageProcessStartTime = performance.now();

                                    // 根据图像格式处理数据
                                    processImageData(finalData, width, height, imageFormat, player, imageProcessStartTime, startTime);
                                };
                                reader.readAsArrayBuffer(blob);
                            }
                            // 处理图像数据并显示
                            function processImageData(data, width, height, format, player, imageProcessStartTime, startTime) {
                                try {
                                    // 检查数据完整性
                                    if (!data || data.length === 0) {
                                        console.error('[图像处理] 无效的图像数据');
                                        return;
                                    }
                                    // console.log(`格式: ${format}`);
                                    if (format === 0) { // RGB格式
                                        // 将RGB数据转换为ImageData
                                        const canvasCreateStartTime = performance.now();
                                        const canvas = document.createElement('canvas');
                                        canvas.width = width;
                                        canvas.height = height;
                                        const ctx = canvas.getContext('2d');
                                        const imageData = ctx.createImageData(width, height);
                                        const pixels = imageData.data;
                                        const canvasCreateTime = performance.now() - canvasCreateStartTime;
                                        // console.log(`[图像处理] Canvas创建完成，用时: ${canvasCreateTime.toFixed(2)}ms`);

                                        // 复制BGR数据到ImageData (注意：BGR转RGBA)
                                        const conversionStartTime = performance.now();
                                        for (let i = 0, j = 0; i < data.length; i += 3, j += 4) {
                                            pixels[j] = data[i + 2];   // R (从BGR的第三个字节获取)
                                            pixels[j + 1] = data[i + 1]; // G (保持不变)
                                            pixels[j + 2] = data[i];   // B (从BGR的第一个字节获取)
                                            pixels[j + 3] = 255;       // A
                                        }
                                        const conversionTime = performance.now() - conversionStartTime;
                                        // console.log(`[图像处理] BGR转RGBA完成，用时: ${conversionTime.toFixed(2)}ms`);

                                        const putImageDataStartTime = performance.now();
                                        ctx.putImageData(imageData, 0, 0);
                                        const putImageDataTime = performance.now() - putImageDataStartTime;
                                        // console.log(`[图像处理] putImageData完成，用时: ${putImageDataTime.toFixed(2)}ms`);

                                        // 记录图像处理完成的时间
                                        const imageProcessTime = performance.now() - imageProcessStartTime;
                                        // console.log(`[图像处理] 图像处理完成，用时: ${imageProcessTime.toFixed(2)}ms`);

                                        // 将canvas转换为Blob并显示
                                        const toBlobStartTime = performance.now();
                                        // console.log(`[图像处理] 开始canvas.toBlob转换`);
                                        canvas.toBlob(function (blob) {
                                            const toBlobTime = performance.now() - toBlobStartTime;
                                            // console.log(`[图像处理] canvas.toBlob完成，用时: ${toBlobTime.toFixed(2)}ms`);
                                            const oldSrc = player.config.video.src;
                                            player.config.video.src = URL.createObjectURL(blob);
                                            if (oldSrc) URL.revokeObjectURL(oldSrc);
                                            // 记录从开始到显示完成的总时间
                                            const totalTime = performance.now() - startTime;
                                            // console.log(`[Zip模式] 完整处理流程完成 - 总用时: ${totalTime.toFixed(2)}ms | Canvas创建: ${canvasCreateTime.toFixed(2)}ms | BGR转RGBA: ${conversionTime.toFixed(2)}ms | putImageData: ${putImageDataTime.toFixed(2)}ms | canvas.toBlob: ${toBlobTime.toFixed(2)}ms | 图像处理总耗时: ${imageProcessTime.toFixed(2)}ms`);
                                        }, 'image/webp', 0.82);
                                    } else if (format === 1) { // YUV420格式
                                        // YUV420转RGB并显示
                                        const rgbData = yuv420ToRgb(data, width, height);

                                        const canvas = document.createElement('canvas');
                                        canvas.width = width;
                                        canvas.height = height;
                                        const ctx = canvas.getContext('2d');
                                        const imageData = ctx.createImageData(width, height);
                                        imageData.data.set(rgbData);
                                        ctx.putImageData(imageData, 0, 0);

                                        // 记录图像处理完成的时间
                                        const imageProcessTime = performance.now() - imageProcessStartTime;
                                        // console.log(`[图像处理] 图像处理完成，用时: ${imageProcessTime.toFixed(2)}ms`);

                                        canvas.toBlob(function (blob) {
                                            const oldSrc = player.config.video.src;
                                            player.config.video.src = URL.createObjectURL(blob);
                                            if (oldSrc) URL.revokeObjectURL(oldSrc);
                                            // 记录从开始到显示完成的总时间
                                            const totalTime = performance.now() - startTime;
                                            // console.log(`[Zip模式] 完整处理流程完成，总用时: ${totalTime.toFixed(2)}ms`);
                                        }, 'image/webp', 0.82);
                                    }
                                } catch (error) {
                                    console.error(`[图像处理] 处理失败:`, error);
                                }
                            }

                            // YUV420转RGB函数
                            function yuv420ToRgb(yuvData, width, height) {
                                const rgbData = new Uint8ClampedArray(width * height * 4);
                                const ySize = width * height;
                                const uvSize = ySize / 4;

                                for (let y = 0; y < height; y++) {
                                    for (let x = 0; x < width; x++) {
                                        const yIndex = y * width + x;
                                        const uIndex = ySize + Math.floor(y / 2) * Math.floor(width / 2) + Math.floor(x / 2);
                                        const vIndex = ySize + uvSize + Math.floor(y / 2) * Math.floor(width / 2) + Math.floor(x / 2);

                                        const Y = yuvData[yIndex];
                                        const U = yuvData[uIndex] - 128;
                                        const V = yuvData[vIndex] - 128;

                                        // YUV到RGB的转换
                                        const R = Math.clamp(Y + 1.402 * V, 0, 255);
                                        const G = Math.clamp(Y - 0.344136 * U - 0.714136 * V, 0, 255);
                                        const B = Math.clamp(Y + 1.772 * U, 0, 255);

                                        const rgbIndex = yIndex * 4;
                                        rgbData[rgbIndex] = R;
                                        rgbData[rgbIndex + 1] = G;
                                        rgbData[rgbIndex + 2] = B;
                                        rgbData[rgbIndex + 3] = 255; // Alpha
                                    }
                                }

                                return rgbData;

                            }
                        }
                        // 收到连接引擎上线消息
                        else if (msg.type == "OpenSession") {
                            $self.iceServers = msg.data;
                            const connectMsg = JSON.stringify({
                                type: "ConnectRequest",
                                data: {}
                            });
                            $self._ws.send(connectMsg);
                        }
                        // 收到连接引擎回复
                        else if (msg.type == "OfferToClient") {
                            configPeerConnection();
                            var romoteSdp = new RTCSessionDescription(msg.data);
                            $self._pc.setRemoteDescription(romoteSdp).then(() => {
                                $self._pc.createAnswer().then((myDesc) => {
                                    var localSdp = new RTCSessionDescription(myDesc);
                                    $self._pc.setLocalDescription(localSdp).then(() => {
                                        $self._ws.send(JSON.stringify({
                                            type: "AnswerToEngine",
                                            data: localSdp
                                        }));
                                    }, (err) => { console.error("Set LocalDescription failed", err); });
                                }, (err) => { console.error("CreateAnswer failed", err); });
                            }, (err) => { console.error("Set RemoteDescription failed", err); });
                        }
                        // 收到IceCandidate消息
                        else if (msg.type === "IceCandidate") {
                            $self._pc.addIceCandidate(new RTCIceCandidate(msg.data));
                        }
                        // 收到关闭消息
                        else if (msg.type === "CloseSession") {
                            $self.exit();
                        }
                        else {
                            console.warn(`Un processed message ${msg.type}`, msg.data);
                            alert(`${msg.type}: ${msg.data}`);
                        }
                    };
                    return true;
                }
                catch (e) {
                    $self.emit("Disconnected", e);
                    return false;
                }
            };

            $self.startCheckSignal = function (tripTimeCb, packetsLostCb) {
                let maxPacketsLost = 0, lastPacketsLost = 0;
                let get = (sipCb, sfuCb) => {
                    if ($self._pc) {
                        $self._pc.getStats().then(function (report) {
                            report.forEach((value, key) => {
                                if (value.type === 'candidate-pair') {
                                    sipCb(value.currentRoundTripTime);
                                }
                                if (value.type == "inbound-rtp" || value.googContentType === 'realtime') {
                                    sfuCb(value.packetsLost);
                                }
                            });
                        });
                    }
                    else {
                        sipCb(99.999);
                        sfuCb(999999);
                    }
                };
                let lastTripTime, lastLost = -1;
                $self.watchSignalTimer = setInterval(() => {
                    get((tripTime) => {
                        if (lastTripTime != tripTime) {
                            lastTripTime = tripTime;
                            tripTimeCb(tripTime);
                        }
                    }, (packetsLost) => {
                        let lost = packetsLost - lastPacketsLost;
                        if (lost <= 0) maxPacketsLost = 0;
                        else if (lost > maxPacketsLost) maxPacketsLost = lost;
                        else lost = maxPacketsLost;
                        lastPacketsLost = packetsLost;
                        if (lost != lastLost) {
                            lastLost = lost;
                            packetsLostCb(lost);
                        }
                    });
                }, 1000);
            };

            $self.stopCheckSignalstartCheckSignal = function () {
                if ($self.watchSignalTimer) {
                    clearInterval($self.watchSignalTimer);
                    $self.watchSignalTimer = null;
                }
            };
        }

        // 初始化输入事件
        let style = getComputedStyle(config.video);
        let isMouseDown = false; // 用于全局监听判断鼠标是否按下
        let mouseDownInfo = {}; // 鼠标按下信息
        let keyList = []; // 键盘按键
        // 注册输入事件 
        if (!config.customInputEvent) {
            var events = {
                MouseMove: (e) => {
                    let x = e.offsetX / parseFloat(style.width) * 2 - 1;
                    let y = e.offsetY / parseFloat(style.height) * 2 - 1;
                    $self.mousemove(x, y);
                    e.preventDefault();
                },
                MouseDown: (e) => {
                    mouseDownInfo = e;
                    let x = e.offsetX / parseFloat(style.width) * 2 - 1;
                    let y = e.offsetY / parseFloat(style.height) * 2 - 1;
                    $self.mousedown(x, y, e.button);
                    isMouseDown = true;
                    e.preventDefault();
                },
                MouseUp: (e) => {
                    if (isMouseDown) {
                        mouseDownInfo = {};
                        let x = e.offsetX / parseFloat(style.width) * 2 - 1;
                        let y = e.offsetY / parseFloat(style.height) * 2 - 1;
                        $self.mouseup(x, y, e.button);
                        isMouseDown = false;
                        e.preventDefault();
                    }
                },
                MouseWheel: (e) => {
                    let x = e.offsetX / parseFloat(style.width) * 2 - 1;
                    let y = e.offsetY / parseFloat(style.height) * 2 - 1;
                    $self.mosuewheel(x, y, e.wheelDeltaY);
                    e.preventDefault();
                },
                MouseDBClick: (e) => {
                    let x = e.offsetX / parseFloat(style.width) * 2 - 1;
                    let y = e.offsetY / parseFloat(style.height) * 2 - 1;
                    $self.mousedbclick(x, y, e.button);
                    e.preventDefault();
                },
                TouchDown: (e) => {
                    let w = parseFloat(style.width);
                    let h = parseFloat(style.height);
                    let box = $self.config.video.getBoundingClientRect();
                    for (let i = 0; i < e.changedTouches.length; ++i) {
                        const t = e.changedTouches[i];
                        let x = (t.clientX - box.left) / w * 2 - 1;
                        let y = (t.clientY - box.top) / h * 2 - 1;
                        y = -y;
                        $self.touchdown(x, y, t.identifier);
                    }
                    e.preventDefault();
                },
                TouchUp: (e) => {
                    let w = parseFloat(style.width);
                    let h = parseFloat(style.height);
                    let box = $self.config.video.getBoundingClientRect();
                    for (let i = 0; i < e.changedTouches.length; ++i) {
                        const t = e.changedTouches[i];
                        let x = (t.clientX - box.left) / w * 2 - 1;
                        let y = (t.clientY - box.top) / h * 2 - 1;
                        y = -y;
                        $self.touchup(x, y, t.identifier);
                    }
                    e.preventDefault();
                },
                TouchMove: (e) => {
                    let w = parseFloat(style.width);
                    let h = parseFloat(style.height);
                    let box = $self.config.video.getBoundingClientRect();
                    for (let i = 0; i < e.changedTouches.length; ++i) {
                        const t = e.changedTouches[i];
                        let x = (t.clientX - box.left) / w * 2 - 1;
                        let y = (t.clientY - box.top) / h * 2 - 1;
                        y = -y;
                        $self.touchmove(x, y, t.identifier);
                    }
                    e.preventDefault();
                },
                KeyDown: (e) => {
                    if (e.target.localName.includes('input')) return
                    const keyIndex = keyList.findIndex(item => {
                        return item.keyCode === e.keyCode
                    });
                    if (keyIndex === -1) {
                        keyList.push(e);
                    }
                    $self.keydown(e.keyCode);
                },
                KeyUp: (e) => {
                    if (e.target.localName.includes('input')) return
                    const keyIndex = keyList.findIndex(item => {
                        return item.keyCode === e.keyCode
                    });
                    keyList.splice(keyIndex, 1);
                    $self.keyup(e.keyCode);
                },
                Blur: (e) => {
                    if (isMouseDown) {
                        let x = mouseDownInfo.offsetX / parseFloat(style.width) * 2 - 1;
                        let y = mouseDownInfo.offsetY / parseFloat(style.height) * 2 - 1;
                        $self.mouseup(x, y, mouseDownInfo.button);
                        isMouseDown = false;
                        mouseDownInfo = {};
                    }
                    for (let i = 0; i < keyList.length; i += 1) {
                        $self.keyup(keyList[i].keyCode);
                    }
                    keyList = [];
                }
            };
            if (config.limtMoveCPS > 0) {
                var limtFuns = (function () {
                    let mouse_x, mouse_y, mouse_hasChanged;
                    let touch_hasChanged, touch_moveList;
                    touch_moveList = new Map();
                    return {
                        mouse_intervalFun: () => {
                            if (mouse_hasChanged) {
                                mouse_hasChanged = false;
                                $self.mousemove(mouse_x, mouse_y);
                            }
                        },
                        mouse_moveFun: (evt) => {
                            mouse_x = evt.offsetX / parseFloat(style.width) * 2 - 1;
                            mouse_y = evt.offsetY / parseFloat(style.height) * 2 - 1;
                            mouse_hasChanged = true;
                        },
                        touch_intervalFun: () => {
                            if (touch_hasChanged) {
                                touch_hasChanged = false;
                                touch_moveList.forEach((v, k) => {
                                    $self.touchmove(v.x, v.y, k);
                                });
                                touch_moveList.clear();
                            }
                        },
                        touch_moveFun: (evt) => {
                            let w = parseFloat(style.width);
                            let h = parseFloat(style.height);
                            let box = $self.config.video.getBoundingClientRect();
                            for (let i = 0; i < evt.changedTouches.length; ++i) {
                                const t = evt.changedTouches[i];
                                let x = (t.clientX - box.left) / w * 2 - 1;
                                let y = (t.clientY - box.top) / h * 2 - 1;
                                y = -y;
                                var o = touch_moveList.get(t.identifier);
                                if (!o || o.x != x || o.y != y) {
                                    touch_moveList.set(t.identifier, { x: x, y: y });
                                    touch_hasChanged = true;
                                }
                            }
                        }
                    };
                })();

                var limtFunsMouseMoveInterval = setInterval(limtFuns.mouse_intervalFun, 1000 / config.limtMoveCPS);
                config.video.addEventListener("mousedown", (e) => {
                    clearInterval(limtFunsMouseMoveInterval);
                    limtFunsMouseMoveInterval = setInterval(limtFuns.mouse_intervalFun, 1000 / (config.limtMoveCPS * 2));
                });
                config.video.addEventListener("mouseup", (e) => {
                    if (e.buttons == 0) {
                        clearInterval(limtFunsMouseMoveInterval);
                        limtFunsMouseMoveInterval = setInterval(limtFuns.mouse_intervalFun, 1000 / config.limtMoveCPS);
                    }
                });
                config.video.addEventListener("mousemove", limtFuns.mouse_moveFun);

                var limtTouchMoveInterval;
                config.video.addEventListener("touchstart", (e) => {
                    limtFuns.touch_intervalFun(); // flush all mouse move event
                    if (!limtTouchMoveInterval) limtTouchMoveInterval = setInterval(limtFuns.touch_intervalFun, 1000 / (config.limtMoveCPS * 3));
                });
                config.video.addEventListener("touchend", (e) => {
                    limtFuns.touch_intervalFun(); // flush all mouse move event
                    if (e.buttons == 0) clearInterval(limtTouchMoveInterval);
                });
                config.video.addEventListener("touchmove", limtFuns.touch_moveFun, { passive: false });
            }
            else {
                config.video.addEventListener("mousemove", events.MouseMove);
                config.video.addEventListener("touchmove", events.TouchMove, { passive: false });
            }
            config.video.addEventListener("mousedown", events.MouseDown);
            config.video.addEventListener("mouseup", events.MouseUp);
            var win = window;
            // while (win.parent && win.parent != win) win = win.parent;
            win.addEventListener("mouseup", events.MouseUp);

            config.video.addEventListener("mousewheel", events.MouseWheel);
            config.video.addEventListener("dblclick", events.MouseDBClick);

            config.video.addEventListener("touchstart", events.TouchDown);
            config.video.addEventListener("touchend", events.TouchUp);

            win.addEventListener("keydown", events.KeyDown);
            win.addEventListener("keyup", events.KeyUp);
            win.addEventListener("blur", events.Blur);

            if (!$self.isNativeApp) {
                config.video.addEventListener("mousedown", $self.resetTimer);
                config.video.addEventListener("mousemove", $self.resetTimer);
                config.video.addEventListener("mouseup", $self.resetTimer);
                config.video.addEventListener("mousewheel", $self.resetTimer);
                config.video.addEventListener("touchstart", $self.resetTimer);
                config.video.addEventListener("touchmove", $self.resetTimer);
                config.video.addEventListener("touchend", $self.resetTimer);
            }
        }

        if (config.autoResize) {
            setInterval((function () {
                let videoWidth, videoHeight;
                return function (force) {
                    const devicePixelRatio =  window.devicePixelRatio || 1;
                    let width = Math.round(parseFloat(style.width)*devicePixelRatio*$self.pixelRatio);
                    let height = Math.round(parseFloat(style.height)*devicePixelRatio*$self.pixelRatio);
                    if (force || videoWidth != width || videoHeight != height) {
                        if ($self.resize(width, height)) {
                            videoWidth = width;
                            videoHeight = height;
                        }
                    }
                }
            }()), 100);
        }

        $self.reconnect();
    }

    RemotePlayer.prototype.constructor = RemotePlayer;

    // for event system
    RemotePlayer.prototype.on = function (name, fn) {
        this.event[name] = fn;
        var arg = this.finishEventObjMap[name];
        if (arg) fn(arg);
    };
    RemotePlayer.prototype.off = function (name) { delete this.eventMap[name]; };
    RemotePlayer.prototype.emit = function (name, ...val) {
        if (this.eventMap[name] && this.eventMap[name].length > 0) this.eventMap[name].forEach(fn => { fn(...val); });
        else return false;
        return true;
    };

    // send mousemove event
    RemotePlayer.prototype.mousemove = (function () {
        let buffer = new ArrayBuffer(12);
        let dataView = new DataView(buffer);
        dataView.setInt32(0, RemotePlayerMsgType.MouseMove, true);
        return function (x, y) {
            if (this._controlChannel) {
                dataView.setFloat32(4, x, true);
                dataView.setFloat32(8, -y, true);
                this._controlChannel.send(buffer);
                // console.debug(`MouseMove: [${x}, ${-y}]`);
                return true;
            }
            return false;
        }
    }());

    // send mousedown event
    RemotePlayer.prototype.mousedown = (function () {
        let buffer = new ArrayBuffer(16);
        let dataView = new DataView(buffer);
        dataView.setInt32(0, RemotePlayerMsgType.MouseDown, true);
        return function (x, y, btn) {
            if (this._controlChannel) {
                dataView.setFloat32(4, x, true);
                dataView.setFloat32(8, -y, true);
                dataView.setInt32(12, btn, true);
                this._controlChannel.send(buffer);
                // console.debug(`MouseDown: [${btn}, ${x}, ${-y}]`);
                return true;
            }
            return false;
        }
    }());

    // send mouseup event
    RemotePlayer.prototype.mouseup = (function () {
        let buffer = new ArrayBuffer(16);
        let dataView = new DataView(buffer);
        dataView.setInt32(0, RemotePlayerMsgType.MouseUp, true);
        return function (x, y, btn) {
            if (this._controlChannel) {
                dataView.setFloat32(4, x, true);
                dataView.setFloat32(8, -y, true);
                dataView.setInt32(12, btn, true);
                this._controlChannel.send(buffer);
                // console.debug(`MouseUp:${btn} [${x}, ${-y}]`);
                return true;
            }
            return false;
        }
    }());

    // send mousewheel event
    RemotePlayer.prototype.mosuewheel = (function () {
        let buffer = new ArrayBuffer(16);
        let dataView = new DataView(buffer);
        dataView.setInt32(0, RemotePlayerMsgType.MouseWheel, true);
        return function (x, y, delta) {
            if (this._controlChannel) {
                dataView.setFloat32(4, x, true);
                dataView.setFloat32(8, -y, true);
                dataView.setInt32(12, delta, true);
                this._controlChannel.send(buffer);
                // console.debug(`MouseWheel:${delta} [${x}, ${-y}]`);
                return true;
            }
            return false;
        }
    }());

    // send mousedbclick event
    RemotePlayer.prototype.mousedbclick = (function () {
        let buffer = new ArrayBuffer(16);
        let dataView = new DataView(buffer);
        dataView.setInt32(0, RemotePlayerMsgType.MouseDBClick, true);
        return function (x, y, btn) {
            if (this._controlChannel) {
                dataView.setFloat32(4, x, true);
                dataView.setFloat32(8, -y, true);
                dataView.setInt32(12, btn, true);
                this._controlChannel.send(buffer);
                // console.debug(`MouseDBClick:${btn} [${x}, ${-y}]`);
                return true;
            }
            return false;
        }
    }());

    // send resize event
    RemotePlayer.prototype.resize = (function () {
        let buffer = new ArrayBuffer(16);
        let dataView = new DataView(buffer);
        dataView.setInt32(0, RemotePlayerMsgType.WindowSize, true);
        return function (w, h) {
            if (this._controlChannel && w >= 64 && h >= 64) {
                w = Math.ceil(w / 2.0) * 2.0;
                h = Math.ceil(h / 2.0) * 2.0;
                dataView.setFloat32(4, w, true);
                dataView.setFloat32(8, h, true);
                dataView.setInt32(12, 96/*DPI*/, true);
                this._controlChannel.send(buffer);
                // console.debug(`WindowSize: [${w}, ${h}]`);
                return true;
            }
            return false;
        }
    }());

    // send touchdown event
    RemotePlayer.prototype.touchdown = (function () {
        let buffer = new ArrayBuffer(16);
        let dataView = new DataView(buffer);
        dataView.setInt32(0, RemotePlayerMsgType.TouchDown, true);
        return function (x, y, id) {
            if (this._controlChannel) {
                dataView.setFloat32(4, x, true);
                dataView.setFloat32(8, -y, true);
                dataView.setInt32(12, id, true);
                this._controlChannel.send(buffer);
                // console.debug(`TouchDown:${id} [${x}, ${-y}]`);
                return true;
            }
            return false;
        }
    })();

    // send touchup event
    RemotePlayer.prototype.touchup = (function () {
        let buffer = new ArrayBuffer(16);
        let dataView = new DataView(buffer);
        dataView.setInt32(0, RemotePlayerMsgType.TouchUp, true);
        return function (x, y, id) {
            if (this._controlChannel) {
                dataView.setFloat32(4, x, true);
                dataView.setFloat32(8, -y, true);
                dataView.setInt32(12, id, true);
                this._controlChannel.send(buffer);
                // console.debug(`TouchUp:${id} [${x}, ${-y}]`);
                return true;
            }
            return false;
        }
    })();

    // send touchmove event
    RemotePlayer.prototype.touchmove = (function () {
        let buffer = new ArrayBuffer(16);
        let dataView = new DataView(buffer);
        dataView.setInt32(0, RemotePlayerMsgType.TouchMove, true);
        return function (x, y, id) {
            if (this._controlChannel) {
                dataView.setFloat32(4, x, true);
                dataView.setFloat32(8, -y, true);
                dataView.setInt32(12, id, true);
                this._controlChannel.send(buffer);
                // console.debug(`TouchMove:${id} [${x}, ${-y}]`);
                return true;
            }
            return false;
        }
    })();

    // send keydown event
    RemotePlayer.prototype.keydown = (function () {
        let buffer = new ArrayBuffer(8);
        let dataView = new DataView(buffer);
        dataView.setInt32(0, RemotePlayerMsgType.KeyDown, true);
        return function (keycode) {
            if (this._controlChannel) {
                dataView.setInt32(4, keycode, true);
                this._controlChannel.send(buffer);
                // console.debug(`KeyDown:${keycode}`);
                return true;
            }
            return false;
        }
    })();

    // send keyup event
    RemotePlayer.prototype.keyup = (function () {
        let buffer = new ArrayBuffer(8);
        let dataView = new DataView(buffer);
        dataView.setInt32(0, RemotePlayerMsgType.KeyUp, true);
        return function (keycode) {
            if (this._controlChannel) {
                dataView.setInt32(4, keycode, true);
                this._controlChannel.send(buffer);
                // console.debug(`KeyUp:${keycode}`);
                return true;
            }
            return false;
        }
    })();

    // send exit event
    RemotePlayer.prototype.exit = (function () {
        let buffer = new ArrayBuffer(4);
        let dataView = new DataView(buffer);
        dataView.setInt32(0, RemotePlayerMsgType.Exit, true);
        return function () {
            clearTimeout(this._userTimer);
            if (this._controlChannel) {
                this._controlChannel.send(buffer);
                this._controlChannel = null;
            }
            if (this._ws) {
                this._ws.close();
                this._ws = null;
            }
            if (this._pc) {
                this._pc.close();
                this._pc = null;
            }
            if (!this.exited) {
                this.exited = true;
                console.info("Exit");
            }
            return true;
        }
    })();

    RemotePlayer.prototype.snapshot = function () {
        var canvas = document.createElement("canvas");
        canvas.width = this.config.video.width | this.config.video.videoWidth;
        canvas.height = this.config.video.height | this.config.video.videoHeight;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(this.config.video, 0, 0, canvas.width, canvas.height);
        var img = document.createElement("img");
        img.src = canvas.toDataURL("image/jpeg", 1);
        img.save = function () {
            var alink = document.createElement("a");
            alink.href = img.src;
            alink.download = "snapshot.jpg";
            alink.click();
        };
        return img;
    };

    var commonAbstractClass = /** @class */ (function () {
        function commonAbstractClass() {
        }
        return commonAbstractClass;
    }());

    var baseWrap = /** @class */ (function () {
        function baseWrap(data, type, parent) {
            var _a;
            /** 详细信息 */
            this.dataInfo = null;
            this.isDeleteInstance = true;
            this.setDataInfo(data);
            this.parentData = parent;
            this.category = type;
            this.id = (_a = data.id) !== null && _a !== void 0 ? _a : generateUUID();
        }
        baseWrap.prototype.destroyInstance = function () {
            var _a, _b, _c;
            return __awaiter$1(this, void 0, void 0, function () {
                var _d;
                return __generator$1(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            _d = this.category;
                            switch (_d) {
                                case cacheType.GIS | cacheType.ElectoronicRail: return [3 /*break*/, 1];
                                case cacheType.Marker: return [3 /*break*/, 3];
                                case cacheType.Clip: return [3 /*break*/, 5];
                                case cacheType.Route: return [3 /*break*/, 7];
                                case cacheType.Animation: return [3 /*break*/, 8];
                                case cacheType.DroneNode: return [3 /*break*/, 10];
                                case cacheType.Particle: return [3 /*break*/, 11];
                            }
                            return [3 /*break*/, 13];
                        case 1: return [4 /*yield*/, ((_a = this.dataInfo) === null || _a === void 0 ? void 0 : _a.instance.destroyInstance())];
                        case 2:
                            _e.sent();
                            return [3 /*break*/, 14];
                        case 3: return [4 /*yield*/, this.dataInfo.instance.destroyInstance(this.dataInfo)];
                        case 4:
                            _e.sent();
                            return [3 /*break*/, 14];
                        case 5: return [4 /*yield*/, this.dataInfo.instance.destroyInstance()];
                        case 6:
                            _e.sent();
                            return [3 /*break*/, 14];
                        case 7:
                            this.dataInfo.instance.destroyInstance(this.dataInfo);
                            return [3 /*break*/, 14];
                        case 8: return [4 /*yield*/, this.dataInfo.instance.destroyInstance(this.dataInfo)];
                        case 9:
                            _e.sent();
                            return [3 /*break*/, 14];
                        case 10:
                            (_b = this.dataInfo.instance) === null || _b === void 0 ? void 0 : _b.destroyInstance(this.dataInfo);
                            return [3 /*break*/, 14];
                        case 11: return [4 /*yield*/, ((_c = this.dataInfo.instance) === null || _c === void 0 ? void 0 : _c.destroyInstance(this.dataInfo))];
                        case 12:
                            _e.sent();
                            return [3 /*break*/, 14];
                        case 13: return [3 /*break*/, 14];
                        case 14: return [2 /*return*/];
                    }
                });
            });
        };
        /** 获取信息 */
        baseWrap.prototype.getDataInfo = function () {
            return this.dataInfo;
        };
        /** 设置信息 */
        baseWrap.prototype.setDataInfo = function (data) {
            var _a;
            this.dataInfo = data;
            this.id = (_a = data.id) !== null && _a !== void 0 ? _a : generateUUID();
        };
        /** 获取父类数据 */
        baseWrap.prototype.getParentData = function () {
            return this.parentData;
        };
        /** 设置父类数据 */
        baseWrap.prototype.setParentData = function (data) {
            this.parentData = data;
        };
        return baseWrap;
    }());

    var Engine = /** @class */ (function (_super) {
        __extends$1(Engine, _super);
        function Engine(cacheManagement, dispatch) {
            var _this = _super.call(this) || this;
            _this.player = null;
            _this.playerInstance = null;
            _this.normalDisconnect = false;
            _this.documentParam = { createElement: function () { } };
            _this.logCounter = 0;
            _this.dispatch = dispatch;
            _this.cacheManagement = cacheManagement;
            Engine.instance = _this;
            return _this;
        }
        Engine.prototype.initDocument = function () {
            return __awaiter$1(this, void 0, void 0, function () {
                var jsdom;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            return [3 /*break*/, 2];
                        case 1:
                            jsdom = _a.sent();
                            this.documentParam = new jsdom.JSDOM().window.document;
                            return [3 /*break*/, 3];
                        case 2:
                            this.documentParam = document;
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        Engine.prototype.destroyInstance = function () {
        };
        Engine.prototype.openDatabase = function () {
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_a) {
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            var request = indexedDB.open('LogDatabase', 1);
                            request.onupgradeneeded = function (event) {
                                var db = event.target.result;
                                var store = db.createObjectStore('logs', { keyPath: 'id' });
                                store.createIndex('orderIndex', 'order', { unique: false });
                            };
                            request.onsuccess = function (event) {
                                resolve(event.target.result);
                            };
                            request.onerror = function (event) {
                                reject(event.target.error);
                            };
                        })];
                });
            });
        };
        Engine.prototype.clearOldLogs = function (db) {
            return __awaiter$1(this, void 0, void 0, function () {
                var transaction, store, index;
                return __generator$1(this, function (_a) {
                    transaction = db.transaction('logs', 'readwrite');
                    store = transaction.objectStore('logs');
                    index = store.index('orderIndex');
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            // 获取记录总数
                            var countRequest = store.count();
                            countRequest.onsuccess = function () {
                                if (countRequest.result > 1000) {
                                    // 如果超过1000条，获取需要删除的旧记录
                                    var request = index.openCursor(null, 'next');
                                    var deleteCount_1 = 0;
                                    var toDelete_1 = countRequest.result - 1000;
                                    request.onsuccess = function (event) {
                                        var cursor = event.target.result;
                                        if (cursor && deleteCount_1 < toDelete_1) {
                                            store.delete(cursor.primaryKey);
                                            deleteCount_1++;
                                            cursor.continue();
                                        }
                                        else {
                                            resolve();
                                        }
                                    };
                                }
                                else {
                                    resolve();
                                }
                            };
                            countRequest.onerror = function () { return reject(); };
                        })];
                });
            });
        };
        Engine.prototype.storeLog = function (log, order) {
            return __awaiter$1(this, void 0, void 0, function () {
                var db, transaction_1, store, logWithOrder, error_1;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 4, , 5]);
                            return [4 /*yield*/, this.openDatabase()];
                        case 1:
                            db = _a.sent();
                            transaction_1 = db.transaction('logs', 'readwrite');
                            store = transaction_1.objectStore('logs');
                            logWithOrder = __assign$2(__assign$2({}, log), { id: order, order: order });
                            return [4 /*yield*/, store.add(logWithOrder)];
                        case 2:
                            _a.sent();
                            // 清理旧日志
                            return [4 /*yield*/, this.clearOldLogs(db)];
                        case 3:
                            // 清理旧日志
                            _a.sent();
                            return [2 /*return*/, new Promise(function (resolve, reject) {
                                    transaction_1.oncomplete = function () { return resolve(true); };
                                    transaction_1.onerror = function () { return reject(transaction_1.error); };
                                })];
                        case 4:
                            error_1 = _a.sent();
                            console.error('Error storing log:', error_1);
                            throw error_1;
                        case 5: return [2 /*return*/];
                    }
                });
            });
        };
        Engine.prototype.storeLogsInOrder = function (sdkArr) {
            return __awaiter$1(this, void 0, void 0, function () {
                var db, transaction_2, store_1, logsWithOrder, error_2;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 3, , 4]);
                            return [4 /*yield*/, this.openDatabase()];
                        case 1:
                            db = _a.sent();
                            transaction_2 = db.transaction('logs', 'readwrite');
                            store_1 = transaction_2.objectStore('logs');
                            logsWithOrder = sdkArr.map(function (log, index) { return (__assign$2(__assign$2({}, log), { order: index })); });
                            return [4 /*yield*/, Promise.all(logsWithOrder.map(function (log) {
                                    return new Promise(function (resolve, reject) {
                                        var request = store_1.add(log);
                                        request.onsuccess = function () { return resolve(true); };
                                        request.onerror = function () { return reject(request.error); };
                                    });
                                }))];
                        case 2:
                            _a.sent();
                            return [2 /*return*/, new Promise(function (resolve, reject) {
                                    transaction_2.oncomplete = function () {
                                        resolve(true);
                                    };
                                    transaction_2.onerror = function () { return reject(transaction_2.error); };
                                })];
                        case 3:
                            error_2 = _a.sent();
                            console.error('Error storing logs:', error_2);
                            throw error_2;
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        Engine.prototype.readLogs = function () {
            return __awaiter$1(this, void 0, void 0, function () {
                var db, transaction, store, index_1, error_3;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.openDatabase()];
                        case 1:
                            db = _a.sent();
                            transaction = db.transaction('logs', 'readonly');
                            store = transaction.objectStore('logs');
                            index_1 = store.index('orderIndex');
                            return [2 /*return*/, new Promise(function (resolve, reject) {
                                    var logs = [];
                                    var request = index_1.openCursor(null, 'prev');
                                    request.onsuccess = function (event) {
                                        var cursor = event.target.result;
                                        if (cursor) {
                                            logs.push(cursor.value);
                                            cursor.continue();
                                        }
                                        else {
                                            resolve(logs);
                                        }
                                    };
                                    request.onerror = function () { return reject(request.error); };
                                })];
                        case 2:
                            error_3 = _a.sent();
                            console.error('Error reading logs:', error_3);
                            throw error_3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        Engine.prototype.initLogCounter = function () {
            return __awaiter$1(this, void 0, void 0, function () {
                var db, transaction, store, index_2, error_4;
                var _this = this;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.openDatabase()];
                        case 1:
                            db = _a.sent();
                            transaction = db.transaction('logs', 'readonly');
                            store = transaction.objectStore('logs');
                            index_2 = store.index('orderIndex');
                            return [2 /*return*/, new Promise(function (resolve) {
                                    // 获取最大的 order 值
                                    var request = index_2.openCursor(null, 'prev');
                                    request.onsuccess = function (event) {
                                        var cursor = event.target.result;
                                        if (cursor) {
                                            // 将 logCounter 设置为最大 order + 1
                                            _this.logCounter = cursor.value.order + 1;
                                            resolve(_this.logCounter);
                                        }
                                        else {
                                            // 如果没有记录，从 0 开始
                                            _this.logCounter = 0;
                                            resolve(0);
                                        }
                                    };
                                    request.onerror = function () {
                                        _this.logCounter = 0;
                                        resolve(0);
                                    };
                                })];
                        case 2:
                            error_4 = _a.sent();
                            console.error('Error initializing log counter:', error_4);
                            this.logCounter = 0;
                            return [2 /*return*/, 0];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * @description: 加载引擎
         * @param {ILoadEngineParameter} paramData 引擎的配置项
         * @return {Promise<IResponse<IPlayer>>} 成功返回player实例
         */
        Engine.prototype.loadEngine = function (paramData) {
            var _this = this;
            return new Promise(function (resolve, reject) { return __awaiter$1(_this, void 0, void 0, function () {
                var video, imgDom, videoDom, sdkArr, reconnect, reconnectTimer // 重新连接的定时器
                , reconnectTime, engineId, config, player;
                var _this = this;
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
                return __generator$1(this, function (_p) {
                    switch (_p.label) {
                        case 0: return [4 /*yield*/, this.initDocument()];
                        case 1:
                            _p.sent();
                            return [4 /*yield*/, this.initLogCounter()];
                        case 2:
                            _p.sent();
                            if (this.player && checkPlayerLoad(this.player) && this.playerInstance) {
                                this.player.exit();
                                this.cacheManagement.deleteCache(this.playerInstance);
                            }
                            // 判断dom类型
                            if (paramData.options && paramData.options.DomType === EDomType.img) {
                                if (!((_a = paramData.options) === null || _a === void 0 ? void 0 : _a.imgDom)) {
                                    imgDom = this.documentParam.createElement("img");
                                    video = imgDom;
                                }
                                else {
                                    video = paramData.options.imgDom;
                                }
                            }
                            else {
                                if (!((_b = paramData.options) === null || _b === void 0 ? void 0 : _b.videoDom)) {
                                    videoDom = this.documentParam.createElement('video');
                                    videoDom.autoplay = true;
                                    videoDom.muted = true;
                                    videoDom.id = "playerEngineId_".concat(generateUUID());
                                    video = videoDom;
                                }
                                else {
                                    video = (_c = paramData.options) === null || _c === void 0 ? void 0 : _c.videoDom;
                                }
                            }
                            sdkArr = [];
                            this.normalDisconnect = false;
                            reconnect = false // 是否正在重新连接
                            ;
                            reconnectTime = 0 // 重连次数
                            ;
                            engineId = ((_d = paramData === null || paramData === void 0 ? void 0 : paramData.options) === null || _d === void 0 ? void 0 : _d.engineId) || generateUUID();
                            config = {
                                video: video,
                                signalServer: paramData.signalServer,
                                engineId: engineId,
                                autoResize: true,
                                userTimeout: ((_e = paramData === null || paramData === void 0 ? void 0 : paramData.options) === null || _e === void 0 ? void 0 : _e.userTimeout) || 3600000,
                                exitTimeout: ((_f = paramData === null || paramData === void 0 ? void 0 : paramData.options) === null || _f === void 0 ? void 0 : _f.exitTimeout) || 60000,
                                maxTimeout: ((_g = paramData === null || paramData === void 0 ? void 0 : paramData.options) === null || _g === void 0 ? void 0 : _g.maxTimeout) || 1000,
                                debug: ((_h = paramData === null || paramData === void 0 ? void 0 : paramData.options) === null || _h === void 0 ? void 0 : _h.openDebug) || false,
                                rtcIni: ((_j = paramData === null || paramData === void 0 ? void 0 : paramData.options) === null || _j === void 0 ? void 0 : _j.rtcIni) || 'rtc.ini',
                                limtMoveCPS: ((_k = paramData === null || paramData === void 0 ? void 0 : paramData.options) === null || _k === void 0 ? void 0 : _k.limtMoveCPS) || 10,
                                pixelRatio: ((_l = paramData === null || paramData === void 0 ? void 0 : paramData.options) === null || _l === void 0 ? void 0 : _l.pixelRatio) || 1,
                                logger: {
                                    onRequest: function (cmdId, request, args) { return __awaiter$1(_this, void 0, void 0, function () {
                                        var time, obj;
                                        var _a;
                                        return __generator$1(this, function (_b) {
                                            switch (_b.label) {
                                                case 0:
                                                    time = new Date().toISOString();
                                                    obj = {
                                                        key: cmdId,
                                                        method: request,
                                                        time: time,
                                                        // id:time,
                                                        args: JSON.stringify(args),
                                                        type: 'request',
                                                        engineId: engineId
                                                    };
                                                    sdkArr.unshift(obj);
                                                    // this.player?._controlChannel.save(obj)
                                                    if ((_a = paramData === null || paramData === void 0 ? void 0 : paramData.options) === null || _a === void 0 ? void 0 : _a.openDebug)
                                                        console.debug(time + "  NativeRequest:{\"id\":".concat(cmdId, "}, \"method\": \"").concat(request, "\""), args);
                                                    return [4 /*yield*/, this.storeLog(obj, this.logCounter++)];
                                                case 1:
                                                    _b.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); },
                                    onResponse: function (cmdId, ret) { return __awaiter$1(_this, void 0, void 0, function () {
                                        var time, obj;
                                        var _a;
                                        return __generator$1(this, function (_b) {
                                            switch (_b.label) {
                                                case 0:
                                                    time = new Date().toISOString();
                                                    obj = {
                                                        key: cmdId,
                                                        time: time,
                                                        // id:time,
                                                        data: JSON.stringify(ret),
                                                        type: 'response',
                                                        engineId: engineId
                                                    };
                                                    sdkArr.unshift(obj);
                                                    // this.player?._controlChannel.save(obj)
                                                    if ((_a = paramData === null || paramData === void 0 ? void 0 : paramData.options) === null || _a === void 0 ? void 0 : _a.openDebug)
                                                        console.debug(time + " NativeResponse:{\"id\":".concat(cmdId, "}"), ret);
                                                    return [4 /*yield*/, this.storeLog(obj, this.logCounter++)];
                                                case 1:
                                                    _b.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); },
                                    onConnectSignal: function (idx, signalName, callback) {
                                        // console.log(`${new Date()} signalConnect: {"method": "${signalName}", "id":${idx}}`, callback)
                                    },
                                    onDisconnectSignal: function (idx, signalName, callback) {
                                        // console.log(`${new Date()} signalDisconnect: {"method": "${signalName}", "id":${idx}}`, callback)
                                    },
                                    onSignal: function (signalName, args) {
                                        // console.log(`${new Date()} signalEmitted: {"method": "${signalName}"}`, args)
                                    },
                                },
                            };
                            if ((_m = paramData === null || paramData === void 0 ? void 0 : paramData.options) === null || _m === void 0 ? void 0 : _m.jpgQuality) {
                                config.jpgQuality = (_o = paramData === null || paramData === void 0 ? void 0 : paramData.options) === null || _o === void 0 ? void 0 : _o.jpgQuality;
                            }
                            player = new RemotePlayer(config);
                            // 监听连接成功消息
                            player.on('Connected', function () { });
                            // 监听消息
                            player.on('Message', function (res) {
                                if (res && res.includes('没有空闲的节点')) {
                                    reject(res);
                                    alert(res);
                                }
                            });
                            // 监听连接失败消息
                            player.on('Disconnected', function (e) { return __awaiter$1(_this, void 0, void 0, function () {
                                var _this = this;
                                return __generator$1(this, function (_a) {
                                    if (sdkArr.length > 1000) {
                                        sdkArr.splice(1000);
                                    }
                                    // 连接断开尝试重连
                                    if (e === 'signal websocket error') {
                                        reconnect = true;
                                        player.reconnect();
                                        if (reconnectTimer) {
                                            clearInterval(reconnectTimer);
                                        }
                                        reconnectTimer = setInterval(function () {
                                            if (reconnectTime < config.maxTimeout / 1000 && reconnect) {
                                                reconnectTime += 1;
                                            }
                                            else {
                                                player.exit();
                                                _this.dispatch.emit('EngineInside', {
                                                    status: false,
                                                });
                                                clearInterval(reconnectTimer);
                                                _this.dispatch.emit("Engine", {
                                                    type: "Disconnected",
                                                    message: "多次重连失败"
                                                });
                                                reject(e);
                                            }
                                        }, 1000);
                                    }
                                    if (!this.normalDisconnect) {
                                        this.normalDisconnect = true;
                                        // 报错  储存错误信息
                                        Logger$1.interfaceError(config.engineId);
                                    }
                                    return [2 /*return*/];
                                });
                            }); });
                            // 监听引擎断开，跟UserTimeOut不同之处是，这个是已经退出的消息，不能取消
                            player.on('TimeOutExit', function () {
                                _this.dispatch.emit("Engine", {
                                    type: "TimeOutExit",
                                    message: "连接已经断开"
                                });
                            });
                            // usertimeout,引擎接收鼠标事件超时发出的通知
                            player.on('UserTimeOut', function () {
                                _this.dispatch.emit("Engine", {
                                    type: "UserTimeOut",
                                    message: "用户操作超时"
                                });
                            });
                            // 远程调用加载完成通知，可以调用Native中的方法了
                            player.on('NativeLoad', function (Native) { return __awaiter$1(_this, void 0, void 0, function () {
                                return __generator$1(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            // 重连不需要再次执行native加载成功的方法
                                            if (reconnect) {
                                                reconnect = false;
                                                reconnectTime = 0;
                                                clearInterval(reconnectTimer);
                                                return [2 /*return*/];
                                            }
                                            this.playerInstance = new baseWrap(player, cacheType.Engine);
                                            return [4 /*yield*/, this.cacheManagement.createCache(config.engineId, this.playerInstance)];
                                        case 1:
                                            _a.sent();
                                            this.player = player;
                                            this.dispatch.emit('EngineInside', {
                                                status: true,
                                            });
                                            Logger$1.setMode(config.debug ? EMode.development : EMode.production);
                                            resolve({
                                                status: true,
                                                message: '',
                                                data: this.playerInstance
                                            });
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        Engine.prototype.setPixelRatio = function (ratio) {
            this.player && (this.player.pixelRatio = ratio);
        };
        /**
         * 重新计算时间
         */
        Engine.prototype.resetTimer = function () {
            if (this.player && this.player.resetTimer) {
                this.player.resetTimer();
            }
        };
        /**
         * @description: 卸载引擎
         * @param {IPlayer} player
         * @return {IResponse<void>} 是否成功
         */
        Engine.prototype.destroyEngine = function () {
            if (this.player) {
                this.player.exit();
                this.normalDisconnect = true;
            }
            this.dispatch.emit('EngineInside', {
                status: false,
            });
            return {
                status: true,
                message: '',
            };
        };
        /**
     * 获取所有包含method属性的对象并按时间排序（从近到远）
     */
        Engine.prototype.getLogsSortedByTime = function () {
            return __awaiter$1(this, void 0, void 0, function () {
                var db_1, request;
                return __generator$1(this, function (_a) {
                    try {
                        request = indexedDB.open("LogDatabase", 1);
                        request.onsuccess = function (event) {
                            var _a;
                            db_1 = (_a = event.target) === null || _a === void 0 ? void 0 : _a.result;
                            var transaction = db_1.transaction(db_1.objectStoreNames, 'readonly');
                            var objectStore = transaction.objectStore('logs');
                            var request2 = objectStore.getAll();
                            request2.onsuccess = function (event) {
                                var data = event.target.result; //将数据保存到本地文件
                                // 按时间从近到远排序
                                var sortedData = data.sort(function (a, b) {
                                    return b.order - a.order;
                                });
                                var dataString = JSON.stringify(sortedData);
                                var blob = new Blob([dataString], { type: 'application/json' });
                                var url = URL.createObjectURL(blob);
                                var a = document.createElement('a');
                                a.href = url;
                                a.download = 'data.json';
                                document.body.appendChild(a);
                                a.click();
                            };
                        };
                    }
                    catch (error) {
                        console.error('获取排序数据失败:', error);
                        throw error;
                    }
                    return [2 /*return*/];
                });
            });
        };
        return Engine;
    }(commonAbstractClass));

    /**
     * 加载地球场景
     * -  注意：加载地球场景，需要根据业务判断是否需要移动模型到地球的某个位置
     * @param {IPlayer} player - player实例
     * @param {string} globalMapPath - GIS地图路径
     * @return
     */
    var GIS = /** @class */ (function (_super) {
        __extends$1(GIS, _super);
        function GIS(cacheManagement) {
            var _this = _super.call(this) || this;
            _this.gisId = '';
            _this.gisId = generateUUID();
            _this.cacheManagement = cacheManagement;
            _this.gisInstance = new baseWrap({ instance: _this }, cacheType.GIS);
            _this.cacheManagement.createCache(_this.gisId, _this.gisInstance);
            var player = getPlayerData(cacheManagement);
            if (!player) {
                throw new Error("player未加载");
            }
            _this.player = player;
            return _this;
        }
        GIS.prototype.destroyInstance = function () {
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.unLoadGis()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        GIS.prototype.loadGis = function (globalMapPath) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var res;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!globalMapPath) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "地图路径无效"
                                    }];
                            }
                            // 先卸载地图
                            return [4 /*yield*/, this.unLoadGis(false)];
                        case 1:
                            // 先卸载地图
                            _b.sent();
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.GisPlatform.loadMap(globalMapPath))];
                        case 2:
                            res = _b.sent();
                            return [2 /*return*/, {
                                    status: res,
                                    message: ""
                                }];
                    }
                });
            });
        };
        /**
         * 卸载地球场景
         * @return {*}
         */
        GIS.prototype.unLoadGis = function (isDeleteGis) {
            var _a;
            if (isDeleteGis === void 0) { isDeleteGis = true; }
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.GisPlatform.unloadMap())];
                        case 1:
                            _b.sent();
                            if (isDeleteGis) {
                                this.cacheManagement.deleteCache(this.gisInstance);
                            }
                            return [2 /*return*/, {
                                    status: true,
                                    message: ""
                                }];
                    }
                });
            });
        };
        GIS.instance = null;
        return GIS;
    }(commonAbstractClass));

    var NodeProperty;
    (function (NodeProperty) {
        NodeProperty["Name"] = "name";
        NodeProperty["Code"] = "code";
        NodeProperty["LocalTrans"] = "localTrans";
        NodeProperty["LocalRot"] = "localRot";
        NodeProperty["LocalScale"] = "localScale";
        NodeProperty["GlobalTrans"] = "globalTrans";
        NodeProperty["GlobalRot"] = "globalRot";
        NodeProperty["Parent"] = "parent";
        NodeProperty["Children"] = "children";
        NodeProperty["Visible"] = "visible";
        NodeProperty["Material"] = "material";
        NodeProperty["Aabb"] = "aabb";
    })(NodeProperty || (NodeProperty = {}));
    var NodeFindType;
    (function (NodeFindType) {
        NodeFindType["codes"] = "codes";
        NodeFindType["names"] = "names";
    })(NodeFindType || (NodeFindType = {}));
    var EMaterialType;
    (function (EMaterialType) {
        EMaterialType[EMaterialType["color"] = 0] = "color";
        EMaterialType[EMaterialType["image"] = 1] = "image";
    })(EMaterialType || (EMaterialType = {}));

    /* node的封装 */
    var nodeWrap = /** @class */ (function (_super) {
        __extends$1(nodeWrap, _super);
        function nodeWrap(player, nodeData) {
            var _this = _super.call(this, nodeData, cacheType.Node) || this;
            _this.nodeInfo = nodeData;
            _this.player = player;
            return _this;
        }
        nodeWrap.prototype.destroyInstance = function () {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.destroy(this.nodeInfo.node))];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        /** 获取node的所有父节点 */
        nodeWrap.prototype.findNodeParentList = function () {
            return __awaiter$1(this, void 0, void 0, function () {
                var parentInstaceList, currentNodeInfo, _a, parentNodeInfo, instance, _b, parentNodeInfo, instance;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            parentInstaceList = [];
                            currentNodeInfo = this.getDataInfo();
                            if (!((currentNodeInfo === null || currentNodeInfo === void 0 ? void 0 : currentNodeInfo.parent) !== 0)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.getNodeParentData(currentNodeInfo)];
                        case 1:
                            _a = _c.sent(), parentNodeInfo = _a.parentNodeInfo, instance = _a.instance;
                            if (instance) {
                                this.setParentData(instance);
                                parentInstaceList.push(instance);
                                currentNodeInfo = parentNodeInfo;
                            }
                            else {
                                currentNodeInfo = null;
                            }
                            _c.label = 2;
                        case 2:
                            if (!(currentNodeInfo && (currentNodeInfo === null || currentNodeInfo === void 0 ? void 0 : currentNodeInfo.parent) !== 0)) return [3 /*break*/, 4];
                            return [4 /*yield*/, this.getNodeParentData(currentNodeInfo)];
                        case 3:
                            _b = _c.sent(), parentNodeInfo = _b.parentNodeInfo, instance = _b.instance;
                            if (!instance) {
                                currentNodeInfo = null;
                            }
                            else {
                                parentInstaceList[parentInstaceList.length - 1].setParentData(instance);
                                parentInstaceList.push(instance);
                                currentNodeInfo = parentNodeInfo;
                            }
                            return [3 /*break*/, 2];
                        case 4: return [2 /*return*/, parentInstaceList];
                    }
                });
            });
        };
        /** 获取当前节点的所有父节点且进行node封装 */
        nodeWrap.prototype.getNodeParentData = function (nodeData) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var parentNodeInfo, instance;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.getProperty(nodeData.parent, [NodeProperty.Parent, NodeProperty.Aabb, NodeProperty.Code, NodeProperty.Name, NodeProperty.Visible]))];
                        case 1:
                            parentNodeInfo = _b.sent();
                            if (Object.keys(parentNodeInfo).length !== 0) {
                                instance = new nodeWrap(this.player, parentNodeInfo);
                            }
                            return [2 /*return*/, {
                                    parentNodeInfo: parentNodeInfo,
                                    instance: instance
                                }];
                    }
                });
            });
        };
        return nodeWrap;
    }(baseWrap));

    // 测量工具集合
    var measureList;
    (function (measureList) {
        measureList[measureList["M_None"] = 0] = "M_None";
        measureList[measureList["M_Line"] = 1] = "M_Line";
        measureList[measureList["M_Point"] = 2] = "M_Point";
        measureList[measureList["M_Vertical"] = 3] = "M_Vertical";
        measureList[measureList["M_Stereo"] = 4] = "M_Stereo";
        measureList[measureList["M_Angel"] = 5] = "M_Angel";
        measureList[measureList["M_Area"] = 6] = "M_Area";
        measureList[measureList["M_WheelBase"] = 7] = "M_WheelBase";
    })(measureList || (measureList = {}));
    var operatMode;
    (function (operatMode) {
        operatMode[operatMode["OF_None"] = 0] = "OF_None";
        operatMode[operatMode["system.Pickup"] = 1] = "system.Pickup";
        operatMode[operatMode["OF_FreePickUp"] = 2] = "OF_FreePickUp";
        operatMode[operatMode["system.ToolHideModel"] = 3] = "system.ToolHideModel";
        operatMode[operatMode["system.PickupCenter"] = 4] = "system.PickupCenter"; // 居中
    })(operatMode || (operatMode = {}));
    var Tool = /** @class */ (function () {
        function Tool(cacheManagement, dispatch) {
            this.player = {};
            this.toolsLClickFun = function () { };
            this.toolsRClickFun = function () { };
            // 漫游相关
            this.roamCom = ['system.walk.first', 'system.walk.third', 'system.walk.fixView'];
            // 操作类
            this.operateTabBar = ['system.Pickup', 'system.PickupCenter', "system.ToolHideModel", "system.ToolMultiSelect"];
            this.cacheManagement = cacheManagement;
            var player = getPlayerData(cacheManagement);
            if (!player) {
                throw new Error("player未加载");
            }
            this.player = player;
            this.dispatch = dispatch;
            Tool.instance = this;
        }
        /**
         * @description: 设置当前激活的工具
         * @param {ITagParams} tag
         * @return {*}
         */
        Tool.prototype.setTool = function (tag, status) {
            var _a, _b, _c, _d, _e, _f;
            return __awaiter$1(this, void 0, void 0, function () {
                var closeTagList, _g, measureCloseList;
                return __generator$1(this, function (_h) {
                    switch (_h.label) {
                        case 0:
                            closeTagList = [];
                            _g = tag;
                            switch (_g) {
                                case Object.keys(measureList).find(function (el) { return el === tag; }): return [3 /*break*/, 1];
                                case this.roamCom.find(function (el) { return el === tag; }): return [3 /*break*/, 3];
                            }
                            return [3 /*break*/, 10];
                        case 1: return [4 /*yield*/, this.setMeasureStatus(tag, status)];
                        case 2:
                            measureCloseList = _h.sent();
                            closeTagList = __spreadArray$2(__spreadArray$2([], closeTagList, true), measureCloseList, true);
                            return [3 /*break*/, 15];
                        case 3:
                            if (!status) return [3 /*break*/, 6];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.PhysicsMgr.updatePhysicsScene())
                                // await this.player.Native?.PhysicsMgr.walkAxis(2)
                            ];
                        case 4:
                            _h.sent();
                            // await this.player.Native?.PhysicsMgr.walkAxis(2)
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Tools.setCurrentTool(tag))];
                        case 5:
                            // await this.player.Native?.PhysicsMgr.walkAxis(2)
                            _h.sent();
                            return [3 /*break*/, 9];
                        case 6: return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.PhysicsMgr.releasePhysicsScene())];
                        case 7:
                            _h.sent();
                            return [4 /*yield*/, ((_d = this.player.Native) === null || _d === void 0 ? void 0 : _d.Tools.setCurrentTool('system.Browse'))];
                        case 8:
                            _h.sent();
                            _h.label = 9;
                        case 9: return [3 /*break*/, 15];
                        case 10:
                            if (!!status) return [3 /*break*/, 12];
                            return [4 /*yield*/, ((_e = this.player.Native) === null || _e === void 0 ? void 0 : _e.Tools.setCurrentTool('system.Browse'))];
                        case 11:
                            _h.sent();
                            return [3 /*break*/, 14];
                        case 12: return [4 /*yield*/, ((_f = this.player.Native) === null || _f === void 0 ? void 0 : _f.Tools.setCurrentTool(tag))];
                        case 13:
                            _h.sent();
                            _h.label = 14;
                        case 14: return [3 /*break*/, 15];
                        case 15: return [2 /*return*/, {
                                status: true,
                                data: closeTagList,
                                message: '',
                            }];
                    }
                });
            });
        };
        /**
         * @description 工具左键点击监听
         * @param e
         */
        Tool.prototype.toolsLClick = function () {
            var _this = this;
            var that = this;
            this.toolsLClickFun = function (e) { return __awaiter$1(_this, void 0, void 0, function () {
                var isExist, nodeData, instance, nodeInfo;
                var _a;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!!e.node) return [3 /*break*/, 1];
                            that.dispatch.emit("Tools", {
                                type: "LClick",
                                data: {
                                    screen: e.screen,
                                    pos: e.pos,
                                },
                            });
                            return [3 /*break*/, 6];
                        case 1: return [4 /*yield*/, that.cacheManagement.findCacheByNode(e.node)];
                        case 2:
                            isExist = _b.sent();
                            if (!!isExist) return [3 /*break*/, 5];
                            return [4 /*yield*/, ((_a = that.player.Native) === null || _a === void 0 ? void 0 : _a.Node.getProperty(e.node, [NodeProperty.Parent, NodeProperty.Aabb, NodeProperty.Code, NodeProperty.Name, NodeProperty.Visible]))];
                        case 3:
                            nodeData = _b.sent();
                            instance = void 0;
                            instance = new nodeWrap(that.player, nodeData);
                            return [4 /*yield*/, that.cacheManagement.createCache(e.node, instance)];
                        case 4:
                            nodeInfo = _b.sent();
                            that.dispatch.emit("Tools", {
                                type: "LClick",
                                data: {
                                    nodeInfo: nodeInfo,
                                    screen: e.screen,
                                    pos: e.pos,
                                },
                            });
                            return [3 /*break*/, 6];
                        case 5:
                            that.dispatch.emit("Tools", {
                                type: "LClick",
                                data: { nodeInfo: isExist, screen: e.screen, pos: e.pos },
                            });
                            _b.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); };
            return this.toolsLClickFun;
        };
        /**
      * @description 工具右键点击监听
      * @param e
      */
        Tool.prototype.toolsRClick = function () {
            var _this = this;
            var that = this;
            this.toolsRClickFun = function (e) { return __awaiter$1(_this, void 0, void 0, function () {
                var isExist, nodeData, instance, nodeInfo;
                var _a;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!!e.node) return [3 /*break*/, 1];
                            that.dispatch.emit("Tools", {
                                type: "RClick",
                                data: {
                                    screen: e.screen,
                                    pos: e.pos,
                                },
                            });
                            return [3 /*break*/, 6];
                        case 1: return [4 /*yield*/, that.cacheManagement.findCacheByNode(e.node)];
                        case 2:
                            isExist = _b.sent();
                            if (!!isExist) return [3 /*break*/, 5];
                            return [4 /*yield*/, ((_a = that.player.Native) === null || _a === void 0 ? void 0 : _a.Node.getProperty(e.node, [NodeProperty.Parent, NodeProperty.Aabb, NodeProperty.Code, NodeProperty.Name, NodeProperty.Visible]))];
                        case 3:
                            nodeData = _b.sent();
                            instance = void 0;
                            instance = new nodeWrap(that.player, nodeData);
                            return [4 /*yield*/, that.cacheManagement.createCache(e.node, instance)];
                        case 4:
                            nodeInfo = _b.sent();
                            that.dispatch.emit("Tools", {
                                type: "RClick",
                                data: {
                                    nodeInfo: nodeInfo,
                                    screen: e.screen,
                                    pos: e.pos,
                                },
                            });
                            return [3 /*break*/, 6];
                        case 5:
                            that.dispatch.emit("Tools", {
                                type: "RClick",
                                data: { nodeInfo: isExist, screen: e.screen, pos: e.pos },
                            });
                            _b.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); };
            return this.toolsRClickFun;
        };
        Tool.prototype.openClickEvent = function () {
            var _a, _b;
            (_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Tools.EventBrowseLClick.connect(this.toolsLClick());
            (_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Tools.EventBrowseRClick.connect(this.toolsRClick());
        };
        Tool.prototype.closeClickEvent = function () {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Tools.EventBrowseLClick.disconnect(this.toolsLClickFun))];
                        case 1:
                            _c.sent();
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Tools.EventBrowseRClick.disconnect(this.toolsRClickFun))];
                        case 2:
                            _c.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        /** 设置工具 */
        Tool.prototype.setMeasureStatus = function (tag, status) {
            var _a, _b, _c, _d, _e, _f;
            return __awaiter$1(this, void 0, void 0, function () {
                var closeTagList, isOpenPickup;
                return __generator$1(this, function (_g) {
                    switch (_g.label) {
                        case 0:
                            closeTagList = [];
                            if (!status) return [3 /*break*/, 6];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.OperatingMode.isEnable(operatMode['system.Pickup']))];
                        case 1:
                            isOpenPickup = _g.sent();
                            if (!isOpenPickup) return [3 /*break*/, 3];
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.OperatingMode.disableOperate(operatMode['system.Pickup']))];
                        case 2:
                            _g.sent();
                            closeTagList.push('system.Pickup');
                            _g.label = 3;
                        case 3:
                            // 设置测量相关功能
                            (_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.Measure.setMeasureType(measureList[tag]);
                            if (!(tag === 'M_None')) return [3 /*break*/, 5];
                            // 如果是清除按钮
                            return [4 /*yield*/, ((_d = this.player.Native) === null || _d === void 0 ? void 0 : _d.Measure.clearAll())];
                        case 4:
                            // 如果是清除按钮
                            _g.sent();
                            _g.label = 5;
                        case 5: return [3 /*break*/, 9];
                        case 6: return [4 /*yield*/, ((_e = this.player.Native) === null || _e === void 0 ? void 0 : _e.Measure.setMeasureType(0))];
                        case 7:
                            _g.sent();
                            return [4 /*yield*/, ((_f = this.player.Native) === null || _f === void 0 ? void 0 : _f.Measure.clearAll())];
                        case 8:
                            _g.sent();
                            _g.label = 9;
                        case 9: return [2 /*return*/, closeTagList];
                    }
                });
            });
        };
        Tool.instance = null;
        return Tool;
    }());

    var EClipType;
    (function (EClipType) {
        EClipType[EClipType["box"] = 0] = "box";
        EClipType[EClipType["singlePanel"] = 1] = "singlePanel";
        EClipType[EClipType["doublePanel"] = 2] = "doublePanel";
        EClipType[EClipType["ThreePanel"] = 3] = "ThreePanel";
        EClipType[EClipType["Polygon"] = 4] = "Polygon";
    })(EClipType || (EClipType = {}));
    var EClipDataType;
    (function (EClipDataType) {
        EClipDataType[EClipDataType["aabb"] = 0] = "aabb";
        EClipDataType[EClipDataType["node"] = 1] = "node";
        EClipDataType[EClipDataType["clipData"] = 2] = "clipData";
    })(EClipDataType || (EClipDataType = {}));
    var IAxisType;
    (function (IAxisType) {
        IAxisType[IAxisType["EditAxisTypeUnknown"] = 0] = "EditAxisTypeUnknown";
        IAxisType[IAxisType["EditAxisTypeMove"] = 1] = "EditAxisTypeMove";
        IAxisType[IAxisType["EditAxisTypeRotate"] = 2] = "EditAxisTypeRotate";
        IAxisType[IAxisType["EditAxisTypeScale"] = 3] = "EditAxisTypeScale";
        IAxisType[IAxisType["EditAxisTypeSingleMove"] = 4] = "EditAxisTypeSingleMove";
        IAxisType[IAxisType["EditAxisTypeSingleRotate"] = 5] = "EditAxisTypeSingleRotate";
        IAxisType[IAxisType["EditAxisTypeFaceMove"] = 6] = "EditAxisTypeFaceMove";
    })(IAxisType || (IAxisType = {}));

    var IAxisStyle;
    (function (IAxisStyle) {
        IAxisStyle[IAxisStyle["arrow"] = 0] = "arrow";
        IAxisStyle[IAxisStyle["cone"] = 1] = "cone";
    })(IAxisStyle || (IAxisStyle = {}));

    // 添加 Math.clamp 函数
    if (!Math.clamp) {
        Math.clamp = function (a, min, max) {
            if (a < min) return min;
            else if (a > max) return max;
            return a;
        };
    }

    /**
     * 三维向量，包含向量常用的运算方法，当前系统使用数组表示向量，三维向量是包含三个Number的数组
     */
    let Vec3 = (function () {
        return {

            /**
             * 判断对象是否是合格的向量
             * @param {*} a 检查对象
             */
            check: function (a) {
                if (!Array.isArray(a))
                    return false;
                for (let i = 0; i < 3; ++i)
                    if (isNaN(a[i]))
                        return false;
                return true;
            },

            /**
             * 向量a与向量b相加，a + b
             * @param {[Number, Number, Number]} a 向量a
             * @param {[Number, Number, Number]} b 向量b
             */
            add: function (a, b) {
                return [a[0] + b[0], a[1] + b[1], a[2] + b[2]];
            },

            /**
             * 向量a与常数b相加，a + b
             * @param {[Number, Number, Number]} a 向量a
             * @param {Number} b 常数b
             */
            addScalar: function (a, b) {
                return [a[0] + b, a[1] + b, a[2] + b];
            },

            /**
             * 向量a与向量b相减， a - b
             * @param {[Number, Number, Number]} a 向量a
             * @param {[Number, Number, Number]} b 向量b
             */
            sub: function (a, b) {
                return [a[0] - b[0], a[1] - b[1], a[2] - b[2]];
            },

            /**
             * 向量a与常数b相减，a - b
             * @param {[Number, Number, Number]} a 向量a
             * @param {Number} b 常数b
             */
            subScalar: function (a, b) {
                return [a[0] - b, a[1] - b, a[2] - b];
            },

            /**
             * 向量a与向量b相乘， a * b
             * @param {[Number, Number, Number]} a 向量a
             * @param {[Number, Number, Number]} b 向量b
             */
            multiply: function (a, b) {
                return [a[0] * b[0], a[1] * b[1], a[2] * b[2]];
            },

            /**
             * 向量a与常数b相乘，a * b
             * @param {[Number, Number, Number]} a 向量a
             * @param {Number} b 常数b
             */
            multiplyScalar: function (a, b) {
                return [a[0] * b, a[1] * b, a[2] * b];
            },

            /**
             * 向量a与向量b相除， a / b
             * @param {[Number, Number, Number]} a 向量a
             * @param {[Number, Number, Number]} b 向量b
             * @note 向量b各分量不能为0
             */
            divide: function (a, b) {
                return [a[0] / b[0], a[1] / b[1], a[2] / b[2]];
            },

            /**
             * 向量a与常数b相除，a / b
             * @param {[Number, Number, Number]} a 向量a
             * @param {Number} b 常数b
             * @note 常数b不能为0
             */
            divideScalar: function (a, b) {
                return [a[0] / b, a[1] / b, a[2] / b];
            },

            /**
             * 向量a与向量b点乘， dot(a, b) = |a| * |b| * cos
             * @param {[Number, Number, Number]} a 向量a
             * @param {[Number, Number, Number]} b 向量b
             */
            dot: function (a, b) {
                return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
            },

            /**
             * 向量a与向量b叉乘， cross(a, b) = 法向量，同时垂直于向量a和向量b
             * @param {[Number, Number, Number]} a 向量a
             * @param {[Number, Number, Number]} b 向量b
             */
            cross: function (a, b) {
                return [a[1] * b[2] - b[1] * a[2],
                    a[2] * b[0] - b[2] * a[0],
                    a[0] * b[1] - b[0] * a[1]
                ];
            },

            /**
             * 获取向量a的模长/长度, length(a) = |a|
             * @param {[Number, Number, Number]} a 向量a
             */
            length: function (a) {
                return Math.sqrt(a[0] * a[0] + a[1] * a[1] + a[2] * a[2]);
            },

            /**
             * 获取向量a的模长/长度的平方，lengthSq(a) = length(a) * length(a)
             * @param {[Number, Number, Number]} a 向量a
             */
            lengthSq: function (a) {
                return a[0] * a[0] + a[1] * a[1] + a[2] * a[2];
            },

            /**
             * 向量取反
             * @param {[Number, Number, Number]} a 向量a
             */
            negate: function (a) {
                return [-a[0], -a[1], -a[2]];
            },

            /**
             * 获取单位向量
             * @param {[Number, Number, Number]} a 向量a
             */
            normalize: function (a) {
                var len = Math.sqrt(a[0] * a[0] + a[1] * a[1] + a[2] * a[2]) || 1;
                return [a[0] / len, a[1] / len, a[2] / len];
            },

            /**
             * 向量a与向量b的夹角
             * @param {[Number, Number, Number]} a 向量a
             * @param {[Number, Number, Number]} b 向量b
             * @param 返回两个向量的夹角(角度制)
             */
            angleBetween: function (a, b) {
                const denominator = Vec3.length(a) * Vec3.length(b);

                if (denominator === 0)
                    return Math.PI / 2 * (180 / Math.PI);

                let theta = Vec3.dot(a, b) / denominator;

                if (theta < -1)
                    theta = -1;
                if (theta > 1)
                    theta = 1;

                let angle = Math.acos(theta);
                angle *= 180 / Math.PI;

                return angle
            }
        }
    })();

    /**
     * 行优先4x4矩阵
     */
    let Matrix4 = (function () {
        return {
            /**
             * 获取单位矩阵
             * @returns 单位矩阵
             */
            identity: function () {
                return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
            },

            /**
             * 检查a是否是合法的矩阵
             * @param {*} a 检查对象
             */
            check: function (a) {
                if (!Array.isArray(a))
                    return false;
                for (let i = 0; i < 16; ++i)
                    if (isNaN(a[i]))
                        return false;
                return true;
            },

            /**
             * 矩阵a与矩阵b相乘
             * @param {[...Number]} a
             * @param {[...Number]} b
             */
            multiply: function (a, b) {
                const ae = a;
                const be = b;

                const a11 = ae[0],
                    a12 = ae[4],
                    a13 = ae[8],
                    a14 = ae[12];
                const a21 = ae[1],
                    a22 = ae[5],
                    a23 = ae[9],
                    a24 = ae[13];
                const a31 = ae[2],
                    a32 = ae[6],
                    a33 = ae[10],
                    a34 = ae[14];
                const a41 = ae[3],
                    a42 = ae[7],
                    a43 = ae[11],
                    a44 = ae[15];

                const b11 = be[0],
                    b12 = be[4],
                    b13 = be[8],
                    b14 = be[12];
                const b21 = be[1],
                    b22 = be[5],
                    b23 = be[9],
                    b24 = be[13];
                const b31 = be[2],
                    b32 = be[6],
                    b33 = be[10],
                    b34 = be[14];
                const b41 = be[3],
                    b42 = be[7],
                    b43 = be[11],
                    b44 = be[15];

                let rMat = [];

                rMat[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
                rMat[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
                rMat[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
                rMat[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;

                rMat[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
                rMat[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
                rMat[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
                rMat[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;

                rMat[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
                rMat[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
                rMat[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
                rMat[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;

                rMat[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
                rMat[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
                rMat[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
                rMat[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;

                return rMat;
            },

            /**
             * 矩阵a与三维坐标b相乘，返回变换后的坐标
             * @param {[...Number]} a 矩阵a
             * @param {[Number,Number,Number]} b 三维坐标b
             */
            multiplyPos: function (a, b) {
                var ret = [];
                for (var i = 0; i < 3; ++i) {
                    ret[i] = a[12 + i];
                    for (var j = 0; j < 3; ++j) {
                        ret[i] += b[j] * a[j * 4 + i];
                    }
                }
                return ret;
            },

            /**
             * 矩阵a与方向向量b相乘，返回变化后的方向
             * @param {[...Number]} a 矩阵a
             * @param {[Number,Number,Number]} b 三维向量b
             */
            multiplyDir: function (a, b) {
                var ret = [];
                for (var i = 0; i < 3; ++i) {
                    ret[i] = 0;
                    for (var j = 0; j < 3; ++j) {
                        ret[i] += b[j] * a[j * 4 + i];
                    }
                }
                return ret;
            },

            /**
             * 构造TRS矩阵
             * @param position 位置
             * @param quaternion 旋转四元数(顺序wxyz)
             * @param scale 缩放
             * @returns 4x4 TRS矩阵
             */
            compose: function (position, quaternion, scale) {

                var ret = [];

                const x = quaternion[1];
                const y = quaternion[2];
                const z = quaternion[3];
                const w = quaternion[0];

                const x2 = x + x;
                const y2 = y + y;
                const z2 = z + z;
                const xx = x * x2;
                const xy = x * y2;
                const xz = x * z2;
                const yy = y * y2;
                const yz = y * z2;
                const zz = z * z2;
                const wx = w * x2;
                const wy = w * y2;
                const wz = w * z2;

                const sx = scale[0];
                const sy = scale[1];
                const sz = scale[2];

                ret[0] = (1 - (yy + zz)) * sx;
                ret[1] = (xy + wz) * sx;
                ret[2] = (xz - wy) * sx;
                ret[3] = 0;

                ret[4] = (xy - wz) * sy;
                ret[5] = (1 - (xx + zz)) * sy;
                ret[6] = (yz + wx) * sy;
                ret[7] = 0;

                ret[8] = (xz + wy) * sz;
                ret[9] = (yz - wx) * sz;
                ret[10] = (1 - (xx + yy)) * sz;
                ret[11] = 0;

                ret[12] = position[0];
                ret[13] = position[1];
                ret[14] = position[2];
                ret[15] = 1;

                return ret;

            },

            /**
             * 矩阵萃取
             * @param {*} m 将被萃取的矩阵对象
             * @returns 萃取结果
             *          - position: 萃取的位置信息
             *          - quaternion: 萃取的旋转四元数信息
             *          - rotation: 萃取的旋转矩阵信息
             *          - scale:萃取的缩放信息
             */
            decompose: function (m) {
                var a = {};

                var vx = [m[0], m[1], m[2]];
                var vy = [m[4], m[5], m[6]];
                var vz = [m[8], m[9], m[10]];

                let sx = Vec3.length(vx);
                const sy = Vec3.length(vy);
                const sz = Vec3.length(vz);

                // if determine is negative, we need to invert one scale
                const det = Matrix4.determinant(m);
                if (det < 0)
                    sx = -sx;

                a.position = [];
                a.position[0] = m[12];
                a.position[1] = m[13];
                a.position[2] = m[14];

                // scale the rotation part
                var rMat = m;
                rMat[12] = 0;
                rMat[13] = 0;
                rMat[14] = 0;

                const invSX = 1 / sx;
                const invSY = 1 / sy;
                const invSZ = 1 / sz;

                rMat[0] *= invSX;
                rMat[1] *= invSX;
                rMat[2] *= invSX;

                rMat[4] *= invSY;
                rMat[5] *= invSY;
                rMat[6] *= invSY;

                rMat[8] *= invSZ;
                rMat[9] *= invSZ;
                rMat[10] *= invSZ;

                a.rotation = rMat;
                a.quaternion = Quat.fromRotationMatrix(rMat);

                a.scale = [];
                a.scale[0] = sx;
                a.scale[1] = sy;
                a.scale[2] = sz;

                return a;
            },

            /**
             * 计算矩阵行列式
             * @param {*} m 将被计算行列式的矩阵对象
             * @returns 矩阵的行列式值
             */
            determinant: function (m) {
                const n11 = m[0],
                    n12 = m[1],
                    n13 = m[2],
                    n14 = m[3];
                const n21 = m[4],
                    n22 = m[5],
                    n23 = m[6],
                    n24 = m[7];
                const n31 = m[8],
                    n32 = m[9],
                    n33 = m[10],
                    n34 = m[11];
                const n41 = m[12],
                    n42 = m[13],
                    n43 = m[14],
                    n44 = m[15];

                return (
                    n41 * (
                        +n14 * n23 * n32 -
                        n13 * n24 * n32 -
                        n14 * n22 * n33 +
                        n12 * n24 * n33 +
                        n13 * n22 * n34 -
                        n12 * n23 * n34
                    ) +
                    n42 * (
                        +n11 * n23 * n34 -
                        n11 * n24 * n33 +
                        n14 * n21 * n33 -
                        n13 * n21 * n34 +
                        n13 * n24 * n31 -
                        n14 * n23 * n31
                    ) +
                    n43 * (
                        +n11 * n24 * n32 -
                        n11 * n22 * n34 -
                        n14 * n21 * n32 +
                        n12 * n21 * n34 +
                        n14 * n22 * n31 -
                        n12 * n24 * n31
                    ) +
                    n44 * (
                        -n13 * n22 * n31 -
                        n11 * n23 * n32 +
                        n11 * n22 * n33 +
                        n13 * n21 * n32 -
                        n12 * n21 * n33 +
                        n12 * n23 * n31
                    )

                );

            },

            /**
             * 计算矩阵的逆
             * @param {*} m 将被计算逆的矩阵对象
             * @returns 矩阵的逆矩阵
             * */
            inverse: function (m) {

                // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm

                const n11 = m[0],
                    n21 = m[1],
                    n31 = m[2],
                    n41 = m[3],
                    n12 = m[4],
                    n22 = m[5],
                    n32 = m[6],
                    n42 = m[7],
                    n13 = m[8],
                    n23 = m[9],
                    n33 = m[10],
                    n43 = m[11],
                    n14 = m[12],
                    n24 = m[13],
                    n34 = m[14],
                    n44 = m[15],

                    t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44,
                    t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44,
                    t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44,
                    t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;

                const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;

                if (det === 0) return [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

                const detInv = 1 / det;

                let invMat = [];

                invMat[0] = t11 * detInv;
                invMat[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
                invMat[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
                invMat[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;

                invMat[4] = t12 * detInv;
                invMat[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
                invMat[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
                invMat[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;

                invMat[8] = t13 * detInv;
                invMat[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
                invMat[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
                invMat[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;

                invMat[12] = t14 * detInv;
                invMat[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
                invMat[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
                invMat[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;

                return invMat;
            },

            /**
             * 构造平移矩阵
             * @param {[Number, Number, Number]} t 平移距离
             * @returns 4x4 的平移矩阵
             */
            makeTranslate: function (t) {
                var mat = this.identity();
                mat[12] = t[0];
                mat[13] = t[1];
                mat[14] = t[2];
                return mat;
            },

            /**
             * 指定旋转角和旋转轴计算一个旋转矩阵
             * @param {Number} angle 旋转角(角度制)
             * @param {[Number, Number, Number]} axis 旋转轴(单位向量)
             * @returns 4x4的旋转矩阵
             * */
            makeRotationAxis: function (angle, axis) {

                const tAngne = angle * Math.PI / 180;
                // Based on http://www.gamedev.net/reference/articles/article1199.asp
                const c = Math.cos(tAngne);
                const s = Math.sin(tAngne);
                const t = 1 - c;
                const x = axis[0],
                    y = axis[1],
                    z = axis[2];
                const tx = t * x,
                    ty = t * y;

                let rMat = [];
                rMat[0] = tx * x + c;
                rMat[4] = tx * y - s * z;
                rMat[8] = tx * z + s * y;
                rMat[12] = 0;
                rMat[1] = tx * y + s * z;
                rMat[5] = ty * y + c;
                rMat[9] = ty * z - s * x;
                rMat[13] = 0;
                rMat[2] = tx * z - s * y;
                rMat[6] = ty * z + s * x;
                rMat[10] = t * z * z + c;
                rMat[14] = 0;
                rMat[3] = 0;
                rMat[7] = 0;
                rMat[11] = 0;
                rMat[15] = 1;
                return rMat;
            },
        }
    })();

    /**
     * 四元素
     *  注：这里四元数对应Player返回的四元数对象，Player返回的四元数的顺序是 [w,x,y,z]
     *   因此这里四元数所有算法也应该遵循Player中的 [w,x,y,z]顺序
     */
    let Quat = (function () {
        return {
            /**
             * 检查a是否是合法的四元数
             * @param {*} a 检查对象
             */
            check: function (a) {
                if (!Array.isArray(a))
                    return false;
                for (let i = 0; i < 4; ++i)
                    if (isNaN(a[i]))
                        return false;
                if (Math.abs(a[0] * a[0] + a[1] * a[1] + a[2] * a[2] + a[3] * a[3] - 1) > 0.01)
                    return false;
                return true;
            },
            /**
             * 转换旋转矩阵到四元数
             * @param {*} m 旋转矩阵
             * @returns 旋转四元数
             */
            fromRotationMatrix: function (m) {
                const m11 = m[0],
                    m12 = m[4],
                    m13 = m[8],
                    m21 = m[1],
                    m22 = m[5],
                    m23 = m[9],
                    m31 = m[2],
                    m32 = m[6],
                    m33 = m[10],
                    trace = m11 + m22 + m33,
                    q = [];

                if (trace > 0) {

                    const s = 0.5 / Math.sqrt(trace + 1.0);

                    q[0] = 0.25 / s;
                    q[1] = (m32 - m23) * s;
                    q[2] = (m13 - m31) * s;
                    q[3] = (m21 - m12) * s;

                } else if (m11 > m22 && m11 > m33) {

                    const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);

                    q[0] = (m32 - m23) / s;
                    q[1] = 0.25 * s;
                    q[2] = (m12 + m21) / s;
                    q[3] = (m13 + m31) / s;

                } else if (m22 > m33) {

                    const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);

                    q[0] = (m13 - m31) / s;
                    q[1] = (m12 + m21) / s;
                    q[2] = 0.25 * s;
                    q[3] = (m23 + m32) / s;

                } else {

                    const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);

                    q[0] = (m21 - m12) / s;
                    q[1] = (m13 + m31) / s;
                    q[2] = (m23 + m32) / s;
                    q[3] = 0.25 * s;

                }

                return q;
            },
            /**
             * 转换四元数到旋转矩阵
             * @param m 旋转四元数
             * @returns 旋转矩阵
             */
            toRotationMatrix: function (q) {
                return Matrix4.compose([0, 0, 0], q, [1, 1, 1]);
            },
        }
    })();


    let EulerAngle = (function () {
        return {
            /**
             * 转换旋转矩阵到欧拉角
             * @param m 旋转矩阵(4x4)
             * @param order 欧拉角顺序, 取值分别为: "XYZ", "YXZ", "ZXY", "ZYX", "YZX", "XZY"
             * @returns 欧拉角
             */
            fromRotationMatrix: function (m, order = 'XYZ') {

                var ret = [];

                const te = m;
                const m11 = te[0],
                    m12 = te[4],
                    m13 = te[8];
                const m21 = te[1],
                    m22 = te[5],
                    m23 = te[9];
                const m31 = te[2],
                    m32 = te[6],
                    m33 = te[10];

                switch (order) {

                    case 'XYZ':

                        ret[1] = Math.asin(Math.clamp(m13, -1, 1));

                        if (Math.abs(m13) < 0.9999999) {

                            ret[0] = Math.atan2(-m23, m33);
                            ret[2] = Math.atan2(-m12, m11);

                        } else {

                            ret[0] = Math.atan2(m32, m22);
                            ret[2] = 0;

                        }

                        break;

                    case 'YXZ':

                        ret[0] = Math.asin(-clamp(m23, -1, 1));

                        if (Math.abs(m23) < 0.9999999) {

                            ret[1] = Math.atan2(m13, m33);
                            ret[2] = Math.atan2(m21, m22);

                        } else {

                            ret[1] = Math.atan2(-m31, m11);
                            ret[2] = 0;

                        }

                        break;

                    case 'ZXY':

                        ret[0] = Math.asin(clamp(m32, -1, 1));

                        if (Math.abs(m32) < 0.9999999) {

                            ret[1] = Math.atan2(-m31, m33);
                            ret[2] = Math.atan2(-m12, m22);

                        } else {

                            ret[1] = 0;
                            ret[2] = Math.atan2(m21, m11);

                        }

                        break;

                    case 'ZYX':

                        ret[1] = Math.asin(-clamp(m31, -1, 1));

                        if (Math.abs(m31) < 0.9999999) {

                            ret[0] = Math.atan2(m32, m33);
                            ret[2] = Math.atan2(m21, m11);

                        } else {

                            ret[0] = 0;
                            ret[2] = Math.atan2(-m12, m22);

                        }

                        break;

                    case 'YZX':

                        ret[2] = Math.asin(clamp(m21, -1, 1));

                        if (Math.abs(m21) < 0.9999999) {

                            ret[0] = Math.atan2(-m23, m22);
                            ret[1] = Math.atan2(-m31, m11);

                        } else {

                            ret[0] = 0;
                            ret[1] = Math.atan2(m13, m33);

                        }

                        break;

                    case 'XZY':

                        ret[2] = Math.asin(-clamp(m12, -1, 1));

                        if (Math.abs(m12) < 0.9999999) {

                            ret[0] = Math.atan2(m32, m22);
                            ret[1] = Math.atan2(m13, m11);

                        } else {

                            ret[0] = Math.atan2(-m23, m33);
                            ret[1] = 0;

                        }

                        break;

                    default:

                        console.warn(' unknown order: ' + order);

                }
                //弧度制转角度制
                ret[0] = ret[0] * 180 / Math.PI;
                ret[1] = ret[1] * 180 / Math.PI;
                ret[2] = ret[2] * 180 / Math.PI;
                return ret;
            },
            /**
             * 转换欧拉角到旋转矩阵
             * @param euler 欧拉角
             * @param order 欧拉角顺序, 取值分别为: "XYZ", "YXZ", "ZXY", "ZYX", "YZX", "XZY"
             * @returns 4x4旋转矩阵
             */
            toRotationMatrix: function (euler, order = 'XYZ') {

                var ret = [];

                const x = euler[0] * Math.PI / 180;
                const y = euler[1] * Math.PI / 180;
                const z = euler[2] * Math.PI / 180;
                const a = Math.cos(x);
                const b = Math.sin(x);
                const c = Math.cos(y);
                const d = Math.sin(y);
                const e = Math.cos(z);
                const f = Math.sin(z);

                if (order === 'XYZ') {

                    const ae = a * e,
                        af = a * f,
                        be = b * e,
                        bf = b * f;

                    ret[0] = c * e;
                    ret[4] = -c * f;
                    ret[8] = d;

                    ret[1] = af + be * d;
                    ret[5] = ae - bf * d;
                    ret[9] = -b * c;

                    ret[2] = bf - ae * d;
                    ret[6] = be + af * d;
                    ret[10] = a * c;

                } else if (order === 'YXZ') {

                    const ce = c * e,
                        cf = c * f,
                        de = d * e,
                        df = d * f;

                    ret[0] = ce + df * b;
                    ret[4] = de * b - cf;
                    ret[8] = a * d;

                    ret[1] = a * f;
                    ret[5] = a * e;
                    ret[9] = -b;

                    ret[2] = cf * b - de;
                    ret[6] = df + ce * b;
                    ret[10] = a * c;

                } else if (order === 'ZXY') {

                    const ce = c * e,
                        cf = c * f,
                        de = d * e,
                        df = d * f;

                    ret[0] = ce - df * b;
                    ret[4] = -a * f;
                    ret[8] = de + cf * b;

                    ret[1] = cf + de * b;
                    ret[5] = a * e;
                    ret[9] = df - ce * b;

                    ret[2] = -a * d;
                    ret[6] = b;
                    ret[10] = a * c;

                } else if (order === 'ZYX') {

                    const ae = a * e,
                        af = a * f,
                        be = b * e,
                        bf = b * f;

                    ret[0] = c * e;
                    ret[4] = be * d - af;
                    ret[8] = ae * d + bf;

                    ret[1] = c * f;
                    ret[5] = bf * d + ae;
                    ret[9] = af * d - be;

                    ret[2] = -d;
                    ret[6] = b * c;
                    ret[10] = a * c;

                } else if (order === 'YZX') {

                    const ac = a * c,
                        ad = a * d,
                        bc = b * c,
                        bd = b * d;

                    ret[0] = c * e;
                    ret[4] = bd - ac * f;
                    ret[8] = bc * f + ad;

                    ret[1] = f;
                    ret[5] = a * e;
                    ret[9] = -b * e;

                    ret[2] = -d * e;
                    ret[6] = ad * f + bc;
                    ret[10] = ac - bd * f;

                } else if (order === 'XZY') {

                    const ac = a * c,
                        ad = a * d,
                        bc = b * c,
                        bd = b * d;

                    ret[0] = c * e;
                    ret[4] = -f;
                    ret[8] = d * e;

                    ret[1] = ac * f + bd;
                    ret[5] = a * e;
                    ret[9] = ad * f - bc;

                    ret[2] = bc * f - ad;
                    ret[6] = b * e;
                    ret[10] = bd * f + ac;

                }

                // bottom row
                ret[3] = 0;
                ret[7] = 0;
                ret[11] = 0;

                // last column
                ret[12] = 0;
                ret[13] = 0;
                ret[14] = 0;
                ret[15] = 1;

                return ret;
            },
            /**
             * 转换旋转四元数到欧拉角
             * @param q 旋转四元数(wxyz)
             * @param order 欧拉角顺序, 取值分别为: "XYZ", "YXZ", "ZXY", "ZYX", "YZX", "XZY"
             * @returns 旋转四元数
             */
            fromQuat: function (q, order = 'XYZ') {
                return EulerAngle.fromRotationMatrix(Quat.toRotationMatrix(q), order);
            },
            /**
             * 转换欧拉角到旋转四元数
             * @param euler 欧拉角
             * @param order 欧拉角顺序, 取值分别为: "XYZ", "YXZ", "ZXY", "ZYX", "YZX", "XZY"
             * @returns 旋转四元数(wxyz)
             */
            toQuat: function (euler, order = 'XYZ') {

                var q = [];
                const x = euler[0] * Math.PI / 180;
                const y = euler[1] * Math.PI / 180;
                const z = euler[2] * Math.PI / 180;

                const cos = Math.cos;
                const sin = Math.sin;

                const c1 = cos(x / 2);
                const c2 = cos(y / 2);
                const c3 = cos(z / 2);

                const s1 = sin(x / 2);
                const s2 = sin(y / 2);
                const s3 = sin(z / 2);

                switch (order) {

                    case 'XYZ':
                        q[1] = s1 * c2 * c3 + c1 * s2 * s3;
                        q[2] = c1 * s2 * c3 - s1 * c2 * s3;
                        q[3] = c1 * c2 * s3 + s1 * s2 * c3;
                        q[0] = c1 * c2 * c3 - s1 * s2 * s3;
                        break;

                    case 'YXZ':
                        q[1] = s1 * c2 * c3 + c1 * s2 * s3;
                        q[2] = c1 * s2 * c3 - s1 * c2 * s3;
                        q[3] = c1 * c2 * s3 - s1 * s2 * c3;
                        q[0] = c1 * c2 * c3 + s1 * s2 * s3;
                        break;

                    case 'ZXY':
                        q[1] = s1 * c2 * c3 - c1 * s2 * s3;
                        q[2] = c1 * s2 * c3 + s1 * c2 * s3;
                        q[3] = c1 * c2 * s3 + s1 * s2 * c3;
                        q[0] = c1 * c2 * c3 - s1 * s2 * s3;
                        break;

                    case 'ZYX':
                        q[1] = s1 * c2 * c3 - c1 * s2 * s3;
                        q[2] = c1 * s2 * c3 + s1 * c2 * s3;
                        q[3] = c1 * c2 * s3 - s1 * s2 * c3;
                        q[0] = c1 * c2 * c3 + s1 * s2 * s3;
                        break;

                    case 'YZX':
                        q[1] = s1 * c2 * c3 + c1 * s2 * s3;
                        q[2] = c1 * s2 * c3 + s1 * c2 * s3;
                        q[3] = c1 * c2 * s3 - s1 * s2 * c3;
                        q[0] = c1 * c2 * c3 - s1 * s2 * s3;
                        break;

                    case 'XZY':
                        q[1] = s1 * c2 * c3 - c1 * s2 * s3;
                        q[2] = c1 * s2 * c3 - s1 * c2 * s3;
                        q[3] = c1 * c2 * s3 + s1 * s2 * c3;
                        q[0] = c1 * c2 * c3 + s1 * s2 * s3;
                        break;

                    default:
                        console.warn('unknown order: ' + order);

                }

                return q;
            }
        };
    })();
    /**
     * 包围盒
     */
    let Aabb = (function () {
        return {
            /**
             * 检查a是否是合法的包围盒
             * @param {*} a 检查对象
             */
            check: function (a) {
                if (!Array.isArray(a))
                    return false;
                if (isNaN(a.min) || isNaN(a.max))
                    return false;
                for (let i = 0; i < 3; ++i)
                    if (isNaN(a.min[i]) || isNaN(a.max[i]))
                        return false;
                return true;
            },

            /**
             * map(min、max)解成二维数组
             * @param {[{"min", [Number, Number, Number]}， {"max", [Number, Number, Number]}]} a map a
             */
            deMap: function (a) {
                return [a.min, a.max];
            },

            /**
             * 获取包围盒8个顶点
             * @param a [ [Number, Number, Number]，[Number, Number, Number]] a aabb
             */
            vertex8: function (a) {
                return [
                    [a[0][0], a[0][1], a[0][2]]

                    ,
                    [a[0][0], a[1][1], a[0][2]]

                    ,
                    [a[1][0], a[1][1], a[0][2]]

                    ,
                    [a[1][0], a[0][1], a[0][2]]

                    ,
                    [a[1][0], a[1][1], a[1][2]]

                    ,
                    [a[0][0], a[1][1], a[1][2]]

                    ,
                    [a[0][0], a[0][1], a[1][2]]

                    ,
                    [a[1][0], a[0][1], a[1][2]]
                ];
            },
            /**
             * 获取包围盒某个面
             * @param a [ [Number, Number, Number]，[Number, Number, Number]] a aabb
             * @param faceName 面名称: X,XN,Y,YN,Z,ZN
             */
            face: function (a, faceName = 'Z') {
                let fIdx = [];
                switch (faceName) {
                    case 'X': {
                        fIdx = [3, 2, 4, 7]; //X
                    }
                    break;
                case 'XN': {
                    fIdx = [1, 0, 6, 5]; //XN
                }
                break;
                case 'Y': {
                    fIdx = [2, 1, 5, 4]; //Y
                }
                break;
                case 'YN': {
                    fIdx = [0, 3, 7, 6]; //YN
                }
                break;
                case 'Z': {
                    fIdx = [6, 7, 4, 5]; //Z
                }
                break;
                case 'ZN': {
                    fIdx = [1, 2, 3, 0]; //ZN
                }
                break;
                default: {
                    console.warn('unknown face: ' + faceName);
                    return [];
                }
                }
                const v8 = Aabb.vertex8(a);
                return [v8[fIdx[0]], v8[fIdx[1]], v8[fIdx[2]], v8[fIdx[3]]]
            },
            /**
             * 获取包围盒某个面中心点
             * @param a [ [Number, Number, Number]，[Number, Number, Number]] a aabb
             * @param faceName 面名称: X,XN,Y,YN,Z,ZN
             */
            faceCenter: function (a, faceName = 'Z') {
                const face = Aabb.face(a, faceName);
                const a0 = Vec3.add(face[0], face[1]);
                const a1 = Vec3.add(a0, face[2]);
                let a2 = Vec3.add(a1, face[3]);
                a2[0] /= 4;
                a2[1] /= 4;
                a2[2] /= 4;
                return a2;
            },
            /**
             * 获取包围盒中心点
             * @param [ [Number, Number, Number]，[Number, Number, Number]] a aabb
             */
            center: function (a) {
                let cen = Vec3.add(a[0], a[1]);
                cen = Vec3.multiplyScalar(cen, 0.5);
                return cen
            }
        }
    })();

    function common(player) {
        var _this = this;
        var traverseNode = function (nodes, call, keys) {
            if (call === void 0) { call = function () { }; }
            if (keys === void 0) { keys = ["name", "code", "parent", "children", "material"]; }
            return __awaiter$1(_this, void 0, void 0, function () {
                var parent, nodeTree, getChildNode;
                var _this = this;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!keys.includes("children")) {
                                keys.push("children");
                            }
                            if (typeof nodes === "number") {
                                nodes = [nodes];
                            }
                            getChildNode = function (nodes) { return __awaiter$1(_this, void 0, void 0, function () {
                                var data, index_1, len_1, childNodes, data1, _i, data1_1, node;
                                var _a, _b;
                                return __generator$1(this, function (_c) {
                                    switch (_c.label) {
                                        case 0: return [4 /*yield*/, ((_a = player.Native) === null || _a === void 0 ? void 0 : _a.Node.getProperty(nodes, keys))];
                                        case 1:
                                            data = _c.sent();
                                            if (parent) {
                                                index_1 = 0;
                                                parent.forEach(function (item) {
                                                    len_1 = item.children.length;
                                                    item.children = data.slice(index_1, index_1 + len_1);
                                                    index_1 += len_1;
                                                });
                                            }
                                            else {
                                                nodeTree = data;
                                            }
                                            childNodes = [];
                                            data1 = data.filter(function (item) { return item.node; });
                                            for (_i = 0, data1_1 = data1; _i < data1_1.length; _i++) {
                                                node = data1_1[_i];
                                                call(node);
                                                if ((_b = node.children) === null || _b === void 0 ? void 0 : _b.length) {
                                                    childNodes.push.apply(childNodes, node.children.map(function (item) { return item.node; }));
                                                }
                                            }
                                            if (!childNodes.length) return [3 /*break*/, 3];
                                            parent = data1;
                                            return [4 /*yield*/, getChildNode(childNodes)];
                                        case 2:
                                            _c.sent();
                                            _c.label = 3;
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); };
                            return [4 /*yield*/, getChildNode(nodes)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/, nodeTree];
                    }
                });
            });
        };
        var getMaterials = function (nodes) { return __awaiter$1(_this, void 0, void 0, function () {
            var materials;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        materials = [];
                        return [4 /*yield*/, traverseNode(nodes, function (node) {
                                if (node.material && !materials.includes(node.material)) {
                                    materials.push(node.material);
                                }
                            }, ["children", "material"])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, materials];
                }
            });
        }); };
        var getMaterialsProperty = function (materials, keys) {
            if (keys === void 0) { keys = ["name", "alpha", "diffuse", "roughness", "metallic"]; }
            return __awaiter$1(_this, void 0, void 0, function () {
                var _a;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = player.Native) === null || _a === void 0 ? void 0 : _a.Material.getProperty(materials, keys))];
                        case 1: return [2 /*return*/, _b.sent()];
                    }
                });
            });
        };
        var setMaterialsProperty = function (materials, params) {
            if (params === void 0) { params = {}; }
            return __awaiter$1(_this, void 0, void 0, function () {
                var _a;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = player.Native) === null || _a === void 0 ? void 0 : _a.Material.setProperty(materials, params))];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        return { traverseNode: traverseNode, getMaterials: getMaterials, getMaterialsProperty: getMaterialsProperty, setMaterialsProperty: setMaterialsProperty };
    }

    var NodeProxy = /** @class */ (function () {
        function NodeProxy(cacheManagement, dispatch, bindEvent) {
            this.player = {};
            this.currentEditNode = 0;
            this.dealEditChange = function () { };
            this.dealSelectItemChange = function () { };
            this.isConnectEditChange = false;
            this.node_material = {};
            this.cacheManagement = cacheManagement;
            var player = getPlayerData(cacheManagement);
            if (!player) {
                throw new Error("player未加载");
            }
            this.player = player;
            this.dispatch = dispatch;
            NodeProxy.instance = this;
            this.Common = common(player);
        }
        NodeProxy.prototype.cacheModelData = function (data) {
            return __awaiter$1(this, void 0, void 0, function () {
                var currentNode, instance;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            instance = new nodeWrap(this.player, data);
                            return [4 /*yield*/, this.cacheManagement.createCache(data.node, instance)];
                        case 1:
                            currentNode = _a.sent();
                            return [2 /*return*/, currentNode ? currentNode.instance : instance];
                    }
                });
            });
        };
        /**
         * @description: 根据code查找模型信息
         * @param {string} params
         * @return {*}
         */
        NodeProxy.prototype.getInfoByCODE = function (code) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var res;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.findNode(NodeFindType.codes, [code])];
                        case 1:
                            res = _b.sent();
                            return [2 /*return*/, (_a = res.data) === null || _a === void 0 ? void 0 : _a[0]];
                    }
                });
            });
        };
        /**
         * @description: 根据不同的参数查找模型信息
         * @param {string} type
         * @param {string} param
         * @return {*}
         */
        NodeProxy.prototype.getInfo = function (type, param) {
            return __awaiter$1(this, void 0, void 0, function () {
                var _a, modelData;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = type;
                            switch (_a) {
                                case 'Code': return [3 /*break*/, 1];
                            }
                            return [3 /*break*/, 3];
                        case 1: return [4 /*yield*/, this.getInfoByCODE(param)];
                        case 2:
                            modelData = _b.sent();
                            if (modelData) {
                                return [2 /*return*/, {
                                        status: true,
                                        data: modelData
                                    }];
                            }
                            return [2 /*return*/, {
                                    status: false,
                                    message: '系统错误'
                                }];
                        case 3: return [2 /*return*/, {
                                status: false,
                                message: '当前传入的类型不支持查询模型节点信息。支持查询的列表：Code、SelfId'
                            }];
                    }
                });
            });
        };
        /**
         * @description: 设置节点的显示隐藏
         * @param {Number} node 节点对象/item
         * @param {Boolean} visible 显示/隐藏
         */
        NodeProxy.prototype.setNodeVisible = function (node, visible) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!Array.isArray(node)) {
                                node = [node];
                            }
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.setProperty(node, { visible: visible }))];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * @description: 获取node的父节点信息
         * @param {IPlayer} player
         * @param {Number} node
         * @return {*}
         */
        NodeProxy.prototype.findNodeParent = function (node) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var nodeRes, nodeInfo;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.cacheManagement.findCacheByObject(node)];
                        case 1:
                            nodeRes = _b.sent();
                            if (nodeRes && nodeRes.type === cacheType.Node) {
                                nodeInfo = (_a = nodeRes.parentInstance) === null || _a === void 0 ? void 0 : _a.getDataInfo();
                                return [2 /*return*/, {
                                        status: !!nodeInfo,
                                        data: nodeInfo,
                                        message: ''
                                    }];
                            }
                            return [2 /*return*/, {
                                    status: false,
                                    message: '当前node无效'
                                }];
                    }
                });
            });
        };
        /**
         * @description: 获取node的所有子节点列表
         * @param {IPlayer} player
         * @param {Number} node
         * @return {*}
         */
        NodeProxy.prototype.findNodeChild = function (node) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var childList, nodeInfo, nodeData, i, element, info, nodeInstance;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            childList = [];
                            nodeInfo = this.getNodeInfo(node);
                            if (!nodeInfo) return [3 /*break*/, 6];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.getProperty(nodeInfo.node, [NodeProperty.Children]))
                                // 存储node节点
                            ];
                        case 1:
                            nodeData = _c.sent();
                            i = 0;
                            _c.label = 2;
                        case 2:
                            if (!(i < nodeData.children.length)) return [3 /*break*/, 5];
                            element = nodeData.children[i];
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Node.getProperty(element.node, [NodeProperty.Parent, NodeProperty.Aabb, NodeProperty.Code, NodeProperty.Name, NodeProperty.Visible, NodeProperty.Material]))];
                        case 3:
                            info = _c.sent();
                            nodeInstance = new nodeWrap(this.player, info);
                            this.cacheManagement.createCache(element.node, nodeInstance);
                            childList.push(nodeInstance);
                            _c.label = 4;
                        case 4:
                            i++;
                            return [3 /*break*/, 2];
                        case 5: return [2 /*return*/, {
                                status: true,
                                data: childList,
                                message: ''
                            }];
                        case 6: return [2 /*return*/, {
                                status: false,
                                message: 'node无效'
                            }];
                    }
                });
            });
        };
        /**
         * @description: 获取node信息
         * @param {nodeWrap} node
         * @return {*}
         */
        NodeProxy.prototype.getNodeInfo = function (node) {
            var _a, _b;
            // 判断node是否有效
            var nodeRes = this.cacheManagement.findCacheByObject(node);
            if (nodeRes && (nodeRes.type === cacheType.Node || nodeRes.type === cacheType.LoadNode)) {
                if (nodeRes.type == cacheType.Node) {
                    return (_a = nodeRes.instance) === null || _a === void 0 ? void 0 : _a.getDataInfo();
                }
                return (_b = nodeRes.instance.getDataInfo()) === null || _b === void 0 ? void 0 : _b.nodeInstance.getDataInfo();
            }
            return null;
        };
        /**
         * @description: 根据名称/位号查找node
         * @param {NodeFindType} type 类型：名称、位号
         * @param { Array<string> | string} param 查询参数
         * @return {*}
         */
        NodeProxy.prototype.findNode = function (type, param, startNode) {
            var _a, _b;
            if (startNode === void 0) { startNode = 0; }
            return __awaiter$1(this, void 0, void 0, function () {
                var nodeInfoList, nodeInstanceList, keys, nodeIndex, nodeInfoItem, info, nodeInstance;
                var _c;
                return __generator$1(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (!NodeFindType[type])
                                return [2 /*return*/, { message: '仅支持名称和位号查询', status: false }];
                            if (!Array.isArray(param)) {
                                param = [param];
                            }
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.findNode(startNode, (_c = {}, _c[type] = param, _c)))];
                        case 1:
                            nodeInfoList = _d.sent();
                            if (Object.keys(nodeInfoList).length === 0)
                                return [2 /*return*/, { message: '未找到节点', status: false }];
                            nodeInstanceList = [];
                            keys = Object.keys(nodeInfoList[type]);
                            nodeIndex = 0;
                            _d.label = 2;
                        case 2:
                            if (!(nodeIndex < Object.keys(nodeInfoList[type]).length)) return [3 /*break*/, 6];
                            nodeInfoItem = nodeInfoList[type][keys[nodeIndex]];
                            if (!(nodeInfoItem && nodeInfoItem.node)) return [3 /*break*/, 5];
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Node.getProperty(nodeInfoItem.node, [NodeProperty.Parent, NodeProperty.Aabb, NodeProperty.Code, NodeProperty.Name, NodeProperty.Visible, NodeProperty.Material]))];
                        case 3:
                            info = _d.sent();
                            return [4 /*yield*/, this.cacheModelData(info)];
                        case 4:
                            nodeInstance = _d.sent();
                            nodeInstanceList.push(nodeInstance);
                            _d.label = 5;
                        case 5:
                            nodeIndex++;
                            return [3 /*break*/, 2];
                        case 6: return [2 /*return*/, {
                                status: true,
                                data: nodeInstanceList
                            }];
                    }
                });
            });
        };
        /**
         * @description 获取选中节点
         * @returns
         */
        NodeProxy.prototype.getSelectedNodes = function () {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var node, nodes, i, info, instance;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.getSeletedNodes())];
                        case 1:
                            node = _c.sent();
                            nodes = [];
                            if (!(node && node.length > 0)) return [3 /*break*/, 7];
                            i = 0;
                            _c.label = 2;
                        case 2:
                            if (!(i < node.length)) return [3 /*break*/, 6];
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Node.getProperty(node[i], [NodeProperty.Parent, NodeProperty.Aabb, NodeProperty.Code, NodeProperty.Name, NodeProperty.Visible, NodeProperty.Material]))];
                        case 3:
                            info = _c.sent();
                            return [4 /*yield*/, this.cacheModelData(info)];
                        case 4:
                            instance = _c.sent();
                            nodes.push(instance);
                            _c.label = 5;
                        case 5:
                            i++;
                            return [3 /*break*/, 2];
                        case 6: return [2 /*return*/, {
                                status: true,
                                data: nodes
                            }];
                        case 7: return [2 /*return*/, {
                                status: false
                            }];
                    }
                });
            });
        };
        NodeProxy.prototype.getSeletedNodes = function () {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var node, nodes, i, info, instance;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.getSeletedNodes())];
                        case 1:
                            node = _c.sent();
                            nodes = [];
                            if (!(node && node.length > 0)) return [3 /*break*/, 7];
                            i = 0;
                            _c.label = 2;
                        case 2:
                            if (!(i < node.length)) return [3 /*break*/, 6];
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Node.getProperty(node[i], [NodeProperty.Parent, NodeProperty.Aabb, NodeProperty.Code, NodeProperty.Name, NodeProperty.Visible, NodeProperty.Material]))];
                        case 3:
                            info = _c.sent();
                            return [4 /*yield*/, this.cacheModelData(info)];
                        case 4:
                            instance = _c.sent();
                            nodes.push(instance);
                            _c.label = 5;
                        case 5:
                            i++;
                            return [3 /*break*/, 2];
                        case 6: return [2 /*return*/, {
                                status: true,
                                data: nodes
                            }];
                        case 7: return [2 /*return*/, {
                                status: false
                            }];
                    }
                });
            });
        };
        /**
       * @description 取消节点选中
       * @returns
       */
        NodeProxy.prototype.removeSelectedItem = function (nodes) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var nodeList, includeNull;
                var _this = this;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!Array.isArray(nodes)) {
                                nodes = [nodes];
                            }
                            nodeList = nodes.map(function (node) {
                                // 如果传入的是数字或字符串数字，直接返回
                                if (!isNaN(Number(node))) {
                                    return Number(node);
                                }
                                // 否则尝试获取节点信息
                                var info = _this.getNodeInfo({ id: node });
                                return info === null || info === void 0 ? void 0 : info.node;
                            });
                            includeNull = nodeList.every(function (item) { return item; });
                            if (!includeNull) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: '参数内含有不存在的节点'
                                    }];
                            }
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.unSelectNodes(nodeList))];
                        case 1:
                            _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                }];
                    }
                });
            });
        };
        // 设置透明度
        NodeProxy.prototype.setAlpha = function (alpha) {
            var _a, _b, _c;
            return __awaiter$1(this, void 0, void 0, function () {
                var root;
                return __generator$1(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.getRoot())];
                        case 1:
                            root = _d.sent();
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Node.setProperty(root, { recvGlobalAlpha: 1 }))];
                        case 2:
                            _d.sent();
                            return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.Setting.set("display.colorControl", alpha))];
                        case 3:
                            _d.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        // 设置节点颜色 colorIndex为0恢复颜色
        NodeProxy.prototype.setNodeColor = function (nodes, colorIndex, recvGlobalAlpha) {
            var _a;
            if (recvGlobalAlpha === void 0) { recvGlobalAlpha = false; }
            return __awaiter$1(this, void 0, void 0, function () {
                var options;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            options = { colorIndex: colorIndex };
                            options.recvGlobalAlpha = recvGlobalAlpha ? 3 : 1;
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.setProperty(nodes, options))];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        // 设置材质
        NodeProxy.prototype.setNodeMaterial = function (node, options) {
            var _a, _b, _c, _d;
            return __awaiter$1(this, void 0, void 0, function () {
                var materials, _e, _f, _g, materialList, _h, _j, _k, _i, key, material, _l;
                return __generator$1(this, function (_m) {
                    switch (_m.label) {
                        case 0:
                            _e = this.node_material;
                            _f = node;
                            _g = this.node_material[node];
                            if (_g) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.getMaterials(node)];
                        case 1:
                            _g = (_m.sent());
                            _m.label = 2;
                        case 2:
                            materials = _e[_f] = _g;
                            materialList = [];
                            _h = materials;
                            _j = [];
                            for (_k in _h)
                                _j.push(_k);
                            _i = 0;
                            _m.label = 3;
                        case 3:
                            if (!(_i < _j.length)) return [3 /*break*/, 9];
                            _k = _j[_i];
                            if (!(_k in _h)) return [3 /*break*/, 8];
                            key = _k;
                            if (!Object.prototype.hasOwnProperty.call(materials, key)) return [3 /*break*/, 8];
                            _l = materials[key].material;
                            if (_l) return [3 /*break*/, 5];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Material.clone(key))];
                        case 4:
                            _l = (_m.sent());
                            _m.label = 5;
                        case 5:
                            material = _l;
                            if (!((_b = materials[key]) === null || _b === void 0 ? void 0 : _b.isOriginal)) return [3 /*break*/, 7];
                            materials[key].isOriginal = false;
                            return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.Node.setProperty(materials[key].nodes, { material: material }))];
                        case 6:
                            _m.sent();
                            _m.label = 7;
                        case 7:
                            materialList.push(material);
                            _m.label = 8;
                        case 8:
                            _i++;
                            return [3 /*break*/, 3];
                        case 9: return [4 /*yield*/, ((_d = this.player.Native) === null || _d === void 0 ? void 0 : _d.Material.setProperty(materialList, options))];
                        case 10:
                            _m.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    data: materials
                                }];
                    }
                });
            });
        };
        // 恢复材质
        NodeProxy.prototype.recoverNodeMaterial = function (node) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var materials, _b, _c, _d, _i, key;
                return __generator$1(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            if (!this.node_material[node]) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "\u8BE5\u8282\u70B9".concat(node, "\u6CA1\u6709\u6539\u53D8\u8FC7\u6750\u8D28")
                                    }];
                            }
                            materials = this.node_material[node];
                            _b = materials;
                            _c = [];
                            for (_d in _b)
                                _c.push(_d);
                            _i = 0;
                            _e.label = 1;
                        case 1:
                            if (!(_i < _c.length)) return [3 /*break*/, 4];
                            _d = _c[_i];
                            if (!(_d in _b)) return [3 /*break*/, 3];
                            key = _d;
                            if (!Object.prototype.hasOwnProperty.call(materials, key)) return [3 /*break*/, 3];
                            if (!!materials[key].isOriginal) return [3 /*break*/, 3];
                            materials[key].isOriginal = true;
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.setProperty(materials[key].nodes, { material: materials[key].originalMaterial }))];
                        case 2:
                            _e.sent();
                            _e.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/, {
                                status: true,
                                message: "\u6210\u529F\u6062\u590D\u6750\u8D28"
                            }];
                    }
                });
            });
        };
        // 获取材质
        NodeProxy.prototype.getMaterials = function (nodes) {
            return __awaiter$1(this, void 0, void 0, function () {
                var materials;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            materials = {};
                            return [4 /*yield*/, this.Common.traverseNode(nodes, function (node) {
                                    if (node.material) {
                                        if (!materials[node.material]) {
                                            materials[node.material] = { nodes: [node.node], isOriginal: true, originalMaterial: node.material };
                                        }
                                        else {
                                            materials[node.material].nodes.push(node.node);
                                        }
                                    }
                                }, ["children", "material"])];
                        case 1:
                            _a.sent();
                            return [2 /*return*/, materials];
                    }
                });
            });
        };
        // private async findMatiral(nodes: Array<number>) {
        //     let material = 0
        //     for (let i = 0; i < nodes.length; i++) {
        //         const node = nodes[i]
        //         const res = await this.player.Native?.Node.getProperty(node, ['material'])
        //         material = res.material
        //         if (material) {
        //             break
        //         }
        //     }
        //     if (!material) {
        //         for (let i = 0; i < nodes.length; i++) {
        //             const node = nodes[i]
        //             const children = await this.player.Native?.Node.getProperty(node, ['children'])
        //             if (children.children.length != 0) {
        //                 material = await this.findMatiral(children.children.map((e: INodeInfo) => { return e.node }))
        //             }
        //             if (material) break
        //         }
        //     }
        //     return material
        // }
        /**
         * @description 设置材质颜色
         * @param nodelist
         * @param color
         * @returns
         */
        // private async setMaterialByColor(nodelist: Array<INodeInfo>, color: string, copymaterial: number): Promise<IResponse<null>> {
        //     await this.player.Native?.Material.setProperty(copymaterial, [{ diffuse: color }])
        //     for (let i = 0; i < nodelist.length; i++) {
        //         await this.player.Native?.Node.setProperty(nodelist[i].node, [{ material: copymaterial }])
        //         this.cacheManagement.updateCaheData(nodelist[i].id, 'material', copymaterial)
        //     }
        //     return {
        //         status: true,
        //         message: ''
        //     }
        // }
        /**
         * @description 设置贴图
         * @param nodelist
         * @param imagePath
         * @returns
         */
        // private async setMaterialByImage(nodelist: Array<INodeInfo>, imagePath: string, copymaterial: number) {
        //     const isExistFile = await this.player.Native?.File.exists(imagePath)
        //     if (!isExistFile) {
        //         return {
        //             status: false,
        //             message: '文件不存在'
        //         }
        //     }
        //     const Texture = await this.player.Native?.Texture.create(imagePath)
        //     await this.player.Native?.Material.setProperty(copymaterial, { TEX_ALBEDO: Texture })
        //     for (let i = 0; i < nodelist.length; i++) {
        //         await this.player.Native?.Node.setProperty(nodelist[i].node, [{ material: copymaterial }])
        //         this.cacheManagement.updateCaheData(nodelist[i].id, 'material', copymaterial)
        //     }
        //     return {
        //         status: true,
        //         message: ''
        //     }
        // }
        /**
         *@description 设置模型材质
         * @param nodes
         * @param type
         * @param value
         * @returns
         */
        // public async setNodeMaterial(nodes: Array<string> | string, type: EMaterialType, value: string): Promise<IResponse<null>> {
        //     if (!nodes || nodes.length == 0 || !value || ![0, 1].includes(type)) return {
        //         status: false,
        //         message: '参数错误'
        //     }
        //     if (!Array.isArray(nodes)) { nodes = [nodes] }
        //     const nodeList = nodes.map((node) => {
        //         return this.getNodeInfo({ id: node })
        //     })
        //     const includeNull = nodeList.every((item) => { return item })
        //     if (!includeNull || nodeList.length == 0) {
        //         return {
        //             status: false,
        //             message: '参数内含有不存在的节点'
        //         }
        //     }
        //     let result: IResponse<null> = {
        //         status: false,
        //         message: '设置材质失败'
        //     }
        //     const nodeMaterials = (nodeList as INodeInfo[]).filter((i) => { return i.material })
        //     const material = nodeMaterials.length === 0 ? await this.findMatiral((nodeList as INodeInfo[]).map((i) => { return i.node })) : nodeMaterials[0].material
        //     const copymaterial = await this.player.Native?.Material.clone(material)
        //     switch (type) {
        //         case EMaterialType.color:
        //             result = await this.setMaterialByColor(nodeList as INodeInfo[], value, copymaterial)
        //             break
        //         case EMaterialType.image:
        //             result = await this.setMaterialByImage(nodeList as INodeInfo[], value, copymaterial)
        //             break
        //         default:
        //             break
        //     }
        //     return result
        // }
        //设置node编辑类型
        NodeProxy.prototype.setNodeEditType = function (node, type) {
            var _a, _b, _c;
            return __awaiter$1(this, void 0, void 0, function () {
                var nodeInfo;
                return __generator$1(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, this.getNodeInfo(node)];
                        case 1:
                            nodeInfo = _d.sent();
                            if (!nodeInfo) return [3 /*break*/, 7];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.addNodeToAxisEdit(nodeInfo.node))];
                        case 2:
                            _d.sent();
                            if (!(type === -1)) return [3 /*break*/, 4];
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Node.removeNodeFromAxisEdit(nodeInfo.node))];
                        case 3:
                            _d.sent();
                            return [3 /*break*/, 6];
                        case 4: return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.Node.setAxisEditType(type))];
                        case 5:
                            _d.sent();
                            _d.label = 6;
                        case 6: return [2 /*return*/, {
                                status: true,
                                message: ''
                            }];
                        case 7: return [2 /*return*/, {
                                status: false,
                                message: 'node无效'
                            }];
                    }
                });
            });
        };
        //通过数据设置node节点的位置、旋转、缩放
        NodeProxy.prototype.setNodeLocal = function (node, options) {
            var _a, _b, _c;
            return __awaiter$1(this, void 0, void 0, function () {
                var nodeInfo;
                return __generator$1(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, this.getNodeInfo(node)];
                        case 1:
                            nodeInfo = _d.sent();
                            if (!nodeInfo) return [3 /*break*/, 8];
                            if (!(options.Position && options.Position.length > 0)) return [3 /*break*/, 3];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.setProperty(nodeInfo.node, { localTrans: options.Position }))];
                        case 2:
                            _d.sent();
                            _d.label = 3;
                        case 3:
                            if (!(options.Rotate && options.Rotate.length > 0)) return [3 /*break*/, 5];
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Node.setProperty(nodeInfo.node, { localRot: options.Rotate }))];
                        case 4:
                            _d.sent();
                            _d.label = 5;
                        case 5:
                            if (!(options.Scale && options.Scale.length > 0)) return [3 /*break*/, 7];
                            return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.Node.setProperty(nodeInfo.node, { localScale: options.Scale }))];
                        case 6:
                            _d.sent();
                            _d.label = 7;
                        case 7: return [2 /*return*/, {
                                status: true,
                            }];
                        case 8: return [2 /*return*/, {
                                status: false,
                                message: 'node无效'
                            }];
                    }
                });
            });
        };
        NodeProxy.prototype.destroyNode = function (node) {
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.cacheManagement.deleteCache(node)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/, {
                                    status: true
                                }];
                    }
                });
            });
        };
        /**
         * 批量移除node
         * @param nodeList
         * @returns
         */
        NodeProxy.prototype.destroyNodeList = function (nodeList) {
            return __awaiter$1(this, void 0, void 0, function () {
                var i, nodeItem;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            i = 0;
                            _a.label = 1;
                        case 1:
                            if (!(i < nodeList.length)) return [3 /*break*/, 4];
                            nodeItem = nodeList[i];
                            return [4 /*yield*/, this.cacheManagement.deleteCache(nodeItem)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/, {
                                status: true
                            }];
                    }
                });
            });
        };
        /**
         * getNodeLocation 获取node的位置
         */
        NodeProxy.prototype.getNodeLocation = function (node) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var nodeInfo, data, Position, Rotate, Scale;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.getNodeInfo(node)];
                        case 1:
                            nodeInfo = _b.sent();
                            if (!nodeInfo) return [3 /*break*/, 3];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.getProperty(nodeInfo.node, [NodeProperty.LocalTrans, NodeProperty.LocalRot, NodeProperty.LocalScale]))];
                        case 2:
                            data = _b.sent();
                            Position = data.localTrans;
                            Rotate = data.localRot;
                            Scale = data.localScale;
                            return [2 /*return*/, {
                                    status: true,
                                    data: {
                                        Position: Position,
                                        Rotate: Rotate,
                                        Scale: Scale
                                    },
                                    message: ''
                                }];
                        case 3: return [2 /*return*/, {
                                status: false,
                                message: 'node无效'
                            }];
                    }
                });
            });
        };
        /**
         * 获取node或item的包围盒
         * @param data node/item
         * @returns
         */
        NodeProxy.prototype.getAabb = function (data) {
            return __awaiter$1(this, void 0, void 0, function () {
                var nodeInfo;
                return __generator$1(this, function (_a) {
                    nodeInfo = this.getNodeInfo(data);
                    if (!nodeInfo) {
                        return [2 /*return*/, {
                                status: false,
                                message: "data\u65E0\u6548"
                            }];
                    }
                    return [2 /*return*/, {
                            status: true,
                            data: nodeInfo.aabb
                        }];
                });
            });
        };
        /**
         * @description 设置节点选中
         * @returns
         */
        NodeProxy.prototype.setModelSelect = function (nodes) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var nodeList, includeNull;
                var _this = this;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!Array.isArray(nodes)) {
                                nodes = [nodes];
                            }
                            nodeList = nodes.map(function (node) {
                                // 如果传入的是数字或字符串数字，直接返回
                                if (!isNaN(Number(node))) {
                                    return Number(node);
                                }
                                // 否则尝试获取节点信息
                                var info = _this.getNodeInfo({ id: node });
                                return info === null || info === void 0 ? void 0 : info.node;
                            });
                            includeNull = nodeList.every(function (item) { return item; });
                            if (!includeNull) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: '参数内含有不存在的节点'
                                    }];
                            }
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.selectNodes(nodeList))];
                        case 1:
                            _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                }];
                    }
                });
            });
        };
        /**
         * 创建node
         * @param name 节点名称
         * @param parentNode 父节点，不传默认添加到场景的根节点
         * @returns
         */
        NodeProxy.prototype.createNode = function (name, parentNode) {
            var _a, _b, _c;
            return __awaiter$1(this, void 0, void 0, function () {
                var nodeInfo, createNodePtr, info, nodeInstance;
                return __generator$1(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            nodeInfo = null;
                            if (parentNode) {
                                nodeInfo = this.getNodeInfo(parentNode);
                                if (!nodeInfo) {
                                    return [2 /*return*/, {
                                            status: false,
                                            message: "父节点无效"
                                        }];
                                }
                            }
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.create())];
                        case 1:
                            createNodePtr = _d.sent();
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Node.setProperty(createNodePtr, { name: name, parent: nodeInfo === null || nodeInfo === void 0 ? void 0 : nodeInfo.node }))];
                        case 2:
                            _d.sent();
                            return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.Node.getProperty(createNodePtr, [NodeProperty.Parent, NodeProperty.Aabb, NodeProperty.Code, NodeProperty.Name, NodeProperty.Visible, NodeProperty.Material]))];
                        case 3:
                            info = _d.sent();
                            return [4 /*yield*/, this.cacheModelData(info)];
                        case 4:
                            nodeInstance = _d.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    data: nodeInstance
                                }];
                    }
                });
            });
        };
        //通过数据设置node节点
        NodeProxy.prototype.setNodeInfo = function (node, options) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var nodeInfo, info;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            nodeInfo = this.getNodeInfo(node);
                            if (!nodeInfo) return [3 /*break*/, 3];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.setProperty(nodeInfo.node, options))];
                        case 1:
                            _c.sent();
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Node.getProperty(nodeInfo.node, Object.keys(options)))];
                        case 2:
                            info = _c.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    data: info,
                                    message: ''
                                }];
                        case 3: return [2 /*return*/, {
                                status: false,
                                message: 'node无效'
                            }];
                    }
                });
            });
        };
        /**
         * @description 设置节点的父节点
         * @param {number|string} node
         * @param {number|string} parentNode
         */
        NodeProxy.prototype.setNodeParentByNodePtr = function (node, parentNode) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.setProperty(node, { parent: parentNode }))];
                        case 1:
                            _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    message: '设置成功'
                                }];
                    }
                });
            });
        };
        /**
         * @description 查询根节点
         * @returns
         */
        NodeProxy.prototype.getRoot = function () {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var root, info;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.getRoot())];
                        case 1:
                            root = _c.sent();
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Node.getProperty(root, [NodeProperty.Parent, NodeProperty.Aabb, NodeProperty.Code, NodeProperty.Name, NodeProperty.Visible, NodeProperty.Material]))];
                        case 2:
                            info = _c.sent();
                            return [4 /*yield*/, this.cacheModelData(__assign$2(__assign$2({}, info), { node: root }))];
                        case 3: return [2 /*return*/, _c.sent()];
                    }
                });
            });
        };
        NodeProxy.instance = null;
        return NodeProxy;
    }());

    var axisObjs = [];
    var isAxisEdtingConnection = false;
    var publicDispatch;
    var onEditting = function (param) { return __awaiter$1(void 0, void 0, void 0, function () {
        return __generator$1(this, function (_a) {
            publicDispatch.emit("Axis", {
                status: true,
                message: '编辑完成',
                data: {
                    relativeOffset: param.relativeOffset,
                    absoluteOffset: param.absoluteOffset,
                    axisObject: param.sender,
                    axisRotate: param.axis
                }
            });
            return [2 /*return*/];
        });
    }); };
    var createAxis = function (player, dispatch, axisType, editNode, options) { return __awaiter$1(void 0, void 0, void 0, function () {
        var currentAxisData, i, currentAxisStyle, _a, _b, tmpPs, param;
        var _c, _d, _e, _f;
        return __generator$1(this, function (_g) {
            switch (_g.label) {
                case 0:
                    publicDispatch = dispatch;
                    currentAxisData = {
                        id: generateUUID(),
                        axisObject: [],
                        axisType: axisType,
                    };
                    if (!(options === null || options === void 0 ? void 0 : options.axisNum)) return [3 /*break*/, 5];
                    i = 0;
                    _g.label = 1;
                case 1:
                    if (!(i < (options === null || options === void 0 ? void 0 : options.axisNum))) return [3 /*break*/, 5];
                    currentAxisStyle = (options === null || options === void 0 ? void 0 : options.axisConfigList) ? (options === null || options === void 0 ? void 0 : options.axisConfigList[i]) || {} : {};
                    // 创建轴对象  4.为单轴移动编辑轴
                    _a = currentAxisData.axisObject;
                    _b = i;
                    return [4 /*yield*/, ((_c = player.Native) === null || _c === void 0 ? void 0 : _c.Axis.create(axisType))];
                case 2:
                    // 创建轴对象  4.为单轴移动编辑轴
                    _a[_b] = _g.sent();
                    return [4 /*yield*/, ((_d = player.Native) === null || _d === void 0 ? void 0 : _d.Axis.getProperty(currentAxisData.axisObject[i], ['style', 'position', 'dir']))];
                case 3:
                    tmpPs = _g.sent();
                    param = {};
                    // 轴的风格属性,0:箭头风格;1:圆锥风格
                    param.style = (currentAxisStyle === null || currentAxisStyle === void 0 ? void 0 : currentAxisStyle.axisStyle) || tmpPs.style;
                    (currentAxisStyle === null || currentAxisStyle === void 0 ? void 0 : currentAxisStyle.position) ? param.position = currentAxisStyle === null || currentAxisStyle === void 0 ? void 0 : currentAxisStyle.position : null;
                    (currentAxisStyle === null || currentAxisStyle === void 0 ? void 0 : currentAxisStyle.dir) ? param.dir = currentAxisStyle === null || currentAxisStyle === void 0 ? void 0 : currentAxisStyle.dir : null;
                    (currentAxisStyle === null || currentAxisStyle === void 0 ? void 0 : currentAxisStyle.transform) ? param.transform = currentAxisStyle === null || currentAxisStyle === void 0 ? void 0 : currentAxisStyle.transform : null;
                    (_e = player.Native) === null || _e === void 0 ? void 0 : _e.Axis.setProperty(currentAxisData.axisObject[i], param);
                    _g.label = 4;
                case 4:
                    i += 1;
                    return [3 /*break*/, 1];
                case 5:
                    axisObjs.push(currentAxisData);
                    if (!isAxisEdtingConnection) {
                        (_f = player.Native) === null || _f === void 0 ? void 0 : _f.Axis.EventAxisEditting.connect(onEditting);
                        isAxisEdtingConnection = true;
                    }
                    return [2 /*return*/, {
                            status: true,
                            data: {
                                id: currentAxisData.id
                            },
                            message: "创建成功"
                        }];
            }
        });
    }); };
    /**
     * @description: 更新轴的位置
     * @param {IPlayer} player
     * @param {number} axisIndex
     * @param {IAxisConfig} options
     * @return {*}
     */
    var updateAxis = function (player, id, options) { return __awaiter$1(void 0, void 0, void 0, function () {
        var currentAxis, i, currentAxisStyle, tmpPs, param;
        var _a, _b;
        return __generator$1(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!checkPlayerLoad(player)) {
                        return [2 /*return*/, {
                                status: true,
                                message: 'player无效'
                            }];
                    }
                    currentAxis = axisObjs.find(function (item) {
                        return item.id === id;
                    });
                    if (!((options === null || options === void 0 ? void 0 : options.axisNum) && currentAxis)) return [3 /*break*/, 5];
                    i = 0;
                    _c.label = 1;
                case 1:
                    if (!(i < (options === null || options === void 0 ? void 0 : options.axisNum))) return [3 /*break*/, 4];
                    currentAxisStyle = (options === null || options === void 0 ? void 0 : options.axisConfigList) ? (options === null || options === void 0 ? void 0 : options.axisConfigList[i]) || {} : {};
                    return [4 /*yield*/, ((_a = player.Native) === null || _a === void 0 ? void 0 : _a.Axis.getProperty(currentAxis.axisObject[i], ['style', 'position']))];
                case 2:
                    tmpPs = _c.sent();
                    param = {};
                    // 轴的风格属性,0:箭头风格;1:圆锥风格
                    param.style = (currentAxisStyle === null || currentAxisStyle === void 0 ? void 0 : currentAxisStyle.axisStyle) || tmpPs.style;
                    (currentAxisStyle === null || currentAxisStyle === void 0 ? void 0 : currentAxisStyle.position) ? param.position = currentAxisStyle === null || currentAxisStyle === void 0 ? void 0 : currentAxisStyle.position : null;
                    (currentAxisStyle === null || currentAxisStyle === void 0 ? void 0 : currentAxisStyle.dir) ? param.dir = currentAxisStyle === null || currentAxisStyle === void 0 ? void 0 : currentAxisStyle.dir : null;
                    (currentAxisStyle === null || currentAxisStyle === void 0 ? void 0 : currentAxisStyle.transform) ? param.transform = currentAxisStyle === null || currentAxisStyle === void 0 ? void 0 : currentAxisStyle.transform : null;
                    (_b = player.Native) === null || _b === void 0 ? void 0 : _b.Axis.setProperty(currentAxis.axisObject[i], param);
                    _c.label = 3;
                case 3:
                    i += 1;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, {
                        status: true,
                        message: '更新成功'
                    }];
                case 5: return [2 /*return*/, {
                        status: false,
                        message: '当前轴不存在'
                    }];
            }
        });
    }); };
    var destroyAxis = function (player, id) {
        var _a, _b;
        if (!checkPlayerLoad(player)) {
            return {
                status: true,
                message: 'player无效'
            };
        }
        var currentAxisIndex = axisObjs.findIndex(function (item) {
            return item.id === id;
        });
        if (currentAxisIndex !== -1) {
            (_a = player.Native) === null || _a === void 0 ? void 0 : _a.Axis.clear();
            axisObjs.splice(currentAxisIndex, 1);
            if (axisObjs.length === 0 && isAxisEdtingConnection) {
                (_b = player.Native) === null || _b === void 0 ? void 0 : _b.Axis.EventAxisEditting.disconnect(onEditting);
                isAxisEdtingConnection = false;
            }
            return {
                status: true,
                message: '销毁成功'
            };
        }
        else {
            return {
                status: false,
                message: '当前轴不存在'
            };
        }
    };
    /**
     * @description: 查找当前轴的序号
     * @param {string} id
     * @param {number} axis
     * @return {*}
     */
    var findAxisIndex = function (id, axis) {
        var currentIndex = axisObjs.findIndex(function (el) {
            return el.id === id;
        });
        if (currentIndex !== -1) {
            var axisIndex = axisObjs[currentIndex].axisObject.findIndex(function (el) {
                return el === axis;
            });
            if (axisIndex === -1)
                return {
                    status: false,
                    message: "未在当前id下找到相应的轴"
                };
            return {
                status: true,
                message: "",
                data: axisIndex
            };
        }
        return {
            status: false,
            message: "当前id未创建轴"
        };
    };
    var setAxisVisible = function (player, id, visible) { return __awaiter$1(void 0, void 0, void 0, function () {
        var currentIndex, i, element;
        var _a;
        return __generator$1(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!checkPlayerLoad(player)) {
                        return [2 /*return*/, {
                                status: true,
                                message: 'player无效'
                            }];
                    }
                    currentIndex = axisObjs.findIndex(function (el) {
                        return el.id === id;
                    });
                    if (!(currentIndex !== -1)) return [3 /*break*/, 5];
                    i = 0;
                    _b.label = 1;
                case 1:
                    if (!(i < axisObjs[currentIndex].axisObject.length)) return [3 /*break*/, 4];
                    element = axisObjs[currentIndex].axisObject[i];
                    return [4 /*yield*/, ((_a = player.Native) === null || _a === void 0 ? void 0 : _a.Axis.setProperty(element, {
                            visible: visible,
                        }))];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, {
                        status: true,
                        message: "更新成功"
                    }];
                case 5: return [2 /*return*/, {
                        status: false,
                        message: "当前id未创建轴"
                    }];
            }
        });
    }); };
    var findAxisObject = function (player, id) {
        if (!checkPlayerLoad(player)) {
            return {
                status: true,
                message: 'player无效'
            };
        }
        var currentAxis = axisObjs.find(function (item) {
            return item.id === id;
        });
        if (currentAxis) {
            return {
                status: true,
                data: currentAxis.axisObject,
                message: ''
            };
        }
        else {
            return {
                status: false,
                message: '当前轴不存在'
            };
        }
    };
    var Axis = { createAxis: createAxis, destroyAxis: destroyAxis, updateAxis: updateAxis, findAxisIndex: findAxisIndex, setAxisVisible: setAxisVisible, findAxisObject: findAxisObject };

    var IPanelType;
    (function (IPanelType) {
        IPanelType[IPanelType["singlePanel"] = 0] = "singlePanel";
        IPanelType[IPanelType["doublePanel"] = 1] = "doublePanel";
        IPanelType[IPanelType["ThreePanel"] = 2] = "ThreePanel";
        IPanelType[IPanelType["PolygonPanel"] = 3] = "PolygonPanel";
    })(IPanelType || (IPanelType = {}));
    var Clip = /** @class */ (function (_super) {
        __extends$1(Clip, _super);
        function Clip(cacheManagement, dispatch) {
            var _this = _super.call(this) || this;
            /** 剖切类型 */
            _this.clipType = null;
            /** 剖切对象 */
            _this.clipObj = 0;
            /** 轴相关配置 */
            _this.axisOptions = {
                axisNum: 0,
                axisConfigList: []
            };
            _this.axisConnect = false;
            _this.currentAxisId = '';
            _this.drawPloygonClip = {};
            _this.ploygonClipData = {};
            _this.drawPloygonEndFun = function () { };
            _this.nodeProxy = null;
            _this.dealAxisData = function () { };
            _this.positionByPanel = [];
            _this.cacheManagement = cacheManagement;
            var player = getPlayerData(cacheManagement);
            if (!player) {
                throw new Error("player未加载");
            }
            var nodeProxy = new NodeProxy(cacheManagement, dispatch);
            if (!nodeProxy) {
                throw new Error("node未加载");
            }
            _this.nodeProxy = nodeProxy;
            _this.dispatch = dispatch;
            _this.player = player;
            Clip.instance = _this;
            return _this;
        }
        Clip.prototype.destroyInstance = function () {
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(typeof this.clipType === 'number')) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.cancelClip()];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 2];
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * @description: 获取剖切的数据
         * @param {IPlayer} player
         * @return {*}
         */
        Clip.prototype.getClipData = function () {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var clipData;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.ClipBox.clipData())];
                        case 1:
                            clipData = _b.sent();
                            return [2 /*return*/, {
                                    data: clipData,
                                    status: true,
                                    message: ''
                                }];
                    }
                });
            });
        };
        /**
        * @description: 设置轴或面的可见性
        * @param {IPlayer} player
        * @param {ClipElement} clipElement 剖切元素 Axis 或 Panel
        * @param {boolean} visible 是否可见
        * @return {*}
        */
        Clip.prototype.setVisible = function (clipElement, visible) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var res, i, item, _b, currentData;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            res = {
                                status: false,
                                message: ""
                            };
                            i = 0;
                            _c.label = 1;
                        case 1:
                            if (!(i < clipElement.length)) return [3 /*break*/, 9];
                            item = clipElement[i];
                            _b = item;
                            switch (_b) {
                                case "Axis": return [3 /*break*/, 2];
                                case "Panel": return [3 /*break*/, 4];
                            }
                            return [3 /*break*/, 6];
                        case 2: return [4 /*yield*/, Axis.setAxisVisible(this.player, this.currentAxisId, visible)];
                        case 3:
                            res = _c.sent();
                            return [3 /*break*/, 7];
                        case 4:
                            currentData = this.cacheManagement.findCacheById(this.clipObj);
                            if (!currentData) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "更新失败"
                                    }];
                            }
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.ClipBox.setProperty(this.clipObj, { visible: visible }))];
                        case 5:
                            _c.sent();
                            res = {
                                status: true,
                                message: "更新成功"
                            };
                            return [3 /*break*/, 7];
                        case 6:
                            res = {
                                status: false,
                                message: "clipElement传值错误，当前仅支持存入'Axis'、'Panel'"
                            };
                            return [3 /*break*/, 7];
                        case 7:
                            if (!res.status) {
                                return [2 /*return*/, res];
                            }
                            _c.label = 8;
                        case 8:
                            i++;
                            return [3 /*break*/, 1];
                        case 9: return [2 /*return*/, res];
                    }
                });
            });
        };
        /**
       * @description: 开启多边形创建剖切
       * @param {IPlayer} player
       * @return {*}
       */
        Clip.prototype.startDrawPloygonClip = function (options) {
            var _a, _b, _c, _d, _e, _f;
            return __awaiter$1(this, void 0, void 0, function () {
                var _g, clipInstance;
                return __generator$1(this, function (_h) {
                    switch (_h.label) {
                        case 0:
                            this.clipType = null;
                            _g = this;
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.ClipBox.activeClip())];
                        case 1:
                            _g.clipObj = _h.sent();
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.ClipBox.setClipType(this.clipObj, EClipType.Polygon))];
                        case 2:
                            _h.sent();
                            return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.ClipBox.setIsInside((_d = options === null || options === void 0 ? void 0 : options.setIsInside) !== null && _d !== void 0 ? _d : true))
                                // 将clip缓存
                            ];
                        case 3:
                            _h.sent();
                            clipInstance = new baseWrap({
                                clipObj: this.clipObj,
                                instance: this
                            }, cacheType.Clip);
                            this.cacheManagement.createCache(this.clipObj, clipInstance);
                            return [4 /*yield*/, ((_e = this.player.Native) === null || _e === void 0 ? void 0 : _e.ClipBox.enableSelectPoints(true))
                                // 监听鼠标右键事件
                            ];
                        case 4:
                            _h.sent();
                            // 监听鼠标右键事件
                            this.drawPloygonClip = options || {};
                            (_f = this.player.Native) === null || _f === void 0 ? void 0 : _f.Tools.EventBrowseRClick.connect(this.handelBrowseRClick());
                            return [2 /*return*/, {
                                    status: true,
                                    message: "",
                                }];
                    }
                });
            });
        };
        Clip.prototype.handelBrowseRClick = function () {
            var _this = this;
            var that = this;
            this.drawPloygonEndFun = function (e) { return __awaiter$1(_this, void 0, void 0, function () {
                var VerticesData, upPanel, downPanel;
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
                return __generator$1(this, function (_r) {
                    switch (_r.label) {
                        case 0: return [4 /*yield*/, ((_a = that.player.Native) === null || _a === void 0 ? void 0 : _a.ClipBox.setProperty(that.clipObj, { visible: true }))];
                        case 1:
                            _r.sent();
                            return [4 /*yield*/, ((_b = that.player.Native) === null || _b === void 0 ? void 0 : _b.ClipBox.setEnable(true))];
                        case 2:
                            _r.sent();
                            return [4 /*yield*/, ((_c = that.player.Native) === null || _c === void 0 ? void 0 : _c.ClipBox.clipPolygonInit(that.clipObj, (_e = (_d = that.drawPloygonClip) === null || _d === void 0 ? void 0 : _d.height) !== null && _e !== void 0 ? _e : 2, (_g = (_f = that.drawPloygonClip) === null || _f === void 0 ? void 0 : _f.ratio) !== null && _g !== void 0 ? _g : 0))
                                // await that.player.Native?.ClipBox.setSideTexture(that.clipObj, that.drawPloygonClip.textureStyle?.sideTexture ?? 'data://icon/side.jpg')
                                // await that.player.Native?.ClipBox.setBottomTexture(
                                //   that.clipObj,
                                //   that.drawPloygonClip.textureStyle?.bottomTexture ?? 'data://icon/bottom.jpg'
                                // )
                            ];
                        case 3:
                            VerticesData = _r.sent();
                            // await that.player.Native?.ClipBox.setSideTexture(that.clipObj, that.drawPloygonClip.textureStyle?.sideTexture ?? 'data://icon/side.jpg')
                            // await that.player.Native?.ClipBox.setBottomTexture(
                            //   that.clipObj,
                            //   that.drawPloygonClip.textureStyle?.bottomTexture ?? 'data://icon/bottom.jpg'
                            // )
                            return [4 /*yield*/, ((_h = that.player.Native) === null || _h === void 0 ? void 0 : _h.ClipBox.enableSelectPoints(false))
                                // 获取上顶面数据
                            ];
                        case 4:
                            // await that.player.Native?.ClipBox.setSideTexture(that.clipObj, that.drawPloygonClip.textureStyle?.sideTexture ?? 'data://icon/side.jpg')
                            // await that.player.Native?.ClipBox.setBottomTexture(
                            //   that.clipObj,
                            //   that.drawPloygonClip.textureStyle?.bottomTexture ?? 'data://icon/bottom.jpg'
                            // )
                            _r.sent();
                            return [4 /*yield*/, ((_j = that.player.Native) === null || _j === void 0 ? void 0 : _j.ClipBox.panelVertices(that.clipObj, VerticesData.length - 1))
                                // 获取上底面数据
                            ];
                        case 5:
                            upPanel = _r.sent();
                            return [4 /*yield*/, ((_k = that.player.Native) === null || _k === void 0 ? void 0 : _k.ClipBox.panelVertices(that.clipObj, VerticesData.length))];
                        case 6:
                            downPanel = _r.sent();
                            that.ploygonClipData = {
                                VerticesData: VerticesData,
                                height: (_m = (_l = that.drawPloygonClip) === null || _l === void 0 ? void 0 : _l.height) !== null && _m !== void 0 ? _m : 1,
                                ratio: (_p = (_o = that.drawPloygonClip) === null || _o === void 0 ? void 0 : _o.ratio) !== null && _p !== void 0 ? _p : 0,
                                upPanel: upPanel,
                                downPanel: downPanel
                            };
                            (_q = that.player.Native) === null || _q === void 0 ? void 0 : _q.Tools.EventBrowseRClick.disconnect(that.drawPloygonEndFun);
                            this.dispatch.emit("Clip", {
                                status: true,
                                message: '',
                                data: {
                                    clipData: this.ploygonClipData
                                }
                            });
                            return [2 /*return*/];
                    }
                });
            }); };
            return this.drawPloygonEndFun;
        };
        /**
           * @description: 获取当前的剖切数据
           * @return {*}
           */
        Clip.prototype.getPloygonClipData = function () {
            if (this.clipObj && Object.values(this.ploygonClipData).length !== 0) {
                return {
                    status: true,
                    message: '',
                    data: this.ploygonClipData
                };
            }
            return {
                status: false,
                message: '当前无剖切数据',
            };
        };
        Clip.prototype.setPloyonClipData = function (options) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __awaiter$1(this, void 0, void 0, function () {
                var _u, _v, _w;
                return __generator$1(this, function (_x) {
                    switch (_x.label) {
                        case 0:
                            this.clipType = null;
                            if (!!this.clipObj) return [3 /*break*/, 5];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.ClipBox.setIsInside(true))];
                        case 1:
                            _x.sent();
                            _u = this;
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.ClipBox.activeClip())];
                        case 2:
                            _u.clipObj = _x.sent();
                            return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.ClipBox.setClipType(this.clipObj, 4))];
                        case 3:
                            _x.sent();
                            return [4 /*yield*/, ((_d = this.player.Native) === null || _d === void 0 ? void 0 : _d.ClipBox.enableSelectPoints(true))];
                        case 4:
                            _x.sent();
                            _x.label = 5;
                        case 5:
                            this.ploygonClipData.VerticesData = (_e = options === null || options === void 0 ? void 0 : options.VerticesData) !== null && _e !== void 0 ? _e : this.ploygonClipData.VerticesData;
                            this.ploygonClipData.height = (_f = options === null || options === void 0 ? void 0 : options.height) !== null && _f !== void 0 ? _f : this.ploygonClipData.height;
                            this.ploygonClipData.ratio = (_g = options === null || options === void 0 ? void 0 : options.ratio) !== null && _g !== void 0 ? _g : this.ploygonClipData.ratio;
                            return [4 /*yield*/, ((_h = this.player.Native) === null || _h === void 0 ? void 0 : _h.ClipBox.setEnable(true))];
                        case 6:
                            _x.sent();
                            return [4 /*yield*/, ((_j = this.player.Native) === null || _j === void 0 ? void 0 : _j.ClipBox.clipPolygonInitByPoint(this.clipObj, (_k = options === null || options === void 0 ? void 0 : options.VerticesData) !== null && _k !== void 0 ? _k : this.ploygonClipData.VerticesData, (_l = options === null || options === void 0 ? void 0 : options.height) !== null && _l !== void 0 ? _l : this.ploygonClipData.height, (_m = options === null || options === void 0 ? void 0 : options.ratio) !== null && _m !== void 0 ? _m : this.ploygonClipData.ratio))];
                        case 7:
                            _x.sent();
                            if (!(options === null || options === void 0 ? void 0 : options.offset)) return [3 /*break*/, 9];
                            return [4 /*yield*/, ((_o = this.player.Native) === null || _o === void 0 ? void 0 : _o.ClipBox.setProperty(this.clipObj, { localTrans: options.offset }))
                                // 更新顶点数据
                            ];
                        case 8:
                            _x.sent();
                            // 更新顶点数据
                            this.ploygonClipData.VerticesData = (_p = this.ploygonClipData.VerticesData) === null || _p === void 0 ? void 0 : _p.map(function (el) {
                                if (options.offset) {
                                    return [el[0] + options.offset[0], el[1] + options.offset[1], el[2] + options.offset[2],];
                                }
                                return el;
                            });
                            _x.label = 9;
                        case 9:
                            // 更新面数据
                            // 获取上顶面数据
                            _v = this.ploygonClipData;
                            return [4 /*yield*/, ((_q = this.player.Native) === null || _q === void 0 ? void 0 : _q.ClipBox.panelVertices(this.clipObj, this.ploygonClipData.VerticesData.length - 1))
                                // 获取上底面数据
                            ];
                        case 10:
                            // 更新面数据
                            // 获取上顶面数据
                            _v.upPanel = _x.sent();
                            // 获取上底面数据
                            _w = this.ploygonClipData;
                            return [4 /*yield*/, ((_r = this.player.Native) === null || _r === void 0 ? void 0 : _r.ClipBox.panelVertices(this.clipObj, this.ploygonClipData.VerticesData.length))
                                // await this.player.Native?.ClipBox.setSideTexture(this.clipObj, options?.textureStyle?.sideTexture ?? 'data://icon/side.jpg')
                                // await this.player.Native?.ClipBox.setBottomTexture(
                                //   this.clipObj,
                                //   options?.textureStyle?.bottomTexture ??
                                //   'data://icon/bottom.jpg'
                                // )
                            ];
                        case 11:
                            // 获取上底面数据
                            _w.downPanel = _x.sent();
                            // await this.player.Native?.ClipBox.setSideTexture(this.clipObj, options?.textureStyle?.sideTexture ?? 'data://icon/side.jpg')
                            // await this.player.Native?.ClipBox.setBottomTexture(
                            //   this.clipObj,
                            //   options?.textureStyle?.bottomTexture ??
                            //   'data://icon/bottom.jpg'
                            // )
                            return [4 /*yield*/, ((_s = this.player.Native) === null || _s === void 0 ? void 0 : _s.ClipBox.setProperty(this.clipObj, { visible: true }))];
                        case 12:
                            // await this.player.Native?.ClipBox.setSideTexture(this.clipObj, options?.textureStyle?.sideTexture ?? 'data://icon/side.jpg')
                            // await this.player.Native?.ClipBox.setBottomTexture(
                            //   this.clipObj,
                            //   options?.textureStyle?.bottomTexture ??
                            //   'data://icon/bottom.jpg'
                            // )
                            _x.sent();
                            return [4 /*yield*/, ((_t = this.player.Native) === null || _t === void 0 ? void 0 : _t.ClipBox.enableSelectPoints(false))];
                        case 13:
                            _x.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    message: "",
                                    data: this.ploygonClipData
                                }];
                    }
                });
            });
        };
        /**
           * @description: 取消多边形剖切
           * @param {IPlayer} player
           * @return {*}
           */
        Clip.prototype.cancelPloygonClip = function () {
            var _a, _b, _c, _d, _e;
            return __awaiter$1(this, void 0, void 0, function () {
                var currentClipCache;
                return __generator$1(this, function (_f) {
                    switch (_f.label) {
                        case 0:
                            (_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Tools.EventBrowseRClick.disconnect(this.drawPloygonEndFun);
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.ClipBox.setEnable(false))
                                // 清除缓存
                            ];
                        case 1:
                            _f.sent();
                            currentClipCache = this.cacheManagement.findCacheById(this.clipObj);
                            if (currentClipCache === null || currentClipCache === void 0 ? void 0 : currentClipCache.instance) {
                                this.cacheManagement.deleteCache(currentClipCache === null || currentClipCache === void 0 ? void 0 : currentClipCache.instance);
                            }
                            if (!this.clipObj) return [3 /*break*/, 4];
                            return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.ClipBox.setProperty(this.clipObj, { visible: false }))];
                        case 2:
                            _f.sent();
                            return [4 /*yield*/, ((_d = this.player.Native) === null || _d === void 0 ? void 0 : _d.ClipBox.enableSelectPoints(false))];
                        case 3:
                            _f.sent();
                            _f.label = 4;
                        case 4: return [4 /*yield*/, ((_e = this.player.Native) === null || _e === void 0 ? void 0 : _e.ClipBox.setLocalDisable())];
                        case 5:
                            _f.sent();
                            this.ploygonClipData = {};
                            this.clipObj = 0;
                            this.clipType = null;
                            return [2 /*return*/];
                    }
                });
            });
        };
        // 获取被剖掉的对象
        Clip.prototype.getClipObjects = function () {
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_a) {
                    return [2 /*return*/, {
                            status: true,
                            message: '',
                        }];
                });
            });
        };
        // 设置剖切对象
        Clip.prototype.setClipItem = function (items) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var itemList, i, element, currentDataNode, currentDataInfo;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            itemList = [];
                            for (i = 0; i < items.length; i++) {
                                element = items[i];
                                currentDataNode = this.cacheManagement.findCacheByObject(element);
                                if (currentDataNode && (currentDataNode.type === cacheType.Node || currentDataNode.type === cacheType.LoadNode)) {
                                    currentDataInfo = (_a = currentDataNode.instance) === null || _a === void 0 ? void 0 : _a.getDataInfo();
                                    if (currentDataInfo && currentDataInfo.item !== 0) {
                                        itemList.push(currentDataInfo.node);
                                    }
                                }
                            }
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.ClipBox.setLocalEnable(itemList))];
                        case 1:
                            _c.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    message: "\u6210\u529F\u8BBE\u7F6E".concat(itemList.length, "\u4E2A"),
                                }];
                    }
                });
            });
        };
        /** 通过剖切盒子更新剖切数据 */
        Clip.prototype.updateClipDataByAabb = function (aabb) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var axisOptions, currentAabbRes, currentAabb, panelList, i, afterPanel, beforePanel, relativeOffset, i, axisStyle;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            axisOptions = {};
                            if (this.clipType !== EClipType.box) {
                                return [2 /*return*/, {
                                        status: false,
                                        mesaage: '通过aabb构造时，需要使用盒子剖切'
                                    }];
                            }
                            return [4 /*yield*/, this.getClipAabb()];
                        case 1:
                            currentAabbRes = _b.sent();
                            if (!(currentAabbRes && currentAabbRes.status)) return [3 /*break*/, 11];
                            currentAabb = currentAabbRes.data;
                            panelList = ['X', "XN", 'Y', 'YN', "Z", 'ZN'];
                            i = 0;
                            _b.label = 2;
                        case 2:
                            if (!(i < 6)) return [3 /*break*/, 5];
                            afterPanel = Aabb.faceCenter(currentAabb, panelList[i]);
                            beforePanel = Aabb.faceCenter(aabb, panelList[i]);
                            relativeOffset = Vec3.sub(beforePanel, afterPanel);
                            switch (panelList[i]) {
                                case 'X':
                                case 'XN':
                                    relativeOffset = [relativeOffset[0], 0, 0];
                                    break;
                                case 'Y':
                                case 'YN':
                                    relativeOffset = [0, relativeOffset[1], 0];
                                    break;
                                case 'Z':
                                case 'ZN':
                                    relativeOffset = [0, 0, relativeOffset[2]];
                                    break;
                            }
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.ClipBox.movePanel(this.clipObj, relativeOffset, i))];
                        case 3:
                            _b.sent();
                            _b.label = 4;
                        case 4:
                            i++;
                            return [3 /*break*/, 2];
                        case 5:
                            // 包围盒固定为6个面
                            axisOptions.axisNum = 6;
                            i = 0;
                            _b.label = 6;
                        case 6:
                            if (!(i < 6)) return [3 /*break*/, 9];
                            axisStyle = {};
                            return [4 /*yield*/, this.computedAxisStyle(i)];
                        case 7:
                            // 计算轴的位置
                            axisStyle = _b.sent();
                            if (axisOptions === null || axisOptions === void 0 ? void 0 : axisOptions.axisConfigList) {
                                axisOptions.axisConfigList[i] = axisStyle;
                            }
                            else {
                                axisOptions.axisConfigList = [];
                                axisOptions.axisConfigList[i] = axisStyle;
                            }
                            _b.label = 8;
                        case 8:
                            i += 1;
                            return [3 /*break*/, 6];
                        case 9: return [4 /*yield*/, Axis.updateAxis(this.player, this.currentAxisId, axisOptions)];
                        case 10:
                            _b.sent();
                            return [2 /*return*/, {
                                    status: true
                                }];
                        case 11: return [2 /*return*/, {
                                status: false,
                                message: '获取包围盒错误'
                            }];
                    }
                });
            });
        };
        /** 获取剖切的包围盒 */
        Clip.prototype.getClipAabb = function () {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var min, max, upVertices, downVertices, i, upPoint, i, downPoint;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            min = [Infinity, Infinity, Infinity];
                            max = [-Infinity, -Infinity, -Infinity];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.ClipBox.panelVertices(this.clipObj, 4))
                                // 下底面
                            ];
                        case 1:
                            upVertices = _c.sent();
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.ClipBox.panelVertices(this.clipObj, 5))];
                        case 2:
                            downVertices = _c.sent();
                            for (i = 0; i < upVertices.length; i++) {
                                upPoint = upVertices[i];
                                if (upPoint[0] < min[0] || upPoint[1] < min[1] || upPoint[2] < min[2]) {
                                    min = upPoint;
                                }
                                if (upPoint[0] > max[0] || upPoint[1] > max[1] || upPoint[2] > max[2]) {
                                    max = upPoint;
                                }
                            }
                            for (i = 0; i < downVertices.length; i++) {
                                downPoint = downVertices[i];
                                if (downPoint[0] < min[0] || downPoint[1] < min[1] || downPoint[2] < min[2]) {
                                    min = downPoint;
                                }
                                if (downPoint[0] > max[0] || downPoint[1] > max[1] || downPoint[2] > max[2]) {
                                    max = downPoint;
                                }
                            }
                            return [2 /*return*/, {
                                    status: true,
                                    data: [min, max]
                                }];
                    }
                });
            });
        };
        Clip.prototype.createCilpBoxByNode = function (currentNode) {
            var _a, _b, _c;
            return __awaiter$1(this, void 0, void 0, function () {
                var nodeInfo, itemAabbData;
                return __generator$1(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            nodeInfo = (_a = this.nodeProxy) === null || _a === void 0 ? void 0 : _a.getNodeInfo(currentNode);
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Node.getProperty(nodeInfo === null || nodeInfo === void 0 ? void 0 : nodeInfo.node, ['aabb']))];
                        case 1:
                            itemAabbData = _d.sent();
                            return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.ClipBox.initByAabb(this.clipObj, itemAabbData.aabb))];
                        case 2:
                            _d.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        Clip.prototype.createClipObjectByBox = function (options, currentNode) {
            var _a, _b, _c, _d, _e;
            return __awaiter$1(this, void 0, void 0, function () {
                var _f, i, axisStyle;
                return __generator$1(this, function (_g) {
                    switch (_g.label) {
                        case 0:
                            // 盒子剖切
                            _f = this;
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.ClipBox.activeClip())];
                        case 1:
                            // 盒子剖切
                            _f.clipObj = _g.sent();
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.ClipBox.setClipType(this.clipObj, EClipType.box))
                                // 根据剖切数据初始化
                            ];
                        case 2:
                            _g.sent();
                            if (!options.clipData) return [3 /*break*/, 4];
                            // 设置剖切数据
                            return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.ClipBox.initByClipData(this.clipObj, options.clipData, options.panelSize))];
                        case 3:
                            // 设置剖切数据
                            _g.sent();
                            return [3 /*break*/, 9];
                        case 4:
                            if (!(options.aabb && options.aabb.length)) return [3 /*break*/, 6];
                            // 根据aabb初始化
                            return [4 /*yield*/, ((_d = this.player.Native) === null || _d === void 0 ? void 0 : _d.ClipBox.initByAabb(this.clipObj, options.aabb))];
                        case 5:
                            // 根据aabb初始化
                            _g.sent();
                            return [3 /*break*/, 9];
                        case 6:
                            if (!currentNode) return [3 /*break*/, 8];
                            return [4 /*yield*/, this.createCilpBoxByNode(currentNode)];
                        case 7:
                            _g.sent();
                            return [3 /*break*/, 9];
                        case 8: return [2 /*return*/, false];
                        case 9:
                            this.axisOptions.axisNum = 6;
                            i = 0;
                            _g.label = 10;
                        case 10:
                            if (!(i < 6)) return [3 /*break*/, 13];
                            axisStyle = {};
                            return [4 /*yield*/, this.computedAxisStyle(i)];
                        case 11:
                            // 计算轴的位置
                            axisStyle = _g.sent();
                            if ((_e = this.axisOptions) === null || _e === void 0 ? void 0 : _e.axisConfigList) {
                                this.axisOptions.axisConfigList[i] = axisStyle;
                            }
                            else {
                                this.axisOptions.axisConfigList = [];
                                this.axisOptions.axisConfigList[i] = axisStyle;
                            }
                            _g.label = 12;
                        case 12:
                            i += 1;
                            return [3 /*break*/, 10];
                        case 13: return [2 /*return*/, true];
                    }
                });
            });
        };
        Clip.prototype.createClipObjectByPanel = function (type, options) {
            var _a, _b, _c, _d, _e, _f;
            return __awaiter$1(this, void 0, void 0, function () {
                var typeMap, _g, localTrans, dir, nodeInfo, data, _h;
                var _j;
                return __generator$1(this, function (_k) {
                    switch (_k.label) {
                        case 0:
                            typeMap = (_j = {},
                                _j[IPanelType.singlePanel] = {
                                    active: 1,
                                    init: 'clipPanelInitByPoint'
                                },
                                _j[IPanelType.doublePanel] = {
                                    active: 2,
                                    init: 'clipTwoPanelInitByPoints'
                                },
                                _j[IPanelType.ThreePanel] = {
                                    active: 3,
                                    init: 'clipThreePanelInitByPoints'
                                },
                                _j);
                            _g = this;
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.ClipBox.activeClip())];
                        case 1:
                            _g.clipObj = _k.sent();
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.ClipBox.setClipType(this.clipObj, typeMap[type].active))];
                        case 2:
                            _k.sent();
                            localTrans = [0, 0, 0];
                            dir = [1, 1, 1];
                            if (!options.clipData) return [3 /*break*/, 3];
                            // 设置剖切数据
                            // await this.player.Native?.ClipBox.initByClipData(this.clipObj, options.clipData, options.panelSize)
                            // await this.player.Native?.ClipBox.setClipData( options.clipData )
                            localTrans = options.clipData.center;
                            return [3 /*break*/, 6];
                        case 3:
                            if (!options.node) return [3 /*break*/, 6];
                            return [4 /*yield*/, ((_c = this.nodeProxy) === null || _c === void 0 ? void 0 : _c.getNodeInfo(options === null || options === void 0 ? void 0 : options.node))];
                        case 4:
                            nodeInfo = _k.sent();
                            if (!nodeInfo) return [3 /*break*/, 6];
                            return [4 /*yield*/, ((_d = this.player.Native) === null || _d === void 0 ? void 0 : _d.Node.getProperty(nodeInfo === null || nodeInfo === void 0 ? void 0 : nodeInfo.node, ['localTrans']))];
                        case 5:
                            data = _k.sent();
                            localTrans = data.localTrans;
                            _k.label = 6;
                        case 6:
                            if (!(type === IPanelType.singlePanel)) return [3 /*break*/, 8];
                            return [4 /*yield*/, ((_e = this.player.Native) === null || _e === void 0 ? void 0 : _e.ClipBox.initByPoint(this.clipObj, localTrans, dir, [options.panelSize[0], options.panelSize[1]]))];
                        case 7:
                            _k.sent();
                            return [3 /*break*/, 10];
                        case 8: return [4 /*yield*/, ((_f = this.player.Native) === null || _f === void 0 ? void 0 : _f.ClipBox.initByPoints(this.clipObj, localTrans, dir, options.panelSize))];
                        case 9:
                            _k.sent();
                            _k.label = 10;
                        case 10:
                            this.axisOptions.axisNum = 1;
                            _h = this;
                            return [4 /*yield*/, this.computedTransform(this.clipObj)];
                        case 11:
                            _h.positionByPanel = _k.sent();
                            this.axisOptions.axisConfigList = [{
                                    position: this.positionByPanel
                                }];
                            return [2 /*return*/];
                    }
                });
            });
        };
        Clip.prototype.computedAxisStyle = function (index) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var axisStyle, tmpTR, d;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            axisStyle = {};
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.ClipBox.panelTRMatrix(this.clipObj, index))];
                        case 1:
                            tmpTR = _b.sent();
                            d = Matrix4.decompose(tmpTR);
                            axisStyle.position = d.position;
                            axisStyle.dir = Matrix4.multiplyDir(d.rotation, [0, 0, 1]);
                            axisStyle.axisStyle = IAxisStyle.cone;
                            return [2 /*return*/, axisStyle];
                    }
                });
            });
        };
        Clip.prototype.computedTransform = function (clipNode) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var clipObjMat;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.getProperty(clipNode, ['localTrans']))];
                        case 1:
                            clipObjMat = _b.sent();
                            return [2 /*return*/, clipObjMat.localTrans];
                    }
                });
            });
        };
        Clip.prototype.handelAxisChange = function () {
            var _this = this;
            var that = this;
            this.dealAxisData = function (e) { return __awaiter$1(_this, void 0, void 0, function () {
                var currentData, axisOptions, currentAxisIndex, aabb, _a, axisIndexRes, i, axisStyle, aabbRes, clipData;
                var _b, _c, _d, _e, _f;
                return __generator$1(this, function (_g) {
                    switch (_g.label) {
                        case 0:
                            currentData = e.data;
                            if (!currentData)
                                return [2 /*return*/];
                            axisOptions = {};
                            currentAxisIndex = -1;
                            aabb = [];
                            _a = that.clipType;
                            switch (_a) {
                                case EClipType.box: return [3 /*break*/, 1];
                                case EClipType.singlePanel: return [3 /*break*/, 9];
                                case EClipType.doublePanel: return [3 /*break*/, 9];
                                case EClipType.ThreePanel: return [3 /*break*/, 9];
                            }
                            return [3 /*break*/, 11];
                        case 1: return [4 /*yield*/, Axis.findAxisIndex(that.currentAxisId, currentData.axisObject)];
                        case 2:
                            axisIndexRes = _g.sent();
                            if (axisIndexRes && axisIndexRes.status) {
                                currentAxisIndex = (_b = axisIndexRes.data) !== null && _b !== void 0 ? _b : -1;
                            }
                            if (currentAxisIndex === -1)
                                return [2 /*return*/];
                            return [4 /*yield*/, ((_c = that.player.Native) === null || _c === void 0 ? void 0 : _c.ClipBox.movePanel(that.clipObj, currentData.relativeOffset, currentAxisIndex))
                                // 包围盒固定为6个面
                            ];
                        case 3:
                            _g.sent();
                            // 包围盒固定为6个面
                            axisOptions.axisNum = 6;
                            i = 0;
                            _g.label = 4;
                        case 4:
                            if (!(i < 6)) return [3 /*break*/, 7];
                            axisStyle = {};
                            return [4 /*yield*/, this.computedAxisStyle(i)];
                        case 5:
                            // 计算轴的位置
                            axisStyle = _g.sent();
                            if (axisOptions === null || axisOptions === void 0 ? void 0 : axisOptions.axisConfigList) {
                                axisOptions.axisConfigList[i] = axisStyle;
                            }
                            else {
                                axisOptions.axisConfigList = [];
                                axisOptions.axisConfigList[i] = axisStyle;
                            }
                            _g.label = 6;
                        case 6:
                            i += 1;
                            return [3 /*break*/, 4];
                        case 7: return [4 /*yield*/, this.getClipAabb()];
                        case 8:
                            aabbRes = _g.sent();
                            if (aabbRes && aabbRes.status) {
                                aabb = (_d = aabbRes.data) !== null && _d !== void 0 ? _d : [];
                            }
                            return [3 /*break*/, 12];
                        case 9:
                            this.positionByPanel[0] += currentData.relativeOffset[0];
                            this.positionByPanel[1] += currentData.relativeOffset[1];
                            this.positionByPanel[2] += currentData.relativeOffset[2];
                            return [4 /*yield*/, ((_e = that.player.Native) === null || _e === void 0 ? void 0 : _e.ClipBox.setProperty(that.clipObj, { localTrans: this.positionByPanel }))];
                        case 10:
                            _g.sent();
                            axisOptions.axisNum = 1;
                            axisOptions.axisConfigList = [{
                                    position: this.positionByPanel
                                }];
                            return [3 /*break*/, 12];
                        case 11: return [3 /*break*/, 12];
                        case 12:
                            Axis.updateAxis(that.player, that.currentAxisId, axisOptions);
                            return [4 /*yield*/, ((_f = that.player.Native) === null || _f === void 0 ? void 0 : _f.ClipBox.clipData())];
                        case 13:
                            clipData = _g.sent();
                            this.dispatch.emit("Clip", {
                                status: true,
                                message: '',
                                data: {
                                    clipData: clipData,
                                    aabb: aabb
                                }
                            });
                            return [2 /*return*/];
                    }
                });
            }); };
            return this.dealAxisData;
        };
        /**
         * 根据类型创建剖切对象
         */
        Clip.prototype.createClip = function (clipDataType, clipType, options) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            return __awaiter$1(this, void 0, void 0, function () {
                var currentNode, currentAabb, currentClipData, _l, nodeInfo, _m, status_1, clipInstance, currentNodeInfo, axisData;
                return __generator$1(this, function (_o) {
                    switch (_o.label) {
                        case 0: return [4 /*yield*/, this.cancelClip()];
                        case 1:
                            _o.sent();
                            currentNode = undefined;
                            currentAabb = [];
                            currentClipData = null;
                            _l = clipDataType;
                            switch (_l) {
                                case EClipDataType.aabb: return [3 /*break*/, 2];
                                case EClipDataType.node: return [3 /*break*/, 3];
                                case EClipDataType.clipData: return [3 /*break*/, 5];
                            }
                            return [3 /*break*/, 6];
                        case 2:
                            // 通过aabb创建剖切
                            if (!(options === null || options === void 0 ? void 0 : options.aabb) || ((_a = options === null || options === void 0 ? void 0 : options.aabb) === null || _a === void 0 ? void 0 : _a.length) < 2) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: 'options中未传入aabb, 或aabb不符合规范'
                                    }];
                            }
                            if (clipType !== EClipType.box) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: '通过aabb剖切时需要指定为盒子剖切'
                                    }];
                            }
                            if (options === null || options === void 0 ? void 0 : options.setPartCilp) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: '通过aabb剖切时需要为全局剖切'
                                    }];
                            }
                            currentAabb = options.aabb;
                            return [3 /*break*/, 7];
                        case 3:
                            // 通过node创建剖切
                            if (!(options === null || options === void 0 ? void 0 : options.node)) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: 'options中未传入node'
                                    }];
                            }
                            return [4 /*yield*/, ((_b = this.nodeProxy) === null || _b === void 0 ? void 0 : _b.getNodeInfo(options === null || options === void 0 ? void 0 : options.node))];
                        case 4:
                            nodeInfo = _o.sent();
                            if (!nodeInfo)
                                return [2 /*return*/, {
                                        status: false,
                                        message: 'options中的node无效'
                                    }
                                    // if (options?.setPartCilp) {
                                    //   return {
                                    //     status: false,
                                    //     message: '通过node剖切时需要为全局剖切'
                                    //   }
                                    // }
                                ];
                            // if (options?.setPartCilp) {
                            //   return {
                            //     status: false,
                            //     message: '通过node剖切时需要为全局剖切'
                            //   }
                            // }
                            currentNode = options === null || options === void 0 ? void 0 : options.node;
                            return [3 /*break*/, 7];
                        case 5:
                            // 通过clipData创建剖切
                            if (!(options === null || options === void 0 ? void 0 : options.clipData)) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: 'options中未传入clipData'
                                    }];
                            }
                            currentClipData = options === null || options === void 0 ? void 0 : options.clipData;
                            return [3 /*break*/, 7];
                        case 6: return [2 /*return*/, {
                                status: false,
                                message: '当前剖切数据类型不支持'
                            }];
                        case 7:
                            // 设置默认值，面剖切默认使用移动编辑轴， 盒子剖切默认使用单轴移动轴
                            options = {
                                axisType: ((_c = options === null || options === void 0 ? void 0 : options.axisType) !== null && _c !== void 0 ? _c : EClipType.box === clipType) ? IAxisType.EditAxisTypeSingleMove : IAxisType.EditAxisTypeMove,
                                setIsInside: (_d = options === null || options === void 0 ? void 0 : options.setIsInside) !== null && _d !== void 0 ? _d : true,
                                setPartCilp: (_e = options === null || options === void 0 ? void 0 : options.setPartCilp) !== null && _e !== void 0 ? _e : false,
                                panelSize: (options === null || options === void 0 ? void 0 : options.panelSize) || [3, 3, 3],
                                aabb: currentAabb,
                                node: currentNode,
                                clipData: currentClipData || undefined
                            };
                            // 创建编辑轴
                            if (!this.axisConnect) {
                                this.axisConnect = true;
                                this.dispatch.on("Axis", this.handelAxisChange());
                            }
                            _m = clipType;
                            switch (_m) {
                                case EClipType.box: return [3 /*break*/, 8];
                                case EClipType.singlePanel: return [3 /*break*/, 10];
                                case EClipType.doublePanel: return [3 /*break*/, 12];
                                case EClipType.ThreePanel: return [3 /*break*/, 14];
                            }
                            return [3 /*break*/, 16];
                        case 8: return [4 /*yield*/, this.createClipObjectByBox(options, currentNode)];
                        case 9:
                            status_1 = _o.sent();
                            if (!status_1)
                                return [2 /*return*/, {
                                        message: '创建剖切失败',
                                        status: false,
                                    }];
                            return [3 /*break*/, 17];
                        case 10: return [4 /*yield*/, this.createClipObjectByPanel(IPanelType.singlePanel, options)];
                        case 11:
                            _o.sent();
                            return [3 /*break*/, 17];
                        case 12: return [4 /*yield*/, this.createClipObjectByPanel(IPanelType.doublePanel, options)];
                        case 13:
                            _o.sent();
                            return [3 /*break*/, 17];
                        case 14: return [4 /*yield*/, this.createClipObjectByPanel(IPanelType.ThreePanel, options)];
                        case 15:
                            _o.sent();
                            return [3 /*break*/, 17];
                        case 16: return [3 /*break*/, 17];
                        case 17:
                            clipInstance = new baseWrap({
                                clipObj: this.clipObj,
                                instance: this
                            }, cacheType.Clip);
                            this.cacheManagement.createCache(this.clipObj, clipInstance, {
                                instance: options.node
                            });
                            // 启用剖切
                            return [4 /*yield*/, ((_f = this.player.Native) === null || _f === void 0 ? void 0 : _f.ClipBox.setEnable(true))
                                // 是否启用内剖切
                            ];
                        case 18:
                            // 启用剖切
                            _o.sent();
                            // 是否启用内剖切
                            return [4 /*yield*/, ((_g = this.player.Native) === null || _g === void 0 ? void 0 : _g.ClipBox.setIsInside(options.setIsInside))
                                // 是否启用局部剖切
                            ];
                        case 19:
                            // 是否启用内剖切
                            _o.sent();
                            currentNodeInfo = currentNode ? currentNode === null || currentNode === void 0 ? void 0 : currentNode.getDataInfo() : null;
                            if (!options.setPartCilp) return [3 /*break*/, 22];
                            if (!(currentNodeInfo && ((currentNode === null || currentNode === void 0 ? void 0 : currentNode.category) === cacheType.Node || (currentNode === null || currentNode === void 0 ? void 0 : currentNode.category) == cacheType.LoadNode))) return [3 /*break*/, 21];
                            return [4 /*yield*/, ((_h = this.player.Native) === null || _h === void 0 ? void 0 : _h.ClipBox.setLocalEnable([currentNodeInfo.node]))];
                        case 20:
                            _o.sent();
                            _o.label = 21;
                        case 21: return [3 /*break*/, 24];
                        case 22: return [4 /*yield*/, ((_j = this.player.Native) === null || _j === void 0 ? void 0 : _j.ClipBox.setLocalDisable())];
                        case 23:
                            _o.sent();
                            _o.label = 24;
                        case 24:
                            if (!(clipType !== EClipType.ThreePanel)) return [3 /*break*/, 26];
                            return [4 /*yield*/, Axis.createAxis(this.player, this.dispatch, options.axisType, this.clipObj, this.axisOptions)];
                        case 25:
                            axisData = _o.sent();
                            if (axisData.status && axisData.data) {
                                this.currentAxisId = (_k = axisData.data) === null || _k === void 0 ? void 0 : _k.id;
                            }
                            _o.label = 26;
                        case 26:
                            this.clipType = clipType;
                            return [2 /*return*/, {
                                    message: '创建剖切成功',
                                    status: true,
                                }];
                    }
                });
            });
        };
        /**
       * @description: 取消剖切
       * @param {*}
       * @return {*}
       */
        Clip.prototype.cancelClip = function () {
            var _a, _b, _c;
            return __awaiter$1(this, void 0, void 0, function () {
                var currentClipCache;
                return __generator$1(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (this.axisConnect) {
                                this.axisConnect = false;
                                this.dispatch.off("Axis", this.dealAxisData);
                                // 取消激活剖切对象
                            }
                            if (!this.clipObj) return [3 /*break*/, 2];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.ClipBox.setProperty(this.clipObj, { visible: false }))];
                        case 1:
                            _d.sent();
                            return [3 /*break*/, 3];
                        case 2: return [2 /*return*/];
                        case 3:
                            currentClipCache = this.cacheManagement.findCacheById(this.clipObj);
                            if (currentClipCache === null || currentClipCache === void 0 ? void 0 : currentClipCache.instance) {
                                this.cacheManagement.deleteCache(currentClipCache === null || currentClipCache === void 0 ? void 0 : currentClipCache.instance);
                            }
                            this.clipObj = 0;
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.ClipBox.setEnable(false))];
                        case 4:
                            _d.sent();
                            return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.ClipBox.setLocalEnable([]))];
                        case 5:
                            _d.sent();
                            Axis.destroyAxis(this.player, this.currentAxisId);
                            this.currentAxisId = '';
                            this.clipType = null;
                            return [2 /*return*/];
                    }
                });
            });
        };
        Clip.instance = null;
        return Clip;
    }(commonAbstractClass));

    var EStyleType;
    (function (EStyleType) {
        EStyleType["riskArea"] = "riskArea";
        EStyleType["fence"] = "fence";
    })(EStyleType || (EStyleType = {}));

    var EMarkPosType$1;
    (function (EMarkPosType) {
        EMarkPosType[EMarkPosType["leftTop"] = 0] = "leftTop";
        EMarkPosType[EMarkPosType["midTop"] = 1] = "midTop";
        EMarkPosType[EMarkPosType["rightTop"] = 2] = "rightTop";
        EMarkPosType[EMarkPosType["leftBottom"] = 3] = "leftBottom";
        EMarkPosType[EMarkPosType["midBottom"] = 4] = "midBottom";
        EMarkPosType[EMarkPosType["rightBottom"] = 5] = "rightBottom";
    })(EMarkPosType$1 || (EMarkPosType$1 = {}));
    var EMarkerEvent$1;
    (function (EMarkerEvent) {
        EMarkerEvent[EMarkerEvent["rightClick"] = 0] = "rightClick";
        EMarkerEvent[EMarkerEvent["leftClick"] = 1] = "leftClick";
        EMarkerEvent[EMarkerEvent["hover"] = 2] = "hover";
    })(EMarkerEvent$1 || (EMarkerEvent$1 = {}));

    /*!
     * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }

    var Bounds = /** @class */ (function () {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function (x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function (context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function (context, domRectList) {
            var domRect = Array.from(domRectList).find(function (rect) { return rect.width !== 0; });
            return domRect
                ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height)
                : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }());
    var parseBounds = function (context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function (document) {
        var body = document.body;
        var documentElement = document.documentElement;
        if (!body || !documentElement) {
            throw new Error("Unable to get document size");
        }
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };

    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var toCodePoints$1 = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint$1 = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$2 = 0; i$2 < chars$2.length; i$2++) {
        lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    }

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++) {
        lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    }
    var decode$1 = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1$1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function (base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16$1(view16, (headerLength + view32[4]) / 2)
            : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2$1) & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$3 = 0; i$3 < chars$3.length; i$3++) {
        lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    }

    var base64$1 = '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';

    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [0x2329, 0xff08];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = '×';
    var BREAK_ALLOWED$1 = '÷';
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [AL, HL];
    var HARD_LINE_BREAKS = [BK, CR$1, LF$1, NL];
    var SPACE$1 = [SP, ZW];
    var PREFIX_POSTFIX = [PR, PO];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
    var HYPHEN = [HY, BA];
    var codePointsToCharacterClasses = function (codePoints, lineBreak) {
        if (lineBreak === void 0) { lineBreak = 'strict'; }
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function (codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            }
            else {
                categories.push(false);
            }
            if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
                // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
                if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) {
                return types.push(lineBreak === 'strict' ? NS : ID);
            }
            if (classType === SA) {
                return types.push(AL);
            }
            if (classType === AI) {
                return types.push(AL);
            }
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if ((codePoint >= 0x20000 && codePoint <= 0x2fffd) || (codePoint >= 0x30000 && codePoint <= 0x3fffd)) {
                    return types.push(ID);
                }
                else {
                    return types.push(AL);
                }
            }
            types.push(classType);
        });
        return [indices, types, categories];
    };
    var isAdjacentWithSpaceIgnored = function (a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while (i <= classTypes.length) {
                i++;
                var next = classTypes[i];
                if (next === b) {
                    return true;
                }
                if (next !== SP) {
                    break;
                }
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while (i > 0) {
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while (n <= classTypes.length) {
                        n++;
                        var next = classTypes[n];
                        if (next === b) {
                            return true;
                        }
                        if (next !== SP) {
                            break;
                        }
                    }
                }
                if (prev !== SP) {
                    break;
                }
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function (currentIndex, classTypes) {
        var i = currentIndex;
        while (i >= 0) {
            var type = classTypes[i];
            if (type === SP) {
                i--;
            }
            else {
                return type;
            }
        }
        return 0;
    };
    var _lineBreakAtIndex = function (codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) {
            return BREAK_NOT_ALLOWED$1;
        }
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
            return BREAK_NOT_ALLOWED$1;
        }
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
            return BREAK_MANDATORY;
        }
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
            return BREAK_ALLOWED$1;
        }
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB18 Break after spaces.
        if (current === SP) {
            return BREAK_ALLOWED$1;
        }
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) {
            return BREAK_ALLOWED$1;
        }
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB22 Do not break before ellipsis.
        if (next === IN) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23 Do not break between digits and letters.
        if ((ALPHABETICS.indexOf(next) !== -1 && current === NU) || (ALPHABETICS.indexOf(current) !== -1 && next === NU)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if ((current === PR && [ID, EB, EM].indexOf(next) !== -1) ||
            ([ID, EB, EM].indexOf(current) !== -1 && next === PO)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if ((ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1) ||
            (PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (
        // (PR | PO) × ( OP | HY )? NU
        ([PR, PO].indexOf(current) !== -1 &&
            (next === NU || ([OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU))) ||
            // ( OP | HY ) × NU
            ([OP, HY].indexOf(current) !== -1 && next === NU) ||
            // NU ×	(NU | SY | IS)
            (current === NU && [NU, SY, IS].indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([PR, PO].indexOf(next) !== -1) {
            var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // LB26 Do not break a Korean syllable.
        if ((JL === current && [JL, JV, H2, H3].indexOf(next) !== -1) ||
            ([JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1) ||
            ([JT, H3].indexOf(current) !== -1 && next === JT)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB27 Treat a Korean Syllable Block the same as ID.
        if ((KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1) ||
            (KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if ((ALPHABETICS.concat(NU).indexOf(current) !== -1 &&
            next === OP &&
            ea_OP.indexOf(codePoints[afterIndex]) === -1) ||
            (ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while (i > 0) {
                i--;
                if (classTypes[i] === RI$1) {
                    count++;
                }
                else {
                    break;
                }
            }
            if (count % 2 !== 0) {
                return BREAK_NOT_ALLOWED$1;
            }
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) {
            return BREAK_NOT_ALLOWED$1;
        }
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function (codePoints, options) {
        if (!options) {
            options = { lineBreak: 'normal', wordBreak: 'normal' };
        }
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
            classTypes = classTypes.map(function (type) { return ([NU, AL, SA].indexOf(type) !== -1 ? ID : type); });
        }
        var forbiddenBreakpoints = options.wordBreak === 'keep-all'
            ? isLetterNumber.map(function (letterNumber, i) {
                return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
            })
            : undefined;
        return [indicies, classTypes, forbiddenBreakpoints];
    };
    var Break = /** @class */ (function () {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function () {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }());
    var LineBreaker = function (str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function () {
                if (nextIndex >= length) {
                    return { done: true, value: null };
                }
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while (nextIndex < length &&
                    (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) ===
                        BREAK_NOT_ALLOWED$1) { }
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };

    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1 << 0;
    var FLAG_ID = 1 << 1;
    var FLAG_INTEGER = 1 << 2;
    var FLAG_NUMBER = 1 << 3;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function (codePoint) { return codePoint >= ZERO && codePoint <= 0x0039; };
    var isSurrogateCodePoint = function (codePoint) { return codePoint >= 0xd800 && codePoint <= 0xdfff; };
    var isHex = function (codePoint) {
        return isDigit(codePoint) || (codePoint >= A && codePoint <= F) || (codePoint >= a && codePoint <= f);
    };
    var isLowerCaseLetter = function (codePoint) { return codePoint >= a && codePoint <= z; };
    var isUpperCaseLetter = function (codePoint) { return codePoint >= A && codePoint <= Z; };
    var isLetter = function (codePoint) { return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint); };
    var isNonASCIICodePoint = function (codePoint) { return codePoint >= CONTROL; };
    var isWhiteSpace = function (codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function (codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function (codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function (codePoint) {
        return ((codePoint >= NULL && codePoint <= BACKSPACE) ||
            codePoint === LINE_TABULATION ||
            (codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE) ||
            codePoint === DELETE);
    };
    var isValidEscape = function (c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) {
            return false;
        }
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function (c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) {
            return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        }
        else if (isNameStartCodePoint(c1)) {
            return true;
        }
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) {
            return true;
        }
        return false;
    };
    var isNumberStart = function (c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) {
                return true;
            }
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) {
            return isDigit(c2);
        }
        return isDigit(c1);
    };
    var stringToNumber = function (codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                sign = -1;
            }
            c++;
        }
        var integers = [];
        while (isDigit(codePoints[c])) {
            integers.push(codePoints[c++]);
        }
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) {
            c++;
        }
        var fraction = [];
        while (isDigit(codePoints[c])) {
            fraction.push(codePoints[c++]);
        }
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) {
            c++;
        }
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                expsign = -1;
            }
            c++;
        }
        var exponent = [];
        while (isDigit(codePoints[c])) {
            exponent.push(codePoints[c++]);
        }
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */
    };
    var COMMA_TOKEN = { type: 4 /* COMMA_TOKEN */ };
    var SUFFIX_MATCH_TOKEN = { type: 13 /* SUFFIX_MATCH_TOKEN */ };
    var PREFIX_MATCH_TOKEN = { type: 8 /* PREFIX_MATCH_TOKEN */ };
    var COLUMN_TOKEN = { type: 21 /* COLUMN_TOKEN */ };
    var DASH_MATCH_TOKEN = { type: 9 /* DASH_MATCH_TOKEN */ };
    var INCLUDE_MATCH_TOKEN = { type: 10 /* INCLUDE_MATCH_TOKEN */ };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */
    };
    var SUBSTRING_MATCH_TOKEN = { type: 14 /* SUBSTRING_MATCH_TOKEN */ };
    var BAD_URL_TOKEN = { type: 23 /* BAD_URL_TOKEN */ };
    var BAD_STRING_TOKEN = { type: 1 /* BAD_STRING_TOKEN */ };
    var CDO_TOKEN = { type: 25 /* CDO_TOKEN */ };
    var CDC_TOKEN = { type: 24 /* CDC_TOKEN */ };
    var COLON_TOKEN = { type: 26 /* COLON_TOKEN */ };
    var SEMICOLON_TOKEN = { type: 27 /* SEMICOLON_TOKEN */ };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */
    };
    var WHITESPACE_TOKEN = { type: 31 /* WHITESPACE_TOKEN */ };
    var EOF_TOKEN = { type: 32 /* EOF_TOKEN */ };
    var Tokenizer = /** @class */ (function () {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function (chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function () {
            var tokens = [];
            var token = this.consumeToken();
            while (token !== EOF_TOKEN) {
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function () {
            var codePoint = this.consumeCodePoint();
            switch (codePoint) {
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return { type: 5 /* HASH_TOKEN */, value: value, flags: flags };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while (true) {
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) {
                                    return this.consumeToken();
                                }
                            }
                            if (c === EOF) {
                                return this.consumeToken();
                            }
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK &&
                        this.peekCodePoint(1) === HYPHEN_MINUS &&
                        this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return { type: 7 /* AT_KEYWORD_TOKEN */, value: value };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return { type: 6 /* DELIM_TOKEN */, value: fromCodePoint$1(codePoint) };
        };
        Tokenizer.prototype.consumeCodePoint = function () {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function (codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function (delta) {
            if (delta >= this._value.length) {
                return -1;
            }
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function () {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while (isHex(codePoint) && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while (codePoint === QUESTION_MARK && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? ZERO : digit); })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? F : digit); })), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start_1, end: end };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while (isHex(codePoint) && endDigits.length < 6) {
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: end };
            }
            else {
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: start };
            }
        };
        Tokenizer.prototype.consumeIdentLikeToken = function () {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            }
            else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return { type: 19 /* FUNCTION_TOKEN */, value: value };
            }
            return { type: 20 /* IDENT_TOKEN */, value: value };
        };
        Tokenizer.prototype.consumeUrlToken = function () {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) {
                return { type: 22 /* URL_TOKEN */, value: '' };
            }
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: stringToken.value };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
                    return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                }
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === QUOTATION_MARK ||
                    codePoint === APOSTROPHE ||
                    codePoint === LEFT_PARENTHESIS ||
                    isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        value.push(this.consumeEscapedCodePoint());
                    }
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                }
                else {
                    value.push(codePoint);
                }
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function () {
            while (isWhiteSpace(this.peekCodePoint(0))) {
                this.consumeCodePoint();
            }
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function () {
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
                    return;
                }
                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    this.consumeEscapedCodePoint();
                }
            }
        };
        Tokenizer.prototype.consumeStringSlice = function (count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while (count > 0) {
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function (endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return { type: 0 /* STRING_TOKEN */, value: value };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        }
                        else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            } while (true);
        };
        Tokenizer.prototype.consumeNumber = function () {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
                repr.push(this.consumeCodePoint());
            }
            while (isDigit(this.peekCodePoint(0))) {
                repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && (((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3)) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            return [stringToNumber(repr), type];
        };
        Tokenizer.prototype.consumeNumericToken = function () {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return { type: 15 /* DIMENSION_TOKEN */, number: number, flags: flags, unit: unit };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return { type: 16 /* PERCENTAGE_TOKEN */, number: number, flags: flags };
            }
            return { type: 17 /* NUMBER_TOKEN */, number: number, flags: flags };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function () {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
                    hex += fromCodePoint$1(this.consumeCodePoint());
                }
                if (isWhiteSpace(this.peekCodePoint(0))) {
                    this.consumeCodePoint();
                }
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) {
                    return REPLACEMENT_CHARACTER;
                }
                return hexCodePoint;
            }
            if (codePoint === EOF) {
                return REPLACEMENT_CHARACTER;
            }
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function () {
            var result = '';
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) {
                    result += fromCodePoint$1(codePoint);
                }
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    result += fromCodePoint$1(this.consumeEscapedCodePoint());
                }
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }());

    var Parser = /** @class */ (function () {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function (value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function (value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function (value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function () {
            var token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */) {
                token = this.consumeToken();
            }
            if (token.type === 32 /* EOF_TOKEN */) {
                throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            }
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do {
                token = this.consumeToken();
            } while (token.type === 31 /* WHITESPACE_TOKEN */);
            if (token.type === 32 /* EOF_TOKEN */) {
                return value;
            }
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function () {
            var values = [];
            while (true) {
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */) {
                    return values;
                }
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function () {
            var token = this.consumeToken();
            switch (token.type) {
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */:
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */:
                case 2 /* LEFT_PARENTHESIS_TOKEN */:
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */:
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function (type) {
            var block = { type: type, values: [] };
            var token = this.consumeToken();
            while (true) {
                if (token.type === 32 /* EOF_TOKEN */ || isEndingTokenFor(token, type)) {
                    return block;
                }
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function (functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */
            };
            while (true) {
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */ || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */) {
                    return cssFunction;
                }
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function () {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function (token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }());
    var isDimensionToken = function (token) { return token.type === 15 /* DIMENSION_TOKEN */; };
    var isNumberToken = function (token) { return token.type === 17 /* NUMBER_TOKEN */; };
    var isIdentToken = function (token) { return token.type === 20 /* IDENT_TOKEN */; };
    var isStringToken = function (token) { return token.type === 0 /* STRING_TOKEN */; };
    var isIdentWithValue = function (token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function (token) { return token.type !== 31 /* WHITESPACE_TOKEN */; };
    var nonFunctionArgSeparator = function (token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ && token.type !== 4 /* COMMA_TOKEN */;
    };
    var parseFunctionArgs = function (tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function (token) {
            if (token.type === 4 /* COMMA_TOKEN */) {
                if (arg.length === 0) {
                    throw new Error("Error parsing function args, zero tokens for arg");
                }
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */) {
                arg.push(token);
            }
        });
        if (arg.length) {
            args.push(arg);
        }
        return args;
    };
    var isEndingTokenFor = function (token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */ && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */) {
            return true;
        }
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */ && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */) {
            return true;
        }
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */ && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */;
    };

    var isLength = function (token) {
        return token.type === 17 /* NUMBER_TOKEN */ || token.type === 15 /* DIMENSION_TOKEN */;
    };

    var isLengthPercentage = function (token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */ || isLength(token);
    };
    var parseLengthPercentageTuple = function (tokens) {
        return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function (tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [getAbsoluteValue(x, width), getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)];
    };
    var getAbsoluteValue = function (token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            return (token.number / 100) * parent;
        }
        if (isDimensionToken(token)) {
            switch (token.unit) {
                case 'rem':
                case 'em':
                    return 16 * token.number; // TODO use correct font-size
                case 'px':
                default:
                    return token.number;
            }
        }
        return token.number;
    };

    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit) {
                    case DEG:
                        return (Math.PI * value.number) / 180;
                    case GRAD:
                        return (Math.PI / 200) * value.number;
                    case RAD:
                        return value.number;
                    case TURN:
                        return Math.PI * 2 * value.number;
                }
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function (value) {
        if (value.type === 15 /* DIMENSION_TOKEN */) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
                return true;
            }
        }
        return false;
    };
    var parseNamedSide = function (tokens) {
        var sideOrCorner = tokens
            .filter(isIdentToken)
            .map(function (ident) { return ident.value; })
            .join(' ');
        switch (sideOrCorner) {
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [ZERO_LENGTH, ZERO_LENGTH];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [ZERO_LENGTH, HUNDRED_PERCENT];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [HUNDRED_PERCENT, HUNDRED_PERCENT];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [HUNDRED_PERCENT, ZERO_LENGTH];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function (deg) { return (Math.PI * deg) / 180; };

    var color$1 = {
        name: 'color',
        parse: function (context, value) {
            if (value.type === 18 /* FUNCTION */) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                }
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') {
                    return namedColor;
                }
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function (color) { return (0xff & color) === 0; };
    var asString = function (color) {
        var alpha = 0xff & color;
        var blue = 0xff & (color >> 8);
        var green = 0xff & (color >> 16);
        var red = 0xff & (color >> 24);
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function (r, g, b, a) {
        return ((r << 24) | (g << 16) | (b << 8) | (Math.round(a * 255) << 0)) >>> 0;
    };
    var getTokenColorValue = function (token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */) {
            return token.number;
        }
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? (token.number / 100) * max : Math.round((token.number / 100) * max);
        }
        return 0;
    };
    var rgb = function (_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) {
            hue += 1;
        }
        if (hue >= 1) {
            hue -= 1;
        }
        if (hue < 1 / 6) {
            return (t2 - t1) * hue * 6 + t1;
        }
        else if (hue < 1 / 2) {
            return t2;
        }
        else if (hue < 2 / 3) {
            return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        }
        else {
            return t1;
        }
    }
    var hsl = function (context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */ ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) {
            return pack(l * 255, l * 255, l * 255, 1);
        }
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function (context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };

    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var parseColorStop = function (context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? { color: color, stop: stop } : { color: color, stop: null };
    };
    var processColorStops = function (stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) {
            first.stop = ZERO_LENGTH;
        }
        if (last.stop === null) {
            last.stop = HUNDRED_PERCENT;
        }
        var processStops = [];
        var previous = 0;
        for (var i = 0; i < stops.length; i++) {
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) {
                    processStops.push(absoluteValue);
                }
                else {
                    processStops.push(previous);
                }
                previous = absoluteValue;
            }
            else {
                processStops.push(null);
            }
        }
        var gapBegin = null;
        for (var i = 0; i < processStops.length; i++) {
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) {
                    gapBegin = i;
                }
            }
            else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for (var g = 1; g <= gapLength; g++) {
                    processStops[gapBegin + g - 1] = gapValue * g;
                }
                gapBegin = null;
            }
        }
        return stops.map(function (_a, i) {
            var color = _a.color;
            return { color: color, stop: Math.max(Math.min(1, processStops[i] / lineLength), 0) };
        });
    };
    var getAngleFromCorner = function (corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function (angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [lineLength, halfWidth - xDiff, halfWidth + xDiff, halfHeight - yDiff, halfHeight + yDiff];
    };
    var distance = function (a, b) { return Math.sqrt(a * a + b * b); };
    var findCorner = function (width, height, x, y, closest) {
        var corners = [
            [0, 0],
            [0, height],
            [width, 0],
            [width, height]
        ];
        return corners.reduce(function (stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
                return {
                    optimumCorner: corner,
                    optimumDistance: d
                };
            }
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function (gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch (gradient.size) {
            case 0 /* CLOSEST_SIDE */:
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */:
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */:
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */:
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [rx, ry];
    };

    var linearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return { angle: angle$1, stops: stops, type: 1 /* LINEAR_GRADIENT */ };
    };

    var prefixLinearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ &&
                    ['top', 'left', 'right', 'bottom'].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */
        };
    };

    var webkitGradient = function (context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */;
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */;
                    return;
                }
                else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: ZERO_LENGTH, color: color });
                }
                else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: HUNDRED_PERCENT, color: color });
                }
                else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) {
                            stops.push({
                                stop: { type: 16 /* PERCENTAGE_TOKEN */, number: stop_1.number * 100, flags: stop_1.flags },
                                color: color
                            });
                        }
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */
            ? {
                angle: (angle + deg(180)) % deg(360),
                stops: stops,
                type: type
            }
            : { size: size, shape: shape, stops: stops, position: position, type: type };
    };

    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function (acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) {
                            switch (token.value) {
                                case 'center':
                                    position.push(FIFTY_PERCENT);
                                    return acc;
                                case 'top':
                                case 'left':
                                    position.push(ZERO_LENGTH);
                                    return acc;
                                case 'right':
                                case 'bottom':
                                    position.push(HUNDRED_PERCENT);
                                    return acc;
                            }
                        }
                        else if (isLengthPercentage(token) || isLength(token)) {
                            position.push(token);
                        }
                    }
                    else if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case 'at':
                                isAtPosition_1 = true;
                                return false;
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case COVER:
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var prefixRadialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return false;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return false;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return false;
                        }
                    }
                    else if (isLengthPercentage(token) || isLength(token)) {
                        position.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            else if (i === 1) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case COVER:
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var isLinearGradient = function (background) {
        return background.type === 1 /* LINEAR_GRADIENT */;
    };
    var isRadialGradient = function (background) {
        return background.type === 2 /* RADIAL_GRADIENT */;
    };
    var image = {
        name: 'image',
        parse: function (context, value) {
            if (value.type === 22 /* URL_TOKEN */) {
                var image_1 = { url: value.value, type: 0 /* URL */ };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                }
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return (!(value.type === 20 /* IDENT_TOKEN */ && value.value === 'none') &&
            (value.type !== 18 /* FUNCTION */ || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]));
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };

    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens
                .filter(function (value) { return nonFunctionArgSeparator(value) && isSupportedImage(value); })
                .map(function (value) { return image.parse(context, value); });
        }
    };

    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) { return values.filter(isLengthPercentage); })
                .map(parseLengthPercentageTuple);
        }
    };

    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) {
                return values
                    .filter(isIdentToken)
                    .map(function (token) { return token.value; })
                    .join(' ');
            })
                .map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function (value) {
        switch (value) {
            case 'no-repeat':
                return 1 /* NO_REPEAT */;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */;
            case 'repeat':
            default:
                return 0 /* REPEAT */;
        }
    };

    var BACKGROUND_SIZE;
    (function (BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens).map(function (values) { return values.filter(isBackgroundSizeInfoToken); });
        }
    };
    var isBackgroundSizeInfoToken = function (value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };

    var borderColorForSide = function (side) { return ({
        name: "border-" + side + "-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    }); };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');

    var borderRadiusForSide = function (side) { return ({
        name: "border-radius-" + side,
        initialValue: '0 0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
        }
    }); };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');

    var borderStyleForSide = function (side) { return ({
        name: "border-" + side + "-style",
        initialValue: 'solid',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, style) {
            switch (style) {
                case 'none':
                    return 0 /* NONE */;
                case 'dashed':
                    return 2 /* DASHED */;
                case 'dotted':
                    return 3 /* DOTTED */;
                case 'double':
                    return 4 /* DOUBLE */;
            }
            return 1 /* SOLID */;
        }
    }); };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');

    var borderWidthForSide = function (side) { return ({
        name: "border-" + side + "-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    }); };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');

    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, direction) {
            switch (direction) {
                case 'rtl':
                    return 1 /* RTL */;
                case 'ltr':
                default:
                    return 0 /* LTR */;
            }
        }
    };

    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function (bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */);
        }
    };
    var parseDisplayValue = function (display) {
        switch (display) {
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */;
            case 'inline':
                return 4 /* INLINE */;
            case 'run-in':
                return 8 /* RUN_IN */;
            case 'flow':
                return 16 /* FLOW */;
            case 'flow-root':
                return 32 /* FLOW_ROOT */;
            case 'table':
                return 64 /* TABLE */;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */;
            case 'ruby':
                return 512 /* RUBY */;
            case 'subgrid':
                return 1024 /* SUBGRID */;
            case 'list-item':
                return 2048 /* LIST_ITEM */;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */;
            case 'table-row':
                return 32768 /* TABLE_ROW */;
            case 'table-cell':
                return 65536 /* TABLE_CELL */;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */;
            case 'contents':
                return 16777216 /* CONTENTS */;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */;
        }
        return 0 /* NONE */;
    };

    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, float) {
            switch (float) {
                case 'left':
                    return 1 /* LEFT */;
                case 'right':
                    return 2 /* RIGHT */;
                case 'inline-start':
                    return 3 /* INLINE_START */;
                case 'inline-end':
                    return 4 /* INLINE_END */;
            }
            return 0 /* NONE */;
        }
    };

    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'normal') {
                return 0;
            }
            if (token.type === 17 /* NUMBER_TOKEN */) {
                return token.number;
            }
            if (token.type === 15 /* DIMENSION_TOKEN */) {
                return token.number;
            }
            return 0;
        }
    };

    var LINE_BREAK;
    (function (LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, lineBreak) {
            switch (lineBreak) {
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };

    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    };
    var computeLineHeight = function (token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') {
            return 1.2 * fontSize;
        }
        else if (token.type === 17 /* NUMBER_TOKEN */) {
            return fontSize * token.number;
        }
        else if (isLengthPercentage(token)) {
            return getAbsoluteValue(token, fontSize);
        }
        return fontSize;
    };

    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            return image.parse(context, token);
        }
    };

    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'inside':
                    return 0 /* INSIDE */;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */;
            }
        }
    };

    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, type) {
            switch (type) {
                case 'disc':
                    return 0 /* DISC */;
                case 'circle':
                    return 1 /* CIRCLE */;
                case 'square':
                    return 2 /* SQUARE */;
                case 'decimal':
                    return 3 /* DECIMAL */;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */;
                case 'armenian':
                    return 12 /* ARMENIAN */;
                case 'bengali':
                    return 13 /* BENGALI */;
                case 'cambodian':
                    return 14 /* CAMBODIAN */;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */;
                case 'devanagari':
                    return 18 /* DEVANAGARI */;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */;
                case 'georgian':
                    return 20 /* GEORGIAN */;
                case 'gujarati':
                    return 21 /* GUJARATI */;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */;
                case 'hebrew':
                    return 22 /* HEBREW */;
                case 'hiragana':
                    return 23 /* HIRAGANA */;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */;
                case 'kannada':
                    return 27 /* KANNADA */;
                case 'katakana':
                    return 28 /* KATAKANA */;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */;
                case 'khmer':
                    return 30 /* KHMER */;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */;
                case 'lao':
                    return 34 /* LAO */;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */;
                case 'malayalam':
                    return 36 /* MALAYALAM */;
                case 'mongolian':
                    return 37 /* MONGOLIAN */;
                case 'myanmar':
                    return 38 /* MYANMAR */;
                case 'oriya':
                    return 39 /* ORIYA */;
                case 'persian':
                    return 40 /* PERSIAN */;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */;
                case 'tamil':
                    return 43 /* TAMIL */;
                case 'telugu':
                    return 44 /* TELUGU */;
                case 'thai':
                    return 45 /* THAI */;
                case 'tibetan':
                    return 46 /* TIBETAN */;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */;
                case 'none':
                default:
                    return -1 /* NONE */;
            }
        }
    };

    var marginForSide = function (side) { return ({
        name: "margin-" + side,
        initialValue: '0',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    }); };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');

    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (overflow) {
                switch (overflow.value) {
                    case 'hidden':
                        return 1 /* HIDDEN */;
                    case 'scroll':
                        return 2 /* SCROLL */;
                    case 'clip':
                        return 3 /* CLIP */;
                    case 'auto':
                        return 4 /* AUTO */;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */;
                }
            });
        }
    };

    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'break-word':
                    return "break-word" /* BREAK_WORD */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var paddingForSide = function (side) { return ({
        name: "padding-" + side,
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length-percentage'
    }); };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');

    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textAlign) {
            switch (textAlign) {
                case 'right':
                    return 2 /* RIGHT */;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */;
                case 'left':
                default:
                    return 0 /* LEFT */;
            }
        }
    };

    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'relative':
                    return 1 /* RELATIVE */;
                case 'absolute':
                    return 2 /* ABSOLUTE */;
                case 'fixed':
                    return 3 /* FIXED */;
                case 'sticky':
                    return 4 /* STICKY */;
            }
            return 0 /* STATIC */;
        }
    };

    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else {
                            shadow.blur = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textTransform) {
            switch (textTransform) {
                case 'uppercase':
                    return 2 /* UPPERCASE */;
                case 'lowercase':
                    return 1 /* LOWERCASE */;
                case 'capitalize':
                    return 3 /* CAPITALIZE */;
            }
            return 0 /* NONE */;
        }
    };

    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            if (token.type === 18 /* FUNCTION */) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                }
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        var a1 = values[0], b1 = values[1]; values[2]; values[3]; var a2 = values[4], b2 = values[5]; values[6]; values[7]; values[8]; values[9]; values[10]; values[11]; var a4 = values[12], b4 = values[13]; values[14]; values[15];
        return values.length === 16 ? [a1, b1, a2, b2, a4, b4] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };

    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) {
                return DEFAULT;
            }
            return [origins[0], origins[1]];
        }
    };

    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, visibility) {
            switch (visibility) {
                case 'hidden':
                    return 1 /* HIDDEN */;
                case 'collapse':
                    return 2 /* COLLAPSE */;
                case 'visible':
                default:
                    return 0 /* VISIBLE */;
            }
        }
    };

    var WORD_BREAK;
    (function (WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, wordBreak) {
            switch (wordBreak) {
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };

    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */) {
                return { auto: true, order: 0 };
            }
            if (isNumberToken(token)) {
                return { auto: false, order: token.number };
            }
            throw new Error("Invalid z-index number parsed");
        }
    };

    var time = {
        name: 'time',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit.toLowerCase()) {
                    case 's':
                        return 1000 * value.number;
                    case 'ms':
                        return value.number;
                }
            }
            throw new Error("Unsupported time type");
        }
    };

    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            return 1;
        }
    };

    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens
                .filter(isIdentToken)
                .map(function (token) {
                switch (token.value) {
                    case 'underline':
                        return 1 /* UNDERLINE */;
                    case 'overline':
                        return 2 /* OVERLINE */;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */;
                    case 'none':
                        return 4 /* BLINK */;
                }
                return 0 /* NONE */;
            })
                .filter(function (line) { return line !== 0 /* NONE */; });
        }
    };

    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function (token) {
                switch (token.type) {
                    case 20 /* IDENT_TOKEN */:
                    case 0 /* STRING_TOKEN */:
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */:
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */:
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) {
                results.push(accumulator.join(' '));
            }
            return results.map(function (result) { return (result.indexOf(' ') === -1 ? result : "'" + result + "'"); });
        }
    };

    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length'
    };

    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            if (isIdentToken(token)) {
                switch (token.value) {
                    case 'bold':
                        return 700;
                    case 'normal':
                    default:
                        return 400;
                }
            }
            return 400;
        }
    };

    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (token) { return token.value; });
        }
    };

    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'oblique':
                    return "oblique" /* OBLIQUE */;
                case 'italic':
                    return "italic" /* ITALIC */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var contains = function (bit, value) { return (bit & value) !== 0; };

    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens;
        }
    };

    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({ counter: counter.value, increment: increment });
                }
            }
            return increments;
        }
    };

    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({ counter: counter.value, reset: reset });
                }
            }
            return resets;
        }
    };

    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (context, tokens) {
            return tokens.filter(isDimensionToken).map(function (token) { return time.parse(context, token); });
        }
    };

    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) {
                return null;
            }
            for (var i = 0; i < filtered.length; i += 2) {
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({ open: open_1, close: close_1 });
            }
            return quotes;
        }
    };
    var getQuote = function (quotes, depth, open) {
        if (!quotes) {
            return '';
        }
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) {
            return '';
        }
        return open ? quote.open : quote.close;
    };

    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) {
                        shadow.inset = true;
                    }
                    else if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else if (c === 2) {
                            shadow.blur = token;
                        }
                        else {
                            shadow.spread = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var DEFAULT_VALUE = [0 /* FILL */, 1 /* STROKE */, 2 /* MARKERS */];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function (token) {
                switch (token.value) {
                    case 'stroke':
                        layers.push(1 /* STROKE */);
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */);
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */);
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function (value) {
                if (layers.indexOf(value) === -1) {
                    layers.push(value);
                }
            });
            return layers;
        }
    };

    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    };

    var CSSParsedDeclaration = /** @class */ (function () {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function () {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */;
        };
        CSSParsedDeclaration.prototype.isTransparent = function () {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function () {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function () {
            return this.position !== 0 /* STATIC */;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function () {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function () {
            return this.float !== 0 /* NONE */;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function () {
            return (contains(this.display, 4 /* INLINE */) ||
                contains(this.display, 33554432 /* INLINE_BLOCK */) ||
                contains(this.display, 268435456 /* INLINE_FLEX */) ||
                contains(this.display, 536870912 /* INLINE_GRID */) ||
                contains(this.display, 67108864 /* INLINE_LIST_ITEM */) ||
                contains(this.display, 134217728 /* INLINE_TABLE */));
        };
        return CSSParsedDeclaration;
    }());
    var CSSParsedPseudoDeclaration = /** @class */ (function () {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }());
    var CSSParsedCounterDeclaration = /** @class */ (function () {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function (context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch (descriptor.type) {
            case 2 /* IDENT_VALUE */:
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */:
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */:
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */:
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */:
                switch (descriptor.format) {
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };

    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function (element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch (attribute) {
            case 'all':
                return 1 /* ALL */;
            case 'clone':
                return 2 /* CLONE */;
            case 'parse':
                return 3 /* PARSE */;
            case 'render':
                return 4 /* RENDER */;
            default:
                return 0 /* NONE */;
        }
    };
    var isDebugging = function (element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */ || type === elementType;
    };

    var ElementContainer = /** @class */ (function () {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */)) {
                debugger;
            }
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function (duration) { return duration > 0; })) {
                    element.style.animationDuration = '0s';
                }
                if (this.styles.transform !== null) {
                    // getBoundingClientRect takes transforms into account
                    element.style.transform = 'none';
                }
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */)) {
                this.flags |= 16 /* DEBUG_RENDER */;
            }
        }
        return ElementContainer;
    }());

    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var base64 = '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';

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1 = 0; i$1 < chars$1.length; i$1++) {
        lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    }
    var decode = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function (base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16(view16, (headerLength + view32[4]) / 2)
            : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2) & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i = 0; i < chars.length; i++) {
        lookup[chars.charCodeAt(i)] = i;
    }

    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = '×';
    var BREAK_ALLOWED = '÷';
    var codePointToClass = function (codePoint) { return UnicodeTrie.get(codePoint); };
    var _graphemeBreakAtIndex = function (_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) {
            return BREAK_NOT_ALLOWED;
        }
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) {
            return BREAK_ALLOWED;
        }
        // GB5
        if (next === CR || next === LF || next === Control) {
            return BREAK_ALLOWED;
        }
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [L, V, LV, LVT].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) {
            return BREAK_NOT_ALLOWED;
        }
        // GB8
        if ((current === LVT || current === T) && next === T) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) {
            return BREAK_NOT_ALLOWED;
        }
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9a
        if (current === Prepend) {
            return BREAK_NOT_ALLOWED;
        }
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while (prev === Extend) {
                prev = classTypes[--prevIndex];
            }
            if (prev === Extended_Pictographic) {
                return BREAK_NOT_ALLOWED;
            }
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while (prev === RI) {
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) {
                return BREAK_NOT_ALLOWED;
            }
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function (str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function () {
                if (index >= length) {
                    return { done: true, value: null };
                }
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while (index < length &&
                    (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED) { }
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };
    var splitGraphemes = function (str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while (!(bk = breaker.next()).done) {
            if (bk.value) {
                graphemes.push(bk.value.slice());
            }
        }
        return graphemes;
    };

    var testRangeBounds = function (document) {
        var TEST_HEIGHT = 123;
        if (document.createRange) {
            var range = document.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) {
                    return true;
                }
            }
        }
        return false;
    };
    var testIOSLineBreak = function (document) {
        var testElement = document.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document.body.appendChild(testElement);
        var range = document.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function (i) { return fromCodePoint$1(i); });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function (text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) {
                return true;
            }
            return boundAhead;
        });
        document.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function () { return typeof new Image().crossOrigin !== 'undefined'; };
    var testResponseType = function () { return typeof new XMLHttpRequest().responseType === 'string'; };
    var testSVG = function (document) {
        var img = new Image();
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return false;
        }
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        }
        catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function (data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function (document) {
        var canvas = document.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return Promise.reject(false);
        }
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg)
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data)
                ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node))
                : Promise.reject(false);
        })
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        })
            .catch(function () { return false; });
    };
    var createForeignObjectSVG = function (width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () { return resolve(img); };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS() {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
            return value;
        },
        get SUPPORT_WORD_BREAKING() {
            var value = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', { value: value });
            return value;
        },
        get SUPPORT_SVG_DRAWING() {
            var value = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING() {
            var value = typeof Array.from === 'function' && typeof window.fetch === 'function'
                ? testForeignObject(document)
                : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_CORS_IMAGES() {
            var value = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
            return value;
        },
        get SUPPORT_RESPONSE_TYPE() {
            var value = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
            return value;
        },
        get SUPPORT_CORS_XHR() {
            var value = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
            return value;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', { value: value });
            return value;
        }
    };

    var TextBounds = /** @class */ (function () {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }());
    var parseTextBounds = function (context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function (text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function (subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    }
                    else {
                        textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                    }
                }
                else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            }
            else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
                node = node.splitText(text.length);
            }
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function (context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) {
                    parentNode.replaceChild(wrapper.firstChild, wrapper);
                }
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function (node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) {
            throw new Error('Node has no owner document');
        }
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function (value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, { granularity: 'grapheme' });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function (value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return breakWords(value, styles);
    };
    var breakText = function (value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [0x0020, 0x00a0, 0x1361, 0x10100, 0x10101, 0x1039, 0x1091];
    var breakWords = function (str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */ ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function () {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function (codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) {
                        word_1 += fromCodePoint$1(codePoint);
                    }
                    else {
                        if (word_1.length) {
                            words.push(word_1);
                        }
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) {
                    words.push(word_1);
                }
            }
        };
        while (!(bk = breaker.next()).done) {
            _loop_1();
        }
        return words;
    };

    var TextContainer = /** @class */ (function () {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }());
    var transform = function (text, transform) {
        switch (transform) {
            case 1 /* LOWERCASE */:
                return text.toLowerCase();
            case 3 /* CAPITALIZE */:
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */:
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function (m, p1, p2) {
        if (m.length > 0) {
            return p1 + p2.toUpperCase();
        }
        return m;
    };

    var ImageElementContainer = /** @class */ (function (_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer));

    var CanvasElementContainer = /** @class */ (function (_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer));

    var SVGElementContainer = /** @class */ (function (_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer));

    var LIElementContainer = /** @class */ (function (_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer));

    var OLElementContainer = /** @class */ (function (_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer));

    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function (bounds) {
        if (bounds.width > bounds.height) {
            return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        }
        else if (bounds.width < bounds.height) {
            return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        }
        return bounds;
    };
    var getInputValue = function (node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ (function (_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor =
                    _this.styles.borderRightColor =
                        _this.styles.borderBottomColor =
                            _this.styles.borderLeftColor =
                                0xa5a5a5ff;
                _this.styles.borderTopWidth =
                    _this.styles.borderRightWidth =
                        _this.styles.borderBottomWidth =
                            _this.styles.borderLeftWidth =
                                1;
                _this.styles.borderTopStyle =
                    _this.styles.borderRightStyle =
                        _this.styles.borderBottomStyle =
                            _this.styles.borderLeftStyle =
                                1 /* SOLID */;
                _this.styles.backgroundClip = [0 /* BORDER_BOX */];
                _this.styles.backgroundOrigin = [0 /* BORDER_BOX */];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch (_this.type) {
                case CHECKBOX:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer));

    var SelectElementContainer = /** @class */ (function (_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer));

    var TextareaElementContainer = /** @class */ (function (_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer));

    var IFrameElementContainer = /** @class */ (function (_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow &&
                    iframe.contentWindow.document &&
                    iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor)
                        : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor)
                        : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor)
                        ? isTransparent(bodyBackgroundColor)
                            ? _this.styles.backgroundColor
                            : bodyBackgroundColor
                        : documentBackgroundColor;
                }
            }
            catch (e) { }
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer));

    var LIST_OWNERS = ['OL', 'UL', 'MENU'];
    var parseNodeTree = function (context, node, parent, root) {
        for (var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) {
                parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            }
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) {
                    childNode.assignedNodes().forEach(function (childNode) { return parseNodeTree(context, childNode, parent, root); });
                }
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) {
                            container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
                        }
                        else if (createsStackingContext(container.styles)) {
                            container.flags |= 2 /* CREATES_STACKING_CONTEXT */;
                        }
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
                            container.flags |= 8 /* IS_LIST_OWNER */;
                        }
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) {
                            parseNodeTree(context, childNode.shadowRoot, container, root);
                        }
                        else if (!isTextareaElement(childNode) &&
                            !isSVGElement(childNode) &&
                            !isSelectElement(childNode)) {
                            parseNodeTree(context, childNode, container, root);
                        }
                    }
                }
            }
        }
    };
    var createContainer = function (context, element) {
        if (isImageElement(element)) {
            return new ImageElementContainer(context, element);
        }
        if (isCanvasElement(element)) {
            return new CanvasElementContainer(context, element);
        }
        if (isSVGElement(element)) {
            return new SVGElementContainer(context, element);
        }
        if (isLIElement(element)) {
            return new LIElementContainer(context, element);
        }
        if (isOLElement(element)) {
            return new OLElementContainer(context, element);
        }
        if (isInputElement(element)) {
            return new InputElementContainer(context, element);
        }
        if (isSelectElement(element)) {
            return new SelectElementContainer(context, element);
        }
        if (isTextareaElement(element)) {
            return new TextareaElementContainer(context, element);
        }
        if (isIFrameElement(element)) {
            return new IFrameElementContainer(context, element);
        }
        return new ElementContainer(context, element);
    };
    var parseTree = function (context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function (node, container, root) {
        return (container.styles.isPositionedWithZIndex() ||
            container.styles.opacity < 1 ||
            container.styles.isTransformed() ||
            (isBodyElement(node) && root.styles.isTransparent()));
    };
    var createsStackingContext = function (styles) { return styles.isPositioned() || styles.isFloating(); };
    var isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
    var isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
    var isHTMLElementNode = function (node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function (element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function (node) { return node.tagName === 'LI'; };
    var isOLElement = function (node) { return node.tagName === 'OL'; };
    var isInputElement = function (node) { return node.tagName === 'INPUT'; };
    var isHTMLElement = function (node) { return node.tagName === 'HTML'; };
    var isSVGElement = function (node) { return node.tagName === 'svg'; };
    var isBodyElement = function (node) { return node.tagName === 'BODY'; };
    var isCanvasElement = function (node) { return node.tagName === 'CANVAS'; };
    var isVideoElement = function (node) { return node.tagName === 'VIDEO'; };
    var isImageElement = function (node) { return node.tagName === 'IMG'; };
    var isIFrameElement = function (node) { return node.tagName === 'IFRAME'; };
    var isStyleElement = function (node) { return node.tagName === 'STYLE'; };
    var isScriptElement = function (node) { return node.tagName === 'SCRIPT'; };
    var isTextareaElement = function (node) { return node.tagName === 'TEXTAREA'; };
    var isSelectElement = function (node) { return node.tagName === 'SELECT'; };
    var isSlotElement = function (node) { return node.tagName === 'SLOT'; };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function (node) { return node.tagName.indexOf('-') > 0; };

    var CounterState = /** @class */ (function () {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function (name) {
            var counter = this.counters[name];
            if (counter && counter.length) {
                return counter[counter.length - 1];
            }
            return 1;
        };
        CounterState.prototype.getCounterValues = function (name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function (counters) {
            var _this = this;
            counters.forEach(function (counter) { return _this.counters[counter].pop(); });
        };
        CounterState.prototype.parse = function (style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) {
                counterIncrement.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    if (counter && entry.increment !== 0) {
                        canReset = false;
                        if (!counter.length) {
                            counter.push(1);
                        }
                        counter[Math.max(0, counter.length - 1)] += entry.increment;
                    }
                });
            }
            var counterNames = [];
            if (canReset) {
                counterReset.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    counterNames.push(entry.counter);
                    if (!counter) {
                        counter = _this.counters[entry.counter] = [];
                    }
                    counter.push(entry.reset);
                });
            }
            return counterNames;
        };
        return CounterState;
    }());
    var ROMAN_UPPER = {
        integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
        values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
    };
    var ARMENIAN = {
        integers: [
            9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70,
            60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'Ք',
            'Փ',
            'Ւ',
            'Ց',
            'Ր',
            'Տ',
            'Վ',
            'Ս',
            'Ռ',
            'Ջ',
            'Պ',
            'Չ',
            'Ո',
            'Շ',
            'Ն',
            'Յ',
            'Մ',
            'Ճ',
            'Ղ',
            'Ձ',
            'Հ',
            'Կ',
            'Ծ',
            'Խ',
            'Լ',
            'Ի',
            'Ժ',
            'Թ',
            'Ը',
            'Է',
            'Զ',
            'Ե',
            'Դ',
            'Գ',
            'Բ',
            'Ա'
        ]
    };
    var HEBREW = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20,
            19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'י׳',
            'ט׳',
            'ח׳',
            'ז׳',
            'ו׳',
            'ה׳',
            'ד׳',
            'ג׳',
            'ב׳',
            'א׳',
            'ת',
            'ש',
            'ר',
            'ק',
            'צ',
            'פ',
            'ע',
            'ס',
            'נ',
            'מ',
            'ל',
            'כ',
            'יט',
            'יח',
            'יז',
            'טז',
            'טו',
            'י',
            'ט',
            'ח',
            'ז',
            'ו',
            'ה',
            'ד',
            'ג',
            'ב',
            'א'
        ]
    };
    var GEORGIAN = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90,
            80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'ჵ',
            'ჰ',
            'ჯ',
            'ჴ',
            'ხ',
            'ჭ',
            'წ',
            'ძ',
            'ც',
            'ჩ',
            'შ',
            'ყ',
            'ღ',
            'ქ',
            'ფ',
            'ჳ',
            'ტ',
            'ს',
            'რ',
            'ჟ',
            'პ',
            'ო',
            'ჲ',
            'ნ',
            'მ',
            'ლ',
            'კ',
            'ი',
            'თ',
            'ჱ',
            'ზ',
            'ვ',
            'ე',
            'დ',
            'გ',
            'ბ',
            'ა'
        ]
    };
    var createAdditiveCounter = function (value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) {
            return createCounterText(value, fallback, suffix.length > 0);
        }
        return (symbols.integers.reduce(function (string, integer, index) {
            while (value >= integer) {
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix);
    };
    var createCounterStyleWithSymbolResolver = function (value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) {
                value--;
            }
            string = resolver(value) + string;
            value /= codePointRangeLength;
        } while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function (value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return ((value < 0 ? '-' : '') +
            (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
                return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
            }) +
                suffix));
    };
    var createCounterStyleFromSymbols = function (value, symbols, suffix) {
        if (suffix === void 0) { suffix = '. '; }
        var codePointRangeLength = symbols.length;
        return (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) { return symbols[Math.floor(codePoint % codePointRangeLength)]; }) + suffix);
    };
    var CJK_ZEROS = 1 << 0;
    var CJK_TEN_COEFFICIENTS = 1 << 1;
    var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
    var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
    var createCJKCounter = function (value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) {
            return createCounterText(value, 4 /* CJK_DECIMAL */, suffix.length > 0);
        }
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) {
            return numbers[0] + string;
        }
        for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') {
                string = numbers[coefficient] + string;
            }
            else if (coefficient > 1 ||
                (coefficient === 1 && digit === 0) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS)) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100) ||
                (coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS))) {
                string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            }
            else if (coefficient === 1 && digit > 0) {
                string = multipliers[digit - 1] + string;
            }
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
    var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
    var JAPANESE_NEGATIVE = 'マイナス';
    var KOREAN_NEGATIVE = '마이너스';
    var createCounterText = function (value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? '、' : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch (type) {
            case 0 /* DISC */:
                return '•' + spaceSuffix;
            case 1 /* CIRCLE */:
                return '◦' + spaceSuffix;
            case 2 /* SQUARE */:
                return '◾' + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */:
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */:
                return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
            case 6 /* LOWER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix);
            case 8 /* LOWER_GREEK */:
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */:
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */:
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */:
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */:
            case 49 /* UPPER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix);
            case 35 /* LOWER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 13 /* BENGALI */:
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */:
            case 30 /* KHMER */:
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */:
                return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */:
                return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */:
            case 48 /* TRAD_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */:
                return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */:
                return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */:
                return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */:
                return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */:
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */:
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */, defaultSuffix);
            case 21 /* GUJARATI */:
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */:
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */:
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */, defaultSuffix);
            case 23 /* HIRAGANA */:
                return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
            case 24 /* HIRAGANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
            case 27 /* KANNADA */:
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */:
                return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
            case 29 /* KATAKANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
            case 34 /* LAO */:
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */:
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */:
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */:
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */:
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */:
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */:
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */:
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */:
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */:
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };

    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ (function () {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) {
                throw new Error('Cloned element does not have an owner document');
            }
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function (ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) {
                return Promise.reject("Unable to find iframe window");
            }
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */
            var iframeLoad = iframeLoader(iframe).then(function () { return __awaiter(_this, void 0, void 0, function () {
                var onclone, referenceElement;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.scrolledElements.forEach(restoreNodeScroll);
                            if (cloneWindow) {
                                cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) &&
                                    (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                    this.context.logger.warn('Unable to restore scroll position for cloned document');
                                    this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                }
                            }
                            onclone = this.options.onclone;
                            referenceElement = this.clonedReferenceElement;
                            if (typeof referenceElement === 'undefined') {
                                return [2 /*return*/, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")];
                            }
                            if (!(documentClone.fonts && documentClone.fonts.ready)) return [3 /*break*/, 2];
                            return [4 /*yield*/, documentClone.fonts.ready];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [3 /*break*/, 4];
                            return [4 /*yield*/, imagesReady(documentClone)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            if (typeof onclone === 'function') {
                                return [2 /*return*/, Promise.resolve()
                                        .then(function () { return onclone(documentClone, referenceElement); })
                                        .then(function () { return iframe; })];
                            }
                            return [2 /*return*/, iframe];
                    }
                });
            }); });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function (node) {
            if (isDebugging(node, 2 /* CLONE */)) {
                debugger;
            }
            if (isCanvasElement(node)) {
                return this.createCanvasClone(node);
            }
            if (isVideoElement(node)) {
                return this.createVideoClone(node);
            }
            if (isStyleElement(node)) {
                return this.createStyleClone(node);
            }
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') {
                    clone.loading = 'eager';
                }
            }
            if (isCustomElement(clone)) {
                return this.createCustomElementClone(clone);
            }
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function (node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function (node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function (css, rule) {
                        if (rule && typeof rule.cssText === 'string') {
                            return css + rule.cssText;
                        }
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            }
            catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') {
                    throw e;
                }
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function (canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                }
                catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) {
                        clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    }
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) {
                                this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                            }
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function (video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) {
                        ctx.getImageData(0, 0, canvas.width, canvas.height);
                    }
                }
                return canvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function (clone, child, copyStyles) {
            if (!isElementNode(child) ||
                (!isScriptElement(child) &&
                    !child.hasAttribute(IGNORE_ATTRIBUTE) &&
                    (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child)))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
                    clone.appendChild(this.cloneNode(child, copyStyles));
                }
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function (node, clone, copyStyles) {
            var _this = this;
            for (var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling) {
                if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                    var assignedNodes = child.assignedNodes();
                    if (assignedNodes.length) {
                        assignedNodes.forEach(function (assignedNode) { return _this.appendChildNode(clone, assignedNode, copyStyles); });
                    }
                }
                else {
                    this.appendChildNode(clone, child, copyStyles);
                }
            }
        };
        DocumentCloner.prototype.cloneNode = function (node, copyStyles) {
            if (isTextNode(node)) {
                return document.createTextNode(node.data);
            }
            if (!node.ownerDocument) {
                return node.cloneNode(false);
            }
            var window = node.ownerDocument.defaultView;
            if (window && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window.getComputedStyle(node);
                var styleBefore = window.getComputedStyle(node, ':before');
                var styleAfter = window.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) {
                    this.clonedReferenceElement = clone;
                }
                if (isBodyElement(clone)) {
                    createPseudoHideStyles(clone);
                }
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) {
                    copyStyles = true;
                }
                if (!isVideoElement(node)) {
                    this.cloneChildNodes(node, clone, copyStyles);
                }
                if (before) {
                    clone.insertBefore(before, clone.firstChild);
                }
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) {
                    clone.appendChild(after);
                }
                this.counters.pop(counters);
                if ((style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node)) ||
                    copyStyles) {
                    copyCSSStyles(style, clone);
                }
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
                }
                if ((isTextareaElement(node) || isSelectElement(node)) &&
                    (isTextareaElement(clone) || isSelectElement(clone))) {
                    clone.value = node.value;
                }
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function (node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) {
                return;
            }
            var value = style.content;
            var document = clone.ownerDocument;
            if (!document || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') {
                return;
            }
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function (token) {
                if (token.type === 0 /* STRING_TOKEN */) {
                    anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                }
                else if (token.type === 22 /* URL_TOKEN */) {
                    var img = document.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                }
                else if (token.type === 18 /* FUNCTION */) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) {
                            anonymousReplacedElement.appendChild(document.createTextNode(node.getAttribute(attr[0].value) || ''));
                        }
                    }
                    else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            anonymousReplacedElement.appendChild(document.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    }
                    else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */ ? delim.value : '';
                            var text = counterStates
                                .map(function (value) { return createCounterText(value, counterType_1, false); })
                                .join(separator);
                            anonymousReplacedElement.appendChild(document.createTextNode(text));
                        }
                    }
                    else ;
                }
                else if (token.type === 20 /* IDENT_TOKEN */) {
                    switch (token.value) {
                        case 'open-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                            break;
                        case 'close-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                            break;
                        default:
                            // safari doesn't parse string tokens correctly because of lack of quotes
                            anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                    }
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE
                ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE
                : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) {
                clone.className.baseValue += newClassName;
            }
            else {
                clone.className += newClassName;
            }
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function (container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }());
    var PseudoElementType;
    (function (PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function (ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function (img) {
        return new Promise(function (resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function (document) {
        return Promise.all([].slice.call(document.images, 0).map(imageReady));
    };
    var iframeLoader = function (iframe) {
        return new Promise(function (resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) {
                return reject("No window assigned for iframe");
            }
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function () {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function () {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function (style, target) {
        // Edge does not provide value for cssText
        for (var i = style.length - 1; i >= 0; i--) {
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) {
                target.style.setProperty(property, style.getPropertyValue(property));
            }
        }
        return target;
    };
    var serializeDoctype = function (doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) {
                str += doctype.name;
            }
            if (doctype.internalSubset) {
                str += doctype.internalSubset;
            }
            if (doctype.publicId) {
                str += "\"" + doctype.publicId + "\"";
            }
            if (doctype.systemId) {
                str += "\"" + doctype.systemId + "\"";
            }
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function (ownerDocument, x, y) {
        if (ownerDocument &&
            ownerDocument.defaultView &&
            (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
            ownerDocument.defaultView.scrollTo(x, y);
        }
    };
    var restoreNodeScroll = function (_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function (body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function (body, styles) {
        var document = body.ownerDocument;
        if (document) {
            var style = document.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };

    var CacheStorage = /** @class */ (function () {
        function CacheStorage() {
        }
        CacheStorage.getOrigin = function (url) {
            var link = CacheStorage._link;
            if (!link) {
                return 'about:blank';
            }
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function (src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function (window) {
            CacheStorage._link = window.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }());
    var Cache = /** @class */ (function () {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function (src) {
            var result = Promise.resolve();
            if (this.has(src)) {
                return result;
            }
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function () {
                    // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function (src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) &&
                                !isSameOrigin &&
                                !isBlobImage(key) &&
                                typeof this._options.proxy === 'string' &&
                                FEATURES.SUPPORT_CORS_XHR &&
                                !useCORS;
                            if (!isSameOrigin &&
                                this._options.allowTaint === false &&
                                !isInlineImage(key) &&
                                !isBlobImage(key) &&
                                !useProxy &&
                                !useCORS) {
                                return [2 /*return*/];
                            }
                            src = key;
                            if (!useProxy) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.proxy(src)];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [4 /*yield*/, new Promise(function (resolve, reject) {
                                    var img = new Image();
                                    img.onload = function () { return resolve(img); };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) {
                                        img.crossOrigin = 'anonymous';
                                    }
                                    img.src = src;
                                    if (img.complete === true) {
                                        // Inline XML images may fail to parse, throwing an Error later on
                                        setTimeout(function () { return resolve(img); }, 500);
                                    }
                                    if (_this._options.imageTimeout > 0) {
                                        setTimeout(function () { return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image"); }, _this._options.imageTimeout);
                                    }
                                })];
                        case 3: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        Cache.prototype.has = function (key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function () {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function (src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) {
                throw new Error('No proxy defined');
            }
            var key = src.substring(0, 256);
            return new Promise(function (resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        if (responseType === 'text') {
                            resolve(xhr.response);
                        }
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function () { return resolve(reader_1.result); }, false);
                            reader_1.addEventListener('error', function (e) { return reject(e); }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    }
                    else {
                        reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                    }
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
                    xhr.responseType = responseType;
                }
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function () { return reject("Timed out (" + timeout_1 + "ms) proxying " + key); };
                }
                xhr.send();
            });
        };
        return Cache;
    }());
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function (src) { return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src); };
    var isInlineImage = function (src) { return INLINE_IMG.test(src); };
    var isInlineBase64Image = function (src) { return INLINE_BASE64.test(src); };
    var isBlobImage = function (src) { return src.substr(0, 4) === 'blob'; };
    var isSVG = function (src) { return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src); };

    var Vector = /** @class */ (function () {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function (deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }());

    var lerp = function (a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ (function () {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function (t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function (deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function () {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }());
    var isBezierCurve = function (path) { return path.type === 1 /* BEZIER_CURVE */; };

    var BoundCurves = /** @class */ (function () {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3, tlh - (borderLeftWidth * 2) / 3, tlv - (borderTopWidth * 2) / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.topRightBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + (borderTopWidth * 2) / 3, trh - (borderRightWidth * 2) / 3, trv - (borderTopWidth * 2) / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.bottomRightBorderDoubleInnerBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - (borderRightWidth * 2) / 3, brv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.bottomLeftBorderDoubleInnerBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + leftHeight, blh - (borderLeftWidth * 2) / 3, blv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.topLeftBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT)
                    : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }());
    var CORNER;
    (function (CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function (x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch (position) {
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function (curves) {
        return [curves.topLeftBorderBox, curves.topRightBorderBox, curves.bottomRightBorderBox, curves.bottomLeftBorderBox];
    };
    var calculateContentBoxPath = function (curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function (curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };

    var TransformEffect = /** @class */ (function () {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return TransformEffect;
    }());
    var ClipEffect = /** @class */ (function () {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */;
        }
        return ClipEffect;
    }());
    var OpacityEffect = /** @class */ (function () {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return OpacityEffect;
    }());
    var isTransformEffect = function (effect) {
        return effect.type === 0 /* TRANSFORM */;
    };
    var isClipEffect = function (effect) { return effect.type === 1 /* CLIP */; };
    var isOpacityEffect = function (effect) { return effect.type === 2 /* OPACITY */; };

    var equalPath = function (a, b) {
        if (a.length === b.length) {
            return a.some(function (v, i) { return v === b[i]; });
        }
        return false;
    };
    var transformPath = function (path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function (point, index) {
            switch (index) {
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };

    var StackingContext = /** @class */ (function () {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }());
    var ElementPaint = /** @class */ (function () {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) {
                this.effects.push(new OpacityEffect(this.container.styles.opacity));
            }
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                }
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */));
                }
            }
        }
        ElementPaint.prototype.getEffects = function (target) {
            var inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while (parent) {
                var croplessEffects = parent.effects.filter(function (effect) { return !isClipEffect(effect); });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */ || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) {
                            effects.unshift(new ClipEffect(paddingBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                        }
                    }
                }
                else {
                    effects.unshift.apply(effects, croplessEffects);
                }
                parent = parent.parent;
            }
            return effects.filter(function (effect) { return contains(effect.target, target); });
        };
        return ElementPaint;
    }());
    var parseStackTree = function (parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function (child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */);
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */);
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */)) {
                listItems.push(paintContainer);
            }
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function (current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            }
                            else if (index_1 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    }
                    else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function (current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            }
                            else if (index_2 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    }
                    else {
                        parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                    }
                }
                else {
                    if (child.styles.isFloating()) {
                        parentStack.nonPositionedFloats.push(stack);
                    }
                    else {
                        parentStack.nonPositionedInlineLevel.push(stack);
                    }
                }
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            }
            else {
                if (child.styles.isInlineLevel()) {
                    stackingContext.inlineLevel.push(paintContainer);
                }
                else {
                    stackingContext.nonInlineLevel.push(paintContainer);
                }
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */)) {
                processListItems(child, listOwnerItems);
            }
        });
    };
    var processListItems = function (owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for (var i = 0; i < elements.length; i++) {
            var item = elements[i];
            if (item.container instanceof LIElementContainer &&
                typeof item.container.value === 'number' &&
                item.container.value !== 0) {
                numbering = item.container.value;
            }
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function (container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };

    var parsePathForBorder = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function (outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        return path;
    };
    var createPathFromCurves = function (outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        if (isBezierCurve(inner2)) {
            path.push(inner2.subdivide(0.5, true).reverse());
        }
        else {
            path.push(inner2);
        }
        if (isBezierCurve(inner1)) {
            path.push(inner1.subdivide(0.5, false).reverse());
        }
        else {
            path.push(inner1);
        }
        return path;
    };

    var paddingBox = function (element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function (element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };

    var calculateBackgroundPositioningArea = function (backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundOrigin === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function (backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundClip === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function (container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [path, offsetX, offsetY, sizeWidth, sizeHeight];
    };
    var isAuto = function (token) { return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO; };
    var hasIntrinsicValue = function (value) { return typeof value === 'number'; };
    var calculateBackgroundSize = function (size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) {
            return [0, 0];
        }
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
            return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)];
        }
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER)
                    ? [bounds.width, bounds.width / intrinsicProportion]
                    : [bounds.height * intrinsicProportion, bounds.height];
            }
            return [bounds.width, bounds.height];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) {
                return [intrinsicWidth, intrinsicHeight];
            }
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
                return [bounds.width, bounds.height];
            }
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth
                    ? intrinsicWidth
                    : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight
                    ? intrinsicHeight
                    : intrinsicWidth / intrinsicProportion;
                return [width_1, height_1];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [width_2, height_2];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) {
                width_3 = getAbsoluteValue(first, bounds.width);
            }
            else if (isLengthPercentage(second)) {
                height_3 = getAbsoluteValue(second, bounds.height);
            }
            if (isAuto(first)) {
                width_3 = height_3 * intrinsicProportion;
            }
            else if (!second || isAuto(second)) {
                height_3 = width_3 / intrinsicProportion;
            }
            return [width_3, height_3];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) {
            width = getAbsoluteValue(first, bounds.width);
        }
        else if (second && isLengthPercentage(second)) {
            height = getAbsoluteValue(second, bounds.height);
        }
        if (width !== null && (!second || isAuto(second))) {
            height =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (width / intrinsicWidth) * intrinsicHeight
                    : bounds.height;
        }
        if (height !== null && isAuto(first)) {
            width =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (height / intrinsicHeight) * intrinsicWidth
                    : bounds.width;
        }
        if (width !== null && height !== null) {
            return [width, height];
        }
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function (values, index) {
        var value = values[index];
        if (typeof value === 'undefined') {
            return values[0];
        }
        return value;
    };
    var calculateBackgroundRepeatPath = function (repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch (repeat) {
            case 2 /* REPEAT_X */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };

    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ (function () {
        function FontMetrics(document) {
            this._data = {};
            this._document = document;
        }
        FontMetrics.prototype.parseMetrics = function (fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return { baseline: baseline, middle: middle };
        };
        FontMetrics.prototype.getMetrics = function (fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') {
                this._data[key] = this.parseMetrics(fontFamily, fontSize);
            }
            return this._data[key];
        };
        return FontMetrics;
    }());

    var Renderer = /** @class */ (function () {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }());

    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ (function (_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function (effects) {
            var _this = this;
            while (this._activeEffects.length) {
                this.popEffect();
            }
            effects.forEach(function (effect) { return _this.applyEffect(effect); });
        };
        CanvasRenderer.prototype.applyEffect = function (effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) {
                this.ctx.globalAlpha = effect.opacity;
            }
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function () {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var styles;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderStackContent(stack)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            if (!paint.container.styles.isVisible()) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(paint)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.renderNodeContent(paint)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function (text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) {
                this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            }
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function (left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function (styles) {
            var fontVariant = styles.fontVariant
                .filter(function (variant) { return variant === 'normal' || variant === 'small-caps'; })
                .join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize)
                ? "" + styles.fontSize.number + styles.fontSize.unit
                : styles.fontSize.number + "px";
            return [
                [styles.fontStyle, fontVariant, styles.fontWeight, fontSize, fontFamily].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function (text, styles) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function (_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */ ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function (text) {
                        paintOrder.forEach(function (paintOrderLayer) {
                            switch (paintOrderLayer) {
                                case 0 /* FILL */:
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows
                                            .slice(0)
                                            .reverse()
                                            .forEach(function (textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function (textDecorationLine) {
                                            switch (textDecorationLine) {
                                                case 1 /* UNDERLINE */:
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */:
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */:
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */:
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function (container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderTextNode(child, styles)];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [3 /*break*/, 8];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([5, 7, , 8]);
                            return [4 /*yield*/, this.context.cache.match(container.src)];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 8];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [3 /*break*/, 8];
                        case 8:
                            if (container instanceof CanvasElementContainer) {
                                this.renderReplacedElement(container, curves, container.canvas);
                            }
                            if (!(container instanceof SVGElementContainer)) return [3 /*break*/, 12];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([9, 11, , 12]);
                            return [4 /*yield*/, this.context.cache.match(container.svg)];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 12];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [3 /*break*/, 12];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [3 /*break*/, 14];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [4 /*yield*/, iframeRenderer.render(container.tree)];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) {
                                this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            }
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                                else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch (container.styles.textAlign) {
                                    case 1 /* CENTER */:
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */:
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */)) return [3 /*break*/, 20];
                            if (!(container.styles.listStyleImage !== null)) return [3 /*break*/, 19];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */)) return [3 /*break*/, 18];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([15, 17, , 18]);
                            return [4 /*yield*/, this.context.cache.match(url)];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [3 /*break*/, 18];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [3 /*break*/, 18];
                        case 18: return [3 /*break*/, 20];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function (_p) {
                    switch (_p.label) {
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(stack.element)];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [3 /*break*/, 5];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [3 /*break*/, 2];
                        case 5: 
                        // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                        return [4 /*yield*/, this.renderNodeContent(stack.element)];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [3 /*break*/, 10];
                            child = _c[_b];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [3 /*break*/, 7];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [3 /*break*/, 14];
                            child = _e[_d];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [3 /*break*/, 11];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [3 /*break*/, 18];
                            child = _g[_f];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [3 /*break*/, 15];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [3 /*break*/, 22];
                            child = _j[_h];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [3 /*break*/, 19];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [3 /*break*/, 26];
                            child = _l[_k];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [3 /*break*/, 23];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [3 /*break*/, 30];
                            child = _o[_m];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [3 /*break*/, 27];
                        case 30: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function (paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function (paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function (paths) {
            var _this = this;
            paths.forEach(function (point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) {
                    _this.ctx.moveTo(start.x, start.y);
                }
                else {
                    _this.ctx.lineTo(start.x, start.y);
                }
                if (isBezierCurve(point)) {
                    _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
                }
            });
        };
        CanvasRenderer.prototype.renderRepeat = function (path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function (image, width, height) {
            var _a;
            if (image.width === width && image.height === height) {
                return image;
            }
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function (container) {
            return __awaiter(this, void 0, void 0, function () {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function (backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function (_h) {
                                    switch (_h.label) {
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */)) return [3 /*break*/, 5];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, this_1.context.cache.match(url)];
                                        case 2:
                                            image = _h.sent();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [3 /*break*/, 4];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [3 /*break*/, 6];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [null, null, null]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function (colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            }
                                            else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [FIFTY_PERCENT] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function (colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    }
                                                    else {
                                                        this_1.ctx.fill();
                                                    }
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            backgroundImage = _a[_i];
                            return [5 /*yield**/, _loop_1(backgroundImage)];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function (color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function (color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                var outerPaths, innerPaths;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(width < 3)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderSolidBorder(color, side, curvePoints)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                { style: styles.borderTopStyle, color: styles.borderTopColor, width: styles.borderTopWidth },
                                { style: styles.borderRightStyle, color: styles.borderRightColor, width: styles.borderRightWidth },
                                { style: styles.borderBottomStyle, color: styles.borderBottomColor, width: styles.borderBottomWidth },
                                { style: styles.borderLeftStyle, color: styles.borderLeftColor, width: styles.borderLeftWidth }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [3 /*break*/, 2];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [4 /*yield*/, this.renderBackgroundImage(paint.container)];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow
                                .slice(0)
                                .reverse()
                                .forEach(function (shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                }
                                else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [3 /*break*/, 13];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */ && !isTransparent(border.color) && border.width > 0)) return [3 /*break*/, 11];
                            if (!(border.style === 2 /* DASHED */)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */)];
                        case 4:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */)) return [3 /*break*/, 7];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */)];
                        case 6:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */)) return [3 /*break*/, 9];
                            return [4 /*yield*/, this.renderDoubleBorder(border.color, border.width, side, paint.curves)];
                        case 8:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 9: return [4 /*yield*/, this.renderSolidBorder(border.color, side, paint.curves)];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [3 /*break*/, 3];
                        case 13: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function (color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function () {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function (_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    }
                    else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    }
                    else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) {
                        length = Math.abs(startX - endX);
                    }
                    else {
                        length = Math.abs(startY - endY);
                    }
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */) {
                        this.formatPath(strokePaths);
                    }
                    else {
                        this.formatPath(boxPaths.slice(0, 2));
                    }
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) {
                        useLineDash = false;
                    }
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    }
                    else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength =
                            maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace)
                                ? minSpace
                                : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */) {
                            this.ctx.setLineDash([0, dashLength + spaceLength]);
                        }
                        else {
                            this.ctx.setLineDash([dashLength, spaceLength]);
                        }
                    }
                    if (style === 3 /* DOTTED */) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    }
                    else {
                        this.ctx.lineWidth = width * 2 + 1.1;
                    }
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var stack;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [4 /*yield*/, this.renderStack(stack)];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer));
    var isTextInputElement = function (container) {
        if (container instanceof TextareaElementContainer) {
            return true;
        }
        else if (container instanceof SelectElementContainer) {
            return true;
        }
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) {
            return true;
        }
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function (clip, curves) {
        switch (clip) {
            case 0 /* BORDER_BOX */:
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */:
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */:
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function (textAlign) {
        switch (textAlign) {
            case 1 /* CENTER */:
                return 'center';
            case 2 /* RIGHT */:
                return 'right';
            case 0 /* LEFT */:
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = ['-apple-system', 'system-ui'];
    var fixIOSSystemFonts = function (fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent)
            ? fontFamilies.filter(function (fontFamily) { return iOSBrokenFonts.indexOf(fontFamily) === -1; })
            : fontFamilies;
    };

    var ForeignObjectRenderer = /** @class */ (function (_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var svg, img;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [4 /*yield*/, loadSerializedSVG(svg)];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer));
    var loadSerializedSVG = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };

    var Logger = /** @class */ (function () {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') {
                    // eslint-disable-next-line no-console
                    console.debug.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.prototype.getTime = function () {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') {
                    // eslint-disable-next-line no-console
                    console.info.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') {
                    // eslint-disable-next-line no-console
                    console.warn.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') {
                    // eslint-disable-next-line no-console
                    console.error.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.instances = {};
        return Logger;
    }());

    var Context = /** @class */ (function () {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({ id: this.instanceName, enabled: options.logging });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }());

    var html2canvas = function (element, options) {
        if (options === void 0) { options = {}; }
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') {
        CacheStorage.setContext(window);
    }
    var renderElement = function (element, opts) { return __awaiter(void 0, void 0, void 0, function () {
        var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        return __generator(this, function (_u) {
            switch (_u.label) {
                case 0:
                    if (!element || typeof element !== 'object') {
                        return [2 /*return*/, Promise.reject('Invalid element provided as first argument')];
                    }
                    ownerDocument = element.ownerDocument;
                    if (!ownerDocument) {
                        throw new Error("Element is not attached to a Document");
                    }
                    defaultView = ownerDocument.defaultView;
                    if (!defaultView) {
                        throw new Error("Document is not attached to a Window");
                    }
                    resourceOptions = {
                        allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                        imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                        proxy: opts.proxy,
                        useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                    };
                    contextOptions = __assign({ logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true, cache: opts.cache }, resourceOptions);
                    windowOptions = {
                        windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                        windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                        scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                        scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                    };
                    windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                    context = new Context(contextOptions, windowBounds);
                    foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                    cloneOptions = {
                        allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                        onclone: opts.onclone,
                        ignoreElements: opts.ignoreElements,
                        inlineImages: foreignObjectRendering,
                        copyStyles: foreignObjectRendering
                    };
                    context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                    documentCloner = new DocumentCloner(context, element, cloneOptions);
                    clonedElement = documentCloner.clonedReferenceElement;
                    if (!clonedElement) {
                        return [2 /*return*/, Promise.reject("Unable to find element in cloned iframe")];
                    }
                    return [4 /*yield*/, documentCloner.toIFrame(ownerDocument, windowBounds)];
                case 1:
                    container = _u.sent();
                    _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement)
                        ? parseDocumentSize(clonedElement.ownerDocument)
                        : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                    backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                    renderOptions = {
                        canvas: opts.canvas,
                        backgroundColor: backgroundColor,
                        scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                        x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                        y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                        width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                        height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                    };
                    if (!foreignObjectRendering) return [3 /*break*/, 3];
                    context.logger.debug("Document cloned, using foreign object rendering");
                    renderer = new ForeignObjectRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(clonedElement)];
                case 2:
                    canvas = _u.sent();
                    return [3 /*break*/, 5];
                case 3:
                    context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                    context.logger.debug("Starting DOM parsing");
                    root = parseTree(context, clonedElement);
                    if (backgroundColor === root.styles.backgroundColor) {
                        root.styles.backgroundColor = COLORS.TRANSPARENT;
                    }
                    context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                    renderer = new CanvasRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(root)];
                case 4:
                    canvas = _u.sent();
                    _u.label = 5;
                case 5:
                    if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                        if (!DocumentCloner.destroy(container)) {
                            context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                    }
                    context.logger.debug("Finished rendering");
                    return [2 /*return*/, canvas];
            }
        });
    }); };
    var parseBackgroundColor = function (context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement
            ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor)
            : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body
            ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor)
            : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string'
            ? parseColor(context, backgroundColorOverride)
            : backgroundColorOverride === null
                ? COLORS.TRANSPARENT
                : 0xffffffff;
        return element === ownerDocument.documentElement
            ? isTransparent(documentBackgroundColor)
                ? isTransparent(bodyBackgroundColor)
                    ? defaultBackgroundColor
                    : bodyBackgroundColor
                : documentBackgroundColor
            : defaultBackgroundColor;
    };

    function ToRGB(color) {
        var regex = /\((.*?)\)/;
        var res = regex.exec(color);
        if (res && res.length > 1) {
            var numArr = res[1].split(',');
            var r = numArr[0] << 24;
            var g = numArr[1] << 16;
            var b = numArr[2] << 8;
            var a = Math.round(numArr[3] * 255);
            return r + g + b + a;
        }
        return null;
    }
    // 将颜色转为十进制
    function dealColorToNumber(param) {
        var color = param.toString();
        var type = null;
        var regex = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/;
        var regexRGBA = /^rgba\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*(0(\.\d+)?|1(\.0+)?)\s*\)$/i;
        var regex0X = /^0x[0-9A-Fa-f]{6}$/i;
        var regexNumber = /^\d+$/;
        // 颜色类型校验
        regex.test(color) ? (type = 1) : null;
        regex0X.test(color) ? (type = 2) : null;
        regexRGBA.test(color) ? (type = 3) : null;
        regexNumber.test(color) ? (type = 4) : null;
        var colorNum = null;
        switch (type) {
            case 1:
                //#十六进制
                if (color.length == 9) {
                    color = color.replace('#', '0x');
                }
                else {
                    color = color.replace('#', '0x') + 'ff';
                }
                colorNum = Number(color);
                break;
            case 2:
                colorNum = Number(color);
                break;
            case 3:
                colorNum = ToRGB(color);
                break;
            case 4:
                colorNum = parseInt(color);
                break;
            default:
                colorNum = null;
                break;
        }
        if (!colorNum && colorNum !== 0)
            return { status: false, message: "不支持该类型颜色" };
        return {
            status: true,
            data: colorNum,
            message: "颜色转换完成",
        };
    }
    function isValidKey(key, object) {
        return key in object;
    }

    var WIDTH_SIZE_MAP = {
        "min": 6,
        "mid": 12,
        "max": 20
    };
    var WIDTH_LEN_SIZE_MAP = {
        "min": 20,
        "mid": 40,
        "max": 80
    };
    var HEIGHT_SIZE_MAP = {
        "min": 3,
        "mid": 6,
        "max": 10
    };
    var sizeList = ["min", "mid", "max"];
    var Marker = /** @class */ (function (_super) {
        __extends$1(Marker, _super);
        function Marker(cacheManagement, dispatch, bindEvent) {
            if (bindEvent === void 0) { bindEvent = false; }
            var _this = this;
            var _a, _b, _c, _d;
            _this = _super.call(this) || this;
            _this.player = {};
            _this.dealGisMarkerLClick = null;
            _this.dealGisMarkerRClick = null;
            _this.dealGisMarkerHover = null;
            _this.dealGisMarkerLeave = null;
            _this.cacheManagement = cacheManagement;
            _this.dispatch = dispatch;
            var player = getPlayerData(cacheManagement);
            if (!player) {
                throw new Error("player未加载");
            }
            _this.player = player;
            _this.nodeInstance = new NodeProxy(cacheManagement, dispatch);
            Marker.instance = _this;
            if (bindEvent) {
                (_a = _this.player.Native) === null || _a === void 0 ? void 0 : _a.GisMarker.EventGisMarkerLClick.connect(_this.gisMarkerLClick());
                (_b = _this.player.Native) === null || _b === void 0 ? void 0 : _b.GisMarker.EventGisMarkerRClick.connect(_this.gisMarkerRClick());
                (_c = _this.player.Native) === null || _c === void 0 ? void 0 : _c.GisMarker.EventGisMarkerHover.connect(_this.gisMarkerHover());
                (_d = _this.player.Native) === null || _d === void 0 ? void 0 : _d.GisMarker.EventGisMarkerLeave.connect(_this.gisMarkerLeave());
            }
            return _this;
        }
        Marker.prototype.destroyInstance = function (markerCache) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var removeMarker;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            removeMarker = [];
                            if (markerCache.type === 'sis') {
                                removeMarker.push.apply(removeMarker, markerCache.extraData.optionsPtr);
                            }
                            removeMarker.push(markerCache === null || markerCache === void 0 ? void 0 : markerCache.pointer);
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.GisMarker.destroy(removeMarker))];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        /** 鼠标左键点击标签 */
        Marker.prototype.gisMarkerLClick = function () {
            var _this = this;
            var that = this;
            this.dealGisMarkerLClick = function (e) {
                var markerNodeList = _this.cacheManagement.findCacheByType(cacheType.Marker);
                var currentMarker = markerNodeList.find(function (el) {
                    var _a, _b, _c;
                    var currentMarkerData = (_a = el.instance) === null || _a === void 0 ? void 0 : _a.getDataInfo();
                    if (currentMarkerData && currentMarkerData.type === 'sis') {
                        var currnetIndex = currentMarkerData.extraData.optionsPtr.findIndex(function (item) {
                            return e.markerId === item;
                        });
                        if (currnetIndex === currentMarkerData.extraData.optionsPtr.length - 3) {
                            that.destroyMarker(currentMarkerData.id);
                            return false;
                        }
                        return currnetIndex !== -1;
                    }
                    return e.markerId === ((_c = (_b = el.instance) === null || _b === void 0 ? void 0 : _b.getDataInfo()) === null || _c === void 0 ? void 0 : _c.pointer);
                });
                if (currentMarker) {
                    _this.dispatch.emit('Marker', {
                        markerId: currentMarker.id,
                        type: EMarkerEvent$1.leftClick
                    });
                }
            };
            return this.dealGisMarkerLClick;
        };
        /** 鼠标右键点击标签 */
        Marker.prototype.gisMarkerRClick = function () {
            var _this = this;
            this.dealGisMarkerRClick = function (e) {
                var markerNodeList = _this.cacheManagement.findCacheByType(cacheType.Marker);
                var currentMarker = markerNodeList.find(function (el) {
                    var _a, _b, _c;
                    var currentMarkerData = (_a = el.instance) === null || _a === void 0 ? void 0 : _a.getDataInfo();
                    if (currentMarkerData && currentMarkerData.type === 'sis') {
                        return currentMarkerData.extraData.optionsPtr.includes(e.markerId);
                    }
                    return e.markerId === ((_c = (_b = el.instance) === null || _b === void 0 ? void 0 : _b.getDataInfo()) === null || _c === void 0 ? void 0 : _c.pointer);
                });
                if (currentMarker) {
                    _this.dispatch.emit('Marker', {
                        markerId: currentMarker.id,
                        type: EMarkerEvent$1.rightClick
                    });
                }
            };
            return this.dealGisMarkerRClick;
        };
        /** 鼠标经过标签 */
        Marker.prototype.gisMarkerHover = function () {
            var _this = this;
            this.dealGisMarkerHover = function (e) {
                var markerNodeList = _this.cacheManagement.findCacheByType(cacheType.Marker);
                var currentMarker = markerNodeList.find(function (el) {
                    var _a, _b, _c;
                    var currentMarkerData = (_a = el.instance) === null || _a === void 0 ? void 0 : _a.getDataInfo();
                    if (currentMarkerData && currentMarkerData.type === 'sis') {
                        return currentMarkerData.extraData.optionsPtr.includes(e.markerId);
                    }
                    return e.markerId === ((_c = (_b = el.instance) === null || _b === void 0 ? void 0 : _b.getDataInfo()) === null || _c === void 0 ? void 0 : _c.pointer);
                });
                if (currentMarker) {
                    _this.dispatch.emit('Marker', {
                        markerId: currentMarker.id,
                        type: EMarkerEvent$1.hover
                    });
                }
            };
            return this.dealGisMarkerHover;
        };
        /** 鼠标离开标签 */
        Marker.prototype.gisMarkerLeave = function () {
            var _this = this;
            this.dealGisMarkerLeave = function (e) {
                var markerNodeList = _this.cacheManagement.findCacheByType(cacheType.Marker);
                var currentMarker = markerNodeList.find(function (el) {
                    var _a, _b, _c;
                    var currentMarkerData = (_a = el.instance) === null || _a === void 0 ? void 0 : _a.getDataInfo();
                    if (currentMarkerData && currentMarkerData.type === 'sis') {
                        return currentMarkerData.extraData.optionsPtr.includes(e.markerId);
                    }
                    return e.markerId === ((_c = (_b = el.instance) === null || _b === void 0 ? void 0 : _b.getDataInfo()) === null || _c === void 0 ? void 0 : _c.pointer);
                });
                if (currentMarker) {
                    _this.dispatch.emit('Marker', {
                        markerId: currentMarker.id,
                        type: EMarkerEvent$1.hover,
                        leave: true
                    });
                }
            };
            return this.dealGisMarkerLeave;
        };
        /**
         * @description: 单行标签创建
         * @param {IMarkSingleLineOption} markSingleLineOption
         * @return {*}
         */
        Marker.prototype.createBySingleLine = function (markSingleLineOption) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var hasMarker, createIds, imgList, imgIdList, optionList, optionsPtr, i, element, id, markerInstance;
                var _this = this;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!Array.isArray(markSingleLineOption)) {
                                markSingleLineOption = [markSingleLineOption];
                            }
                            hasMarker = markSingleLineOption.find(function (item) {
                                return item.id && _this.cacheManagement.findCacheById(item.id);
                            });
                            if (hasMarker) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "".concat(hasMarker.id, "\u5DF2\u5B58\u5728")
                                    }];
                            }
                            // 加载标签
                            // 计算文本大小
                            markSingleLineOption = this.fetchTextStyle(markSingleLineOption);
                            createIds = [];
                            imgList = this.fetchImgList('single', markSingleLineOption);
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.GisMarker.loadImage(imgList))
                                // 批量加载标签
                            ];
                        case 1:
                            imgIdList = _c.sent();
                            optionList = this.fetchSingleMarkerOption(markSingleLineOption, imgIdList);
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.GisMarker.create(optionList))
                                // 将标签关联至node上
                            ];
                        case 2:
                            optionsPtr = _c.sent();
                            // 将标签关联至node上
                            for (i = 0; i < optionsPtr.length; i++) {
                                element = optionsPtr[i];
                                id = markSingleLineOption[i].id || generateUUID();
                                createIds.push(id);
                                markerInstance = new baseWrap({
                                    id: id,
                                    pointer: element,
                                    type: 'single',
                                    markOption: markSingleLineOption[i],
                                    realOption: optionList[i],
                                    instance: this
                                }, cacheType.Marker);
                                this.cacheManagement.createCache(id, markerInstance, {
                                    instance: markSingleLineOption[i].parentNode
                                });
                            }
                            return [2 /*return*/, {
                                    status: true,
                                    message: "加载成功",
                                    data: createIds,
                                    extra: optionsPtr
                                }];
                    }
                });
            });
        };
        /**
         * @description: 单行标签的更新
         * @param {IMarkSingleLineOption} markSingleLineOption
         * @return {*}
         */
        Marker.prototype.updateBySingleLine = function (markSingleLineOption) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var markerNodeList, markerSingleList, markerInfoList, arrayHasId, imgList, imgIdList, optionList, batchUpdateData;
                var _this = this;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!Array.isArray(markSingleLineOption)) {
                                markSingleLineOption = [markSingleLineOption];
                            }
                            markerNodeList = this.cacheManagement.findCacheByType(cacheType.Marker);
                            markerSingleList = markerNodeList.filter(function (el) {
                                var markInfo = _this.findMarkerCacheInfo(el.instance);
                                return (markInfo === null || markInfo === void 0 ? void 0 : markInfo.type) === 'single';
                            });
                            markerInfoList = markerSingleList.map(function (el) {
                                return _this.findMarkerCacheInfo(el.instance);
                            });
                            arrayHasId = markSingleLineOption.every(function (el) {
                                return !!el.id && markerInfoList.find(function (item) {
                                    return (item === null || item === void 0 ? void 0 : item.id) === el.id;
                                });
                            });
                            if (!arrayHasId) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "更新标记时,每项需要传递id, 且当前id创建的标签为单行类型的标签"
                                    }];
                            }
                            // 处理选项
                            markSingleLineOption = markSingleLineOption.map(function (element) {
                                // 获取当前id关联的标记
                                var currentData = markerInfoList.find(function (item) {
                                    return (item === null || item === void 0 ? void 0 : item.id) === element.id;
                                });
                                return __assign$2(__assign$2({}, currentData === null || currentData === void 0 ? void 0 : currentData.markOption), element);
                            });
                            // 计算文本大小
                            markSingleLineOption = this.fetchTextStyle(markSingleLineOption);
                            imgList = this.fetchImgList('single', markSingleLineOption);
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.GisMarker.loadImage(imgList))
                                // 批量加载标签
                            ];
                        case 1:
                            imgIdList = _c.sent();
                            optionList = this.fetchSingleMarkerOption(markSingleLineOption, imgIdList);
                            batchUpdateData = optionList.map(function (el, index) {
                                var currentMarkerData = markerInfoList.find(function (item) {
                                    return (item === null || item === void 0 ? void 0 : item.id) === markSingleLineOption[index].id;
                                });
                                Object.entries(currentMarkerData === null || currentMarkerData === void 0 ? void 0 : currentMarkerData.realOption).forEach(function (item) {
                                    if (isValidKey(item[0], el)) {
                                        if (item[1] === el[item[0]]) {
                                            delete el[item[0]];
                                        }
                                    }
                                });
                                return {
                                    markerId: currentMarkerData === null || currentMarkerData === void 0 ? void 0 : currentMarkerData.pointer,
                                    props: el
                                };
                            });
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.GisMarker.setProperty(batchUpdateData))
                                // 更新option
                            ];
                        case 2:
                            _c.sent();
                            // 更新option
                            markerNodeList.forEach(function (el) {
                                var _a, _b;
                                var currentIndex = markSingleLineOption.findIndex(function (i) {
                                    return i.id === el.id;
                                });
                                if (currentIndex !== -1) {
                                    var markerInstance = _this.cacheManagement.findCacheById(el.id);
                                    if (markerInstance && markerInstance.type === cacheType.Marker) {
                                        var dataInfo = (_a = markerInstance.instance) === null || _a === void 0 ? void 0 : _a.getDataInfo();
                                        if (dataInfo) {
                                            dataInfo.markOption = markSingleLineOption[currentIndex];
                                            dataInfo.realOption = optionList[currentIndex];
                                            (_b = markerInstance.instance) === null || _b === void 0 ? void 0 : _b.setDataInfo(dataInfo);
                                        }
                                    }
                                }
                            });
                            return [2 /*return*/, {
                                    status: true,
                                    message: "更新成功",
                                }];
                    }
                });
            });
        };
        /**
         * 创建多行标签
         * @param markMultiLineOption
         * @returns
         */
        Marker.prototype.createByMultiLine = function (markMultiLineOption) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var hasMarker, createIds, imgList, imgIdList, optionList, optionsPtr, i, element, id, markerInstance;
                var _this = this;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!Array.isArray(markMultiLineOption)) {
                                markMultiLineOption = [markMultiLineOption];
                            }
                            hasMarker = markMultiLineOption.find(function (item) {
                                return item.id && _this.cacheManagement.findCacheById(item.id);
                            });
                            if (hasMarker) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "".concat(hasMarker.id, "\u5DF2\u5B58\u5728")
                                    }];
                            }
                            createIds = [];
                            // 计算文本大小
                            markMultiLineOption = this.fetchTextStyleByMulti(markMultiLineOption);
                            imgList = this.fetchImgList('multi', markMultiLineOption);
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.GisMarker.loadImage(imgList))
                                // 批量加载标签
                            ];
                        case 1:
                            imgIdList = _c.sent();
                            optionList = this.fetchMultiMarkerOption(markMultiLineOption, imgIdList);
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.GisMarker.create(optionList))
                                // 将标签关联至node上
                            ];
                        case 2:
                            optionsPtr = _c.sent();
                            // 将标签关联至node上
                            for (i = 0; i < optionsPtr.length; i++) {
                                element = optionsPtr[i];
                                id = markMultiLineOption[i].id || generateUUID();
                                createIds.push(id);
                                markerInstance = new baseWrap({
                                    id: id,
                                    pointer: element,
                                    type: 'multi',
                                    markOption: markMultiLineOption[i],
                                    realOption: optionList[i],
                                    instance: this
                                }, cacheType.Marker);
                                this.cacheManagement.createCache(id, markerInstance, {
                                    instance: markMultiLineOption[i].parentNode
                                });
                            }
                            return [2 /*return*/, {
                                    status: true,
                                    message: "加载成功",
                                    data: createIds
                                }];
                    }
                });
            });
        };
        /**
         * @description: 更新多行标签
         * @param {IMarkMultiLineOption} markMultiLineOption
         * @return {*}
         */
        Marker.prototype.updateByMultiLine = function (markMultiLineOption) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var markerNodeList, markerMultiList, markerInfoList, arrayHasId, imgList, imgIdList, optionList, batchUpdateData;
                var _this = this;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!Array.isArray(markMultiLineOption)) {
                                markMultiLineOption = [markMultiLineOption];
                            }
                            markerNodeList = this.cacheManagement.findCacheByType(cacheType.Marker);
                            markerMultiList = markerNodeList.filter(function (el) {
                                var markInfo = _this.findMarkerCacheInfo(el.instance);
                                return (markInfo === null || markInfo === void 0 ? void 0 : markInfo.type) === 'multi';
                            });
                            markerInfoList = markerMultiList.map(function (el) {
                                return _this.findMarkerCacheInfo(el.instance);
                            });
                            arrayHasId = markMultiLineOption.every(function (el) {
                                return !!el.id && markerInfoList.find(function (item) {
                                    return (item === null || item === void 0 ? void 0 : item.id) === el.id;
                                });
                            });
                            if (!arrayHasId) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "更新标记时,每项需要传递id, 且当前id创建的标签未多行类型的标签"
                                    }];
                            }
                            // 处理选项
                            markMultiLineOption = markMultiLineOption.map(function (element) {
                                // 获取当前id关联的标记
                                var currentData = markerInfoList.find(function (item) {
                                    return (item === null || item === void 0 ? void 0 : item.id) === element.id;
                                });
                                return __assign$2(__assign$2({}, currentData === null || currentData === void 0 ? void 0 : currentData.markOption), element);
                            });
                            // 计算文本大小
                            markMultiLineOption = this.fetchTextStyleByMulti(markMultiLineOption);
                            imgList = this.fetchImgList('multi', markMultiLineOption);
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.GisMarker.loadImage(imgList))
                                // 批量加载标签
                            ];
                        case 1:
                            imgIdList = _c.sent();
                            optionList = this.fetchMultiMarkerOption(markMultiLineOption, imgIdList);
                            batchUpdateData = optionList.map(function (el, index) {
                                var currentMarkerData = markerInfoList.find(function (item) {
                                    return (item === null || item === void 0 ? void 0 : item.id) === markMultiLineOption[index].id;
                                });
                                Object.entries(currentMarkerData === null || currentMarkerData === void 0 ? void 0 : currentMarkerData.realOption).forEach(function (item) {
                                    if (isValidKey(item[0], el)) {
                                        if (item[1] === el[item[0]]) {
                                            delete el[item[0]];
                                        }
                                    }
                                });
                                return {
                                    markerId: currentMarkerData === null || currentMarkerData === void 0 ? void 0 : currentMarkerData.pointer,
                                    props: el
                                };
                            });
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.GisMarker.setProperty(batchUpdateData))
                                // 更新option
                            ];
                        case 2:
                            _c.sent();
                            // 更新option
                            markerNodeList.forEach(function (el) {
                                var _a, _b;
                                var currentIndex = markMultiLineOption.findIndex(function (i) {
                                    return i.id === el.id;
                                });
                                if (currentIndex !== -1) {
                                    var markerInstance = _this.cacheManagement.findCacheById(el.id);
                                    if (markerInstance && markerInstance.type === cacheType.Marker) {
                                        var dataInfo = (_a = markerInstance.instance) === null || _a === void 0 ? void 0 : _a.getDataInfo();
                                        if (dataInfo) {
                                            dataInfo.markOption = markMultiLineOption[currentIndex];
                                            dataInfo.realOption = optionList[currentIndex];
                                            (_b = markerInstance.instance) === null || _b === void 0 ? void 0 : _b.setDataInfo(dataInfo);
                                        }
                                    }
                                }
                            });
                            return [2 /*return*/, {
                                    status: true,
                                    message: "更新成功",
                                }];
                    }
                });
            });
        };
        /**
         * 创建圆形标签
         * @param markRoundOption
         * @returns
         */
        Marker.prototype.createByRound = function (markRoundOption) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var hasMarker, createIds, imgList, imgIdList, optionList, optionsPtr, i, element, id, markerInstance;
                var _this = this;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!Array.isArray(markRoundOption)) {
                                markRoundOption = [markRoundOption];
                            }
                            hasMarker = markRoundOption.find(function (item) {
                                return item.id && _this.cacheManagement.findCacheById(item.id);
                            });
                            if (hasMarker) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "".concat(hasMarker.id, "\u5DF2\u5B58\u5728")
                                    }];
                            }
                            createIds = [];
                            imgList = this.fetchImgList('round', markRoundOption);
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.GisMarker.loadImage(imgList))
                                // 批量加载标签
                            ];
                        case 1:
                            imgIdList = _c.sent();
                            optionList = this.fetchRoundMarkerOption(markRoundOption, imgIdList);
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.GisMarker.create(optionList))
                                // 将标签关联至node上
                            ];
                        case 2:
                            optionsPtr = _c.sent();
                            // 将标签关联至node上
                            for (i = 0; i < optionsPtr.length; i++) {
                                element = optionsPtr[i];
                                id = markRoundOption[i].id || generateUUID();
                                createIds.push(id);
                                markerInstance = new baseWrap({
                                    id: id,
                                    pointer: element,
                                    type: 'round',
                                    markOption: markRoundOption[i],
                                    realOption: optionList[i],
                                    instance: this
                                }, cacheType.Marker);
                                this.cacheManagement.createCache(id, markerInstance, {
                                    instance: markRoundOption[i].parentNode
                                });
                            }
                            return [2 /*return*/, {
                                    status: true,
                                    message: "加载成功",
                                    data: createIds
                                }];
                    }
                });
            });
        };
        /**
         * @description: 更新圆形标签
         * @param {IMarkRoundOption} markRoundOption
         * @return {*}
         */
        Marker.prototype.updateByRound = function (markRoundOption) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var markerNodeList, markerRoundList, markerInfoList, arrayHasId, imgList, imgIdList, optionList, batchUpdateData;
                var _this = this;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!Array.isArray(markRoundOption)) {
                                markRoundOption = [markRoundOption];
                            }
                            markerNodeList = this.cacheManagement.findCacheByType(cacheType.Marker);
                            markerRoundList = markerNodeList.filter(function (el) {
                                var markInfo = _this.findMarkerCacheInfo(el.instance);
                                return (markInfo === null || markInfo === void 0 ? void 0 : markInfo.type) === 'round';
                            });
                            markerInfoList = markerRoundList.map(function (el) {
                                return _this.findMarkerCacheInfo(el.instance);
                            });
                            arrayHasId = markRoundOption.every(function (el) {
                                return !!el.id && markerInfoList.find(function (item) {
                                    return (item === null || item === void 0 ? void 0 : item.id) === el.id;
                                });
                            });
                            if (!arrayHasId) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "更新标记时,每项需要传递id, 且当前id已创建圆形类型的标签"
                                    }];
                            }
                            // 处理选项
                            markRoundOption = markRoundOption.map(function (element) {
                                // 获取当前id关联的标记
                                var currentData = markerInfoList.find(function (item) {
                                    return (item === null || item === void 0 ? void 0 : item.id) === element.id;
                                });
                                return __assign$2(__assign$2({}, currentData === null || currentData === void 0 ? void 0 : currentData.markOption), element);
                            });
                            imgList = this.fetchImgList('round', markRoundOption);
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.GisMarker.loadImage(imgList))
                                // 批量加载标签
                            ];
                        case 1:
                            imgIdList = _c.sent();
                            optionList = this.fetchRoundMarkerOption(markRoundOption, imgIdList);
                            batchUpdateData = optionList.map(function (el, index) {
                                var currentMarkerData = markerInfoList.find(function (item) {
                                    return (item === null || item === void 0 ? void 0 : item.id) === markRoundOption[index].id;
                                });
                                Object.entries(currentMarkerData === null || currentMarkerData === void 0 ? void 0 : currentMarkerData.realOption).forEach(function (item) {
                                    if (isValidKey(item[0], el)) {
                                        if (item[1] === el[item[0]]) {
                                            delete el[item[0]];
                                        }
                                    }
                                });
                                return {
                                    markerId: currentMarkerData === null || currentMarkerData === void 0 ? void 0 : currentMarkerData.pointer,
                                    props: el
                                };
                            });
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.GisMarker.setProperty(batchUpdateData))
                                // 更新option
                            ];
                        case 2:
                            _c.sent();
                            // 更新option
                            markerNodeList.forEach(function (el) {
                                var _a, _b;
                                var currentIndex = markRoundOption.findIndex(function (i) {
                                    return i.id === el.id;
                                });
                                if (currentIndex !== -1) {
                                    var markerInstance = _this.cacheManagement.findCacheById(el.id);
                                    if (markerInstance && markerInstance.type === cacheType.Marker) {
                                        var dataInfo = (_a = markerInstance.instance) === null || _a === void 0 ? void 0 : _a.getDataInfo();
                                        if (dataInfo) {
                                            dataInfo.markOption = markRoundOption[currentIndex];
                                            dataInfo.realOption = optionList[currentIndex];
                                            (_b = markerInstance.instance) === null || _b === void 0 ? void 0 : _b.setDataInfo(dataInfo);
                                        }
                                    }
                                }
                            });
                            return [2 /*return*/, {
                                    status: true,
                                    message: "更新成功",
                                }];
                    }
                });
            });
        };
        /**
         * 创建图片标签
         * @param markPictureOption
         * @returns
         */
        Marker.prototype.createByPicture = function (markPictureOption) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var hasMarker, imgList, createIds, imgIdList, optionList, optionsPtr, i, element, id, markerInstance;
                var _this = this;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            // 检测id是否已经存在
                            if (!Array.isArray(markPictureOption)) {
                                markPictureOption = [markPictureOption];
                            }
                            hasMarker = markPictureOption.find(function (item) {
                                return item.id && _this.cacheManagement.findCacheById(item.id);
                            });
                            if (hasMarker) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "".concat(hasMarker.id, "\u5DF2\u5B58\u5728")
                                    }];
                            }
                            imgList = markPictureOption.map(function (element) {
                                return element.backgroundUrl;
                            });
                            createIds = [];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.GisMarker.loadImage(imgList))
                                // 批量加载标签
                            ];
                        case 1:
                            imgIdList = _c.sent();
                            optionList = this.fetchPictureMarkerOption(markPictureOption, imgIdList);
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.GisMarker.create(optionList))
                                // 将标签关联至node上
                            ];
                        case 2:
                            optionsPtr = _c.sent();
                            // 将标签关联至node上
                            for (i = 0; i < optionsPtr.length; i++) {
                                element = optionsPtr[i];
                                id = markPictureOption[i].id || generateUUID();
                                createIds.push(id);
                                markerInstance = new baseWrap({
                                    id: id,
                                    pointer: element,
                                    type: 'picture',
                                    markOption: markPictureOption[i],
                                    realOption: optionList[i],
                                    instance: this
                                }, cacheType.Marker);
                                this.cacheManagement.createCache(id, markerInstance, {
                                    instance: markPictureOption[i].parentNode
                                });
                            }
                            return [2 /*return*/, {
                                    status: true,
                                    message: "加载成功",
                                    data: createIds
                                }];
                    }
                });
            });
        };
        /**
         * @description: 更新图片标签
         * @param {IMarkPictureOption} markPictureOption
         * @return {*}
         */
        Marker.prototype.updateByPicture = function (markPictureOption) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var markerNodeList, markerPictureList, markerInfoList, arrayHasId, imgList, imgIdList, optionList, batchUpdateData;
                var _this = this;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!Array.isArray(markPictureOption)) {
                                markPictureOption = [markPictureOption];
                            }
                            markerNodeList = this.cacheManagement.findCacheByType(cacheType.Marker);
                            markerPictureList = markerNodeList.filter(function (el) {
                                var markInfo = _this.findMarkerCacheInfo(el.instance);
                                return (markInfo === null || markInfo === void 0 ? void 0 : markInfo.type) === 'picture';
                            });
                            markerInfoList = markerPictureList.map(function (el) {
                                return _this.findMarkerCacheInfo(el.instance);
                            });
                            arrayHasId = markPictureOption.every(function (el) {
                                return !!el.id && markerInfoList.find(function (item) {
                                    return (item === null || item === void 0 ? void 0 : item.id) === el.id;
                                });
                            });
                            if (!arrayHasId) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "更新标记时,每项需要传递id, 且当前id已创建图片类型的标签"
                                    }];
                            }
                            // 处理选项
                            markPictureOption = markPictureOption.map(function (element) {
                                // 获取当前id关联的标记
                                var currentData = markerInfoList.find(function (item) {
                                    return (item === null || item === void 0 ? void 0 : item.id) === element.id;
                                });
                                return __assign$2(__assign$2({}, currentData === null || currentData === void 0 ? void 0 : currentData.markOption), element);
                            });
                            imgList = markPictureOption.map(function (element) {
                                return element.backgroundUrl;
                            });
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.GisMarker.loadImage(imgList))
                                // 批量加载标签
                            ];
                        case 1:
                            imgIdList = _c.sent();
                            optionList = this.fetchPictureMarkerOption(markPictureOption, imgIdList);
                            batchUpdateData = optionList.map(function (el, index) {
                                var currentMarkerData = markerInfoList.find(function (item) {
                                    return (item === null || item === void 0 ? void 0 : item.id) === markPictureOption[index].id;
                                });
                                Object.entries(currentMarkerData === null || currentMarkerData === void 0 ? void 0 : currentMarkerData.realOption).forEach(function (item) {
                                    if (isValidKey(item[0], el)) {
                                        if (item[1] === el[item[0]]) {
                                            delete el[item[0]];
                                        }
                                    }
                                });
                                return {
                                    markerId: currentMarkerData === null || currentMarkerData === void 0 ? void 0 : currentMarkerData.pointer,
                                    props: el
                                };
                            });
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.GisMarker.setProperty(batchUpdateData))
                                // 更新option
                            ];
                        case 2:
                            _c.sent();
                            // 更新option
                            markerNodeList.forEach(function (el) {
                                var _a, _b;
                                var currentIndex = markPictureOption.findIndex(function (i) {
                                    return i.id === el.id;
                                });
                                if (currentIndex !== -1) {
                                    var markerInstance = _this.cacheManagement.findCacheById(el.id);
                                    if (markerInstance && markerInstance.type === cacheType.Marker) {
                                        var dataInfo = (_a = markerInstance.instance) === null || _a === void 0 ? void 0 : _a.getDataInfo();
                                        if (dataInfo) {
                                            dataInfo.markOption = markPictureOption[currentIndex];
                                            dataInfo.realOption = optionList[currentIndex];
                                            (_b = markerInstance.instance) === null || _b === void 0 ? void 0 : _b.setDataInfo(dataInfo);
                                        }
                                    }
                                }
                            });
                            return [2 /*return*/, {
                                    status: true,
                                    message: "更新成功",
                                }];
                    }
                });
            });
        };
        /**
         * 创建dom标签
         * @param markDomOption
         * @returns
         */
        Marker.prototype.createByDom = function (markDomOption) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var hasMarker, markDomList, imgList, i, element, convas, imgIdList, optionList, optionsPtr, createIds, i, element, id, markerInstance;
                var _this = this;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!Array.isArray(markDomOption)) {
                                markDomOption = [markDomOption];
                            }
                            hasMarker = markDomOption.find(function (item) {
                                return item.id && _this.cacheManagement.findCacheById(item.id);
                            });
                            if (hasMarker) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "".concat(hasMarker.id, "\u5DF2\u5B58\u5728")
                                    }];
                            }
                            markDomList = markDomOption.map(function (el) {
                                return el.dom;
                            });
                            imgList = [];
                            i = 0;
                            _c.label = 1;
                        case 1:
                            if (!(i < 1)) return [3 /*break*/, 4];
                            element = markDomList[i];
                            return [4 /*yield*/, html2canvas(element, {})];
                        case 2:
                            convas = _c.sent();
                            imgList.push(convas.toDataURL());
                            _c.label = 3;
                        case 3:
                            i++;
                            return [3 /*break*/, 1];
                        case 4: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.GisMarker.loadImage(imgList))
                            // 批量加载标签
                        ];
                        case 5:
                            imgIdList = _c.sent();
                            optionList = this.fetchDomOption(markDomOption, imgIdList);
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.GisMarker.create(optionList))
                                // 获取需要加载标签的列表
                            ];
                        case 6:
                            optionsPtr = _c.sent();
                            createIds = [];
                            // 将标签关联至node上
                            for (i = 0; i < optionsPtr.length; i++) {
                                element = optionsPtr[i];
                                id = markDomOption[i].id || generateUUID();
                                createIds.push(id);
                                markerInstance = new baseWrap({
                                    id: id,
                                    pointer: element,
                                    type: 'dom',
                                    markOption: markDomOption[i],
                                    realOption: optionList[i],
                                    instance: this
                                }, cacheType.Marker);
                                this.cacheManagement.createCache(id, markerInstance, {
                                    instance: markDomOption[i].parentNode
                                });
                            }
                            return [2 /*return*/, {
                                    status: true,
                                    message: "加载成功",
                                    data: createIds
                                }];
                    }
                });
            });
        };
        /**
         * @description: 更新dom标签
         * @param {IMarkDomOption} markDomOption
         * @return {*}
         */
        Marker.prototype.updateByDom = function (markDomOption) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var markerNodeList, markerDomList, markerInfoList, arrayHasId, markDomList, imgList, i, element, convas, imgIdList, optionList, batchUpdateData;
                var _this = this;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!Array.isArray(markDomOption)) {
                                markDomOption = [markDomOption];
                            }
                            markerNodeList = this.cacheManagement.findCacheByType(cacheType.Marker);
                            markerDomList = markerNodeList.filter(function (el) {
                                var markInfo = _this.findMarkerCacheInfo(el.instance);
                                return (markInfo === null || markInfo === void 0 ? void 0 : markInfo.type) === 'dom';
                            });
                            markerInfoList = markerDomList.map(function (el) {
                                return _this.findMarkerCacheInfo(el.instance);
                            });
                            arrayHasId = markDomOption.every(function (el) {
                                return !!el.id && markerInfoList.find(function (item) {
                                    return (item === null || item === void 0 ? void 0 : item.id) === el.id;
                                });
                            });
                            if (!arrayHasId) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "更新标记时,每项需要传递id, 且当前id已创建dom类型的标签"
                                    }];
                            }
                            // 处理选项
                            markDomOption = markDomOption.map(function (element) {
                                // 获取当前id关联的标记
                                var currentData = markerInfoList.find(function (item) {
                                    return (item === null || item === void 0 ? void 0 : item.id) === element.id;
                                });
                                return __assign$2(__assign$2({}, currentData === null || currentData === void 0 ? void 0 : currentData.markOption), element);
                            });
                            markDomList = markDomOption.map(function (el) {
                                return el.dom;
                            });
                            imgList = [];
                            i = 0;
                            _c.label = 1;
                        case 1:
                            if (!(i < 1)) return [3 /*break*/, 4];
                            element = markDomList[i];
                            return [4 /*yield*/, html2canvas(element, {})];
                        case 2:
                            convas = _c.sent();
                            imgList.push(convas.toDataURL());
                            _c.label = 3;
                        case 3:
                            i++;
                            return [3 /*break*/, 1];
                        case 4: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.GisMarker.loadImage(imgList))
                            // 批量加载标签
                        ];
                        case 5:
                            imgIdList = _c.sent();
                            optionList = this.fetchDomOption(markDomOption, imgIdList);
                            batchUpdateData = optionList.map(function (el, index) {
                                var currentMarkerData = markerInfoList.find(function (item) {
                                    return (item === null || item === void 0 ? void 0 : item.id) === markDomOption[index].id;
                                });
                                Object.entries(currentMarkerData === null || currentMarkerData === void 0 ? void 0 : currentMarkerData.realOption).forEach(function (item) {
                                    if (isValidKey(item[0], el)) {
                                        if (item[1] === el[item[0]]) {
                                            delete el[item[0]];
                                        }
                                    }
                                });
                                return {
                                    markerId: currentMarkerData === null || currentMarkerData === void 0 ? void 0 : currentMarkerData.pointer,
                                    props: el
                                };
                            });
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.GisMarker.setProperty(batchUpdateData))
                                // 更新option
                            ];
                        case 6:
                            _c.sent();
                            // 更新option
                            markerNodeList.forEach(function (el) {
                                var _a, _b;
                                var currentIndex = markDomOption.findIndex(function (i) {
                                    return i.id === el.id;
                                });
                                if (currentIndex !== -1) {
                                    var markerInstance = _this.cacheManagement.findCacheById(el.id);
                                    if (markerInstance && markerInstance.type === cacheType.Marker) {
                                        var dataInfo = (_a = markerInstance.instance) === null || _a === void 0 ? void 0 : _a.getDataInfo();
                                        if (dataInfo) {
                                            dataInfo.markOption = markDomOption[currentIndex];
                                            dataInfo.realOption = optionList[currentIndex];
                                            (_b = markerInstance.instance) === null || _b === void 0 ? void 0 : _b.setDataInfo(dataInfo);
                                        }
                                    }
                                }
                            });
                            return [2 /*return*/, {
                                    status: true,
                                    message: "更新成功",
                                }];
                    }
                });
            });
        };
        /**
         * 创建sis标签
         * @param markSisOption
         * @returns
         */
        Marker.prototype.createBySis = function (markSisOption) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var hasMarker, imgList, backgroundList, _loop_1, this_1, i, loadImage, imgIdList_1, createIds, optionMapList, optionList, optionItem, element, optionsPtr, startPtr, i, element, id, ptr, markerInstance;
                var _this = this;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!Array.isArray(markSisOption)) {
                                markSisOption = [markSisOption];
                            }
                            hasMarker = markSisOption.find(function (item) {
                                return item.id && _this.cacheManagement.findCacheById(item.id);
                            });
                            if (hasMarker) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "".concat(hasMarker.id, "\u5DF2\u5B58\u5728")
                                    }];
                            }
                            imgList = {};
                            backgroundList = this.getImageCacheList();
                            _loop_1 = function (i) {
                                var sisItem = markSisOption[i];
                                // 内容默认的背景图
                                if (!sisItem.contentBackgroud || (sisItem.contentBackgroud && sisItem.contentBackgroud.includes("#"))) {
                                    var url = this_1.getImgUrl("single", sisItem.contentBackgroud);
                                    imgList[url] = 0;
                                }
                                else {
                                    sizeList.forEach(function (sizeItem) {
                                        var url = _this.getImgUrl("single", sisItem.contentBackgroud, sizeItem, false);
                                        imgList[url] = 0;
                                    });
                                }
                                Object.keys(sisItem.levelStyle).forEach(function (levelItem) {
                                    var currentLevel = sisItem.levelStyle[levelItem];
                                    if (currentLevel.background) {
                                        if (currentLevel.background.includes("#")) {
                                            var url = _this.getImgUrl("single", currentLevel.background);
                                            imgList[url] = 0;
                                        }
                                        else {
                                            sizeList.forEach(function (sizeItem) {
                                                if (currentLevel.background) {
                                                    var url = _this.getImgUrl("single", currentLevel.background, sizeItem, false, levelItem);
                                                    imgList[url] = 0;
                                                }
                                            });
                                        }
                                    }
                                });
                                // title
                                if (!sisItem.titleBackground || (sisItem.titleBackground && sisItem.titleBackground.includes("#"))) {
                                    var url = this_1.getImgUrl("single", sisItem.titleBackground);
                                    imgList[url] = 0;
                                }
                                else {
                                    sizeList.forEach(function (sizeItem) {
                                        var url = _this.getImgUrl("single", sisItem.titleBackground, sizeItem, false);
                                        imgList[url] = 0;
                                    });
                                }
                                // close
                                if (sisItem.closeIconUrl) {
                                    imgList[sisItem.closeIconUrl] = 0;
                                }
                            };
                            this_1 = this;
                            // 加载img等级的图片
                            for (i = 0; i < markSisOption.length; i++) {
                                _loop_1(i);
                            }
                            loadImage = Object.keys(imgList).filter(function (item) {
                                return !Object.keys(backgroundList).includes(item);
                            });
                            if (!(loadImage.length !== 0)) return [3 /*break*/, 2];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.GisMarker.loadImage(loadImage))];
                        case 1:
                            imgIdList_1 = _c.sent();
                            loadImage.forEach(function (imgitem, index) {
                                // 存入缓存
                                var imgCache = new baseWrap({
                                    id: imgIdList_1[index],
                                    background: imgitem
                                }, cacheType.Image);
                                _this.cacheManagement.createCache(imgIdList_1[index], imgCache);
                            });
                            _c.label = 2;
                        case 2:
                            createIds = [];
                            optionMapList = this.fetchSisMarkerOption(markSisOption);
                            optionList = [];
                            for (optionItem = 0; optionItem < optionMapList.length; optionItem++) {
                                element = optionMapList[optionItem];
                                optionList = __spreadArray$2(__spreadArray$2([], optionList, true), Object.values(element), true);
                            }
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.GisMarker.create(optionList))
                                // 将标签关联至node上
                            ];
                        case 3:
                            optionsPtr = _c.sent();
                            startPtr = 0;
                            for (i = 0; i < markSisOption.length; i++) {
                                element = markSisOption[i];
                                id = markSisOption[i].id || generateUUID();
                                createIds.push(id);
                                ptr = optionsPtr.slice(startPtr, Object.values(optionMapList[i]).length);
                                startPtr += Object.values(optionMapList[i]).length;
                                markerInstance = new baseWrap({
                                    id: id,
                                    pointer: 0,
                                    type: 'sis',
                                    markOption: element,
                                    realOption: {},
                                    extraData: {
                                        optionList: optionMapList[i],
                                        optionsPtr: ptr
                                    },
                                    instance: this
                                }, cacheType.Marker);
                                this.cacheManagement.createCache(id, markerInstance, {
                                    instance: markSisOption[i].parentNode
                                });
                            }
                            return [2 /*return*/, {
                                    status: true,
                                    data: createIds
                                }];
                    }
                });
            });
        };
        /**
         * 更新sis标签
         * @param markSisUpdateOption
         * @returns
         */
        Marker.prototype.updateBySis = function (markSisUpdateOption) {
            var _a, _b, _c;
            return __awaiter$1(this, void 0, void 0, function () {
                var checkRes, imgList, backgroundList, _loop_2, this_2, i, loadImage, imgIdList_2, markerSisOption, optionMapList, newMarker, updateMarker, newGisPtr, startPtr;
                var _d;
                var _this = this;
                return __generator$1(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            if (!Array.isArray(markSisUpdateOption)) {
                                markSisUpdateOption = [markSisUpdateOption];
                            }
                            checkRes = this.checkMarkerId(markSisUpdateOption.map(function (el) {
                                return el.id;
                            }), 'sis');
                            if (!checkRes.status) {
                                return [2 /*return*/, checkRes];
                            }
                            imgList = {};
                            backgroundList = this.getImageCacheList();
                            _loop_2 = function (i) {
                                var sisItem = markSisUpdateOption[i];
                                // title
                                if (!sisItem.titleBackground || (sisItem.titleBackground && sisItem.titleBackground.includes("#"))) {
                                    var url = this_2.getImgUrl("single", sisItem.titleBackground);
                                    imgList[url] = 0;
                                }
                                else {
                                    sizeList.forEach(function (sizeItem) {
                                        var url = _this.getImgUrl("single", sisItem.titleBackground, sizeItem, false);
                                        imgList[url] = 0;
                                    });
                                }
                                // close
                                if (sisItem.closeIconUrl) {
                                    imgList[sisItem.closeIconUrl] = 0;
                                }
                            };
                            this_2 = this;
                            // 判断title和close的图片是否变更
                            for (i = 0; i < markSisUpdateOption.length; i++) {
                                _loop_2(i);
                            }
                            loadImage = Object.keys(imgList).filter(function (item) {
                                return !Object.keys(backgroundList).includes(item);
                            });
                            if (!(loadImage.length !== 0)) return [3 /*break*/, 2];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.GisMarker.loadImage(loadImage))];
                        case 1:
                            imgIdList_2 = _e.sent();
                            loadImage.forEach(function (imgitem, index) {
                                // 存入缓存
                                var imgCache = new baseWrap({
                                    id: imgIdList_2[index],
                                    background: imgitem
                                }, cacheType.Image);
                                _this.cacheManagement.createCache(imgIdList_2[index], imgCache);
                            });
                            _e.label = 2;
                        case 2:
                            markerSisOption = this.fetchSisUpdateOption(markSisUpdateOption);
                            optionMapList = this.fetchSisMarkerOption(markerSisOption);
                            newMarker = {};
                            updateMarker = [];
                            markSisUpdateOption.forEach(function (sisItem, index) {
                                var _a;
                                // 获取缓存数据
                                var sisCacheData = ((_a = _this.cacheManagement.findCacheById(sisItem.id)) === null || _a === void 0 ? void 0 : _a.instance).getDataInfo();
                                if (sisCacheData) {
                                    var currentOptionList = Object.values((sisCacheData.extraData.optionList));
                                    var titleOption = null;
                                    var closeOption = null;
                                    for (var sisIndex = 0; sisIndex < Object.values(optionMapList[index]).length; sisIndex++) {
                                        var curSisOption = Object.values(optionMapList[index])[sisIndex];
                                        var markerId = sisCacheData.extraData.optionsPtr[sisIndex];
                                        // sisData
                                        var preOption = __assign$2({}, currentOptionList[sisIndex]);
                                        if (markerId) {
                                            // 更新
                                            updateMarker.push(_this.computedSampleOption(preOption, curSisOption, markerId));
                                        }
                                        else {
                                            // 新增
                                            if (newMarker[sisItem.id]) {
                                                newMarker[sisItem.id].push(curSisOption);
                                            }
                                            else {
                                                newMarker[sisItem.id] = [curSisOption];
                                            }
                                        }
                                    }
                                    if (titleOption) {
                                        updateMarker.push(titleOption);
                                    }
                                    if (closeOption) {
                                        updateMarker.push(closeOption);
                                    }
                                    // 需要隐藏的marker
                                    sisCacheData.extraData.optionsPtr.forEach(function (item) {
                                        if (!updateMarker.find(function (mitem) {
                                            return mitem.markerId === item;
                                        })) {
                                            updateMarker.push({
                                                markerId: item,
                                                props: {
                                                    visible: false
                                                }
                                            });
                                        }
                                    });
                                }
                            });
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.GisMarker.setProperty(updateMarker))];
                        case 3:
                            _e.sent();
                            return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : (_d = _c.GisMarker).create.apply(_d, Object.values(newMarker)))
                                // 更新缓存
                            ];
                        case 4:
                            newGisPtr = _e.sent();
                            startPtr = 0;
                            markerSisOption.forEach(function (sisItem, index) {
                                var _a;
                                var _b, _c;
                                if (sisItem.id) {
                                    var markerInstance = _this.cacheManagement.findCacheById(sisItem.id);
                                    if (markerInstance && markerInstance.type === cacheType.Marker) {
                                        var dataInfo = (_b = markerInstance.instance) === null || _b === void 0 ? void 0 : _b.getDataInfo();
                                        if (dataInfo) {
                                            dataInfo.markOption = sisItem;
                                            dataInfo.extraData.optionList = optionMapList[index];
                                            if (newMarker[sisItem.id]) {
                                                var ptr = newGisPtr.slice(startPtr, Object.values(newMarker[sisItem.id]).length);
                                                startPtr += Object.values(newMarker[sisItem.id]).length;
                                                (_a = dataInfo.extraData.optionsPtr).push.apply(_a, ptr);
                                            }
                                            (_c = markerInstance.instance) === null || _c === void 0 ? void 0 : _c.setDataInfo(dataInfo);
                                        }
                                    }
                                }
                            });
                            return [2 /*return*/, {
                                    status: true,
                                    message: "更新成功",
                                }];
                    }
                });
            });
        };
        // 销毁标签
        Marker.prototype.destroyMarker = function (markerId, isDeletCache) {
            var _a;
            if (isDeletCache === void 0) { isDeletCache = true; }
            return __awaiter$1(this, void 0, void 0, function () {
                var markerNodeList, markerInfoList, removeMarker, nodeList;
                var _this = this;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!Array.isArray(markerId)) {
                                markerId = [markerId];
                            }
                            markerNodeList = this.cacheManagement.findCacheByType(cacheType.Marker);
                            markerInfoList = markerNodeList.map(function (el) {
                                return _this.findMarkerCacheInfo(el.instance);
                            });
                            removeMarker = markerInfoList.filter(function (el, index) {
                                if (!el)
                                    return false;
                                return markerId.includes(el.id);
                            });
                            nodeList = [];
                            removeMarker.forEach(function (el) {
                                if (el) {
                                    if ((el === null || el === void 0 ? void 0 : el.type) === 'sis') {
                                        nodeList.push.apply(nodeList, el.extraData.optionsPtr);
                                    }
                                    nodeList.push(el === null || el === void 0 ? void 0 : el.pointer);
                                }
                            });
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.GisMarker.destroy(nodeList))
                                // 清除缓存
                            ];
                        case 1:
                            _b.sent();
                            // 清除缓存
                            markerInfoList.forEach(function (el, index) {
                                var _a;
                                if (!el)
                                    return false;
                                var status = markerId.includes(el.id);
                                // 清除缓存
                                if (status && markerNodeList[index].instance) {
                                    if (isDeletCache) {
                                        if ((_a = markerNodeList[index].instance) === null || _a === void 0 ? void 0 : _a.isDeleteInstance) {
                                            markerNodeList[index].instance.isDeleteInstance = false;
                                        }
                                        _this.cacheManagement.deleteCache(markerNodeList[index].instance);
                                    }
                                }
                                return status;
                            });
                            return [2 /*return*/, {
                                    status: true,
                                    message: "卸载成功",
                                    data: markerId
                                }];
                    }
                });
            });
        };
        /**
         * 卸载所有标签
         * @returns
         */
        Marker.prototype.destroyAllMarker = function () {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var markerNodeList, markerInfoList, nodeList;
                var _this = this;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            markerNodeList = this.cacheManagement.findCacheByType(cacheType.Marker);
                            markerInfoList = markerNodeList.map(function (el) {
                                return _this.findMarkerCacheInfo(el.instance);
                            });
                            nodeList = [];
                            markerInfoList.forEach(function (el) {
                                if (el) {
                                    if ((el === null || el === void 0 ? void 0 : el.type) === 'sis') {
                                        nodeList.push.apply(nodeList, el.extraData.optionsPtr);
                                    }
                                    nodeList.push(el === null || el === void 0 ? void 0 : el.pointer);
                                }
                            });
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.GisMarker.destroy(nodeList))];
                        case 1:
                            _b.sent();
                            markerNodeList.forEach(function (el) {
                                var _a;
                                if ((_a = el.instance) === null || _a === void 0 ? void 0 : _a.isDeleteInstance) {
                                    el.instance.isDeleteInstance = false;
                                }
                                _this.cacheManagement.deleteCache(el.instance);
                            });
                            return [2 /*return*/, {
                                    status: true,
                                    message: "卸载成功",
                                }];
                    }
                });
            });
        };
        /**
         * @description: 整理图片路径
         * @param {Array} optionList
         * @return {*}
         */
        Marker.prototype.fetchImgList = function (type, optionList) {
            return optionList.map(function (element) {
                if (!element.background) {
                    return "rgba:0,0,0,255";
                }
                if (element.background.includes('#')) {
                    var rgba = hex2rgba(element.background);
                    return "rgba:".concat(rgba.r, ",").concat(rgba.g, ",").concat(rgba.b, ",").concat(rgba.a);
                }
                else if (element.background.includes('data://')) {
                    var rgba = hex2rgba(element.background);
                    return element.background;
                }
                else {
                    return "data://../apps/markers/".concat(element.background, "/").concat(type).concat((type === 'round' ? '' : "_".concat(element.textSize)) + (element.hasTriangle ? '_triangle' : ''), ".png");
                }
            });
        };
        // 整理单行标签的样式
        Marker.prototype.fetchTextStyle = function (optionList) {
            return optionList.map(function (element) {
                var textLen = computedByteLen((element === null || element === void 0 ? void 0 : element.text) || '');
                var textWidth = computedTextWidth((element === null || element === void 0 ? void 0 : element.text) || '');
                element.textSize = 'min';
                element.textWidth = textWidth;
                if (WIDTH_SIZE_MAP['mid'] <= textLen && textLen < WIDTH_SIZE_MAP['max']) {
                    element.textSize = 'mid';
                }
                else if (WIDTH_SIZE_MAP['max'] <= textLen) {
                    element.textSize = 'max';
                }
                return __assign$2({}, element);
            });
        };
        // 整理多行标签的样式
        Marker.prototype.fetchTextStyleByMulti = function (optionList) {
            return optionList.map(function (element) {
                var dataLen = element.dataList.length;
                element.textSize = 'min';
                if (HEIGHT_SIZE_MAP['mid'] <= dataLen && dataLen < HEIGHT_SIZE_MAP['max']) {
                    element.textSize = 'mid';
                }
                else if (HEIGHT_SIZE_MAP['max'] <= dataLen) {
                    element.textSize = 'max';
                }
                return __assign$2({}, element);
            });
        };
        /**
         * @description: 整理单行标签的选项
         * @param {Array} markSingleLineOption
         * @param {Array} imgIdList
         * @return {*}
         */
        Marker.prototype.fetchSingleMarkerOption = function (markSingleLineOption, imgIdList) {
            var _this = this;
            return markSingleLineOption.map(function (element, index) {
                var _a, _b, _c, _d, _e;
                // 判断是否带三角，若是背景颜色则不允许设置三角
                var imgSize = [0, 0];
                var padding = 0;
                var contentPadding = [0, 0, 0, 0];
                if (element.background && !element.background.includes('#') && element.hasTriangle) {
                    imgSize = [(element.textWidth || 0) + 20 > 80 ? (element.textWidth || 0) + 20 : 80, 42];
                    padding = (element.textWidth || 0) + 20 > 80 ? 10 : (80 - (element.textWidth || 0)) / 2;
                    contentPadding = [padding, 10, padding, 20];
                }
                else {
                    imgSize = [(element.textWidth || 0) + 20 > 80 ? (element.textWidth || 0) + 20 : 80, 32];
                    padding = (element.textWidth || 0) + 20 > 80 ? 10 : (80 - (element.textWidth || 0)) / 2;
                    contentPadding = [padding, 10, padding, 10];
                }
                // 根据定位点位置 修改marker的nodeOffset
                var nodeOffset = _this.fetchNodeOffset((_a = element.markPosType) !== null && _a !== void 0 ? _a : EMarkPosType$1.leftTop, (_b = element.nodeOffset) !== null && _b !== void 0 ? _b : [0, 0], imgSize);
                var nodeInfo = (_c = _this.nodeInstance) === null || _c === void 0 ? void 0 : _c.getNodeInfo(element === null || element === void 0 ? void 0 : element.parentNode);
                var option = {
                    localTrans: (element === null || element === void 0 ? void 0 : element.pos) || [0, 0, 0],
                    visible: (_d = element === null || element === void 0 ? void 0 : element.visible) !== null && _d !== void 0 ? _d : true,
                    size: -1,
                    nodeOffset: nodeOffset,
                    imgId: imgIdList[index],
                    imgSize: imgSize,
                    text: (element === null || element === void 0 ? void 0 : element.text) || '',
                    fontSize: 14.0,
                    breakWidth: -1,
                    contentPadding: contentPadding,
                    textColor: Number(((_e = element === null || element === void 0 ? void 0 : element.textColor) === null || _e === void 0 ? void 0 : _e.replace('#', '0x')) || 0xffffffff),
                    title: '',
                    titleFontSize: 18.0,
                    titleColor: 0xffffffff,
                    userData: null, // 用户数据，仅帮外部系统保存数据
                };
                if (element.LodRange && element.LodRange.length > 2) {
                    option.minLod = element.LodRange[0];
                    option.maxLod = element.LodRange[1];
                }
                if (nodeInfo && nodeInfo.node)
                    option.parentNode = nodeInfo.node;
                if (option.parentNode)
                    delete option.localTrans;
                return option;
            });
        };
        /**
         * @description: 多行标签label定位
         * @param {Array} dataList
         * @return {*}
         */
        Marker.prototype.fetchMutiTextAndWidth = function (dataList) {
            var text = '';
            var textWidth = 0;
            if (dataList && dataList.every(function (i) { return typeof i === 'string'; })) {
                var dataLenList = dataList.map(function (item) {
                    text = text + '\n' + item;
                    return computedTextWidth(item);
                });
                textWidth = Math.max.apply(Math, dataLenList);
            }
            else {
                var dataKeyLenList_1 = [];
                var dataValueLenList_1 = [];
                // key value格式，分别算出key和value的最大宽度
                dataList.forEach(function (item) {
                    dataKeyLenList_1.push(computedTextWidth(item.label));
                    dataValueLenList_1.push(computedTextWidth(item.value));
                });
                var keyMaxWidth = Math.max.apply(Math, dataKeyLenList_1);
                var valueMaxWidth = Math.max.apply(Math, dataValueLenList_1);
                var colonWidth = computedTextWidth(':');
                textWidth = keyMaxWidth + valueMaxWidth + colonWidth;
                dataList.forEach(function (item, index) {
                    // 求出需要展示的文本
                    if (index === 0) {
                        text = item.label + ": " + item.value;
                    }
                    else {
                        text += '\n' + item.label + ": " + item.value;
                    }
                });
            }
            return { text: text, textWidth: textWidth };
        };
        /**
         * @description: 整理多行标签的配置项
         * @param {Array} markMultiLineOption
         * @param {Array} imgIdList
         * @return {*}
         */
        Marker.prototype.fetchMultiMarkerOption = function (markMultiLineOption, imgIdList) {
            var _this = this;
            // 计算最长的数据
            return markMultiLineOption.map(function (element, index) {
                var _a, _b, _c, _d, _e;
                var _f = _this.fetchMutiTextAndWidth(element.dataList), text = _f.text, textWidth = _f.textWidth;
                var imgSize = [0, 0];
                var padding = 0;
                var contentPadding = [0, 0, 0, 0];
                if (element.background && !element.background.includes('#') && element.hasTriangle) {
                    imgSize = [textWidth + 20, 18 * element.dataList.length + 10];
                    contentPadding = [10, 10, 10, 0];
                }
                else {
                    imgSize = [(textWidth || 0) + 20 > 80 ? (textWidth || 0) + 20 : 80, 18 * element.dataList.length + 10];
                    padding = (textWidth || 0) + 20 > 80 ? 10 : (80 - (textWidth || 0)) / 2;
                    contentPadding = [padding, 10, padding, 0];
                }
                var nodeInfo = (_a = _this.nodeInstance) === null || _a === void 0 ? void 0 : _a.getNodeInfo(element === null || element === void 0 ? void 0 : element.parentNode);
                var nodeOffset = _this.fetchNodeOffset((_b = element.markPosType) !== null && _b !== void 0 ? _b : EMarkPosType$1.leftTop, (_c = element.nodeOffset) !== null && _c !== void 0 ? _c : [0, 0], imgSize);
                var option = {
                    parentNode: nodeInfo ? nodeInfo.node : null,
                    localTrans: (element === null || element === void 0 ? void 0 : element.pos) || [0, 0, 0],
                    visible: (_d = element === null || element === void 0 ? void 0 : element.visible) !== null && _d !== void 0 ? _d : true,
                    size: -1,
                    nodeOffset: nodeOffset,
                    imgId: imgIdList[index],
                    imgSize: imgSize,
                    text: text || '',
                    fontSize: 14.0,
                    breakWidth: -1,
                    contentPadding: contentPadding,
                    textColor: Number(((_e = element === null || element === void 0 ? void 0 : element.textColor) === null || _e === void 0 ? void 0 : _e.replace('#', '0x')) || 0xffffffff),
                    title: '',
                    titleFontSize: 18.0,
                    titleColor: 0xffffffff,
                    userData: null, // 用户数据，仅帮外部系统保存数据
                };
                if (element.LodRange && element.LodRange.length > 2) {
                    option.minLod = element.LodRange[0];
                    option.maxLod = element.LodRange[1];
                }
                if (option.parentNode)
                    delete option.localTrans;
                return option;
            });
        };
        /**
         * @description: 整理原型标签的配置项
         * @param {Array} markRoundOption
         * @param {Array} imgIdList
         * @return {*}
         */
        Marker.prototype.fetchRoundMarkerOption = function (markRoundOption, imgIdList) {
            var _this = this;
            return markRoundOption.map(function (element, index) {
                var _a, _b, _c, _d, _e;
                var textWidth = computedTextWidth((element === null || element === void 0 ? void 0 : element.text) || '');
                var contentPadding = [0, 0, 0, 0];
                if (60 - textWidth > 0) {
                    contentPadding = [(60 - textWidth) / 2, element.hasTriangle ? 20 : 22, (60 - textWidth) / 2, element.hasTriangle ? 20 : 22];
                }
                else {
                    contentPadding = [0, element.hasTriangle ? 20 : 22, 0, element.hasTriangle ? 20 : 22];
                }
                var imgSize = [60, element.hasTriangle ? 64 : 60];
                var nodeInfo = (_a = _this.nodeInstance) === null || _a === void 0 ? void 0 : _a.getNodeInfo(element === null || element === void 0 ? void 0 : element.parentNode);
                var nodeOffset = _this.fetchNodeOffset((_b = element.markPosType) !== null && _b !== void 0 ? _b : EMarkPosType$1.leftTop, (_c = element.nodeOffset) !== null && _c !== void 0 ? _c : [0, 0], imgSize);
                var option = {
                    parentNode: nodeInfo ? nodeInfo.node : null,
                    localTrans: (element === null || element === void 0 ? void 0 : element.pos) || [0, 0, 0],
                    visible: (_d = element === null || element === void 0 ? void 0 : element.visible) !== null && _d !== void 0 ? _d : true,
                    size: -1,
                    nodeOffset: nodeOffset,
                    imgId: imgIdList[index],
                    imgSize: imgSize,
                    text: (element === null || element === void 0 ? void 0 : element.text) || '',
                    fontSize: 14.0,
                    breakWidth: -1,
                    contentPadding: contentPadding,
                    textColor: Number(((_e = element === null || element === void 0 ? void 0 : element.textColor) === null || _e === void 0 ? void 0 : _e.replace('#', '0x')) || 0xffffffff),
                    title: '',
                    titleFontSize: 18.0,
                    titleColor: 0xffffffff,
                    userData: null, // 用户数据，仅帮外部系统保存数据
                };
                if (element.LodRange && element.LodRange.length > 2) {
                    option.minLod = element.LodRange[0];
                    option.maxLod = element.LodRange[1];
                }
                if (option.parentNode)
                    delete option.localTrans;
                return option;
            });
        };
        /**
         * @description: 整理通过图片加载标签的配置项
         * @param {Array} markPictureOption
         * @param {Array} imgIdList
         * @return {*}
         */
        Marker.prototype.fetchPictureMarkerOption = function (markPictureOption, imgIdList) {
            var _this = this;
            return markPictureOption.map(function (element, index) {
                var _a, _b, _c, _d, _e, _f, _g;
                var nodeInfo = (_a = _this.nodeInstance) === null || _a === void 0 ? void 0 : _a.getNodeInfo(element === null || element === void 0 ? void 0 : element.parentNode);
                var imgSize = (_b = element === null || element === void 0 ? void 0 : element.imgSize) !== null && _b !== void 0 ? _b : [-1, -1];
                var nodeOffset = element.nodeOffset;
                if (element.imgSize) {
                    nodeOffset = _this.fetchNodeOffset((_c = element.markPosType) !== null && _c !== void 0 ? _c : EMarkPosType$1.leftTop, (_d = element.nodeOffset) !== null && _d !== void 0 ? _d : [0, 0], imgSize);
                }
                var option = {
                    parentNode: nodeInfo ? nodeInfo.node : null,
                    localTrans: (element === null || element === void 0 ? void 0 : element.pos) || [0, 0, 0],
                    visible: (_e = element === null || element === void 0 ? void 0 : element.visible) !== null && _e !== void 0 ? _e : true,
                    size: -1,
                    nodeOffset: nodeOffset,
                    imgId: imgIdList[index],
                    imgSize: imgSize || [100, element.height],
                    text: element.text || '',
                    fontSize: element.textFontSize || 14.0,
                    breakWidth: -1,
                    contentPadding: [10, 10, 10, 10],
                    textColor: Number(((_f = element.textColor) === null || _f === void 0 ? void 0 : _f.replace('#', '0x')) || 0xffffffff),
                    title: element.title || '',
                    titleFontSize: element.titleFontSize,
                    titleColor: Number(((_g = element.titleColor) === null || _g === void 0 ? void 0 : _g.replace('#', '0x')) || 0xffffffff),
                    userData: null, // 用户数据，仅帮外部系统保存数据
                };
                if (element.LodRange && element.LodRange.length > 2) {
                    option.minLod = element.LodRange[0];
                    option.maxLod = element.LodRange[1];
                }
                if (option.parentNode)
                    delete option.localTrans;
                return option;
            });
        };
        /**
        * 创建图片标签(带文字)
        * @param IMarkPictureTextOption
        * @returns
        */
        Marker.prototype.createByPictureWithText = function (markPictureOption) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var hasMarker, imgList, createIds, imgIdList, optionList, optionsPtr, i, element, id, markerInstance;
                var _this = this;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            // 检测id是否已经存在
                            if (!Array.isArray(markPictureOption)) {
                                markPictureOption = [markPictureOption];
                            }
                            hasMarker = markPictureOption.find(function (item) {
                                return item.id && _this.cacheManagement.findCacheById(item.id);
                            });
                            if (hasMarker) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "".concat(hasMarker.id, "\u5DF2\u5B58\u5728")
                                    }];
                            }
                            imgList = markPictureOption.map(function (element) {
                                return element.backgroundUrl;
                            });
                            createIds = [];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.GisMarker.loadImage(imgList))
                                // 批量加载标签
                            ];
                        case 1:
                            imgIdList = _c.sent();
                            optionList = this.fetchPictureMarkerOption(markPictureOption, imgIdList);
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.GisMarker.create(optionList))
                                // 将标签关联至node上
                            ];
                        case 2:
                            optionsPtr = _c.sent();
                            // 将标签关联至node上
                            for (i = 0; i < optionsPtr.length; i++) {
                                element = optionsPtr[i];
                                id = markPictureOption[i].id || generateUUID();
                                createIds.push(id);
                                markerInstance = new baseWrap({
                                    id: id,
                                    pointer: element,
                                    type: 'picture',
                                    markOption: markPictureOption[i],
                                    realOption: optionList[i],
                                    instance: this
                                }, cacheType.Marker);
                                this.cacheManagement.createCache(id, markerInstance, {
                                    instance: markPictureOption[i].parentNode
                                });
                            }
                            return [2 /*return*/, {
                                    status: true,
                                    message: "加载成功",
                                    data: createIds
                                }];
                    }
                });
            });
        };
        /**
         * @description: 整理通过dom加载标签的配置项
         * @param {Array} markDomOption
         * @param {Array} imgIdList
         * @return {*}
         */
        Marker.prototype.fetchDomOption = function (markDomOption, imgIdList) {
            var _this = this;
            return markDomOption.map(function (element, index) {
                var _a, _b, _c, _d;
                var imgSize = element.imgSize || [-1, -1];
                var nodeOffset = element.nodeOffset;
                if (element.imgSize) {
                    nodeOffset = _this.fetchNodeOffset((_a = element.markPosType) !== null && _a !== void 0 ? _a : EMarkPosType$1.leftTop, (_b = element.nodeOffset) !== null && _b !== void 0 ? _b : [0, 0], imgSize);
                }
                var nodeInfo = (_c = _this.nodeInstance) === null || _c === void 0 ? void 0 : _c.getNodeInfo(element === null || element === void 0 ? void 0 : element.parentNode);
                var option = {
                    parentNode: nodeInfo ? nodeInfo.node : null,
                    localTrans: (element === null || element === void 0 ? void 0 : element.pos) || [0, 0, 0],
                    visible: (_d = element === null || element === void 0 ? void 0 : element.visible) !== null && _d !== void 0 ? _d : true,
                    size: -1,
                    nodeOffset: nodeOffset,
                    imgId: imgIdList[index],
                    imgSize: element.imgSize || [-1, -1],
                    userData: null, // 用户数据，仅帮外部系统保存数据
                };
                if (element.LodRange && element.LodRange.length > 2) {
                    option.minLod = element.LodRange[0];
                    option.maxLod = element.LodRange[1];
                }
                if (option.parentNode)
                    delete option.localTrans;
                return option;
            });
        };
        /**
         * 整理sis标签选项
         * @param markSisOption
         * @returns
         */
        Marker.prototype.fetchSisMarkerOption = function (markSisOption) {
            var _this = this;
            // 获取图片的缓存
            var backgroundList = this.getImageCacheList();
            return markSisOption.map(function (element, index) {
                var _a, _b, _c, _d, _e, _f;
                var nodeInfo = (_b = (_a = _this.nodeInstance) === null || _a === void 0 ? void 0 : _a.getNodeInfo(element === null || element === void 0 ? void 0 : element.parentNode)) !== null && _b !== void 0 ? _b : undefined;
                var optionList = {};
                // 将数据分块[超过10，就分栏] 计算每一栏的最大宽度
                var colonWidth = _this.computedSisWidth(element.sisData);
                // 计算出title的宽度
                var titleWidth = Object.values(colonWidth).reduce(function (preValue, currentValue) {
                    return preValue + currentValue;
                }, 0);
                // 算出整个sis的长宽
                var sisWidth = titleWidth;
                var sisHeight = Object.values(colonWidth).length > 1 ? 10 * 32 + 32 : element.sisData.length * 32 + 32;
                // 整理title的option start
                var titleSize = _this.computedSize(titleWidth);
                var imgId = backgroundList[_this.getImgUrl("single", element.titleBackground, titleSize, false, '')];
                var currentNodeOffset = _this.fetchNodeOffset((_c = element.markPosType) !== null && _c !== void 0 ? _c : EMarkPosType$1.leftTop, (_d = element.nodeOffset) !== null && _d !== void 0 ? _d : [0, 0], [sisWidth, sisHeight]);
                var titleOption = _this.setOption({
                    parentNode: nodeInfo ? nodeInfo.node : null,
                    localTrans: element.pos,
                    visible: element.visible,
                    nodeOffset: currentNodeOffset,
                    imgId: imgId,
                    imgSize: [titleWidth, 32],
                    text: element.title,
                    fontSize: 16.0,
                    textColor: Number((_e = element.titleColor) === null || _e === void 0 ? void 0 : _e.replace('#', '0x')) || 0xffffffff,
                });
                // 整理title的option end
                // 整理close icon的option  start
                var closePreNodeOffset = [element.nodeOffset ? titleWidth + element.nodeOffset[0] - 30 : titleWidth - 30, element.nodeOffset ? element.nodeOffset[1] - 5 : 5];
                var closeImgId = element.closeIconUrl ? backgroundList[element.closeIconUrl] : 0;
                var closeNodeOffset = _this.fetchNodeOffset((_f = element.markPosType) !== null && _f !== void 0 ? _f : EMarkPosType$1.leftTop, closePreNodeOffset, [sisWidth, sisHeight]);
                var closeOption = _this.setOption({
                    parentNode: nodeInfo ? nodeInfo.node : null,
                    localTrans: element.pos,
                    visible: element.visible,
                    nodeOffset: closeNodeOffset,
                    imgId: closeImgId,
                    imgSize: [20, 20],
                });
                // 整理close icon的option  end
                // 组合每一列的option
                var sisOptionList = _this.computedSisOption(element, colonWidth, backgroundList, [sisWidth, sisHeight], nodeInfo);
                optionList = __assign$2(__assign$2({}, optionList), sisOptionList);
                // 创建空白的sis的option
                // TODO: 云渲染点击之后激活的是最下方的标签，因为放置一个标签在最下方
                optionList["close1"] = closeOption;
                optionList["title"] = titleOption;
                optionList["close"] = closeOption;
                return optionList;
            });
        };
        /**
         * 获取marker的缓存
         * @param item
         * @returns
         */
        Marker.prototype.findMarkerCacheInfo = function (item) {
            var _a;
            // 判断node是否有效
            var markerRes = this.cacheManagement.findCacheByObject(item);
            if (markerRes && markerRes.type === cacheType.Marker) {
                return (_a = markerRes.instance) === null || _a === void 0 ? void 0 : _a.getDataInfo();
            }
            return null;
        };
        /**
         * 计算node的偏移量
         * @param markPosType 定位类型
         * @param nodeOffset 当前的偏移量
         * @param imgSize 整个标签的大小
         * @returns
         */
        Marker.prototype.fetchNodeOffset = function (markPosType, nodeOffset, imgSize) {
            var nodeOffsetCopy = JSON.parse(JSON.stringify(nodeOffset));
            var imgSizeCopy = JSON.parse(JSON.stringify(imgSize));
            switch (markPosType) {
                case EMarkPosType$1.leftTop:
                    return nodeOffsetCopy;
                case EMarkPosType$1.midTop:
                    nodeOffsetCopy[0] -= imgSizeCopy[0] / 2;
                    return nodeOffsetCopy;
                case EMarkPosType$1.rightTop:
                    nodeOffsetCopy[0] -= imgSizeCopy[0];
                    return nodeOffsetCopy;
                case EMarkPosType$1.leftBottom:
                    nodeOffsetCopy[1] -= imgSizeCopy[1];
                    return nodeOffsetCopy;
                case EMarkPosType$1.midBottom:
                    nodeOffsetCopy[0] -= imgSizeCopy[0] / 2;
                    nodeOffsetCopy[1] -= imgSizeCopy[1];
                    return nodeOffsetCopy;
                case EMarkPosType$1.rightBottom:
                    nodeOffsetCopy[0] -= imgSizeCopy[0];
                    nodeOffsetCopy[1] -= imgSizeCopy[1];
                    return nodeOffsetCopy;
                default:
                    return nodeOffsetCopy;
            }
        };
        /**
         * 获取图片的地址
         * @param type 图片类型
         * @param background 背景颜色或类别
         * @param size 图片的大小
         * @param hasTriangle 是否需要小三角
         * @param level 等级
         * @returns
         */
        Marker.prototype.getImgUrl = function (type, background, size, hasTriangle, level) {
            if (!background) {
                return "rgba:0,0,0,255";
            }
            if (background.includes('#')) {
                var rgba = hex2rgba(background);
                return "rgba:".concat(rgba.r, ",").concat(rgba.g, ",").concat(rgba.b, ",").concat(rgba.a);
            }
            else {
                return "data://apps/markers/".concat(background, "/").concat(type).concat((size ? "_".concat(size) : '') + (hasTriangle ? '_triangle' : '') + (level ? "_".concat(level) : ''), ".png");
            }
        };
        /**
         * 获取imgId
         * @param markerSisData sis数据
         * @param level 等级
         * @param width 文本长度
         * @param imgIdList 当前的图片id列表
         * @returns
         */
        Marker.prototype.computedImgId = function (markerSisData, level, width, imgIdList) {
            // 判断level是否在levelList中
            var currentLevel = markerSisData.levelStyle[level];
            var size = 'min';
            if (width >= WIDTH_LEN_SIZE_MAP["max"]) {
                size = "max";
            }
            else if (width >= WIDTH_LEN_SIZE_MAP["mid"]) {
                size = "mid";
            }
            if (Object.keys(markerSisData.levelStyle).includes(level) && currentLevel.background) {
                // 根据width判断加载的图片
                if (currentLevel.background.includes("#")) {
                    return imgIdList[this.getImgUrl("single", currentLevel.background)];
                }
                else {
                    return imgIdList[this.getImgUrl("single", currentLevel.background, size, false, level)];
                }
            }
            else {
                // 根据width判断加载的图片
                if (!markerSisData.contentBackgroud || markerSisData.contentBackgroud.includes("#")) {
                    return imgIdList[this.getImgUrl("single", markerSisData.contentBackgroud)];
                }
                else {
                    return imgIdList[this.getImgUrl("single", markerSisData.contentBackgroud, size, false, '')];
                }
            }
        };
        /**
         * 计算sis每一列的宽度
         * @param sisData
         * @returns
         */
        Marker.prototype.computedSisWidth = function (sisData) {
            var currentCol = 1;
            var maxWidth = 0;
            var colonWidth = {};
            sisData.forEach(function (sisItem, sisIndex) {
                var content = sisItem.label + ": " + sisItem.value;
                // 加上左右的padding 10
                var contentWidth = computedTextWidth(content) + 30;
                maxWidth = contentWidth > maxWidth ? contentWidth : maxWidth;
                if (sisIndex >= (currentCol * 10 - 1)) {
                    // 记录之前列的最大长度
                    colonWidth[currentCol] = maxWidth;
                    currentCol++;
                    maxWidth = 0;
                }
            });
            if (maxWidth !== 0) {
                colonWidth[currentCol] = maxWidth;
            }
            return colonWidth;
        };
        /**
         * 计算sisData的option
         * @param markerSisData sis数据
         * @param colonWidth 每一列的宽度
         * @param imgIdList 当前的图片id列表
         * @param sisSize 整个sis的宽高
         * @param nodeInfo 绑定的node
         * @returns
         */
        Marker.prototype.computedSisOption = function (markerSisData, colonWidth, imgIdList, sisSize, nodeInfo) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            var sisOptionList = {};
            for (var i = 0; i < Object.keys(colonWidth).length; i++) {
                var colIndex = Object.keys(colonWidth)[i];
                var maxSisIndex = 0;
                var sisStartIndex = (Number(colIndex) - 1) * 10;
                if (Object.keys(colonWidth).length === 1) {
                    // 不补空
                    maxSisIndex = markerSisData.sisData.length;
                }
                else {
                    // 补空
                    maxSisIndex = sisStartIndex + 10;
                }
                for (var sisIndex = sisStartIndex; sisIndex < maxSisIndex; sisIndex++) {
                    var sisItem = markerSisData.sisData[sisIndex];
                    var content = sisItem ? sisItem.label + ": " + sisItem.value : '';
                    var imgId = this.computedImgId(markerSisData, (_a = sisItem === null || sisItem === void 0 ? void 0 : sisItem.level) !== null && _a !== void 0 ? _a : 'defalut', colonWidth[Number(colIndex)], imgIdList);
                    var currentOffsetWidth = markerSisData.nodeOffset ? markerSisData.nodeOffset[0] : 0;
                    for (var coli = 0; coli < Number(colIndex); coli++) {
                        currentOffsetWidth += (_b = colonWidth[coli]) !== null && _b !== void 0 ? _b : 0;
                    }
                    var currentRow = sisIndex % 10;
                    var preNodeOffset = [currentOffsetWidth, currentRow * 32 + 32];
                    var currentNodeOffset = this.fetchNodeOffset((_c = markerSisData.markPosType) !== null && _c !== void 0 ? _c : EMarkPosType$1.leftTop, preNodeOffset, sisSize);
                    var option = this.setOption({
                        parentNode: nodeInfo ? nodeInfo.node : null,
                        localTrans: markerSisData === null || markerSisData === void 0 ? void 0 : markerSisData.pos,
                        visible: (_d = markerSisData === null || markerSisData === void 0 ? void 0 : markerSisData.visible) !== null && _d !== void 0 ? _d : true,
                        nodeOffset: currentNodeOffset,
                        imgId: imgId,
                        imgSize: [colonWidth[Number(colIndex)], 32],
                        text: content || '',
                        textColor: Number((_g = (_f = markerSisData.levelStyle[(_e = sisItem === null || sisItem === void 0 ? void 0 : sisItem.level) !== null && _e !== void 0 ? _e : "defalut"]) === null || _f === void 0 ? void 0 : _f.color) === null || _g === void 0 ? void 0 : _g.replace('#', '0x')) || 0xffffffff,
                    });
                    sisOptionList[(_h = sisItem === null || sisItem === void 0 ? void 0 : sisItem.label) !== null && _h !== void 0 ? _h : 'emptySis' + generateUUID()] = option;
                }
            }
            return sisOptionList;
        };
        Marker.prototype.setOption = function (option) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            return {
                parentNode: (_a = option.parentNode) !== null && _a !== void 0 ? _a : null,
                localTrans: (_b = option.localTrans) !== null && _b !== void 0 ? _b : [0, 0, 0],
                visible: (_c = option.visible) !== null && _c !== void 0 ? _c : true,
                size: -1,
                nodeOffset: (_d = option.nodeOffset) !== null && _d !== void 0 ? _d : [0, 0, 0],
                imgId: (_e = option.imgId) !== null && _e !== void 0 ? _e : 0,
                imgSize: (_f = option.imgSize) !== null && _f !== void 0 ? _f : [-1, -1],
                text: (_g = option.text) !== null && _g !== void 0 ? _g : '',
                fontSize: (_h = option.fontSize) !== null && _h !== void 0 ? _h : 14.0,
                breakWidth: -1,
                contentPadding: (_j = option.contentPadding) !== null && _j !== void 0 ? _j : [10, 10, 10, 10],
                textColor: (_k = option.textColor) !== null && _k !== void 0 ? _k : 0xffffffff,
                title: '',
                titleFontSize: 18.0,
                titleColor: 0xffffffff,
                userData: null, // 用户数据，仅帮外部系统保存数据
            };
        };
        /**
         * 计算大小
         * @param content
         * @returns
         */
        Marker.prototype.computedSize = function (content) {
            var size = 'min';
            if (content >= WIDTH_LEN_SIZE_MAP["max"]) {
                size = "max";
            }
            else if (content >= WIDTH_LEN_SIZE_MAP["mid"]) {
                size = "mid";
            }
            return size;
        };
        /**
         * 检查缓存中是否存在当前类型的标记
         * @param idList
         * @param type
         * @returns
         */
        Marker.prototype.checkMarkerId = function (idList, type) {
            var _this = this;
            // 获取标签类型的缓存
            var markerNodeList = this.cacheManagement.findCacheByType(cacheType.Marker);
            // 过滤掉类型
            var markerList = markerNodeList.filter(function (el) {
                var markInfo = _this.findMarkerCacheInfo(el.instance);
                return (markInfo === null || markInfo === void 0 ? void 0 : markInfo.type) === type;
            });
            var arrayHasId = idList.every(function (el) {
                return !!el && markerList.find(function (item) {
                    return (item === null || item === void 0 ? void 0 : item.id) === el;
                });
            });
            if (!arrayHasId) {
                return {
                    status: false,
                    message: "\u66F4\u65B0\u6807\u8BB0\u65F6,\u6BCF\u9879\u9700\u8981\u4F20\u9012id, \u4E14\u5F53\u524Did\u5DF2\u521B\u5EFA".concat(type, "\u7C7B\u578B\u7684\u6807\u7B7E")
                };
            }
            return {
                status: true
            };
        };
        /**
         * 获取图片的缓存
         * @returns
         */
        Marker.prototype.getImageCacheList = function () {
            // 获取图片的缓存
            var imageList = this.cacheManagement.findCacheByType(cacheType.Image);
            // 获取background与id的对应
            var backgroundList = {};
            imageList.forEach(function (imageItem) {
                var _a;
                var item = (_a = imageItem.instance) === null || _a === void 0 ? void 0 : _a.getDataInfo();
                if (item) {
                    backgroundList[item.background] = item.id;
                }
            });
            return backgroundList;
        };
        /**
         * 整理更新的sis数据
         * @param markerSisData
         * @returns
         */
        Marker.prototype.fetchSisUpdateOption = function (markerSisData) {
            var _this = this;
            return markerSisData.map(function (sisItem) {
                var _a;
                // 获取缓存数据
                var sisCacheData = ((_a = _this.cacheManagement.findCacheById(sisItem.id)) === null || _a === void 0 ? void 0 : _a.instance).getDataInfo();
                // 推断sisData数据长度是否发生变化
                if (sisCacheData) {
                    var option = __assign$2(__assign$2({}, sisCacheData.markOption), sisItem);
                    return option;
                }
            });
        };
        /**
         * 过滤掉option重复的属性
         * @param preOption
         * @param curOption
         * @param markerId
         * @returns
         */
        Marker.prototype.computedSampleOption = function (preOption, curOption, markerId) {
            var _a;
            Object.entries(curOption).forEach(function (item) {
                if (isValidKey(item[0], preOption)) {
                    if (item[1] === preOption[item[0]]) {
                        delete curOption[item[0]];
                    }
                }
            });
            return {
                markerId: markerId,
                props: __assign$2(__assign$2({}, curOption), { visible: (_a = curOption.visible) !== null && _a !== void 0 ? _a : true })
            };
        };
        Marker.instance = null;
        return Marker;
    }(commonAbstractClass));

    var ECreateElectoronicRailSatuts;
    (function (ECreateElectoronicRailSatuts) {
        ECreateElectoronicRailSatuts[ECreateElectoronicRailSatuts["append"] = 0] = "append";
        ECreateElectoronicRailSatuts[ECreateElectoronicRailSatuts["editFinish"] = 1] = "editFinish";
    })(ECreateElectoronicRailSatuts || (ECreateElectoronicRailSatuts = {}));
    var ElectoronicRail = /** @class */ (function (_super) {
        __extends$1(ElectoronicRail, _super);
        function ElectoronicRail(cacheManagement, dispatch) {
            var _this = this;
            var _a, _b, _c, _d;
            _this = _super.call(this) || this;
            /** 当前加载的围栏列表 */
            _this.fenceList = [];
            _this.isEditing = '';
            _this.defaultMaterial = {};
            _this.cacheManagement = cacheManagement;
            _this.dispatch = dispatch;
            var player = getPlayerData(cacheManagement);
            if (!player) {
                throw new Error("player未加载");
            }
            _this.player = player;
            ElectoronicRail.instance = _this;
            _this.markerRes = new Marker(_this.cacheManagement, _this.dispatch);
            ((_b = (_a = _this.player.Native) === null || _a === void 0 ? void 0 : _a.EFence) === null || _b === void 0 ? void 0 : _b.getDefaultCapMaterial) && ((_d = (_c = _this.player.Native) === null || _c === void 0 ? void 0 : _c.EFence) === null || _d === void 0 ? void 0 : _d.getDefaultCapMaterial().then(function (res) { return __awaiter$1(_this, void 0, void 0, function () {
                var m;
                var _a, _b;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Material.create(0))
                            // const m2 = await this.player.Native?.Material.clone(res)
                        ];
                        case 1:
                            m = _c.sent();
                            // const m2 = await this.player.Native?.Material.clone(res)
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Material.setProperty(m, { "diffuse": 0x005aff88, "ambient": 0x005aff88, "roughness": 1, "metallic": 0.5, alpha: 0.5 }))];
                        case 2:
                            // const m2 = await this.player.Native?.Material.clone(res)
                            _c.sent();
                            this.defaultMaterial = {
                                cap: res,
                                wall: m
                            };
                            return [2 /*return*/];
                    }
                });
            }); }));
            return _this;
        }
        ElectoronicRail.prototype.destroyInstance = function () {
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.destroyAll()];
                        case 1:
                            _a.sent();
                            ElectoronicRail.instance = null;
                            return [2 /*return*/];
                    }
                });
            });
        };
        /** 激活编辑模式 */
        ElectoronicRail.prototype.changeActiveStatus = function (id, active) {
            var _a, _b, _c;
            return __awaiter$1(this, void 0, void 0, function () {
                var status, fence;
                return __generator$1(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            status = false;
                            fence = (_a = this.fenceList.find(function (item) { return item.id === id; })) === null || _a === void 0 ? void 0 : _a.fenceObject;
                            if (!active) return [3 /*break*/, 2];
                            if (!fence) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: '未找到该对象'
                                    }];
                            }
                            if (this.isEditing)
                                return [2 /*return*/, { status: false, message: '已在编辑', }];
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.EFence.startEditPillar(fence))];
                        case 1:
                            status = _d.sent();
                            this.isEditing = id;
                            return [3 /*break*/, 4];
                        case 2:
                            if (!this.isEditing)
                                return [2 /*return*/, { status: false, message: '还未编辑', }];
                            return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.EFence.endEditPillar())];
                        case 3:
                            status = _d.sent();
                            this.isEditing = '';
                            _d.label = 4;
                        case 4: return [2 /*return*/, {
                                status: status,
                                message: '设置成功',
                            }];
                    }
                });
            });
        };
        //init
        ElectoronicRail.prototype.init = function (baseOptions, styleOptions, markerOptions, isByMouse) {
            var _a, _b, _c, _d, _e;
            if (isByMouse === void 0) { isByMouse = true; }
            return __awaiter$1(this, void 0, void 0, function () {
                var isExists, fenceInfo, param, mat, callback_1, res, center, marker;
                var _this = this;
                return __generator$1(this, function (_f) {
                    switch (_f.label) {
                        case 0:
                            isExists = this.fenceList.find(function (fenceItem) {
                                return fenceItem.id === baseOptions.id;
                            });
                            if (isExists) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "".concat(isExists.id, "\u91CD\u590D"),
                                    }];
                            }
                            fenceInfo = {
                                id: baseOptions.id
                            };
                            this.fenceList.push(fenceInfo);
                            return [4 /*yield*/, this.getFenceStyle(styleOptions, isByMouse)];
                        case 1:
                            param = _f.sent();
                            param.height = baseOptions.height;
                            if (!baseOptions.llh) return [3 /*break*/, 3];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.GisPlatform.makeGisTransform(baseOptions.llh))];
                        case 2:
                            mat = _f.sent();
                            param.offsetMatrix = mat;
                            _f.label = 3;
                        case 3:
                            if (!isByMouse) return [3 /*break*/, 4];
                            (_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.EFence.startCreateByMouse(param);
                            callback_1 = function (fence, res) { return __awaiter$1(_this, void 0, void 0, function () {
                                var center, marker;
                                var _a, _b;
                                return __generator$1(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            fenceInfo.fenceObject = fence;
                                            fenceInfo.pos = res;
                                            if (styleOptions.type === EStyleType.riskArea) {
                                                this.update(baseOptions.id, {}, styleOptions);
                                            }
                                            if (!(markerOptions === null || markerOptions === void 0 ? void 0 : markerOptions.showMarker)) return [3 /*break*/, 2];
                                            center = this.getCenter(res, param.height);
                                            return [4 /*yield*/, this.createFenceMarker(markerOptions.options, center)];
                                        case 1:
                                            marker = _c.sent();
                                            fenceInfo.markerId = marker.markerId;
                                            (_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.setProperty(marker.node, { parent: fence });
                                            _c.label = 2;
                                        case 2:
                                            (_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.EFence.EventCreateByMouseFinish.disconnect(callback_1);
                                            this.dispatch.emit("ElectoronicRail", {
                                                type: 'createByMouse',
                                                currentState: ECreateElectoronicRailSatuts.append,
                                                pos: res,
                                            });
                                            if (baseOptions.editMode) {
                                                // 设置编辑方式，监听编辑结果
                                                this.changeActiveStatus(baseOptions.id, baseOptions.editMode);
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); };
                            (_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.EFence.EventCreateByMouseFinish.connect(callback_1);
                            return [3 /*break*/, 8];
                        case 4:
                            if (!baseOptions.pos)
                                return [2 /*return*/, { status: false, message: '请传入pos参数' }];
                            param.points = baseOptions.pos;
                            return [4 /*yield*/, ((_d = this.player.Native) === null || _d === void 0 ? void 0 : _d.EFence.create(param))];
                        case 5:
                            res = _f.sent();
                            fenceInfo.fenceObject = res;
                            fenceInfo.pos = baseOptions.pos;
                            if (!(markerOptions === null || markerOptions === void 0 ? void 0 : markerOptions.showMarker)) return [3 /*break*/, 7];
                            center = this.getCenter(baseOptions.pos, baseOptions.height);
                            return [4 /*yield*/, this.createFenceMarker(markerOptions.options, center)];
                        case 6:
                            marker = _f.sent();
                            fenceInfo.markerId = marker.markerId;
                            (_e = this.player.Native) === null || _e === void 0 ? void 0 : _e.Node.setProperty(marker.node, { parent: res });
                            _f.label = 7;
                        case 7:
                            this.dispatch.emit("ElectoronicRail", {
                                type: 'create',
                                currentState: ECreateElectoronicRailSatuts.append,
                                pos: baseOptions.pos,
                            });
                            _f.label = 8;
                        case 8: return [2 /*return*/, {
                                status: true,
                                message: '成功',
                                data: fenceInfo,
                            }];
                    }
                });
            });
        };
        // 激活鼠标创建方式
        ElectoronicRail.prototype.activeCreateByMouse = function (baseOptions, styleOptions, markerOptions) {
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_a) {
                    return [2 /*return*/, this.init(baseOptions, styleOptions, markerOptions)];
                });
            });
        };
        //获取坐标点中心
        ElectoronicRail.prototype.getCenter = function (data, height) {
            if (height === void 0) { height = 0; }
            var sumX = 0, sumY = 0, sumZ = 0;
            data.forEach(function (point) {
                sumX += point[0];
                sumY += point[1];
                sumZ += point[2];
            });
            return [sumX / data.length, sumY / data.length, height + sumZ / data.length];
        };
        // 创建电子围栏
        ElectoronicRail.prototype.createByPosition = function (baseOptions, styleOptions, markerOptions) {
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_a) {
                    return [2 /*return*/, this.init(baseOptions, styleOptions, markerOptions, false)];
                });
            });
        };
        // 设置围栏样式
        ElectoronicRail.prototype.getFenceStyle = function (styleOptions, isByMouse) {
            var _a, _b, _c;
            if (isByMouse === void 0) { isByMouse = false; }
            return __awaiter$1(this, void 0, void 0, function () {
                var param, _d, alpha, m, m2;
                return __generator$1(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            param = {};
                            _d = styleOptions.type;
                            switch (_d) {
                                case EStyleType.fence: return [3 /*break*/, 1];
                                case EStyleType.riskArea: return [3 /*break*/, 2];
                            }
                            return [3 /*break*/, 8];
                        case 1: return [3 /*break*/, 9];
                        case 2:
                            if (!isByMouse) return [3 /*break*/, 3];
                            param.insideMaterial = this.defaultMaterial.wall;
                            param.outsideMaterial = this.defaultMaterial.wall;
                            return [3 /*break*/, 7];
                        case 3:
                            alpha = (styleOptions.style & 0xFF) / 255;
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Material.create(0))];
                        case 4:
                            m = _e.sent();
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Material.clone(this.defaultMaterial.cap))];
                        case 5:
                            m2 = _e.sent();
                            return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.Material.setProperty([m, m2], { "diffuse": styleOptions.style, "ambient": styleOptions.style, "roughness": 1, "metallic": 0.5, alpha: alpha }))];
                        case 6:
                            _e.sent();
                            param.insideMaterial = m;
                            param.outsideMaterial = m;
                            param.capMaterial = m2;
                            _e.label = 7;
                        case 7:
                            param.pillarVisible = false;
                            param.capVisible = true;
                            return [3 /*break*/, 9];
                        case 8: return [3 /*break*/, 9];
                        case 9: return [2 /*return*/, param];
                    }
                });
            });
        };
        // 更新电子围栏
        ElectoronicRail.prototype.update = function (id, updateOptions, styleOptions) {
            var _a, _b, _c, _d;
            return __awaiter$1(this, void 0, void 0, function () {
                var currentFence, markerPos, param;
                return __generator$1(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            currentFence = this.fenceList.find(function (item) {
                                return item.id === id;
                            });
                            if (!currentFence || !currentFence.fenceObject) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: '未找到围栏'
                                    }];
                            }
                            // 设置高度
                            if (updateOptions.height) {
                                (_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.EFence.setProperty(currentFence.fenceObject, { height: updateOptions.height });
                            }
                            if (!updateOptions.updatePos) return [3 /*break*/, 3];
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.EFence.resetPillar(currentFence.fenceObject, updateOptions.updatePos))
                                // 更新标签
                            ];
                        case 1:
                            _e.sent();
                            markerPos = this.getCenter(updateOptions.updatePos, updateOptions.height);
                            if (!currentFence.markerId) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.markerRes.updateBySingleLine({
                                    id: currentFence.markerId,
                                    pos: markerPos
                                })];
                        case 2:
                            _e.sent();
                            _e.label = 3;
                        case 3:
                            if (!styleOptions) return [3 /*break*/, 6];
                            return [4 /*yield*/, this.getFenceStyle(styleOptions)];
                        case 4:
                            param = _e.sent();
                            return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.EFence.setProperty(currentFence.fenceObject, param))];
                        case 5:
                            _e.sent();
                            _e.label = 6;
                        case 6:
                            // 设置显隐
                            if (typeof updateOptions.visible === 'boolean') {
                                (_d = this.player.Native) === null || _d === void 0 ? void 0 : _d.Node.setProperty(currentFence.fenceObject, { visible: updateOptions.visible });
                            }
                            return [2 /*return*/, {
                                    status: true,
                                    message: '编辑成功',
                                    data: currentFence,
                                }];
                    }
                });
            });
        };
        // 销毁电子围栏
        ElectoronicRail.prototype.destroy = function (ids) {
            var _a, _b, _c;
            return __awaiter$1(this, void 0, void 0, function () {
                var destroyMarkerList, fenceList, i, item;
                return __generator$1(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            destroyMarkerList = [];
                            fenceList = [];
                            i = 0;
                            _d.label = 1;
                        case 1:
                            if (!(i < this.fenceList.length)) return [3 /*break*/, 5];
                            item = this.fenceList[i];
                            if (!ids.includes(item.id))
                                return [3 /*break*/, 4];
                            if (!(this.isEditing === item.id)) return [3 /*break*/, 3];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.EFence.endEditPillar())];
                        case 2:
                            _d.sent();
                            this.isEditing = '';
                            _d.label = 3;
                        case 3:
                            if (item.fenceObject) {
                                fenceList.push(item.fenceObject);
                            }
                            if (item.markerId) {
                                destroyMarkerList.push(item.markerId);
                            }
                            this.fenceList.splice(i, 1);
                            i--;
                            _d.label = 4;
                        case 4:
                            i++;
                            return [3 /*break*/, 1];
                        case 5:
                            (_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.EFence.destroy(fenceList);
                            return [4 /*yield*/, ((_c = this.markerRes) === null || _c === void 0 ? void 0 : _c.destroyMarker(destroyMarkerList))];
                        case 6:
                            _d.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    message: '销毁成功'
                                }];
                    }
                });
            });
        };
        // 清除所有围栏
        ElectoronicRail.prototype.destroyAll = function () {
            var _a, _b, _c;
            return __awaiter$1(this, void 0, void 0, function () {
                var destroyMarkerList, fenceList, i, item;
                return __generator$1(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            destroyMarkerList = [];
                            fenceList = [];
                            if (!this.isEditing) return [3 /*break*/, 2];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.EFence.endEditPillar())];
                        case 1:
                            _d.sent();
                            this.isEditing = '';
                            _d.label = 2;
                        case 2:
                            for (i = 0; i < this.fenceList.length; i += 1) {
                                item = this.fenceList[i];
                                if (item.fenceObject) {
                                    fenceList.push(item.fenceObject);
                                }
                                if (item.markerId) {
                                    destroyMarkerList.push(item.markerId);
                                }
                            }
                            (_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.EFence.destroy(fenceList);
                            return [4 /*yield*/, ((_c = this.markerRes) === null || _c === void 0 ? void 0 : _c.destroyMarker(destroyMarkerList))];
                        case 3:
                            _d.sent();
                            this.fenceList = [];
                            return [2 /*return*/, {
                                    status: true,
                                    message: '销毁成功'
                                }];
                    }
                });
            });
        };
        // 创建围栏标签
        ElectoronicRail.prototype.createFenceMarker = function (markerOptions, center) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var res, markerList;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            markerOptions.pos = center;
                            return [4 /*yield*/, this.markerRes.createBySingleLine(markerOptions)];
                        case 1:
                            markerList = _c.sent();
                            res = { markerId: (_a = markerList === null || markerList === void 0 ? void 0 : markerList.data) === null || _a === void 0 ? void 0 : _a[0], node: (_b = markerList === null || markerList === void 0 ? void 0 : markerList.extra) === null || _b === void 0 ? void 0 : _b[0] };
                            return [2 /*return*/, res];
                    }
                });
            });
        };
        ElectoronicRail.instance = null;
        return ElectoronicRail;
    }(commonAbstractClass));

    var Camera = /** @class */ (function () {
        function Camera(cacheManagement, dispatch, bindEvent) {
            this.player = {};
            this.dealEventAnchorPosChanged = function () { };
            this.cacheManagement = cacheManagement;
            var player = getPlayerData(cacheManagement);
            if (!player) {
                throw new Error("player未加载");
            }
            var nodeProxyInstance = new NodeProxy(cacheManagement, dispatch);
            if (!nodeProxyInstance) {
                throw new Error("node未加载");
            }
            this.player = player;
            this.nodeProxyInstance = nodeProxyInstance;
            Camera.instance = this;
            this.dispatch = dispatch;
        }
        // 定位到原点
        Camera.prototype.moveCameraByHOME = function (moveSpeed) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Camera.goHome(moveSpeed !== null && moveSpeed !== void 0 ? moveSpeed : 2))];
                        case 1:
                            _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    data: null,
                                    message: ''
                                }];
                    }
                });
            });
        };
        // 根据相机参数定位
        Camera.prototype.moveCameraByCAMERAPARAM = function (param, moveSpeed) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var error_1;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Camera.moveTo(param.eye, param.target, param.up, moveSpeed !== null && moveSpeed !== void 0 ? moveSpeed : 2))];
                        case 1:
                            _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    data: null,
                                    message: ''
                                }];
                        case 2:
                            error_1 = _b.sent();
                            return [2 /*return*/, {
                                    status: false,
                                    data: null,
                                    message: error_1
                                }];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        // 根据经纬高定位
        Camera.prototype.moveCameraByLLH = function (param, moveSpeed) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // 判断params是否为数组
                            if (!Array.isArray(param)) {
                                return [2 /*return*/, {
                                        status: false,
                                        data: null,
                                        message: '参数需要传递数组类型'
                                    }];
                            }
                            if (!(param.filter(function (el) { return typeof el === "number"; }).length === 3)) return [3 /*break*/, 2];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Camera.moveToLLH(param, moveSpeed !== null && moveSpeed !== void 0 ? moveSpeed : 2))];
                        case 1:
                            _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    data: null,
                                    message: ''
                                }];
                        case 2: return [2 /*return*/, {
                                status: false,
                                data: null,
                                message: '参数需要数值类型的数组'
                            }];
                    }
                });
            });
        };
        // 根据Node定位
        Camera.prototype.moveCameraByNode = function (nodeInfo, moveSpeed) {
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.moveCameraByAabb(nodeInfo.aabb, moveSpeed !== null && moveSpeed !== void 0 ? moveSpeed : 2)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        // 根据code定位
        Camera.prototype.moveCameraByCODE = function (param, moveSpeed) {
            var _a, _b, _c;
            return __awaiter$1(this, void 0, void 0, function () {
                var res;
                return __generator$1(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, this.nodeProxyInstance.findNode(NodeFindType.codes, param)];
                        case 1:
                            res = _d.sent();
                            if (!res.status)
                                return [2 /*return*/, res];
                            return [4 /*yield*/, this.moveCameraByAabb((_c = (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.getDataInfo()) === null || _c === void 0 ? void 0 : _c.aabb, moveSpeed !== null && moveSpeed !== void 0 ? moveSpeed : 2)];
                        case 2: return [2 /*return*/, _d.sent()];
                    }
                });
            });
        };
        Camera.prototype.moveCameraByAabb = function (param, moveSpeed) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var error_2;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Camera.moveToAabbWithDistance(param, moveSpeed !== null && moveSpeed !== void 0 ? moveSpeed : 2, 0, 1.1))];
                        case 1:
                            _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    data: null,
                                    message: ''
                                }];
                        case 2:
                            error_2 = _b.sent();
                            return [2 /*return*/, {
                                    status: false,
                                    data: null,
                                    message: error_2
                                }];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * @description: 移动相机
         * @param {MoveType} moveType 相机移动的类型
         * @param {Number} moveSpeed 相机移动速度
         * @param {String} param 相机移动时的参数
         * @return {*}
         */
        Camera.prototype.moveCamera = function (moveType, param, moveSpeed, modelData) {
            var _a, _b, _c;
            return __awaiter$1(this, void 0, void 0, function () {
                var _d, nodeRes, nodeInfo;
                return __generator$1(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            _d = moveType;
                            switch (_d) {
                                case 'Node': return [3 /*break*/, 1];
                                case 'CameraParam': return [3 /*break*/, 6];
                                case 'Code': return [3 /*break*/, 8];
                                case 'Home': return [3 /*break*/, 10];
                                case 'LLH': return [3 /*break*/, 12];
                                case "Aabb": return [3 /*break*/, 14];
                            }
                            return [3 /*break*/, 17];
                        case 1:
                            if (!param) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.cacheManagement.findCacheByObject(param)];
                        case 2:
                            nodeRes = _e.sent();
                            if (!(nodeRes && (nodeRes.type === cacheType.Node || nodeRes.type === cacheType.LoadNode))) return [3 /*break*/, 4];
                            nodeInfo = null;
                            if (nodeRes.type === cacheType.LoadNode) {
                                nodeInfo = (_b = (_a = nodeRes.instance) === null || _a === void 0 ? void 0 : _a.getDataInfo()) === null || _b === void 0 ? void 0 : _b.nodeInstance.getDataInfo();
                            }
                            else {
                                nodeInfo = (_c = nodeRes.instance) === null || _c === void 0 ? void 0 : _c.getDataInfo();
                            }
                            if (!nodeInfo) return [3 /*break*/, 4];
                            return [4 /*yield*/, this.moveCameraByNode(nodeInfo, moveSpeed)];
                        case 3: return [2 /*return*/, _e.sent()];
                        case 4: return [2 /*return*/, {
                                status: false,
                                message: 'params参数错误'
                            }];
                        case 5: return [2 /*return*/, {
                                status: false,
                                message: 'params参数未传'
                            }];
                        case 6:
                            if (typeof param !== 'object' || ['eye', 'target', 'up'].find(function (el) {
                                return !Object.keys(param).includes(el);
                            })) {
                                return [2 /*return*/, {
                                        status: false,
                                        data: null,
                                        message: "param参数错误"
                                    }];
                            }
                            return [4 /*yield*/, this.moveCameraByCAMERAPARAM(param, moveSpeed)];
                        case 7: return [2 /*return*/, _e.sent()];
                        case 8:
                            if (typeof param !== 'string') {
                                return [2 /*return*/, {
                                        status: false,
                                        data: null,
                                        message: "param参数错误"
                                    }];
                            }
                            return [4 /*yield*/, this.moveCameraByCODE(param, moveSpeed)];
                        case 9: return [2 /*return*/, _e.sent()];
                        case 10: return [4 /*yield*/, this.moveCameraByHOME(moveSpeed)];
                        case 11: return [2 /*return*/, _e.sent()];
                        case 12: return [4 /*yield*/, this.moveCameraByLLH(param, moveSpeed)];
                        case 13: return [2 /*return*/, _e.sent()];
                        case 14:
                            if (!(Array.isArray(param) && param.length === 2)) return [3 /*break*/, 16];
                            return [4 /*yield*/, this.moveCameraByAabb(param, moveSpeed)];
                        case 15: return [2 /*return*/, _e.sent()];
                        case 16: return [2 /*return*/, {
                                status: false,
                                data: null,
                                message: "param参数错误"
                            }];
                        case 17: return [2 /*return*/, {
                                status: false,
                                data: null,
                                message: '相机移动类型错误'
                            }];
                    }
                });
            });
        };
        /**
         * @description: 移动相机
         * @param {Number} node 节点
         * @param {Number} moveSpeed 相机移动速度
         * @param {number} distance_radio 相机结束位置参数 控制相机离节点的距离
         * @return {*}
         */
        Camera.prototype.moveCameraWithRot = function (node, distance_radio, moveSpeed) {
            var _a;
            if (distance_radio === void 0) { distance_radio = 1; }
            return __awaiter$1(this, void 0, void 0, function () {
                var res, distance, d, vec3, eye, cameraParams;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.getProperty(node, ['globalTrans', 'globalScale', 'aabb', 'wholeMatrix']))];
                        case 1:
                            res = _b.sent();
                            if (!res) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: 'node异常'
                                    }];
                            }
                            distance = function (a, b) {
                                var dx = b[0] - a[0];
                                var dy = b[1] - a[1];
                                var dz = b[2] - a[2];
                                return Math.sqrt(dx * dx + dy * dy + dz * dz);
                            };
                            d = distance(res.aabb[0], res.aabb[1]);
                            vec3 = [d / res.globalScale[0] * distance_radio, 0, 0];
                            eye = Matrix4.multiplyPos(res.wholeMatrix, vec3);
                            cameraParams = {
                                eye: eye,
                                target: res.globalTrans,
                                up: [-0, -0, 1],
                            };
                            return [4 /*yield*/, this.moveCamera("CameraParam", cameraParams, moveSpeed)];
                        case 2: return [2 /*return*/, _b.sent()];
                    }
                });
            });
        };
        /**
         * @description: 获取当前相机的参数
         * @return {*}
         */
        Camera.prototype.getCurrentCamera = function () {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var currentParam;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Camera.currentParam())];
                        case 1:
                            currentParam = _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    data: currentParam,
                                    message: ''
                                }];
                    }
                });
            });
        };
        /**
         * 获取锚点位置
         * @returns
         */
        Camera.prototype.getAnchorPos = function () {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var anchorPos;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Camera.getAnchorPos())];
                        case 1:
                            anchorPos = _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    data: anchorPos,
                                    message: ''
                                }];
                    }
                });
            });
        };
        /**
         * 设置锚点位置
         * @param anchorPos 锚点位置
         * @returns
         */
        Camera.prototype.setAnchorPos = function (anchorPos) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(anchorPos.length === 3)) return [3 /*break*/, 2];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Camera.setAnchorPos(anchorPos))];
                        case 1:
                            _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    message: ''
                                }];
                        case 2: return [2 /*return*/, {
                                status: false,
                                message: '锚点信息'
                            }];
                    }
                });
            });
        };
        /** 截图 */
        Camera.prototype.screenShot = function (param) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var base64;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Camera.screenShot(param))];
                        case 1:
                            base64 = _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    data: base64
                                }];
                    }
                });
            });
        };
        Camera.prototype.worldsToScreens = function (param) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var pos;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Camera.worldsToScreens(param))];
                        case 1:
                            pos = _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    data: pos
                                }];
                    }
                });
            });
        };
        Camera.instance = null;
        return Camera;
    }());

    var ILoadFileStatus;
    (function (ILoadFileStatus) {
        ILoadFileStatus[ILoadFileStatus["Error"] = 0] = "Error";
        ILoadFileStatus[ILoadFileStatus["DownLoading"] = 1] = "DownLoading";
        ILoadFileStatus[ILoadFileStatus["DownLoadSuccess"] = 2] = "DownLoadSuccess";
    })(ILoadFileStatus || (ILoadFileStatus = {}));

    var downloadList = [];
    var File = /** @class */ (function () {
        function File(player, dispatch, loadFileParams, bindEvent) {
            if (bindEvent === void 0) { bindEvent = false; }
            this.downloadProgressChangeFun = function () { };
            this.downloadFinishFun = function () { };
            this.player = player;
            this.dispatch = dispatch;
            if (bindEvent) {
                this.setConnect();
            }
            if (loadFileParams === null || loadFileParams === void 0 ? void 0 : loadFileParams.fileList) {
                if (!Array.isArray(loadFileParams.fileList)) {
                    loadFileParams.fileList = [loadFileParams.fileList];
                }
                this.init(loadFileParams.fileList, loadFileParams.httpOptions, loadFileParams.type, loadFileParams.confirmFileUnExist);
            }
        }
        /**
         * @description: 初始化下载文件的任务
         * @param {Array} fileList 文件列表
         * @param {ILoadFileHttpOptions} httpOptions 接口的方法+请求头
         * @return {*}
         */
        File.prototype.init = function (fileList, httpOptions, type, confirmFileUnExist) {
            var _a;
            if (confirmFileUnExist === void 0) { confirmFileUnExist = false; }
            return __awaiter$1(this, void 0, void 0, function () {
                var i, file, isExistFile, res;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            i = 0;
                            _b.label = 1;
                        case 1:
                            if (!(i < fileList.length)) return [3 /*break*/, 6];
                            file = fileList[i];
                            if (!!confirmFileUnExist) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.checkFile(file.targetUrl)];
                        case 2:
                            isExistFile = _b.sent();
                            if (isExistFile) {
                                this.changeStatus(ILoadFileStatus.DownLoadSuccess, '模型下载完成！', {
                                    tempPath: file.tempPath || "",
                                    targetUrl: file.targetUrl,
                                    md5: file.md5 || '',
                                    type: type || ''
                                });
                                return [3 /*break*/, 5];
                            }
                            _b.label = 3;
                        case 3: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.File.downloadFile(file.tempPath, (httpOptions === null || httpOptions === void 0 ? void 0 : httpOptions.methods) || "GET", file.fileUrl, (httpOptions === null || httpOptions === void 0 ? void 0 : httpOptions.header) || {}))];
                        case 4:
                            res = _b.sent();
                            if (res) {
                                // 存储当前处于下载的队列,tempPath一定存在
                                downloadList.push({
                                    tempPath: file.tempPath || "",
                                    targetUrl: file.targetUrl,
                                    md5: file.md5 || '',
                                    type: type || ''
                                });
                            }
                            else {
                                this.changeStatus(ILoadFileStatus.Error, '创建下载模型任务失败！', {
                                    tempPath: file.tempPath || "",
                                    targetUrl: file.targetUrl,
                                    md5: file.md5 || '',
                                    type: type || ''
                                });
                            }
                            _b.label = 5;
                        case 5:
                            i++;
                            return [3 /*break*/, 1];
                        case 6: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * @description: 追加文件
         * @param {Array} fileList
         * @param {ILoadFileHttpOptions} httpOptions
         * @return {*}
         */
        File.prototype.addFileList = function (loadFileParams) {
            if (!Array.isArray(loadFileParams.fileList)) {
                loadFileParams.fileList = [loadFileParams.fileList];
            }
            this.init(loadFileParams.fileList, loadFileParams.httpOptions, loadFileParams.type, loadFileParams.confirmFileUnExist);
        };
        File.prototype.checkFile = function (targetUrl) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var isExistFile;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.File.exists(targetUrl))];
                        case 1:
                            isExistFile = _b.sent();
                            return [2 /*return*/, isExistFile];
                    }
                });
            });
        };
        File.prototype.setConnect = function () {
            var _a, _b;
            // 设置下载的监听
            (_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.File.EventDownloadProcessChanged.connect(this.downloadProgressChange());
            (_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.File.EventDownloadFinish.connect(this.downloadFinishMsg());
        };
        /**
         * @description: 下载进度变化
         * @return {*}
         * @internal
         */
        File.prototype.downloadProgressChange = function () {
            var that = this;
            this.downloadProgressChangeFun = function (file, bytesReceived, bytesTotal) {
                var currentFile = downloadList.find(function (el) {
                    return el.tempPath === file;
                });
                var loadPercentage = 0;
                if (bytesTotal) {
                    loadPercentage = (bytesReceived / bytesTotal) * 100;
                }
                // 更新消息
                that.changeStatus(ILoadFileStatus.DownLoading, "下载中...", currentFile, loadPercentage);
            };
            return this.downloadProgressChangeFun;
        };
        /**
        * @description: 下载模型成功回调
        * @return {*}
        * @internal
        */
        File.prototype.downloadFinishMsg = function () {
            var _this = this;
            var that = this;
            this.downloadFinishFun = function (file, err, bytesTotal) { return __awaiter$1(_this, void 0, void 0, function () {
                var currentFileIndex, currentFile, moveStatus;
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                return __generator$1(this, function (_l) {
                    switch (_l.label) {
                        case 0:
                            currentFileIndex = downloadList.findIndex(function (el) {
                                return el.tempPath === file;
                            });
                            if (!(currentFileIndex !== -1)) return [3 /*break*/, 7];
                            currentFile = downloadList.splice(currentFileIndex, 1);
                            // 存在则报错
                            if (err) {
                                // 更新消息
                                that.changeStatus(ILoadFileStatus.Error, err, (_a = currentFile[0]) !== null && _a !== void 0 ? _a : undefined);
                                return [2 /*return*/];
                            }
                            if (!(file === ((_b = currentFile[0]) === null || _b === void 0 ? void 0 : _b.tempPath))) return [3 /*break*/, 6];
                            moveStatus = void 0;
                            if (!(currentFile[0].type == 'nodeDecals')) return [3 /*break*/, 3];
                            return [4 /*yield*/, ((_c = that.player.Native) === null || _c === void 0 ? void 0 : _c.File.move(file, "".concat((_d = currentFile[0]) === null || _d === void 0 ? void 0 : _d.targetUrl, ".zip")))];
                        case 1:
                            moveStatus = _l.sent();
                            return [4 /*yield*/, ((_e = that.player.Native) === null || _e === void 0 ? void 0 : _e.File.unZip("".concat((_f = currentFile[0]) === null || _f === void 0 ? void 0 : _f.targetUrl, ".zip")))];
                        case 2:
                            _l.sent();
                            return [3 /*break*/, 5];
                        case 3: return [4 /*yield*/, ((_g = that.player.Native) === null || _g === void 0 ? void 0 : _g.File.move(file, (_h = currentFile[0]) === null || _h === void 0 ? void 0 : _h.targetUrl))];
                        case 4:
                            moveStatus = _l.sent();
                            _l.label = 5;
                        case 5:
                            // 更新消息
                            that.changeStatus(moveStatus ? ILoadFileStatus.DownLoadSuccess : ILoadFileStatus.Error, moveStatus ? '下载成功' : '模型移动失败', (_j = currentFile[0]) !== null && _j !== void 0 ? _j : undefined);
                            return [3 /*break*/, 7];
                        case 6:
                            that.changeStatus(ILoadFileStatus.Error, '下载的文件与模型的md5不一致', (_k = currentFile[0]) !== null && _k !== void 0 ? _k : undefined);
                            _l.label = 7;
                        case 7: return [2 /*return*/];
                    }
                });
            }); };
            return this.downloadFinishFun;
        };
        /**
         * @description: 状态变化时发送事件
         * @param {ILoadFileStatus} status 下载的状态
         * @param {string} message
         * @param {IDownloadList} currentFile 下载的文件信息
         * @param {number} process 下载的进度
         * @return {*}
         */
        File.prototype.changeStatus = function (status, message, currentFile, process) {
            if (process === void 0) { process = -1; }
            this.dispatch.emit("File", {
                message: message,
                status: status !== ILoadFileStatus.Error,
                data: __assign$2({ currentState: status, process: process }, currentFile)
            });
        };
        /**
        * @description: 获取指定文件的内容
        * @param {string} filePath 文件地址
        * @return {*}
        */
        File.prototype.getFileData = function (filePath) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var jsonString;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.File.loadText(filePath))];
                        case 1:
                            jsonString = _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    message: '成功',
                                    data: jsonString
                                }];
                    }
                });
            });
        };
        return File;
    }());

    var Node$1 = /** @class */ (function (_super) {
        __extends$1(Node, _super);
        function Node(cacheManagement, dispatch, bindEvent) {
            if (bindEvent === void 0) { bindEvent = false; }
            var _this = this;
            var _a, _b, _c;
            _this = _super.call(this) || this;
            // player
            _this.player = {};
            /** 文件对象，用于加载 */
            _this.fileObject = { addFileList: function () { } };
            /** 当前已加载的node列表*/
            _this.nodeList = [];
            /** 是否已经开启了监听 */
            _this.connectFlag = false;
            /** 当前加载状态 */
            _this.LoadStatus = {};
            _this.dealFileData = function () { };
            _this.loadNodeProgressChangeFun = function () { };
            _this.loadFileFinishEventFun = function () { };
            _this.loadNodeFinishFun = function () { };
            /** node操作类实例 */
            _this.nodeProxy = null;
            _this.loadTaskCollection = {};
            _this.cacheManagement = cacheManagement;
            _this.dispatch = dispatch;
            var player = getPlayerData(cacheManagement);
            if (!player) {
                throw new Error("player未加载");
            }
            var nodeProxy = new NodeProxy(cacheManagement, dispatch);
            if (!nodeProxy) {
                throw new Error("node未加载");
            }
            _this.player = player;
            _this.nodeProxy = nodeProxy;
            _this.fileObject = new File(_this.player, _this.dispatch, undefined, true);
            (_a = _this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.EventLoadFileFinish.connect(_this.loadFileFinishEvent());
            if (bindEvent) {
                (_b = _this.player.Native) === null || _b === void 0 ? void 0 : _b.Node.EventLoadFileProgress.connect(_this.loadNodeProgressChange());
                (_c = _this.player.Native) === null || _c === void 0 ? void 0 : _c.Node.EventLoadFileProgressEnd.connect(_this.loadNodeFinish());
            }
            return _this;
        }
        /** 加载node */
        Node.prototype.addNode = function (paramsData) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var collatingDataList, currentIndex, unloadModelList, files, fileExist, downloadFileList, loadFileList;
                var _this = this;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            collatingDataList = this.collatingData(paramsData);
                            currentIndex = collatingDataList.findIndex(function (item) {
                                return _this.cacheManagement.findCacheById(item.nodeId);
                            });
                            if (currentIndex !== -1) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "\u7B2C".concat(currentIndex, "\u6761\u6570\u636E\uFF0CnodeId\u5DF2\u5B58\u5728"),
                                    }];
                            }
                            unloadModelList = collatingDataList.filter(function (node) {
                                return (_this.nodeList.findIndex(function (el) {
                                    return el.nodeId === node.nodeId;
                                }) === -1);
                            });
                            this.nodeList = __spreadArray$2(__spreadArray$2([], this.nodeList, true), unloadModelList, true);
                            files = unloadModelList.map(function (item) { return item.targetUrl; });
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.File.batchExists(files))];
                        case 1:
                            fileExist = _b.sent();
                            downloadFileList = [];
                            loadFileList = [];
                            fileExist.forEach(function (element, index) {
                                if (element) {
                                    loadFileList.push(unloadModelList[index]);
                                }
                                else {
                                    downloadFileList.push(unloadModelList[index]);
                                }
                            });
                            if (loadFileList.length !== 0) {
                                this.loadExistNode(loadFileList);
                            }
                            if (downloadFileList.length !== 0) {
                                this.loadUnExistNode(downloadFileList);
                            }
                            return [2 /*return*/, {
                                    status: true,
                                    message: "加载节点任务创建完成",
                                }];
                    }
                });
            });
        };
        /**
         * 获取加载的node信息
         * @param nodeId
         * @returns
         */
        Node.prototype.getInfo = function (nodeId) {
            var loadNodeInfo = this.getNodeCache(nodeId);
            if (loadNodeInfo) {
                return {
                    status: true,
                    data: loadNodeInfo.nodeInstance,
                };
            }
            return {
                status: false,
                message: "".concat(nodeId, "\u65E0\u6548"),
            };
        };
        /**
         * 设置node的位置
         * @param nodeId
         * @param position
         * @returns
         */
        Node.prototype.setNodePosition = function (nodeId, options) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var loadNodeInfo, setRes;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            loadNodeInfo = this.getNodeCache(nodeId);
                            if (!loadNodeInfo) return [3 /*break*/, 2];
                            return [4 /*yield*/, ((_a = this.nodeProxy) === null || _a === void 0 ? void 0 : _a.setNodeInfo(loadNodeInfo.nodeInstance, options))];
                        case 1:
                            setRes = _b.sent();
                            return [2 /*return*/, (setRes !== null && setRes !== void 0 ? setRes : {
                                    status: false,
                                    message: "\u7CFB\u7EDF\u5F02\u5E38",
                                })];
                        case 2: return [2 /*return*/, {
                                status: false,
                                message: "".concat(nodeId, "\u65E0\u6548"),
                            }];
                    }
                });
            });
        };
        /**
         * 设置模型在地球中的位置
         * @param nodeId
         * @param gisSetting 球上的设置
         * @returns
         */
        Node.prototype.setNodeGisPosition = function (nodeId, gisSetting) {
            var _a, _b, _c, _d;
            return __awaiter$1(this, void 0, void 0, function () {
                var loadNodeInfo, isGisMode, nodeInfo, latitude, longitude, llh, _e, _f, mat;
                return __generator$1(this, function (_g) {
                    switch (_g.label) {
                        case 0:
                            loadNodeInfo = this.getNodeCache(nodeId);
                            if (!loadNodeInfo) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "".concat(nodeId, "\u65E0\u6548"),
                                    }];
                            }
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.GisPlatform.isGisMode())];
                        case 1:
                            isGisMode = _g.sent();
                            if (!isGisMode) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "未加载地球",
                                    }];
                            }
                            if (!gisSetting) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "Gis的配置不存在",
                                    }];
                            }
                            nodeInfo = loadNodeInfo.nodeInstance.getDataInfo();
                            if (!(nodeInfo && nodeInfo.node)) return [3 /*break*/, 6];
                            latitude = (gisSetting === null || gisSetting === void 0 ? void 0 : gisSetting.Latitude) || 0;
                            longitude = (gisSetting === null || gisSetting === void 0 ? void 0 : gisSetting.Longitude) || 0;
                            llh = [longitude, latitude, (gisSetting === null || gisSetting === void 0 ? void 0 : gisSetting.Elevation) || 0];
                            if (!(gisSetting === null || gisSetting === void 0 ? void 0 : gisSetting.IsAutoFollowFloor)) return [3 /*break*/, 3];
                            // 查询经纬度的高程信息,返回的是数组,批量查询结果与单个查询一致，但性能更高
                            _e = llh;
                            _f = 2;
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.GisPlatform.queryDEM([
                                    [longitude, latitude],
                                ])[0])];
                        case 2:
                            // 查询经纬度的高程信息,返回的是数组,批量查询结果与单个查询一致，但性能更高
                            _e[_f] =
                                (_g.sent()) || 0;
                            _g.label = 3;
                        case 3:
                            // 设置模型位置
                            llh[2] += (gisSetting === null || gisSetting === void 0 ? void 0 : gisSetting.Model_Offset) || 0;
                            return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.GisPlatform.makeGisTransform(llh))];
                        case 4:
                            mat = _g.sent();
                            return [4 /*yield*/, ((_d = this.player.Native) === null || _d === void 0 ? void 0 : _d.Node.setProperty(nodeInfo.node, { "wholeMatrix": mat }))
                                // 设置模型的旋转
                                // await this.player.Native?.Node.setProperty(
                                //     nodeInfo.node,
                                //     {
                                //         localRot: [
                                //             gisSetting?.X_Axis_Angle || 0,
                                //             gisSetting?.Y_Axis_Angle || 0,
                                //             gisSetting?.Z_Axis_Angle || 0,
                                //         ]
                                //     }
                                // );
                                // 设置地形攀爬偏移量
                                // await this.player.Native?.NodeProxy.setNodeClampOffset(
                                //     nodeInfo.nodePtr,
                                //     gisSetting?.Model_Offset || 0
                                // );
                            ];
                        case 5:
                            _g.sent();
                            // 设置模型的旋转
                            // await this.player.Native?.Node.setProperty(
                            //     nodeInfo.node,
                            //     {
                            //         localRot: [
                            //             gisSetting?.X_Axis_Angle || 0,
                            //             gisSetting?.Y_Axis_Angle || 0,
                            //             gisSetting?.Z_Axis_Angle || 0,
                            //         ]
                            //     }
                            // );
                            // 设置地形攀爬偏移量
                            // await this.player.Native?.NodeProxy.setNodeClampOffset(
                            //     nodeInfo.nodePtr,
                            //     gisSetting?.Model_Offset || 0
                            // );
                            return [2 /*return*/, {
                                    status: true,
                                    message: "",
                                }];
                        case 6: return [2 /*return*/, {
                                status: false,
                                message: "模型未加载完全",
                            }];
                    }
                });
            });
        };
        /**
         * 卸载node
         */
        Node.prototype.destroyNode = function (nodeId) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var _loop_1, this_1, nodeIndex, state_1;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!Array.isArray(nodeId)) {
                                nodeId = [nodeId];
                            }
                            _loop_1 = function (nodeIndex) {
                                var nodeItem, nodeCache, loadNodeInfo;
                                return __generator$1(this, function (_d) {
                                    switch (_d.label) {
                                        case 0:
                                            nodeItem = nodeId[nodeIndex];
                                            nodeCache = this_1.cacheManagement.findCacheById(nodeItem);
                                            if (!(nodeCache &&
                                                nodeCache.instance &&
                                                nodeCache.type === cacheType.LoadNode)) return [3 /*break*/, 4];
                                            loadNodeInfo = this_1.getNodeCache(nodeItem);
                                            if (!loadNodeInfo) return [3 /*break*/, 2];
                                            return [4 /*yield*/, ((_a = this_1.nodeProxy) === null || _a === void 0 ? void 0 : _a.destroyNode(loadNodeInfo.nodeInstance))];
                                        case 1:
                                            _d.sent();
                                            return [3 /*break*/, 3];
                                        case 2:
                                            _d.label = 3;
                                        case 3:
                                            this_1.cacheManagement.deleteCache(nodeCache.instance);
                                            this_1.nodeList = this_1.nodeList.filter(function (el) {
                                                return el.nodeId != nodeItem;
                                            });
                                            delete this_1.LoadStatus[nodeItem];
                                            return [3 /*break*/, 5];
                                        case 4: return [2 /*return*/, { value: {
                                                    status: false,
                                                    message: "".concat(nodeId, "\u65E0\u6548"),
                                                } }];
                                        case 5: return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            nodeIndex = 0;
                            _b.label = 1;
                        case 1:
                            if (!(nodeIndex < nodeId.length)) return [3 /*break*/, 4];
                            return [5 /*yield**/, _loop_1(nodeIndex)];
                        case 2:
                            state_1 = _b.sent();
                            if (typeof state_1 === "object")
                                return [2 /*return*/, state_1.value];
                            _b.label = 3;
                        case 3:
                            nodeIndex++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/, {
                                status: true,
                            }];
                    }
                });
            });
        };
        /**
         * 卸载node
         */
        Node.prototype.destroyAllNode = function () {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var loadNodeCacheList, index, loadNodeItem, loadNodeInfo;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            loadNodeCacheList = this.cacheManagement.findCacheByType(cacheType.LoadNode);
                            index = 0;
                            _c.label = 1;
                        case 1:
                            if (!(index < loadNodeCacheList.length)) return [3 /*break*/, 4];
                            loadNodeItem = loadNodeCacheList[index];
                            loadNodeInfo = (_a = loadNodeItem.instance) === null || _a === void 0 ? void 0 : _a.getDataInfo();
                            if (!(loadNodeInfo && loadNodeItem.instance)) return [3 /*break*/, 3];
                            return [4 /*yield*/, ((_b = this.nodeProxy) === null || _b === void 0 ? void 0 : _b.destroyNode(loadNodeInfo.nodeInstance))];
                        case 2:
                            _c.sent();
                            this.cacheManagement.deleteCache(loadNodeItem.instance);
                            _c.label = 3;
                        case 3:
                            index++;
                            return [3 /*break*/, 1];
                        case 4:
                            this.nodeList = [];
                            this.LoadStatus = {};
                            return [2 /*return*/, {
                                    status: true,
                                }];
                    }
                });
            });
        };
        /** 整理选项的数据 */
        Node.prototype.collatingData = function (paramData) {
            var _a, _b, _c, _d;
            if (Array.isArray(paramData)) {
                return paramData.map(function (node) {
                    var _a, _b, _c, _d;
                    var nodeId = ((_a = node.options) === null || _a === void 0 ? void 0 : _a.nodeId) || generateUUID();
                    return {
                        md5: node.md5 || "",
                        fileUrl: node.fileUrl || "",
                        targetUrl: node.targetUrl,
                        nodeId: nodeId,
                        nodeDecals: (_b = node.options) === null || _b === void 0 ? void 0 : _b.nodeDecals,
                        gisSetting: (_c = node.options) === null || _c === void 0 ? void 0 : _c.gisSetting,
                        httpOptions: (_d = node.options) === null || _d === void 0 ? void 0 : _d.httpOptions,
                        tempPath: (node === null || node === void 0 ? void 0 : node.tempPath) || "data://temps/models/".concat(nodeId, "/").concat(nodeId, ".pr"),
                    };
                });
            }
            else {
                var nodeId = ((_a = paramData.options) === null || _a === void 0 ? void 0 : _a.nodeId) || generateUUID();
                return [
                    {
                        md5: paramData.md5 || "",
                        fileUrl: paramData.fileUrl || "",
                        targetUrl: paramData.targetUrl,
                        nodeId: nodeId,
                        nodeDecals: (_b = paramData.options) === null || _b === void 0 ? void 0 : _b.nodeDecals,
                        gisSetting: (_c = paramData.options) === null || _c === void 0 ? void 0 : _c.gisSetting,
                        httpOptions: (_d = paramData.options) === null || _d === void 0 ? void 0 : _d.httpOptions,
                        tempPath: (paramData === null || paramData === void 0 ? void 0 : paramData.tempPath) ||
                            "data://temps/models/".concat(nodeId, "/").concat(nodeId, ".pr"),
                    },
                ];
            }
        };
        Node.prototype.getNodeCache = function (nodeId) {
            var nodeCache = this.cacheManagement.findCacheById(nodeId);
            if (nodeCache &&
                nodeCache.instance &&
                nodeCache.type === cacheType.LoadNode) {
                return nodeCache.instance.getDataInfo();
            }
            return null;
        };
        Node.prototype.destroyInstance = function () {
            throw new Error("Method not implemented.");
        };
        /**
         * @description 加载文件已存在的节点
         * @param fileDetail
         */
        Node.prototype.loadExistNode = function (fileDetail) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var param, res;
                var _b;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            param = fileDetail.map(function (item) {
                                return item.targetUrl;
                            });
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.loadFile(param, false, true))];
                        case 1:
                            res = _c.sent();
                            Object.assign(this.loadTaskCollection, (_b = {}, _b[res] = fileDetail, _b));
                            this.dispatch.emit("loadNode", {
                                status: true,
                                message: "创建加载任务",
                                data: {
                                    type: "nodeStatus",
                                    currentState: ILoadModelStatus.CreateTask,
                                    taskId: res
                                },
                            });
                            return [2 /*return*/];
                    }
                });
            });
        };
        /**
     * @description: 加载模型进度变化
     * @return {*}
     * @internal
     */
        Node.prototype.loadNodeProgressChange = function () {
            var _this = this;
            this.loadNodeProgressChangeFun = function (taskId, process) {
                _this.dispatch.emit("loadNode", {
                    status: true,
                    message: "加载中...",
                    data: {
                        type: 'nodeStatus',
                        currentState: ILoadModelStatus.Loading,
                        process: process * 100
                    },
                });
            };
            return this.loadNodeProgressChangeFun;
        };
        Node.prototype.loadFileFinishEvent = function () {
            var _this = this;
            this.loadFileFinishEventFun = function (taskId, nodes) { return __awaiter$1(_this, void 0, void 0, function () {
                var fileDetail, root, rootId, i, nodeInfos, successList, failueList, i, instance, loadNodeInfo, loadNodeInstance;
                var _a, _b;
                var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
                return __generator$1(this, function (_o) {
                    switch (_o.label) {
                        case 0:
                            fileDetail = this.loadTaskCollection[taskId];
                            if (!fileDetail)
                                return [2 /*return*/];
                            if (!(nodes.length !== 0)) return [3 /*break*/, 14];
                            return [4 /*yield*/, ((_c = this.nodeProxy) === null || _c === void 0 ? void 0 : _c.getRoot())];
                        case 1:
                            root = _o.sent();
                            rootId = (_d = root === null || root === void 0 ? void 0 : root.getDataInfo()) === null || _d === void 0 ? void 0 : _d.node;
                            i = 0;
                            _o.label = 2;
                        case 2:
                            if (!(i < nodes.length)) return [3 /*break*/, 5];
                            return [4 /*yield*/, ((_e = this.player.Native) === null || _e === void 0 ? void 0 : _e.Node.setProperty(nodes[i], (_a = {}, _a[NodeProperty.Parent] = rootId, _a)))];
                        case 3:
                            _o.sent();
                            this.LoadStatus[(_f = fileDetail[i]) === null || _f === void 0 ? void 0 : _f.nodeId] = Object.assign((_h = this.LoadStatus[(_g = fileDetail[i]) === null || _g === void 0 ? void 0 : _g.nodeId]) !== null && _h !== void 0 ? _h : {}, (_b = {},
                                _b["nodeStatus"] = nodes[i]
                                    ? ILoadModelStatus.LoadSuccess
                                    : ILoadModelStatus.Error,
                                _b));
                            _o.label = 4;
                        case 4:
                            i++;
                            return [3 /*break*/, 2];
                        case 5: return [4 /*yield*/, ((_j = this.player.Native) === null || _j === void 0 ? void 0 : _j.Node.addToFactory(nodes))];
                        case 6:
                            _o.sent();
                            return [4 /*yield*/, ((_k = this.player.Native) === null || _k === void 0 ? void 0 : _k.Node.getProperty(nodes, [NodeProperty.Parent, NodeProperty.Aabb, NodeProperty.Code, NodeProperty.Name, NodeProperty.Visible, NodeProperty.Parent, NodeProperty.Material]))];
                        case 7:
                            nodeInfos = _o.sent();
                            successList = [];
                            failueList = [];
                            i = 0;
                            _o.label = 8;
                        case 8:
                            if (!(i < nodeInfos.length)) return [3 /*break*/, 13];
                            if (!nodeInfos[i]) return [3 /*break*/, 11];
                            instance = new nodeWrap(this.player, nodeInfos[i]);
                            return [4 /*yield*/, this.cacheManagement.createCache(nodeInfos[i].node, instance)];
                        case 9:
                            _o.sent();
                            loadNodeInfo = {
                                nodeInstance: instance,
                                id: (_l = fileDetail[i]) === null || _l === void 0 ? void 0 : _l.nodeId,
                            };
                            loadNodeInstance = new baseWrap(loadNodeInfo, cacheType.LoadNode);
                            return [4 /*yield*/, this.cacheManagement.createCache((_m = fileDetail[i]) === null || _m === void 0 ? void 0 : _m.nodeId, loadNodeInstance, root)];
                        case 10:
                            _o.sent();
                            successList.push(fileDetail[i]);
                            return [3 /*break*/, 12];
                        case 11:
                            failueList.push(fileDetail[i]);
                            _o.label = 12;
                        case 12:
                            i++;
                            return [3 /*break*/, 8];
                        case 13:
                            if (successList.length !== 0) {
                                this.dispatch.emit("loadNode", {
                                    status: ILoadModelStatus.LoadSuccess,
                                    message: "加载成功",
                                    data: {
                                        type: "nodeStatus",
                                        currentState: ILoadModelStatus.LoadSuccess,
                                        loadNodeInfo: successList,
                                        taskId: taskId
                                    },
                                });
                            }
                            if (failueList.length !== 0) {
                                this.dispatch.emit("loadNode", {
                                    status: ILoadModelStatus.Error,
                                    message: "加载失败",
                                    data: {
                                        type: "nodeStatus",
                                        currentState: ILoadModelStatus.Error,
                                        loadNodeInfo: failueList,
                                        taskId: taskId
                                    },
                                });
                            }
                            return [3 /*break*/, 15];
                        case 14:
                            this.dispatch.emit("loadNode", {
                                status: ILoadModelStatus.Error,
                                message: "加载失败",
                                data: {
                                    type: "nodeStatus",
                                    currentState: ILoadModelStatus.Error,
                                    loadNodeInfo: fileDetail,
                                    taskId: taskId
                                },
                            });
                            _o.label = 15;
                        case 15:
                            delete this.loadTaskCollection[taskId];
                            return [2 /*return*/];
                    }
                });
            }); };
            return this.loadFileFinishEventFun;
        };
        /**
     * @description: 加载模型成功回调
     * @return {*}
     * @internal
     */
        Node.prototype.loadNodeFinish = function () {
            var _this = this;
            this.loadNodeFinishFun = function (taskId, process) { return __awaiter$1(_this, void 0, void 0, function () {
                return __generator$1(this, function (_a) {
                    // 更新消息
                    this.dispatch.emit("loadNode", {
                        status: ILoadModelStatus.Loading,
                        message: "加载完成",
                        data: {
                            type: 'nodeStatus',
                            currentState: ILoadModelStatus.Loading,
                            process: process * 100,
                            taskId: taskId
                        },
                    });
                    return [2 /*return*/];
                });
            }); };
            return this.loadNodeFinishFun;
        };
        Node.prototype.setConnect = function () {
            // 设置文件加载状态的监听
            this.dispatch.on("File", this.connectFileData());
        };
        Node.prototype.loadFile = function (fileDetail, nodeId) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var res;
                var _b;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.loadFile([fileDetail.targetUrl], false, true))];
                        case 1:
                            res = _c.sent();
                            Object.assign(this.loadTaskCollection, (_b = {}, _b[res] = [__assign$2(__assign$2({}, fileDetail), { nodeId: nodeId })], _b));
                            this.dispatch.emit("loadNode", {
                                status: true,
                                message: "创建加载任务",
                                data: {
                                    type: "nodeStatus",
                                    currentState: ILoadModelStatus.CreateTask,
                                    taskId: res
                                },
                            });
                            return [2 /*return*/];
                    }
                });
            });
        };
        Node.prototype.changeLoadStatus = function (nodeId, status, message, type, process) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var currentNode, _b, unDownLoadSuccessIndex, loadNodeInfo;
                var _c;
                return __generator$1(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            currentNode = null;
                            if (!nodeId) return [3 /*break*/, 8];
                            this.LoadStatus[nodeId] = Object.assign((_a = this.LoadStatus[nodeId]) !== null && _a !== void 0 ? _a : {}, (_c = {},
                                _c[type] = status,
                                _c));
                            currentNode = this.nodeList.find(function (el) {
                                return el.nodeId === nodeId;
                            });
                            if (!currentNode) return [3 /*break*/, 8];
                            _b = status;
                            switch (_b) {
                                case ILoadModelStatus.DownLoadSuccess: return [3 /*break*/, 1];
                                case ILoadModelStatus.UnLoadModel: return [3 /*break*/, 2];
                                case ILoadModelStatus.LoadSuccess: return [3 /*break*/, 3];
                                case ILoadModelStatus.Error: return [3 /*break*/, 6];
                            }
                            return [3 /*break*/, 7];
                        case 1:
                            unDownLoadSuccessIndex = Object.values(this.LoadStatus[nodeId || -1]).findIndex(function (el) {
                                return el !== ILoadModelStatus.DownLoadSuccess;
                            });
                            if (unDownLoadSuccessIndex === -1) {
                                this.loadFile(currentNode, nodeId);
                            }
                            return [3 /*break*/, 8];
                        case 2:
                            // 卸载模型
                            this.nodeList = this.nodeList.filter(function (item) {
                                return item.nodeId !== nodeId;
                            });
                            delete this.LoadStatus[nodeId];
                            return [3 /*break*/, 8];
                        case 3:
                            if (!currentNode.gisSetting) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.setNodeGisPosition(nodeId, currentNode.gisSetting)];
                        case 4:
                            _d.sent();
                            _d.label = 5;
                        case 5: return [3 /*break*/, 8];
                        case 6:
                            this.nodeList = this.nodeList.filter(function (item) {
                                return item.nodeId !== nodeId;
                            });
                            delete this.LoadStatus[nodeId];
                            return [3 /*break*/, 8];
                        case 7: return [3 /*break*/, 8];
                        case 8:
                            loadNodeInfo = this.getNodeCache(nodeId);
                            this.dispatch.emit("loadNode", {
                                status: status !== ILoadModelStatus.Error,
                                message: message,
                                data: {
                                    type: type,
                                    currentState: status,
                                    loadNodeInfo: loadNodeInfo,
                                    process: process,
                                },
                            });
                            return [2 /*return*/];
                    }
                });
            });
        };
        Node.prototype.connectFileData = function () {
            var _this = this;
            var that = this;
            this.dealFileData = function (res) {
                var _a, _b, _c, _d, _e, _f;
                if (!((_a = res.data) === null || _a === void 0 ? void 0 : _a.type))
                    return;
                var currentNode = that.nodeList.find(function (el) {
                    var _a, _b, _c, _d;
                    if (((_a = res.data) === null || _a === void 0 ? void 0 : _a.type) === "nodeDecals") {
                        return ((_b = el.nodeDecals) === null || _b === void 0 ? void 0 : _b.targetUrl) === ((_c = res.data) === null || _c === void 0 ? void 0 : _c.targetUrl);
                    }
                    return el.targetUrl === ((_d = res.data) === null || _d === void 0 ? void 0 : _d.targetUrl);
                });
                if (!currentNode)
                    return;
                switch ((_b = res.data) === null || _b === void 0 ? void 0 : _b.currentState) {
                    case ILoadFileStatus.Error:
                        _this.changeLoadStatus(currentNode === null || currentNode === void 0 ? void 0 : currentNode.nodeId, ILoadModelStatus.Error, res.message || "下载失败", (_c = res.data) === null || _c === void 0 ? void 0 : _c.type);
                        break;
                    case ILoadFileStatus.DownLoadSuccess:
                        _this.changeLoadStatus(currentNode === null || currentNode === void 0 ? void 0 : currentNode.nodeId, ILoadModelStatus.DownLoadSuccess, "下载成功", (_d = res.data) === null || _d === void 0 ? void 0 : _d.type);
                        break;
                    case ILoadFileStatus.DownLoading:
                        _this.changeLoadStatus(currentNode === null || currentNode === void 0 ? void 0 : currentNode.nodeId, ILoadModelStatus.DownLoading, "下载中...", (_e = res.data) === null || _e === void 0 ? void 0 : _e.type, (_f = res.data) === null || _f === void 0 ? void 0 : _f.process);
                        break;
                }
            };
            return this.dealFileData;
        };
        /** 初始化监听，创建下载文件的任务 */
        Node.prototype.loadUnExistNode = function (options) {
            var _this = this;
            if (!this.connectFlag) {
                this.setConnect();
                this.connectFlag = true;
            }
            options.forEach(function (node) {
                if (!_this.LoadStatus[node.nodeId]) {
                    // 初始化LoadStatus
                    _this.LoadStatus[node.nodeId] = {
                        nodeStatus: ILoadModelStatus.Init,
                    };
                    // 检查是否需要加载贴图
                    if (node.nodeDecals) {
                        _this.LoadStatus[node.nodeId].nodeDecals = ILoadModelStatus.Init;
                        // 判断是否存在临时路径,不存在设置默认值
                        if (!node.nodeDecals.tempPath) {
                            node.nodeDecals.tempPath = "data://temps/models/".concat(node.nodeId, "/").concat(node.nodeId, ".zip");
                        }
                        _this.fileObject.addFileList({
                            fileList: node.nodeDecals,
                            httpOptions: node.httpOptions,
                            type: "nodeDecals",
                        });
                    }
                    _this.fileObject.addFileList({
                        fileList: node,
                        httpOptions: node.httpOptions,
                        type: "nodeStatus",
                        confirmFileUnExist: true,
                    });
                }
            });
        };
        return Node;
    }(commonAbstractClass));

    var Setting = /** @class */ (function () {
        function Setting(cacheManagement, dispatch) {
            this.player = {};
            var player = getPlayerData(cacheManagement);
            if (!player) {
                throw new Error("player未加载");
            }
            this.player = player;
            this.fileObject = new File(player, dispatch);
            Setting.instance = this;
        }
        /**
         * @description: 保存string到文件里面
         * @param {string} filePath 文件地址
         * @param {string} fileData 文件的内容
         * @return {*}
         */
        Setting.prototype.saveSetting = function (filePath, fileData) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var saveStatus;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.File.saveText(filePath, fileData))];
                        case 1:
                            saveStatus = _b.sent();
                            return [2 /*return*/, {
                                    status: saveStatus,
                                    message: saveStatus ? '保存成功' : '保存失败'
                                }];
                    }
                });
            });
        };
        /**
         * @description: 获取指定文件的内容
         * @param {string} filePath 文件地址
         * @return {*}
         */
        Setting.prototype.getSettingData = function (filePath) {
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.fileObject.getFileData(filePath)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        /**
         * @description: 获取当前的所有配置
         * @return {*}
         */
        Setting.prototype.getAll = function () {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var Setting;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Setting.getAll())];
                        case 1:
                            Setting = _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    message: '成功',
                                    data: Setting
                                }];
                    }
                });
            });
        };
        /**
         * @description: 设置
         * @param {Array} playerSetting
         * @return {*}
         */
        Setting.prototype.set = function (playerSetting) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var i, element;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!Array.isArray(playerSetting)) {
                                playerSetting = [playerSetting];
                            }
                            i = 0;
                            _b.label = 1;
                        case 1:
                            if (!(i < playerSetting.length)) return [3 /*break*/, 4];
                            element = playerSetting[i];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Setting.set(element.name, element.value))];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/, {
                                status: true,
                                message: '成功'
                            }];
                    }
                });
            });
        };
        /**
         * @description: 获取配置
         * @param {Array} name
         * @return {*}
         */
        Setting.prototype.get = function (name) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var settingList, i, _b, _c, _d;
                return __generator$1(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            settingList = [];
                            if (!Array.isArray(name)) {
                                name = [name];
                            }
                            i = 0;
                            _e.label = 1;
                        case 1:
                            if (!(i < name.length)) return [3 /*break*/, 4];
                            _c = (_b = settingList).push;
                            _d = [{}];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Setting.get(name[i]))];
                        case 2:
                            _c.apply(_b, [__assign$2.apply(void 0, [__assign$2.apply(void 0, _d.concat([_e.sent()])), { name: name[i] }])]);
                            _e.label = 3;
                        case 3:
                            i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/, {
                                status: true,
                                message: '成功',
                                data: settingList
                            }];
                    }
                });
            });
        };
        Setting.instance = null;
        return Setting;
    }());

    /**键盘与code的对应 */
    var IKeyCodeAndHotKey;
    (function (IKeyCodeAndHotKey) {
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Zero"] = 48] = "Zero";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["One"] = 49] = "One";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Two"] = 50] = "Two";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Three"] = 51] = "Three";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Four"] = 52] = "Four";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Five"] = 53] = "Five";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Six"] = 54] = "Six";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Seven"] = 55] = "Seven";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Eight"] = 56] = "Eight";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Nine"] = 57] = "Nine";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["A"] = 65] = "A";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["B"] = 66] = "B";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["C"] = 67] = "C";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["D"] = 68] = "D";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["E"] = 69] = "E";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["F"] = 70] = "F";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["G"] = 71] = "G";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["H"] = 72] = "H";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["I"] = 73] = "I";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["J"] = 74] = "J";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["K"] = 75] = "K";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["L"] = 76] = "L";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["M"] = 77] = "M";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["N"] = 78] = "N";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["O"] = 79] = "O";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["P"] = 80] = "P";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Q"] = 81] = "Q";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["R"] = 82] = "R";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["S"] = 83] = "S";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["T"] = 84] = "T";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["U"] = 85] = "U";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["V"] = 86] = "V";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["W"] = 87] = "W";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["X"] = 88] = "X";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Y"] = 89] = "Y";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Z"] = 90] = "Z";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["End"] = 35] = "End";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Home"] = 36] = "Home";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["ArrowLeft"] = 37] = "ArrowLeft";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["ArrowUp"] = 38] = "ArrowUp";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["ArrowRight"] = 39] = "ArrowRight";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["ArrowDown"] = 40] = "ArrowDown";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["PageDown"] = 34] = "PageDown";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["PageUp"] = 33] = "PageUp";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Insert"] = 45] = "Insert";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Delete"] = 46] = "Delete";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["F1"] = 112] = "F1";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["F2"] = 113] = "F2";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["F3"] = 114] = "F3";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["F4"] = 115] = "F4";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["F5"] = 116] = "F5";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["F6"] = 117] = "F6";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["F7"] = 118] = "F7";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["F8"] = 119] = "F8";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["F9"] = 120] = "F9";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["F10"] = 121] = "F10";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["F11"] = 122] = "F11";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["F12"] = 123] = "F12";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Escape"] = 27] = "Escape";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Return"] = 13] = "Return";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Add"] = 187] = "Add";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Subtract"] = 189] = "Subtract";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Divide"] = 111] = "Divide";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Enter"] = 108] = "Enter";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Multiply"] = 106] = "Multiply";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Capital"] = 20] = "Capital";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Backspace"] = 8] = "Backspace";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Tab"] = 9] = "Tab";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Alt"] = 18] = "Alt";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["LeftAlt"] = 164] = "LeftAlt";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["RightAl"] = 165] = "RightAl";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["LeftWin"] = 91] = "LeftWin";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["RightWi"] = 92] = "RightWi";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Shift"] = 16] = "Shift";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["LeftShift"] = 160] = "LeftShift";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["RightShift"] = 161] = "RightShift";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Control"] = 17] = "Control";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["LeftControl"] = 162] = "LeftControl";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["RightControl"] = 163] = "RightControl";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Comma"] = 188] = "Comma";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Pause"] = 19] = "Pause";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["ScrollLock"] = 145] = "ScrollLock";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Space"] = 32] = "Space";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["NumLock"] = 144] = "NumLock";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Numpad0"] = 96] = "Numpad0";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Numpad1"] = 97] = "Numpad1";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Numpad2"] = 98] = "Numpad2";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Numpad3"] = 99] = "Numpad3";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Numpad4"] = 100] = "Numpad4";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Numpad5"] = 101] = "Numpad5";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Numpad6"] = 102] = "Numpad6";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Numpad7"] = 103] = "Numpad7";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Numpad8"] = 104] = "Numpad8";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Numpad9"] = 105] = "Numpad9";
        IKeyCodeAndHotKey[IKeyCodeAndHotKey["Decimal"] = 106] = "Decimal";
    })(IKeyCodeAndHotKey || (IKeyCodeAndHotKey = {}));
    var IHotKeyName;
    (function (IHotKeyName) {
        IHotKeyName["\u524D\u8FDB"] = "\u524D\u8FDB";
        IHotKeyName["\u540E\u9000"] = "\u540E\u9000";
        IHotKeyName["\u5411\u5DE6\u79FB\u52A8"] = "\u5411\u5DE6\u79FB\u52A8";
        IHotKeyName["\u5411\u53F3\u79FB\u52A8"] = "\u5411\u53F3\u79FB\u52A8";
        IHotKeyName["\u5411\u4E0A\u4EF0\u89C6"] = "\u5411\u4E0A\u4EF0\u89C6";
        IHotKeyName["\u5411\u4E0B\u4FEF\u89C6"] = "\u5411\u4E0B\u4FEF\u89C6";
        IHotKeyName["\u5DE6\u8F6C"] = "\u5DE6\u8F6C";
        IHotKeyName["\u53F3\u8F6C"] = "\u53F3\u8F6C";
        IHotKeyName["\u8DF3\u8D77"] = "\u8DF3\u8D77";
        IHotKeyName["\u65E0\u91CD\u529B\u8DF3"] = "\u65E0\u91CD\u529B\u8DF3";
        IHotKeyName["\u5954\u8DD1"] = "\u5954\u8DD1";
        IHotKeyName["\u8E72\u4E0B"] = "\u8E72\u4E0B";
        IHotKeyName["\u5782\u76F4\u5411\u4E0A\u79FB\u52A8"] = "\u5782\u76F4\u5411\u4E0A\u79FB\u52A8";
        IHotKeyName["\u5782\u76F4\u5411\u4E0B\u79FB\u52A8"] = "\u5782\u76F4\u5411\u4E0B\u79FB\u52A8";
        IHotKeyName["\u5F00\u542F/\u5173\u95ED\u4EBA\u7269\u7A7F\u5899"] = "\u5F00\u542F/\u5173\u95ED\u4EBA\u7269\u7A7F\u5899";
        IHotKeyName["\u5F00\u542F/\u5173\u95ED\u4EBA\u7269\u98DE\u884C\u6A21\u5F0F"] = "\u5F00\u542F/\u5173\u95ED\u4EBA\u7269\u98DE\u884C\u6A21\u5F0F";
    })(IHotKeyName || (IHotKeyName = {}));

    /*
     * @Author: fengxiaojing
     * @LastEditTime: 2023-03-28 14:38:29
     * @Description:
     * @LastEditors: fengxiaojing
     */
    /** 检查文件是否存在*/
    function checkFile(player, url) {
        var _a;
        return __awaiter$1(this, void 0, void 0, function () {
            var status;
            return __generator$1(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = player.Native) === null || _a === void 0 ? void 0 : _a.File.exists(url))];
                    case 1:
                        status = _b.sent();
                        return [2 /*return*/, !!status];
                }
            });
        });
    }
    // export async function downLoadFile(player: any, fileUrl: string, md5: string, targetUrl: string, modelId: string): Promise<boolean> {
    // }

    var Walking = /** @class */ (function () {
        function Walking(cacheManagement) {
            this.player = {};
            this.hotKeyMap = IKeyCodeAndHotKey;
            var player = getPlayerData(cacheManagement);
            if (!player) {
                throw new Error("player未加载");
            }
            this.player = player;
        }
        /**
         * @description: 获取漫游所有的快捷键
         * @return {*}
         */
        Walking.prototype.getAllHotKey = function () {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var resData;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            resData = [];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Walking.getHotkeys())
                                // todo 暂时注释
                                // Object.keys(hotkeys).forEach(item => {
                                //     resData.push({
                                //         label: item,
                                //         value: hotkeys[item],
                                //         code: hotkeys[item].map(keys => {
                                //             const keyList = keys.split('+')
                                //             return keyList.map(key => {
                                //                 return IKeyCodeAndHotKey[key as THotKey]
                                //             })
                                //         })
                                //     })
                                // })
                            ];
                        case 1:
                            _b.sent();
                            // todo 暂时注释
                            // Object.keys(hotkeys).forEach(item => {
                            //     resData.push({
                            //         label: item,
                            //         value: hotkeys[item],
                            //         code: hotkeys[item].map(keys => {
                            //             const keyList = keys.split('+')
                            //             return keyList.map(key => {
                            //                 return IKeyCodeAndHotKey[key as THotKey]
                            //             })
                            //         })
                            //     })
                            // })
                            return [2 /*return*/, {
                                    message: '',
                                    status: true,
                                    data: resData
                                }];
                    }
                });
            });
        };
        /**
         * @description:  获取当前快捷键是否可用
         * @param {number} code
         * @return {*}
         */
        Walking.prototype.isEnableHotKey = function (code) {
            return __awaiter$1(this, void 0, void 0, function () {
                var hotkeysRes, isExis;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!code.every(function (el) {
                                return !!IKeyCodeAndHotKey[el];
                            })) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: '不支持当前快捷键'
                                    }];
                            }
                            return [4 /*yield*/, this.getAllHotKey()];
                        case 1:
                            hotkeysRes = _a.sent();
                            if (hotkeysRes && hotkeysRes.data) {
                                isExis = hotkeysRes.data.some(function (element) {
                                    return element.value[0] === code.map(function (item) {
                                        return IKeyCodeAndHotKey[item];
                                    }).join('+');
                                });
                                return [2 /*return*/, {
                                        status: true,
                                        message: isExis ? '当前快捷键已被占用' : '当前快捷键可用',
                                        data: !isExis
                                    }];
                            }
                            return [2 /*return*/, {
                                    status: false,
                                    message: ''
                                }];
                    }
                });
            });
        };
        /**
         * @description: 批量设置快捷键
         * @param {Array} hotkeys
         * @return {*}
         */
        Walking.prototype.setHotKeys = function (hotkeys) {
            return __awaiter$1(this, void 0, void 0, function () {
                var failCodeList;
                return __generator$1(this, function (_a) {
                    failCodeList = [];
                    if (!Array.isArray(hotkeys)) {
                        hotkeys = [hotkeys];
                    }
                    // todo 暂时注释
                    // for (let i = 0; i < hotkeys.length; i++) {
                    //     const element: IHotKeyParams = hotkeys[i];
                    //     // 判断是否可以设置当前快捷键
                    //     if (!element.code.every(el => {
                    //         return !!IKeyCodeAndHotKey[el]
                    //     })) {
                    //         failCodeList.push(element)
                    //         continue
                    //     }
                    //     if (!IHotKeyName[element.name]) {
                    //         // 判断name是否支持可设置
                    //         failCodeList.push(element)
                    //         continue
                    //     }
                    //     // 判断当前快捷键是否被占用
                    //     const isEnableRes = await this.isEnableHotKey(element.code)
                    //     if (isEnableRes && !isEnableRes.data) {
                    //         failCodeList.push(element)
                    //         continue
                    //     }
                    //     await this.player.Native?.Walking.setHotkey(element.name, [element.code.map(el => {
                    //         return IKeyCodeAndHotKey[el]
                    //     })])
                    // }
                    return [2 /*return*/, {
                            data: {
                                failCodeList: failCodeList
                            },
                            status: true,
                            message: "\u6279\u91CF\u8BBE\u7F6E\u6210\u529F".concat(hotkeys.length - failCodeList.length, "\u4E2A\uFF0C \u8BBE\u7F6E\u5931\u8D25").concat(failCodeList.length)
                        }];
                });
            });
        };
        /**
         * @description: 获取人物的基准速度
         * @return {*}
         */
        Walking.prototype.getAvatarSpeed = function () {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var speed;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Walking.avatarMoveSpeed())];
                        case 1:
                            speed = _b.sent();
                            return [2 /*return*/, {
                                    message: '',
                                    status: true,
                                    data: speed
                                }];
                    }
                });
            });
        };
        /**
         * @description: 设置人物的基准速度
         * @param {number} speed 速度
         * @return {*}
         */
        Walking.prototype.setAvatarSpeed = function (speed) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Walking.setAvatarMoveSpeed(speed))];
                        case 1:
                            _b.sent();
                            return [2 /*return*/, {
                                    message: '',
                                    status: true
                                }];
                    }
                });
            });
        };
        /**
         * @description: 设置皮肤
         * @param {ISkinOption} skinOption
         * @return {*}
         */
        Walking.prototype.setAvatarSkin = function (type, skinOption) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var message, bodyUrl, res, headUrl, res;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            message = '';
                            if (!skinOption.body) return [3 /*break*/, 4];
                            bodyUrl = "data://../apps/skin/".concat(type, "/body_").concat(skinOption.body, ".jpg");
                            return [4 /*yield*/, checkFile(this.player, bodyUrl)];
                        case 1:
                            if (!_c.sent()) return [3 /*break*/, 3];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Walking.setAvatarBodySkin(bodyUrl))];
                        case 2:
                            res = _c.sent();
                            if (!res) {
                                message += " 身体贴图设置失败!";
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            message += " 身体贴图文件不存在!";
                            _c.label = 4;
                        case 4:
                            if (!skinOption.head) return [3 /*break*/, 8];
                            headUrl = "data://../apps/skin/".concat(type, "/head_").concat(skinOption.head, ".jpg");
                            return [4 /*yield*/, checkFile(this.player, headUrl)];
                        case 5:
                            if (!_c.sent()) return [3 /*break*/, 7];
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Walking.setAvatarCapSkin(headUrl))];
                        case 6:
                            res = _c.sent();
                            if (!res) {
                                message += " 头部贴图设置失败!";
                            }
                            return [3 /*break*/, 8];
                        case 7:
                            message += " 头部贴图文件不存在!";
                            _c.label = 8;
                        case 8: return [2 /*return*/, {
                                message: message,
                                status: message ? false : true
                            }];
                    }
                });
            });
        };
        return Walking;
    }());

    var ModelGlitter = /** @class */ (function () {
        function ModelGlitter(player) {
            this.maps = new Map();
            this.player = null;
            this.player = player;
            this.common = common(player);
        }
        /**
         * 开启闪烁
         * @param nodeWraps 需要闪烁的节点
         * @param colorList 颜色列表
         * @param frequency 闪烁频率
         * @param alpha 透明度
         */
        ModelGlitter.prototype.open = function (nodeWraps, colorList, frequency, alpha) {
            if (frequency === void 0) { frequency = 500; }
            if (alpha === void 0) { alpha = 1.0; }
            return __awaiter$1(this, void 0, void 0, function () {
                var nodes, materialsInfo, index, fun, intervalID;
                var _this = this;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!Array.isArray(nodeWraps)) {
                                nodeWraps = [nodeWraps];
                            }
                            //判断nodeWraps是否在maps中
                            if (this.maps.get(nodeWraps)) {
                                console.log('该节点已闪烁');
                                return [2 /*return*/];
                            }
                            nodes = nodeWraps.map(function (item) { return item.nodeInfo.node; });
                            return [4 /*yield*/, this.getMaterialsClone(nodes)];
                        case 1:
                            materialsInfo = _a.sent();
                            index = 0;
                            fun = function () {
                                _this.common.setMaterialsProperty(materialsInfo.map(function (item) { return item.clone; }), { "diffuse": colorList[index], "alpha": alpha, "enableAlphaTest": alpha < 1.0 });
                                index = (index + 1) % colorList.length;
                            };
                            fun();
                            intervalID = setInterval(fun, frequency);
                            this.maps.set(nodeWraps, {
                                intervalID: intervalID,
                                materialsInfo: materialsInfo
                            });
                            return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * 关闭闪烁
         * @param nodeWraps 关闭闪烁的节点
         */
        ModelGlitter.prototype.close = function (nodeWraps) {
            var res = this.maps.get(nodeWraps);
            if (!res)
                return;
            var intervalID = res.intervalID, materialsInfo = res.materialsInfo;
            if (intervalID) {
                clearInterval(intervalID);
            }
            this.maps.delete(nodeWraps);
            this.restoreMaterials(materialsInfo);
        };
        // 关闭所有闪烁
        ModelGlitter.prototype.destroyInstance = function () {
            var _this = this;
            this.maps.forEach(function (_a) {
                var intervalID = _a.intervalID, materialsInfo = _a.materialsInfo;
                clearInterval(intervalID);
                _this.restoreMaterials(materialsInfo);
            });
            this.maps.clear();
        };
        /**
         * 获取节点及其子孙节点的材质，并设置节点为clone后的材质，这是为了防止后续更改材质时，
         * 影响其他节点，因为可能其他节点和该节点的材质是同一个
         * @param nodes 节点数组
         */
        ModelGlitter.prototype.getMaterialsClone = function (nodes) {
            var _a, _b, _c, _d;
            return __awaiter$1(this, void 0, void 0, function () {
                var materialsObj, materialsInfo, params, _loop_1, this_1, _e, _f, _g, _i, key;
                var _this = this;
                return __generator$1(this, function (_h) {
                    switch (_h.label) {
                        case 0:
                            materialsObj = {};
                            materialsInfo = [];
                            return [4 /*yield*/, this.common.traverseNode(nodes, function (node) { return __awaiter$1(_this, void 0, void 0, function () {
                                    return __generator$1(this, function (_a) {
                                        if (!node.material)
                                            return [2 /*return*/];
                                        if (materialsObj[node.material]) {
                                            materialsObj[node.material].nodes.push(node.node);
                                        }
                                        else {
                                            materialsObj[node.material] = { nodes: [node.node] };
                                        }
                                        return [2 /*return*/];
                                    });
                                }); }, ["children", "material"])];
                        case 1:
                            _h.sent();
                            params = [];
                            _loop_1 = function (key) {
                                var element, clone_1;
                                return __generator$1(this, function (_j) {
                                    switch (_j.label) {
                                        case 0:
                                            if (!Object.prototype.hasOwnProperty.call(materialsObj, key)) return [3 /*break*/, 2];
                                            element = materialsObj[key];
                                            return [4 /*yield*/, ((_b = (_a = this_1.player) === null || _a === void 0 ? void 0 : _a.Native) === null || _b === void 0 ? void 0 : _b.Material.clone(key))];
                                        case 1:
                                            clone_1 = _j.sent();
                                            materialsInfo.push({ clone: clone_1, original: Number(key), nodes: element.nodes });
                                            element.nodes.forEach(function (node) {
                                                params.push({
                                                    node: node,
                                                    props: {
                                                        material: clone_1
                                                    }
                                                });
                                            });
                                            _j.label = 2;
                                        case 2: return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            _e = materialsObj;
                            _f = [];
                            for (_g in _e)
                                _f.push(_g);
                            _i = 0;
                            _h.label = 2;
                        case 2:
                            if (!(_i < _f.length)) return [3 /*break*/, 5];
                            _g = _f[_i];
                            if (!(_g in _e)) return [3 /*break*/, 4];
                            key = _g;
                            return [5 /*yield**/, _loop_1(key)];
                        case 3:
                            _h.sent();
                            _h.label = 4;
                        case 4:
                            _i++;
                            return [3 /*break*/, 2];
                        case 5: return [4 /*yield*/, ((_d = (_c = this.player) === null || _c === void 0 ? void 0 : _c.Native) === null || _d === void 0 ? void 0 : _d.Node.setProperty(params))];
                        case 6:
                            _h.sent();
                            return [2 /*return*/, materialsInfo];
                    }
                });
            });
        };
        /**
         * 还原材质
         * @param materialsInfo 材质和节点的对应信息
         */
        ModelGlitter.prototype.restoreMaterials = function (materialsInfo) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var params;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            params = [];
                            materialsInfo.forEach(function (element) {
                                element.nodes.forEach(function (node) {
                                    params.push({
                                        node: node,
                                        props: {
                                            material: element.original
                                        }
                                    });
                                });
                            });
                            return [4 /*yield*/, ((_b = (_a = this.player) === null || _a === void 0 ? void 0 : _a.Native) === null || _b === void 0 ? void 0 : _b.Node.setProperty(params))];
                        case 1:
                            _c.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        return ModelGlitter;
    }());

    var EMarkPosType;
    (function (EMarkPosType) {
        EMarkPosType[EMarkPosType["leftTop"] = 0] = "leftTop";
        EMarkPosType[EMarkPosType["midTop"] = 1] = "midTop";
        EMarkPosType[EMarkPosType["rightTop"] = 2] = "rightTop";
        EMarkPosType[EMarkPosType["leftBottom"] = 3] = "leftBottom";
        EMarkPosType[EMarkPosType["midBottom"] = 4] = "midBottom";
        EMarkPosType[EMarkPosType["rightBottom"] = 5] = "rightBottom";
    })(EMarkPosType || (EMarkPosType = {}));
    var EType;
    (function (EType) {
        EType[EType["MT_KEEP_SIZE"] = 0] = "MT_KEEP_SIZE";
        EType[EType["MT_KEEP_Z"] = 1] = "MT_KEEP_Z";
        EType[EType["MT_AUTO_SIZE"] = 2] = "MT_AUTO_SIZE";
        EType[EType["MT_MODEL"] = 3] = "MT_MODEL";
    })(EType || (EType = {}));
    var EMarkerEvent;
    (function (EMarkerEvent) {
        EMarkerEvent[EMarkerEvent["click"] = 0] = "click";
        EMarkerEvent[EMarkerEvent["hover"] = 1] = "hover";
    })(EMarkerEvent || (EMarkerEvent = {}));

    // 深度克隆
    function deepClone(obj) {
        // 处理 null、undefined 或基本类型
        if (obj === null || typeof obj !== "object") {
            return obj;
        }
        // 处理 Date 类型
        if (obj instanceof Date) {
            return new Date(obj.getTime());
        }
        // 处理 Array 类型
        if (Array.isArray(obj)) {
            return obj.map(function (item) { return deepClone(item); });
        }
        // 处理 RegExp 类型
        if (obj instanceof RegExp) {
            return new RegExp(obj);
        }
        // 处理普通对象
        var clonedObj = {};
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                clonedObj[key] = deepClone(obj[key]);
            }
        }
        return clonedObj;
    }

    var Marker3D = /** @class */ (function (_super) {
        __extends$1(Marker3D, _super);
        function Marker3D(player, dispatch, bindEvent) {
            var _this = _super.call(this) || this;
            _this.player = {};
            _this.dealMarkerLClick = null;
            _this.dealMarkerHover = null;
            _this.markerMap = {};
            _this.markerMap_sis = {};
            _this.sis_markerId = {};
            _this.dispatch = dispatch;
            if (!player) {
                throw new Error("player未加载");
            }
            _this.player = player;
            Marker3D.instance = _this;
            _this.markerClick();
            _this.markerHover();
            return _this;
        }
        Marker3D.prototype.destroyInstance = function (markerCache) {
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_a) {
                    return [2 /*return*/];
                });
            });
        };
        // 标签点击事件开关
        Marker3D.prototype.triggerMarkerClick = function (bool) {
            var _a, _b;
            if (bool) {
                (_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Marker3D.EventMarkerLClick.connect(this.dealMarkerLClick);
            }
            else {
                (_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Marker3D.EventMarkerLClick.disconnect(this.dealMarkerLClick);
            }
        };
        // 鼠标经过事件开关
        Marker3D.prototype.triggerMarkerHover = function (bool) {
            var _a, _b, _c, _d;
            if (bool) {
                (_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Setting.set('func.markerHover', true);
                (_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Marker3D.EventMarkerHover.connect(this.dealMarkerHover);
            }
            else {
                (_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.Setting.set('func.markerHover', false);
                (_d = this.player.Native) === null || _d === void 0 ? void 0 : _d.Marker3D.EventMarkerHover.disconnect(this.dealMarkerHover);
            }
        };
        /** 鼠标点击标签 */
        Marker3D.prototype.markerClick = function () {
            var _this = this;
            this.dealMarkerLClick = function (e) {
                for (var key in _this.markerMap) {
                    if (Object.prototype.hasOwnProperty.call(_this.markerMap, key)) {
                        var element = _this.markerMap[key];
                        if (element.node === e) {
                            return _this.dispatch.emit('Marker', {
                                markerId: element,
                                type: EMarkerEvent.click
                            });
                        }
                    }
                }
            };
            return this.dealMarkerLClick;
        };
        /** 鼠标经过标签 */
        Marker3D.prototype.markerHover = function () {
            var _this = this;
            this.dealMarkerHover = function (e, e2) {
                for (var key in _this.markerMap) {
                    if (Object.prototype.hasOwnProperty.call(_this.markerMap, key)) {
                        var element = _this.markerMap[key];
                        if (element.node === e) {
                            return _this.dispatch.emit('Marker', {
                                markerId: element,
                                type: EMarkerEvent.hover
                            });
                        }
                    }
                }
            };
            return this.dealMarkerHover;
        };
        /**
         * @description: 单行标签创建
         * @param {IMarkSingleLineOption} options
         * @return {*}
         */
        Marker3D.prototype.createBySingleLine = function (options) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var res, optionList, markerPtrs, i, id;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // 初始化参数以及简单排查
                            options = this.initOptions(options);
                            res = this.isNoValidOption(options);
                            if (res)
                                return [2 /*return*/, res
                                    // 计算参数
                                ];
                            optionList = this.handeleParams(options);
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Marker3D.create(optionList))
                                // 将标签关联至node上
                            ];
                        case 1:
                            markerPtrs = _b.sent();
                            // 将标签关联至node上
                            for (i = 0; i < markerPtrs.length; i++) {
                                options[i].node = markerPtrs[i];
                                id = options[i].id;
                                this.markerMap[id] = {
                                    id: id,
                                    node: markerPtrs[i],
                                    type: 'singleLine',
                                    markOption: options[i]
                                };
                            }
                            //设置标签的节点设置
                            return [4 /*yield*/, this.setNode(options)];
                        case 2:
                            //设置标签的节点设置
                            _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    message: "加载成功",
                                    data: options
                                }];
                    }
                });
            });
        };
        Marker3D.prototype.setNode = function (markSingleLineOptions) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var params;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            params = markSingleLineOptions.map(function (item) {
                                var props = {};
                                item.pos && (props['localTrans'] = item.pos);
                                item.parentNode && (props['parent'] = item.parentNode);
                                item.visible && (props['visible'] = item.visible);
                                return {
                                    node: item.node,
                                    props: props
                                };
                            });
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.setProperty(params))];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * @description: 单行标签的更新
         * @param {IMarkSingleLineOption} options
         * @return {*}
         */
        Marker3D.prototype.updateBySingleLine = function (options) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var res, newOptions, updateOption;
                var _this = this;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // 初始化参数以及简单排查
                            options = this.initOptions(options);
                            res = this.isNoValidUpdateOption(options);
                            if (res)
                                return [2 /*return*/, res
                                    // 去除无需更新的配置 更新旧配置
                                ];
                            newOptions = options.map(function (option) {
                                var oldOption = _this.markerMap[option.id].markOption;
                                var newOption = {};
                                for (var key in option) {
                                    if (Object.prototype.hasOwnProperty.call(option, key)) {
                                        var value = option[key];
                                        var oldValue = oldOption[key];
                                        if (!_this.isEqual(value, oldValue)) {
                                            oldOption[key] = value;
                                            newOption[key] = value;
                                        }
                                    }
                                }
                                if (newOption.text || newOption.textPadding || newOption.textFontSize || newOption.markPosType || newOption.nodeOffset) {
                                    newOption = __assign$2(__assign$2({}, newOption), { text: oldOption.text, textPadding: oldOption.textPadding, textFontSize: oldOption.textFontSize, markPosType: oldOption.markPosType, nodeOffset: oldOption.nodeOffset, type: oldOption.type });
                                }
                                newOption.node = _this.markerMap[option.id].node;
                                return newOption;
                            });
                            updateOption = this.handeleUpdateParams(newOptions);
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Marker3D.setProperty(updateOption))
                                //设置标签的节点设置
                            ];
                        case 1:
                            _b.sent();
                            //设置标签的节点设置
                            return [4 /*yield*/, this.setNode(newOptions)];
                        case 2:
                            //设置标签的节点设置
                            _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    message: "更新成功",
                                }];
                    }
                });
            });
        };
        /**
         * 创建多行标签
         * @param options
         * @returns
         */
        Marker3D.prototype.createByMultiLine = function (options) {
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            /** 整理多行标签的参数 */
                            options = this.handleMultiLineParams(options);
                            return [4 /*yield*/, this.createBySingleLine(options)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        /**
         * @description: 更新多行标签
         * @param {IMarkMultiLineOption} options
         * @return {*}
         */
        Marker3D.prototype.updateByMultiLine = function (options) {
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            /** 整理多行标签的参数 */
                            options = this.handleMultiLineParams(options);
                            return [4 /*yield*/, this.updateBySingleLine(options)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        /**创建图片标签*/
        Marker3D.prototype.createByPicture = function (options) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var res, optionList, markerPtrs, i, id;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // 初始化参数以及简单排查
                            options = this.initOptions(options);
                            res = this.isNoValidOption(options);
                            if (res)
                                return [2 /*return*/, res
                                    // 计算参数
                                ];
                            return [4 /*yield*/, this.handelePicParams(options, false)];
                        case 1:
                            optionList = _b.sent();
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Marker3D.create(optionList))
                                // 将标签关联至node上
                            ];
                        case 2:
                            markerPtrs = _b.sent();
                            // 将标签关联至node上
                            for (i = 0; i < markerPtrs.length; i++) {
                                options[i].node = markerPtrs[i];
                                id = options[i].id;
                                this.markerMap[id] = {
                                    id: id,
                                    node: markerPtrs[i],
                                    type: 'picture',
                                    markOption: options[i]
                                };
                            }
                            //设置标签的节点设置
                            return [4 /*yield*/, this.setNode(options)];
                        case 3:
                            //设置标签的节点设置
                            _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    message: "加载成功",
                                    data: options
                                }];
                    }
                });
            });
        };
        /**
         * @description: 更新图片标签
         * @param {IMarkPictureOption} options
         * @return {*}
         */
        Marker3D.prototype.updateByPicture = function (options) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var res, newOptions, updateOption;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // 初始化参数以及简单排查
                            options = this.initOptions(options);
                            res = this.isNoValidUpdateOption(options);
                            if (res)
                                return [2 /*return*/, res
                                    // 去除无需更新的配置 更新旧配置
                                ];
                            newOptions = this.updateOptions(options);
                            return [4 /*yield*/, this.handeleUpdatePicParams(newOptions)];
                        case 1:
                            updateOption = _b.sent();
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Marker3D.setProperty(updateOption))
                                //设置标签的节点设置
                            ];
                        case 2:
                            _b.sent();
                            //设置标签的节点设置
                            return [4 /*yield*/, this.setNode(newOptions)];
                        case 3:
                            //设置标签的节点设置
                            _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    message: "更新成功",
                                }];
                    }
                });
            });
        };
        /**创建带文字的图片标签*/
        Marker3D.prototype.createByPictureWithText = function (options) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var res, optionList, markerPtrs, i, id;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // 初始化参数以及简单排查
                            options = this.initOptions(options);
                            res = this.isNoValidOption(options);
                            if (res)
                                return [2 /*return*/, res
                                    // 计算参数
                                ];
                            return [4 /*yield*/, this.handelePicParams(options, true)];
                        case 1:
                            optionList = _b.sent();
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Marker3D.create(optionList))
                                // 将标签关联至node上
                            ];
                        case 2:
                            markerPtrs = _b.sent();
                            // 将标签关联至node上
                            for (i = 0; i < markerPtrs.length; i++) {
                                options[i].node = markerPtrs[i];
                                id = options[i].id;
                                this.markerMap[id] = {
                                    id: id,
                                    node: markerPtrs[i],
                                    type: 'picture',
                                    markOption: options[i]
                                };
                            }
                            //设置标签的节点设置
                            return [4 /*yield*/, this.setNode(options)];
                        case 3:
                            //设置标签的节点设置
                            _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    message: "加载成功",
                                    data: options
                                }];
                    }
                });
            });
        };
        /**
         * @description: 更新带文字的图片标签
         * @param {IMarkPictureOption} options
         * @return {*}
         */
        Marker3D.prototype.updateByPictureWithText = function (options) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var res, newOptions, updateOption;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // 初始化参数以及简单排查
                            options = this.initOptions(options);
                            res = this.isNoValidUpdateOption(options);
                            if (res)
                                return [2 /*return*/, res
                                    // 去除无需更新的配置 更新旧配置
                                ];
                            newOptions = this.updateOptions(options);
                            return [4 /*yield*/, this.handeleUpdatePicParams(newOptions, true)];
                        case 1:
                            updateOption = _b.sent();
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Marker3D.setProperty(updateOption))
                                //设置标签的节点设置
                            ];
                        case 2:
                            _b.sent();
                            //设置标签的节点设置
                            return [4 /*yield*/, this.setNode(newOptions)];
                        case 3:
                            //设置标签的节点设置
                            _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    message: "更新成功",
                                }];
                    }
                });
            });
        };
        /**创建带文字的圆形图片标签*/
        Marker3D.prototype.createByRound = function (options) {
            return __awaiter$1(this, void 0, void 0, function () {
                var newOptions;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // 处理圆形图片参数
                            if (!Array.isArray(options)) {
                                options = [options];
                            }
                            newOptions = this.handleRoundOptions(options);
                            return [4 /*yield*/, this.createByPictureWithText(newOptions)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        /**
         * @description: 更新带文字的圆形图片标签
         * @param {IMarkPictureOption} options
         * @return {*}
         */
        Marker3D.prototype.updateByRound = function (options) {
            return __awaiter$1(this, void 0, void 0, function () {
                var newOptions;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // 处理圆形图片参数
                            if (!Array.isArray(options)) {
                                options = [options];
                            }
                            newOptions = this.handleRoundOptions(options);
                            return [4 /*yield*/, this.updateByPictureWithText(newOptions)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        /**
         * 创建图片标签
         * @param {IMarkDomOption} options
         * @returns
         */
        Marker3D.prototype.createByDom = function (options) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var res, optionList, markerPtrs, i, id;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // 初始化参数以及简单排查
                            // options = this.initOptions(options)
                            if (!Array.isArray(options)) {
                                options = [options];
                            }
                            res = this.isNoValidOption(options);
                            if (res)
                                return [2 /*return*/, res
                                    // 计算参数
                                ];
                            return [4 /*yield*/, this.handelePicParams(options, false)];
                        case 1:
                            optionList = _b.sent();
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Marker3D.create(optionList))
                                // 将标签关联至node上
                            ];
                        case 2:
                            markerPtrs = _b.sent();
                            // 将标签关联至node上
                            for (i = 0; i < markerPtrs.length; i++) {
                                options[i].node = markerPtrs[i];
                                id = options[i].id;
                                this.markerMap[id] = {
                                    id: id,
                                    node: markerPtrs[i],
                                    type: 'dom',
                                    markOption: options[i]
                                };
                            }
                            //设置标签的节点设置
                            return [4 /*yield*/, this.setNode(options)];
                        case 3:
                            //设置标签的节点设置
                            _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    message: "加载成功",
                                    data: options
                                }];
                    }
                });
            });
        };
        /**
         * @description: 更新图片标签
         * @param {IMarkDomOption} options
         * @return {*}
         */
        Marker3D.prototype.updateByDom = function (options) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var res, newOptions, updateOption;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // 初始化参数以及简单排查
                            // options = this.initOptions(options)
                            if (!Array.isArray(options)) {
                                options = [options];
                            }
                            res = this.isNoValidUpdateOption(options);
                            if (res)
                                return [2 /*return*/, res
                                    // 去除无需更新的配置 更新旧配置
                                ];
                            newOptions = this.updateOptions(options);
                            return [4 /*yield*/, this.handeleUpdatePicParams(newOptions)];
                        case 1:
                            updateOption = _b.sent();
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Marker3D.setProperty(updateOption))
                                //设置标签的节点设置
                            ];
                        case 2:
                            _b.sent();
                            //设置标签的节点设置
                            return [4 /*yield*/, this.setNode(newOptions)];
                        case 3:
                            //设置标签的节点设置
                            _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    message: "更新成功",
                                }];
                    }
                });
            });
        };
        /**
             * 创建sis标签
             * @param options
             * @returns
             */
        Marker3D.prototype.createBySis = function (options) {
            return __awaiter$1(this, void 0, void 0, function () {
                var hasMarker, newOption;
                var _this = this;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!Array.isArray(options)) {
                                options = [options];
                            }
                            hasMarker = options.find(function (item) {
                                return item.id && _this.markerMap_sis[item.id];
                            });
                            if (hasMarker) {
                                return [2 /*return*/, { status: false, message: "".concat(hasMarker.id, "\u5DF2\u5B58\u5728") }];
                            }
                            newOption = this.handeleSisParams(options);
                            return [4 /*yield*/, this.createBySingleLine(newOption)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        /**
         * 更新sis标签
         * @param options
         * @returns
         */
        Marker3D.prototype.updateBySis = function (options) {
            return __awaiter$1(this, void 0, void 0, function () {
                var arrayHasId, newOption;
                var _this = this;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!Array.isArray(options)) {
                                options = [options];
                            }
                            arrayHasId = options.every(function (el) {
                                return !!el.id && _this.markerMap_sis[el.id];
                            });
                            if (!arrayHasId) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "每项需要传递id, 且每个id创建的标签需要存在"
                                    }];
                            }
                            newOption = this.handeleSisParams(options, true);
                            return [4 /*yield*/, this.createBySingleLine(newOption)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    message: "更新成功",
                                }];
                    }
                });
            });
        };
        //卸载标签
        Marker3D.prototype.destroyMarker = function (ids) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var nodes, res;
                var _this = this;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!Array.isArray(ids))
                                ids = [ids];
                            nodes = [];
                            ids.map(function (id) {
                                if (_this.sis_markerId[id]) {
                                    _this.sis_markerId[id].forEach(function (id) {
                                        nodes.push(_this.markerMap[id].node);
                                        delete _this.markerMap[id];
                                    });
                                }
                                else {
                                    nodes.push(_this.markerMap[id].node);
                                    delete _this.markerMap[id];
                                }
                            });
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Marker3D.destroy(nodes))];
                        case 1:
                            res = _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    message: "卸载成功",
                                    data: res
                                }];
                    }
                });
            });
        };
        //卸载所有标签
        Marker3D.prototype.destroyAllMarker = function () {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var nodes, res;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            nodes = Object.values(this.markerMap).map(function (item) { return item.node; });
                            this.markerMap = {};
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Marker3D.destroy(nodes))];
                        case 1:
                            res = _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    message: "卸载成功",
                                    data: res
                                }];
                    }
                });
            });
        };
        // 参数初始化处理 克隆和转数组
        Marker3D.prototype.initOptions = function (options) {
            options = deepClone(options);
            if (!Array.isArray(options)) {
                options = [options];
            }
            return options;
        };
        // 测试参数是否合法
        Marker3D.prototype.isNoValidOption = function (options) {
            var _this = this;
            var hasMarker = options.find(function (item) {
                return item.id && _this.markerMap[item.id];
            });
            if (hasMarker) {
                return { status: false, message: "".concat(hasMarker.id, "\u5DF2\u5B58\u5728") };
            }
        };
        Marker3D.prototype.isNoValidUpdateOption = function (options) {
            var _this = this;
            var arrayHasId = options.every(function (el) {
                return !!el.id && _this.markerMap[el.id];
            });
            if (!arrayHasId) {
                return {
                    status: false,
                    message: "每项需要传递id, 且每个id创建的标签需要存在"
                };
            }
        };
        //获取去除无需更新的配置(和旧值相同) 更新旧配置
        Marker3D.prototype.updateOptions = function (options) {
            var _this = this;
            return options.map(function (option) {
                var oldOption = _this.markerMap[option.id].markOption;
                var newOption = {};
                for (var key in option) {
                    if (Object.prototype.hasOwnProperty.call(option, key)) {
                        var value = option[key];
                        var oldValue = oldOption[key];
                        if (!_this.isEqual(value, oldValue)) {
                            oldOption[key] = value;
                            newOption[key] = value;
                        }
                    }
                }
                if (newOption.markPosType || newOption.nodeOffset || newOption.imgSize) {
                    newOption = __assign$2(__assign$2({}, newOption), { markPosType: oldOption.markPosType, nodeOffset: oldOption.nodeOffset, imgSize: oldOption.imgSize });
                }
                newOption.node = _this.markerMap[option.id].node;
                return newOption;
            });
        };
        //判断值是否相同，包含数组元素相同
        Marker3D.prototype.isEqual = function (obj1, obj2) {
            var _this = this;
            if (Array.isArray(obj1)) {
                return obj1.length === obj2.length && obj1.every(function (item, index) { return _this.isEqual(item, obj2[index]); });
            }
            else {
                return obj1 === obj2;
            }
        };
        /** 整理多行标签的参数 */
        Marker3D.prototype.handleMultiLineParams = function (options) {
            if (!Array.isArray(options)) {
                options = [options];
            }
            options.forEach(function (option) {
                var line = option === null || option === void 0 ? void 0 : option.dataList.map(function (element) {
                    if (typeof element === 'string') {
                        return element;
                    }
                    else {
                        return element.label + ':' + element.value;
                    }
                });
                option.text = line.join('\n');
            });
            return options;
        };
        /** 整理单/多行标签的参数 */
        Marker3D.prototype.handeleParams = function (optionList) {
            var _this = this;
            return optionList.map(function (element) {
                var _a;
                var textFontSize = element.textFontSize = element.textFontSize || 1;
                var text = element.text = element.text || '';
                var textPadding = element.textPadding = element.textPadding || [0, 0, 0, 0];
                var type = (_a = element.type) !== null && _a !== void 0 ? _a : 1;
                var imageSize;
                if (element.imageSize) {
                    imageSize = element.imageSize;
                }
                else {
                    var textSize = element.textSize = element.textSize || computedText(text, textFontSize);
                    //用于调整2种标签的文字大小
                    if (type) {
                        textSize[0] = textSize[0] * 0.91 + 0.25;
                    }
                    else {
                        textSize[0] = textSize[0] * 1.23;
                        textSize[1] = textSize[1] * 1.1 + textFontSize * 0.3;
                    }
                    imageSize = element.imageSize = [textSize[0] + textPadding[0] + textPadding[2], textSize[1] + textPadding[1] + textPadding[3]];
                }
                element.textColor = element.textColor || '#ffffffff';
                element.background = element.background || '#ffffffff';
                var imageColor = Number(element.background.replace("#", '0x'));
                var textColor = Number(element.textColor.replace("#", '0x'));
                element.markPosType = element.markPosType || EMarkPosType.leftTop;
                element.nodeOffset = element.nodeOffset || [0, 0];
                var markerOffset = _this.fetchNodeOffset(element.markPosType, element.nodeOffset, imageSize);
                var option = {
                    type: type,
                    props: { markerOffset: markerOffset, imageSize: imageSize, imageColor: imageColor, text: text, textColor: textColor, textFontSize: textFontSize, textPadding: textPadding }
                };
                return option;
            });
        };
        // 整理单/多行标签的更新参数
        Marker3D.prototype.handeleUpdateParams = function (optionList) {
            var _this = this;
            return optionList.map(function (element) {
                var _a, _b, _c;
                var option = {
                    marker: element.node,
                    props: {}
                };
                if (element.text) {
                    var textFontSize = element.textFontSize;
                    var text = element.text;
                    var textPadding = element.textPadding || [0, 0, 0, 0];
                    var type = (_a = element.type) !== null && _a !== void 0 ? _a : 1;
                    var imageSize = void 0;
                    if (element.imageSize) {
                        imageSize = element.imageSize;
                    }
                    else {
                        var textSize = element.textSize = element.textSize || computedText(text, textFontSize);
                        //用于调整2种标签的文字大小
                        if (type) {
                            textSize[0] = textSize[0] * 0.91 + 0.25;
                        }
                        else {
                            textSize[0] = textSize[0] * 1.23;
                            textSize[1] = textSize[1] * 1.1 + textFontSize * 0.3;
                        }
                        imageSize = element.imageSize = [textSize[0] + textPadding[0] + textPadding[2], textSize[1] + textPadding[1] + textPadding[3]];
                    }
                    var markerOffset = _this.fetchNodeOffset((_b = element.markPosType) !== null && _b !== void 0 ? _b : EMarkPosType.leftTop, (_c = element.nodeOffset) !== null && _c !== void 0 ? _c : [0, 0], imageSize);
                    option.props.markerOffset = markerOffset;
                    option.props.imageSize = imageSize;
                    option.props.textFontSize = textFontSize;
                    option.props.text = text;
                    option.props.textPadding = textPadding;
                }
                if (element.background) {
                    option.props.imageColor = Number(element.background.replace("#", '0x'));
                }
                if (element.textColor) {
                    option.props.textColor = Number(element.textColor.replace("#", '0x'));
                }
                return option;
            });
        };
        // 整理图片标签的更新参数
        Marker3D.prototype.handeleUpdatePicParams = function (optionList, withText) {
            if (withText === void 0) { withText = false; }
            return __awaiter$1(this, void 0, void 0, function () {
                var promises;
                var _this = this;
                return __generator$1(this, function (_a) {
                    promises = optionList.map(function (element) { return __awaiter$1(_this, void 0, void 0, function () {
                        var option, imageSize, markerOffset, imageTexture, convas, imageTexture, textColor;
                        var _a, _b;
                        return __generator$1(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    option = {
                                        marker: element.node,
                                        props: {}
                                    };
                                    if (element.imgSize) {
                                        imageSize = element.imgSize;
                                        markerOffset = this.fetchNodeOffset(element.markPosType, element.nodeOffset, imageSize);
                                        option.props.markerOffset = markerOffset;
                                        option.props.imageSize = imageSize;
                                    }
                                    if (!element.backgroundUrl) return [3 /*break*/, 2];
                                    return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Texture.create(element.backgroundUrl))];
                                case 1:
                                    imageTexture = _c.sent();
                                    option.props.imageTexture = imageTexture;
                                    return [3 /*break*/, 5];
                                case 2:
                                    if (!element.dom) return [3 /*break*/, 5];
                                    return [4 /*yield*/, html2canvas(element.dom, {})];
                                case 3:
                                    convas = _c.sent();
                                    return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Texture.create(convas.toDataURL()))];
                                case 4:
                                    imageTexture = _c.sent();
                                    option.props.imageTexture = imageTexture;
                                    _c.label = 5;
                                case 5:
                                    if (withText) {
                                        if ('text' in element)
                                            option.props.text = element.text;
                                        if ('textFontSize' in element)
                                            option.props.textFontSize = element.textFontSize;
                                        if ('textPadding' in element)
                                            option.props.textPadding = element.textPadding;
                                        if ('textSpacing' in element)
                                            option.props.textSpacing = element.textSpacing;
                                        if ('textColor' in element && element.textColor) {
                                            textColor = Number(element.textColor.replace("#", '0x'));
                                            option.props.textColor = textColor;
                                        }
                                    }
                                    return [2 /*return*/, option];
                            }
                        });
                    }); });
                    // 等待所有 Promise 完成并返回结果数组
                    return [2 /*return*/, Promise.all(promises)];
                });
            });
        };
        /** 整理图片标签的参数 */
        Marker3D.prototype.handelePicParams = function (optionList, withText) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var promises, imgUrls, imgIdList;
                var _this = this;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            promises = optionList.map(function (element) { return __awaiter$1(_this, void 0, void 0, function () {
                                var convas;
                                return __generator$1(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!('backgroundUrl' in element)) return [3 /*break*/, 1];
                                            return [2 /*return*/, element.backgroundUrl];
                                        case 1:
                                            if (!('dom' in element)) return [3 /*break*/, 3];
                                            return [4 /*yield*/, html2canvas(element.dom, {})];
                                        case 2:
                                            convas = _a.sent();
                                            return [2 /*return*/, convas.toDataURL()];
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); });
                            return [4 /*yield*/, Promise.all(promises)];
                        case 1:
                            imgUrls = _b.sent();
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Texture.create(imgUrls))];
                        case 2:
                            imgIdList = _b.sent();
                            return [2 /*return*/, optionList.map(function (element, index) {
                                    var _a;
                                    var imageSize = element.imgSize || [32, 32];
                                    var imageTexture = imgIdList[index];
                                    element.markPosType = element.markPosType || EMarkPosType.leftTop;
                                    element.nodeOffset = element.nodeOffset || [0, 0];
                                    var markerOffset = _this.fetchNodeOffset(element.markPosType, element.nodeOffset, imageSize);
                                    var option = {
                                        type: (_a = element.type) !== null && _a !== void 0 ? _a : 1,
                                        props: { markerOffset: markerOffset, imageSize: imageSize, imageTexture: imageTexture }
                                    };
                                    if (withText) {
                                        if ('text' in element) {
                                            option.props.text = element.text;
                                        }
                                        if ('textColor' in element && element.textColor) {
                                            var textColor = Number(element.textColor.replace("#", '0x'));
                                            option.props.textColor = textColor;
                                        }
                                        if ('textFontSize' in element) {
                                            option.props.textFontSize = element.textFontSize;
                                        }
                                        if ('textPadding' in element) {
                                            option.props.textPadding = element.textPadding;
                                        }
                                        if ('textSpacing' in element) {
                                            option.props.textSpacing = element.textSpacing;
                                        }
                                    }
                                    return option;
                                })];
                    }
                });
            });
        };
        // 处理圆形图片参数
        Marker3D.prototype.handleRoundOptions = function (options) {
            return options.map(function (option) {
                var textFontSize = option.textFontSize || 1;
                var text = option.text || '';
                var textSize = computedText(text, textFontSize);
                var radio = (option.type == 0 ? 1 : 0.04 * textFontSize);
                var T = (option.type == 0 ? 1.25 : 0.85);
                var imageSize = option.hasTriangle ? [62 * radio, 67 * radio] : [62 * radio, 60 * radio];
                var textPadding = [(imageSize[0] - textSize[0]) * 0.46, (60 * radio - textSize[1] * T) * 0.5, 0, 0];
                var newOption = __assign$2(__assign$2({}, option), { imgSize: imageSize, textPadding: textPadding });
                if (option.background) {
                    newOption.backgroundUrl = "data://../apps/markers/".concat(option.background, "/round").concat(option.hasTriangle ? '_triangle' : '', ".png");
                }
                return newOption;
            });
        };
        /** 整理单/多行标签的参数 */
        Marker3D.prototype.handeleSisParams = function (optionList, isUpdate) {
            var _this = this;
            if (isUpdate === void 0) { isUpdate = false; }
            var list = [];
            optionList.forEach(function (element) {
                var _a;
                if (isUpdate) {
                    element = __assign$2(__assign$2({}, _this.markerMap_sis[element.id]), element);
                    _this.destroyMarker(element.id);
                }
                _this.markerMap_sis[element.id] = element;
                var textFontSize = element.textFontSize = element.textFontSize || 1;
                var type = (_a = element.type) !== null && _a !== void 0 ? _a : 1;
                var textPadding = element.textPadding || [1, 0, 1, 0];
                var imageSize_max = [0, 0];
                var length = element.sisData.length;
                _this.sis_markerId[element.id] = [];
                element.sisData.map(function (item, index) {
                    var _a, _b;
                    var text = item.label + ": " + item.value;
                    var textSize = computedText(text, textFontSize);
                    //用于调整2种标签的文字大小
                    if (type) {
                        textSize[1] = textSize[1] * 0.8;
                    }
                    else {
                        textSize[0] = textSize[0] * 1.23;
                        textSize[1] = textSize[1] * 1.1 + textFontSize * 0.3;
                    }
                    imageSize_max[0] = Math.max(textSize[0] + textPadding[0] + textPadding[2], imageSize_max[0]);
                    imageSize_max[1] = imageSize_max[1] || textSize[1] + textPadding[1] + textPadding[3];
                    var nodeOffset = [0, -imageSize_max[1] * (length - index - 1)];
                    var textColor = ((_a = element.levelStyle[item.level]) === null || _a === void 0 ? void 0 : _a.color) || '#ffffffff';
                    var background = ((_b = element.levelStyle[item.level]) === null || _b === void 0 ? void 0 : _b.background) || '#0c3d48ff';
                    var id = 'SIS_' + element.id + index;
                    _this.sis_markerId[element.id].push(id);
                    var option = {
                        id: id,
                        imageSize: imageSize_max,
                        type: type,
                        textFontSize: textFontSize,
                        textPadding: textPadding,
                        text: text,
                        textSize: textSize,
                        textColor: textColor,
                        background: background,
                        nodeOffset: nodeOffset,
                        markPosType: element.markPosType, pos: element.pos, visible: element.visible
                    };
                    list.push(option);
                });
                var option1 = {
                    id: 'SIS_' + element.id + '_title', imageSize: imageSize_max,
                    type: type,
                    textFontSize: textFontSize,
                    textPadding: textPadding,
                    markPosType: element.markPosType, pos: element.pos, visible: element.visible,
                    text: element.title,
                    textColor: element.titleColor,
                    background: element.titleBackground,
                    nodeOffset: [0, -imageSize_max[1] * length]
                };
                _this.sis_markerId[element.id].push('SIS_' + element.id + '_title');
                list.push(option1);
            });
            return list;
        };
        /**
         * 计算node的偏移量
         * @param markPosType 定位类型
         * @param nodeOffset 当前的偏移量
         * @param imgSize 整个标签的大小
         * @returns
         */
        Marker3D.prototype.fetchNodeOffset = function (markPosType, nodeOffset, imgSize) {
            var nodeOffsetCopy = JSON.parse(JSON.stringify(nodeOffset));
            var imgSizeCopy = JSON.parse(JSON.stringify(imgSize));
            switch (markPosType) {
                case EMarkPosType.leftTop:
                    return nodeOffsetCopy;
                case EMarkPosType.midTop:
                    nodeOffsetCopy[0] -= imgSizeCopy[0] / 2;
                    return nodeOffsetCopy;
                case EMarkPosType.rightTop:
                    nodeOffsetCopy[0] -= imgSizeCopy[0];
                    return nodeOffsetCopy;
                case EMarkPosType.leftBottom:
                    nodeOffsetCopy[1] -= imgSizeCopy[1];
                    return nodeOffsetCopy;
                case EMarkPosType.midBottom:
                    nodeOffsetCopy[0] -= imgSizeCopy[0] / 2;
                    nodeOffsetCopy[1] -= imgSizeCopy[1];
                    return nodeOffsetCopy;
                case EMarkPosType.rightBottom:
                    nodeOffsetCopy[0] -= imgSizeCopy[0];
                    nodeOffsetCopy[1] -= imgSizeCopy[1];
                    return nodeOffsetCopy;
                default:
                    return nodeOffsetCopy;
            }
        };
        Marker3D.instance = null;
        return Marker3D;
    }(commonAbstractClass));

    var IAxis;
    (function (IAxis) {
        IAxis[IAxis["X"] = 0] = "X";
        IAxis[IAxis["Y"] = 1] = "Y";
        IAxis[IAxis["Z"] = 2] = "Z";
    })(IAxis || (IAxis = {}));
    //粒子创建方式1.通过位号2.数据创建
    var IPartilceCreateType;
    (function (IPartilceCreateType) {
        IPartilceCreateType[IPartilceCreateType["code"] = 0] = "code";
        IPartilceCreateType[IPartilceCreateType["data"] = 1] = "data";
    })(IPartilceCreateType || (IPartilceCreateType = {}));

    var Particle = /** @class */ (function (_super) {
        __extends$1(Particle, _super);
        function Particle(cacheManagement, dispatch) {
            var _this = _super.call(this) || this;
            _this.nodeInstance = null;
            _this.player = {};
            _this.dealFileLinstener = function () { };
            _this.dealParticleEditor = function () { };
            _this.dealTextureFile = function () { };
            _this.particleRes = { status: false };
            /** 默认返回值 */
            _this.defauleRes = {
                status: false,
                message: "系统错误",
            };
            _this.cacheManagement = cacheManagement;
            _this.dispatch = dispatch;
            var player = getPlayerData(cacheManagement);
            if (!player) {
                throw new Error("player未加载");
            }
            _this.player = player;
            Particle.instance = _this;
            var nodeRes = new NodeProxy(cacheManagement, dispatch);
            _this.nodeInstance = nodeRes;
            return _this;
        }
        Particle.prototype.destroyInstance = function (particleInfo) {
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.destroyParticle([particleInfo.id], false)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        // 辅助方法:将 nodeWrap[] 转换为单个 nodeWrap
        Particle.prototype.convertNodeArrayToSingle = function (response) {
            var _a;
            if (!((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.length)) {
                return undefined;
            }
            return {
                status: response.status,
                message: response.message,
                data: response.data[0]
            };
        };
        //通过code定位
        Particle.prototype.positionByCode = function (code) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var codeInfoRes, _b, codeInfo, Position;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _b = this.convertNodeArrayToSingle;
                            return [4 /*yield*/, ((_a = this.nodeInstance) === null || _a === void 0 ? void 0 : _a.findNode(NodeFindType.codes, code))];
                        case 1:
                            codeInfoRes = _b.apply(this, [_c.sent()]);
                            if (codeInfoRes && codeInfoRes.data) {
                                codeInfo = codeInfoRes.data.getDataInfo();
                                if (!codeInfo)
                                    return [2 /*return*/, { status: false, message: "无法通过位号获取节点信息" }];
                                Position = Aabb.faceCenter(codeInfo.aabb);
                                return [2 /*return*/, {
                                        Position: Position,
                                    }];
                            }
                            return [2 /*return*/, null];
                    }
                });
            });
        };
        /**
         * 设置粒子颜色
         * @param particleObject
         * @param colorOptions
         * @returns
         */
        // private async setParticleColor(
        //   particleObject: nodeWrap,
        //   colorOptions: IColorOptions
        // ): Promise<IResponse<null>> {
        //   // 获取粒子指针
        //   const particleData = particleObject.getDataInfo();
        //   if (particleData) {
        //     const particleChildrensRes: IResponse<nodeWrap[]> | undefined =
        //       await this.nodeInstance?.findNodeChild(particleObject);
        //     let colorList: any = [];
        //     if (!particleChildrensRes || !particleChildrensRes.data)
        //       return {
        //         status: false,
        //         data: null,
        //         message: "当前节点无子节点",
        //       };
        //     const particleChildrens = particleChildrensRes.data;
        //     try {
        //       colorOptions.colorList?.forEach((item: IColorOption) => {
        //         let start = dealColorToNumber(item.startColor);
        //         let end = dealColorToNumber(item.endColor);
        //         let obj: any = { startColor: null, endColor: null };
        //         if (start.status && start.data != null) {
        //           obj.startColor = start.data;
        //         }
        //         if (end.status && end.data != null) {
        //           obj.endColor = end.data;
        //         }
        //         colorList.push(obj);
        //       });
        //       if (colorList.length <= 0)
        //         return { status: false, message: "颜色无效" };
        //       //判断颜色设置模式，默认为计算模式
        //       if (!colorOptions.customModel) {
        //         colorList = colorList.slice(0, 2);
        //         let colorClip = {
        //           startClip: 0,
        //           endClip: 0,
        //         };
        //         if (colorList.length == 2) {
        //           //计算开始颜色的平均差值
        //           colorClip.startClip =
        //             particleChildrens.length > 1
        //               ? (colorList[0].startColor - colorList[1].startColor) /
        //               (particleChildrens.length - 1)
        //               : 0;
        //           //计算结束颜色的平均差值
        //           colorClip.endClip =
        //             particleChildrens.length > 1
        //               ? (colorList[0].endColor - colorList[1].endColor) /
        //               (particleChildrens.length - 1)
        //               : 0;
        //           for (let i = 0; i < particleChildrens.length; i++) {
        //             const particleNodeInfo = particleChildrens[i].getDataInfo();
        //             if (!particleNodeInfo) break;
        //             await this.player.Native?.ParticleEffekseer.setStartColor(
        //               particleNodeInfo.node,
        //               Math.round(colorList[0].startColor - i * colorClip.startClip)
        //             );
        //             await this.player.Native?.ParticleEffekseer.setEndColor(
        //               particleNodeInfo.node,
        //               Math.round(colorList[0].endColor - i * colorClip.endClip)
        //             );
        //           }
        //         }
        //       } else {
        //         //用户自定义样式，子节点和颜色一一对应
        //         for (let i = 0; i < particleChildrens.length; i++) {
        //           const particleNodeInfo = particleChildrens[i].getDataInfo();
        //           if (!particleNodeInfo) break;
        //           colorList[i]?.startColor
        //             ? await this.player.Native?.ParticleEffekseer.setStartColor(
        //               particleNodeInfo.node,
        //               colorList[i].startColor
        //             )
        //             : null;
        //           colorList[i]?.endColor
        //             ? await this.player.Native?.ParticleEffekseer.setEndColor(
        //               particleNodeInfo.node,
        //               colorList[i].endColor
        //             )
        //             : null;
        //         }
        //       }
        //       return {
        //         status: true,
        //         message: "",
        //       };
        //     } catch (error: any) {
        //       return {
        //         status: false,
        //         data: null,
        //         message: error,
        //       };
        //     }
        //   }
        //   return {
        //     status: false,
        //     data: null,
        //     message: "particleObject字段传递错误",
        //   };
        // }
        Particle.prototype.dealCreateParticle = function (id, createType, particleOptions) {
            var _a, _b, _c, _d, _e, _f;
            return __awaiter$1(this, void 0, void 0, function () {
                var particleObject, nodeInfo, nodeInstance, isExist, particleInstance, localPos, _g, res_1, res, axisObj;
                return __generator$1(this, function (_h) {
                    switch (_h.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.ParticleEffekseer.create(particleOptions === null || particleOptions === void 0 ? void 0 : particleOptions.fileOptions.targetUrl))];
                        case 1:
                            particleObject = _h.sent();
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Node.getProperty(particleObject, ["name", "code", "localTrans", "localRot", "localScale", "globalTrans", "globalRot", "parent", "children", "visible", "material", "aabb"]))];
                        case 2:
                            nodeInfo = _h.sent();
                            nodeInstance = new nodeWrap(this.player, nodeInfo);
                            return [4 /*yield*/, this.cacheManagement.createCache(nodeInfo.node, nodeInstance)];
                        case 3:
                            _h.sent();
                            isExist = this.cacheManagement.findCacheById(id);
                            if (!(isExist && isExist.type == cacheType.Particle)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.destroyParticle([id])];
                        case 4:
                            _h.sent();
                            _h.label = 5;
                        case 5:
                            particleInstance = new baseWrap({
                                id: id,
                                nodeInstance: nodeInstance,
                                instance: this
                            }, cacheType.Particle);
                            return [4 /*yield*/, this.cacheManagement.createCache(id, particleInstance, {
                                    instance: nodeInstance,
                                })];
                        case 6:
                            _h.sent();
                            localPos = {
                                Position: [],
                                Rotate: [],
                                Scale: [],
                            };
                            _g = createType;
                            switch (_g) {
                                case IPartilceCreateType.code: return [3 /*break*/, 7];
                                case IPartilceCreateType.data: return [3 /*break*/, 10];
                            }
                            return [3 /*break*/, 11];
                        case 7:
                            if (!particleOptions.code) return [3 /*break*/, 9];
                            return [4 /*yield*/, this.positionByCode(particleOptions.code)];
                        case 8:
                            res_1 = _h.sent();
                            if (res_1) {
                                localPos.Position = res_1.Position;
                            }
                            _h.label = 9;
                        case 9:
                            localPos.Rotate = particleOptions === null || particleOptions === void 0 ? void 0 : particleOptions.Rotate;
                            return [3 /*break*/, 12];
                        case 10:
                            localPos.Position = particleOptions === null || particleOptions === void 0 ? void 0 : particleOptions.Position;
                            localPos.Rotate = particleOptions === null || particleOptions === void 0 ? void 0 : particleOptions.Rotate;
                            return [3 /*break*/, 12];
                        case 11:
                            if (!(particleOptions === null || particleOptions === void 0 ? void 0 : particleOptions.code)) {
                                this.particleRes = { status: false, message: "不支持该类型创建" };
                            }
                            return [3 /*break*/, 12];
                        case 12:
                            // 判断是否创建在世界原点,不是则设置位置
                            localPos.Scale = particleOptions === null || particleOptions === void 0 ? void 0 : particleOptions.Scale;
                            return [4 /*yield*/, ((_c = this.nodeInstance) === null || _c === void 0 ? void 0 : _c.setNodeLocal(nodeInstance, localPos))];
                        case 13:
                            res = (_h.sent()) ||
                                this.defauleRes;
                            if (!!(particleOptions === null || particleOptions === void 0 ? void 0 : particleOptions.Rotate)) return [3 /*break*/, 15];
                            axisObj = {
                                axis: null,
                                angle: ((_d = particleOptions === null || particleOptions === void 0 ? void 0 : particleOptions.rotateOption) === null || _d === void 0 ? void 0 : _d.angle) || 90,
                            };
                            switch ((_e = particleOptions === null || particleOptions === void 0 ? void 0 : particleOptions.rotateOption) === null || _e === void 0 ? void 0 : _e.axis) {
                                case IAxis.Y:
                                    axisObj.axis = [0.0, 1.0, 0.0];
                                    break;
                                case IAxis.Z:
                                    axisObj.axis = [0.0, 0.0, 1.0];
                                    break;
                                default:
                                    axisObj.axis = [1.0, 0.0, 0.0];
                                    break;
                            }
                            return [4 /*yield*/, ((_f = this.player.Native) === null || _f === void 0 ? void 0 : _f.Node.setProperty(particleObject, { localRot: axisObj.axis }))];
                        case 14:
                            _h.sent();
                            _h.label = 15;
                        case 15:
                            // 如果位置信息设置不成功则返回 失败信息
                            if (!res.status) {
                                this.dispatch.emit("Particle", {
                                    status: res.status,
                                    message: res.message,
                                    data: res.data,
                                });
                                return [2 /*return*/];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        //监听粒子文件状态
        Particle.prototype.fileLinstener = function (id, createType, particleOptions) {
            var _this = this;
            var that = this;
            this.dealFileLinstener = function (res) { return __awaiter$1(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator$1(this, function (_c) {
                    //  如果粒子文件存在或是已下载完成
                    if (((_a = res.data) === null || _a === void 0 ? void 0 : _a.targetUrl) == (particleOptions === null || particleOptions === void 0 ? void 0 : particleOptions.fileOptions.targetUrl) &&
                        ((_b = res.data) === null || _b === void 0 ? void 0 : _b.currentState) == ILoadFileStatus.DownLoadSuccess) {
                        //移除文件状态监听
                        this.dispatch.off("File", that.dealFileLinstener);
                        // 贴图存在，先加载贴图
                        if (particleOptions === null || particleOptions === void 0 ? void 0 : particleOptions.textureOptions) {
                            that.setParticleTexture(id, createType, particleOptions);
                        }
                        else {
                            this.dealCreateParticle(id, createType, particleOptions);
                        }
                    }
                    else {
                        this.dispatch.emit("Particle", {
                            status: res.status,
                            message: res.message,
                            data: res.data,
                        });
                    }
                    return [2 /*return*/];
                });
            }); };
            return that.dealFileLinstener;
        };
        //粒子编辑完成后的回调
        Particle.prototype.particleEditorListener = function () {
            var _this = this;
            this.dealParticleEditor = function (res) {
                var _a, _b, _c, _d, _e;
                // 从缓存中查找当前node关联的粒子id
                var nodeInfo = (_a = _this.nodeInstance) === null || _a === void 0 ? void 0 : _a.getNodeInfo((_b = res.data) === null || _b === void 0 ? void 0 : _b.node);
                if (!nodeInfo) {
                    _this.dispatch.emit("Particle", {
                        status: false,
                        message: "node错误",
                    });
                    return;
                }
                var particleList = _this.cacheManagement.findCacheByType(cacheType.Particle);
                var particleTreeNode = particleList.find(function (item) {
                    var _a, _b, _c;
                    return (((_b = (_a = item.instance) === null || _a === void 0 ? void 0 : _a.getDataInfo()) === null || _b === void 0 ? void 0 : _b.nodeInstance) ==
                        ((_c = res.data) === null || _c === void 0 ? void 0 : _c.node));
                });
                var result = {
                    id: particleTreeNode === null || particleTreeNode === void 0 ? void 0 : particleTreeNode.id,
                    localPos: {
                        Position: (_c = res.data) === null || _c === void 0 ? void 0 : _c.Position,
                        Rotate: (_d = res.data) === null || _d === void 0 ? void 0 : _d.Rotate,
                        Scale: (_e = res.data) === null || _e === void 0 ? void 0 : _e.Scale,
                    },
                };
                _this.dispatch.emit("Particle", {
                    status: !!result.id,
                    message: res.message,
                    data: result,
                });
            };
            return this.dealParticleEditor;
        };
        /**
         * @description 创建粒子
         * @param {string | number} id
         * @param {IPartilceCreateType} type
         * @param {IParticleBaseOption} options
         * @returns
         */
        Particle.prototype.createParticle = function (id, type, options) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var hasCache, itemInfo, _b, fileData;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            hasCache = this.cacheManagement.findCacheById(id);
                            if (hasCache) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "".concat(id, "\u5DF2\u5B58\u5728,\u8BF7\u66F4\u6362id\u8FDB\u884C\u521B\u5EFA\u7C92\u5B50\u3002"),
                                    }];
                            }
                            id = id || generateUUID(); //创建粒子id
                            if (!(type == IPartilceCreateType.code)) return [3 /*break*/, 2];
                            if (!options.code) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "\u4F4D\u53F7\u4E3A\u7A7A,\u521B\u5EFA\u5931\u8D25",
                                    }];
                            }
                            _b = this.convertNodeArrayToSingle;
                            return [4 /*yield*/, ((_a = this.nodeInstance) === null || _a === void 0 ? void 0 : _a.findNode(NodeFindType.codes, options.code))];
                        case 1:
                            itemInfo = _b.apply(this, [_c.sent()]);
                            if (!(itemInfo === null || itemInfo === void 0 ? void 0 : itemInfo.data)) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "\u4F4D\u53F7\u4E3A\u7A7A\u6216\u4E0D\u5B58\u5728,\u521B\u5EFA\u5931\u8D25",
                                    }];
                            }
                            _c.label = 2;
                        case 2:
                            fileData = {
                                fileList: [
                                    {
                                        targetUrl: options.fileOptions.targetUrl,
                                        fileUrl: options.fileOptions.fileUrl,
                                        md5: options.fileOptions.md5,
                                        tempPath: options.fileOptions.tempPath,
                                    },
                                ],
                                httpOptions: options.fileOptions.httpOptions,
                                type: options.fileOptions.type,
                            };
                            //文件路径是否存在，若不存在则下载文件
                            new File(this.player, this.dispatch, fileData);
                            //监听粒子文件状态
                            this.dispatch.on("File", this.fileLinstener(id, type, options));
                            return [2 /*return*/, {
                                    status: true,
                                    message: "创建任务成功",
                                }];
                    }
                });
            });
        };
        /**
         * 设置粒子的创建
         * @param {number | string} id
         * @param {INodeEditorType} type
         * @returns {IResponse<null>} 是否设置成功
         */
        Particle.prototype.setParticleEditor = function (id, type) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var particleInfo, result;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!id) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "粒子Id为空",
                                    }];
                            }
                            particleInfo = this.findParticleByCache(id);
                            if (!particleInfo) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "该粒子不存在",
                                    }];
                            }
                            return [4 /*yield*/, ((_a = this.nodeInstance) === null || _a === void 0 ? void 0 : _a.setNodeEditType(particleInfo.nodeInstance, type))];
                        case 1:
                            result = (_b.sent()) || this.defauleRes;
                            if (type != 0) {
                                this.dispatch.on("NodeEditor", this.particleEditorListener());
                            }
                            else {
                                this.dispatch.off("NodeEditor", this.particleEditorListener());
                            }
                            return [2 /*return*/, result];
                    }
                });
            });
        };
        /**
         * @description 设置粒子
         * @param {number | strin} id
         * @param {ILocalOptions} options
         * @returns {IResponse<null>} 是否成功
         */
        Particle.prototype.setParticle = function (id, options) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var particleInfo, result, error_1;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!id) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "粒子Id为空",
                                    }];
                            }
                            particleInfo = this.findParticleByCache(id);
                            if (!particleInfo)
                                return [2 /*return*/, {
                                        status: false,
                                        message: "该粒子不存在",
                                    }];
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, ((_a = this.nodeInstance) === null || _a === void 0 ? void 0 : _a.setNodeLocal(particleInfo.nodeInstance, options))];
                        case 2:
                            result = (_b.sent()) || this.defauleRes;
                            if (!result.status)
                                return [2 /*return*/, result];
                            // if (options.colorOptions) {
                            //   const res = await this.setParticleColor(
                            //     particleInfo.nodeInstance,
                            //     options.colorOptions
                            //   );
                            //   if (!res.status) return res;
                            // }
                            return [2 /*return*/, {
                                    status: true,
                                    message: "",
                                }];
                        case 3:
                            error_1 = _b.sent();
                            return [2 /*return*/, {
                                    status: false,
                                    data: null,
                                    message: error_1,
                                }];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * @description 销毁粒子
         * @param {Array<string|number>} ids 粒子ids
         * @returns {IResponse<void>} 是否成功
         */
        Particle.prototype.destroyParticle = function (ids, isDeletCache) {
            var _a;
            if (isDeletCache === void 0) { isDeletCache = true; }
            return __awaiter$1(this, void 0, void 0, function () {
                var i, element, particleInfo, nodeInfo, error_2;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 5, , 6]);
                            i = 0;
                            _b.label = 1;
                        case 1:
                            if (!(i < ids.length)) return [3 /*break*/, 4];
                            element = ids[i];
                            particleInfo = this.findParticleByCache(element);
                            if (!particleInfo) return [3 /*break*/, 3];
                            nodeInfo = particleInfo.nodeInstance.getDataInfo();
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.ParticleEffekseer.destroy(nodeInfo === null || nodeInfo === void 0 ? void 0 : nodeInfo.node))];
                        case 2:
                            _b.sent();
                            // const res = await this.setParticleEditor(ids[i], 0);
                            // if (!res.status) return res;
                            if (isDeletCache) {
                                this.cacheManagement.deleteCacheById(particleInfo.id);
                            }
                            _b.label = 3;
                        case 3:
                            i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/, {
                                status: true,
                            }];
                        case 5:
                            error_2 = _b.sent();
                            Logger$1.error(error_2);
                            return [2 /*return*/, {
                                    status: false,
                                }];
                        case 6: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * 销毁所有粒子
         */
        Particle.prototype.destroyAllParticle = function () {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var particleList, i, particleItem, particleInfo, nodeInfo;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            particleList = this.cacheManagement.findCacheByType(cacheType.Particle);
                            i = 0;
                            _c.label = 1;
                        case 1:
                            if (!(i < particleList.length)) return [3 /*break*/, 4];
                            particleItem = particleList[i];
                            particleInfo = (_a = particleItem.instance) === null || _a === void 0 ? void 0 : _a.getDataInfo();
                            if (!particleInfo) return [3 /*break*/, 3];
                            nodeInfo = particleInfo.nodeInstance.getDataInfo();
                            // 暂停粒子的动画
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.ParticleEffekseer.destroy(nodeInfo === null || nodeInfo === void 0 ? void 0 : nodeInfo.node))];
                        case 2:
                            // 暂停粒子的动画
                            _c.sent();
                            this.cacheManagement.deleteCacheById(particleInfo.id);
                            _c.label = 3;
                        case 3:
                            i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * 查询粒子颜色
         * @param id
         * @returns {IResponse<IColorOption[]>}
         */
        // public async getParticleColor(
        //   id: string | number
        // ): Promise<IResponse<IColorOption[] | null>> {
        //   if (!id) {
        //     return {
        //       status: false,
        //       message: "粒子Id为空",
        //     };
        //   }
        //   const particleInfo = this.findParticleByCache(id);
        //   if (!particleInfo) {
        //     return {
        //       status: false,
        //       message: "粒子不存在",
        //     };
        //   }
        //   const particleChildrens: IResponse<nodeWrap[]> | undefined =
        //     await this.nodeInstance?.findNodeChild(particleInfo.nodeInstance);
        //   if (!particleChildrens || particleChildrens.data?.length === 0) {
        //     return {
        //       status: false,
        //       message: "当前粒子无子级节点",
        //     };
        //   }
        //   let list: IColorOption[] = [];
        //   particleChildrens.data?.forEach(async (node) => {
        //     const nodeInfo = await this.nodeInstance?.getNodeInfo(node);
        //     if (nodeInfo) {
        //       let startColor =
        //         await this.player.Native?.ParticleEffekseer.getStartColor(
        //           nodeInfo.node
        //         );
        //       let endColor = await this.player.Native?.ParticleEffekseer.getEndColor(
        //         nodeInfo.node
        //       );
        //       list.push({
        //         startColor: startColor,
        //         endColor: endColor,
        //       });
        //     }
        //   });
        //   return {
        //     status: true,
        //     data: list,
        //     message: "",
        //   };
        // }
        /**
         * @description 获取所有粒子
         * @returns  {IResponse<IParticleInfo[]>}
         */
        Particle.prototype.getAllParticle = function () {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var list, result, particleList, i, element, particleInfo, res, localPos;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            list = [];
                            result = null;
                            particleList = this.cacheManagement.findCacheByType(cacheType.Particle);
                            i = 0;
                            _b.label = 1;
                        case 1:
                            if (!(i < particleList.length)) return [3 /*break*/, 5];
                            element = particleList[i];
                            return [4 /*yield*/, this.findParticleByCache(element.id)];
                        case 2:
                            particleInfo = _b.sent();
                            if (!particleInfo) return [3 /*break*/, 4];
                            return [4 /*yield*/, ((_a = this.nodeInstance) === null || _a === void 0 ? void 0 : _a.getNodeLocation(particleInfo.nodeInstance))];
                        case 3:
                            res = _b.sent();
                            if (res && res.status && res.data) {
                                localPos = res.data;
                                // const resColor = await this.getParticleColor(particleInfo.id);
                                list.push({
                                    id: particleInfo.id,
                                    localInfo: localPos,
                                    nodeInfo: particleInfo.nodeInstance.getDataInfo(),
                                    // colorList: resColor.data ? resColor.data : [],
                                });
                            }
                            else {
                                result = res;
                            }
                            _b.label = 4;
                        case 4:
                            i++;
                            return [3 /*break*/, 1];
                        case 5:
                            if (result)
                                return [2 /*return*/, result];
                            return [2 /*return*/, {
                                    status: true,
                                    data: list,
                                    message: "",
                                }];
                    }
                });
            });
        };
        /**
         * @description 获取粒子详情
         * @param {number | string} id
         * @returns {IResponse<IParticleInfo>} 粒子位置、颜色信息
         */
        Particle.prototype.getParticleInfo = function (id) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var particleInfo, res;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!id) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "粒子Id为空",
                                    }];
                            }
                            particleInfo = this.findParticleByCache(id);
                            if (!particleInfo) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "粒子不存在",
                                    }];
                            }
                            return [4 /*yield*/, ((_a = this.nodeInstance) === null || _a === void 0 ? void 0 : _a.getNodeLocation(particleInfo.nodeInstance))];
                        case 1:
                            res = _b.sent();
                            if (!res || !res.status || !res.data) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "查询失败",
                                    }];
                            }
                            // const resColor = await this.getParticleColor(particleInfo.id);
                            // if (!resColor.status) return resColor;
                            return [2 /*return*/, {
                                    status: true,
                                    data: {
                                        id: id,
                                        nodeInfo: particleInfo.nodeInstance.getDataInfo(),
                                        localInfo: res.data,
                                        // colorList: resColor.data ? resColor.data : [],
                                    },
                                    message: "",
                                }];
                    }
                });
            });
        };
        /**
         * 显示/隐藏粒子
         * @param {string|number}id
         * @param {Boolean} visible 是否隐藏
         * @returns
         */
        Particle.prototype.setParticleVisible = function (id, visible) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var i, item, particleInfo;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!id) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "粒子Id为空",
                                    }];
                            }
                            if (!Array.isArray(id)) {
                                id = [id];
                            }
                            i = 0;
                            _b.label = 1;
                        case 1:
                            if (!(i < id.length)) return [3 /*break*/, 4];
                            item = id[i];
                            particleInfo = this.findParticleByCache(item);
                            if (!particleInfo || !particleInfo.nodeInstance) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "".concat(item, "\u7C92\u5B50\u4E0D\u5B58\u5728"),
                                    }];
                            }
                            return [4 /*yield*/, ((_a = this.nodeInstance) === null || _a === void 0 ? void 0 : _a.setNodeInfo(particleInfo.nodeInstance, { visible: visible }))];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/, {
                                status: true,
                                message: "",
                            }];
                    }
                });
            });
        };
        /**
         * @description 贴图文件加载
         * @returns
         */
        Particle.prototype.textureFileLisenter = function (id, createType, particleOptions) {
            var _this = this;
            var that = this;
            this.dealTextureFile = function (res) { return __awaiter$1(_this, void 0, void 0, function () {
                var _a, _b, _c, _d, _e, _f;
                return __generator$1(this, function (_g) {
                    switch (_g.label) {
                        case 0:
                            if (!(((_a = res.data) === null || _a === void 0 ? void 0 : _a.targetUrl) == ((_b = particleOptions.textureOptions) === null || _b === void 0 ? void 0 : _b.targetUrl) &&
                                ((_c = res.data) === null || _c === void 0 ? void 0 : _c.currentState) == ILoadFileStatus.DownLoadSuccess)) return [3 /*break*/, 3];
                            this.dispatch.off("File", that.dealTextureFile);
                            return [4 /*yield*/, ((_e = (_d = that.player) === null || _d === void 0 ? void 0 : _d.Native) === null || _e === void 0 ? void 0 : _e.UiQt.decompressingZIP((_f = particleOptions.textureOptions) === null || _f === void 0 ? void 0 : _f.targetUrl, ""))];
                        case 1:
                            _g.sent();
                            return [4 /*yield*/, that.dealCreateParticle(id, createType, particleOptions)];
                        case 2:
                            _g.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            that.particleRes = res;
                            _g.label = 4;
                        case 4:
                            this.dispatch.emit("Particle", {
                                status: that.particleRes.status,
                                message: that.particleRes.message,
                                data: that.particleRes.data,
                            });
                            return [2 /*return*/];
                    }
                });
            }); };
            return that.dealTextureFile;
        };
        /**
         * @description 设置贴图
         * @param options
         */
        Particle.prototype.setParticleTexture = function (id, createType, particleOptions) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var fileOptions, isExist;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            fileOptions = {
                                fileList: [
                                    {
                                        targetUrl: particleOptions.textureOptions.targetUrl,
                                        fileUrl: particleOptions.textureOptions.fileUrl,
                                        tempPath: particleOptions.textureOptions.tempPath,
                                        md5: particleOptions.textureOptions.md5,
                                    },
                                ],
                                httpOptions: particleOptions.textureOptions.httpOptions,
                                type: particleOptions.textureOptions.type,
                            };
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.File.exists(particleOptions.textureOptions.targetUrl))];
                        case 1:
                            isExist = _b.sent();
                            if (isExist) {
                                this.dealCreateParticle(id, createType, particleOptions);
                            }
                            else {
                                new File(this.player, this.dispatch, fileOptions);
                                //监听粒子贴图文件状态
                                this.dispatch.on("File", this.textureFileLisenter(id, createType, particleOptions));
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        Particle.prototype.findParticleByCache = function (id) {
            var _a;
            var particleInstance = this.cacheManagement.findCacheById(id);
            if (particleInstance && particleInstance.type === cacheType.Particle) {
                var particleInfo = (_a = particleInstance.instance) === null || _a === void 0 ? void 0 : _a.getDataInfo();
                if (particleInfo) {
                    return particleInfo;
                }
            }
            return null;
        };
        Particle.instance = null;
        return Particle;
    }(commonAbstractClass));

    /*
     * @Author: fengxiaojing
     * @LastEditTime: 2024-03-04 14:28:04
     * @Description:
     * @LastEditors: fengxiaojing
     */
    // 调度中心
    var Dispatch = /** @class */ (function () {
        function Dispatch() {
            this.list = {};
        }
        // 注册事件
        Dispatch.prototype.on = function (name, fn) {
            // 把传入的事件放入对应名称的事件数组中
            var callbacks = this.list[name] || [];
            callbacks.push(fn);
            this.list[name] = callbacks;
        };
        // 调用事件
        Dispatch.prototype.emit = function (name) {
            var _this = this;
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            var callbacks = this.list[name];
            if (callbacks && callbacks.length) {
                // 找到名称对应的事件数组，将数组中事件全部调用
                callbacks.forEach(function (fns) {
                    fns.apply(_this, args);
                });
            }
        };
        // 解绑事件
        Dispatch.prototype.off = function (name, fn) {
            // 找到对应名称下的事件数组，删除指定的事件函数
            var callbacks = this.list[name];
            if (callbacks && fn) {
                var index = callbacks.findIndex(function (fns) { return fns === fn; });
                if (index > -1) {
                    callbacks.splice(index, 1);
                }
            }
            else {
                Logger$1.warn('该事件未监听');
            }
        };
        // 注册一个仅执行一次的事件：执行结束后立刻解绑（仅注册，还是需要 emit 执行）
        Dispatch.prototype.once = function (name, fn) {
            var _this = this;
            // 创建一个临时函数用于绑定，在临时函数内部执行完 fn 之后即刻解绑
            var temFn = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                fn.apply(_this, args);
                _this.off(name, temFn);
            };
            this.on(name, temFn);
        };
        // 关闭所有监听
        Dispatch.prototype.offAll = function () {
            this.list = {};
        };
        return Dispatch;
    }());

    var PersonalPerspective$1;
    (function (PersonalPerspective) {
        PersonalPerspective[PersonalPerspective["first"] = 1] = "first";
        PersonalPerspective[PersonalPerspective["second"] = 2] = "second";
        PersonalPerspective[PersonalPerspective["third"] = 3] = "third";
    })(PersonalPerspective$1 || (PersonalPerspective$1 = {}));

    var ICapType$1;
    (function (ICapType) {
        ICapType["red"] = "red";
        ICapType["blue"] = "blue";
        ICapType["yellow"] = "yellow";
        ICapType["white"] = "white";
    })(ICapType$1 || (ICapType$1 = {}));
    var IClipType;
    (function (IClipType) {
        IClipType["idle"] = "idle";
        IClipType["walk"] = "walk";
        IClipType["run"] = "run";
        IClipType["crouchWalk"] = "crouchWalk";
        IClipType["crouchToStand"] = "crouchToStand";
        IClipType["crouchingIdle"] = "crouchingIdle";
        IClipType["jump"] = "jump";
        IClipType["standingToCrouched"] = "standingToCrouched";
        IClipType["stop"] = "stop";
    })(IClipType || (IClipType = {}));

    // import { Matrix4 } from "../../assets/player/PlayerUtils"
    var SkeletonNode = /** @class */ (function (_super) {
        __extends$1(SkeletonNode, _super);
        function SkeletonNode(cacheManagement, dispatch) {
            var _this = _super.call(this) || this;
            _this.player = {};
            _this.markerInstance = null;
            _this.PMap = {};
            _this.cameraNode = null;
            _this.aboutFollow = {};
            _this.isInitDefaultModel = false;
            _this.matchModel = {
                "red": "data://../apps/Man/Man_R.pprj",
                "blue": "data://../apps/Man/Man_B.pprj",
                "yellow": "data://../apps/Man/Man_Y.pprj",
                "white": "data://../apps/Man/Man_W.pprj"
            };
            _this.defaultModel = {};
            _this.cacheManagement = cacheManagement;
            _this.dispatch = dispatch;
            SkeletonNode.instance = _this;
            var player = getPlayerData(cacheManagement);
            if (!player) {
                throw new Error("player未加载");
            }
            _this.player = player;
            _this.markerInstance = new Marker(cacheManagement, dispatch);
            return SkeletonNode.instance;
        }
        SkeletonNode.prototype.destroyInstance = function () {
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.aboutFollow.parent) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.cancelPerspectiveFollow()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [4 /*yield*/, this.destroyAllSkeletonNode()];
                        case 3:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        SkeletonNode.prototype.initDefaultModel = function () {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var _c, capTypeSrcs, res, i, key;
                return __generator$1(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (this.isInitDefaultModel)
                                return [2 /*return*/];
                            this.isInitDefaultModel = true;
                            _c = this.defaultModel;
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.SkeletonNode.defaultSkeletonModel())];
                        case 1:
                            _c.defaultModel = _d.sent();
                            capTypeSrcs = Object.values(this.matchModel);
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Node.loadFile(capTypeSrcs))];
                        case 2:
                            res = _d.sent();
                            i = 0;
                            for (key in this.matchModel) {
                                this.defaultModel[key] = res[i] || this.defaultModel.defaultModel;
                                i++;
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        // 创建人物标签统一处理
        SkeletonNode.prototype.dealData = function (manNodes, options) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var i, markerOptions, markerRes;
                var _this = this;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            for (i = 0; i < manNodes.length; i++) {
                                if (options[i].markerOption) {
                                    options[i].markerOption.skeletonPtr = manNodes[i];
                                    options[i].markerOption.skeletonId = options[i].id;
                                }
                                // await this.updateAction(options[i].id, (options[i].state || IClipType.idle));
                            }
                            markerOptions = options.reduce(function (acc, item) {
                                if (item.markerOption) {
                                    acc.push(item.markerOption);
                                }
                                return acc;
                            }, []);
                            /** 是否需要创建标签，若无需创建则返回 */
                            if (markerOptions.length == 0)
                                return [2 /*return*/];
                            return [4 /*yield*/, ((_a = this.markerInstance) === null || _a === void 0 ? void 0 : _a.createBySingleLine(markerOptions))];
                        case 1:
                            markerRes = _b.sent();
                            markerOptions.forEach(function (item, index) { return __awaiter$1(_this, void 0, void 0, function () {
                                var param;
                                var _a;
                                return __generator$1(this, function (_b) {
                                    this.PMap[item.skeletonId].markerNode = markerRes === null || markerRes === void 0 ? void 0 : markerRes.extra[index];
                                    this.PMap[item.skeletonId].markerInfo = item;
                                    if (markerRes === null || markerRes === void 0 ? void 0 : markerRes.data)
                                        this.PMap[item.skeletonId].markerId = markerRes === null || markerRes === void 0 ? void 0 : markerRes.data[index];
                                    param = { parent: item.skeletonPtr, localTrans: [0, 0, 1.8], visible: options[index].visible };
                                    (_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.setProperty(markerRes === null || markerRes === void 0 ? void 0 : markerRes.extra[index], param);
                                    return [2 /*return*/];
                                });
                            }); });
                            return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * @description 创建人物模型模型
         * @param {ISkeletonNodeCommonOption} option
         * @returns
         */
        SkeletonNode.prototype.createSkeletonNode = function (option) {
            var _a, _b, _c, _d, _e, _f;
            return __awaiter$1(this, void 0, void 0, function () {
                var Pobj, manNode, capTypeSrc, res, p0, _g;
                return __generator$1(this, function (_h) {
                    switch (_h.label) {
                        case 0:
                            if (!option)
                                option = {};
                            option.id = (option === null || option === void 0 ? void 0 : option.id) || generateUUID();
                            //id冲突
                            if (this.PMap[option.id])
                                return [2 /*return*/, { status: false, message: 'ID已存在' }];
                            Pobj = {};
                            this.PMap[option.id] = Pobj;
                            Pobj.id = option.id;
                            option.capType = option.capType || ICapType$1.red;
                            capTypeSrc = this.matchModel[option.capType] || this.matchModel.red;
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.loadFile(capTypeSrc))];
                        case 1:
                            res = _h.sent();
                            if (!res[0]) return [3 /*break*/, 2];
                            manNode = Pobj.manNode = res[0];
                            return [3 /*break*/, 5];
                        case 2: return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.SkeletonNode.defaultSkeletonModel())];
                        case 3:
                            p0 = _h.sent();
                            _g = Pobj;
                            return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.Node.clone(p0))];
                        case 4:
                            manNode = _g.manNode = _h.sent();
                            _h.label = 5;
                        case 5:
                            Pobj.property = { localTrans: (option.position || [0, 0, 0]), visible: ((_d = option.visible) !== null && _d !== void 0 ? _d : true) };
                            if (option.rotate && option.rotate.length == 4) {
                                Pobj.rotate = Pobj.property.localRot = option.rotate;
                            }
                            if (option.parent) {
                                Pobj.property.parent = option.parent;
                            }
                            return [4 /*yield*/, ((_e = this.player.Native) === null || _e === void 0 ? void 0 : _e.Node.setProperty(manNode, Pobj.property))];
                        case 6:
                            _h.sent();
                            return [4 /*yield*/, ((_f = this.player.Native) === null || _f === void 0 ? void 0 : _f.Node.addToFactory([manNode]))];
                        case 7:
                            _h.sent();
                            return [4 /*yield*/, this.dealData([manNode], [option])];
                        case 8:
                            _h.sent();
                            return [2 /*return*/, { status: true, data: this.PMap[option.id] }];
                    }
                });
            });
        };
        /**
         * @description 批量创建人物模型
         * @param {Array<ISkeletonNodeCommonOption>} options
         * @returns
         */
        SkeletonNode.prototype.batchCreateSkeletonNode = function (options) {
            var _a, _b, _c, _d;
            return __awaiter$1(this, void 0, void 0, function () {
                var i, id, params, data, cloneNodes, i, option, id, Pobj, cloneNode, manNodes, i, option, id, Pobj, param;
                return __generator$1(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            for (i = 0; i < options.length; i++) {
                                id = options[i].id || generateUUID() || '1';
                                options[i].id = id;
                                if (this.PMap[id]) {
                                    return [2 /*return*/, { status: false, message: "".concat(id, " ID\u5DF2\u5B58\u5728") }];
                                }
                                this.PMap[id] = {};
                            }
                            return [4 /*yield*/, this.initDefaultModel()
                                // const manNodes: Array<number> = []
                            ];
                        case 1:
                            _e.sent();
                            params = [];
                            data = [];
                            cloneNodes = [];
                            for (i = 0; i < options.length; i++) {
                                option = options[i];
                                id = options[i].id || 1;
                                Pobj = this.PMap[id];
                                Pobj.id = id;
                                cloneNode = (option === null || option === void 0 ? void 0 : option.capType) ? this.defaultModel[option === null || option === void 0 ? void 0 : option.capType] : this.defaultModel.defaultModel;
                                cloneNodes.push(cloneNode);
                            }
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.clone(cloneNodes))];
                        case 2:
                            manNodes = _e.sent();
                            for (i = 0; i < options.length; i++) {
                                option = options[i];
                                id = options[i].id || 1;
                                Pobj = this.PMap[id];
                                Pobj.manNode = manNodes[i];
                                Pobj.property = { localTrans: (option.position || [0, 0, 0]), visible: ((_b = option.visible) !== null && _b !== void 0 ? _b : true) };
                                if (option.rotate && option.rotate.length == 4) {
                                    Pobj.rotate = Pobj.property.localRot = option.rotate;
                                }
                                if (option.parent) {
                                    Pobj.property.parent = option.parent;
                                }
                                param = {
                                    node: manNodes[i],
                                    props: Pobj.property
                                };
                                params.push(param);
                                data.push({
                                    id: id,
                                    nodeInstance: Pobj,
                                });
                            }
                            return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.Node.setProperty(params))];
                        case 3:
                            _e.sent();
                            return [4 /*yield*/, ((_d = this.player.Native) === null || _d === void 0 ? void 0 : _d.Node.addToFactory(manNodes))];
                        case 4:
                            _e.sent();
                            return [4 /*yield*/, this.dealData(manNodes, options)];
                        case 5:
                            _e.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    data: data,
                                }];
                    }
                });
            });
        };
        /**
         * @description 更新人物模型动画
         * @param {string | number} id
         * @param {IClipType} behavior
         * @param {number} duration
         * @returns
         */
        SkeletonNode.prototype.updateAction = function (id, behavior, duration) {
            var _a, _b, _c, _d, _e;
            return __awaiter$1(this, void 0, void 0, function () {
                var p, manMixer, _f, outAction, inAction;
                return __generator$1(this, function (_g) {
                    switch (_g.label) {
                        case 0:
                            if (!Object.values(IClipType).includes(behavior))
                                return [2 /*return*/, { status: false, message: "动作类型不支持" }];
                            p = this.PMap[id];
                            p.behavior = behavior;
                            _f = p;
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.SkeletonNode.getMixer(p.manNode))];
                        case 1:
                            manMixer = _f.manMixer = _g.sent();
                            if (!manMixer)
                                return [2 /*return*/, { status: false, message: "人物模型动画创建失败" }];
                            if (!(behavior == IClipType.stop && p.nowAction)) return [3 /*break*/, 3];
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.AnimationAction.stopActions(manMixer))];
                        case 2:
                            _g.sent();
                            return [3 /*break*/, 9];
                        case 3:
                            outAction = p.nowAction;
                            return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.AnimationAction.clipAction(manMixer, behavior))];
                        case 4:
                            inAction = _g.sent();
                            if (!!outAction) return [3 /*break*/, 6];
                            return [4 /*yield*/, ((_d = this.player.Native) === null || _d === void 0 ? void 0 : _d.AnimationAction.play(inAction))];
                        case 5:
                            _g.sent();
                            return [3 /*break*/, 8];
                        case 6: return [4 /*yield*/, ((_e = this.player.Native) === null || _e === void 0 ? void 0 : _e.AnimationAction.crossFadeFrom(inAction, outAction, duration ? duration : 0.3, true))];
                        case 7:
                            _g.sent();
                            _g.label = 8;
                        case 8:
                            p.nowAction = inAction;
                            _g.label = 9;
                        case 9: return [2 /*return*/, { status: true }];
                    }
                });
            });
        };
        SkeletonNode.prototype.batchInitAction = function (options) {
            return __awaiter$1(this, void 0, void 0, function () {
                var manNodes, i, option, id, behavior, p;
                return __generator$1(this, function (_a) {
                    manNodes = [];
                    for (i = 0; i < options.length; i++) {
                        option = options[i];
                        id = option.id, behavior = option.behavior;
                        p = this.PMap[id];
                        p.behavior = behavior;
                        manNodes.push(p.manNode);
                    }
                    // const manMixers = await this.player.Native?.SkeletonNode.getMixer(manNodes)
                    //   const inAction = await this.player.Native?.AnimationAction.clipAction(
                    //     manMixer,
                    //     behavior
                    //   );
                    //   await this.player.Native?.AnimationAction.play(inAction)
                    //   p.nowAction = inAction
                    return [2 /*return*/, { status: true }];
                });
            });
        };
        /**
         * @description 销毁人物模型
         * @param {string | number | Array<string | number>} ids
         * @returns
         */
        SkeletonNode.prototype.destroySkeletonNode = function (ids) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var noIds, markerId, nodes, res;
                var _this = this;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!Array.isArray(ids)) {
                                ids = [ids];
                            }
                            noIds = [];
                            markerId = [];
                            nodes = ids.map(function (id) {
                                if (_this.PMap[id] && _this.PMap[id].manNode) {
                                    markerId.push(_this.PMap[id].markerId);
                                    return _this.PMap[id].manNode;
                                }
                                else {
                                    noIds.push(id);
                                    return null;
                                }
                            });
                            if (noIds.length)
                                return [2 /*return*/, { status: false, message: "id\u4E3A".concat(noIds.toString(), "\u4EBA\u7269\u6A21\u578B\u4E0D\u5B58\u5728") }];
                            (_a = this.markerInstance) === null || _a === void 0 ? void 0 : _a.destroyMarker(markerId);
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Node.destroy(nodes))];
                        case 1:
                            res = _c.sent();
                            ids.forEach(function (id) {
                                delete _this.PMap[id];
                            });
                            return [2 /*return*/, { status: res }];
                    }
                });
            });
        };
        /**
         * 销毁所有人员模型
         * @returns
         */
        SkeletonNode.prototype.destroyAllSkeletonNode = function () {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var markerId, nodes, res;
                var _this = this;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            markerId = [];
                            nodes = Object.keys(this.PMap).map(function (id) {
                                var node = _this.PMap[id].manNode;
                                markerId.push(_this.PMap[id].markerId);
                                delete _this.PMap[id];
                                return node;
                            });
                            (_a = this.markerInstance) === null || _a === void 0 ? void 0 : _a.destroyMarker(markerId);
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Node.destroy(nodes))];
                        case 1:
                            res = _c.sent();
                            return [2 /*return*/, { status: res }];
                    }
                });
            });
        };
        /**
         * @description 设置人物模型显示、隐藏
         * @param { string | number | Array<string | number>}id
         * @param {Boolean} visible
         * @returns
         */
        SkeletonNode.prototype.setSkeletonNodeVisible = function (ids, visible) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var noIds, nodes;
                var _this = this;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!Array.isArray(ids)) {
                                ids = [ids];
                            }
                            noIds = [];
                            nodes = ids.map(function (id) {
                                if (_this.PMap[id] && _this.PMap[id].manNode) {
                                    _this.PMap[id].property.visible = visible;
                                    return _this.PMap[id].manNode;
                                }
                                else {
                                    noIds.push(id);
                                    return null;
                                }
                            });
                            if (noIds.length)
                                return [2 /*return*/, { status: false, message: "id\u4E3A".concat(noIds.toString(), "\u4EBA\u7269\u6A21\u578B\u4E0D\u5B58\u5728") }];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.setProperty(nodes, { visible: visible }))];
                        case 1:
                            _b.sent();
                            return [2 /*return*/, { status: true }];
                    }
                });
            });
        };
        /**
         * @description 更新人物模型标签
         * @param {Array<IMarkerOption> | IMarkerOption} options
         * @returns
         */
        SkeletonNode.prototype.updateSkeletonNodeMarker = function (options) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var isNo, markerOptions, result;
                var _this = this;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!Array.isArray(options)) {
                                options = [options];
                            }
                            isNo = [];
                            markerOptions = options.map(function (item) {
                                if (_this.PMap[item.id]) {
                                    item.markerOption.id = _this.PMap[item.id].markerId;
                                    item.markerOption.pos = item.markerOption.pos || [0, 0, 1.8];
                                }
                                else {
                                    isNo.push(item.id);
                                }
                                return item.markerOption;
                            });
                            if (isNo.length > 0) {
                                console.warn("marker ".concat(isNo.join(','), " is not exist"));
                            }
                            return [4 /*yield*/, ((_a = this.markerInstance) === null || _a === void 0 ? void 0 : _a.updateBySingleLine(markerOptions))];
                        case 1:
                            result = _b.sent();
                            if (!(result === null || result === void 0 ? void 0 : result.status))
                                return [2 /*return*/, { status: false, message: result === null || result === void 0 ? void 0 : result.message }];
                            return [2 /*return*/, { status: true }];
                    }
                });
            });
        };
        /**
         * @description 设置视角跟随
         * @param {IPerspectiveOption} option
         * @returns
         */
        SkeletonNode.prototype.setPerspectiveFollow = function (option) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            return __awaiter$1(this, void 0, void 0, function () {
                var parent, localTrans, _l, _m, _o;
                return __generator$1(this, function (_p) {
                    switch (_p.label) {
                        case 0:
                            parent = (_a = this.PMap[option.id]) === null || _a === void 0 ? void 0 : _a.manNode;
                            if (!parent)
                                return [2 /*return*/, { status: false, message: "id为" + option.id + "的模型不存在" }
                                    // 显示上一次隐藏的父节点
                                ];
                            if (!(this.aboutFollow.isHideParent && option.personalPerspective != PersonalPerspective$1.first)) return [3 /*break*/, 2];
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Node.setProperty([
                                    { node: parent, props: { visible: true } },
                                ]))];
                        case 1:
                            _p.sent();
                            _p.label = 2;
                        case 2:
                            this.aboutFollow.parent = parent;
                            (_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.Camera.setCameraFixedTarget(true); //设置固定目标
                            localTrans = (option === null || option === void 0 ? void 0 : option.offset) || [-2, 0, 2];
                            option.targetPosOffset = (option === null || option === void 0 ? void 0 : option.targetPosOffset) || [0, 0, 1.7];
                            _l = option.personalPerspective;
                            switch (_l) {
                                case PersonalPerspective$1.first: return [3 /*break*/, 3];
                                case PersonalPerspective$1.second: return [3 /*break*/, 5];
                                case PersonalPerspective$1.third: return [3 /*break*/, 6];
                            }
                            return [3 /*break*/, 7];
                        case 3:
                            // option.targetPosOffset = [0, 0, 1.7];
                            localTrans = [option.targetPosOffset[0], option.targetPosOffset[1] + 0.01, option.targetPosOffset[2]];
                            return [4 /*yield*/, ((_d = this.player.Native) === null || _d === void 0 ? void 0 : _d.Node.setProperty([
                                    { node: parent, props: { visible: false } },
                                ]))];
                        case 4:
                            _p.sent();
                            this.aboutFollow.isHideParent = parent;
                            return [3 /*break*/, 8];
                        case 5:
                            (_e = this.player.Native) === null || _e === void 0 ? void 0 : _e.Camera.setCameraFollowRotation(true);
                            return [3 /*break*/, 8];
                        case 6:
                            (_f = this.player.Native) === null || _f === void 0 ? void 0 : _f.Camera.setCameraFollowRotation(false);
                            return [3 /*break*/, 8];
                        case 7:
                            (_g = this.player.Native) === null || _g === void 0 ? void 0 : _g.Camera.setCameraFollowRotation(true);
                            _p.label = 8;
                        case 8:
                            //获取相机节点并放到父节点下
                            _m = this.aboutFollow;
                            _o = this.aboutFollow.cameraNode;
                            if (_o) return [3 /*break*/, 10];
                            return [4 /*yield*/, ((_h = this.player.Native) === null || _h === void 0 ? void 0 : _h.AnimationMixer.getCameraNode())];
                        case 9:
                            _o = (_p.sent());
                            _p.label = 10;
                        case 10:
                            //获取相机节点并放到父节点下
                            _m.cameraNode = _o;
                            return [4 /*yield*/, ((_j = this.player.Native) === null || _j === void 0 ? void 0 : _j.Node.setProperty([
                                    { node: this.aboutFollow.cameraNode, props: { parent: parent, localTrans: localTrans } },
                                ]))
                                // 设置相机目标点偏移
                            ];
                        case 11:
                            _p.sent();
                            // 设置相机目标点偏移
                            return [4 /*yield*/, ((_k = this.player.Native) === null || _k === void 0 ? void 0 : _k.Camera.setCameraFixedTargetOffset(option.targetPosOffset))];
                        case 12:
                            // 设置相机目标点偏移
                            _p.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * @description 取消视角跟随
         * @returns
         */
        SkeletonNode.prototype.cancelPerspectiveFollow = function () {
            var _a, _b, _c;
            return __awaiter$1(this, void 0, void 0, function () {
                var info;
                return __generator$1(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (!this.aboutFollow.parent)
                                return [2 /*return*/];
                            this.aboutFollow.parent = 0;
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Camera.currentParam())];
                        case 1:
                            info = _d.sent();
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Node.setProperty(this.aboutFollow.cameraNode, { parent: 0, localTrans: info.localTrans, localRot: info.localRot }))];
                        case 2:
                            _d.sent();
                            (_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.Camera.setCameraFixedTarget(false);
                            return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * @description 获取信息
         * @param ids
         * @returns
         */
        SkeletonNode.prototype.getInfo = function (ids) {
            var _this = this;
            if (!Array.isArray(ids)) {
                ids = [ids];
            }
            var status = true;
            var returnData = ids.map(function (id) {
                if (!_this.PMap[id])
                    status = false;
                return _this.PMap[id] || "id".concat(id, "\u4E0D\u5B58\u5728");
            });
            return { status: status, data: returnData };
        };
        /**
         * 设置人员的朝向
         * @param id 人员id
         * @param towards 人员朝向的角度
      
         */
        SkeletonNode.prototype.setSkeletonNodeAngle = function (id, towards) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var result, localRot, nodes;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.getInfo(id)];
                        case 1:
                            result = _b.sent();
                            localRot = EulerAngle.toQuat([0, 0, towards]);
                            nodes = result.data.map(function (item) {
                                return item.manNode;
                            });
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.setProperty(nodes, { localRot: localRot }))];
                        case 2:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        // 计算两个点A、B之间的距离、方向向量、以及转到该向量的四元数
        SkeletonNode.prototype.getLineInfo = function (A, B, towards, onlyXY, quat) {
            if (towards === void 0) { towards = [1, 0, 0]; }
            if (onlyXY === void 0) { onlyXY = true; }
            // 计算方向向量AB
            var vecAB = [B[0] - A[0], B[1] - A[1], B[2] - A[2]];
            if (quat) {
                vecAB = this.getOriginalVector(vecAB, quat);
            }
            else {
                quat = [1, 0, 0, 0];
            }
            // 计算向量长度
            var lengthAB = Math.sqrt(Math.pow(vecAB[0], 2) + Math.pow(vecAB[1], 2) + Math.pow(vecAB[2], 2));
            // 处理零向量情况（A和B重合）
            if (lengthAB < 1e-6) {
                return {
                    length: lengthAB,
                    quat: quat
                }; // 返回单位四元数
            }
            // 归一化目标向量
            var v = [vecAB[0] / lengthAB, vecAB[1] / lengthAB, vecAB[2] / lengthAB];
            if (onlyXY)
                v[2] = 0;
            // 原始向量 towards
            var u = towards;
            // 计算点积和叉积
            var dot = u[0] * v[0] + u[1] * v[1] + u[2] * v[2];
            var axis = [
                u[1] * v[2] - u[2] * v[1],
                u[2] * v[0] - u[0] * v[2],
                u[0] * v[1] - u[1] * v[0]
            ];
            // 计算叉积长度
            var axisLength = Math.sqrt(Math.pow(axis[0], 2) + Math.pow(axis[1], 2) + Math.pow(axis[2], 2));
            // 处理平行向量（包括同向和反向）
            if (axisLength < 1e-6) {
                if (Math.abs(dot - 1) < 1e-6) { // 同向
                    return {
                        length: lengthAB,
                        quat: quat // 只需要up旋转
                    };
                }
                else if (Math.abs(dot + 1) < 1e-6) { // 反向
                    // 构造180度旋转四元数，并与up旋转组合
                    var reverseQuat = [0, 0, 0, 1];
                    var combinedQuat = this.multiplyQuaternions(quat, reverseQuat);
                    return {
                        length: lengthAB,
                        quat: combinedQuat
                    };
                }
            }
            // 归一化旋转轴
            var axisNormalized = [
                axis[0] / axisLength,
                axis[1] / axisLength,
                axis[2] / axisLength
            ];
            // 计算旋转角度
            var theta = Math.acos(dot);
            var halfTheta = theta / 2;
            // 构造四元数
            var directionQuat = [
                Math.cos(halfTheta),
                axisNormalized[0] * Math.sin(halfTheta),
                axisNormalized[1] * Math.sin(halfTheta),
                axisNormalized[2] * Math.sin(halfTheta)
            ];
            var finalQuat = this.multiplyQuaternions(quat, directionQuat);
            return {
                length: lengthAB,
                direction: v,
                quat: finalQuat
            };
        };
        /**
       * 根据经纬度计算up方向向量
       * @param latitude 纬度（度） -90到90度
       * @param longitude 经度（度） -180到180度
       * @returns up方向向量 [x, y, z]
       */
        SkeletonNode.prototype.getUpDirectionFromLatLng = function (longitude, latitude) {
            // 将角度转换为弧度
            var latRad = latitude * Math.PI / 180;
            var lonRad = longitude * Math.PI / 180;
            // 计算笛卡尔坐标
            var x = Math.cos(latRad) * Math.cos(lonRad);
            var y = Math.cos(latRad) * Math.sin(lonRad);
            var z = Math.sin(latRad);
            return [x, y, z];
        };
        /**
       * 根据旋转后的向量和旋转四元数，求旋转前的向量
       * @param rotatedVector 旋转后的向量A
       * @param quaternion 旋转四元数
       * @returns 旋转前的向量B
       */
        SkeletonNode.prototype.getOriginalVector = function (rotatedVector, quaternion) {
            // 计算四元数的逆
            var inverseQuaternion = this.inverseQuaternion(quaternion);
            // 将向量转换为纯四元数 (0, x, y, z)
            var vectorQuaternion = [0, rotatedVector[0], rotatedVector[1], rotatedVector[2]];
            // 执行逆旋转: B = quat^-1 * A * quat
            var result = this.multiplyQuaternions(this.multiplyQuaternions(inverseQuaternion, vectorQuaternion), quaternion);
            // 返回向量部分
            return [result[1], result[2], result[3]];
        };
        /**
         * 计算四元数的逆
         * @param quat 四元数 [w, x, y, z]
         * @returns 四元数的逆
         */
        SkeletonNode.prototype.inverseQuaternion = function (quat) {
            var normSquared = quat[0] * quat[0] + quat[1] * quat[1] + quat[2] * quat[2] + quat[3] * quat[3];
            // 如果四元数未标准化，则需要除以模长的平方
            return [
                quat[0] / normSquared,
                -quat[1] / normSquared,
                -quat[2] / normSquared,
                -quat[3] / normSquared // z
            ];
        };
        /**
         * 四元数乘法
         * @param q1 四元数1
         * @param q2 四元数2
         * @returns 相乘后的四元数
         */
        SkeletonNode.prototype.multiplyQuaternions = function (q1, q2) {
            return [
                q1[0] * q2[0] - q1[1] * q2[1] - q1[2] * q2[2] - q1[3] * q2[3],
                q1[0] * q2[1] + q1[1] * q2[0] + q1[2] * q2[3] - q1[3] * q2[2],
                q1[0] * q2[2] - q1[1] * q2[3] + q1[2] * q2[0] + q1[3] * q2[1],
                q1[0] * q2[3] + q1[1] * q2[2] - q1[2] * q2[1] + q1[3] * q2[0] // z
            ];
        };
        SkeletonNode.instance = null;
        return SkeletonNode;
    }(commonAbstractClass));

    var PosViewer = /** @class */ (function (_super) {
        __extends$1(PosViewer, _super);
        function PosViewer(cacheManagement, dispatch) {
            var _this = this;
            var _a;
            _this = _super.call(this, cacheManagement, dispatch) || this;
            _this.action_id_map = {};
            // PosViewer.instance = this;
            // this.createPosViewer = this.batchCreateSkeletonNode
            _this.updatePosViewerMarker = _this.updateSkeletonNodeMarker;
            _this.setPosViewerVisible = _this.setSkeletonNodeVisible;
            _this.destroyPosviewer = _this.destroySkeletonNode;
            _this.destroyAllPosviewer = _this.destroyAllSkeletonNode;
            _this.getPosViewerInfo = _this.getInfo;
            _this.dealMarker = function (res) {
                if (res.type === 1) {
                    var data = Object.values(_this.PMap);
                    var target = data.find(function (item) { return (item === null || item === void 0 ? void 0 : item.markerId) === res.markerId; });
                    dispatch.emit("PosViewerMarker", target);
                }
            };
            _this.dispatch.on("Marker", _this.dealMarker);
            //监听动画更新事件 即结束事件
            (_a = _this.player.Native) === null || _a === void 0 ? void 0 : _a.AnimationAction.EventActionUpdate.connect(function (res) {
                var _a, _b;
                if (res.state == 2) {
                    var P = _this.PMap[_this.action_id_map[res.sender]];
                    if (!P)
                        return;
                    P.animation.playing = false;
                    (_a = _this.player.Native) === null || _a === void 0 ? void 0 : _a.AnimationAction.stop(P.animation.action);
                    (_b = _this.player.Native) === null || _b === void 0 ? void 0 : _b.KeyframeTrack.clearTrack(P.animation.clip);
                    // this.updateAction(this.action_id_map[res.sender], IClipType.idle, 0.3)
                }
            });
            return _this;
        }
        PosViewer.prototype.createPosViewer = function (options) {
            var _a, _b, _c;
            return __awaiter$1(this, void 0, void 0, function () {
                var res, nodes, controllers_1;
                return __generator$1(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, this.batchCreateSkeletonNode(options)];
                        case 1:
                            res = _d.sent();
                            if (!res.status) return [3 /*break*/, 3];
                            nodes = (_a = res.data) === null || _a === void 0 ? void 0 : _a.map(function (p) { return p.nodeInstance.manNode; });
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.AvatarLocation.createAvatarLocationController(nodes))];
                        case 2:
                            controllers_1 = _d.sent();
                            (_c = res.data) === null || _c === void 0 ? void 0 : _c.forEach(function (e, i) {
                                e.nodeInstance.controller = controllers_1[i];
                            });
                            _d.label = 3;
                        case 3: return [2 /*return*/, res];
                    }
                });
            });
        };
        /**
         * @description 设置全部实时人员显示、隐藏
         * @param {Boolean} visible
         * @returns
         */
        PosViewer.prototype.setAllPosViewerVisible = function (visible) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var nodes;
                var _this = this;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            nodes = Object.keys(this.PMap).map(function (id) {
                                _this.PMap[id].property.visible = visible;
                                return _this.PMap[id].manNode;
                            });
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.setProperty(nodes, { visible: visible }))];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        /**
           * @description 获取所有实时人员信息
           * @returns
           */
        PosViewer.prototype.getAllInfo = function () {
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_a) {
                    return [2 /*return*/, {
                            status: true,
                            data: this.PMap,
                        }];
                });
            });
        };
        /**
         * @description 设置人物位置（可批量设置）
         * @param {IPosviewerPosition|Array<IPosviewerPosition>} options
         * @param {number} dataFrequency
         * @returns
         */
        PosViewer.prototype.setPosition = function (options, dataFrequency) {
            var _a;
            if (dataFrequency === void 0) { dataFrequency = 1; }
            return __awaiter$1(this, void 0, void 0, function () {
                var params, i, option, id, P;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!Array.isArray(options)) {
                                options = [options];
                            }
                            params = [];
                            for (i = 0; i < options.length; i++) {
                                option = options[i];
                                id = option.id;
                                P = this.PMap[id];
                                if (P) {
                                    P.property.localTrans = option.position;
                                    params.push({
                                        avatarLocationController: P.controller,
                                        time: dataFrequency,
                                        dstPos: option.position
                                    });
                                }
                                else {
                                    return [2 /*return*/, { status: false, message: "id\u4E3A".concat(id, "\u4EBA\u7269\u6A21\u578B\u4E0D\u5B58\u5728") }];
                                }
                            }
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.AvatarLocation.moveToPos(params))];
                        case 1:
                            _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                }];
                    }
                });
            });
        };
        return PosViewer;
    }(SkeletonNode));

    var IRouteType;
    (function (IRouteType) {
        IRouteType["line"] = "line";
        IRouteType["spline"] = "spline";
    })(IRouteType || (IRouteType = {}));
    var PersonalPerspective;
    (function (PersonalPerspective) {
        PersonalPerspective[PersonalPerspective["first"] = 1] = "first";
        PersonalPerspective[PersonalPerspective["second"] = 2] = "second";
        PersonalPerspective[PersonalPerspective["third"] = 3] = "third";
    })(PersonalPerspective || (PersonalPerspective = {}));
    var TargetPosType;
    (function (TargetPosType) {
        TargetPosType[TargetPosType["position"] = 0] = "position";
        TargetPosType[TargetPosType["aabb"] = 1] = "aabb";
    })(TargetPosType || (TargetPosType = {}));
    var IStipplePattern;
    (function (IStipplePattern) {
        IStipplePattern[IStipplePattern["pointline"] = 4369] = "pointline";
        IStipplePattern[IStipplePattern["chainline"] = 10239] = "chainline";
        IStipplePattern[IStipplePattern["centerline"] = 13311] = "centerline";
        IStipplePattern[IStipplePattern["dashedline"] = 16191] = "dashedline";
        IStipplePattern[IStipplePattern["doubledotdash"] = 9471] = "doubledotdash";
        IStipplePattern[IStipplePattern["threedotdash"] = 22015] = "threedotdash";
    })(IStipplePattern || (IStipplePattern = {}));

    var Route = /** @class */ (function (_super) {
        __extends$1(Route, _super);
        function Route(cacheManagement) {
            var _this = _super.call(this) || this;
            _this.player = {};
            _this.defaultRes = { status: false, message: "id不存在" };
            _this.cacheManagement = cacheManagement;
            var player = getPlayerData(cacheManagement);
            if (!player) {
                throw new Error("player未加载");
            }
            _this.player = player;
            Route.instance = _this;
            return _this;
        }
        Route.prototype.destroyInstance = function (routeCache) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Route.destroy(routeCache.pointer))];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * @description 创建路径
         * @param {IBaseOption} option
         * @returns
         */
        Route.prototype.createRoute = function (option) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                function is2DArray(arr) {
                    return Array.isArray(arr) && (arr.length === 0 || arr.every(function (item) { return Array.isArray(item); }));
                }
                var routeId, isExist, props, optionStyle, colorDeal, colorDeal, controlPoints, pointer, routeInstance;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            routeId = option.id || generateUUID();
                            isExist = this.cacheManagement.findCacheById(routeId);
                            //id冲突
                            if (isExist && isExist.type == cacheType.Route) {
                                return [2 /*return*/, { status: false, message: 'ID已存在' }];
                            }
                            props = {
                                depthTest: (_a = option.setDepthTest) !== null && _a !== void 0 ? _a : true,
                            };
                            optionStyle = option.style;
                            if (optionStyle) {
                                if (optionStyle === null || optionStyle === void 0 ? void 0 : optionStyle.pointColor) {
                                    colorDeal = dealColorToNumber(optionStyle.pointColor);
                                    if (!colorDeal.status || !colorDeal.data)
                                        return [2 /*return*/, { status: false, message: colorDeal.message }];
                                    props.pointColor = colorDeal.data;
                                }
                                if (optionStyle.isLineStipple != null && optionStyle.isLineStipple != undefined) {
                                    props.enableLineStipple = optionStyle.isLineStipple;
                                    props.lineStipplePattern = IStipplePattern[optionStyle.pattern] || IStipplePattern.dashedline;
                                    props.lineStippleFactor = optionStyle.factor || 1;
                                }
                                if (optionStyle.lineColor) {
                                    colorDeal = dealColorToNumber(optionStyle.lineColor);
                                    if (!colorDeal.status || !colorDeal.data)
                                        return [2 /*return*/, { status: false, message: colorDeal.message }];
                                    props.lineColor = colorDeal.data;
                                }
                                if (optionStyle.lineWidth) {
                                    props.lineWidth = optionStyle.lineWidth;
                                }
                            }
                            if (option.point) {
                                controlPoints = is2DArray(option.point) ? option.point : [option.point];
                                props = __assign$2(__assign$2({}, props), { controlPoints: controlPoints });
                            }
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Route.create({ type: option.type == IRouteType.spline ? 1 : 0, props: props }))];
                        case 1:
                            pointer = _c.sent();
                            option.id = routeId;
                            routeInstance = new baseWrap({
                                id: routeId,
                                pointer: pointer,
                                routeOption: option,
                                instance: this,
                            }, cacheType.Route);
                            this.cacheManagement.createCache(routeId, routeInstance);
                            return [2 /*return*/, {
                                    status: true,
                                    data: routeId,
                                }];
                    }
                });
            });
        };
        /**
         * @description 追加控制点
         * @param {string|number} id
         * @param {Array<number>|Array<Array<number>>} position
         * @returns
         */
        Route.prototype.appendControlPoint = function (id, positions) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var isExist, isArray;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            isExist = this.getRouteData(id);
                            if (!isExist.status)
                                return [2 /*return*/, { status: false }];
                            //判断是否是数组
                            if (!Array.isArray(positions)) {
                                throw new Error("数据类型错误");
                            }
                            isArray = positions.every(function (item) {
                                return Array.isArray(item);
                            });
                            // 若是一维数组则转为二维
                            if (!isArray) {
                                positions = [positions];
                            }
                            _c.label = 1;
                        case 1:
                            if (!(positions.length > 0)) return [3 /*break*/, 3];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Route.appendControlPoint((_b = isExist.data) === null || _b === void 0 ? void 0 : _b.pointer, positions.splice(0, 1000)))];
                        case 2:
                            _c.sent();
                            return [3 /*break*/, 1];
                        case 3: return [2 /*return*/, {
                                status: true,
                            }];
                    }
                });
            });
        };
        /**
         * @description 设置路径控制点
         * @param {string|number} id
         * @param {Array<number>|Array<Array<number>>} position
         * @returns
         */
        Route.prototype.setControlPoints = function (id, positions) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var isExist, isArray;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            isExist = this.getRouteData(id);
                            if (!isExist.status)
                                return [2 /*return*/, this.defaultRes];
                            //判断是否是数组
                            if (!Array.isArray(positions)) {
                                throw new Error("数据类型错误");
                            }
                            isArray = positions.every(function (item) {
                                return Array.isArray(item);
                            });
                            // 若是一维数组则转为二维
                            if (!isArray) {
                                positions = [positions];
                            }
                            // 分批加载，云渲染添加数据大小限制 
                            // todo 没明白为什么这样做，反而导致无法正确添加超过1000点的数据 我只能注释掉
                            // const positionData = [...positions]
                            // while (positionData.length > 0) {
                            //   await this.player.Native?.Route.setProperty(
                            //     isExist.data?.pointer,
                            //     { controlPoints: positionData.splice(0, 1000) }
                            //   );
                            // }
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Route.setProperty((_b = isExist.data) === null || _b === void 0 ? void 0 : _b.pointer, { controlPoints: positions }))];
                        case 1:
                            // 分批加载，云渲染添加数据大小限制 
                            // todo 没明白为什么这样做，反而导致无法正确添加超过1000点的数据 我只能注释掉
                            // const positionData = [...positions]
                            // while (positionData.length > 0) {
                            //   await this.player.Native?.Route.setProperty(
                            //     isExist.data?.pointer,
                            //     { controlPoints: positionData.splice(0, 1000) }
                            //   );
                            // }
                            _c.sent();
                            return [2 /*return*/, {
                                    status: true,
                                }];
                    }
                });
            });
        };
        /**
         * @description 设置路径线条隐藏、显示
         * @param {string | number} id
         * @param {boolean} visible
         * @returns
         */
        Route.prototype.setLineVisible = function (id, visible) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var isExist;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            isExist = this.getRouteData(id);
                            if (!isExist.status)
                                return [2 /*return*/, this.defaultRes];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Route.setProperty((_b = isExist.data) === null || _b === void 0 ? void 0 : _b.pointer, { lineVisible: visible }))];
                        case 1:
                            _c.sent();
                            return [2 /*return*/, {
                                    status: true,
                                }];
                    }
                });
            });
        };
        /**
         * @description 设置路径线条隐藏、显示
         * @param {string | number} id
         * @param {boolean} visible
         * @returns
         */
        Route.prototype.setPointVisible = function (id, visible) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var isExist;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            isExist = this.getRouteData(id);
                            if (!isExist.status)
                                return [2 /*return*/, this.defaultRes];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Route.setProperty((_b = isExist.data) === null || _b === void 0 ? void 0 : _b.pointer, { pointVisible: visible }))];
                        case 1:
                            _c.sent();
                            return [2 /*return*/, {
                                    status: true,
                                }];
                    }
                });
            });
        };
        /**
         * @description 设置路径隐藏、显示
         * @param {string | number} id
         * @param {boolean} visible
         * @returns
         */
        Route.prototype.setRouteVisible = function (id, visible) {
            return __awaiter$1(this, void 0, void 0, function () {
                var isExist, pointRes, lineRes;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isExist = this.getRouteData(id);
                            if (!isExist.status)
                                return [2 /*return*/, this.defaultRes];
                            return [4 /*yield*/, this.setPointVisible(id, visible)];
                        case 1:
                            pointRes = _a.sent();
                            if (!pointRes.status)
                                return [2 /*return*/, pointRes];
                            return [4 /*yield*/, this.setLineVisible(id, visible)];
                        case 2:
                            lineRes = _a.sent();
                            if (!lineRes.status)
                                return [2 /*return*/, lineRes];
                            return [2 /*return*/, { status: true }];
                    }
                });
            });
        };
        /**
         * @description 销毁路径
         * @param { string | number|Array<string | number> } ids
         * @returns
         */
        Route.prototype.destroyRoute = function (ids) {
            return __awaiter$1(this, void 0, void 0, function () {
                var routeList, list, i, pointerItem;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!Array.isArray(ids)) {
                                ids = [ids];
                            }
                            routeList = this.cacheManagement.findCacheByType(cacheType.Route);
                            if (routeList.length == 0)
                                return [2 /*return*/, { status: true }];
                            list = routeList.filter(function (item) {
                                var isExist = ids.includes(item.id);
                                return isExist;
                            });
                            if (list.length == 0) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "id\u4E3A".concat(ids, "\u8DEF\u5F84\u4E0D\u5B58\u5728"),
                                    }];
                            }
                            i = 0;
                            _a.label = 1;
                        case 1:
                            if (!(i < list.length)) return [3 /*break*/, 4];
                            pointerItem = list[i];
                            return [4 /*yield*/, this.cacheManagement.deleteCache(pointerItem.instance)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/, {
                                status: true,
                            }];
                    }
                });
            });
        };
        /**
         * @description 清空路径对象
         * @returns
         */
        Route.prototype.clearRoute = function () {
            return __awaiter$1(this, void 0, void 0, function () {
                var routeList, i, pointerItem;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            routeList = this.cacheManagement.findCacheByType(cacheType.Route);
                            if (routeList.length == 0)
                                return [2 /*return*/, { status: true }];
                            i = 0;
                            _a.label = 1;
                        case 1:
                            if (!(i < routeList.length)) return [3 /*break*/, 4];
                            pointerItem = routeList[i];
                            return [4 /*yield*/, this.cacheManagement.deleteCache(pointerItem.instance)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/, {
                                status: true,
                            }];
                    }
                });
            });
        };
        /**
         * @description 清空路径控制点
         * @param {string|number} id
         * @returns
         */
        Route.prototype.clearControlPoint = function (id) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var isExist;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            isExist = this.getRouteData(id);
                            if (!isExist.status)
                                return [2 /*return*/, this.defaultRes];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Route.clearControlPoint((_b = isExist.data) === null || _b === void 0 ? void 0 : _b.pointer))];
                        case 1:
                            _c.sent();
                            return [2 /*return*/, { status: true }];
                    }
                });
            });
        };
        /**
         * @description 获取路径下控制点的数量
         * @param {string|number} id
         * @returns
         */
        Route.prototype.controlPointCount = function (id) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var isExist, count;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            isExist = this.getRouteData(id);
                            if (!isExist.status)
                                return [2 /*return*/, this.defaultRes];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Route.controlPointCount((_b = isExist.data) === null || _b === void 0 ? void 0 : _b.pointer))];
                        case 1:
                            count = _c.sent();
                            return [2 /*return*/, { status: true, data: count }];
                    }
                });
            });
        };
        /**
         * @description 获取路径下的所有控制点
         * @param {string|number} id
         * @returns
         */
        Route.prototype.controlPoints = function (id) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var isExist, points;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            isExist = this.getRouteData(id);
                            if (!isExist.status)
                                return [2 /*return*/, this.defaultRes];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Route.getProperty((_b = isExist.data) === null || _b === void 0 ? void 0 : _b.pointer, ["controlPoints"]))];
                        case 1:
                            points = _c.sent();
                            return [2 /*return*/, { status: true, data: points }];
                    }
                });
            });
        };
        /**
         * @description 设置线条样式
         * @param {string|number} id
         * @param {ILineStyle} option
         * @returns
         */
        Route.prototype.setLineStyle = function (id, option) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var isExist, props, colorDeal;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            isExist = this.getRouteData(id);
                            if (!isExist.status)
                                return [2 /*return*/, this.defaultRes];
                            props = {};
                            if (option.lineColor) {
                                colorDeal = dealColorToNumber(option.lineColor);
                                if (!colorDeal.status || !colorDeal.data)
                                    return [2 /*return*/, { status: false, message: colorDeal.message }];
                                // await this.player.Native?.Route.setProperty(
                                //   isExist.data?.pointer,
                                //   { lineColor: colorDeal.data }
                                // );
                                props.lineColor = colorDeal.data;
                            }
                            if (option.lineWidth) {
                                // await this.player.Native?.Route.setProperty(
                                //   isExist.data?.pointer,
                                //   { lineWidth: option.lineWidth }
                                // );
                                props.lineWidth = option.lineWidth;
                            }
                            if (option.isLineStipple != null && option.isLineStipple != undefined) {
                                // const res = await this.setLineStipple(
                                //   id,
                                //   option.isLineStipple,
                                //   option.pattern || "",
                                //   option.factor
                                // );
                                // if (!res.status) return res;
                                // props.lineStipple = {
                                //   isLineStipple: option.isLineStipple,
                                //   pattern: IStipplePattern[option.pattern as stipplePatternType] || IStipplePattern.dashedline,
                                //   factor: option.factor || 1
                                // }
                                props.enableLineStipple = option.isLineStipple;
                                props.lineStipplePattern = IStipplePattern[option.pattern] || IStipplePattern.dashedline;
                                props.lineStippleFactor = option.factor || 1;
                            }
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Route.setProperty((_b = isExist.data) === null || _b === void 0 ? void 0 : _b.pointer, props))];
                        case 1:
                            _c.sent();
                            return [2 /*return*/, { status: true }];
                    }
                });
            });
        };
        /**
         * @description 设置路径控制点颜色
         * @param {string|number} id
         * @param {string} color
         * @returns
         */
        Route.prototype.setPointColor = function (id, color) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var isExist, colorDeal;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            isExist = this.getRouteData(id);
                            if (!isExist.status)
                                return [2 /*return*/, this.defaultRes];
                            colorDeal = dealColorToNumber(color);
                            if (!colorDeal.status)
                                return [2 /*return*/, { status: false, message: colorDeal.message }];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Route.setProperty((_b = isExist.data) === null || _b === void 0 ? void 0 : _b.pointer, { pointColor: colorDeal.data }))];
                        case 1:
                            _c.sent();
                            return [2 /*return*/, { status: true }];
                    }
                });
            });
        };
        Route.prototype.setLineStipple = function (id, isLineStipple, pattern, factor) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var isExist, value;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            isExist = this.getRouteData(id);
                            if (!isExist.status)
                                return [2 /*return*/, this.defaultRes];
                            value = IStipplePattern[pattern] || IStipplePattern.dashedline;
                            if (!value)
                                return [2 /*return*/, { status: false }];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Route.setProperty((_b = isExist.data) === null || _b === void 0 ? void 0 : _b.pointer, {
                                    lineStipple: {
                                        isLineStipple: isLineStipple,
                                        pattern: value,
                                        factor: factor || 1
                                    }
                                }))];
                        case 1:
                            _c.sent();
                            return [2 /*return*/, { status: true }];
                    }
                });
            });
        };
        /**
         * @description 获取全部路径id
         * @returns
         */
        Route.prototype.getAllRoutes = function () {
            var routes = this.cacheManagement.findCacheByType(cacheType.Route);
            var routeIds = routes.map(function (item) {
                return item.id;
            });
            return { status: true, data: routeIds };
        };
        /**
         * @description 用id获取路径详情
         * @param id
         * @returns
         */
        Route.prototype.getRouteData = function (id) {
            var isExist = this.cacheManagement.findCacheById(id);
            if (!isExist || (isExist === null || isExist === void 0 ? void 0 : isExist.type) != cacheType.Route)
                return { status: false, message: "id\u4E3A".concat(id, "\u4E0D\u5B58\u5728") };
            var info = isExist.instance.getDataInfo();
            if (!info)
                throw new Error("id\u4E3A".concat(id, "\u7684\u6570\u636E\u672A\u627E\u5230"));
            return { status: true, data: info };
        };
        Route.instance = null;
        return Route;
    }(commonAbstractClass));

    var EActionState;
    (function (EActionState) {
        /**正在播放 */
        EActionState[EActionState["AS_Running"] = 0] = "AS_Running";
        /**	循环模式下，到达endTime时通知; 只要当前时间到达动画片段的结束时间,就会发出一次此通知; LM_LoopOnce, LM_LoopRepeat模式时会发送此通知 */
        EActionState[EActionState["AS_Loop"] = 1] = "AS_Loop";
        /**非无线循环模式下,播放完成时通知(无限循环不存在Finished状态);LM_LoopOnce, LM_LoopRepeat, LM_LoopPingPong均有可能发送该通知 */
        EActionState[EActionState["AS_Finished"] = 2] = "AS_Finished";
        /**乒乓模式下,时间到达开始时间时通知; LM_LoopPingPong模式时会发送此通知 */
        EActionState[EActionState["AS_LoopPing"] = 3] = "AS_LoopPing";
        /** 乒乓模式下,时间到达开始结束时间时通知; LM_LoopPingPong模式时会发送此通知 */
        EActionState[EActionState["AS_LoopPong"] = 4] = "AS_LoopPong";
        /** 开始时通知(调用play()或者调用了间接调用play()的接口,例如 fadeIn()) */
        EActionState[EActionState["AS_Started"] = 5] = "AS_Started";
        /** 停止时通知(调用stop()或者调用了间接调用stop()的接口,例如 fadeOut()) */
        EActionState[EActionState["AS_Stopped"] = 6] = "AS_Stopped";
        /** 暂停时通知(调用setPause(true)) */
        EActionState[EActionState["AS_Paused"] = 7] = "AS_Paused";
        /** 继续时通知(调用setPause(false)) */
        EActionState[EActionState["AS_Continue"] = 8] = "AS_Continue";
    })(EActionState || (EActionState = {}));
    var EAnimateNodeType;
    (function (EAnimateNodeType) {
        /** 人员 */
        EAnimateNodeType[EAnimateNodeType["person"] = 0] = "person";
        /** 管道 */
        EAnimateNodeType[EAnimateNodeType["pipeline"] = 1] = "pipeline";
        /** 无人机 */
        EAnimateNodeType[EAnimateNodeType["drone"] = 2] = "drone";
    })(EAnimateNodeType || (EAnimateNodeType = {}));
    var EKeyframeState;
    (function (EKeyframeState) {
        EKeyframeState[EKeyframeState["loading"] = 0] = "loading";
        EKeyframeState[EKeyframeState["loaded"] = 1] = "loaded";
    })(EKeyframeState || (EKeyframeState = {}));
    var EAnimationEventType;
    (function (EAnimationEventType) {
        EAnimationEventType[EAnimationEventType["timeChange"] = 0] = "timeChange";
        EAnimationEventType[EAnimationEventType["actionStateChange"] = 1] = "actionStateChange";
        EAnimationEventType[EAnimationEventType["keyframeChange"] = 2] = "keyframeChange";
    })(EAnimationEventType || (EAnimationEventType = {}));
    var ELoopMode;
    (function (ELoopMode) {
        /** 只执行一次 */
        ELoopMode[ELoopMode["LM_LoopOnce"] = 0] = "LM_LoopOnce";
        /** 重复次数为repetitions的值,且每次循环结束时自动回到下一次循环的开始 */
        ELoopMode[ELoopMode["LM_LoopRepeat"] = 1] = "LM_LoopRepeat";
        /** 重复次数为repetitions的值,且特么的就像乒乓球一样在起始点和结束点之间来回循环 */
        ELoopMode[ELoopMode["LM_LoopPingPong"] = 2] = "LM_LoopPingPong";
    })(ELoopMode || (ELoopMode = {}));
    var ETrackType;
    (function (ETrackType) {
        /** 未知类型,预留,动画轨道中不会出现该类型 */
        ETrackType[ETrackType["KFTT_None"] = 0] = "KFTT_None";
        /** double类型 */
        ETrackType[ETrackType["KFTT_Double"] = 1] = "KFTT_Double";
        /** 二维向量(double2)类型 */
        ETrackType[ETrackType["KFTT_Real2"] = 2] = "KFTT_Real2";
        /**三维向量(double3)类型 */
        ETrackType[ETrackType["KFTT_Real3"] = 3] = "KFTT_Real3";
        /**四维向量(double4)类型 */
        ETrackType[ETrackType["KFTT_Real4"] = 4] = "KFTT_Real4";
        /** 四元数(quat<double>)类型 */
        ETrackType[ETrackType["KFTT_Quaternion"] = 5] = "KFTT_Quaternion";
        /** 颜色(Rgba)类型 */
        ETrackType[ETrackType["KFTT_Color"] = 6] = "KFTT_Color";
        /** bool类型 */
        ETrackType[ETrackType["KFTT_Bool"] = 7] = "KFTT_Bool";
        /** 字符串(std::string) 类型 */
        ETrackType[ETrackType["KFTT_String"] = 8] = "KFTT_String";
    })(ETrackType || (ETrackType = {}));
    var EPropertyLinkType;
    (function (EPropertyLinkType) {
        /** 无绑定(或者不希望使用系统的绑定类型) */
        EPropertyLinkType[EPropertyLinkType["APBT_None"] = 0] = "APBT_None";
        /** 位置属性绑定 */
        EPropertyLinkType[EPropertyLinkType["APBT_Translation"] = 1] = "APBT_Translation";
        /** 旋转属性绑定 */
        EPropertyLinkType[EPropertyLinkType["APBT_Rotation"] = 2] = "APBT_Rotation";
        /** 缩放属性绑定 */
        EPropertyLinkType[EPropertyLinkType["APBT_Scaling"] = 3] = "APBT_Scaling";
        /** 可见性属性绑定 */
        EPropertyLinkType[EPropertyLinkType["APBT_Visible"] = 4] = "APBT_Visible";
        /** 颜色属性绑定 */
        EPropertyLinkType[EPropertyLinkType["APBT_Color"] = 5] = "APBT_Color";
        /** UV属性绑定 */
        EPropertyLinkType[EPropertyLinkType["APBT_UV"] = 6] = "APBT_UV";
    })(EPropertyLinkType || (EPropertyLinkType = {}));
    var EInterpolationType;
    (function (EInterpolationType) {
        /** 线性插值 */
        EInterpolationType[EInterpolationType["IT_Linear"] = 0] = "IT_Linear";
        /** 三次插值 */
        EInterpolationType[EInterpolationType["IT_Cubic"] = 1] = "IT_Cubic";
        /** 离散插值,曲线的值保持不变，直到下一个关键帧(比如 BoolKeyframeTrack, StringKeyframeTrack) */
        EInterpolationType[EInterpolationType["IT_Discrete"] = 2] = "IT_Discrete";
    })(EInterpolationType || (EInterpolationType = {}));

    var animation = /** @class */ (function (_super) {
        __extends$1(animation, _super);
        function animation(cacheManagement, dispatch, bindEvent) {
            if (bindEvent === void 0) { bindEvent = false; }
            var _this = this;
            var _a, _b;
            _this = _super.call(this) || this;
            _this.player = {};
            _this.dealMixerChange = null;
            _this.dealActionUpdate = null;
            /** node操作类实例 */
            _this.nodeProxy = null;
            _this.MAXDATALEN = 1000;
            _this.cacheManagement = cacheManagement;
            var player = getPlayerData(cacheManagement);
            if (!player) {
                throw new Error("player未加载");
            }
            var nodeProxy = new NodeProxy(cacheManagement, dispatch);
            if (!nodeProxy) {
                throw new Error("node未加载");
            }
            _this.nodeProxy = nodeProxy;
            _this.player = player;
            _this.dispatch = dispatch;
            animation.instance = _this;
            if (bindEvent) {
                //  动画状态变化监听
                (_a = _this.player.Native) === null || _a === void 0 ? void 0 : _a.AnimationAction.EventActionUpdate.connect(_this.actionUpdate());
                // 混合器时间变化监听
                (_b = _this.player.Native) === null || _b === void 0 ? void 0 : _b.AnimationMixer.EventMixerCurrentTime.connect(_this.mixerTimeChange());
            }
            return _this;
        }
        animation.prototype.destroyInstance = function (param) {
            return __awaiter$1(this, void 0, void 0, function () {
                var nodeCache;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            nodeCache = this.cacheManagement.findCacheById(param.nodePtr);
                            if (!(param && param.animateId && nodeCache && nodeCache.instance)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.clearClip(param.animateId, [(nodeCache.instance)], false)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        /** 混合器时间变化 */
        animation.prototype.mixerTimeChange = function () {
            var _this = this;
            this.dealMixerChange = function (e) {
                var _a, _b;
                // 获取mixer对应的animateId
                var animationTypeList = _this.cacheManagement.findCacheByType(cacheType.Animation);
                // 过滤出当前mixer的数据
                var currentAnimationList = animationTypeList.filter(function (el) {
                    var _a;
                    return e.sender === ((_a = el.instance.getDataInfo()) === null || _a === void 0 ? void 0 : _a.mixer);
                });
                if (currentAnimationList && currentAnimationList.length > 0) {
                    var animateId = (_b = (_a = currentAnimationList[0].instance) === null || _a === void 0 ? void 0 : _a.getDataInfo()) === null || _b === void 0 ? void 0 : _b.animateId;
                    if (animateId) {
                        _this.dispatch.emit('Animation', {
                            type: EAnimationEventType.timeChange,
                            animateId: animateId,
                            time: e.time
                        });
                    }
                }
            };
            return this.dealMixerChange;
        };
        /** 动画变化 */
        animation.prototype.actionUpdate = function () {
            var _this = this;
            this.dealActionUpdate = function (e) {
                var _a, _b, _c, _d;
                // 获取mixer对应的action
                var animationTypeList = _this.cacheManagement.findCacheByType(cacheType.Animation);
                // 过滤出当前action的数据
                var currentNodeList = animationTypeList.filter(function (el) {
                    var _a;
                    return e.sender === ((_a = el.instance.getDataInfo()) === null || _a === void 0 ? void 0 : _a.action);
                });
                if (currentNodeList && currentNodeList.length > 0) {
                    var nodePtr = (_b = (_a = currentNodeList[0].instance) === null || _a === void 0 ? void 0 : _a.getDataInfo()) === null || _b === void 0 ? void 0 : _b.nodePtr;
                    var animateId = (_d = (_c = currentNodeList[0].instance) === null || _c === void 0 ? void 0 : _c.getDataInfo()) === null || _d === void 0 ? void 0 : _d.animateId;
                    if (nodePtr && animateId) {
                        var nodeCache = _this.cacheManagement.findCacheById(nodePtr);
                        if (nodeCache && nodeCache.instance) {
                            _this.dispatch.emit('Animation', {
                                type: EAnimationEventType.actionStateChange,
                                animateId: animateId,
                                node: nodeCache.instance,
                                actionState: e.state
                            });
                        }
                    }
                }
            };
            return this.dealActionUpdate;
        };
        /**
         * 创建node的动画
         * @param animateId 动画id
         * @param nodeList node列表
         * @param trackParam 轨道相关参数
         * @param keyframeData 关键帧数据【二维数据，必须和trackParam相对应】
         * @param options 可选参数
         * @returns
         */
        animation.prototype.loadAnimation = function (animateId, nodeAnimationParams, options) {
            var _a, _b, _c, _d, _e;
            return __awaiter$1(this, void 0, void 0, function () {
                var animateIdCache, nodeList, nodeInfoList, isNullNode, mixer, clipData, loopParams, clipTrackData, clipIndex, clipItem, animationInstance, status_1;
                var _this = this;
                return __generator$1(this, function (_f) {
                    switch (_f.label) {
                        case 0:
                            animateIdCache = this.cacheManagement.findCacheById(animateId);
                            if (animateIdCache) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "".concat(animateId, "\u5DF2\u88AB\u4F7F\u7528\uFF0C\u8BF7\u66F4\u6362\u4E00\u4E2Aid")
                                    }];
                            }
                            nodeList = nodeAnimationParams.map(function (el) {
                                return el.node;
                            });
                            nodeInfoList = nodeList.map(function (el) {
                                var _a;
                                var nodelInfo = (_a = _this.nodeProxy) === null || _a === void 0 ? void 0 : _a.getNodeInfo(el);
                                return nodelInfo;
                            });
                            isNullNode = nodeInfoList.find(function (el) {
                                return !el;
                            });
                            if (isNullNode) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: 'nodeList中含有错误的数据'
                                    }];
                            }
                            // 判断关键帧与轨道是否对应
                            if (nodeAnimationParams.find(function (el) {
                                return el.track.length !== el.keyframeData.length;
                            })) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: 'track与keyframeData的项数不一致'
                                    }];
                            }
                            return [4 /*yield*/, this.createMixer(animateId, (_a = options === null || options === void 0 ? void 0 : options.bindUpdate) !== null && _a !== void 0 ? _a : false)];
                        case 1:
                            mixer = _f.sent();
                            if (!mixer) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "\u7CFB\u7EDF\u9519\u8BEF"
                                    }];
                            }
                            return [4 /*yield*/, this.batchCreateClip(mixer, nodeInfoList, (_b = options === null || options === void 0 ? void 0 : options.bindUpdate) !== null && _b !== void 0 ? _b : false)
                                // 批量设置循环
                            ];
                        case 2:
                            clipData = _f.sent();
                            loopParams = clipData.map(function (el) {
                                var _a, _b;
                                return {
                                    action: el.action,
                                    loopMode: (_a = options === null || options === void 0 ? void 0 : options.loopType) !== null && _a !== void 0 ? _a : ELoopMode.LM_LoopOnce,
                                    repetitions: (_b = options === null || options === void 0 ? void 0 : options.cycle) !== null && _b !== void 0 ? _b : -1
                                };
                            });
                            (_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.AnimationAction.batchSetLoop(loopParams);
                            return [4 /*yield*/, this.batchCreateTrack(nodeInfoList, clipData, nodeAnimationParams)];
                        case 3:
                            clipTrackData = _f.sent();
                            if (clipTrackData) {
                                for (clipIndex = 0; clipIndex < clipTrackData.length; clipIndex++) {
                                    clipItem = clipTrackData[clipIndex];
                                    if (clipItem.clip) {
                                        animationInstance = new baseWrap(__assign$2({ mixer: mixer, animateId: animateId, instance: this }, clipItem), cacheType.Animation);
                                        this.cacheManagement.createCache(clipItem.clip, animationInstance, {
                                            type: cacheType.Animation
                                        });
                                    }
                                }
                            }
                            if (!clipTrackData) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.batchCreateKeyframe(animateId, clipTrackData, nodeAnimationParams)];
                        case 4:
                            status_1 = _f.sent();
                            if (!status_1) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: '部分node的动画已被删除，node已被销毁'
                                    }];
                            }
                            // 批量播放
                            (_d = this.player.Native) === null || _d === void 0 ? void 0 : _d.AnimationAction.batchPlay(clipTrackData.map(function (el) {
                                return el.action;
                            }));
                            _f.label = 5;
                        case 5:
                            // 判断是否需要自动播放
                            if (options === null || options === void 0 ? void 0 : options.autoPlay) {
                                (_e = this.player.Native) === null || _e === void 0 ? void 0 : _e.AnimationMixer.setPause(mixer, false);
                            }
                            return [2 /*return*/, {
                                    status: true
                                }];
                    }
                });
            });
        };
        /**
         * 设置动画的状态
         * @param animateId 动画id
         * @param status 播放状态
         */
        animation.prototype.setAnimationStatus = function (animateId, status) {
            var _a;
            var animateDataInfoList = this.getAnimateData(animateId);
            if (animateDataInfoList && animateDataInfoList.length !== 0) {
                // 设置动画状态
                (_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.AnimationMixer.setPause(animateDataInfoList[0].mixer, !status);
                return {
                    status: true
                };
            }
            return {
                status: false,
                message: '当前animateId无效'
            };
        };
        /**
         * 获取动画的状态
         * @param animateId 动画id
         */
        animation.prototype.getAnimationStatus = function (animateId) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var animateDataInfoList, currentStatus;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            animateDataInfoList = this.getAnimateData(animateId);
                            if (!(animateDataInfoList && animateDataInfoList.length !== 0)) return [3 /*break*/, 2];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.AnimationMixer.isPause(animateDataInfoList[0].mixer))];
                        case 1:
                            currentStatus = _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    data: !currentStatus
                                }];
                        case 2: return [2 /*return*/, {
                                status: false,
                                message: '当前animateId无效'
                            }];
                    }
                });
            });
        };
        /**
         * 快进动画至指定时间
         * @param animateId 动画id
         * @param time 时间
         * @returns
         */
        animation.prototype.setAnimationTime = function (animateId, time) {
            var _a, _b, _c, _d;
            return __awaiter$1(this, void 0, void 0, function () {
                var animateDataInfoList, currentTimeScale, actionList;
                return __generator$1(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            animateDataInfoList = this.getAnimateData(animateId);
                            if (!(animateDataInfoList && animateDataInfoList.length !== 0)) return [3 /*break*/, 3];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.AnimationMixer.timeScale(animateDataInfoList[0].mixer))];
                        case 1:
                            currentTimeScale = (_b = _e.sent()) !== null && _b !== void 0 ? _b : 1;
                            actionList = animateDataInfoList.map(function (item) {
                                return item.action;
                            });
                            return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.AnimationAction.batchPlay(actionList))
                                // 设置动画时间
                            ];
                        case 2:
                            _e.sent();
                            // 设置动画时间
                            (_d = this.player.Native) === null || _d === void 0 ? void 0 : _d.AnimationMixer.setTime(animateDataInfoList[0].mixer, time / currentTimeScale);
                            return [2 /*return*/, {
                                    status: true
                                }];
                        case 3: return [2 /*return*/, {
                                status: false,
                                message: '当前animateId无效'
                            }];
                    }
                });
            });
        };
        /**
         * 获取动画时间
         * @param animateId 动画id
         * @returns
         */
        animation.prototype.getAnimationTime = function (animateId) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var animateDataInfoList, currentTime;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            animateDataInfoList = this.getAnimateData(animateId);
                            if (!(animateDataInfoList && animateDataInfoList.length !== 0)) return [3 /*break*/, 2];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.AnimationMixer.time(animateDataInfoList[0].mixer))];
                        case 1:
                            currentTime = _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    data: currentTime
                                }];
                        case 2: return [2 /*return*/, {
                                status: false,
                                message: '当前animateId无效'
                            }];
                    }
                });
            });
        };
        /**
         * 设置播放速度
         * @param animateId 动画id
         * @param speed 设置的速度
         */
        animation.prototype.setAnimationSpeed = function (animateId, speed) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var animateDataInfoList;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            animateDataInfoList = this.getAnimateData(animateId);
                            if (!(animateDataInfoList && animateDataInfoList.length !== 0)) return [3 /*break*/, 2];
                            // 设置动画时间倍数
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.AnimationMixer.setTimeScale(animateDataInfoList[0].mixer, speed))];
                        case 1:
                            // 设置动画时间倍数
                            _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                }];
                        case 2: return [2 /*return*/, {
                                status: false,
                                message: '当前animateId无效'
                            }];
                    }
                });
            });
        };
        /**
         * 获取播放速度
         * @param animateId 动画id
         */
        animation.prototype.getAnimationSpeed = function (animateId) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var animateDataInfoList, currentSpeed;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            animateDataInfoList = this.getAnimateData(animateId);
                            if (!(animateDataInfoList && animateDataInfoList.length !== 0)) return [3 /*break*/, 2];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.AnimationMixer.timeScale(animateDataInfoList[0].mixer))];
                        case 1:
                            currentSpeed = _b.sent();
                            return [2 /*return*/, {
                                    status: true,
                                    data: currentSpeed
                                }];
                        case 2: return [2 /*return*/, {
                                status: false,
                                message: '当前animateId无效'
                            }];
                    }
                });
            });
        };
        /**
         * 追加关键帧
         * @param animateId 动画id
         * @param keyframeData 关键帧数据
         * @returns
         */
        animation.prototype.appendKeyframe = function (animateId, nodeAnimationParams) {
            return __awaiter$1(this, void 0, void 0, function () {
                var animateDataInfoList, animateControl, nodeInfoList, isNullNode, createKeyframeStatus;
                var _this = this;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            animateDataInfoList = this.getAnimateData(animateId);
                            animateControl = animateDataInfoList.map(function (el) {
                                return {
                                    clip: el.clip,
                                    action: el.action,
                                    track: el.track,
                                    nodePtr: el.nodePtr
                                };
                            });
                            if (animateControl.length === 0) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: '当前animateId无效'
                                    }];
                            }
                            nodeInfoList = nodeAnimationParams.map(function (el) {
                                var _a;
                                var nodelInfo = (_a = _this.nodeProxy) === null || _a === void 0 ? void 0 : _a.getNodeInfo(el.node);
                                return nodelInfo;
                            });
                            isNullNode = nodeInfoList.find(function (el) {
                                return !el;
                            });
                            if (isNullNode) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: 'nodeList中含有错误的数据'
                                    }];
                            }
                            return [4 /*yield*/, this.batchCreateKeyframe(animateId, animateControl, nodeAnimationParams)];
                        case 1:
                            createKeyframeStatus = _a.sent();
                            return [2 /*return*/, {
                                    status: createKeyframeStatus,
                                    message: createKeyframeStatus ? '' : '部分node的动画已被删除，node已被销毁'
                                }];
                    }
                });
            });
        };
        /**
         *  清除指定node的关键帧
         * @param animateId 动画id
         * @param nodeList node节点
         */
        animation.prototype.clearKeyframe = function (animateId, nodeList) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var nodeInfoList, isNullNode, animateDataInfoList, _loop_1, this_1, nodeIndex, state_1;
                var _this = this;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            nodeInfoList = nodeList.map(function (el) {
                                var _a;
                                var nodelInfo = (_a = _this.nodeProxy) === null || _a === void 0 ? void 0 : _a.getNodeInfo(el);
                                return nodelInfo;
                            });
                            isNullNode = nodeInfoList.find(function (el) {
                                return !el;
                            });
                            if (isNullNode) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: 'nodeList中含有错误的数据'
                                    }];
                            }
                            animateDataInfoList = this.getAnimateData(animateId);
                            _loop_1 = function (nodeIndex) {
                                var nodeItem, currentAnimateData, trackIndex, trackItem;
                                return __generator$1(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            nodeItem = nodeInfoList[nodeIndex];
                                            currentAnimateData = animateDataInfoList === null || animateDataInfoList === void 0 ? void 0 : animateDataInfoList.find(function (animatieItem) {
                                                return (animatieItem === null || animatieItem === void 0 ? void 0 : animatieItem.nodePtr) === (nodeItem === null || nodeItem === void 0 ? void 0 : nodeItem.node);
                                            });
                                            if (!currentAnimateData || !currentAnimateData.track) {
                                                return [2 /*return*/, { value: {
                                                            status: false,
                                                            message: 'nodeList中含有未创建动画的数据'
                                                        } }];
                                            }
                                            trackIndex = 0;
                                            _c.label = 1;
                                        case 1:
                                            if (!(trackIndex < currentAnimateData.track.length)) return [3 /*break*/, 4];
                                            trackItem = currentAnimateData.track[trackIndex];
                                            return [4 /*yield*/, ((_a = this_1.player.Native) === null || _a === void 0 ? void 0 : _a.KeyframeTrack.keyClear(trackItem))];
                                        case 2:
                                            _c.sent();
                                            _c.label = 3;
                                        case 3:
                                            trackIndex++;
                                            return [3 /*break*/, 1];
                                        case 4: return [2 /*return*/, { value: {
                                                    status: true,
                                                } }];
                                    }
                                });
                            };
                            this_1 = this;
                            nodeIndex = 0;
                            _b.label = 1;
                        case 1:
                            if (!(nodeIndex < nodeInfoList.length)) return [3 /*break*/, 4];
                            return [5 /*yield**/, _loop_1(nodeIndex)];
                        case 2:
                            state_1 = _b.sent();
                            if (typeof state_1 === "object")
                                return [2 /*return*/, state_1.value];
                            _b.label = 3;
                        case 3:
                            nodeIndex++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/, {
                                status: false,
                                message: '当前animateId无效'
                            }];
                    }
                });
            });
        };
        /**
         * 清除所有的关键帧
         * @param animateId 动画id
         * @returns
         */
        animation.prototype.clearAllKeyframe = function (animateId) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var animateDataInfoList, i, animateItem, trackIndex, trackItem;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            animateDataInfoList = this.getAnimateData(animateId);
                            i = 0;
                            _b.label = 1;
                        case 1:
                            if (!(i < animateDataInfoList.length)) return [3 /*break*/, 7];
                            animateItem = animateDataInfoList[i];
                            if (!(animateItem && animateItem.track)) return [3 /*break*/, 6];
                            trackIndex = 0;
                            _b.label = 2;
                        case 2:
                            if (!(trackIndex < animateItem.track.length)) return [3 /*break*/, 5];
                            trackItem = animateItem.track[trackIndex];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.KeyframeTrack.keyClear(trackItem))];
                        case 3:
                            _b.sent();
                            _b.label = 4;
                        case 4:
                            trackIndex++;
                            return [3 /*break*/, 2];
                        case 5: return [2 /*return*/, {
                                status: true,
                            }];
                        case 6:
                            i++;
                            return [3 /*break*/, 1];
                        case 7: return [2 /*return*/, {
                                status: false,
                                message: '当前animateId无效'
                            }];
                    }
                });
            });
        };
        /**
         * 清除node动画
         * @param animateId 动画id
         * @param nodeList node节点列表
         * @returns
         */
        animation.prototype.clearClip = function (animateId, nodeList, updateCache) {
            var _a, _b;
            if (updateCache === void 0) { updateCache = true; }
            return __awaiter$1(this, void 0, void 0, function () {
                var nodeInfoList, isNullNode, mixer, animateDataInfoList, _loop_2, this_2, nodeIndex, state_2, animateDataInfoListAfter;
                var _this = this;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            nodeInfoList = nodeList.map(function (el) {
                                var _a;
                                var nodelInfo = (_a = _this.nodeProxy) === null || _a === void 0 ? void 0 : _a.getNodeInfo(el);
                                return nodelInfo;
                            });
                            isNullNode = nodeInfoList.find(function (el) {
                                return !el;
                            });
                            if (isNullNode) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: 'nodeList中含有错误的数据'
                                    }];
                            }
                            mixer = null;
                            animateDataInfoList = this.getAnimateData(animateId);
                            if (animateDataInfoList.length === 0) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "".concat(animateId, "\u6CA1\u6709\u7ED1\u5B9Anode\u52A8\u753B")
                                    }];
                            }
                            _loop_2 = function (nodeIndex) {
                                var nodeItem, currentAnimateData;
                                return __generator$1(this, function (_d) {
                                    switch (_d.label) {
                                        case 0:
                                            nodeItem = nodeInfoList[nodeIndex];
                                            currentAnimateData = animateDataInfoList === null || animateDataInfoList === void 0 ? void 0 : animateDataInfoList.find(function (animatieItem) {
                                                return (animatieItem === null || animatieItem === void 0 ? void 0 : animatieItem.nodePtr) === (nodeItem === null || nodeItem === void 0 ? void 0 : nodeItem.node);
                                            });
                                            if (!currentAnimateData || !currentAnimateData.clip || !currentAnimateData.mixer) {
                                                return [2 /*return*/, { value: {
                                                            status: false,
                                                            message: 'nodeList中含有未创建动画的数据'
                                                        } }];
                                            }
                                            mixer = currentAnimateData.mixer;
                                            return [4 /*yield*/, ((_a = this_2.player.Native) === null || _a === void 0 ? void 0 : _a.AnimationClip.removeClip(currentAnimateData.mixer, currentAnimateData.clip))
                                                // 更新缓存数据
                                            ];
                                        case 1:
                                            _d.sent();
                                            if (!updateCache) return [3 /*break*/, 3];
                                            return [4 /*yield*/, this_2.cacheManagement.deleteCacheById(currentAnimateData.clip)];
                                        case 2:
                                            _d.sent();
                                            _d.label = 3;
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            };
                            this_2 = this;
                            nodeIndex = 0;
                            _c.label = 1;
                        case 1:
                            if (!(nodeIndex < nodeInfoList.length)) return [3 /*break*/, 4];
                            return [5 /*yield**/, _loop_2(nodeIndex)];
                        case 2:
                            state_2 = _c.sent();
                            if (typeof state_2 === "object")
                                return [2 /*return*/, state_2.value];
                            _c.label = 3;
                        case 3:
                            nodeIndex++;
                            return [3 /*break*/, 1];
                        case 4:
                            animateDataInfoListAfter = this.getAnimateData(animateId);
                            if (!(animateDataInfoListAfter.length === 0 && mixer)) return [3 /*break*/, 6];
                            // 销毁mixer
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.AnimationMixer.removeMixer(mixer))];
                        case 5:
                            // 销毁mixer
                            _c.sent();
                            _c.label = 6;
                        case 6: return [2 /*return*/, {
                                status: true
                            }];
                    }
                });
            });
        };
        /**
         * 清除所有的动画
         * @param animateId 动画id
         */
        animation.prototype.clearAllClip = function (animateId) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var animateDataInfoList, i, element;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            animateDataInfoList = this.getAnimateData(animateId);
                            if (!(animateDataInfoList.length > 0 && animateDataInfoList[0].mixer)) return [3 /*break*/, 3];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.AnimationClip.clearClip(animateDataInfoList[0].mixer))];
                        case 1:
                            _c.sent();
                            for (i = 0; i < animateDataInfoList.length; i++) {
                                element = animateDataInfoList[i];
                                if (element === null || element === void 0 ? void 0 : element.clip) {
                                    this.cacheManagement.deleteCacheById(element.clip);
                                }
                            }
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.AnimationMixer.removeMixer(animateDataInfoList[0].mixer))];
                        case 2:
                            _c.sent();
                            return [2 /*return*/, {
                                    status: true,
                                }];
                        case 3: return [2 /*return*/, {
                                status: false,
                                message: '当前animateId无效'
                            }];
                    }
                });
            });
        };
        /**
         * 创建混合器
         * @param animateId 动画id
         * @param bindUpdate 是否绑定混合器时间变化的监听
         * @returns
         */
        animation.prototype.createMixer = function (animateId, bindUpdate) {
            var _a, _b, _c, _d;
            return __awaiter$1(this, void 0, void 0, function () {
                var mixer;
                return __generator$1(this, function (_e) {
                    switch (_e.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.AnimationMixer.getMixer(String(animateId)))];
                        case 1:
                            mixer = _e.sent();
                            if (!mixer)
                                return [2 /*return*/, null
                                    // 将混合器设置为暂停状态
                                ];
                            // 将混合器设置为暂停状态
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.AnimationMixer.setPause(mixer, true))
                                // 设置混合器时间为0
                            ];
                        case 2:
                            // 将混合器设置为暂停状态
                            _e.sent();
                            // 设置混合器时间为0
                            return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.AnimationMixer.setTime(mixer, 0))];
                        case 3:
                            // 设置混合器时间为0
                            _e.sent();
                            if (!bindUpdate) return [3 /*break*/, 5];
                            // 绑定混合器的监听
                            return [4 /*yield*/, ((_d = this.player.Native) === null || _d === void 0 ? void 0 : _d.AnimationMixer.bindMixerNoticeCurrentTime(mixer))];
                        case 4:
                            // 绑定混合器的监听
                            _e.sent();
                            _e.label = 5;
                        case 5: return [2 /*return*/, mixer];
                    }
                });
            });
        };
        /**
         * 批量创建片段
         * @param mixer 混合器
         * @param nodeInfoList 对象列表
         * @returns
         */
        animation.prototype.batchCreateClip = function (mixer, nodeInfoList, bindUpdate) {
            var _a, _b, _c, _d, _e;
            return __awaiter$1(this, void 0, void 0, function () {
                var mixerClipName, clipList, mixerClipPtr, loopNum, i, el, actionList;
                return __generator$1(this, function (_f) {
                    switch (_f.label) {
                        case 0:
                            mixerClipName = nodeInfoList.map(function (el) {
                                return {
                                    mixer: mixer,
                                    clipName: el.node
                                };
                            });
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.AnimationClip.getBatchClips(mixerClipName))
                                // 批量获取控制器
                            ];
                        case 1:
                            clipList = _f.sent();
                            mixerClipPtr = clipList.map(function (el) {
                                return {
                                    mixer: mixer,
                                    clip: el
                                };
                            });
                            if (!(clipList.length > this.MAXDATALEN)) return [3 /*break*/, 6];
                            loopNum = Math.ceil(clipList.length / this.MAXDATALEN);
                            i = 0;
                            _f.label = 2;
                        case 2:
                            if (!(i < loopNum)) return [3 /*break*/, 5];
                            el = clipList.slice(i * this.MAXDATALEN, (i + 1) * this.MAXDATALEN);
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.KeyframeTrack.batchClearTrack(el))];
                        case 3:
                            _f.sent();
                            _f.label = 4;
                        case 4:
                            i += 1;
                            return [3 /*break*/, 2];
                        case 5: return [3 /*break*/, 8];
                        case 6: 
                        // 批量清除所有轨道数据
                        return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.KeyframeTrack.batchClearTrack(clipList))];
                        case 7:
                            // 批量清除所有轨道数据
                            _f.sent();
                            _f.label = 8;
                        case 8: return [4 /*yield*/, ((_d = this.player.Native) === null || _d === void 0 ? void 0 : _d.AnimationAction.getBatchclipActions(mixerClipPtr))];
                        case 9:
                            actionList = _f.sent();
                            if (!bindUpdate) return [3 /*break*/, 11];
                            return [4 /*yield*/, ((_e = this.player.Native) === null || _e === void 0 ? void 0 : _e.AnimationAction.batchBindActionUpdate(actionList))];
                        case 10:
                            _f.sent();
                            _f.label = 11;
                        case 11: 
                        // 返回clip->action的对应
                        return [2 /*return*/, clipList.map(function (el, index) {
                                return {
                                    clip: el,
                                    action: actionList[index],
                                    nodePtr: mixerClipName[index].clipName
                                };
                            })];
                    }
                });
            });
        };
        /**
         * 批量创建轨道【加载node的动画】
         * @param nodeType node类型
         * @param nodeInfoList node列表
         * @param clipData 片段数据
         */
        animation.prototype.batchCreateTrack = function (nodeInfoList, clipData, nodeAnimationParams) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var allTracksData, trackList, currentIndex;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            allTracksData = [];
                            nodeAnimationParams.forEach(function (nodeAnimationParam, nodeIndex) {
                                var trackData = nodeAnimationParam.track.map(function (el, index) {
                                    return {
                                        node: nodeInfoList[nodeIndex].node,
                                        clip: clipData[nodeIndex].clip,
                                        trackParam: el
                                    };
                                });
                                allTracksData.push.apply(allTracksData, trackData);
                            });
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.KeyframeTrack.batchAddTracksWithParam(allTracksData))
                                // 清除关键帧数据
                            ];
                        case 1:
                            trackList = _c.sent();
                            // 清除关键帧数据
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.KeyframeTrack.batchKeyClear(trackList))];
                        case 2:
                            // 清除关键帧数据
                            _c.sent();
                            currentIndex = 0;
                            return [2 /*return*/, nodeAnimationParams.map(function (nodeAnimationParam, nodeIndex) {
                                    // 获取出track的值
                                    var track = nodeAnimationParam.track.map(function (el, index) {
                                        return trackList[currentIndex + index];
                                    });
                                    currentIndex += nodeAnimationParam.track.length;
                                    return __assign$2(__assign$2({}, clipData[nodeIndex]), { track: track });
                                })];
                    }
                });
            });
        };
        /**
         * 批量创建关键帧
         * @param clipData 轨道数据
         * @param keyframeData 关键帧数据
         * @returns
         */
        animation.prototype.batchCreateKeyframe = function (animateId, clipData, nodeAnimationParams) {
            return __awaiter$1(this, void 0, void 0, function () {
                var keyframeParam, _loop_3, i;
                var _this = this;
                return __generator$1(this, function (_a) {
                    keyframeParam = [];
                    _loop_3 = function (i) {
                        var nodeAnimationParam = nodeAnimationParams[i];
                        nodeAnimationParam.track.forEach(function (el, index) {
                            var _a, _b;
                            var nodeInfo = (_a = _this.nodeProxy) === null || _a === void 0 ? void 0 : _a.getNodeInfo(nodeAnimationParam.node);
                            if (!nodeInfo)
                                return false;
                            var currentClipData = clipData.find(function (clipItem) {
                                return clipItem.nodePtr === nodeInfo.node;
                            });
                            if (!currentClipData)
                                return false;
                            if (currentClipData.track && ((_b = currentClipData.track) === null || _b === void 0 ? void 0 : _b.length) !== 0) {
                                nodeAnimationParam.keyframeData[index].forEach(function (keyframeItem) {
                                    keyframeParam.push({
                                        keyframeTrack: currentClipData.track[index],
                                        time: keyframeItem.time,
                                        value: keyframeItem.point,
                                    });
                                });
                            }
                        });
                    };
                    for (i = 0; i < nodeAnimationParams.length; i++) {
                        _loop_3(i);
                    }
                    this.loadKeyframe(animateId, keyframeParam);
                    return [2 /*return*/, true];
                });
            });
        };
        /**
         * 获取动画详情
         * @param animateId 动画id
         * @returns
         */
        animation.prototype.getAnimateData = function (animateId) {
            var animationTypeList = this.cacheManagement.findCacheByType(cacheType.Animation);
            // 过滤出当前animateId的数据
            var currentAnimationList = animationTypeList.filter(function (el) {
                var _a;
                return animateId === ((_a = el.instance.getDataInfo()) === null || _a === void 0 ? void 0 : _a.animateId);
            });
            var currentAnimationInfoList = currentAnimationList.map(function (el) {
                return el.instance.getDataInfo();
            });
            // 过滤掉null的数据
            return currentAnimationInfoList.filter(function (el) {
                return el;
            });
        };
        animation.prototype.loadKeyframe = function (animateId, keyframeParam) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var currentKeyframeParam, loopNum, i, el;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            // 更新状态
                            this.dispatch.emit('Animation', {
                                animateId: animateId,
                                keyframeState: EKeyframeState.loading,
                                type: EAnimationEventType.keyframeChange
                            });
                            if (!(keyframeParam.length > this.MAXDATALEN)) return [3 /*break*/, 5];
                            currentKeyframeParam = keyframeParam.sort(function (keyframeItemA, keyframeItemB) {
                                return keyframeItemA.time - keyframeItemB.time;
                            });
                            loopNum = Math.ceil(currentKeyframeParam.length / this.MAXDATALEN);
                            i = 0;
                            _c.label = 1;
                        case 1:
                            if (!(i < loopNum)) return [3 /*break*/, 4];
                            el = currentKeyframeParam.slice(i * this.MAXDATALEN, (i + 1) * this.MAXDATALEN);
                            // eslint-disable-next-line no-await-in-loop
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.KeyframeTrack.batchKeyAppend(el))];
                        case 2:
                            // eslint-disable-next-line no-await-in-loop
                            _c.sent();
                            this.getAnimateData(animateId);
                            // 更新状态
                            this.dispatch.emit('Animation', {
                                animateId: animateId,
                                keyframeState: EKeyframeState.loading,
                                type: EAnimationEventType.keyframeChange,
                                loadTime: el[el.length - 1].time
                            });
                            _c.label = 3;
                        case 3:
                            i += 1;
                            return [3 /*break*/, 1];
                        case 4: return [3 /*break*/, 7];
                        case 5: return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.KeyframeTrack.batchKeyAppend(keyframeParam))];
                        case 6:
                            _c.sent();
                            _c.label = 7;
                        case 7:
                            // 更新状态
                            this.dispatch.emit('Animation', {
                                animateId: animateId,
                                keyframeState: EKeyframeState.loaded,
                                type: EAnimationEventType.keyframeChange
                            });
                            return [2 /*return*/];
                    }
                });
            });
        };
        animation.instance = null;
        return animation;
    }(commonAbstractClass));

    var cacheManagement = /** @class */ (function () {
        function cacheManagement(cloudRenderId) {
            this.instanceNodeList = [];
            this.cloudRenderId = cloudRenderId;
        }
        /** 写入缓存【engine】 */
        cacheManagement.prototype.createCacheByEngine = function (id, instance) {
            var instanceData = {
                id: id,
                instance: instance,
                type: cacheType.Engine,
                parentInstance: undefined,
            };
            this.instanceNodeList.push(instanceData);
            return instanceData;
        };
        /** 根据node写入缓存 */
        cacheManagement.prototype.createCacheByNode = function (id, instance, relationParent) {
            return __awaiter$1(this, void 0, void 0, function () {
                var parentInstance, currentInstance, instanceData;
                var _this = this;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!relationParent) return [3 /*break*/, 3];
                            return [4 /*yield*/, instance.findNodeParentList()];
                        case 1:
                            parentInstance = _a.sent();
                            return [4 /*yield*/, this.createCacheByNode(id, instance, {
                                    instance: instance.getParentData(),
                                })];
                        case 2:
                            currentInstance = _a.sent();
                            parentInstance.forEach(function (i) {
                                var _a;
                                var nodeInfo = i.getDataInfo();
                                if (nodeInfo) {
                                    var currentInstance_1 = _this.instanceNodeList.find(function (el) {
                                        return el.id === nodeInfo.node;
                                    });
                                    if (!currentInstance_1) {
                                        // 若父节点不存在，则将节点挂载到engine上
                                        var parentData = (_a = i.getParentData()) !== null && _a !== void 0 ? _a : _this.findCacheByType(cacheType.Engine)[0];
                                        _this.createCacheByNode(nodeInfo.node, i, parentData);
                                    }
                                }
                            });
                            return [2 /*return*/, currentInstance];
                        case 3:
                            instanceData = {
                                id: id,
                                instance: instance,
                                type: cacheType.Node,
                                parentInstance: relationParent.instance,
                            };
                            this.instanceNodeList.push(instanceData);
                            return [2 /*return*/, instanceData];
                    }
                });
            });
        };
        cacheManagement.prototype.createCacheByParticle = function (id, instance, relationParent) {
            if (!(relationParent === null || relationParent === void 0 ? void 0 : relationParent.instance)) {
                throw new Error("未传入上级对象");
            }
            var instanceData = {
                id: id,
                instance: instance,
                type: cacheType.Particle,
                parentInstance: relationParent.instance,
            };
            this.instanceNodeList.push(instanceData);
            return instanceData;
        };
        cacheManagement.prototype.createCacheByMarker = function (id, instance, relationParent) {
            var parentData;
            if (relationParent && relationParent.instance) {
                parentData = this.instanceNodeList.find(function (el) {
                    return (el.instance &&
                        relationParent.instance &&
                        el.instance.id === relationParent.instance.id);
                });
            }
            if (!parentData) {
                // 挂载到engine上
                parentData = this.instanceNodeList.find(function (el) {
                    return el.type === cacheType.Engine;
                });
            }
            var instanceData = {
                id: id,
                instance: instance,
                type: cacheType.Marker,
                parentInstance: (parentData === null || parentData === void 0 ? void 0 : parentData.instance) || undefined,
            };
            this.instanceNodeList.push(instanceData);
            return instanceData;
        };
        cacheManagement.prototype.createCacheByRoute = function (id, instance) {
            // 挂载到engine上
            var parentData = this.instanceNodeList.find(function (el) {
                return el.type === cacheType.Engine;
            });
            var instanceData = {
                id: id,
                instance: instance,
                type: cacheType.Route,
                parentInstance: (parentData === null || parentData === void 0 ? void 0 : parentData.instance) || undefined,
            };
            this.instanceNodeList.push(instanceData);
            return instanceData;
        };
        cacheManagement.prototype.createCacheByLoadNode = function (id, instance, extraData) {
            var engineData = this.instanceNodeList.find(function (el) {
                return el.type === cacheType.Engine;
            });
            var instanceData = {
                id: id,
                instance: instance,
                type: cacheType.LoadNode,
                parentInstance: (engineData === null || engineData === void 0 ? void 0 : engineData.instance) || undefined,
                extraData: extraData,
            };
            this.instanceNodeList.push(instanceData);
            if (!engineData) {
                Logger$1.warn("未加载引擎-----");
            }
            return instanceData;
        };
        /** 写入缓存【Clip】 */
        cacheManagement.prototype.createCacheByClip = function (id, instance, relationParent) {
            var parentData;
            if (relationParent && relationParent.instance) {
                var currentNode = this.findCacheByObject(relationParent.instance);
                if (currentNode) {
                    parentData = currentNode;
                }
            }
            if (!parentData) {
                // 挂载到engine上
                parentData = this.instanceNodeList.find(function (el) {
                    return el.type === cacheType.Engine;
                });
            }
            var instanceData = {
                id: id,
                instance: instance,
                type: cacheType.Clip,
                parentInstance: (parentData === null || parentData === void 0 ? void 0 : parentData.instance) || undefined,
            };
            this.instanceNodeList.push(instanceData);
            return instanceData;
        };
        /** 存储image数据 */
        cacheManagement.prototype.createCacheByImage = function (id, instance) {
            // 挂载到engine上
            var parentData = this.instanceNodeList.find(function (el) {
                return el.type === cacheType.Engine;
            });
            var instanceData = {
                id: id,
                instance: instance,
                type: cacheType.Image,
                parentInstance: (parentData === null || parentData === void 0 ? void 0 : parentData.instance) || undefined,
            };
            this.instanceNodeList.push(instanceData);
            return instanceData;
        };
        /** 写入缓存【Animation】 */
        cacheManagement.prototype.createCacheByAnimation = function (id, instance) {
            var parentData;
            parentData = this.instanceNodeList.find(function (el) {
                var _a;
                return el.id === ((_a = instance.getDataInfo()) === null || _a === void 0 ? void 0 : _a.nodePtr);
            });
            if (!parentData) {
                // 挂载到engine上
                parentData = this.instanceNodeList.find(function (el) {
                    return el.type === cacheType.Engine;
                });
            }
            var instanceData = {
                id: id,
                instance: instance,
                type: cacheType.Animation,
                parentInstance: (parentData === null || parentData === void 0 ? void 0 : parentData.instance) || undefined,
            };
            this.instanceNodeList.push(instanceData);
            return instanceData;
        };
        cacheManagement.prototype.createCacheByHistoryTrajectory = function (id, instance) {
            var _this = this;
            // 挂载到engine上
            var parentData = this.instanceNodeList.find(function (el) {
                return el.type === cacheType.Engine;
            });
            var instanceData = {
                id: id,
                instance: instance,
                type: cacheType.HistoryTrajectory,
                parentInstance: (parentData === null || parentData === void 0 ? void 0 : parentData.instance) || undefined,
            };
            this.instanceNodeList.push(instanceData);
            // 设置子节点
            var currentDataInfo = instance.getDataInfo();
            currentDataInfo === null || currentDataInfo === void 0 ? void 0 : currentDataInfo.routeIds.forEach(function (routeItem) {
                _this.updateCaheParentById(routeItem, instance);
            });
            currentDataInfo === null || currentDataInfo === void 0 ? void 0 : currentDataInfo.personIds.forEach(function (personItem) {
                var _a;
                // 获取人员的node
                var personNode = (_a = _this.findCacheById(personItem)) === null || _a === void 0 ? void 0 : _a.parentInstance;
                // 获取人员node的id
                var personNodeInfo = personNode === null || personNode === void 0 ? void 0 : personNode.getDataInfo();
                if (personNodeInfo &&
                    personNode &&
                    personNode.category === cacheType.Node) {
                    _this.updateCaheParentById(personNodeInfo.node, instance);
                }
            });
            return instanceData;
        };
        /** 存储巡检数据 */
        cacheManagement.prototype.createCacheByInspection = function (id, instance) {
            var _a;
            // 挂载到engine上
            var parentData = this.instanceNodeList.find(function (el) {
                return el.type === cacheType.Engine;
            });
            var instanceData = {
                id: id,
                instance: instance,
                type: cacheType.Inspection,
                parentInstance: (parentData === null || parentData === void 0 ? void 0 : parentData.instance) || undefined,
            };
            this.instanceNodeList.push(instanceData);
            // 设置子节点
            var currentDataInfo = instance.getDataInfo();
            if (currentDataInfo === null || currentDataInfo === void 0 ? void 0 : currentDataInfo.routeId) {
                this.updateCaheParentById(currentDataInfo.routeId, instance);
            }
            if (currentDataInfo === null || currentDataInfo === void 0 ? void 0 : currentDataInfo.nodeId) {
                // TODO: 之后考虑下无人机的情况
                // 获取人员的node
                var personNode = (_a = this.findCacheById(currentDataInfo === null || currentDataInfo === void 0 ? void 0 : currentDataInfo.nodeId)) === null || _a === void 0 ? void 0 : _a.parentInstance;
                // 获取人员node的id
                var personNodeInfo = personNode === null || personNode === void 0 ? void 0 : personNode.getDataInfo();
                if (personNodeInfo &&
                    personNode &&
                    personNode.category === cacheType.Node) {
                    this.updateCaheParentById(personNodeInfo.node, instance);
                }
            }
            return instanceData;
        };
        /**
         * @description: 写入缓存
         * @param {string} id 缓存的id，之后通过此id查询
         * @param {baseWrap} instance 需要储存的数据
         * @param {object} relationParent 绑定的父级相关数据
         * @param {object} config 自身的相关配置
         * @return {*}
         */
        cacheManagement.prototype.createCache = function (id, instance, relationParent, config) {
            return __awaiter$1(this, void 0, void 0, function () {
                var currentInstance, _a;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            currentInstance = this.instanceNodeList.find(function (el) {
                                return el.id === id;
                            });
                            if (currentInstance)
                                return [2 /*return*/, currentInstance];
                            _a = instance.category;
                            switch (_a) {
                                case cacheType.Node: return [3 /*break*/, 1];
                                case cacheType.Engine: return [3 /*break*/, 3];
                                case cacheType.Clip: return [3 /*break*/, 4];
                                case cacheType.LoadNode: return [3 /*break*/, 5];
                                case cacheType.Particle: return [3 /*break*/, 6];
                                case cacheType.Marker: return [3 /*break*/, 7];
                                case cacheType.Route: return [3 /*break*/, 8];
                                case cacheType.Image: return [3 /*break*/, 9];
                                case cacheType.Animation: return [3 /*break*/, 10];
                                case cacheType.HistoryTrajectory: return [3 /*break*/, 11];
                                case cacheType.Inspection: return [3 /*break*/, 12];
                            }
                            return [3 /*break*/, 13];
                        case 1: return [4 /*yield*/, this.createCacheByNode(id, instance, relationParent)];
                        case 2:
                            currentInstance = _b.sent();
                            return [3 /*break*/, 14];
                        case 3:
                            currentInstance = this.createCacheByEngine(id, instance);
                            return [3 /*break*/, 14];
                        case 4:
                            currentInstance = this.createCacheByClip(id, instance, relationParent);
                            return [3 /*break*/, 14];
                        case 5:
                            currentInstance = this.createCacheByLoadNode(id, instance);
                            return [3 /*break*/, 14];
                        case 6:
                            currentInstance = this.createCacheByParticle(id, instance, relationParent);
                            return [3 /*break*/, 14];
                        case 7:
                            currentInstance = this.createCacheByMarker(id, instance, relationParent);
                            return [3 /*break*/, 14];
                        case 8:
                            currentInstance = this.createCacheByRoute(id, instance);
                            return [3 /*break*/, 14];
                        case 9:
                            currentInstance = this.createCacheByImage(id, instance);
                            return [3 /*break*/, 14];
                        case 10:
                            currentInstance = this.createCacheByAnimation(id, instance);
                            return [3 /*break*/, 14];
                        case 11:
                            currentInstance = this.createCacheByHistoryTrajectory(id, instance);
                            return [3 /*break*/, 14];
                        case 12:
                            currentInstance = this.createCacheByInspection(id, instance);
                            return [3 /*break*/, 14];
                        case 13:
                            Logger$1.warn("当前不支持当前类型的数据缓存", instance.category);
                            return [3 /*break*/, 14];
                        case 14:
                            if (config && currentInstance && config.isDeleteInstance && currentInstance.instance) {
                                currentInstance.instance.isDeleteInstance = config.isDeleteInstance;
                            }
                            return [2 /*return*/, currentInstance];
                    }
                });
            });
        };
        /**删除缓存 */
        cacheManagement.prototype.deleteCache = function (instance) {
            return __awaiter$1(this, void 0, void 0, function () {
                var currentInstance;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            Logger$1.warn(instance);
                            currentInstance = this.instanceNodeList.find(function (el) {
                                return el.instance && instance && el.instance.id === instance.id;
                            });
                            if (!currentInstance) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.deleteCacheChildren(currentInstance)];
                        case 1:
                            _a.sent();
                            this.instanceNodeList = this.instanceNodeList.filter(function (el) {
                                return (el.instance &&
                                    currentInstance.instance &&
                                    el.instance.id !== currentInstance.instance.id);
                            });
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * 通过id删除缓存
         * @param id 缓存的id
         */
        cacheManagement.prototype.deleteCacheById = function (id) {
            return __awaiter$1(this, void 0, void 0, function () {
                var currentInstance;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            currentInstance = this.instanceNodeList.find(function (el) {
                                return el.id === id;
                            });
                            if (!currentInstance) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.deleteCacheChildren(currentInstance)];
                        case 1:
                            _a.sent();
                            this.instanceNodeList = this.instanceNodeList.filter(function (el) {
                                return (el.instance &&
                                    currentInstance.instance &&
                                    el.instance.id !== currentInstance.instance.id);
                            });
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        /** 通过id查找是否存在缓存 */
        cacheManagement.prototype.findCacheById = function (id) {
            var currentInstance = this.instanceNodeList.find(function (el) {
                return el.id === id;
            });
            return currentInstance;
        };
        /** 通过id查找是否存在缓存 */
        cacheManagement.prototype.findCacheByNode = function (node) {
            var nodeList = this.instanceNodeList.filter(function (item) { return item.type == cacheType.LoadNode || item.type == cacheType.Node; });
            var currentInstance = nodeList.filter(function (el) {
                var _a, _b, _c;
                if (el.type === cacheType.LoadNode) {
                    var element = (_a = el.instance) === null || _a === void 0 ? void 0 : _a.getDataInfo();
                    return ((_b = element.nodeInstance.getDataInfo()) === null || _b === void 0 ? void 0 : _b.node) === node;
                }
                else {
                    var element = (_c = el.instance) === null || _c === void 0 ? void 0 : _c.getDataInfo();
                    return element.node === node;
                }
            });
            if (currentInstance.length > 1) {
                return currentInstance.find(function (i) { return i.type === cacheType.LoadNode; });
            }
            return currentInstance[0];
        };
        /** 通过对象查找是否存在缓存 */
        cacheManagement.prototype.findCacheByObject = function (instance) {
            var currentInstance = this.instanceNodeList.find(function (el) {
                return el.instance && instance && el.instance.id === instance.id;
            });
            return currentInstance;
        };
        /** 删除子级缓存 */
        cacheManagement.prototype.deleteCacheChildren = function (node) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var childrenInstanceList, _i, childrenInstanceList_1, item;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            childrenInstanceList = this.instanceNodeList.filter(function (el) {
                                return (el.parentInstance &&
                                    node.instance &&
                                    el.parentInstance.id === node.instance.id);
                            });
                            if (!(childrenInstanceList.length > 0)) return [3 /*break*/, 4];
                            _i = 0, childrenInstanceList_1 = childrenInstanceList;
                            _c.label = 1;
                        case 1:
                            if (!(_i < childrenInstanceList_1.length)) return [3 /*break*/, 4];
                            item = childrenInstanceList_1[_i];
                            return [4 /*yield*/, this.deleteCacheChildren(item)];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4:
                            this.instanceNodeList = this.instanceNodeList.filter(function (el) {
                                return (el.instance && node.instance && el.instance.id !== node.instance.id);
                            });
                            if (!((_a = node.instance) === null || _a === void 0 ? void 0 : _a.isDeleteInstance))
                                return [2 /*return*/];
                            return [4 /*yield*/, ((_b = node.instance) === null || _b === void 0 ? void 0 : _b.destroyInstance())];
                        case 5:
                            _c.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        /** 通过类型查找节点 */
        cacheManagement.prototype.findCacheByType = function (type) {
            var currentInstanceList = this.instanceNodeList.filter(function (el) {
                return el.type === type;
            });
            return currentInstanceList;
        };
        /** 修改关联的父级 */
        cacheManagement.prototype.updateCaheParentById = function (id, parentInstance) {
            var currentInstanceIndex = this.instanceNodeList.findIndex(function (el) {
                return el.id === id;
            });
            if (currentInstanceIndex !== -1) {
                this.instanceNodeList[currentInstanceIndex].parentInstance =
                    parentInstance;
                return true;
            }
            return false;
        };
        cacheManagement.prototype.updateCaheData = function (id, key, value) {
            var _a;
            var _b, _c;
            var currentInstanceIndex = this.instanceNodeList.findIndex(function (el) {
                return el.id === id;
            });
            if (currentInstanceIndex !== -1) {
                var info = (_b = this.instanceNodeList[currentInstanceIndex].instance) === null || _b === void 0 ? void 0 : _b.getDataInfo();
                (_c = this.instanceNodeList[currentInstanceIndex].instance) === null || _c === void 0 ? void 0 : _c.setDataInfo(__assign$2(__assign$2({}, info), (_a = {}, _a[key] = value, _a)));
                return true;
            }
            return false;
        };
        cacheManagement.prototype.deletAllCache = function () {
            this.instanceNodeList = [];
        };
        return cacheManagement;
    }());

    var HistoricalTrajectory = /** @class */ (function (_super) {
        __extends$1(HistoricalTrajectory, _super);
        function HistoricalTrajectory(cacheManagement, dispatch) {
            var _this = _super.call(this) || this;
            /** node操作类实例 */
            _this.nodeProxy = null;
            /** animation 动画实例 */
            _this.animationInstance = null;
            /** route 路径实例 */
            _this.routeInstance = null;
            /** 人员的加载 */
            _this.skeletonNodeInstance = null;
            _this.player = {};
            _this.dealAnimationChange = null;
            _this.MAXLEN = 100;
            _this.cacheManagement = cacheManagement;
            _this.dispatch = dispatch;
            var player = getPlayerData(cacheManagement);
            if (!player) {
                throw new Error("player未加载");
            }
            var nodeProxy = new NodeProxy(cacheManagement, dispatch);
            if (!nodeProxy) {
                throw new Error("node未加载");
            }
            var animationInstance = new animation(cacheManagement, dispatch);
            if (!animationInstance) {
                throw new Error("animation未加载");
            }
            var routeInstance = new Route(cacheManagement);
            if (!routeInstance) {
                throw new Error("Route未加载");
            }
            var skeletonNodeInstance = new SkeletonNode(cacheManagement, dispatch);
            if (!skeletonNodeInstance) {
                throw new Error("SkeletonNode未加载");
            }
            _this.nodeProxy = nodeProxy;
            _this.animationInstance = animationInstance;
            _this.routeInstance = routeInstance;
            _this.skeletonNodeInstance = skeletonNodeInstance;
            _this.player = player;
            // 设置动画的监听
            _this.dispatch.on('Animation', _this.animationChange());
            return _this;
        }
        HistoricalTrajectory.prototype.destroyInstance = function (param) {
        };
        HistoricalTrajectory.prototype.animationChange = function () {
            var _this = this;
            var that = this;
            this.dealAnimationChange = function (animateData) {
                var _a, _b, _c, _d;
                var historyCacheList = _this.cacheManagement.findCacheByType(cacheType.HistoryTrajectory);
                // 查找historyId
                var currentHistoryCache = historyCacheList.find(function (historyCacheItem) {
                    if (historyCacheItem.instance) {
                        var historyData = historyCacheItem.instance.getDataInfo();
                        if (historyData && historyData.animateId === animateData.animateId) {
                            return true;
                        }
                    }
                    return false;
                });
                if (!currentHistoryCache)
                    return;
                var currentHistory = currentHistoryCache.instance.getDataInfo();
                if (!currentHistory)
                    return;
                switch (animateData.type) {
                    case EAnimationEventType.actionStateChange:
                        // 查询node关联的人员id
                        var currentPersonId = currentHistory.personIds.find(function (personItem) {
                            var _a;
                            var nodeCache = (_a = _this.cacheManagement.findCacheById(personItem)) === null || _a === void 0 ? void 0 : _a.parentInstance;
                            return nodeCache === animateData.node;
                        });
                        if (!currentPersonId)
                            return;
                        (_a = that.skeletonNodeInstance) === null || _a === void 0 ? void 0 : _a.updateAction(currentPersonId, IClipType.idle);
                        break;
                    case EAnimationEventType.timeChange:
                        // 时间大于endTime时，暂停混合器
                        var diffTime = dayjs(currentHistory.startTime).add(((_b = animateData.time) !== null && _b !== void 0 ? _b : 0) * 1000).diff(currentHistory.endTime);
                        if (diffTime >= 0) {
                            that.setStatus(currentHistory.id, false);
                        }
                        var currentTime = dayjs(currentHistory.startTime).add(((_c = animateData.time) !== null && _c !== void 0 ? _c : 0) * 1000).format('YYYY-MM-DD HH:mm:ss');
                        // 发送时间更新通知
                        _this.dispatch.emit('HistoricalTrajectory', {
                            time: currentTime,
                            historyId: currentHistory.id
                        });
                        break;
                    case EAnimationEventType.keyframeChange:
                        currentHistoryCache.instance.setDataInfo(__assign$2(__assign$2({}, currentHistory), { loadStatus: (_d = animateData.keyframeState) !== null && _d !== void 0 ? _d : EKeyframeState.loading }));
                        break;
                }
            };
            return this.dealAnimationChange;
        };
        /**
         * 创建历史轨迹
         * @param id 历史id 用于后续的查询
         * @param personHistoryData 人员的数据
         * @param option 配置项
         * @returns
         */
        HistoricalTrajectory.prototype.create = function (id, personHistoryData, option) {
            var _a, _b, _c;
            return __awaiter$1(this, void 0, void 0, function () {
                var routeIdList, personList, personNodeList, animateId, loadAnimationStatus, historyInstance;
                var _this = this;
                return __generator$1(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            // 判断当前id是否已经存在过
                            if (this.cacheManagement.findCacheById(id)) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: '当前id已被使用，请更改id'
                                    }];
                            }
                            // 整理出按时间排序的数据
                            personHistoryData.forEach(function (historyItem) {
                                var _a, _b;
                                // 对关键帧数据排序
                                if (historyItem.keyframeData) {
                                    historyItem.keyframeData = historyItem.keyframeData.sort(function (keyframeItemA, keyframeItemB) {
                                        return new Date(keyframeItemA.time).getTime() - new Date(keyframeItemB.time).getTime();
                                    });
                                    // 判断开始时间和关键帧数据中的最小时间是否一致
                                    if ((option === null || option === void 0 ? void 0 : option.startTime) && dayjs(historyItem.keyframeData[0].time).diff(option === null || option === void 0 ? void 0 : option.startTime) < 0) {
                                        return {
                                            status: false,
                                            message: '开始时间小于数据中的的最小时间'
                                        };
                                    }
                                    // 判断开始时间和关键帧数据中的最小时间是否一致
                                    if ((option === null || option === void 0 ? void 0 : option.endTime) && dayjs(historyItem.keyframeData[historyItem.keyframeData.length - 1].time).diff(option === null || option === void 0 ? void 0 : option.endTime) > 0) {
                                        return {
                                            status: false,
                                            message: '结束时间小于数据中的的最大时间'
                                        };
                                    }
                                    option = __assign$2(__assign$2({}, option), { startTime: (_a = option === null || option === void 0 ? void 0 : option.startTime) !== null && _a !== void 0 ? _a : historyItem.keyframeData[0].time, endTime: (_b = option === null || option === void 0 ? void 0 : option.endTime) !== null && _b !== void 0 ? _b : historyItem.keyframeData[historyItem.keyframeData.length - 1].time });
                                }
                            });
                            // 修改time为数值类型
                            personHistoryData.forEach(function (historyItem) {
                                if (historyItem.keyframeData) {
                                    historyItem.keyframeData = historyItem.keyframeData.map(function (keyframeItem) {
                                        return __assign$2(__assign$2({}, keyframeItem), { timeNumber: dayjs(keyframeItem.time).diff(option.startTime) / 1000 });
                                    });
                                }
                            });
                            return [4 /*yield*/, this.batchCreateRoute(personHistoryData, option.routeOption)
                                // 判断路径是否与历史数据总条数是否一致
                            ];
                        case 1:
                            routeIdList = _d.sent();
                            if (!(routeIdList.length !== personHistoryData.length)) return [3 /*break*/, 3];
                            // 路径存在加载失败的
                            // 销毁创建成功的路径
                            return [4 /*yield*/, ((_a = this.routeInstance) === null || _a === void 0 ? void 0 : _a.destroyRoute(routeIdList))];
                        case 2:
                            // 路径存在加载失败的
                            // 销毁创建成功的路径
                            _d.sent();
                            return [2 /*return*/, {
                                    status: false,
                                    message: '加载路径失败'
                                }];
                        case 3: return [4 /*yield*/, this.batchCreatePerson(personHistoryData, option.personOption)
                            // 获取人员的node
                        ];
                        case 4:
                            personList = _d.sent();
                            personNodeList = [];
                            return [4 /*yield*/, Promise.all(personList.map(function (personItem) { return __awaiter$1(_this, void 0, void 0, function () {
                                    var N, nodeInstance;
                                    return __generator$1(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                N = {
                                                    id: personItem.id,
                                                    node: personItem.node,
                                                    name: '',
                                                    code: '',
                                                    item: personItem.node,
                                                    parent: 0,
                                                    type: '2',
                                                    aabb: [[1, 0, 0]],
                                                    children: [],
                                                    localTrans: [0, 0, 0],
                                                    localRot: [1, 0, 0, 0],
                                                    localScale: [1, 1, 1],
                                                    visible: true,
                                                    material: 0,
                                                };
                                                nodeInstance = new nodeWrap(this.player, N);
                                                personNodeList.push(nodeInstance);
                                                return [4 /*yield*/, this.cacheManagement.createCache(personItem.id, nodeInstance)];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); }))];
                        case 5:
                            _d.sent();
                            animateId = generateUUID();
                            return [4 /*yield*/, this.batchCreateAnimation(animateId, personNodeList, personHistoryData, option.personOption.rotate)];
                        case 6:
                            loadAnimationStatus = _d.sent();
                            if (!loadAnimationStatus) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: '加载动画失败'
                                    }];
                            }
                            historyInstance = new baseWrap({
                                id: id,
                                personData: personHistoryData,
                                routeIds: routeIdList,
                                personIds: personList.map(function (item) { return item.id; }),
                                animateId: animateId,
                                startTime: (_b = option.startTime) !== null && _b !== void 0 ? _b : '',
                                endTime: (_c = option.endTime) !== null && _c !== void 0 ? _c : '',
                                loadStatus: EKeyframeState.loading
                            }, cacheType.HistoryTrajectory);
                            this.cacheManagement.createCache(id, historyInstance);
                            if (!option.startTime) return [3 /*break*/, 8];
                            return [4 /*yield*/, this.setTime(id, option.startTime)];
                        case 7:
                            _d.sent();
                            _d.label = 8;
                        case 8: return [2 /*return*/, {
                                data: historyInstance,
                                status: true
                            }];
                    }
                });
            });
        };
        /**
         * 设置播放器状态
         * @param id 历史id
         * @param status 状态
         * @returns
         */
        HistoricalTrajectory.prototype.setStatus = function (id, status) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var historyInfo, i, personItem, setRes;
                var _this = this;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            historyInfo = this.getHistoryCacheInfo(id);
                            if (!(historyInfo && historyInfo.animateId)) return [3 /*break*/, 8];
                            i = 0;
                            _c.label = 1;
                        case 1:
                            if (!(i < historyInfo.personIds.length)) return [3 /*break*/, 4];
                            personItem = historyInfo.personIds[i];
                            return [4 /*yield*/, ((_a = this.skeletonNodeInstance) === null || _a === void 0 ? void 0 : _a.updateAction(personItem, status ? IClipType.walk : IClipType.idle))];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            i++;
                            return [3 /*break*/, 1];
                        case 4: return [4 /*yield*/, ((_b = this.animationInstance) === null || _b === void 0 ? void 0 : _b.setAnimationStatus(historyInfo.animateId, status))];
                        case 5:
                            setRes = _c.sent();
                            if (!(setRes && setRes.status)) return [3 /*break*/, 6];
                            return [2 /*return*/, {
                                    status: true
                                }];
                        case 6: return [4 /*yield*/, historyInfo.personIds.forEach(function (personItem) {
                                var _a;
                                (_a = _this.skeletonNodeInstance) === null || _a === void 0 ? void 0 : _a.updateAction(personItem, IClipType.idle);
                            })];
                        case 7:
                            _c.sent();
                            _c.label = 8;
                        case 8: return [2 /*return*/, {
                                status: false,
                                message: "".concat(id, "\u65E0\u6548")
                            }];
                    }
                });
            });
        };
        /**
         * 获取播放器状态
         * @param id 历史id
         * @returns
         */
        HistoricalTrajectory.prototype.getStatus = function (id) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var animateId, getRes;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            animateId = this.getAnimateId(id);
                            if (!animateId) return [3 /*break*/, 2];
                            return [4 /*yield*/, ((_a = this.animationInstance) === null || _a === void 0 ? void 0 : _a.getAnimationStatus(animateId))];
                        case 1:
                            getRes = _b.sent();
                            if (getRes && getRes.status) {
                                return [2 /*return*/, getRes];
                            }
                            _b.label = 2;
                        case 2: return [2 /*return*/, {
                                status: false,
                                message: "".concat(id, "\u65E0\u6548")
                            }];
                    }
                });
            });
        };
        /**
         * 设置播放器的时间
         * @param id 历史id
         * @param time 时间
         * @returns
         */
        HistoricalTrajectory.prototype.setTime = function (id, time) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var historyCacheInfo, currentTime, res;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.getHistoryCacheInfo(id)];
                        case 1:
                            historyCacheInfo = _b.sent();
                            if (!historyCacheInfo) return [3 /*break*/, 3];
                            if (dayjs(time).diff(historyCacheInfo.startTime) < 0 || dayjs(time).diff(historyCacheInfo.endTime) > 0) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: '当前时间小于开始时间或大于结束时间'
                                    }];
                            }
                            currentTime = dayjs(time).diff(historyCacheInfo.startTime);
                            return [4 /*yield*/, ((_a = this.animationInstance) === null || _a === void 0 ? void 0 : _a.setAnimationTime(historyCacheInfo.animateId, currentTime / 1000))];
                        case 2:
                            res = _b.sent();
                            if (res && res.status) {
                                return [2 /*return*/, {
                                        status: true
                                    }];
                            }
                            _b.label = 3;
                        case 3: return [2 /*return*/, {
                                status: false,
                                message: "".concat(id, "\u65E0\u6548")
                            }];
                    }
                });
            });
        };
        /**
         * 获取播放器的时间
         * @param id 历史id
         * @returns
         */
        HistoricalTrajectory.prototype.getTime = function (id) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var historyCacheInfo, res;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, this.getHistoryCacheInfo(id)];
                        case 1:
                            historyCacheInfo = _c.sent();
                            if (!historyCacheInfo) return [3 /*break*/, 3];
                            return [4 /*yield*/, ((_a = this.animationInstance) === null || _a === void 0 ? void 0 : _a.getAnimationTime(historyCacheInfo.animateId))];
                        case 2:
                            res = _c.sent();
                            if (res && res.status) {
                                return [2 /*return*/, {
                                        data: dayjs(historyCacheInfo.startTime).add(((_b = res.data) !== null && _b !== void 0 ? _b : 0) * 1000).format('YYYY-MM-DD HH:mm:ss'),
                                        status: true
                                    }];
                            }
                            _c.label = 3;
                        case 3: return [2 /*return*/, {
                                status: false,
                                message: "".concat(id, "\u65E0\u6548")
                            }];
                    }
                });
            });
        };
        /**
         * 设置播放器的速度
         * @param id 历史id
         * @param speed 速度
         * @returns
         */
        HistoricalTrajectory.prototype.setSpeed = function (id, speed) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var animateId, res;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            animateId = this.getAnimateId(id);
                            if (!animateId) return [3 /*break*/, 2];
                            return [4 /*yield*/, ((_a = this.animationInstance) === null || _a === void 0 ? void 0 : _a.setAnimationSpeed(animateId, speed))];
                        case 1:
                            res = _b.sent();
                            if (res && res.status) {
                                return [2 /*return*/, res];
                            }
                            _b.label = 2;
                        case 2: return [2 /*return*/, {
                                status: false,
                                message: "".concat(id, "\u65E0\u6548")
                            }];
                    }
                });
            });
        };
        /**
         * 获取播放器的速度
         * @param id 历史id
         * @returns
         */
        HistoricalTrajectory.prototype.getSpeed = function (id) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var animateId, res;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            animateId = this.getAnimateId(id);
                            if (!animateId) return [3 /*break*/, 2];
                            return [4 /*yield*/, ((_a = this.animationInstance) === null || _a === void 0 ? void 0 : _a.getAnimationSpeed(animateId))];
                        case 1:
                            res = _b.sent();
                            if (res && res.status) {
                                return [2 /*return*/, res];
                            }
                            _b.label = 2;
                        case 2: return [2 /*return*/, {
                                status: false,
                                message: "".concat(id, "\u65E0\u6548")
                            }];
                    }
                });
            });
        };
        /**
         * 获取加载状态
         * @param id 历史id
         */
        HistoricalTrajectory.prototype.getLoadStatus = function (id) {
            var historyInfo = this.getHistoryCacheInfo(id);
            if (historyInfo) {
                return {
                    status: true,
                    data: historyInfo.loadStatus
                };
            }
            return {
                status: false,
                message: "".concat(id, "\u65E0\u6548")
            };
        };
        /**
         * 人员跟随
         * @param id 历史id
         * @param personName 需要跟随的人员名称
         */
        HistoricalTrajectory.prototype.setPersonFollow = function (id, personName, personalPerspective, option) {
            var _a, _b, _c;
            var historyInfo = this.getHistoryCacheInfo(id);
            if (historyInfo) {
                var currentPersonIndex = historyInfo.personData.findIndex(function (personItem) {
                    return personItem.name === personName;
                });
                if (currentPersonIndex !== -1 && historyInfo.personIds[currentPersonIndex]) {
                    (_a = this.skeletonNodeInstance) === null || _a === void 0 ? void 0 : _a.setPerspectiveFollow({
                        id: historyInfo.personIds[currentPersonIndex],
                        personalPerspective: personalPerspective,
                        targetPosOffset: (_b = option.targetPosOffset) !== null && _b !== void 0 ? _b : [0, 0, 0],
                        offset: (_c = option.offset) !== null && _c !== void 0 ? _c : [0, 3, 1.6]
                    });
                    return {
                        status: true
                    };
                }
            }
            return {
                status: false,
                message: "".concat(id, "\u65E0\u6548")
            };
        };
        /**
         * 取消人员跟随
         * @returns
         */
        HistoricalTrajectory.prototype.cancelPersonFollow = function () {
            var _a;
            (_a = this.skeletonNodeInstance) === null || _a === void 0 ? void 0 : _a.cancelPerspectiveFollow();
            return {
                status: true
            };
        };
        /**
         * 删除历史轨迹
         * @param id 历史id
         */
        HistoricalTrajectory.prototype.destroy = function (id) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var historyInfo;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.cancelPersonFollow()];
                        case 1:
                            _b.sent();
                            historyInfo = this.getHistoryCacheInfo(id);
                            if (!historyInfo) return [3 /*break*/, 3];
                            return [4 /*yield*/, ((_a = this.skeletonNodeInstance) === null || _a === void 0 ? void 0 : _a.destroySkeletonNode(historyInfo.personIds))];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3: return [4 /*yield*/, this.cacheManagement.deleteCacheById(id)];
                        case 4:
                            _b.sent();
                            return [2 /*return*/, {
                                    status: true
                                }];
                    }
                });
            });
        };
        /**
         * 批量加载路径
         * @param personHistoryData 历史数据
         * @param routeOption
         * @returns
         */
        HistoricalTrajectory.prototype.batchCreateRoute = function (personHistoryData, routeOption) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            return __awaiter$1(this, void 0, void 0, function () {
                var routeRes, i, historyItem, pointList, routId, createRouteRes;
                return __generator$1(this, function (_l) {
                    switch (_l.label) {
                        case 0:
                            routeRes = [];
                            i = 0;
                            _l.label = 1;
                        case 1:
                            if (!(i < personHistoryData.length)) return [3 /*break*/, 5];
                            historyItem = personHistoryData[i];
                            pointList = historyItem.keyframeData.map(function (keyframeItem) {
                                return keyframeItem.point;
                            });
                            routId = generateUUID();
                            return [4 /*yield*/, ((_a = this.routeInstance) === null || _a === void 0 ? void 0 : _a.createRoute({
                                    id: routId,
                                    type: (_b = routeOption === null || routeOption === void 0 ? void 0 : routeOption.type) !== null && _b !== void 0 ? _b : IRouteType.line,
                                    style: routeOption !== null && routeOption !== void 0 ? routeOption : {},
                                    setDepthTest: (_c = routeOption === null || routeOption === void 0 ? void 0 : routeOption.openDepthTest) !== null && _c !== void 0 ? _c : true
                                }))];
                        case 2:
                            createRouteRes = _l.sent();
                            if ((routeOption === null || routeOption === void 0 ? void 0 : routeOption.visible) === undefined) {
                                (_d = this.routeInstance) === null || _d === void 0 ? void 0 : _d.setLineVisible(routId, (_e = routeOption === null || routeOption === void 0 ? void 0 : routeOption.lineVisible) !== null && _e !== void 0 ? _e : true);
                                (_f = this.routeInstance) === null || _f === void 0 ? void 0 : _f.setPointVisible(routId, (_g = routeOption === null || routeOption === void 0 ? void 0 : routeOption.pointVisible) !== null && _g !== void 0 ? _g : true);
                            }
                            else {
                                (_h = this.routeInstance) === null || _h === void 0 ? void 0 : _h.setLineVisible(routId, routeOption.visible);
                                (_j = this.routeInstance) === null || _j === void 0 ? void 0 : _j.setPointVisible(routId, routeOption.visible);
                            }
                            return [4 /*yield*/, ((_k = this.routeInstance) === null || _k === void 0 ? void 0 : _k.appendControlPoint(routId, pointList))];
                        case 3:
                            _l.sent();
                            if (createRouteRes && createRouteRes.status && createRouteRes.data) {
                                routeRes.push(createRouteRes.data);
                            }
                            _l.label = 4;
                        case 4:
                            i++;
                            return [3 /*break*/, 1];
                        case 5: return [2 /*return*/, routeRes];
                    }
                });
            });
        };
        /**
         * 批量加载人员
         * @param personHistoryData
         * @param personOption 人员配置
         */
        HistoricalTrajectory.prototype.batchCreatePerson = function (personHistoryData, personOption) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var personParams, skeletonNodeList;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            personParams = personHistoryData.map(function (personItem) {
                                return {
                                    id: generateUUID(),
                                    markerOption: personOption.markerOption,
                                    capType: personOption.capType,
                                    rotate: personOption.rotate
                                };
                            });
                            return [4 /*yield*/, ((_a = this.skeletonNodeInstance) === null || _a === void 0 ? void 0 : _a.batchCreateSkeletonNode(personParams))];
                        case 1:
                            skeletonNodeList = _b.sent();
                            if (skeletonNodeList && skeletonNodeList.data) {
                                return [2 /*return*/, skeletonNodeList.data.map(function (res) {
                                        return { id: res.id, node: res.nodeInstance.manNode };
                                    })];
                            }
                            return [2 /*return*/, []];
                    }
                });
            });
        };
        /**
         * 加载动画
         * @param animateId 动画id
         * @param personNode 人员列表
         * @param personHistoryData 人员历史数据
         * @returns
         */
        HistoricalTrajectory.prototype.batchCreateAnimation = function (animateId, personNode, personHistoryData, rotate) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var nodeAnimationParam, animationRes;
                var _this = this;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            nodeAnimationParam = personNode.map(function (personItem, index) {
                                // 根据位移关键帧算出旋转关键帧
                                var rotationKeyframe = personHistoryData[index].keyframeData.map(function (keyframeItem, keyframeIndex) {
                                    var _a;
                                    var nextTimePosition = personHistoryData[index].keyframeData[keyframeIndex + 1];
                                    if (!nextTimePosition)
                                        return {
                                            time: keyframeItem.timeNumber,
                                            point: [0, 0, 0, 0],
                                        };
                                    // let rotMat = Matrix4.identity()
                                    // const initFrontDir = [0, -1, 0]
                                    // const initUpDir = [0, 0, 1]
                                    // const initRightDir = Vec3.normalize(Vec3.cross(initFrontDir, initUpDir))
                                    // const upDir = [0, 0, 1]
                                    // const nextTimePos = [nextTimePosition.point[0], nextTimePosition.point[1], 0]
                                    // const firstTimePos = [keyframeItem.point[0], keyframeItem.point[1], 0]
                                    // const frontDir = Vec3.normalize(Vec3.sub(nextTimePos, firstTimePos))
                                    // const angle = Vec3.angleBetween(initFrontDir, frontDir)
                                    // const dt = Vec3.dot(initRightDir, frontDir)
                                    // if (dt < 0) {
                                    //     rotMat = Matrix4.makeRotationAxis(angle, upDir)
                                    // } else {
                                    //     rotMat = Matrix4.makeRotationAxis(-angle, upDir)
                                    // }
                                    // // 旋转矩阵转换为四元数
                                    // const quat = Quat.fromRotationMatrix(rotMat)
                                    var info = (_a = _this.skeletonNodeInstance) === null || _a === void 0 ? void 0 : _a.getLineInfo(keyframeItem.point, nextTimePosition.point, [0, -1, 0], true, rotate);
                                    // 添加旋转关键帧
                                    return {
                                        time: keyframeItem.timeNumber,
                                        point: (info === null || info === void 0 ? void 0 : info.quat) || [0, 0, 0, 1],
                                    };
                                });
                                var translationKeyframe = personHistoryData[index].keyframeData.map(function (keyframeItem) {
                                    return {
                                        time: keyframeItem.timeNumber,
                                        point: keyframeItem.point
                                    };
                                });
                                rotationKeyframe.splice(rotationKeyframe.length - 1, 1);
                                return {
                                    node: personItem,
                                    track: [{
                                            name: 'trackLocalTranslation',
                                            trackType: ETrackType.KFTT_Real3,
                                            propertyLinkType: EPropertyLinkType.APBT_Translation,
                                            interpolationType: EInterpolationType.IT_Linear
                                        }, {
                                            name: 'trackLocalRotation',
                                            trackType: ETrackType.KFTT_Quaternion,
                                            propertyLinkType: EPropertyLinkType.APBT_Rotation,
                                            interpolationType: EInterpolationType.IT_Discrete
                                        }],
                                    keyframeData: [translationKeyframe, rotationKeyframe]
                                };
                            });
                            return [4 /*yield*/, ((_a = this.animationInstance) === null || _a === void 0 ? void 0 : _a.loadAnimation(animateId, nodeAnimationParam, {
                                    autoPlay: false,
                                    bindUpdate: true,
                                }))];
                        case 1:
                            animationRes = _c.sent();
                            return [2 /*return*/, (_b = animationRes === null || animationRes === void 0 ? void 0 : animationRes.status) !== null && _b !== void 0 ? _b : false];
                    }
                });
            });
        };
        /**
         * 获取历史绑定的动画id
         * @param historyId
         * @returns
         */
        HistoricalTrajectory.prototype.getAnimateId = function (historyId) {
            var historyCache = this.cacheManagement.findCacheById(historyId);
            if (historyCache && historyCache.instance && historyCache.type === cacheType.HistoryTrajectory) {
                var historyDataInfo = historyCache.instance.getDataInfo();
                if (historyDataInfo && historyDataInfo.animateId) {
                    return historyDataInfo.animateId;
                }
            }
            return '';
        };
        /**
         * 获取历史缓存的详细信息
         * @param historyId
         * @returns
         */
        HistoricalTrajectory.prototype.getHistoryCacheInfo = function (historyId) {
            var historyCache = this.cacheManagement.findCacheById(historyId);
            if (historyCache && historyCache.instance && historyCache.type === cacheType.HistoryTrajectory) {
                return historyCache.instance.getDataInfo();
            }
            return null;
        };
        /**
         *@description 获取历史轨迹信息
         * @param {string | number} historyId 轨迹ID
         * @returns
         */
        HistoricalTrajectory.prototype.getHistoryInfo = function (historyId) {
            var _this = this;
            var _a, _b;
            var historyCache = this.cacheManagement.findCacheById(historyId);
            if (historyCache &&
                historyCache.instance &&
                historyCache.type === cacheType.HistoryTrajectory) {
                var personPtr_1 = [];
                (_b = (_a = historyCache.instance
                    .getDataInfo()) === null || _a === void 0 ? void 0 : _a.personIds) === null || _b === void 0 ? void 0 : _b.forEach(function (person) {
                    var personInfo = _this.cacheManagement.findCacheById(person);
                    if (personInfo && personInfo.type === cacheType.SkeletonNode) {
                        personPtr_1.push(
                        // (personInfo.instance?.getDataInfo()).pointer
                        );
                    }
                });
                return __assign$2(__assign$2({}, historyCache.instance.getDataInfo()), { personNode: personPtr_1 });
            }
            return null;
        };
        HistoricalTrajectory.instance = null;
        return HistoricalTrajectory;
    }(commonAbstractClass));

    var EInspectionNodeType;
    (function (EInspectionNodeType) {
        EInspectionNodeType[EInspectionNodeType["person"] = 0] = "person";
        EInspectionNodeType[EInspectionNodeType["drone"] = 1] = "drone";
    })(EInspectionNodeType || (EInspectionNodeType = {}));
    var EPointType;
    (function (EPointType) {
        EPointType[EPointType["pathPoint"] = 0] = "pathPoint";
        EPointType[EPointType["inspectionPoint"] = 1] = "inspectionPoint";
    })(EPointType || (EPointType = {}));
    var ICapType;
    (function (ICapType) {
        ICapType["red"] = "red";
        ICapType["blue"] = "blue";
        ICapType["yellow"] = "yellow";
        ICapType["white"] = "white";
    })(ICapType || (ICapType = {}));

    // import DroneNode from "./drone";
    /**
     * 巡检
     */
    var Inspection = /** @class */ (function () {
        /** 无人机 */
        // private droneNodeInstance: DroneNode | null = null
        function Inspection(cacheManagement, dispatch) {
            /** animation 动画实例 */
            this.animationInstance = null;
            /** route 路径实例 */
            this.routeInstance = null;
            /** 相机实例 */
            this.cameraInstance = null;
            this.player = {};
            this.dealAnimationChange = null;
            /** 人员 */
            this.skeletonNodeInstance = null;
            this.cacheManagement = cacheManagement;
            var player = getPlayerData(cacheManagement);
            if (!player) {
                throw new Error("player未加载");
            }
            var skeletonNodeInstance = new SkeletonNode(cacheManagement, dispatch);
            if (!skeletonNodeInstance) {
                throw new Error("SkeletonNode未加载");
            }
            // const droneNodeInstance = new DroneNode(cacheManagement, dispatch)
            // if (!droneNodeInstance) {
            //     throw new Error("DroneNode未加载");
            // }
            var routeInstance = new Route(cacheManagement);
            if (!routeInstance) {
                throw new Error("Route未加载");
            }
            var animationInstance = new animation(cacheManagement, dispatch);
            if (!animationInstance) {
                throw new Error("animation未加载");
            }
            var cameraInstance = new Camera(cacheManagement, dispatch);
            if (!cameraInstance) {
                throw new Error("camera未加载");
            }
            this.skeletonNodeInstance = skeletonNodeInstance;
            // this.droneNodeInstance = droneNodeInstance
            this.animationInstance = animationInstance;
            this.routeInstance = routeInstance;
            this.cameraInstance = cameraInstance;
            this.player = player;
            this.dispatch = dispatch;
            // 设置动画的监听
            this.dispatch.on('Animation', this.animationChange());
        }
        /** 处理动画变化事件 */
        Inspection.prototype.animationChange = function () {
            var _this = this;
            var that = this;
            var play = true;
            this.dealAnimationChange = function (animateData) { return __awaiter$1(_this, void 0, void 0, function () {
                var inspectionList, currentInspection, currentInspectionInfo, _a, currentPointIndex, endTime, currentPointIndex_1;
                var _b, _c, _d, _e, _f;
                return __generator$1(this, function (_g) {
                    switch (_g.label) {
                        case 0:
                            inspectionList = this.cacheManagement.findCacheByType(cacheType.Inspection);
                            currentInspection = inspectionList.find(function (inspectionItem) {
                                var _a;
                                return ((_a = inspectionItem.instance.getDataInfo()) === null || _a === void 0 ? void 0 : _a.animateId) === animateData.animateId;
                            });
                            if (!currentInspection)
                                return [2 /*return*/];
                            currentInspectionInfo = currentInspection.instance.getDataInfo();
                            if (!currentInspectionInfo)
                                return [2 /*return*/];
                            _a = animateData.type;
                            switch (_a) {
                                case EAnimationEventType.actionStateChange: return [3 /*break*/, 1];
                                case EAnimationEventType.timeChange: return [3 /*break*/, 2];
                                case EAnimationEventType.keyframeChange: return [3 /*break*/, 7];
                            }
                            return [3 /*break*/, 8];
                        case 1:
                            // 初始化设置node为静止状态
                            (_b = that.skeletonNodeInstance) === null || _b === void 0 ? void 0 : _b.updateAction(currentInspectionInfo.nodeId, IClipType.idle);
                            return [3 /*break*/, 9];
                        case 2:
                            currentPointIndex = currentInspectionInfo.inspectionPointData.findIndex(function (pointItem) {
                                return pointItem.time === Math.floor(animateData.time);
                            });
                            if (!(play && currentPointIndex !== -1 && ((_c = currentInspectionInfo.animateStatus.inspectionPointIndex) !== null && _c !== void 0 ? _c : 1) <= currentPointIndex + 1)) return [3 /*break*/, 5];
                            // 执行暂停动画
                            play = false;
                            return [4 /*yield*/, ((_d = this.animationInstance) === null || _d === void 0 ? void 0 : _d.setAnimationStatus(currentInspectionInfo.animateId, false))];
                        case 3:
                            _g.sent();
                            return [4 /*yield*/, this.dealInspectionPoint(currentInspectionInfo.id, currentPointIndex + 1)];
                        case 4:
                            _g.sent();
                            play = true;
                            return [3 /*break*/, 6];
                        case 5:
                            endTime = currentInspectionInfo.animateParamData.keyframeData[0][currentInspectionInfo.animateParamData.keyframeData[0].length - 1].time;
                            if (endTime <= Number(animateData.time)) {
                                // 设置暂停
                                that.setStatus(currentInspectionInfo.id, false);
                            }
                            _g.label = 6;
                        case 6:
                            this.dispatch.emit('Inspection', {
                                id: currentInspectionInfo.id,
                                currentInspectionIndex: (_e = currentInspectionInfo.animateStatus.inspectionPointIndex) !== null && _e !== void 0 ? _e : 1
                            });
                            return [3 /*break*/, 9];
                        case 7:
                            if (animateData.loadTime) {
                                currentPointIndex_1 = currentInspectionInfo.inspectionPointData.findIndex(function (pointItem, index) {
                                    if (index !== currentInspectionInfo.inspectionPointData.length - 1) {
                                        var lastPointItem = currentInspectionInfo.inspectionPointData[index + 1];
                                        return pointItem.time <= animateData.loadTime && lastPointItem.time > animateData.loadTime;
                                    }
                                    return true;
                                });
                                this.dispatch.emit('Inspection', {
                                    id: currentInspectionInfo.id,
                                    currentInspectionIndex: (_f = currentInspectionInfo.animateStatus.inspectionPointIndex) !== null && _f !== void 0 ? _f : 1,
                                    loadInspectionPointIndex: currentPointIndex_1 + 1
                                });
                            }
                            return [3 /*break*/, 9];
                        case 8: return [3 /*break*/, 9];
                        case 9: return [2 /*return*/];
                    }
                });
            }); };
            return this.dealAnimationChange;
        };
        /**
         * 加载巡检数据
         * @param id 巡检id用于之后操作播放列表
         * @param inspectionData 巡检数据列表
         * @param nodeType node的类型
         * @param options 可选配置
         * @returns
         */
        Inspection.prototype.create = function (id, inspectionData, nodeType, options) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __awaiter$1(this, void 0, void 0, function () {
                var nodeId, nodeData, dealData, nodeParam, animateId, loadAnimationStatus, point, createRouteRes, inspectionInstance;
                return __generator$1(this, function (_u) {
                    switch (_u.label) {
                        case 0:
                            // 判断当前id是否已经存在过
                            if (this.cacheManagement.findCacheById(id)) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: '当前id已被使用，请更改id'
                                    }];
                            }
                            nodeId = generateUUID();
                            return [4 /*yield*/, this.createNodeByType(nodeId, nodeType, options)];
                        case 1:
                            nodeData = _u.sent();
                            if (!nodeData) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: '加载node节点失败'
                                    }];
                            }
                            dealData = this.dealInspectionData(inspectionData, options);
                            return [4 /*yield*/, this.getNodeAnimationParam(nodeData, dealData.keyframeData, options === null || options === void 0 ? void 0 : options.rotate)];
                        case 2:
                            nodeParam = _u.sent();
                            if (!nodeParam) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: '加载轨道数据失败'
                                    }];
                            }
                            animateId = generateUUID();
                            return [4 /*yield*/, this.createAnimation(animateId, nodeParam)];
                        case 3:
                            loadAnimationStatus = _u.sent();
                            if (!loadAnimationStatus) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: '加载动画失败'
                                    }];
                            }
                            point = JSON.parse(JSON.stringify(dealData.routePathData[0].points));
                            return [4 /*yield*/, ((_a = this.routeInstance) === null || _a === void 0 ? void 0 : _a.createRoute({
                                    type: (_c = (_b = options === null || options === void 0 ? void 0 : options.routeStyle) === null || _b === void 0 ? void 0 : _b.type) !== null && _c !== void 0 ? _c : IRouteType.line,
                                    style: (_d = options === null || options === void 0 ? void 0 : options.routeStyle) !== null && _d !== void 0 ? _d : {},
                                    setDepthTest: (_f = (_e = options === null || options === void 0 ? void 0 : options.routeStyle) === null || _e === void 0 ? void 0 : _e.openDepthTest) !== null && _f !== void 0 ? _f : true
                                }))];
                        case 4:
                            createRouteRes = _u.sent();
                            if (!createRouteRes || !createRouteRes.status || !createRouteRes.data) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: '初始化路径失败'
                                    }];
                            }
                            if (!(((_g = options === null || options === void 0 ? void 0 : options.routeStyle) === null || _g === void 0 ? void 0 : _g.visible) === undefined)) return [3 /*break*/, 7];
                            return [4 /*yield*/, ((_h = this.routeInstance) === null || _h === void 0 ? void 0 : _h.setLineVisible(createRouteRes.data, (_k = (_j = options === null || options === void 0 ? void 0 : options.routeStyle) === null || _j === void 0 ? void 0 : _j.lineVisible) !== null && _k !== void 0 ? _k : true))];
                        case 5:
                            _u.sent();
                            return [4 /*yield*/, ((_l = this.routeInstance) === null || _l === void 0 ? void 0 : _l.setPointVisible(createRouteRes.data, (_o = (_m = options === null || options === void 0 ? void 0 : options.routeStyle) === null || _m === void 0 ? void 0 : _m.pointVisible) !== null && _o !== void 0 ? _o : true))];
                        case 6:
                            _u.sent();
                            return [3 /*break*/, 10];
                        case 7: return [4 /*yield*/, ((_p = this.routeInstance) === null || _p === void 0 ? void 0 : _p.setLineVisible(createRouteRes.data, options.routeStyle.visible))];
                        case 8:
                            _u.sent();
                            return [4 /*yield*/, ((_q = this.routeInstance) === null || _q === void 0 ? void 0 : _q.setPointVisible(createRouteRes.data, options.routeStyle.visible))];
                        case 9:
                            _u.sent();
                            _u.label = 10;
                        case 10: return [4 /*yield*/, ((_r = this.routeInstance) === null || _r === void 0 ? void 0 : _r.appendControlPoint(createRouteRes.data, point))
                            // 添加缓存
                        ];
                        case 11:
                            _u.sent();
                            inspectionInstance = new baseWrap({
                                id: id,
                                animateId: animateId,
                                nodeId: nodeId,
                                nodeType: nodeType,
                                routeId: createRouteRes.data,
                                animateParamData: nodeParam,
                                inspectionPointData: dealData.inspectionTimeMap,
                                routePathData: dealData.routePathData,
                                routeStyle: (_s = options === null || options === void 0 ? void 0 : options.routeStyle) !== null && _s !== void 0 ? _s : {},
                                loadStatus: {},
                                animateStatus: {}
                            }, cacheType.Inspection);
                            this.cacheManagement.createCache(id, inspectionInstance);
                            if (!loadAnimationStatus) return [3 /*break*/, 13];
                            return [4 /*yield*/, ((_t = this.animationInstance) === null || _t === void 0 ? void 0 : _t.setAnimationTime(animateId, 0))];
                        case 12:
                            _u.sent();
                            _u.label = 13;
                        case 13: return [2 /*return*/, {
                                status: true
                            }];
                    }
                });
            });
        };
        /**
         * 设置巡检的播放状态
         * @param id 巡检id
         * @param status 播放状态
         */
        Inspection.prototype.setStatus = function (id, status) {
            var _a, _b, _c, _d;
            return __awaiter$1(this, void 0, void 0, function () {
                var inspectionCache, inspectionInfo, setRes;
                return __generator$1(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            inspectionCache = this.cacheManagement.findCacheById(id);
                            if (!inspectionCache || !inspectionCache.instance || inspectionCache.type !== cacheType.Inspection) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "".concat(id, "\u65E0\u6548")
                                    }];
                            }
                            inspectionInfo = inspectionCache.instance.getDataInfo();
                            if (!inspectionInfo) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "".concat(id, "\u65E0\u6548")
                                    }];
                            }
                            if (inspectionInfo.animateStatus.playStatus === status) {
                                // 设置的状态为当前状态
                                return [2 /*return*/, {
                                        status: false,
                                        message: '设置的状态为当前状态'
                                    }];
                            }
                            // 更新数据
                            inspectionInfo.animateStatus.playStatus = status;
                            inspectionCache.instance.setDataInfo(__assign$2({}, inspectionInfo));
                            if (!inspectionInfo.animateStatus.isInspectionPoint) return [3 /*break*/, 4];
                            if (!!status) return [3 /*break*/, 2];
                            // 暂停，清除巡检点的动画执行，清空定时器
                            if (inspectionInfo.loadStatus.inspectionTimer) {
                                clearTimeout(inspectionInfo.loadStatus.inspectionTimer);
                            }
                            return [4 /*yield*/, this.pauseActionByInspectionPoint(inspectionInfo)];
                        case 1:
                            _e.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            // 播放
                            this.jumpInspectionPoint(inspectionInfo.id, (_a = inspectionInfo.animateStatus.inspectionPointIndex) !== null && _a !== void 0 ? _a : 1);
                            _e.label = 3;
                        case 3: return [2 /*return*/, {
                                status: true,
                            }];
                        case 4:
                            if (!(inspectionInfo.nodeId && inspectionInfo.nodeType === EInspectionNodeType.person)) return [3 /*break*/, 6];
                            return [4 /*yield*/, ((_b = this.skeletonNodeInstance) === null || _b === void 0 ? void 0 : _b.updateAction(inspectionInfo.nodeId, status ? IClipType.walk : IClipType.idle))];
                        case 5:
                            _e.sent();
                            _e.label = 6;
                        case 6: return [4 /*yield*/, ((_c = this.animationInstance) === null || _c === void 0 ? void 0 : _c.setAnimationStatus(inspectionInfo.animateId, status))];
                        case 7:
                            setRes = _e.sent();
                            if (!(setRes && setRes.status)) return [3 /*break*/, 8];
                            return [2 /*return*/, {
                                    status: true
                                }];
                        case 8:
                            if (!(inspectionInfo.nodeId && inspectionInfo.nodeType === EInspectionNodeType.person)) return [3 /*break*/, 10];
                            return [4 /*yield*/, ((_d = this.skeletonNodeInstance) === null || _d === void 0 ? void 0 : _d.updateAction(inspectionInfo.nodeId, status ? IClipType.walk : IClipType.idle))];
                        case 9:
                            _e.sent();
                            _e.label = 10;
                        case 10: return [2 /*return*/, {
                                status: false,
                                message: "\u7CFB\u7EDF\u9519\u8BEF"
                            }];
                    }
                });
            });
        };
        /**
        * 获取巡检的播放状态
        * @param id 巡检id
        */
        Inspection.prototype.getStatus = function (id) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var inspectionInfo, playStatus;
                return __generator$1(this, function (_b) {
                    inspectionInfo = this.getInspectionCacheInfo(id);
                    if (inspectionInfo) {
                        playStatus = (_a = inspectionInfo.animateStatus.playStatus) !== null && _a !== void 0 ? _a : false;
                        return [2 /*return*/, {
                                status: true,
                                data: playStatus
                            }];
                    }
                    return [2 /*return*/, {
                            status: false,
                            message: "".concat(id, "\u65E0\u6548")
                        }];
                });
            });
        };
        /**
         * 设置巡检播放速度
         * @param id 巡检id
         * @param speed 速度
         */
        Inspection.prototype.setSpeed = function (id, speed) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var inspectionCache, inspectionInfo, res;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            inspectionCache = this.cacheManagement.findCacheById(id);
                            if (!inspectionCache || !inspectionCache.instance || inspectionCache.type !== cacheType.Inspection) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "".concat(id, "\u65E0\u6548")
                                    }];
                            }
                            inspectionInfo = inspectionCache.instance.getDataInfo();
                            if (!inspectionInfo) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "".concat(id, "\u65E0\u6548")
                                    }];
                            }
                            return [4 /*yield*/, ((_a = this.animationInstance) === null || _a === void 0 ? void 0 : _a.setAnimationSpeed(inspectionInfo.animateId, speed))];
                        case 1:
                            res = _b.sent();
                            if (res && res.status) {
                                // 更新缓存
                                inspectionInfo.animateStatus.speed = speed;
                                inspectionCache.instance.setDataInfo(__assign$2({}, inspectionInfo));
                                this.dispatch.emit('Inspection_inside', {
                                    id: inspectionInfo.id,
                                    speedChange: true
                                });
                                return [2 /*return*/, res];
                            }
                            return [2 /*return*/, {
                                    status: false,
                                    message: "\u7CFB\u7EDF\u9519\u8BEF"
                                }];
                    }
                });
            });
        };
        /**
         * 获取巡检播放速度
         * @param id 巡检id
         */
        Inspection.prototype.getSpeed = function (id) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var inspectionInfo, speed;
                return __generator$1(this, function (_b) {
                    inspectionInfo = this.getInspectionCacheInfo(id);
                    if (inspectionInfo && inspectionInfo.animateId) {
                        speed = (_a = inspectionInfo.animateStatus.speed) !== null && _a !== void 0 ? _a : 1;
                        return [2 /*return*/, {
                                status: true,
                                data: speed
                            }];
                    }
                    return [2 /*return*/, {
                            status: false,
                            message: "".concat(id, "\u65E0\u6548")
                        }];
                });
            });
        };
        /**
         * 跳转至指定序号的巡检点
         * @param id 巡检id
         * @param inspectionPointIndex 巡检点序号【由1开始】
         */
        Inspection.prototype.jumpInspectionPoint = function (id, inspectionPointIndex) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var inspectionInfo, currentTime;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            inspectionInfo = this.getInspectionCacheInfo(id);
                            if (!(inspectionInfo && inspectionInfo.animateId)) return [3 /*break*/, 3];
                            currentTime = (_a = inspectionInfo.inspectionPointData[inspectionPointIndex - 1]) === null || _a === void 0 ? void 0 : _a.time;
                            return [4 /*yield*/, ((_b = this.animationInstance) === null || _b === void 0 ? void 0 : _b.setAnimationTime(inspectionInfo.animateId, currentTime))];
                        case 1:
                            _c.sent();
                            inspectionInfo.animateStatus.inspectionPointIndex = inspectionPointIndex;
                            // 更新路径
                            return [4 /*yield*/, this.updateRoutePoint(inspectionInfo)];
                        case 2:
                            // 更新路径
                            _c.sent();
                            return [2 /*return*/, {
                                    status: true,
                                }];
                        case 3: return [2 /*return*/, {
                                status: false,
                                message: "".concat(id, "\u65E0\u6548")
                            }];
                    }
                });
            });
        };
        /**
         * 获取当前播放的巡检点序号
         * @param id 巡检id
         */
        Inspection.prototype.getInspectionPointIndex = function (id) {
            var _a;
            var inspectionInfo = this.getInspectionCacheInfo(id);
            if (inspectionInfo && inspectionInfo.animateId) {
                var inspectionPointIndex = (_a = inspectionInfo.animateStatus.inspectionPointIndex) !== null && _a !== void 0 ? _a : 1;
                return {
                    status: true,
                    data: inspectionPointIndex
                };
            }
            return {
                status: false,
                message: "".concat(id, "\u65E0\u6548")
            };
        };
        /**
         * 设置路径的显示隐藏
         * @param id 巡检id
         * @param visible 是否显示
         */
        Inspection.prototype.setRouteStatus = function (id, visible) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return __awaiter$1(this, void 0, void 0, function () {
                var inspectionInfo;
                return __generator$1(this, function (_j) {
                    switch (_j.label) {
                        case 0:
                            inspectionInfo = this.getInspectionCacheInfo(id);
                            if (!(inspectionInfo && inspectionInfo.routeId)) return [3 /*break*/, 7];
                            if (!visible) return [3 /*break*/, 3];
                            return [4 /*yield*/, ((_a = this.routeInstance) === null || _a === void 0 ? void 0 : _a.setLineVisible(inspectionInfo.routeId, (_c = (_b = inspectionInfo.routeStyle) === null || _b === void 0 ? void 0 : _b.lineVisible) !== null && _c !== void 0 ? _c : true))];
                        case 1:
                            _j.sent();
                            return [4 /*yield*/, ((_d = this.routeInstance) === null || _d === void 0 ? void 0 : _d.setPointVisible(inspectionInfo.routeId, (_f = (_e = inspectionInfo.routeStyle) === null || _e === void 0 ? void 0 : _e.pointVisible) !== null && _f !== void 0 ? _f : true))];
                        case 2:
                            _j.sent();
                            return [3 /*break*/, 6];
                        case 3: return [4 /*yield*/, ((_g = this.routeInstance) === null || _g === void 0 ? void 0 : _g.setLineVisible(inspectionInfo.routeId, visible))];
                        case 4:
                            _j.sent();
                            return [4 /*yield*/, ((_h = this.routeInstance) === null || _h === void 0 ? void 0 : _h.setPointVisible(inspectionInfo.routeId, visible))];
                        case 5:
                            _j.sent();
                            _j.label = 6;
                        case 6: return [2 /*return*/, {
                                status: true
                            }];
                        case 7: return [2 /*return*/, {
                                status: false,
                                message: "".concat(id, "\u65E0\u6548")
                            }];
                    }
                });
            });
        };
        /**
         * 跟随
         * @param id 巡检id
         */
        Inspection.prototype.setFollow = function (id, angle, option) {
            var _a, _b, _c;
            var inspectionInfo = this.getInspectionCacheInfo(id);
            if (inspectionInfo) {
                if (inspectionInfo.nodeType === 0) {
                    (_a = this.skeletonNodeInstance) === null || _a === void 0 ? void 0 : _a.setPerspectiveFollow({
                        id: inspectionInfo.nodeId,
                        personalPerspective: angle,
                        targetPosOffset: (_b = option.targetPosOffset) !== null && _b !== void 0 ? _b : [0, 0, 0],
                        offset: (_c = option.offset) !== null && _c !== void 0 ? _c : [0, 3, 1.6]
                    });
                }
                else if (inspectionInfo.nodeType === 1) ;
                return {
                    status: true
                };
            }
            return {
                status: false,
                message: "".concat(id, "\u65E0\u6548")
            };
        };
        /**
         * 取消跟随
         * @returns
         */
        Inspection.prototype.cancelFollow = function () {
            var _a;
            (_a = this.skeletonNodeInstance) === null || _a === void 0 ? void 0 : _a.cancelPerspectiveFollow();
            // this.droneNodeInstance?.cancelDroneFollow()
            return {
                status: true
            };
        };
        /**
         * 退出巡检
         * @param id 巡检id
         * @returns
         */
        Inspection.prototype.destroy = function (id) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var inspectionInfo;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            inspectionInfo = this.getInspectionCacheInfo(id);
                            if (!inspectionInfo) return [3 /*break*/, 7];
                            (_a = this.skeletonNodeInstance) === null || _a === void 0 ? void 0 : _a.cancelPerspectiveFollow();
                            return [4 /*yield*/, ((_b = this.skeletonNodeInstance) === null || _b === void 0 ? void 0 : _b.destroySkeletonNode(inspectionInfo.nodeId))];
                        case 1:
                            _c.sent();
                            this.dispatch.emit('Inspection_inside', {
                                id: id,
                                quitInspection: true
                            });
                            if (!inspectionInfo.loadStatus.loadInspectionPoint) return [3 /*break*/, 3];
                            return [4 /*yield*/, inspectionInfo.loadStatus.loadInspectionPoint];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            if (!inspectionInfo.loadStatus.personAction) return [3 /*break*/, 5];
                            return [4 /*yield*/, inspectionInfo.loadStatus.personAction];
                        case 4:
                            _c.sent();
                            _c.label = 5;
                        case 5: return [4 /*yield*/, this.cacheManagement.deleteCacheById(id)];
                        case 6:
                            _c.sent();
                            return [2 /*return*/, {
                                    status: true
                                }];
                        case 7: return [2 /*return*/, {
                                status: false,
                                message: "".concat(id, "\u65E0\u6548")
                            }];
                    }
                });
            });
        };
        /**
         * 加载node
         * @param nodeType node的类型
         * @param options node的类型
         *
         * @returns
         */
        Inspection.prototype.createNodeByType = function (nodeId, nodeType, options) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var _b, skeletonNodeList, res, N, nodeInstance;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _b = nodeType;
                            switch (_b) {
                                case EInspectionNodeType.person: return [3 /*break*/, 1];
                                case EInspectionNodeType.drone: return [3 /*break*/, 4];
                            }
                            return [3 /*break*/, 4];
                        case 1: return [4 /*yield*/, ((_a = this.skeletonNodeInstance) === null || _a === void 0 ? void 0 : _a.batchCreateSkeletonNode([{
                                    id: nodeId,
                                    markerOption: {
                                        id: "".concat(nodeId, "_mark"),
                                        background: 'sample',
                                        visible: false,
                                        nodeOffset: [0, 0],
                                        text: '',
                                        textColor: '#fff',
                                        hasTriangle: true,
                                    },
                                    capType: options === null || options === void 0 ? void 0 : options.capType,
                                    rotate: options === null || options === void 0 ? void 0 : options.rotate,
                                }]))
                            // 获取人员的node
                        ];
                        case 2:
                            skeletonNodeList = _c.sent();
                            if (!(skeletonNodeList && skeletonNodeList.data)) return [3 /*break*/, 4];
                            res = skeletonNodeList.data[0];
                            N = {
                                id: res.id,
                                node: res.nodeInstance.manNode,
                                name: '',
                                code: '',
                                item: res.nodeInstance.manNode,
                                parent: 0,
                                type: '2',
                                aabb: [[1, 0, 0]],
                                children: [],
                                localTrans: [0, 0, 0],
                                localRot: [1, 0, 0, 0],
                                localScale: [1, 1, 1],
                                visible: true,
                                material: 0
                            };
                            nodeInstance = new nodeWrap(this.player, N);
                            return [4 /*yield*/, this.cacheManagement.createCache(res.id, nodeInstance)];
                        case 3:
                            _c.sent();
                            return [2 /*return*/, nodeInstance];
                        case 4: return [2 /*return*/, null];
                    }
                });
            });
        };
        /**
         * 处理巡检数据
         * @param inspectionData
         * @param options
         */
        Inspection.prototype.dealInspectionData = function (inspectionData, options) {
            // 记录巡检点的时间与巡检相关配置
            var inspectionTimeMap = [];
            var currentTime = 0;
            // 当前巡检点路径
            var currentInspectionPath = [];
            var routePathData = [];
            // 填充时间
            var keyframeData = inspectionData.map(function (inspectionItem, index) {
                var _a;
                currentInspectionPath.push(inspectionItem.pointData);
                if (index === 0) {
                    // 记录巡检点数据
                    if (inspectionItem.type === EPointType.inspectionPoint) {
                        routePathData.push({
                            points: currentInspectionPath
                        });
                        inspectionTimeMap.push(__assign$2(__assign$2({}, inspectionItem === null || inspectionItem === void 0 ? void 0 : inspectionItem.inspectionConfig), { time: currentTime }));
                        if (currentInspectionPath.length > 0) {
                            currentInspectionPath = [currentInspectionPath[currentInspectionPath.length - 1]];
                        }
                        else {
                            currentInspectionPath = [];
                        }
                    }
                    return {
                        point: inspectionItem.pointData,
                        time: currentTime
                    };
                }
                // 判断两个点是否都为巡检点，若都为巡检点，则直接跳转过去
                if (inspectionItem.type === EPointType.inspectionPoint && inspectionData[index - 1].type === EPointType.inspectionPoint) {
                    currentTime += 1;
                    if (currentInspectionPath.length > 0) {
                        currentInspectionPath = [currentInspectionPath[currentInspectionPath.length - 1]];
                    }
                    else {
                        currentInspectionPath = [];
                    }
                    routePathData.push({
                        points: currentInspectionPath
                    });
                    inspectionTimeMap.push(__assign$2(__assign$2({}, inspectionItem === null || inspectionItem === void 0 ? void 0 : inspectionItem.inspectionConfig), { time: currentTime }));
                    return {
                        point: inspectionItem.pointData,
                        time: currentTime
                    };
                }
                // 计算当前点与上一个点的距离
                var distance = Math.sqrt(Math.pow((inspectionItem.pointData[0] - inspectionData[index - 1].pointData[0]), 2) + Math.pow((inspectionItem.pointData[1] - inspectionData[index - 1].pointData[1]), 2) + Math.pow((inspectionItem.pointData[2] - inspectionData[index - 1].pointData[2]), 2));
                var time = distance / ((_a = options === null || options === void 0 ? void 0 : options.defalutNodeSpeed) !== null && _a !== void 0 ? _a : 1);
                currentTime += Math.ceil(time);
                // 记录巡检点数据
                if (inspectionItem.type === EPointType.inspectionPoint) {
                    routePathData.push({
                        points: currentInspectionPath
                    });
                    inspectionTimeMap.push(__assign$2(__assign$2({}, inspectionItem === null || inspectionItem === void 0 ? void 0 : inspectionItem.inspectionConfig), { time: currentTime }));
                    if (currentInspectionPath.length > 0) {
                        currentInspectionPath = [currentInspectionPath[currentInspectionPath.length - 1]];
                    }
                    else {
                        currentInspectionPath = [];
                    }
                }
                return {
                    point: inspectionItem.pointData,
                    time: currentTime
                };
            });
            if (currentInspectionPath && currentInspectionPath.length !== 0) {
                routePathData.push({
                    points: currentInspectionPath
                });
            }
            return {
                keyframeData: keyframeData,
                inspectionTimeMap: inspectionTimeMap,
                routePathData: routePathData
            };
        };
        /**
         * 获取node的轨道数据
         * @param keyframeData 关键帧数据
         */
        Inspection.prototype.getNodeAnimationParam = function (node, keyframeData, rotate) {
            var _this = this;
            // 根据位移关键帧算出旋转关键帧
            var rotationKeyframe = keyframeData.map(function (keyframeItem, keyframeIndex) {
                var _a;
                var nextTimePosition = keyframeData[keyframeIndex + 1];
                if (!nextTimePosition)
                    return {
                        time: keyframeItem.time,
                        point: [0, 0, 0, 0],
                    };
                // 旋转矩阵转换为四元数
                var info = (_a = _this.skeletonNodeInstance) === null || _a === void 0 ? void 0 : _a.getLineInfo(keyframeItem.point, nextTimePosition.point, [0, -1, 0], true, rotate);
                // 添加旋转关键帧
                return {
                    time: keyframeItem.time,
                    point: (info === null || info === void 0 ? void 0 : info.quat) || [0, 0, 0, 1],
                };
            });
            var translationKeyframe = keyframeData.map(function (keyframeItem) {
                return {
                    time: keyframeItem.time,
                    point: keyframeItem.point
                };
            });
            rotationKeyframe.splice(rotationKeyframe.length - 1, 1);
            return {
                node: node,
                track: [{
                        name: 'trackLocalTranslation',
                        trackType: ETrackType.KFTT_Real3,
                        propertyLinkType: EPropertyLinkType.APBT_Translation,
                        interpolationType: EInterpolationType.IT_Linear
                    }, {
                        name: 'trackLocalRotation',
                        trackType: ETrackType.KFTT_Quaternion,
                        propertyLinkType: EPropertyLinkType.APBT_Rotation,
                        interpolationType: EInterpolationType.IT_Discrete
                    }],
                keyframeData: [translationKeyframe, rotationKeyframe]
            };
        };
        /**
         * 创建动画数据
         * @param animateId 动画的id
         * @param nodeParam node的轨道数据
         * @returns
         */
        Inspection.prototype.createAnimation = function (animateId, nodeParam) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var animationRes;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, ((_a = this.animationInstance) === null || _a === void 0 ? void 0 : _a.loadAnimation(animateId, [nodeParam], {
                                autoPlay: false,
                                bindUpdate: true,
                            }))];
                        case 1:
                            animationRes = _c.sent();
                            return [2 /*return*/, (_b = animationRes === null || animationRes === void 0 ? void 0 : animationRes.status) !== null && _b !== void 0 ? _b : false];
                    }
                });
            });
        };
        /**
         * 设置巡检点的操作
         * @param inspectionInfo 巡检相关信息
         * @param currentInspectionPoint 当前的巡检点数据
         */
        Inspection.prototype.setInspectionPointData = function (inspectionInfo, currentInspectionPoint) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            // 执行相机移动操作
                            if (currentInspectionPoint.cameraData) {
                                (_a = this.cameraInstance) === null || _a === void 0 ? void 0 : _a.moveCamera('CameraParam', currentInspectionPoint.cameraData, 2);
                            }
                            if (!(inspectionInfo.nodeId && currentInspectionPoint.personAngle)) return [3 /*break*/, 2];
                            return [4 /*yield*/, ((_b = this.skeletonNodeInstance) === null || _b === void 0 ? void 0 : _b.setSkeletonNodeAngle(inspectionInfo.nodeId, currentInspectionPoint.personAngle))];
                        case 1:
                            _c.sent();
                            _c.label = 2;
                        case 2:
                            // 依次执行人物动作
                            if (currentInspectionPoint.personActionList) {
                                this.executeSkeletonNodeAction(inspectionInfo.id, currentInspectionPoint.personActionList, currentInspectionPoint.duration);
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * 执行巡检点的动作
         * @param inspectionId 巡检id
         * @param personActionList 巡检点需要执行的动画
         * @param duration 巡检点停留时长
         * @returns
         */
        Inspection.prototype.executeSkeletonNodeAction = function (inspectionId, personActionList, duration) {
            var _this = this;
            if (duration === void 0) { duration = 10; }
            // 开启执行动作,修改数据
            var currentCache = this.cacheManagement.findCacheById(inspectionId);
            if (!currentCache)
                return;
            var currentInstance = currentCache.instance;
            var currentInspectionInfo = currentInstance.getDataInfo();
            if (!currentInspectionInfo)
                return;
            currentInspectionInfo.loadStatus.personAction = new Promise(function (resolve, reject) { return __awaiter$1(_this, void 0, void 0, function () {
                var currentIndex, currentTime, timePtr, that, InspectionInsideDealFun, _loop_1;
                var _this = this;
                var _a, _b;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            currentIndex = 0;
                            currentTime = 0;
                            timePtr = setTimeout(function () {
                            }, 0);
                            that = this;
                            InspectionInsideDealFun = function (res) {
                                if ((res.clearPersonAction || res.quitInspection) && res.id === inspectionId) {
                                    clearTimeout(timePtr);
                                    currentIndex = personActionList.length;
                                    _this.dispatch.off('Inspection_inside', InspectionInsideDealFun);
                                    resolve({
                                        status: false,
                                        message: '动画被强制终止!'
                                    });
                                }
                            };
                            this.dispatch.on('Inspection_inside', InspectionInsideDealFun);
                            _loop_1 = function () {
                                var currentActionTime, actionPromise;
                                return __generator$1(this, function (_d) {
                                    switch (_d.label) {
                                        case 0: return [4 /*yield*/, ((_a = that.skeletonNodeInstance) === null || _a === void 0 ? void 0 : _a.updateAction(currentInspectionInfo.nodeId, personActionList[currentIndex].action))
                                            // 当前动作需要执行的时间
                                        ];
                                        case 1:
                                            _d.sent();
                                            currentActionTime = ((_b = personActionList[currentIndex].time) !== null && _b !== void 0 ? _b : 8) * 1000;
                                            if (duration * 1000 <= currentTime + currentActionTime) {
                                                // 跳出while
                                                currentIndex = -1;
                                                currentActionTime = duration * 1000 - currentTime;
                                            }
                                            clearTimeout(timePtr);
                                            actionPromise = new Promise(function (resolve, reject) {
                                                timePtr = setTimeout(function () {
                                                    resolve();
                                                }, currentActionTime);
                                            });
                                            return [4 /*yield*/, actionPromise];
                                        case 2:
                                            _d.sent();
                                            currentTime += currentActionTime;
                                            if (currentIndex !== personActionList.length) {
                                                currentIndex++;
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            };
                            _c.label = 1;
                        case 1:
                            if (!(currentIndex !== -1 && currentIndex <= personActionList.length - 1)) return [3 /*break*/, 3];
                            return [5 /*yield**/, _loop_1()];
                        case 2:
                            _c.sent();
                            return [3 /*break*/, 1];
                        case 3:
                            clearTimeout(timePtr);
                            this.dispatch.off('Inspection_inside', InspectionInsideDealFun);
                            resolve({
                                status: currentIndex !== -1,
                                message: currentIndex === -1 ? '动画执行超时，强行终止!' : "成功"
                            });
                            return [2 /*return*/];
                    }
                });
            }); });
            currentInstance.setDataInfo(__assign$2({}, currentInspectionInfo));
        };
        /**
         * 获取巡检缓存的详细信息
         * @param id
         * @returns
         */
        Inspection.prototype.getInspectionCacheInfo = function (id) {
            var inspectionCache = this.cacheManagement.findCacheById(id);
            if (inspectionCache && inspectionCache.instance && inspectionCache.type === cacheType.Inspection) {
                return inspectionCache.instance.getDataInfo();
            }
            return null;
        };
        /**
         * 清除上一次或正在执行的巡检点动作
         * @param inspectionInfo 巡检相关数据
         */
        Inspection.prototype.pauseActionByInspectionPoint = function (inspectionInfo) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // 清除之前的人员动作
                            this.dispatch.emit('Inspection_inside', {
                                id: inspectionInfo.id,
                                clearPersonAction: true
                            });
                            if (!inspectionInfo.loadStatus.personAction) return [3 /*break*/, 2];
                            return [4 /*yield*/, inspectionInfo.loadStatus.personAction];
                        case 1:
                            _b.sent();
                            _b.label = 2;
                        case 2:
                            if (inspectionInfo.loadStatus.inspectionTimer) {
                                clearTimeout(inspectionInfo.loadStatus.inspectionTimer);
                            }
                            return [4 /*yield*/, ((_a = this.skeletonNodeInstance) === null || _a === void 0 ? void 0 : _a.updateAction(inspectionInfo.nodeId, IClipType.idle))];
                        case 3:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * 执行巡检点信息
         * @param id 巡检id
         * @param inspectionPointIndex 巡检点序号
         * @returns
         */
        Inspection.prototype.dealInspectionPoint = function (id, inspectionPointIndex) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var inspectionCache, inspectionInfo_1, currentTime_1, loadInspectionPoint;
                var _this = this;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            inspectionCache = this.cacheManagement.findCacheById(id);
                            if (!(inspectionCache && inspectionCache.instance && inspectionCache.type === cacheType.Inspection)) return [3 /*break*/, 3];
                            inspectionInfo_1 = inspectionCache.instance.getDataInfo();
                            if (!(inspectionInfo_1 && inspectionInfo_1.animateId)) return [3 /*break*/, 3];
                            currentTime_1 = (_a = inspectionInfo_1.inspectionPointData[inspectionPointIndex - 1]) === null || _a === void 0 ? void 0 : _a.time;
                            if (!(currentTime_1 || currentTime_1 === 0)) return [3 /*break*/, 2];
                            loadInspectionPoint = new Promise(function (resolve, reject) { return __awaiter$1(_this, void 0, void 0, function () {
                                var _this = this;
                                var _a, _b, _c;
                                return __generator$1(this, function (_d) {
                                    switch (_d.label) {
                                        case 0: 
                                        // 执行暂停动画 并重置时间为当前点时间
                                        return [4 /*yield*/, ((_a = this.animationInstance) === null || _a === void 0 ? void 0 : _a.setAnimationStatus(inspectionInfo_1.animateId, false))
                                            // 暂停上一次巡检动画
                                        ];
                                        case 1:
                                            // 执行暂停动画 并重置时间为当前点时间
                                            _d.sent();
                                            // 暂停上一次巡检动画
                                            return [4 /*yield*/, this.pauseActionByInspectionPoint(inspectionInfo_1)
                                                // 更新数据
                                            ];
                                        case 2:
                                            // 暂停上一次巡检动画
                                            _d.sent();
                                            // 更新数据
                                            inspectionInfo_1.animateStatus.inspectionPointIndex = inspectionPointIndex;
                                            inspectionInfo_1.animateStatus.isInspectionPoint = true;
                                            inspectionCache.instance.setDataInfo(__assign$2({}, inspectionInfo_1));
                                            // 判断当前播放状态
                                            if (inspectionInfo_1.animateStatus.playStatus) {
                                                // 是巡检点，需要执行巡检点操作
                                                this.setInspectionPointData(inspectionInfo_1, inspectionInfo_1.inspectionPointData[inspectionPointIndex - 1]);
                                                inspectionInfo_1.loadStatus.inspectionTimer = setTimeout(function () { return __awaiter$1(_this, void 0, void 0, function () {
                                                    var currentPointIndex, lastPoint;
                                                    var _a, _b, _c, _d;
                                                    return __generator$1(this, function (_e) {
                                                        switch (_e.label) {
                                                            case 0: return [4 /*yield*/, this.pauseActionByInspectionPoint(inspectionInfo_1)
                                                                // 判断下一s是否是巡检点，如果是，就直接跳转
                                                            ];
                                                            case 1:
                                                                _e.sent();
                                                                currentPointIndex = inspectionInfo_1.inspectionPointData.findIndex(function (pointItem) {
                                                                    return pointItem.time === currentTime_1 + 1;
                                                                });
                                                                lastPoint = inspectionInfo_1.animateParamData.keyframeData[0][inspectionInfo_1.animateParamData.keyframeData[0].length - 1];
                                                                if (currentPointIndex !== -1 || lastPoint.time === currentTime_1) {
                                                                    (_a = this.skeletonNodeInstance) === null || _a === void 0 ? void 0 : _a.updateAction(inspectionInfo_1.nodeId, IClipType.idle);
                                                                }
                                                                else {
                                                                    // 设置人员为行走or idle状态
                                                                    (_b = this.skeletonNodeInstance) === null || _b === void 0 ? void 0 : _b.updateAction(inspectionInfo_1.nodeId, inspectionInfo_1.animateStatus.playStatus ? IClipType.walk : IClipType.idle);
                                                                }
                                                                return [4 /*yield*/, ((_c = this.animationInstance) === null || _c === void 0 ? void 0 : _c.setAnimationTime(inspectionInfo_1.animateId, currentPointIndex !== -1 ? currentTime_1 + 1 : currentTime_1))
                                                                    // 更新数据
                                                                ];
                                                            case 2:
                                                                _e.sent();
                                                                // 更新数据
                                                                inspectionInfo_1.animateStatus.inspectionPointIndex = inspectionPointIndex + 1;
                                                                inspectionInfo_1.animateStatus.isInspectionPoint = false;
                                                                inspectionCache.instance.setDataInfo(__assign$2({}, inspectionInfo_1));
                                                                // 更新路径
                                                                return [4 /*yield*/, this.updateRoutePoint(inspectionInfo_1)
                                                                    // 开启播放动画
                                                                ];
                                                            case 3:
                                                                // 更新路径
                                                                _e.sent();
                                                                // 开启播放动画
                                                                return [4 /*yield*/, ((_d = this.animationInstance) === null || _d === void 0 ? void 0 : _d.setAnimationStatus(inspectionInfo_1.animateId, true))];
                                                            case 4:
                                                                // 开启播放动画
                                                                _e.sent();
                                                                return [2 /*return*/];
                                                        }
                                                    });
                                                }); }, ((_b = inspectionInfo_1.inspectionPointData[inspectionPointIndex - 1].duration) !== null && _b !== void 0 ? _b : 10) * 1000 / ((_c = inspectionInfo_1.animateStatus.speed) !== null && _c !== void 0 ? _c : 1));
                                            }
                                            resolve();
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                            // 存储promise
                            inspectionInfo_1.loadStatus.loadInspectionPoint = loadInspectionPoint;
                            inspectionCache.instance.setDataInfo(__assign$2({}, inspectionInfo_1));
                            return [4 /*yield*/, loadInspectionPoint];
                        case 1:
                            _b.sent();
                            return [2 /*return*/, {
                                    status: true
                                }];
                        case 2: return [2 /*return*/, {
                                status: false,
                                message: "\u5E8F\u53F7".concat(inspectionPointIndex, "\u65E0\u6548")
                            }];
                        case 3: return [2 /*return*/, {
                                status: false,
                                message: "".concat(id, "\u65E0\u6548")
                            }];
                    }
                });
            });
        };
        /**
         * 更新路径点
         * @param inspectionInfo 巡检信息
         */
        Inspection.prototype.updateRoutePoint = function (inspectionInfo) {
            var _a, _b, _c;
            return __awaiter$1(this, void 0, void 0, function () {
                var points, pointParams;
                return __generator$1(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, ((_a = this.routeInstance) === null || _a === void 0 ? void 0 : _a.clearControlPoint(inspectionInfo.routeId))];
                        case 1:
                            _d.sent();
                            points = inspectionInfo.routePathData[((_b = inspectionInfo.animateStatus.inspectionPointIndex) !== null && _b !== void 0 ? _b : 1) - 1].points;
                            pointParams = JSON.parse(JSON.stringify(points));
                            return [4 /*yield*/, ((_c = this.routeInstance) === null || _c === void 0 ? void 0 : _c.appendControlPoint(inspectionInfo.routeId, pointParams))];
                        case 2:
                            _d.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        Inspection.instance = null;
        return Inspection;
    }());

    var PlottingType;
    (function (PlottingType) {
        PlottingType["Line"] = "Line";
        PlottingType["Marker"] = "Marker";
        PlottingType["Cube"] = "Cube";
    })(PlottingType || (PlottingType = {}));
    var PlottingStatus;
    (function (PlottingStatus) {
        /** 初始化，刚开启一个类型的标绘 */
        PlottingStatus["init"] = "init";
        /** 等待中，通常是指创建marker时需要等待输入marker的内容 */
        PlottingStatus["pendding"] = "pendding";
        /** 当前类型的标绘完成 */
        PlottingStatus["success"] = "success";
    })(PlottingStatus || (PlottingStatus = {}));

    var currentPlottingData$3;
    var route$1;
    var player$4;
    var dispatch$3;
    var cubeConfig;
    function createByCube(config) {
        var _a;
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_b) {
                cubeConfig = config;
                (_a = player$4.Native) === null || _a === void 0 ? void 0 : _a.Tools.EventBrowseLClick.connect(handleMouseLClickByCube);
                return [2 /*return*/];
            });
        });
    }
    function cancleByCube(plottingData) {
        var _a;
        return __awaiter$1(this, void 0, void 0, function () {
            var ids;
            return __generator$1(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        (_a = player$4.Native) === null || _a === void 0 ? void 0 : _a.Tools.EventBrowseLClick.disconnect(handleMouseLClickByCube);
                        if (!plottingData.cloudId) return [3 /*break*/, 2];
                        ids = plottingData.cloudId.split(', ');
                        return [4 /*yield*/, route$1.destroyRoute(ids)];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    }
    function setDataByCube(plottingData) {
        return __awaiter$1(this, void 0, void 0, function () {
            var res;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cubeConfig = plottingData.config;
                        return [4 /*yield*/, createCubeRoute(plottingData.data.localTrans)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, __assign$2(__assign$2({}, plottingData), { cloudId: res })];
                }
            });
        });
    }
    function createCubeRoute(pos) {
        var _a, _b, _c, _d;
        return __awaiter$1(this, void 0, void 0, function () {
            var bottomPos, topPos, column1, column2, routeConfig, routeIdBottom, routeIdTop, routeIdCol1, routeIdCol2;
            return __generator$1(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        bottomPos = [pos[0], [pos[1][0], pos[0][1], pos[0][2]], [pos[1][0], pos[1][1], pos[0][2]], [pos[0][0], pos[1][1], pos[0][2]], pos[0], [pos[0][0], pos[0][1], pos[1][2]]];
                        topPos = [pos[1], [pos[1][0], pos[0][1], pos[1][2]], [pos[0][0], pos[0][1], pos[1][2]], [pos[0][0], pos[1][1], pos[1][2]], pos[1], [pos[1][0], pos[1][1], pos[0][2]]];
                        column1 = [[pos[1][0], pos[0][1], pos[0][2]], [pos[1][0], pos[0][1], pos[1][2]]];
                        column2 = [[pos[0][0], pos[1][1], pos[0][2]], [pos[0][0], pos[1][1], pos[1][2]]];
                        routeConfig = {
                            type: ((_a = cubeConfig.lineOption) === null || _a === void 0 ? void 0 : _a.smooth) ? IRouteType.spline : IRouteType.line,
                            style: {
                                lineColor: (_b = cubeConfig === null || cubeConfig === void 0 ? void 0 : cubeConfig.color) !== null && _b !== void 0 ? _b : '#ffff00',
                                lineWidth: (_d = (_c = cubeConfig === null || cubeConfig === void 0 ? void 0 : cubeConfig.lineOption) === null || _c === void 0 ? void 0 : _c.width) !== null && _d !== void 0 ? _d : 2,
                                isLineStipple: false,
                                pointColor: "#ffffff00"
                            }
                        };
                        return [4 /*yield*/, route$1.createRoute(__assign$2(__assign$2({}, routeConfig), { point: bottomPos }))];
                    case 1:
                        routeIdBottom = (_e.sent()).data;
                        return [4 /*yield*/, route$1.createRoute(__assign$2(__assign$2({}, routeConfig), { point: topPos }))];
                    case 2:
                        routeIdTop = (_e.sent()).data;
                        return [4 /*yield*/, route$1.createRoute(__assign$2(__assign$2({}, routeConfig), { point: column1 }))];
                    case 3:
                        routeIdCol1 = (_e.sent()).data;
                        return [4 /*yield*/, route$1.createRoute(__assign$2(__assign$2({}, routeConfig), { point: column2 }))];
                    case 4:
                        routeIdCol2 = (_e.sent()).data;
                        if (!(routeIdBottom && routeIdTop && routeIdCol1 && routeIdCol2)) return [3 /*break*/, 9];
                        // 监听鼠标左键
                        return [4 /*yield*/, route$1.setPointVisible(routeIdBottom, false)];
                    case 5:
                        // 监听鼠标左键
                        _e.sent();
                        return [4 /*yield*/, route$1.setPointVisible(routeIdTop, false)];
                    case 6:
                        _e.sent();
                        return [4 /*yield*/, route$1.setPointVisible(routeIdCol1, false)];
                    case 7:
                        _e.sent();
                        return [4 /*yield*/, route$1.setPointVisible(routeIdCol2, false)];
                    case 8:
                        _e.sent();
                        _e.label = 9;
                    case 9: return [2 /*return*/, "".concat(routeIdBottom, ", ").concat(routeIdTop, ", ").concat(routeIdCol1, ", ").concat(routeIdCol2)];
                }
            });
        });
    }
    function handleMouseLClickByCube(e) {
        var _a;
        return __awaiter$1(this, void 0, void 0, function () {
            var cloudId;
            return __generator$1(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        currentPlottingData$3.data.localTrans.push(e.pos);
                        if (!(currentPlottingData$3.data.localTrans.length === 2)) return [3 /*break*/, 3];
                        return [4 /*yield*/, createCubeRoute(currentPlottingData$3.data.localTrans)];
                    case 1:
                        cloudId = _b.sent();
                        currentPlottingData$3.cloudId = cloudId;
                        currentPlottingData$3.status = PlottingStatus.success;
                        return [4 /*yield*/, ((_a = player$4.Native) === null || _a === void 0 ? void 0 : _a.Tools.EventBrowseLClick.disconnect(handleMouseLClickByCube))];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        dispatch$3.emit('plottingData_inside', currentPlottingData$3);
                        return [2 /*return*/];
                }
            });
        });
    }
    function cubeConnect(playerData, cacheManagement, Dispatch) {
        player$4 = playerData;
        dispatch$3 = Dispatch;
        route$1 = new Route(cacheManagement);
        dispatch$3.on("plottingData_inside", function (data) {
            currentPlottingData$3 = data;
        });
    }

    var currentPlottingData$2;
    var route;
    var player$3;
    var dispatch$2;
    /** 创建线条标绘 */
    function createByLine(config) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter$1(this, void 0, void 0, function () {
            var routeId;
            return __generator$1(this, function (_g) {
                switch (_g.label) {
                    case 0: return [4 /*yield*/, route.createRoute({
                            type: ((_a = config.lineOption) === null || _a === void 0 ? void 0 : _a.smooth) ? IRouteType.spline : IRouteType.line,
                            style: {
                                lineColor: (_b = config === null || config === void 0 ? void 0 : config.color) !== null && _b !== void 0 ? _b : '#ffff00',
                                lineWidth: (_d = (_c = config === null || config === void 0 ? void 0 : config.lineOption) === null || _c === void 0 ? void 0 : _c.width) !== null && _d !== void 0 ? _d : 2,
                                isLineStipple: false,
                            }
                        })];
                    case 1:
                        routeId = (_g.sent()).data;
                        if (!routeId) return [3 /*break*/, 3];
                        // 监听鼠标左键
                        return [4 /*yield*/, route.setPointVisible(routeId, false)];
                    case 2:
                        // 监听鼠标左键
                        _g.sent();
                        (_e = player$3.Native) === null || _e === void 0 ? void 0 : _e.Tools.EventBrowseLClick.connect(handleMouseLClickByLine);
                        // 监听鼠标右键
                        (_f = player$3.Native) === null || _f === void 0 ? void 0 : _f.Tools.EventBrowseRClick.connect(handleMouseRClickByLine);
                        _g.label = 3;
                    case 3: return [2 /*return*/, routeId];
                }
            });
        });
    }
    /** 通过数据设置线条标绘 */
    function setDataByLine(plottingData) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter$1(this, void 0, void 0, function () {
            var routeId;
            return __generator$1(this, function (_g) {
                switch (_g.label) {
                    case 0: return [4 /*yield*/, route.createRoute({
                            type: ((_a = plottingData.config.lineOption) === null || _a === void 0 ? void 0 : _a.smooth) ? IRouteType.spline : IRouteType.line,
                            style: {
                                lineColor: (_c = (_b = plottingData.config) === null || _b === void 0 ? void 0 : _b.color) !== null && _c !== void 0 ? _c : '#ffff00',
                                lineWidth: (_f = (_e = (_d = plottingData.config) === null || _d === void 0 ? void 0 : _d.lineOption) === null || _e === void 0 ? void 0 : _e.width) !== null && _f !== void 0 ? _f : 2,
                                isLineStipple: false,
                            },
                            point: plottingData.data.localTrans
                        })];
                    case 1:
                        routeId = (_g.sent()).data;
                        if (routeId) {
                            route.setPointVisible(routeId, false);
                            return [2 /*return*/, __assign$2(__assign$2({}, plottingData), { cloudId: routeId })];
                        }
                        return [2 /*return*/, null];
                }
            });
        });
    }
    function cancleByLine(data) {
        var _a, _b;
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!data.cloudId) return [3 /*break*/, 2];
                        return [4 /*yield*/, route.destroyRoute(data.cloudId)];
                    case 1:
                        _c.sent();
                        (_a = player$3.Native) === null || _a === void 0 ? void 0 : _a.Tools.EventBrowseLClick.disconnect(handleMouseLClickByLine);
                        (_b = player$3.Native) === null || _b === void 0 ? void 0 : _b.Tools.EventBrowseRClick.disconnect(handleMouseRClickByLine);
                        _c.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    }
    /** 监听鼠标事件 */
    function handleMouseLClickByLine(e) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(currentPlottingData$2 && currentPlottingData$2.cloudId)) return [3 /*break*/, 2];
                        currentPlottingData$2.data.localTrans.push(e.pos);
                        dispatch$2.emit('plottingData_inside', currentPlottingData$2);
                        return [4 /*yield*/, route.appendControlPoint(currentPlottingData$2.cloudId, e.pos)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    }
    function handleMouseRClickByLine(e) {
        var _a, _b;
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(currentPlottingData$2 && currentPlottingData$2.data.localTrans.length >= 2)) return [3 /*break*/, 3];
                        currentPlottingData$2.status = PlottingStatus.success;
                        return [4 /*yield*/, ((_a = player$3.Native) === null || _a === void 0 ? void 0 : _a.Tools.EventBrowseLClick.disconnect(handleMouseLClickByLine))];
                    case 1:
                        _c.sent();
                        return [4 /*yield*/, ((_b = player$3.Native) === null || _b === void 0 ? void 0 : _b.Tools.EventBrowseRClick.disconnect(handleMouseRClickByLine))];
                    case 2:
                        _c.sent();
                        dispatch$2.emit('plottingData_inside', currentPlottingData$2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function lineConnect(playerData, cacheManagement, Dispatch) {
        player$3 = playerData;
        dispatch$2 = Dispatch;
        route = new Route(cacheManagement);
        dispatch$2.on("plottingData_inside", function (data) {
            currentPlottingData$2 = data;
        });
    }

    var currentPlottingData$1;
    var dispatch$1;
    var player$2;
    /** 创建标签标绘 */
    function createByMarker() {
        var _a;
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_b) {
                (_a = player$2.Native) === null || _a === void 0 ? void 0 : _a.Tools.EventBrowseLClick.connect(handleMouseLClickByMarker);
                return [2 /*return*/];
            });
        });
    }
    function cancleByMarker(data) {
        var _a, _b;
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        (_a = player$2.Native) === null || _a === void 0 ? void 0 : _a.Tools.EventBrowseLClick.disconnect(handleMouseLClickByMarker);
                        if (!data.cloudId) return [3 /*break*/, 2];
                        return [4 /*yield*/, ((_b = player$2.Native) === null || _b === void 0 ? void 0 : _b.GisMarker.destroy([data.cloudId]))];
                    case 1:
                        _c.sent();
                        _c.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    }
    function setMarkerData(localTrans, config) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        return __awaiter$1(this, void 0, void 0, function () {
            var img, rgba, imgid, optionMarker, cloudId;
            return __generator$1(this, function (_q) {
                switch (_q.label) {
                    case 0:
                        img = '';
                        // 加载img
                        if (!((_a = config.markerOption) === null || _a === void 0 ? void 0 : _a.img)) {
                            img = "rgba:0,0,0,255";
                        }
                        else if ((_b = config.markerOption) === null || _b === void 0 ? void 0 : _b.img.includes('#')) {
                            rgba = hex2rgba((_c = config.markerOption) === null || _c === void 0 ? void 0 : _c.img);
                            img = "rgba:".concat(rgba.r, ",").concat(rgba.g, ",").concat(rgba.b, ",").concat(rgba.a);
                        }
                        else {
                            img = (_d = config.markerOption) === null || _d === void 0 ? void 0 : _d.img;
                        }
                        return [4 /*yield*/, ((_e = player$2.Native) === null || _e === void 0 ? void 0 : _e.GisMarker.loadImage(img))];
                    case 1:
                        imgid = _q.sent();
                        optionMarker = {
                            parentNode: 0,
                            localTrans: localTrans,
                            size: ((_f = config.markerOption) === null || _f === void 0 ? void 0 : _f.size) || [-1, -1],
                            nodeOffset: ((_g = config.markerOption) === null || _g === void 0 ? void 0 : _g.offset) || [0, 0],
                            imgId: imgid,
                            imgSize: ((_h = config.markerOption) === null || _h === void 0 ? void 0 : _h.imgSize) || [32, 32],
                            imgPadding: ((_j = config.markerOption) === null || _j === void 0 ? void 0 : _j.imgPadding) || [0, 0, 0, 0],
                            text: ((_k = config.markerOption) === null || _k === void 0 ? void 0 : _k.text) || '',
                            textFontSize: ((_l = config.markerOption) === null || _l === void 0 ? void 0 : _l.fontSize) || 14,
                            breakWidth: -1,
                            contentPadding: (_m = config.markerOption) === null || _m === void 0 ? void 0 : _m.padding,
                            textColor: config.color ? hex2Number(config.color) : 0xffffffff,
                            title: '',
                            titleFontSize: 18,
                            titleColor: 0xFFFFFFF,
                            userData: null,
                        };
                        return [4 /*yield*/, ((_o = player$2.Native) === null || _o === void 0 ? void 0 : _o.GisMarker.create(optionMarker))];
                    case 2:
                        cloudId = _q.sent();
                        (_p = player$2.Native) === null || _p === void 0 ? void 0 : _p.Tools.EventBrowseLClick.disconnect(handleMouseLClickByMarker);
                        return [2 /*return*/, cloudId];
                }
            });
        });
    }
    function setDataByMarker(plottingData) {
        return __awaiter$1(this, void 0, void 0, function () {
            var cloudId;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, setMarkerData(plottingData.data.localTrans[0], plottingData.config)];
                    case 1:
                        cloudId = _a.sent();
                        return [2 /*return*/, __assign$2(__assign$2({}, plottingData), { cloudId: cloudId })];
                }
            });
        });
    }
    /** 监听鼠标事件 */
    function handleMouseLClickByMarker(e) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                if (currentPlottingData$1 && currentPlottingData$1.type === PlottingType.Marker) {
                    currentPlottingData$1.status = PlottingStatus.pendding;
                    currentPlottingData$1.data.localTrans = [e.pos];
                    dispatch$1.emit("plottingData_inside", currentPlottingData$1);
                }
                return [2 /*return*/];
            });
        });
    }
    function markerConnect(playerData, Dispatch) {
        dispatch$1 = Dispatch;
        player$2 = playerData;
        dispatch$1.on("plottingData_inside", function (data) {
            currentPlottingData$1 = data;
        });
    }

    var player$1 = {};
    var plottingData = [];
    var currentPlottingData;
    var dispatch;
    var Plotting = /** @class */ (function () {
        function Plotting(cacheManagement, Dispatch) {
            dispatch = Dispatch;
            var playerData = getPlayerData(cacheManagement);
            if (!playerData) {
                throw new Error("player未加载");
            }
            player$1 = playerData;
            // 子监听currentPlotting数据的变化
            lineConnect(player$1, cacheManagement, dispatch);
            markerConnect(player$1, dispatch);
            cubeConnect(player$1, cacheManagement, dispatch);
            dispatch.on("plottingData_inside", handelPlottingChange);
        }
        /** 获取当前标绘的所有数据 */
        Plotting.prototype.getAllDataList = function () {
            return {
                status: true,
                data: plottingData.map(function (el) {
                    return {
                        type: el.type,
                        data: el.data,
                        config: el.config,
                        status: el.status
                    };
                })
            };
        };
        /** 获取指定序号的标绘数据 */
        Plotting.prototype.getDataList = function (index) {
            var currentData = plottingData[index];
            if (!currentData) {
                return {
                    status: false,
                    message: "\u7B2C".concat(index, "\u6761\u6807\u6CE8\u4E0D\u5B58\u5728")
                };
            }
            delete currentData.cloudId;
            return {
                status: true,
                data: currentData
            };
        };
        /** 设置标绘数据【会将之前的数据都删除】 */
        Plotting.prototype.setPlottingData = function (plottingList) {
            return __awaiter$1(this, void 0, void 0, function () {
                var plottingDataTemp, i, item, res, _a;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            plottingDataTemp = [];
                            return [4 /*yield*/, this.deleteAll()];
                        case 1:
                            _b.sent();
                            i = 0;
                            _b.label = 2;
                        case 2:
                            if (!(i < plottingList.length)) return [3 /*break*/, 12];
                            item = plottingList[i];
                            res = null;
                            _a = item.type;
                            switch (_a) {
                                case PlottingType.Line: return [3 /*break*/, 3];
                                case PlottingType.Marker: return [3 /*break*/, 5];
                                case PlottingType.Cube: return [3 /*break*/, 7];
                            }
                            return [3 /*break*/, 9];
                        case 3: return [4 /*yield*/, setDataByLine(item)];
                        case 4:
                            res = _b.sent();
                            return [3 /*break*/, 10];
                        case 5: return [4 /*yield*/, setDataByMarker(item)];
                        case 6:
                            res = _b.sent();
                            return [3 /*break*/, 10];
                        case 7: return [4 /*yield*/, setDataByCube(item)];
                        case 8:
                            res = _b.sent();
                            return [3 /*break*/, 10];
                        case 9: return [3 /*break*/, 10];
                        case 10:
                            if (res) {
                                plottingDataTemp.push(res);
                            }
                            else {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "\u521B\u5EFA".concat(item.type, "\u7C7B\u578B\u7684\u6570\u636E\u9519\u8BEF")
                                    }];
                            }
                            _b.label = 11;
                        case 11:
                            i++;
                            return [3 /*break*/, 2];
                        case 12:
                            plottingData = plottingDataTemp;
                            return [2 /*return*/, {
                                    status: true,
                                    message: "成功"
                                }];
                    }
                });
            });
        };
        /** 创建指定类型的标记 */
        Plotting.prototype.createPlotting = function (type, config) {
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0: 
                        // 判断当前是否有其他开启了的类型， 如果有就关闭
                        return [4 /*yield*/, this.canclePlotting()];
                        case 1:
                            // 判断当前是否有其他开启了的类型， 如果有就关闭
                            _a.sent();
                            return [4 /*yield*/, createPlottingType({
                                    type: type,
                                    config: config || {},
                                    status: PlottingStatus.init,
                                    data: {
                                        localTrans: []
                                    }
                                })];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        Plotting.prototype.setMarkerData = function (config) {
            return __awaiter$1(this, void 0, void 0, function () {
                var _a;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(currentPlottingData &&
                                currentPlottingData.type === PlottingType.Marker &&
                                currentPlottingData.status === PlottingStatus.pendding)) return [3 /*break*/, 2];
                            // 设置数据
                            _a = currentPlottingData;
                            return [4 /*yield*/, setMarkerData(currentPlottingData.data.localTrans[0], config)];
                        case 1:
                            // 设置数据
                            _a.cloudId = _b.sent();
                            currentPlottingData.config = config;
                            currentPlottingData.status = PlottingStatus.success;
                            dispatch.emit('plottingData_inside', currentPlottingData);
                            return [3 /*break*/, 3];
                        case 2: return [2 /*return*/, {
                                status: false,
                                message: "当前不存在需要设置的marker,请确认是否开启marker绘制，且已在模型中左键点击"
                            }];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        /** 取消当前标绘 */
        Plotting.prototype.canclePlotting = function () {
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // 判断当前是否存在标绘数据
                            if (!currentPlottingData || currentPlottingData.status === PlottingStatus.success)
                                return [2 /*return*/];
                            // 清除未完成的标绘
                            return [4 /*yield*/, canclePlottingByData(currentPlottingData)];
                        case 1:
                            // 清除未完成的标绘
                            _a.sent();
                            currentPlottingData = null;
                            return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * 删除指定序号的标绘数据
         * @param index
         */
        Plotting.prototype.delete = function (index) {
            return __awaiter$1(this, void 0, void 0, function () {
                var currentData;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            currentData = plottingData[index];
                            if (!currentData) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "\u7B2C".concat(index, "\u6761\u6807\u6CE8\u4E0D\u5B58\u5728")
                                    }];
                            }
                            return [4 /*yield*/, canclePlottingByData(currentData)];
                        case 1:
                            _a.sent();
                            plottingData.splice(index, 1);
                            return [2 /*return*/, {
                                    status: true,
                                    message: "成功"
                                }];
                    }
                });
            });
        };
        /** 删除所有的标绘数据 */
        Plotting.prototype.deleteAll = function () {
            return __awaiter$1(this, void 0, void 0, function () {
                var i, item;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.canclePlotting()];
                        case 1:
                            _a.sent();
                            i = 0;
                            _a.label = 2;
                        case 2:
                            if (!(i < plottingData.length)) return [3 /*break*/, 5];
                            item = plottingData[i];
                            return [4 /*yield*/, canclePlottingByData(item)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            i++;
                            return [3 /*break*/, 2];
                        case 5:
                            plottingData = [];
                            return [2 /*return*/, {
                                    message: "删除成功",
                                    status: true
                                }];
                    }
                });
            });
        };
        /** 获取当前标绘的类型 */
        Plotting.prototype.getCurrentPlottingType = function () {
            return {
                status: true,
                data: currentPlottingData === null || currentPlottingData === void 0 ? void 0 : currentPlottingData.type
            };
        };
        return Plotting;
    }());
    function canclePlottingByData(plottingData) {
        return __awaiter$1(this, void 0, void 0, function () {
            var _a;
            return __generator$1(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = plottingData.type;
                        switch (_a) {
                            case PlottingType.Line: return [3 /*break*/, 1];
                            case PlottingType.Marker: return [3 /*break*/, 3];
                            case PlottingType.Cube: return [3 /*break*/, 5];
                        }
                        return [3 /*break*/, 7];
                    case 1: return [4 /*yield*/, cancleByLine(plottingData)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 8];
                    case 3: return [4 /*yield*/, cancleByMarker(plottingData)];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 8];
                    case 5: return [4 /*yield*/, cancleByCube(plottingData)];
                    case 6:
                        _b.sent();
                        _b.label = 7;
                    case 7: return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
    function createPlottingType(plottingData) {
        return __awaiter$1(this, void 0, void 0, function () {
            var _a, _b;
            return __generator$1(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        currentPlottingData = plottingData;
                        _a = plottingData.type;
                        switch (_a) {
                            case PlottingType.Line: return [3 /*break*/, 1];
                            case PlottingType.Marker: return [3 /*break*/, 3];
                            case PlottingType.Cube: return [3 /*break*/, 5];
                        }
                        return [3 /*break*/, 7];
                    case 1:
                        _b = currentPlottingData;
                        return [4 /*yield*/, createByLine(plottingData.config)];
                    case 2:
                        _b.cloudId = _c.sent();
                        return [3 /*break*/, 8];
                    case 3: return [4 /*yield*/, createByMarker()];
                    case 4:
                        _c.sent();
                        return [3 /*break*/, 8];
                    case 5: return [4 /*yield*/, createByCube(plottingData.config)];
                    case 6:
                        _c.sent();
                        return [3 /*break*/, 8];
                    case 7: return [3 /*break*/, 8];
                    case 8:
                        dispatch.emit("plottingData_inside", currentPlottingData);
                        return [2 /*return*/];
                }
            });
        });
    }
    function handelPlottingChange(data) {
        /** 成功之后，重新开始一个新 */
        if (data.status === PlottingStatus.success) {
            plottingData.push(__assign$2({}, data));
            currentPlottingData = __assign$2(__assign$2({}, data), { status: PlottingStatus.init, data: {
                    localTrans: []
                } });
            delete currentPlottingData.cloudId;
            createPlottingType(currentPlottingData);
        }
        else {
            currentPlottingData = __assign$2({}, data);
        }
    }

    var ProgressStatus;
    (function (ProgressStatus) {
        ProgressStatus["awaitData"] = "awaitData";
        ProgressStatus["pending"] = "pending";
        ProgressStatus["pause"] = "pause";
        ProgressStatus["init"] = "init";
        ProgressStatus["playing"] = "playing";
        ProgressStatus["finish"] = "finish";
    })(ProgressStatus || (ProgressStatus = {}));

    var Progress$1 = /** @class */ (function () {
        function Progress(cacheManagement, dispatch) {
            this.player = {};
            this.progressCodeByItem = {};
            /** 开始时间 */
            this.startDate = '';
            /** 结束时间 */
            this.endDate = '';
            /** 进度数据 */
            this.stageData = {};
            /** 当前播放进度 */
            this.currentDate = 0;
            /** 定时器 */
            this.dateInternal = null;
            /** 阶段和颜色的映射 */
            this.stageMaterialMap = {};
            /** 倍速 */
            this.speed = 1;
            /** 当前播放状态 */
            this.currentStatus = null;
            this.changeModelColor = null;
            this.cacheManagement = cacheManagement;
            var player = getPlayerData(cacheManagement);
            if (!player) {
                throw new Error("player未加载");
            }
            this.player = player;
            this.dispatch = dispatch;
            this.common = common(player);
        }
        /**
         * 创建进度可视化
         * @param startDate  开始时间
         * @param endDate 结束时间
         * @param stageMaterialMap 阶段与材质属性的map
         */
        Progress.prototype.create = function (startDate, endDate, stageMaterialMap) {
            var _a, _b, _c, _d;
            return __awaiter$1(this, void 0, void 0, function () {
                var nodes, nodeTree, root, _e, nodeTree, nodeinfo, _f;
                var _this = this;
                return __generator$1(this, function (_g) {
                    switch (_g.label) {
                        case 0: 
                        // await this.destory()
                        return [4 /*yield*/, Promise.all(Object.keys(stageMaterialMap).map(function (el) { return __awaiter$1(_this, void 0, void 0, function () {
                                var m;
                                var _a, _b;
                                return __generator$1(this, function (_c) {
                                    switch (_c.label) {
                                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Material.create(0))];
                                        case 1:
                                            m = _c.sent();
                                            (_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Material.setProperty(m, stageMaterialMap[el]);
                                            this.stageMaterialMap[el] = m;
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                        case 1:
                            // await this.destory()
                            _g.sent();
                            nodes = [];
                            if (!this.model) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.common.traverseNode(this.model, function (node) {
                                    node.code && (_this.progressCodeByItem[node.code] = node);
                                    if (node.material) {
                                        nodes.push(node.node);
                                    }
                                })];
                        case 2:
                            nodeTree = _g.sent();
                            return [3 /*break*/, 6];
                        case 3:
                            _e = this;
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.getRoot())];
                        case 4:
                            root = _e.root = _g.sent();
                            return [4 /*yield*/, this.common.traverseNode(root, function (node) {
                                    node.code && (_this.progressCodeByItem[node.code] = node);
                                    if (node.material) {
                                        nodes.push(node.node);
                                    }
                                })];
                        case 5:
                            nodeTree = _g.sent();
                            nodeinfo = (_b = nodeTree[0]) === null || _b === void 0 ? void 0 : _b.children[0];
                            if (!nodeinfo)
                                throw new Error("未找到模型节点");
                            this.model = nodeinfo.node;
                            _g.label = 6;
                        case 6:
                            _f = this;
                            return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.Node.clone(this.model))];
                        case 7:
                            _f.clone = _g.sent();
                            return [4 /*yield*/, ((_d = this.player.Native) === null || _d === void 0 ? void 0 : _d.Node.setProperty(nodes, { "material": this.stageMaterialMap.init }))];
                        case 8:
                            _g.sent();
                            this.startDate = startDate;
                            this.endDate = endDate;
                            this.currentStatus = ProgressStatus.init;
                            this.stageData = [];
                            this.currentDate = 0;
                            this.dispatch.emit("Progress", {
                                currentTime: dayjs(this.startDate).add(this.currentDate, "day").format("YYYY-MM-DD"),
                                status: this.currentStatus,
                                dateRange: [],
                            });
                            return [2 /*return*/, {
                                    status: true
                                }];
                    }
                });
            });
        };
        // 设置进度数据
        Progress.prototype.setProgressData = function (date, stageData) {
            if (!this.currentStatus) {
                return {
                    status: false,
                    message: "未初始化进度"
                };
            }
            var dateNumber = dayjs(date).diff(this.startDate, "day");
            this.stageData[dateNumber] = __assign$2(__assign$2({}, this.stageData[dateNumber]), stageData);
            if (this.currentStatus === ProgressStatus.pending) {
                if (this.dateInternal) {
                    clearInterval(this.dateInternal);
                }
                this.startPlay();
            }
            return {
                status: true
            };
        };
        // 开始播放
        Progress.prototype.startPlay = function (jumpFirst) {
            if (jumpFirst === void 0) { jumpFirst = false; }
            return __awaiter$1(this, void 0, void 0, function () {
                var _this = this;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!jumpFirst) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.startPlayByDate(this.currentDate)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            this.dateInternal = setInterval(function () { return __awaiter$1(_this, void 0, void 0, function () {
                                return __generator$1(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.startPlayByDate(this.currentDate + this.speed)];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, 1000);
                            return [2 /*return*/];
                    }
                });
            });
        };
        Progress.prototype.startPlayByDate = function (date) {
            return __awaiter$1(this, void 0, void 0, function () {
                var list;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (dayjs(this.startDate).add(date, 'day').diff(this.endDate, 'days') >= 0) {
                                date = dayjs(this.endDate).diff(this.startDate, 'days');
                            }
                            list = this.getChangeList(this.currentDate, date);
                            if (!list) return [3 /*break*/, 2];
                            this.currentStatus = ProgressStatus.playing;
                            this.currentDate = date;
                            return [4 /*yield*/, this.sumbitEngineChanges(list.changeProcessMap)];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            // 当前时间无数据，等待数据写入
                            this.currentStatus = ProgressStatus.pending;
                            if (this.dateInternal) {
                                clearInterval(this.dateInternal);
                            }
                            _a.label = 3;
                        case 3:
                            if (date === dayjs(this.endDate).diff(this.startDate, 'days')) {
                                if (this.dateInternal) {
                                    clearInterval(this.dateInternal);
                                }
                                this.currentStatus = ProgressStatus.finish;
                            }
                            this.dispatch.emit("Progress", {
                                currentTime: dayjs(this.startDate).add(this.currentDate, "day").format("YYYY-MM-DD"),
                                status: this.currentStatus,
                                dateRange: []
                            });
                            return [2 /*return*/];
                    }
                });
            });
        };
        // 暂停播放
        Progress.prototype.pausePlay = function () {
            this.currentStatus = ProgressStatus.pause;
            if (this.dateInternal) {
                clearInterval(this.dateInternal);
            }
            this.dispatch.emit("Progress", {
                currentTime: dayjs(this.startDate).add(this.currentDate, "day").format("YYYY-MM-DD"),
                status: this.currentStatus,
                dateRange: [],
            });
        };
        // 获取当前播放进度
        Progress.prototype.getCurrentDate = function () {
            var currentDate = dayjs(this.startDate).add(this.currentDate, 'day').format("YYYY-MM-DD HH:mm:ss");
            return {
                data: currentDate,
                status: true
            };
        };
        // 设置时间范围的数据
        Progress.prototype.setDataByDateRange = function (startDate, endDate, stageData) {
            return __awaiter$1(this, void 0, void 0, function () {
                var dateNumber;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            dateNumber = dayjs(endDate).diff(this.startDate, "day");
                            this.currentDate = dateNumber;
                            this.currentStatus = ProgressStatus.playing;
                            return [4 /*yield*/, this.sumbitEngineChanges(stageData)];
                        case 1:
                            _a.sent();
                            this.dispatch.emit("Progress", {
                                currentTime: dayjs(this.startDate).add(this.currentDate, "day").format("YYYY-MM-DD"),
                                status: this.currentStatus,
                                dateRange: []
                            });
                            if (this.dateInternal) {
                                clearInterval(this.dateInternal);
                            }
                            this.startPlay(true);
                            return [2 /*return*/];
                    }
                });
            });
        };
        // 设置播放倍速
        Progress.prototype.setSpeed = function (speed) {
            this.speed = speed;
        };
        Progress.prototype.destory = function () {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (this.dateInternal) {
                                clearInterval(this.dateInternal);
                            }
                            return [4 /*yield*/, this.changeModelColor];
                        case 1:
                            _c.sent();
                            (_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.removeFromFactory([this.model]);
                            (_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Node.addToFactory([this.clone]);
                            this.model = this.clone;
                            this.currentDate = 0;
                            this.speed = 1;
                            this.startDate = '';
                            this.endDate = '';
                            this.currentStatus = null;
                            return [2 /*return*/];
                    }
                });
            });
        };
        Progress.prototype.destroy = function () {
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.destory()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        // 跳转至指定时间
        Progress.prototype.jumpDate = function (date) {
            return __awaiter$1(this, void 0, void 0, function () {
                var dateNumber, changelist;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // 校验date
                            if (dayjs(this.endDate).diff(date, 'day') < 0) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "当前时间大于了创建时的结束时间"
                                    }];
                            }
                            return [4 /*yield*/, this.changeModelColor];
                        case 1:
                            _a.sent();
                            this.pausePlay();
                            this.currentStatus = ProgressStatus.awaitData;
                            dateNumber = dayjs(date).diff(this.startDate, "day");
                            changelist = this.getChangeList(this.currentDate, dateNumber);
                            if (!changelist) return [3 /*break*/, 3];
                            this.currentStatus = ProgressStatus.playing;
                            this.currentDate = dateNumber;
                            return [4 /*yield*/, this.sumbitEngineChanges(changelist.changeProcessMap)];
                        case 2:
                            _a.sent();
                            if (this.dateInternal) {
                                clearInterval(this.dateInternal);
                            }
                            this.dispatch.emit("Progress", {
                                currentTime: dayjs(this.startDate).add(this.currentDate, "day").format("YYYY-MM-DD"),
                                status: this.currentStatus,
                                dateRange: []
                            });
                            this.startPlay(true);
                            return [3 /*break*/, 4];
                        case 3:
                            this.dispatch.emit("Progress", {
                                currentTime: dayjs(this.startDate).add(this.currentDate, "day").format("YYYY-MM-DD"),
                                status: this.currentStatus,
                                dateRange: [dayjs(this.startDate).add(this.currentDate, "day").format("YYYY-MM-DD"), dayjs(date).format("YYYY-MM-DD")] // 状态为awaitData时，会存在这个值 
                            });
                            _a.label = 4;
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        Progress.prototype.getChangeList = function (start, end) {
            /** key为code，value为code当前的状态 */
            var codeStatusMap = {};
            /** key为状态，value为code列表 */
            var changeProcessMap = {};
            if (start > end) {
                // 逆向
                // 0->start
                var changeMap1_1 = this.getChangeList(0, end);
                // start->end
                var changeMap2 = this.getChangeList(end, start);
                if (!changeMap1_1 || !changeMap2) {
                    return null;
                }
                codeStatusMap = changeMap1_1.codeStatusMap;
                Object.keys(changeMap2.codeStatusMap).forEach(function (key) {
                    if (!changeMap1_1.codeStatusMap.hasOwnProperty(key)) {
                        codeStatusMap[key] = "init";
                    }
                });
            }
            else {
                var _loop_1 = function (i) {
                    var currentIndexData = this_1.stageData[i];
                    if (!currentIndexData) {
                        return { value: null };
                    }
                    Object.keys(currentIndexData).forEach(function (key) {
                        for (var j = 0; j < currentIndexData[key].length; j++) {
                            var code = currentIndexData[key][j];
                            codeStatusMap[code] = key;
                        }
                    });
                };
                var this_1 = this;
                // 正向
                for (var i = start; i <= end; i++) {
                    var state_1 = _loop_1(i);
                    if (typeof state_1 === "object")
                        return state_1.value;
                }
            }
            Object.keys(codeStatusMap).forEach(function (key) {
                var _a;
                var lastCode = (_a = changeProcessMap[codeStatusMap[key]]) !== null && _a !== void 0 ? _a : [];
                changeProcessMap[codeStatusMap[key]] = __spreadArray$2(__spreadArray$2([], lastCode, true), [key], false);
            });
            return {
                changeProcessMap: changeProcessMap,
                codeStatusMap: codeStatusMap
            };
        };
        // 通知模型变色
        Progress.prototype.sumbitEngineChanges = function (changeMap) {
            return __awaiter$1(this, void 0, void 0, function () {
                var _this = this;
                return __generator$1(this, function (_a) {
                    this.changeModelColor = new Promise(function (resolve, reject) { return __awaiter$1(_this, void 0, void 0, function () {
                        var _loop_2, this_2, _i, _a, item;
                        var _b;
                        return __generator$1(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    _loop_2 = function (item) {
                                        var key, value, itemList, index, element;
                                        return __generator$1(this, function (_d) {
                                            switch (_d.label) {
                                                case 0:
                                                    key = item;
                                                    value = changeMap[item];
                                                    itemList = [];
                                                    if (!(value.length !== 0)) return [3 /*break*/, 2];
                                                    for (index = 0; index < value.length; index++) {
                                                        element = value[index];
                                                        if (this_2.progressCodeByItem[element]) {
                                                            this_2.traverseTree([this_2.progressCodeByItem[element]], function (node) {
                                                                if (node.material) {
                                                                    itemList.push(node.node);
                                                                }
                                                            });
                                                        }
                                                    }
                                                    return [4 /*yield*/, ((_b = this_2.player.Native) === null || _b === void 0 ? void 0 : _b.Node.setProperty(itemList, { "material": this_2.stageMaterialMap[key] }))];
                                                case 1:
                                                    _d.sent();
                                                    _d.label = 2;
                                                case 2: return [2 /*return*/];
                                            }
                                        });
                                    };
                                    this_2 = this;
                                    _i = 0, _a = Object.keys(changeMap);
                                    _c.label = 1;
                                case 1:
                                    if (!(_i < _a.length)) return [3 /*break*/, 4];
                                    item = _a[_i];
                                    return [5 /*yield**/, _loop_2(item)];
                                case 2:
                                    _c.sent();
                                    _c.label = 3;
                                case 3:
                                    _i++;
                                    return [3 /*break*/, 1];
                                case 4:
                                    resolve();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    return [2 /*return*/, this.changeModelColor];
                });
            });
        };
        Progress.prototype.traverseTree = function (nodeTree, call) {
            var myForEach = function (nodes) {
                nodes.forEach(function (node) {
                    call(node);
                    if (node.children && node.children.length) {
                        myForEach(node.children);
                    }
                });
            };
            myForEach(nodeTree);
        };
        Progress.progress = null;
        return Progress;
    }());

    var Progress = /** @class */ (function () {
        function Progress(cacheManagement, dispatch) {
            this.player = {};
            /** 开始时间 */
            this.startDate = '';
            /** 结束时间 */
            this.endDate = '';
            /** 进度数据 */
            this.stageDatas = [];
            /** 当前播放进度 */
            this.currentDate = 0;
            this.lastDate = 0;
            /** 定时器 */
            this.dateInternal = null;
            /** 倍速 */
            this.speed = 1;
            /** 当前播放状态 */
            this.currentStatus = null;
            /** 阶段和颜色的映射 */
            this.stageColorIndexMap = {};
            /** code和node的映射 */
            this.codeNodeMap = {};
            var player = getPlayerData(cacheManagement);
            if (!player) {
                throw new Error("player未加载");
            }
            this.player = player;
            this.dispatch = dispatch;
        }
        /**
         * 创建进度可视化
         * @param startDate  开始时间
         * @param endDate 结束时间
         * @param stageColorIndexMap 阶段与材质属性的map
         */
        Progress.prototype.create = function (startDate, endDate, stageColorIndexMap, alpha) {
            var _a, _b, _c;
            return __awaiter$1(this, void 0, void 0, function () {
                var root;
                return __generator$1(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            // await this.destory()
                            this.stageColorIndexMap = stageColorIndexMap;
                            this.stageColorIndexMap.init = this.stageColorIndexMap.init || 138;
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.getRoot())];
                        case 1:
                            root = _d.sent();
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Node.setProperty(root, { colorIndex: this.stageColorIndexMap.init }))];
                        case 2:
                            _d.sent();
                            return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.Setting.set("display.colorControl", alpha))];
                        case 3:
                            _d.sent();
                            // await this.player.Native?.Setting.set("display.oit", true);
                            this.startDate = startDate;
                            this.endDate = endDate;
                            this.currentStatus = ProgressStatus.init;
                            this.stageDatas = [];
                            this.currentDate = 0;
                            this.dispatch.emit("Progress", {
                                currentTime: this.startDate,
                                status: this.currentStatus
                            });
                            return [2 /*return*/, {
                                    status: true
                                }];
                    }
                });
            });
        };
        // 设置进度数据
        Progress.prototype.setProgressData = function (date, stageData) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var allCode, res, i, code, settings, dateNumber;
                var _this = this;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            allCode = [];
                            Object.keys(stageData).forEach(function (key) {
                                var codes = stageData[key];
                                allCode.push.apply(allCode, codes);
                            });
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.findNode(0, { codes: allCode }))];
                        case 1:
                            res = _c.sent();
                            for (i = 0; i < allCode.length; i++) {
                                code = allCode[i];
                                if ((_b = res.codes) === null || _b === void 0 ? void 0 : _b[code]) {
                                    this.codeNodeMap[code] = res.codes[code].node;
                                }
                                else {
                                    console.warn("\u672A\u627E\u5230".concat(code, "\u5BF9\u5E94\u7684\u8282\u70B9"));
                                }
                            }
                            settings = [];
                            Object.keys(stageData).forEach(function (key) {
                                var codes = stageData[key];
                                settings.push({
                                    nodes: codes.map(function (code) { return _this.codeNodeMap[code]; }),
                                    color: _this.stageColorIndexMap[key]
                                });
                            });
                            dateNumber = dayjs(date).diff(this.startDate, "day");
                            this.stageDatas[dateNumber] = settings;
                            return [2 /*return*/];
                    }
                });
            });
        };
        // 批量设置进度数据
        Progress.prototype.batchSetProgressData = function (progressDataList) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var allCode, res, i, code;
                var _this = this;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!this.currentStatus) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "未初始化进度"
                                    }];
                            }
                            allCode = [];
                            progressDataList.forEach(function (_a) {
                                _a.date; var stageData = _a.stageData;
                                Object.keys(stageData).forEach(function (key) {
                                    var codes = stageData[key];
                                    allCode.push.apply(allCode, codes);
                                });
                            });
                            allCode = Array.from(new Set(allCode));
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.findNode(0, { codes: allCode }))];
                        case 1:
                            res = _c.sent();
                            for (i = 0; i < allCode.length; i++) {
                                code = allCode[i];
                                if ((_b = res.codes) === null || _b === void 0 ? void 0 : _b[code]) {
                                    this.codeNodeMap[code] = res.codes[code].node;
                                }
                                else {
                                    console.warn("\u672A\u627E\u5230".concat(code, "\u5BF9\u5E94\u7684\u8282\u70B9"));
                                }
                            }
                            progressDataList.forEach(function (_a) {
                                var date = _a.date, stageData = _a.stageData;
                                var settings = [];
                                Object.keys(stageData).forEach(function (key) {
                                    var codes = stageData[key];
                                    settings.push({
                                        nodes: codes.map(function (code) { return _this.codeNodeMap[code]; }),
                                        color: _this.stageColorIndexMap[key]
                                    });
                                });
                                var dateNumber = dayjs(date).diff(_this.startDate, "day");
                                _this.stageDatas[dateNumber] = settings;
                            });
                            return [2 /*return*/];
                    }
                });
            });
        };
        // 开始播放
        Progress.prototype.startPlay = function () {
            return __awaiter$1(this, void 0, void 0, function () {
                var _this = this;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.currentStatus) {
                                return [2 /*return*/, {
                                        status: false,
                                        message: "未初始化进度"
                                    }];
                            }
                            if (this.dateInternal) {
                                clearInterval(this.dateInternal);
                            }
                            this.currentDate += this.speed;
                            return [4 /*yield*/, this.startPlayByDate()];
                        case 1:
                            _a.sent();
                            this.dateInternal = setInterval(function () { return __awaiter$1(_this, void 0, void 0, function () {
                                return __generator$1(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            this.currentDate += this.speed;
                                            return [4 /*yield*/, this.startPlayByDate()];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, 1000);
                            return [2 /*return*/];
                    }
                });
            });
        };
        Progress.prototype.startPlayByDate = function () {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var num, options;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            num = dayjs(this.endDate).diff(this.startDate, 'days');
                            options = this.getChangeList(this.currentDate);
                            this.lastDate = this.currentDate;
                            if (!(options.length > 0)) return [3 /*break*/, 2];
                            this.currentStatus = ProgressStatus.playing;
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.setProperty(options))];
                        case 1:
                            _b.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            this.currentStatus = ProgressStatus.pending;
                            _b.label = 3;
                        case 3:
                            if (this.currentDate >= num) {
                                if (this.dateInternal) {
                                    clearInterval(this.dateInternal);
                                }
                                this.currentStatus = ProgressStatus.finish;
                            }
                            this.dispatch.emit("Progress", {
                                currentTime: dayjs(this.startDate).add(this.currentDate, "day").format("YYYY-MM-DD"),
                                status: this.currentStatus
                            });
                            return [2 /*return*/];
                    }
                });
            });
        };
        // 暂停播放
        Progress.prototype.pausePlay = function () {
            this.currentStatus = ProgressStatus.pause;
            if (this.dateInternal) {
                clearInterval(this.dateInternal);
                this.dateInternal = null;
            }
            this.dispatch.emit("Progress", {
                currentTime: dayjs(this.startDate).add(this.currentDate, "day").format("YYYY-MM-DD"),
                status: this.currentStatus,
            });
        };
        // 获取当前播放进度
        Progress.prototype.getCurrentDate = function () {
            var currentDate = dayjs(this.startDate).add(this.currentDate, 'day').format("YYYY-MM-DD HH:mm:ss");
            return {
                data: currentDate,
                status: true
            };
        };
        // 设置播放倍速
        Progress.prototype.setSpeed = function (speed) {
            this.speed = Math.floor(speed);
        };
        Progress.prototype.destroy = function () {
            var _a, _b, _c;
            return __awaiter$1(this, void 0, void 0, function () {
                var root;
                return __generator$1(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (this.dateInternal) {
                                clearInterval(this.dateInternal);
                            }
                            this.currentDate = 0;
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Node.getRoot())];
                        case 1:
                            root = _d.sent();
                            return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.Node.setProperty(root, { colorIndex: 0 }))];
                        case 2:
                            _d.sent();
                            return [4 /*yield*/, ((_c = this.player.Native) === null || _c === void 0 ? void 0 : _c.Setting.set("display.colorControl", 1))];
                        case 3:
                            _d.sent();
                            // await this.player.Native?.Setting.set("display.oit", false);
                            this.lastDate = 0;
                            this.speed = 1;
                            this.startDate = '';
                            this.endDate = '';
                            this.currentStatus = null;
                            this.stageColorIndexMap = {};
                            this.stageDatas = [];
                            this.codeNodeMap = {};
                            return [2 /*return*/];
                    }
                });
            });
        };
        // 跳转至指定时间
        Progress.prototype.jumpDate = function (date) {
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_a) {
                    // 校验date
                    if (dayjs(this.endDate).diff(date, 'day') < 0) {
                        return [2 /*return*/, {
                                status: false,
                                message: "当前时间大于了创建时的结束时间"
                            }];
                    }
                    if (dayjs(date).diff(this.startDate, 'day') < 0) {
                        return [2 /*return*/, {
                                status: false,
                                message: "当前时间小于了创建时的开始时间"
                            }];
                    }
                    this.currentDate = dayjs(date).diff(this.startDate, "day") - this.speed;
                    this.startPlay();
                    return [2 /*return*/, {
                            status: true
                        }];
                });
            });
        };
        Progress.prototype.getChangeList = function (start) {
            var _this = this;
            /** key为状态，value为code列表 */
            var options = [];
            if (start > this.lastDate) {
                // 正向
                for (var i = this.lastDate; i < start; i++) {
                    var stageData = this.stageDatas[i];
                    if (stageData) {
                        stageData.forEach(function (nodeColor) {
                            nodeColor.nodes.forEach(function (node) {
                                options.push({
                                    node: node,
                                    props: {
                                        colorIndex: nodeColor.color,
                                        recvGlobalAlpha: 1
                                    }
                                });
                            });
                        });
                    }
                }
            }
            else {
                // ni
                for (var i = start; i <= this.lastDate; i++) {
                    var stageData = this.stageDatas[i];
                    if (stageData) {
                        stageData.forEach(function (nodeColor) {
                            nodeColor.nodes.forEach(function (node) {
                                options.push({
                                    node: node,
                                    props: {
                                        colorIndex: _this.stageColorIndexMap.init,
                                        recvGlobalAlpha: 3
                                    }
                                });
                            });
                        });
                    }
                }
            }
            return options;
        };
        return Progress;
    }());

    var MultisegmentLine = /** @class */ (function () {
        function MultisegmentLine(cacheManagement) {
            this.player = {};
            this.idLineMap = {};
            var player = getPlayerData(cacheManagement);
            if (!player) {
                throw new Error("player未加载");
            }
            this.player = player;
        }
        /**
         * 创建导航线
         * @param options 导航线参数
         */
        MultisegmentLine.prototype.create = function (options) {
            var _a, _b;
            return __awaiter$1(this, void 0, void 0, function () {
                var validOptions, imageFiles, imageFiles2, F_T, textureIds, lines;
                var _this = this;
                return __generator$1(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!Array.isArray(options)) {
                                options = [options];
                            }
                            validOptions = options.filter(function (option) {
                                if (option.id === undefined || option.id === null) {
                                    console.warn("\u8B66\u544A: \u53D1\u73B0\u672A\u5B9A\u4E49\u7684 ID\uFF0C\u8DF3\u8FC7\u6B64\u9879\u76EE");
                                    return false;
                                }
                                if (_this.idLineMap[option.id]) {
                                    console.warn("\u8B66\u544A: ID ".concat(option.id, " \u5DF2\u5B58\u5728\uFF0C\u8DF3\u8FC7\u6B64\u9879\u76EE"));
                                    return false;
                                }
                                _this.idLineMap[option.id] = 1;
                                return true;
                            });
                            imageFiles = validOptions.map(function (item) { return item.imageFile; });
                            imageFiles2 = Array.from(new Set(imageFiles.filter(function (item) { return Boolean(item); })));
                            F_T = {};
                            if (!imageFiles2.length) return [3 /*break*/, 2];
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.Texture.create(imageFiles2))];
                        case 1:
                            textureIds = _c.sent();
                            textureIds.forEach(function (textureId, index) {
                                F_T[imageFiles2[index]] = textureId;
                            });
                            validOptions.forEach(function (item, index) {
                                if (item.imageFile) {
                                    item.textureId = F_T[item.imageFile];
                                    delete item.imageFile;
                                }
                            });
                            _c.label = 2;
                        case 2: return [4 /*yield*/, ((_b = this.player.Native) === null || _b === void 0 ? void 0 : _b.MultisegmentLine.create(validOptions))];
                        case 3:
                            lines = _c.sent();
                            lines.forEach(function (line, index) {
                                _this.idLineMap[validOptions[index].id] = line;
                            });
                            return [2 /*return*/, {
                                    data: lines,
                                    status: true
                                }];
                    }
                });
            });
        };
        /**
         * 获取属性
         * @param {string|string[]} ids   id
         * @param {(keyof IMultisegmentLine)[]} keys 获取的属性
         * @returns
         */
        MultisegmentLine.prototype.getProperty = function (id, keys) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var res;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // if (!Array.isArray(ids)) {
                            //     ids = [ids]
                            // }
                            // const lines: number[] = []
                            // ids.forEach(id => {
                            // if (this.idLineMap[id]) {
                            //     lines.push(this.idLineMap[id])
                            // } else {
                            //     console.warn(`${id} not found`)
                            // }
                            // });
                            if (!this.idLineMap[id]) {
                                return [2 /*return*/, Promise.resolve({
                                        status: false,
                                        meassage: "".concat(id, " not found")
                                    })];
                            }
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.MultisegmentLine.getProperty(this.idLineMap[id], keys))];
                        case 1:
                            res = _b.sent();
                            return [2 /*return*/, {
                                    data: res,
                                    status: true
                                }];
                    }
                });
            });
        };
        /**
         * @description 设置多段线属性
         * @param {string|string[]} ids
         * @param {IMultisegmentLine} props
         * @returns
         */
        MultisegmentLine.prototype.setProperty = function (ids, props) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var lines;
                var _this = this;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!Array.isArray(ids)) {
                                ids = [ids];
                            }
                            lines = [];
                            ids.forEach(function (id) {
                                if (_this.idLineMap[id]) {
                                    lines.push(_this.idLineMap[id]);
                                }
                                else {
                                    console.warn("".concat(id, " not found"));
                                }
                            });
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.MultisegmentLine.setProperty(lines, props))];
                        case 1:
                            _b.sent();
                            return [2 /*return*/, { status: true }];
                    }
                });
            });
        };
        // 销毁
        MultisegmentLine.prototype.destroy = function (ids) {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                var lines;
                var _this = this;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!Array.isArray(ids)) {
                                ids = [ids];
                            }
                            lines = [];
                            ids.forEach(function (id) {
                                if (_this.idLineMap[id]) {
                                    lines.push(_this.idLineMap[id]);
                                    delete _this.idLineMap[id];
                                }
                                else {
                                    console.warn("".concat(id, " not found"));
                                }
                            });
                            return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.MultisegmentLine.destroy(lines))];
                        case 1:
                            _b.sent();
                            return [2 /*return*/, { status: true }];
                    }
                });
            });
        };
        // 销毁所有
        MultisegmentLine.prototype.destroyAll = function () {
            var _a;
            return __awaiter$1(this, void 0, void 0, function () {
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = this.player.Native) === null || _a === void 0 ? void 0 : _a.MultisegmentLine.clear())];
                        case 1:
                            _b.sent();
                            this.idLineMap = {};
                            return [2 /*return*/, { status: true }];
                    }
                });
            });
        };
        return MultisegmentLine;
    }());

    // 加载场景
    // import Model from "./load/loadModel";
    // Engine
    var cloudRender = /** @class */ (function () {
        function cloudRender() {
            // Model: Model | null = null;
            this.Engine = null;
            this.GIS = null;
            this.Tool = null;
            this.Clip = null;
            this.ElectoronicRail = null;
            this.Camera = null;
            this.NodeProxy = null;
            this.Node = null;
            this.Setting = null;
            this.Walking = null;
            this.ModelGlitter = null;
            this.Marker = null;
            this.Marker3D = null;
            this.Particle = null;
            this.PosViewer = null;
            this.Route = null;
            this.Animation = null;
            this.SkeletonNode = null;
            this.HistoricalTrajectory = null;
            this.Inspection = null;
            // DroneNode: DroneNode | null = null;
            this.Plotting = null;
            this.Logger = Logger$1;
            this.Progress = null;
            this.Progress2 = null;
            this.MultisegmentLine = null;
            this.cloudRenderId = generateUUID();
            this.cacheManagement = new cacheManagement(this.cloudRenderId);
            this.Dispatch = new Dispatch();
            this.Engine = new Engine(this.cacheManagement, this.Dispatch);
            this.Dispatch.on("EngineInside", this.dealLoadEngineStatus());
        }
        cloudRender.prototype.dealLoadEngineStatus = function () {
            var _this = this;
            var that = this;
            var dealLoadEngineStatus = function (engineData) {
                var _a;
                var player = getPlayerData(_this.cacheManagement);
                var status = engineData.status;
                Logger$1.cacheManagement = status ? that.cacheManagement : null;
                // that.Model = status
                //   ? new Model(that.cacheManagement, that.Dispatch, true)
                //   : null;
                that.GIS = status ? new GIS(that.cacheManagement) : null;
                that.Tool = status ? new Tool(that.cacheManagement, that.Dispatch) : null;
                that.Clip = status ? new Clip(that.cacheManagement, that.Dispatch) : null;
                that.ElectoronicRail = status
                    ? new ElectoronicRail(that.cacheManagement, that.Dispatch)
                    : null;
                that.Camera = status
                    ? new Camera(that.cacheManagement, that.Dispatch, true)
                    : null;
                that.NodeProxy = status
                    ? new NodeProxy(that.cacheManagement, that.Dispatch, true)
                    : null;
                that.Node = status ? new Node$1(that.cacheManagement, that.Dispatch, true) : null;
                that.Setting = status ? new Setting(that.cacheManagement, that.Dispatch) : null;
                that.Walking = status ? new Walking(that.cacheManagement) : null;
                that.ModelGlitter = (status && player)
                    ? new ModelGlitter(player)
                    : null;
                that.Marker = status
                    ? new Marker(that.cacheManagement, that.Dispatch, true)
                    : null;
                that.Marker3D = (status && player)
                    ? new Marker3D(player, that.Dispatch, true)
                    : null;
                that.Particle = status
                    ? new Particle(that.cacheManagement, that.Dispatch)
                    : null;
                that.PosViewer = status
                    ? new PosViewer(that.cacheManagement, that.Dispatch)
                    : null;
                that.Route = status ? new Route(that.cacheManagement) : null;
                that.Animation = status
                    ? new animation(that.cacheManagement, that.Dispatch, true)
                    : null;
                that.SkeletonNode = status
                    ? new SkeletonNode(that.cacheManagement, that.Dispatch)
                    : null;
                that.HistoricalTrajectory = status
                    ? new HistoricalTrajectory(that.cacheManagement, that.Dispatch)
                    : null;
                that.Inspection = status
                    ? new Inspection(that.cacheManagement, that.Dispatch)
                    : null;
                // that.DroneNode = status
                //   ? new DroneNode(that.cacheManagement, that.Dispatch)
                //   : null;
                that.Plotting = status
                    ? new Plotting(that.cacheManagement, that.Dispatch)
                    : null;
                that.Progress = status
                    ? new Progress$1(that.cacheManagement, that.Dispatch)
                    : null;
                that.Progress2 = status
                    ? new Progress(that.cacheManagement, that.Dispatch)
                    : null;
                that.MultisegmentLine = status
                    ? new MultisegmentLine(that.cacheManagement)
                    : null;
                that.Common = player ? common(player) : null;
                // 清除dispatch中的数据
                if (!status) {
                    that.Dispatch.offAll();
                    that.Dispatch.on("EngineInside", _this.dealLoadEngineStatus());
                    // 清空缓存
                    (_a = that.cacheManagement) === null || _a === void 0 ? void 0 : _a.deletAllCache();
                }
            };
            return dealLoadEngineStatus;
        };
        return cloudRender;
    }());
    var index = {
        cloudRender: cloudRender,
        instance: new cloudRender(),
    };

    return index;

}));
